(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

// rawAsap provides everything we need except exception management.
var rawAsap = require("./raw");
// RawTasks are recycled to reduce GC churn.
var freeTasks = [];
// We queue errors to ensure they are thrown in right order (FIFO).
// Array-as-queue is good enough here, since we are just dealing with exceptions.
var pendingErrors = [];
var requestErrorThrow = rawAsap.makeRequestCallFromTimer(throwFirstError);

function throwFirstError() {
    if (pendingErrors.length) {
        throw pendingErrors.shift();
    }
}

/**
 * Calls a task as soon as possible after returning, in its own event, with priority
 * over other events like animation, reflow, and repaint. An error thrown from an
 * event will not interrupt, nor even substantially slow down the processing of
 * other events, but will be rather postponed to a lower priority event.
 * @param {{call}} task A callable object, typically a function that takes no
 * arguments.
 */
module.exports = asap;
function asap(task) {
    var rawTask;
    if (freeTasks.length) {
        rawTask = freeTasks.pop();
    } else {
        rawTask = new RawTask();
    }
    rawTask.task = task;
    rawAsap(rawTask);
}

// We wrap tasks with recyclable task objects.  A task object implements
// `call`, just like a function.
function RawTask() {
    this.task = null;
}

// The sole purpose of wrapping the task is to catch the exception and recycle
// the task object after its single use.
RawTask.prototype.call = function () {
    try {
        this.task.call();
    } catch (error) {
        if (asap.onerror) {
            // This hook exists purely for testing purposes.
            // Its name will be periodically randomized to break any code that
            // depends on its existence.
            asap.onerror(error);
        } else {
            // In a web browser, exceptions are not fatal. However, to avoid
            // slowing down the queue of pending tasks, we rethrow the error in a
            // lower priority turn.
            pendingErrors.push(error);
            requestErrorThrow();
        }
    } finally {
        this.task = null;
        freeTasks[freeTasks.length] = this;
    }
};

},{"./raw":2}],2:[function(require,module,exports){
(function (global){
"use strict";

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],3:[function(require,module,exports){
(function (global){
/*! http://mths.be/base64 v0.1.0 by @mathias | MIT license */
;(function(root) {

	// Detect free variables `exports`.
	var freeExports = typeof exports == 'object' && exports;

	// Detect free variable `module`.
	var freeModule = typeof module == 'object' && module &&
		module.exports == freeExports && module;

	// Detect free variable `global`, from Node.js or Browserified code, and use
	// it as `root`.
	var freeGlobal = typeof global == 'object' && global;
	if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal) {
		root = freeGlobal;
	}

	/*--------------------------------------------------------------------------*/

	var InvalidCharacterError = function(message) {
		this.message = message;
	};
	InvalidCharacterError.prototype = new Error;
	InvalidCharacterError.prototype.name = 'InvalidCharacterError';

	var error = function(message) {
		// Note: the error messages used throughout this file match those used by
		// the native `atob`/`btoa` implementation in Chromium.
		throw new InvalidCharacterError(message);
	};

	var TABLE = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
	// http://whatwg.org/html/common-microsyntaxes.html#space-character
	var REGEX_SPACE_CHARACTERS = /[\t\n\f\r ]/g;

	// `decode` is designed to be fully compatible with `atob` as described in the
	// HTML Standard. http://whatwg.org/html/webappapis.html#dom-windowbase64-atob
	// The optimized base64-decoding algorithm used is based on @atk’s excellent
	// implementation. https://gist.github.com/atk/1020396
	var decode = function(input) {
		input = String(input)
			.replace(REGEX_SPACE_CHARACTERS, '');
		var length = input.length;
		if (length % 4 == 0) {
			input = input.replace(/==?$/, '');
			length = input.length;
		}
		if (
			length % 4 == 1 ||
			// http://whatwg.org/C#alphanumeric-ascii-characters
			/[^+a-zA-Z0-9/]/.test(input)
		) {
			error(
				'Invalid character: the string to be decoded is not correctly encoded.'
			);
		}
		var bitCounter = 0;
		var bitStorage;
		var buffer;
		var output = '';
		var position = -1;
		while (++position < length) {
			buffer = TABLE.indexOf(input.charAt(position));
			bitStorage = bitCounter % 4 ? bitStorage * 64 + buffer : buffer;
			// Unless this is the first of a group of 4 characters…
			if (bitCounter++ % 4) {
				// …convert the first 8 bits to a single ASCII character.
				output += String.fromCharCode(
					0xFF & bitStorage >> (-2 * bitCounter & 6)
				);
			}
		}
		return output;
	};

	// `encode` is designed to be fully compatible with `btoa` as described in the
	// HTML Standard: http://whatwg.org/html/webappapis.html#dom-windowbase64-btoa
	var encode = function(input) {
		input = String(input);
		if (/[^\0-\xFF]/.test(input)) {
			// Note: no need to special-case astral symbols here, as surrogates are
			// matched, and the input is supposed to only contain ASCII anyway.
			error(
				'The string to be encoded contains characters outside of the ' +
				'Latin1 range.'
			);
		}
		var padding = input.length % 3;
		var output = '';
		var position = -1;
		var a;
		var b;
		var c;
		var d;
		var buffer;
		// Make sure any padding is handled outside of the loop.
		var length = input.length - padding;

		while (++position < length) {
			// Read three bytes, i.e. 24 bits.
			a = input.charCodeAt(position) << 16;
			b = input.charCodeAt(++position) << 8;
			c = input.charCodeAt(++position);
			buffer = a + b + c;
			// Turn the 24 bits into four chunks of 6 bits each, and append the
			// matching character for each of them to the output.
			output += (
				TABLE.charAt(buffer >> 18 & 0x3F) +
				TABLE.charAt(buffer >> 12 & 0x3F) +
				TABLE.charAt(buffer >> 6 & 0x3F) +
				TABLE.charAt(buffer & 0x3F)
			);
		}

		if (padding == 2) {
			a = input.charCodeAt(position) << 8;
			b = input.charCodeAt(++position);
			buffer = a + b;
			output += (
				TABLE.charAt(buffer >> 10) +
				TABLE.charAt((buffer >> 4) & 0x3F) +
				TABLE.charAt((buffer << 2) & 0x3F) +
				'='
			);
		} else if (padding == 1) {
			buffer = input.charCodeAt(position);
			output += (
				TABLE.charAt(buffer >> 2) +
				TABLE.charAt((buffer << 4) & 0x3F) +
				'=='
			);
		}

		return output;
	};

	var base64 = {
		'encode': encode,
		'decode': decode,
		'version': '0.1.0'
	};

	// Some AMD build optimizers, like r.js, check for specific condition patterns
	// like the following:
	if (
		typeof define == 'function' &&
		typeof define.amd == 'object' &&
		define.amd
	) {
		define(function() {
			return base64;
		});
	}	else if (freeExports && !freeExports.nodeType) {
		if (freeModule) { // in Node.js or RingoJS v0.8.0+
			freeModule.exports = base64;
		} else { // in Narwhal or RingoJS v0.7.0-
			for (var key in base64) {
				base64.hasOwnProperty(key) && (freeExports[key] = base64[key]);
			}
		}
	} else { // in Rhino or a web browser
		root.base64 = base64;
	}

}(this));

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],4:[function(require,module,exports){
var Modernizr = require('./lib/Modernizr'),
    ModernizrProto = require('./lib/ModernizrProto'),
    classes = require('./lib/classes'),
    testRunner = require('./lib/testRunner'),
    setClasses = require('./lib/setClasses');

// Run each test
testRunner();

// Remove the "no-js" class if it exists
setClasses(classes);

delete ModernizrProto.addTest;
delete ModernizrProto.addAsyncTest;

// Run the things that are supposed to run after the tests
for (var i = 0; i < Modernizr._q.length; i++) {
  Modernizr._q[i]();
}

module.exports = Modernizr;

},{"./lib/Modernizr":5,"./lib/ModernizrProto":6,"./lib/classes":8,"./lib/setClasses":28,"./lib/testRunner":33}],5:[function(require,module,exports){
var ModernizrProto = require('./ModernizrProto.js');
  // Fake some of Object.create so we can force non test results to be non "own" properties.
  var Modernizr = function() {};
  Modernizr.prototype = ModernizrProto;

  // Leak modernizr globally when you `require` it rather than force it here.
  // Overwrite name so constructor name is nicer :D
  Modernizr = new Modernizr();

  module.exports = Modernizr;


},{"./ModernizrProto.js":6}],6:[function(require,module,exports){
var tests = require('./tests.js');
  /**
   *
   * ModernizrProto is the constructor for Modernizr
   *
   * @class
   * @access public
   */

  var ModernizrProto = {
    // The current version, dummy
    _version: '3.4.0 (browsernizr 2.2.0)',

    // Any settings that don't work as separate modules
    // can go in here as configuration.
    _config: {
      'classPrefix': '',
      'enableClasses': true,
      'enableJSClass': true,
      'usePrefixes': true
    },

    // Queue of tests
    _q: [],

    // Stub these for people who are listening
    on: function(test, cb) {
      // I don't really think people should do this, but we can
      // safe guard it a bit.
      // -- NOTE:: this gets WAY overridden in src/addTest for actual async tests.
      // This is in case people listen to synchronous tests. I would leave it out,
      // but the code to *disallow* sync tests in the real version of this
      // function is actually larger than this.
      var self = this;
      setTimeout(function() {
        cb(self[test]);
      }, 0);
    },

    addTest: function(name, fn, options) {
      tests.push({name: name, fn: fn, options: options});
    },

    addAsyncTest: function(fn) {
      tests.push({name: null, fn: fn});
    }
  };

  module.exports = ModernizrProto;


},{"./tests.js":35}],7:[function(require,module,exports){
var ModernizrProto = require('./ModernizrProto.js');
var prefixes = require('./cssomPrefixes.js');
  /**
   * atRule returns a given CSS property at-rule (eg @keyframes), possibly in
   * some prefixed form, or false, in the case of an unsupported rule
   *
   * @memberof Modernizr
   * @name Modernizr.atRule
   * @optionName Modernizr.atRule()
   * @optionProp atRule
   * @access public
   * @function atRule
   * @param {string} prop - String name of the @-rule to test for
   * @returns {string|boolean} The string representing the (possibly prefixed)
   * valid version of the @-rule, or `false` when it is unsupported.
   * @example
   * ```js
   *  var keyframes = Modernizr.atRule('@keyframes');
   *
   *  if (keyframes) {
   *    // keyframes are supported
   *    // could be `@-webkit-keyframes` or `@keyframes`
   *  } else {
   *    // keyframes === `false`
   *  }
   * ```
   *
   */

  var atRule = function(prop) {
    var length = prefixes.length;
    var cssrule = window.CSSRule;
    var rule;

    if (typeof cssrule === 'undefined') {
      return undefined;
    }

    if (!prop) {
      return false;
    }

    // remove literal @ from beginning of provided property
    prop = prop.replace(/^@/, '');

    // CSSRules use underscores instead of dashes
    rule = prop.replace(/-/g, '_').toUpperCase() + '_RULE';

    if (rule in cssrule) {
      return '@' + prop;
    }

    for (var i = 0; i < length; i++) {
      // prefixes gives us something like -o-, and we want O_
      var prefix = prefixes[i];
      var thisRule = prefix.toUpperCase() + '_' + rule;

      if (thisRule in cssrule) {
        return '@-' + prefix.toLowerCase() + '-' + prop;
      }
    }

    return false;
  };

  ModernizrProto.atRule = atRule;

  module.exports = atRule;


},{"./ModernizrProto.js":6,"./cssomPrefixes.js":13}],8:[function(require,module,exports){

  var classes = [];
  module.exports = classes;


},{}],9:[function(require,module,exports){


  /**
   * wrapper around getComputedStyle, to fix issues with Firefox returning null when
   * called inside of a hidden iframe
   *
   * @access private
   * @function computedStyle
   * @param {HTMLElement|SVGElement} - The element we want to find the computed styles of
   * @param {string|null} [pseudoSelector]- An optional pseudo element selector (e.g. :before), of null if none
   * @returns {CSSStyleDeclaration}
   */

  function computedStyle(elem, pseudo, prop) {
    var result;

    if ('getComputedStyle' in window) {
      result = getComputedStyle.call(window, elem, pseudo);
      var console = window.console;

      if (result !== null) {
        if (prop) {
          result = result.getPropertyValue(prop);
        }
      } else {
        if (console) {
          var method = console.error ? 'error' : 'log';
          console[method].call(console, 'getComputedStyle returning null, its possible modernizr test results are inaccurate');
        }
      }
    } else {
      result = !pseudo && elem.currentStyle && elem.currentStyle[prop];
    }

    return result;
  }

  module.exports = computedStyle;


},{}],10:[function(require,module,exports){


  /**
   * contains checks to see if a string contains another string
   *
   * @access private
   * @function contains
   * @param {string} str - The string we want to check for substrings
   * @param {string} substr - The substring we want to search the first string for
   * @returns {boolean}
   */

  function contains(str, substr) {
    return !!~('' + str).indexOf(substr);
  }

  module.exports = contains;


},{}],11:[function(require,module,exports){
var isSVG = require('./isSVG.js');
  /**
   * createElement is a convenience wrapper around document.createElement. Since we
   * use createElement all over the place, this allows for (slightly) smaller code
   * as well as abstracting away issues with creating elements in contexts other than
   * HTML documents (e.g. SVG documents).
   *
   * @access private
   * @function createElement
   * @returns {HTMLElement|SVGElement} An HTML or SVG element
   */

  function createElement() {
    if (typeof document.createElement !== 'function') {
      // This is the case in IE7, where the type of createElement is "object".
      // For this reason, we cannot call apply() as Object is not a Function.
      return document.createElement(arguments[0]);
    } else if (isSVG) {
      return document.createElementNS.call(document, 'http://www.w3.org/2000/svg', arguments[0]);
    } else {
      return document.createElement.apply(document, arguments);
    }
  }

  module.exports = createElement;


},{"./isSVG.js":21}],12:[function(require,module,exports){

  /**
   * cssToDOM takes a kebab-case string and converts it to camelCase
   * e.g. box-sizing -> boxSizing
   *
   * @access private
   * @function cssToDOM
   * @param {string} name - String name of kebab-case prop we want to convert
   * @returns {string} The camelCase version of the supplied name
   */

  function cssToDOM(name) {
    return name.replace(/([a-z])-([a-z])/g, function(str, m1, m2) {
      return m1 + m2.toUpperCase();
    }).replace(/^-/, '');
  }
  module.exports = cssToDOM;


},{}],13:[function(require,module,exports){
var ModernizrProto = require('./ModernizrProto.js');
var omPrefixes = require('./omPrefixes.js');
  var cssomPrefixes = (ModernizrProto._config.usePrefixes ? omPrefixes.split(' ') : []);
  ModernizrProto._cssomPrefixes = cssomPrefixes;
  module.exports = cssomPrefixes;


},{"./ModernizrProto.js":6,"./omPrefixes.js":25}],14:[function(require,module,exports){

  /**
   * docElement is a convenience wrapper to grab the root element of the document
   *
   * @access private
   * @returns {HTMLElement|SVGElement} The root element of the document
   */

  var docElement = document.documentElement;
  module.exports = docElement;


},{}],15:[function(require,module,exports){
var ModernizrProto = require('./ModernizrProto.js');
var omPrefixes = require('./omPrefixes.js');
  /**
   * List of JavaScript DOM values used for tests
   *
   * @memberof Modernizr
   * @name Modernizr._domPrefixes
   * @optionName Modernizr._domPrefixes
   * @optionProp domPrefixes
   * @access public
   * @example
   *
   * Modernizr._domPrefixes is exactly the same as [_prefixes](#modernizr-_prefixes), but rather
   * than kebab-case properties, all properties are their Capitalized variant
   *
   * ```js
   * Modernizr._domPrefixes === [ "Moz", "O", "ms", "Webkit" ];
   * ```
   */

  var domPrefixes = (ModernizrProto._config.usePrefixes ? omPrefixes.toLowerCase().split(' ') : []);
  ModernizrProto._domPrefixes = domPrefixes;
  module.exports = domPrefixes;


},{"./ModernizrProto.js":6,"./omPrefixes.js":25}],16:[function(require,module,exports){

  /**
   * domToCSS takes a camelCase string and converts it to kebab-case
   * e.g. boxSizing -> box-sizing
   *
   * @access private
   * @function domToCSS
   * @param {string} name - String name of camelCase prop we want to convert
   * @returns {string} The kebab-case version of the supplied name
   */

  function domToCSS(name) {
    return name.replace(/([A-Z])/g, function(str, m1) {
      return '-' + m1.toLowerCase();
    }).replace(/^ms-/, '-ms-');
  }
  module.exports = domToCSS;


},{}],17:[function(require,module,exports){

  /**
   * fnBind is a super small [bind](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/bind) polyfill.
   *
   * @access private
   * @function fnBind
   * @param {function} fn - a function you want to change `this` reference to
   * @param {object} that - the `this` you want to call the function with
   * @returns {function} The wrapped version of the supplied function
   */

  function fnBind(fn, that) {
    return function() {
      return fn.apply(that, arguments);
    };
  }

  module.exports = fnBind;


},{}],18:[function(require,module,exports){
var createElement = require('./createElement.js');
var isSVG = require('./isSVG.js');
  /**
   * getBody returns the body of a document, or an element that can stand in for
   * the body if a real body does not exist
   *
   * @access private
   * @function getBody
   * @returns {HTMLElement|SVGElement} Returns the real body of a document, or an
   * artificially created element that stands in for the body
   */

  function getBody() {
    // After page load injecting a fake body doesn't work so check if body exists
    var body = document.body;

    if (!body) {
      // Can't use the real body create a fake one.
      body = createElement(isSVG ? 'svg' : 'body');
      body.fake = true;
    }

    return body;
  }

  module.exports = getBody;


},{"./createElement.js":11,"./isSVG.js":21}],19:[function(require,module,exports){
var ModernizrProto = require('./ModernizrProto.js');
var docElement = require('./docElement.js');
var createElement = require('./createElement.js');
var getBody = require('./getBody.js');
  /**
   * injectElementWithStyles injects an element with style element and some CSS rules
   *
   * @access private
   * @function injectElementWithStyles
   * @param {string} rule - String representing a css rule
   * @param {function} callback - A function that is used to test the injected element
   * @param {number} [nodes] - An integer representing the number of additional nodes you want injected
   * @param {string[]} [testnames] - An array of strings that are used as ids for the additional nodes
   * @returns {boolean}
   */

  function injectElementWithStyles(rule, callback, nodes, testnames) {
    var mod = 'modernizr';
    var style;
    var ret;
    var node;
    var docOverflow;
    var div = createElement('div');
    var body = getBody();

    if (parseInt(nodes, 10)) {
      // In order not to give false positives we create a node for each test
      // This also allows the method to scale for unspecified uses
      while (nodes--) {
        node = createElement('div');
        node.id = testnames ? testnames[nodes] : mod + (nodes + 1);
        div.appendChild(node);
      }
    }

    style = createElement('style');
    style.type = 'text/css';
    style.id = 's' + mod;

    // IE6 will false positive on some tests due to the style element inside the test div somehow interfering offsetHeight, so insert it into body or fakebody.
    // Opera will act all quirky when injecting elements in documentElement when page is served as xml, needs fakebody too. #270
    (!body.fake ? div : body).appendChild(style);
    body.appendChild(div);

    if (style.styleSheet) {
      style.styleSheet.cssText = rule;
    } else {
      style.appendChild(document.createTextNode(rule));
    }
    div.id = mod;

    if (body.fake) {
      //avoid crashing IE8, if background image is used
      body.style.background = '';
      //Safari 5.13/5.1.4 OSX stops loading if ::-webkit-scrollbar is used and scrollbars are visible
      body.style.overflow = 'hidden';
      docOverflow = docElement.style.overflow;
      docElement.style.overflow = 'hidden';
      docElement.appendChild(body);
    }

    ret = callback(div, rule);
    // If this is done after page load we don't want to remove the body so check if body exists
    if (body.fake) {
      body.parentNode.removeChild(body);
      docElement.style.overflow = docOverflow;
      // Trigger layout so kinetic scrolling isn't disabled in iOS6+
      // eslint-disable-next-line
      docElement.offsetHeight;
    } else {
      div.parentNode.removeChild(div);
    }

    return !!ret;

  }

  module.exports = injectElementWithStyles;


},{"./ModernizrProto.js":6,"./createElement.js":11,"./docElement.js":14,"./getBody.js":18}],20:[function(require,module,exports){

  /**
   * is returns a boolean if the typeof an obj is exactly type.
   *
   * @access private
   * @function is
   * @param {*} obj - A thing we want to check the type of
   * @param {string} type - A string to compare the typeof against
   * @returns {boolean}
   */

  function is(obj, type) {
    return typeof obj === type;
  }
  module.exports = is;


},{}],21:[function(require,module,exports){
var docElement = require('./docElement.js');
  /**
   * A convenience helper to check if the document we are running in is an SVG document
   *
   * @access private
   * @returns {boolean}
   */

  var isSVG = docElement.nodeName.toLowerCase() === 'svg';
  module.exports = isSVG;


},{"./docElement.js":14}],22:[function(require,module,exports){
var Modernizr = require('./Modernizr.js');
var modElem = require('./modElem.js');
  var mStyle = {
    style: modElem.elem.style
  };

  // kill ref for gc, must happen before mod.elem is removed, so we unshift on to
  // the front of the queue.
  Modernizr._q.unshift(function() {
    delete mStyle.style;
  });

  module.exports = mStyle;


},{"./Modernizr.js":5,"./modElem.js":23}],23:[function(require,module,exports){
var Modernizr = require('./Modernizr.js');
var createElement = require('./createElement.js');
  /**
   * Create our "modernizr" element that we do most feature tests on.
   *
   * @access private
   */

  var modElem = {
    elem: createElement('modernizr')
  };

  // Clean up this element
  Modernizr._q.push(function() {
    delete modElem.elem;
  });

  module.exports = modElem;


},{"./Modernizr.js":5,"./createElement.js":11}],24:[function(require,module,exports){
var injectElementWithStyles = require('./injectElementWithStyles.js');
var domToCSS = require('./domToCSS.js');
var computedStyle = require('./computedStyle.js');
  /**
   * nativeTestProps allows for us to use native feature detection functionality if available.
   * some prefixed form, or false, in the case of an unsupported rule
   *
   * @access private
   * @function nativeTestProps
   * @param {array} props - An array of property names
   * @param {string} value - A string representing the value we want to check via @supports
   * @returns {boolean|undefined} A boolean when @supports exists, undefined otherwise
   */

  // Accepts a list of property names and a single value
  // Returns `undefined` if native detection not available
  function nativeTestProps(props, value) {
    var i = props.length;
    // Start with the JS API: http://www.w3.org/TR/css3-conditional/#the-css-interface
    if ('CSS' in window && 'supports' in window.CSS) {
      // Try every prefixed variant of the property
      while (i--) {
        if (window.CSS.supports(domToCSS(props[i]), value)) {
          return true;
        }
      }
      return false;
    }
    // Otherwise fall back to at-rule (for Opera 12.x)
    else if ('CSSSupportsRule' in window) {
      // Build a condition string for every prefixed variant
      var conditionText = [];
      while (i--) {
        conditionText.push('(' + domToCSS(props[i]) + ':' + value + ')');
      }
      conditionText = conditionText.join(' or ');
      return injectElementWithStyles('@supports (' + conditionText + ') { #modernizr { position: absolute; } }', function(node) {
        return computedStyle(node, null, 'position') == 'absolute';
      });
    }
    return undefined;
  }
  module.exports = nativeTestProps;


},{"./computedStyle.js":9,"./domToCSS.js":16,"./injectElementWithStyles.js":19}],25:[function(require,module,exports){

  /**
   * If the browsers follow the spec, then they would expose vendor-specific styles as:
   *   elem.style.WebkitBorderRadius
   * instead of something like the following (which is technically incorrect):
   *   elem.style.webkitBorderRadius

   * WebKit ghosts their properties in lowercase but Opera & Moz do not.
   * Microsoft uses a lowercase `ms` instead of the correct `Ms` in IE8+
   *   erik.eae.net/archives/2008/03/10/21.48.10/

   * More here: github.com/Modernizr/Modernizr/issues/issue/21
   *
   * @access private
   * @returns {string} The string representing the vendor-specific style properties
   */

  var omPrefixes = 'Moz O ms Webkit';
  module.exports = omPrefixes;


},{}],26:[function(require,module,exports){
var ModernizrProto = require('./ModernizrProto.js');
var testPropsAll = require('./testPropsAll.js');
var cssToDOM = require('./cssToDOM.js');
var atRule = require('./atRule.js');
  /**
   * prefixed returns the prefixed or nonprefixed property name variant of your input
   *
   * @memberof Modernizr
   * @name Modernizr.prefixed
   * @optionName Modernizr.prefixed()
   * @optionProp prefixed
   * @access public
   * @function prefixed
   * @param {string} prop - String name of the property to test for
   * @param {object} [obj] - An object to test for the prefixed properties on
   * @param {HTMLElement} [elem] - An element used to test specific properties against
   * @returns {string|false} The string representing the (possibly prefixed) valid
   * version of the property, or `false` when it is unsupported.
   * @example
   *
   * Modernizr.prefixed takes a string css value in the DOM style camelCase (as
   * opposed to the css style kebab-case) form and returns the (possibly prefixed)
   * version of that property that the browser actually supports.
   *
   * For example, in older Firefox...
   * ```js
   * prefixed('boxSizing')
   * ```
   * returns 'MozBoxSizing'
   *
   * In newer Firefox, as well as any other browser that support the unprefixed
   * version would simply return `boxSizing`. Any browser that does not support
   * the property at all, it will return `false`.
   *
   * By default, prefixed is checked against a DOM element. If you want to check
   * for a property on another object, just pass it as a second argument
   *
   * ```js
   * var rAF = prefixed('requestAnimationFrame', window);
   *
   * raf(function() {
   *  renderFunction();
   * })
   * ```
   *
   * Note that this will return _the actual function_ - not the name of the function.
   * If you need the actual name of the property, pass in `false` as a third argument
   *
   * ```js
   * var rAFProp = prefixed('requestAnimationFrame', window, false);
   *
   * rafProp === 'WebkitRequestAnimationFrame' // in older webkit
   * ```
   *
   * One common use case for prefixed is if you're trying to determine which transition
   * end event to bind to, you might do something like...
   * ```js
   * var transEndEventNames = {
   *     'WebkitTransition' : 'webkitTransitionEnd', * Saf 6, Android Browser
   *     'MozTransition'    : 'transitionend',       * only for FF < 15
   *     'transition'       : 'transitionend'        * IE10, Opera, Chrome, FF 15+, Saf 7+
   * };
   *
   * var transEndEventName = transEndEventNames[ Modernizr.prefixed('transition') ];
   * ```
   *
   * If you want a similar lookup, but in kebab-case, you can use [prefixedCSS](#modernizr-prefixedcss).
   */

  var prefixed = ModernizrProto.prefixed = function(prop, obj, elem) {
    if (prop.indexOf('@') === 0) {
      return atRule(prop);
    }

    if (prop.indexOf('-') != -1) {
      // Convert kebab-case to camelCase
      prop = cssToDOM(prop);
    }
    if (!obj) {
      return testPropsAll(prop, 'pfx');
    } else {
      // Testing DOM property e.g. Modernizr.prefixed('requestAnimationFrame', window) // 'mozRequestAnimationFrame'
      return testPropsAll(prop, obj, elem);
    }
  };

  module.exports = prefixed;


},{"./ModernizrProto.js":6,"./atRule.js":7,"./cssToDOM.js":12,"./testPropsAll.js":32}],27:[function(require,module,exports){
var ModernizrProto = require('./ModernizrProto.js');
  /**
   * List of property values to set for css tests. See ticket #21
   * http://git.io/vUGl4
   *
   * @memberof Modernizr
   * @name Modernizr._prefixes
   * @optionName Modernizr._prefixes
   * @optionProp prefixes
   * @access public
   * @example
   *
   * Modernizr._prefixes is the internal list of prefixes that we test against
   * inside of things like [prefixed](#modernizr-prefixed) and [prefixedCSS](#-code-modernizr-prefixedcss). It is simply
   * an array of kebab-case vendor prefixes you can use within your code.
   *
   * Some common use cases include
   *
   * Generating all possible prefixed version of a CSS property
   * ```js
   * var rule = Modernizr._prefixes.join('transform: rotate(20deg); ');
   *
   * rule === 'transform: rotate(20deg); webkit-transform: rotate(20deg); moz-transform: rotate(20deg); o-transform: rotate(20deg); ms-transform: rotate(20deg);'
   * ```
   *
   * Generating all possible prefixed version of a CSS value
   * ```js
   * rule = 'display:' +  Modernizr._prefixes.join('flex; display:') + 'flex';
   *
   * rule === 'display:flex; display:-webkit-flex; display:-moz-flex; display:-o-flex; display:-ms-flex; display:flex'
   * ```
   */

  // we use ['',''] rather than an empty array in order to allow a pattern of .`join()`ing prefixes to test
  // values in feature detects to continue to work
  var prefixes = (ModernizrProto._config.usePrefixes ? ' -webkit- -moz- -o- -ms- '.split(' ') : ['','']);

  // expose these for the plugin API. Look in the source for how to join() them against your input
  ModernizrProto._prefixes = prefixes;

  module.exports = prefixes;


},{"./ModernizrProto.js":6}],28:[function(require,module,exports){
var Modernizr = require('./Modernizr.js');
var docElement = require('./docElement.js');
var isSVG = require('./isSVG.js');
  /**
   * setClasses takes an array of class names and adds them to the root element
   *
   * @access private
   * @function setClasses
   * @param {string[]} classes - Array of class names
   */

  // Pass in an and array of class names, e.g.:
  //  ['no-webp', 'borderradius', ...]
  function setClasses(classes) {
    var className = docElement.className;
    var classPrefix = Modernizr._config.classPrefix || '';

    if (isSVG) {
      className = className.baseVal;
    }

    // Change `no-js` to `js` (independently of the `enableClasses` option)
    // Handle classPrefix on this too
    if (Modernizr._config.enableJSClass) {
      var reJS = new RegExp('(^|\\s)' + classPrefix + 'no-js(\\s|$)');
      className = className.replace(reJS, '$1' + classPrefix + 'js$2');
    }

    if (Modernizr._config.enableClasses) {
      // Add the new classes
      className += ' ' + classPrefix + classes.join(' ' + classPrefix);
      if (isSVG) {
        docElement.className.baseVal = className;
      } else {
        docElement.className = className;
      }
    }

  }

  module.exports = setClasses;


},{"./Modernizr.js":5,"./docElement.js":14,"./isSVG.js":21}],29:[function(require,module,exports){
var ModernizrProto = require('./ModernizrProto.js');
var testPropsAll = require('./testPropsAll.js');
  /**
   * testAllProps determines whether a given CSS property is supported in the browser
   *
   * @memberof Modernizr
   * @name Modernizr.testAllProps
   * @optionName Modernizr.testAllProps()
   * @optionProp testAllProps
   * @access public
   * @function testAllProps
   * @param {string} prop - String naming the property to test (either camelCase or kebab-case)
   * @param {string} [value] - String of the value to test
   * @param {boolean} [skipValueTest=false] - Whether to skip testing that the value is supported when using non-native detection
   * @example
   *
   * testAllProps determines whether a given CSS property, in some prefixed form,
   * is supported by the browser.
   *
   * ```js
   * testAllProps('boxSizing')  // true
   * ```
   *
   * It can optionally be given a CSS value in string form to test if a property
   * value is valid
   *
   * ```js
   * testAllProps('display', 'block') // true
   * testAllProps('display', 'penguin') // false
   * ```
   *
   * A boolean can be passed as a third parameter to skip the value check when
   * native detection (@supports) isn't available.
   *
   * ```js
   * testAllProps('shapeOutside', 'content-box', true);
   * ```
   */

  function testAllProps(prop, value, skipValueTest) {
    return testPropsAll(prop, undefined, undefined, value, skipValueTest);
  }
  ModernizrProto.testAllProps = testAllProps;
  module.exports = testAllProps;


},{"./ModernizrProto.js":6,"./testPropsAll.js":32}],30:[function(require,module,exports){
var is = require('./is.js');
var fnBind = require('./fnBind.js');
  /**
   * testDOMProps is a generic DOM property test; if a browser supports
   *   a certain property, it won't return undefined for it.
   *
   * @access private
   * @function testDOMProps
   * @param {array.<string>} props - An array of properties to test for
   * @param {object} obj - An object or Element you want to use to test the parameters again
   * @param {boolean|object} elem - An Element to bind the property lookup again. Use `false` to prevent the check
   * @returns {false|*} returns false if the prop is unsupported, otherwise the value that is supported
   */
  function testDOMProps(props, obj, elem) {
    var item;

    for (var i in props) {
      if (props[i] in obj) {

        // return the property name as a string
        if (elem === false) {
          return props[i];
        }

        item = obj[props[i]];

        // let's bind a function
        if (is(item, 'function')) {
          // bind to obj unless overriden
          return fnBind(item, elem || obj);
        }

        // return the unbound function or obj or value
        return item;
      }
    }
    return false;
  }

  module.exports = testDOMProps;


},{"./fnBind.js":17,"./is.js":20}],31:[function(require,module,exports){
var contains = require('./contains.js');
var mStyle = require('./mStyle.js');
var createElement = require('./createElement.js');
var nativeTestProps = require('./nativeTestProps.js');
var is = require('./is.js');
var cssToDOM = require('./cssToDOM.js');
  // testProps is a generic CSS / DOM property test.

  // In testing support for a given CSS property, it's legit to test:
  //    `elem.style[styleName] !== undefined`
  // If the property is supported it will return an empty string,
  // if unsupported it will return undefined.

  // We'll take advantage of this quick test and skip setting a style
  // on our modernizr element, but instead just testing undefined vs
  // empty string.

  // Property names can be provided in either camelCase or kebab-case.

  function testProps(props, prefixed, value, skipValueTest) {
    skipValueTest = is(skipValueTest, 'undefined') ? false : skipValueTest;

    // Try native detect first
    if (!is(value, 'undefined')) {
      var result = nativeTestProps(props, value);
      if (!is(result, 'undefined')) {
        return result;
      }
    }

    // Otherwise do it properly
    var afterInit, i, propsLength, prop, before;

    // If we don't have a style element, that means we're running async or after
    // the core tests, so we'll need to create our own elements to use

    // inside of an SVG element, in certain browsers, the `style` element is only
    // defined for valid tags. Therefore, if `modernizr` does not have one, we
    // fall back to a less used element and hope for the best.
    // for strict XHTML browsers the hardly used samp element is used
    var elems = ['modernizr', 'tspan', 'samp'];
    while (!mStyle.style && elems.length) {
      afterInit = true;
      mStyle.modElem = createElement(elems.shift());
      mStyle.style = mStyle.modElem.style;
    }

    // Delete the objects if we created them.
    function cleanElems() {
      if (afterInit) {
        delete mStyle.style;
        delete mStyle.modElem;
      }
    }

    propsLength = props.length;
    for (i = 0; i < propsLength; i++) {
      prop = props[i];
      before = mStyle.style[prop];

      if (contains(prop, '-')) {
        prop = cssToDOM(prop);
      }

      if (mStyle.style[prop] !== undefined) {

        // If value to test has been passed in, do a set-and-check test.
        // 0 (integer) is a valid property value, so check that `value` isn't
        // undefined, rather than just checking it's truthy.
        if (!skipValueTest && !is(value, 'undefined')) {

          // Needs a try catch block because of old IE. This is slow, but will
          // be avoided in most cases because `skipValueTest` will be used.
          try {
            mStyle.style[prop] = value;
          } catch (e) {}

          // If the property value has changed, we assume the value used is
          // supported. If `value` is empty string, it'll fail here (because
          // it hasn't changed), which matches how browsers have implemented
          // CSS.supports()
          if (mStyle.style[prop] != before) {
            cleanElems();
            return prefixed == 'pfx' ? prop : true;
          }
        }
        // Otherwise just return true, or the property name if this is a
        // `prefixed()` call
        else {
          cleanElems();
          return prefixed == 'pfx' ? prop : true;
        }
      }
    }
    cleanElems();
    return false;
  }

  module.exports = testProps;


},{"./contains.js":10,"./createElement.js":11,"./cssToDOM.js":12,"./is.js":20,"./mStyle.js":22,"./nativeTestProps.js":24}],32:[function(require,module,exports){
var ModernizrProto = require('./ModernizrProto.js');
var cssomPrefixes = require('./cssomPrefixes.js');
var is = require('./is.js');
var testProps = require('./testProps.js');
var domPrefixes = require('./domPrefixes.js');
var testDOMProps = require('./testDOMProps.js');
  /**
   * testPropsAll tests a list of DOM properties we want to check against.
   * We specify literally ALL possible (known and/or likely) properties on
   * the element including the non-vendor prefixed one, for forward-
   * compatibility.
   *
   * @access private
   * @function testPropsAll
   * @param {string} prop - A string of the property to test for
   * @param {string|object} [prefixed] - An object to check the prefixed properties on. Use a string to skip
   * @param {HTMLElement|SVGElement} [elem] - An element used to test the property and value against
   * @param {string} [value] - A string of a css value
   * @param {boolean} [skipValueTest] - An boolean representing if you want to test if value sticks when set
   * @returns {false|string} returns the string version of the property, or false if it is unsupported
   */
  function testPropsAll(prop, prefixed, elem, value, skipValueTest) {

    var ucProp = prop.charAt(0).toUpperCase() + prop.slice(1),
      props = (prop + ' ' + cssomPrefixes.join(ucProp + ' ') + ucProp).split(' ');

    // did they call .prefixed('boxSizing') or are we just testing a prop?
    if (is(prefixed, 'string') || is(prefixed, 'undefined')) {
      return testProps(props, prefixed, value, skipValueTest);

      // otherwise, they called .prefixed('requestAnimationFrame', window[, elem])
    } else {
      props = (prop + ' ' + (domPrefixes).join(ucProp + ' ') + ucProp).split(' ');
      return testDOMProps(props, prefixed, elem);
    }
  }

  // Modernizr.testAllProps() investigates whether a given style property,
  // or any of its vendor-prefixed variants, is recognized
  //
  // Note that the property names must be provided in the camelCase variant.
  // Modernizr.testAllProps('boxSizing')
  ModernizrProto.testAllProps = testPropsAll;

  module.exports = testPropsAll;


},{"./ModernizrProto.js":6,"./cssomPrefixes.js":13,"./domPrefixes.js":15,"./is.js":20,"./testDOMProps.js":30,"./testProps.js":31}],33:[function(require,module,exports){
var tests = require('./tests.js');
var Modernizr = require('./Modernizr.js');
var classes = require('./classes.js');
var is = require('./is.js');
  /**
   * Run through all tests and detect their support in the current UA.
   *
   * @access private
   */

  function testRunner() {
    var featureNames;
    var feature;
    var aliasIdx;
    var result;
    var nameIdx;
    var featureName;
    var featureNameSplit;

    for (var featureIdx in tests) {
      if (tests.hasOwnProperty(featureIdx)) {
        featureNames = [];
        feature = tests[featureIdx];
        // run the test, throw the return value into the Modernizr,
        // then based on that boolean, define an appropriate className
        // and push it into an array of classes we'll join later.
        //
        // If there is no name, it's an 'async' test that is run,
        // but not directly added to the object. That should
        // be done with a post-run addTest call.
        if (feature.name) {
          featureNames.push(feature.name.toLowerCase());

          if (feature.options && feature.options.aliases && feature.options.aliases.length) {
            // Add all the aliases into the names list
            for (aliasIdx = 0; aliasIdx < feature.options.aliases.length; aliasIdx++) {
              featureNames.push(feature.options.aliases[aliasIdx].toLowerCase());
            }
          }
        }

        // Run the test, or use the raw value if it's not a function
        result = is(feature.fn, 'function') ? feature.fn() : feature.fn;


        // Set each of the names on the Modernizr object
        for (nameIdx = 0; nameIdx < featureNames.length; nameIdx++) {
          featureName = featureNames[nameIdx];
          // Support dot properties as sub tests. We don't do checking to make sure
          // that the implied parent tests have been added. You must call them in
          // order (either in the test, or make the parent test a dependency).
          //
          // Cap it to TWO to make the logic simple and because who needs that kind of subtesting
          // hashtag famous last words
          featureNameSplit = featureName.split('.');

          if (featureNameSplit.length === 1) {
            Modernizr[featureNameSplit[0]] = result;
          } else {
            // cast to a Boolean, if not one already
            if (Modernizr[featureNameSplit[0]] && !(Modernizr[featureNameSplit[0]] instanceof Boolean)) {
              Modernizr[featureNameSplit[0]] = new Boolean(Modernizr[featureNameSplit[0]]);
            }

            Modernizr[featureNameSplit[0]][featureNameSplit[1]] = result;
          }

          classes.push((result ? '' : 'no-') + featureNameSplit.join('-'));
        }
      }
    }
  }
  module.exports = testRunner;


},{"./Modernizr.js":5,"./classes.js":8,"./is.js":20,"./tests.js":35}],34:[function(require,module,exports){
var ModernizrProto = require('./ModernizrProto.js');
var injectElementWithStyles = require('./injectElementWithStyles.js');
  /**
   * testStyles injects an element with style element and some CSS rules
   *
   * @memberof Modernizr
   * @name Modernizr.testStyles
   * @optionName Modernizr.testStyles()
   * @optionProp testStyles
   * @access public
   * @function testStyles
   * @param {string} rule - String representing a css rule
   * @param {function} callback - A function that is used to test the injected element
   * @param {number} [nodes] - An integer representing the number of additional nodes you want injected
   * @param {string[]} [testnames] - An array of strings that are used as ids for the additional nodes
   * @returns {boolean}
   * @example
   *
   * `Modernizr.testStyles` takes a CSS rule and injects it onto the current page
   * along with (possibly multiple) DOM elements. This lets you check for features
   * that can not be detected by simply checking the [IDL](https://developer.mozilla.org/en-US/docs/Mozilla/Developer_guide/Interface_development_guide/IDL_interface_rules).
   *
   * ```js
   * Modernizr.testStyles('#modernizr { width: 9px; color: papayawhip; }', function(elem, rule) {
   *   // elem is the first DOM node in the page (by default #modernizr)
   *   // rule is the first argument you supplied - the CSS rule in string form
   *
   *   addTest('widthworks', elem.style.width === '9px')
   * });
   * ```
   *
   * If your test requires multiple nodes, you can include a third argument
   * indicating how many additional div elements to include on the page. The
   * additional nodes are injected as children of the `elem` that is returned as
   * the first argument to the callback.
   *
   * ```js
   * Modernizr.testStyles('#modernizr {width: 1px}; #modernizr2 {width: 2px}', function(elem) {
   *   document.getElementById('modernizr').style.width === '1px'; // true
   *   document.getElementById('modernizr2').style.width === '2px'; // true
   *   elem.firstChild === document.getElementById('modernizr2'); // true
   * }, 1);
   * ```
   *
   * By default, all of the additional elements have an ID of `modernizr[n]`, where
   * `n` is its index (e.g. the first additional, second overall is `#modernizr2`,
   * the second additional is `#modernizr3`, etc.).
   * If you want to have more meaningful IDs for your function, you can provide
   * them as the fourth argument, as an array of strings
   *
   * ```js
   * Modernizr.testStyles('#foo {width: 10px}; #bar {height: 20px}', function(elem) {
   *   elem.firstChild === document.getElementById('foo'); // true
   *   elem.lastChild === document.getElementById('bar'); // true
   * }, 2, ['foo', 'bar']);
   * ```
   *
   */

  var testStyles = ModernizrProto.testStyles = injectElementWithStyles;
  module.exports = testStyles;


},{"./ModernizrProto.js":6,"./injectElementWithStyles.js":19}],35:[function(require,module,exports){

  var tests = [];
  module.exports = tests;


},{}],36:[function(require,module,exports){
/*!
{
  "name": "@font-face",
  "property": "fontface",
  "authors": ["Diego Perini", "Mat Marquis"],
  "tags": ["css"],
  "knownBugs": [
    "False Positive: WebOS https://github.com/Modernizr/Modernizr/issues/342",
    "False Postive: WP7 https://github.com/Modernizr/Modernizr/issues/538"
  ],
  "notes": [{
    "name": "@font-face detection routine by Diego Perini",
    "href": "http://javascript.nwbox.com/CSSSupport/"
  },{
    "name": "Filament Group @font-face compatibility research",
    "href": "https://docs.google.com/presentation/d/1n4NyG4uPRjAA8zn_pSQ_Ket0RhcWC6QlZ6LMjKeECo0/edit#slide=id.p"
  },{
    "name": "Filament Grunticon/@font-face device testing results",
    "href": "https://docs.google.com/spreadsheet/ccc?key=0Ag5_yGvxpINRdHFYeUJPNnZMWUZKR2ItMEpRTXZPdUE#gid=0"
  },{
    "name": "CSS fonts on Android",
    "href": "https://stackoverflow.com/questions/3200069/css-fonts-on-android"
  },{
    "name": "@font-face and Android",
    "href": "http://archivist.incutio.com/viewlist/css-discuss/115960"
  }]
}
!*/
var Modernizr = require('./../../lib/Modernizr.js');
var testStyles = require('./../../lib/testStyles.js');
  var blacklist = (function() {
    var ua = navigator.userAgent;
    var webos = ua.match(/w(eb)?osbrowser/gi);
    var wppre8 = ua.match(/windows phone/gi) && ua.match(/iemobile\/([0-9])+/gi) && parseFloat(RegExp.$1) >= 9;
    return webos || wppre8;
  }());
  if (blacklist) {
    Modernizr.addTest('fontface', false);
  } else {
    testStyles('@font-face {font-family:"font";src:url("https://")}', function(node, rule) {
      var style = document.getElementById('smodernizr');
      var sheet = style.sheet || style.styleSheet;
      var cssText = sheet ? (sheet.cssRules && sheet.cssRules[0] ? sheet.cssRules[0].cssText : sheet.cssText || '') : '';
      var bool = /src/i.test(cssText) && cssText.indexOf(rule.split(' ')[0]) === 0;
      Modernizr.addTest('fontface', bool);
    });
  }


},{"./../../lib/Modernizr.js":5,"./../../lib/testStyles.js":34}],37:[function(require,module,exports){
/*!
{
  "name": "CSS Object Fit",
  "caniuse": "object-fit",
  "property": "objectfit",
  "tags": ["css"],
  "builderAliases": ["css_objectfit"],
  "notes": [{
    "name": "Opera Article on Object Fit",
    "href": "https://dev.opera.com/articles/css3-object-fit-object-position/"
  }]
}
!*/
var Modernizr = require('./../../lib/Modernizr.js');
var prefixed = require('./../../lib/prefixed.js');
  Modernizr.addTest('objectfit', !!prefixed('objectFit'), {aliases: ['object-fit']});


},{"./../../lib/Modernizr.js":5,"./../../lib/prefixed.js":26}],38:[function(require,module,exports){
/*!
{
  "name": "CSS Transforms 3D",
  "property": "csstransforms3d",
  "caniuse": "transforms3d",
  "tags": ["css"],
  "warnings": [
    "Chrome may occassionally fail this test on some systems; more info: https://code.google.com/p/chromium/issues/detail?id=129004"
  ]
}
!*/
var Modernizr = require('./../../lib/Modernizr.js');
var testAllProps = require('./../../lib/testAllProps.js');
var testStyles = require('./../../lib/testStyles.js');
var docElement = require('./../../lib/docElement.js');
  Modernizr.addTest('csstransforms3d', function() {
    var ret = !!testAllProps('perspective', '1px', true);
    var usePrefix = Modernizr._config.usePrefixes;

    // Webkit's 3D transforms are passed off to the browser's own graphics renderer.
    //   It works fine in Safari on Leopard and Snow Leopard, but not in Chrome in
    //   some conditions. As a result, Webkit typically recognizes the syntax but
    //   will sometimes throw a false positive, thus we must do a more thorough check:
    if (ret && (!usePrefix || 'webkitPerspective' in docElement.style)) {
      var mq;
      var defaultStyle = '#modernizr{width:0;height:0}';
      // Use CSS Conditional Rules if available
      if (Modernizr.supports) {
        mq = '@supports (perspective: 1px)';
      } else {
        // Otherwise, Webkit allows this media query to succeed only if the feature is enabled.
        // `@media (transform-3d),(-webkit-transform-3d){ ... }`
        mq = '@media (transform-3d)';
        if (usePrefix) {
          mq += ',(-webkit-transform-3d)';
        }
      }

      mq += '{#modernizr{width:7px;height:18px;margin:0;padding:0;border:0}}';

      testStyles(defaultStyle + mq, function(elem) {
        ret = elem.offsetWidth === 7 && elem.offsetHeight === 18;
      });
    }

    return ret;
  });


},{"./../../lib/Modernizr.js":5,"./../../lib/docElement.js":14,"./../../lib/testAllProps.js":29,"./../../lib/testStyles.js":34}],39:[function(require,module,exports){
/*!
{
  "name": "Touch Events",
  "property": "touchevents",
  "caniuse" : "touch",
  "tags": ["media", "attribute"],
  "notes": [{
    "name": "Touch Events spec",
    "href": "https://www.w3.org/TR/2013/WD-touch-events-20130124/"
  }],
  "warnings": [
    "Indicates if the browser supports the Touch Events spec, and does not necessarily reflect a touchscreen device"
  ],
  "knownBugs": [
    "False-positive on some configurations of Nokia N900",
    "False-positive on some BlackBerry 6.0 builds – https://github.com/Modernizr/Modernizr/issues/372#issuecomment-3112695"
  ]
}
!*/
/* DOC
Indicates if the browser supports the W3C Touch Events API.

This *does not* necessarily reflect a touchscreen device:

* Older touchscreen devices only emulate mouse events
* Modern IE touch devices implement the Pointer Events API instead: use `Modernizr.pointerevents` to detect support for that
* Some browsers & OS setups may enable touch APIs when no touchscreen is connected
* Future browsers may implement other event models for touch interactions

See this article: [You Can't Detect A Touchscreen](http://www.stucox.com/blog/you-cant-detect-a-touchscreen/).

It's recommended to bind both mouse and touch/pointer events simultaneously – see [this HTML5 Rocks tutorial](http://www.html5rocks.com/en/mobile/touchandmouse/).

This test will also return `true` for Firefox 4 Multitouch support.
*/
var Modernizr = require('./../lib/Modernizr.js');
var prefixes = require('./../lib/prefixes.js');
var testStyles = require('./../lib/testStyles.js');
  // Chrome (desktop) used to lie about its support on this, but that has since been rectified: http://crbug.com/36415
  Modernizr.addTest('touchevents', function() {
    var bool;
    if (('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch) {
      bool = true;
    } else {
      // include the 'heartz' as a way to have a non matching MQ to help terminate the join
      // https://git.io/vznFH
      var query = ['@media (', prefixes.join('touch-enabled),('), 'heartz', ')', '{#modernizr{top:9px;position:absolute}}'].join('');
      testStyles(query, function(node) {
        bool = node.offsetTop === 9;
      });
    }
    return bool;
  });


},{"./../lib/Modernizr.js":5,"./../lib/prefixes.js":27,"./../lib/testStyles.js":34}],40:[function(require,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _arrayFrom = Array.from || function () {
  var isCallable = function isCallable(fn) {
    return typeof fn === 'function';
  };

  var toInteger = function toInteger(value) {
    var number = Number(value);

    if (isNaN(number)) {
      return 0;
    }

    if (number === 0 || !isFinite(number)) {
      return number;
    }

    return (number > 0 ? 1 : -1) * Math.floor(Math.abs(number));
  };

  var maxSafeInteger = Math.pow(2, 53) - 1;

  var toLength = function toLength(value) {
    var len = toInteger(value);
    return Math.min(Math.max(len, 0), maxSafeInteger);
  };

  var iteratorProp = function iteratorProp(value) {
    if (value != null) {
      if (['string', 'number', 'boolean', 'symbol'].indexOf(typeof value === 'undefined' ? 'undefined' : _typeof(value)) > -1) {
        return Symbol.iterator;
      } else if (typeof Symbol !== 'undefined' && 'iterator' in Symbol && Symbol.iterator in value) {
        return Symbol.iterator;
      } else if ('@@iterator' in value) {
        return '@@iterator';
      }
    }
  };

  var getMethod = function getMethod(O, P) {
    if (O != null && P != null) {
      var func = O[P];

      if (func == null) {
        return void 0;
      }

      if (!isCallable(func)) {
        throw new TypeError(func + " is not a function");
      }

      return func;
    }
  };

  var iteratorStep = function iteratorStep(iterator) {
    var result = iterator.next();
    var done = Boolean(result.done);

    if (done) {
      return false;
    }

    return result;
  };

  return function from(items) {
    "use strict";

    var C = this;
    var mapFn = arguments.length > 1 ? arguments[1] : void 0;
    var T;

    if (typeof mapFn !== 'undefined') {
      if (!isCallable(mapFn)) {
        throw new TypeError('Array.from: when provided, the second argument must be a function');
      }

      if (arguments.length > 2) {
        T = arguments[2];
      }
    }

    var A, k;
    var usingIterator = getMethod(items, iteratorProp(items));

    if (usingIterator !== void 0) {
      A = isCallable(C) ? Object(new C()) : [];
      var iterator = usingIterator.call(items);

      if (iterator == null) {
        throw new TypeError("Array.from requires an array-like or iterable object");
      }

      k = 0;
      var next, nextValue;

      while (true) {
        next = iteratorStep(iterator);

        if (!next) {
          A.length = k;
          return A;
        }

        nextValue = next.value;

        if (mapFn) {
          A[k] = mapFn.call(T, nextValue, k);
        } else {
          A[k] = nextValue;
        }

        k++;
      }
    } else {
      var arrayLike = Object(items);

      if (items == null) {
        throw new TypeError("Array.from requires an array-like object - not null or undefined");
      }

      var len = toLength(arrayLike.length);
      A = isCallable(C) ? Object(new C(len)) : new Array(len);
      k = 0;
      var kValue;

      while (k < len) {
        kValue = arrayLike[k];

        if (mapFn) {
          A[k] = mapFn.call(T, kValue, k);
        } else {
          A[k] = kValue;
        }

        k++;
      }

      A.length = len;
    }

    return A;
  };
}();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = require('./encode'),
    encodeConsentString = _require.encodeConsentString;

var _require2 = require('./decode'),
    decodeConsentString = _require2.decodeConsentString;

var _require3 = require('./utils/definitions'),
    vendorVersionMap = _require3.vendorVersionMap;

/**
 * Regular expression for validating
 */


var consentLanguageRegexp = /^[a-z]{2}$/;

var ConsentString = function () {
  /**
   * Initialize a new ConsentString object
   *
   * @param {string} baseString An existing consent string to parse and use for our initial values
   */
  function ConsentString() {
    var baseString = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    _classCallCheck(this, ConsentString);

    this.created = new Date();
    this.lastUpdated = new Date();

    /**
     * Version number of consent string specification
     *
     * @type {integer}
     */
    this.version = 1;

    /**
     * Vendor list with format from https://github.com/InteractiveAdvertisingBureau/GDPR-Transparency-and-Consent-Framework/blob/master/Draft_for_Public_Comment_Transparency%20%26%20Consent%20Framework%20-%20cookie%20and%20vendor%20list%20format%20specification%20v1.0a.pdf
     *
     * @type {object}
     */
    this.vendorList = null;

    /**
     * Version of the vendor list used for the purposes and vendors
     *
     * @type {integer}
     */
    this.vendorListVersion = null;

    /**
     * The unique ID of the CMP that last modified the consent string
     *
     * @type {integer}
     */
    this.cmpId = null;

    /**
     * Version of the code used by the CMP when collecting consent
     *
     * @type {integer}
     */
    this.cmpVersion = null;

    /**
     * ID of the screen used by CMP when collecting consent
     *
     * @type {integer}
     */
    this.consentScreen = null;

    /**
     * Two-letter ISO639-1 code (en, fr, de, etc.) of the language that the CMP asked consent in
     *
     * @type {string}
     */
    this.consentLanguage = null;

    /**
     * List of purpose IDs that the user has given consent to
     *
     * @type {integer[]}
     */
    this.allowedPurposeIds = [];

    /**
     * List of vendor IDs that the user has given consent to
     *
     * @type {integer[]}
     */
    this.allowedVendorIds = [];

    // Decode the base string
    if (baseString) {
      Object.assign(this, decodeConsentString(baseString));
    }
  }

  /**
   * Get the web-safe, base64-encoded consent string
   *
   * @return {string} Web-safe, base64-encoded consent string
   */


  _createClass(ConsentString, [{
    key: 'getConsentString',
    value: function getConsentString() {
      var updateDate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      if (!this.vendorList) {
        throw new Error('ConsentString - A vendor list is required to encode a consent string');
      }

      if (updateDate === true) {
        this.lastUpdated = new Date();
      }

      return encodeConsentString({
        version: this.getVersion(),
        vendorList: this.vendorList,
        allowedPurposeIds: this.allowedPurposeIds,
        allowedVendorIds: this.allowedVendorIds,
        created: this.created,
        lastUpdated: this.lastUpdated,
        cmpId: this.cmpId,
        cmpVersion: this.cmpVersion,
        consentScreen: this.consentScreen,
        consentLanguage: this.consentLanguage,
        vendorListVersion: this.vendorListVersion
      });
    }

    /**
     * Get the web-safe, base64-encoded metadata string
     *
     * @return {string} Web-safe, base64-encoded metadata string
     */

  }, {
    key: 'getMetadataString',
    value: function getMetadataString() {
      return encodeConsentString({
        version: this.getVersion(),
        created: this.created,
        lastUpdated: this.lastUpdated,
        cmpId: this.cmpId,
        cmpVersion: this.cmpVersion,
        consentScreen: this.consentScreen,
        vendorListVersion: this.vendorListVersion
      });
    }

    /**
     * Decode the web-safe, base64-encoded metadata string
     * @param {string} encodedMetadata Web-safe, base64-encoded metadata string
     * @return {object} decoded metadata
     */

  }, {
    key: 'getVersion',


    /**
     * Get the version number that this consent string specification adheres to
     *
     * @return {integer} Version number of consent string specification
     */
    value: function getVersion() {
      return this.version;
    }

    /**
     * Get the version of the vendor list
     *
     * @return {integer} Vendor list version
     */

  }, {
    key: 'getVendorListVersion',
    value: function getVendorListVersion() {
      return this.vendorListVersion;
    }

    /**
     * Set the vendors list to use when generating the consent string
     *
     * The expected format is the one from https://github.com/InteractiveAdvertisingBureau/GDPR-Transparency-and-Consent-Framework/blob/master/Draft_for_Public_Comment_Transparency%20%26%20Consent%20Framework%20-%20cookie%20and%20vendor%20list%20format%20specification%20v1.0a.pdf
     *
     * @param {object} vendorList Vendor list with format from https://github.com/InteractiveAdvertisingBureau/GDPR-Transparency-and-Consent-Framework/blob/master/Draft_for_Public_Comment_Transparency%20%26%20Consent%20Framework%20-%20cookie%20and%20vendor%20list%20format%20specification%20v1.0a.pdf
     */

  }, {
    key: 'setGlobalVendorList',
    value: function setGlobalVendorList(vendorList) {
      if ((typeof vendorList === 'undefined' ? 'undefined' : _typeof(vendorList)) !== 'object') {
        throw new Error('ConsentString - You must provide an object when setting the global vendor list');
      }

      if (!vendorList.vendorListVersion || !Array.isArray(vendorList.purposes) || !Array.isArray(vendorList.vendors)) {
        // The provided vendor list does not look valid
        throw new Error('ConsentString - The provided vendor list does not respect the schema from the IAB EU’s GDPR Consent and Transparency Framework');
      }

      // Cloning the GVL
      // It's important as we might transform it and don't want to modify objects that we do not own
      this.vendorList = {
        vendorListVersion: vendorList.vendorListVersion,
        lastUpdated: vendorList.lastUpdated,
        purposes: vendorList.purposes,
        features: vendorList.features,

        // Clone the list and sort the vendors by ID (it breaks our range generation algorithm if they are not sorted)
        vendors: vendorList.vendors.slice(0).sort(function (firstVendor, secondVendor) {
          return firstVendor.id < secondVendor.id ? -1 : 1;
        })
      };
      this.vendorListVersion = vendorList.vendorListVersion;
    }

    /**
     * Set the ID of the Consent Management Platform that last modified the consent string
     *
     * Every CMP is assigned a unique ID by the IAB EU that must be provided here before changing any other value in the consent string.
     *
     * @param {integer} id CMP ID
     */

  }, {
    key: 'setCmpId',
    value: function setCmpId(id) {
      this.cmpId = id;
    }

    /**
     * Get the ID of the Consent Management Platform from the consent string
     *
     * @return {integer}
     */

  }, {
    key: 'getCmpId',
    value: function getCmpId() {
      return this.cmpId;
    }

    /**
     * Set the version of the Consent Management Platform that last modified the consent string
     *
     * This version number references the CMP code running when collecting the user consent.
     *
     * @param {integer} version Version
     */

  }, {
    key: 'setCmpVersion',
    value: function setCmpVersion(version) {
      this.cmpVersion = version;
    }

    /**
     * Get the verison of the Consent Management Platform that last modified the consent string
     *
     * @return {integer}
     */

  }, {
    key: 'getCmpVersion',
    value: function getCmpVersion() {
      return this.cmpVersion;
    }

    /**
     * Set the Consent Management Platform screen ID that collected the user consent
     *
     * This screen ID references a unique view in the CMP that was displayed to the user to collect consent
     *
     * @param {*} screenId Screen ID
     */

  }, {
    key: 'setConsentScreen',
    value: function setConsentScreen(screenId) {
      this.consentScreen = screenId;
    }

    /**
     * Get the Consent Management Platform screen ID that collected the user consent
     *
     * @return {integer}
     */

  }, {
    key: 'getConsentScreen',
    value: function getConsentScreen() {
      return this.consentScreen;
    }

    /**
     * Set the language that the CMP asked the consent in
     *
     * @param {string} language Two-letter ISO639-1 code (en, fr, de, etc.)
     */

  }, {
    key: 'setConsentLanguage',
    value: function setConsentLanguage(language) {
      if (consentLanguageRegexp.test(language) === false) {
        throw new Error('ConsentString - The consent language must be a two-letter ISO639-1 code (en, fr, de, etc.)');
      }

      this.consentLanguage = language;
    }

    /**
     * Get the language that the CMP asked consent in
     *
     * @return {string} Two-letter ISO639-1 code (en, fr, de, etc.)
     */

  }, {
    key: 'getConsentLanguage',
    value: function getConsentLanguage() {
      return this.consentLanguage;
    }

    /**
     * Set the list of purpose IDs that the user has given consent to
     *
     * @param {integer[]} purposeIds An array of integers that map to the purposes defined in the vendor list. Purposes included in the array are purposes that the user has given consent to
     */

  }, {
    key: 'setPurposesAllowed',
    value: function setPurposesAllowed(purposeIds) {
      this.allowedPurposeIds = purposeIds;
    }

    /**
     * Get the list of purpose IDs that the user has given consent to
     *
     * @return {integer[]}
     */

  }, {
    key: 'getPurposesAllowed',
    value: function getPurposesAllowed() {
      return this.allowedPurposeIds;
    }

    /**
     * Set the consent status of a user for a given purpose
     *
     * @param {integer} purposeId The ID (from the vendor list) of the purpose to update
     * @param {boolean} value Consent status
     */

  }, {
    key: 'setPurposeAllowed',
    value: function setPurposeAllowed(purposeId, value) {
      var purposeIndex = this.allowedPurposeIds.indexOf(purposeId);

      if (value === true) {
        if (purposeIndex === -1) {
          this.allowedPurposeIds.push(purposeId);
        }
      } else if (value === false) {
        if (purposeIndex !== -1) {
          this.allowedPurposeIds.splice(purposeIndex, 1);
        }
      }
    }

    /**
     * Check if the user has given consent for a specific purpose
     *
     * @param {integer} purposeId
     *
     * @return {boolean}
     */

  }, {
    key: 'isPurposeAllowed',
    value: function isPurposeAllowed(purposeId) {
      return this.allowedPurposeIds.indexOf(purposeId) !== -1;
    }

    /**
     * Set the list of vendor IDs that the user has given consent to
     *
     * @param {integer[]} vendorIds An array of integers that map to the vendors defined in the vendor list. Vendors included in the array are vendors that the user has given consent to
     */

  }, {
    key: 'setVendorsAllowed',
    value: function setVendorsAllowed(vendorIds) {
      this.allowedVendorIds = vendorIds;
    }

    /**
     * Get the list of vendor IDs that the user has given consent to
     *
     * @return {integer[]}
     */

  }, {
    key: 'getVendorsAllowed',
    value: function getVendorsAllowed() {
      return this.allowedVendorIds;
    }

    /**
     * Set the consent status of a user for a given vendor
     *
     * @param {integer} vendorId The ID (from the vendor list) of the vendor to update
     * @param {boolean} value Consent status
     */

  }, {
    key: 'setVendorAllowed',
    value: function setVendorAllowed(vendorId, value) {
      var vendorIndex = this.allowedVendorIds.indexOf(vendorId);

      if (value === true) {
        if (vendorIndex === -1) {
          this.allowedVendorIds.push(vendorId);
        }
      } else if (value === false) {
        if (vendorIndex !== -1) {
          this.allowedVendorIds.splice(vendorIndex, 1);
        }
      }
    }

    /**
     * Check if the user has given consent for a specific vendor
     *
     * @param {integer} vendorId
     *
     * @return {boolean}
     */

  }, {
    key: 'isVendorAllowed',
    value: function isVendorAllowed(vendorId) {
      return this.allowedVendorIds.indexOf(vendorId) !== -1;
    }
  }], [{
    key: 'decodeMetadataString',
    value: function decodeMetadataString(encodedMetadata) {
      var decodedString = decodeConsentString(encodedMetadata);
      var metadata = {};
      vendorVersionMap[decodedString.version].metadataFields.forEach(function (field) {
        metadata[field] = decodedString[field];
      });
      return metadata;
    }
  }]);

  return ConsentString;
}();

module.exports = {
  ConsentString: ConsentString
};
},{"./decode":41,"./encode":42,"./utils/definitions":45}],41:[function(require,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _arrayFrom = Array.from || function () {
  var isCallable = function isCallable(fn) {
    return typeof fn === 'function';
  };

  var toInteger = function toInteger(value) {
    var number = Number(value);

    if (isNaN(number)) {
      return 0;
    }

    if (number === 0 || !isFinite(number)) {
      return number;
    }

    return (number > 0 ? 1 : -1) * Math.floor(Math.abs(number));
  };

  var maxSafeInteger = Math.pow(2, 53) - 1;

  var toLength = function toLength(value) {
    var len = toInteger(value);
    return Math.min(Math.max(len, 0), maxSafeInteger);
  };

  var iteratorProp = function iteratorProp(value) {
    if (value != null) {
      if (['string', 'number', 'boolean', 'symbol'].indexOf(typeof value === 'undefined' ? 'undefined' : _typeof(value)) > -1) {
        return Symbol.iterator;
      } else if (typeof Symbol !== 'undefined' && 'iterator' in Symbol && Symbol.iterator in value) {
        return Symbol.iterator;
      } else if ('@@iterator' in value) {
        return '@@iterator';
      }
    }
  };

  var getMethod = function getMethod(O, P) {
    if (O != null && P != null) {
      var func = O[P];

      if (func == null) {
        return void 0;
      }

      if (!isCallable(func)) {
        throw new TypeError(func + " is not a function");
      }

      return func;
    }
  };

  var iteratorStep = function iteratorStep(iterator) {
    var result = iterator.next();
    var done = Boolean(result.done);

    if (done) {
      return false;
    }

    return result;
  };

  return function from(items) {
    "use strict";

    var C = this;
    var mapFn = arguments.length > 1 ? arguments[1] : void 0;
    var T;

    if (typeof mapFn !== 'undefined') {
      if (!isCallable(mapFn)) {
        throw new TypeError('Array.from: when provided, the second argument must be a function');
      }

      if (arguments.length > 2) {
        T = arguments[2];
      }
    }

    var A, k;
    var usingIterator = getMethod(items, iteratorProp(items));

    if (usingIterator !== void 0) {
      A = isCallable(C) ? Object(new C()) : [];
      var iterator = usingIterator.call(items);

      if (iterator == null) {
        throw new TypeError("Array.from requires an array-like or iterable object");
      }

      k = 0;
      var next, nextValue;

      while (true) {
        next = iteratorStep(iterator);

        if (!next) {
          A.length = k;
          return A;
        }

        nextValue = next.value;

        if (mapFn) {
          A[k] = mapFn.call(T, nextValue, k);
        } else {
          A[k] = nextValue;
        }

        k++;
      }
    } else {
      var arrayLike = Object(items);

      if (items == null) {
        throw new TypeError("Array.from requires an array-like object - not null or undefined");
      }

      var len = toLength(arrayLike.length);
      A = isCallable(C) ? Object(new C(len)) : new Array(len);
      k = 0;
      var kValue;

      while (k < len) {
        kValue = arrayLike[k];

        if (mapFn) {
          A[k] = mapFn.call(T, kValue, k);
        } else {
          A[k] = kValue;
        }

        k++;
      }

      A.length = len;
    }

    return A;
  };
}();

var _require = require('./utils/bits'),
    decodeBitsToIds = _require.decodeBitsToIds,
    decodeFromBase64 = _require.decodeFromBase64;

/**
 * Decode consent data from a web-safe base64-encoded string
 *
 * @param {string} consentString
 */


function decodeConsentString(consentString) {
  var _decodeFromBase = decodeFromBase64(consentString),
      version = _decodeFromBase.version,
      cmpId = _decodeFromBase.cmpId,
      vendorListVersion = _decodeFromBase.vendorListVersion,
      purposeIdBitString = _decodeFromBase.purposeIdBitString,
      maxVendorId = _decodeFromBase.maxVendorId,
      created = _decodeFromBase.created,
      lastUpdated = _decodeFromBase.lastUpdated,
      isRange = _decodeFromBase.isRange,
      defaultConsent = _decodeFromBase.defaultConsent,
      vendorIdBitString = _decodeFromBase.vendorIdBitString,
      vendorRangeList = _decodeFromBase.vendorRangeList,
      cmpVersion = _decodeFromBase.cmpVersion,
      consentScreen = _decodeFromBase.consentScreen,
      consentLanguage = _decodeFromBase.consentLanguage;

  var consentStringData = {
    version: version,
    cmpId: cmpId,
    vendorListVersion: vendorListVersion,
    allowedPurposeIds: decodeBitsToIds(purposeIdBitString),
    maxVendorId: maxVendorId,
    created: created,
    lastUpdated: lastUpdated,
    cmpVersion: cmpVersion,
    consentScreen: consentScreen,
    consentLanguage: consentLanguage
  };

  if (isRange) {
    /* eslint no-shadow: off */
    var idMap = vendorRangeList.reduce(function (acc, _ref) {
      var isRange = _ref.isRange,
          startVendorId = _ref.startVendorId,
          endVendorId = _ref.endVendorId;

      var lastVendorId = isRange ? endVendorId : startVendorId;

      for (var i = startVendorId; i <= lastVendorId; i += 1) {
        acc[i] = true;
      }

      return acc;
    }, {});

    consentStringData.allowedVendorIds = [];

    for (var i = 1; i <= maxVendorId; i += 1) {
      if (defaultConsent && !idMap[i] || !defaultConsent && idMap[i]) {
        if (consentStringData.allowedVendorIds.indexOf(i) === -1) {
          consentStringData.allowedVendorIds.push(i);
        }
      }
    }
  } else {
    consentStringData.allowedVendorIds = decodeBitsToIds(vendorIdBitString);
  }

  return consentStringData;
}

module.exports = {
  decodeConsentString: decodeConsentString
};
},{"./utils/bits":44}],42:[function(require,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _arrayFrom = Array.from || function () {
  var isCallable = function isCallable(fn) {
    return typeof fn === 'function';
  };

  var toInteger = function toInteger(value) {
    var number = Number(value);

    if (isNaN(number)) {
      return 0;
    }

    if (number === 0 || !isFinite(number)) {
      return number;
    }

    return (number > 0 ? 1 : -1) * Math.floor(Math.abs(number));
  };

  var maxSafeInteger = Math.pow(2, 53) - 1;

  var toLength = function toLength(value) {
    var len = toInteger(value);
    return Math.min(Math.max(len, 0), maxSafeInteger);
  };

  var iteratorProp = function iteratorProp(value) {
    if (value != null) {
      if (['string', 'number', 'boolean', 'symbol'].indexOf(typeof value === 'undefined' ? 'undefined' : _typeof(value)) > -1) {
        return Symbol.iterator;
      } else if (typeof Symbol !== 'undefined' && 'iterator' in Symbol && Symbol.iterator in value) {
        return Symbol.iterator;
      } else if ('@@iterator' in value) {
        return '@@iterator';
      }
    }
  };

  var getMethod = function getMethod(O, P) {
    if (O != null && P != null) {
      var func = O[P];

      if (func == null) {
        return void 0;
      }

      if (!isCallable(func)) {
        throw new TypeError(func + " is not a function");
      }

      return func;
    }
  };

  var iteratorStep = function iteratorStep(iterator) {
    var result = iterator.next();
    var done = Boolean(result.done);

    if (done) {
      return false;
    }

    return result;
  };

  return function from(items) {
    "use strict";

    var C = this;
    var mapFn = arguments.length > 1 ? arguments[1] : void 0;
    var T;

    if (typeof mapFn !== 'undefined') {
      if (!isCallable(mapFn)) {
        throw new TypeError('Array.from: when provided, the second argument must be a function');
      }

      if (arguments.length > 2) {
        T = arguments[2];
      }
    }

    var A, k;
    var usingIterator = getMethod(items, iteratorProp(items));

    if (usingIterator !== void 0) {
      A = isCallable(C) ? Object(new C()) : [];
      var iterator = usingIterator.call(items);

      if (iterator == null) {
        throw new TypeError("Array.from requires an array-like or iterable object");
      }

      k = 0;
      var next, nextValue;

      while (true) {
        next = iteratorStep(iterator);

        if (!next) {
          A.length = k;
          return A;
        }

        nextValue = next.value;

        if (mapFn) {
          A[k] = mapFn.call(T, nextValue, k);
        } else {
          A[k] = nextValue;
        }

        k++;
      }
    } else {
      var arrayLike = Object(items);

      if (items == null) {
        throw new TypeError("Array.from requires an array-like object - not null or undefined");
      }

      var len = toLength(arrayLike.length);
      A = isCallable(C) ? Object(new C(len)) : new Array(len);
      k = 0;
      var kValue;

      while (k < len) {
        kValue = arrayLike[k];

        if (mapFn) {
          A[k] = mapFn.call(T, kValue, k);
        } else {
          A[k] = kValue;
        }

        k++;
      }

      A.length = len;
    }

    return A;
  };
}();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return _arrayFrom(arr); } }

var _require = require('./utils/bits'),
    encodeToBase64 = _require.encodeToBase64,
    padRight = _require.padRight;

/**
 * Encode a list of vendor IDs into bits
 *
 * @param {integer} maxVendorId Highest vendor ID in the vendor list
 * @param {integer[]} allowedVendorIds Vendors that the user has given consent to
 */


function encodeVendorIdsToBits(maxVendorId) {
  var allowedVendorIds = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  var vendorString = '';

  for (var id = 1; id <= maxVendorId; id += 1) {
    vendorString += allowedVendorIds.indexOf(id) !== -1 ? '1' : '0';
  }

  return padRight(vendorString, Math.max(0, maxVendorId - vendorString.length));
}

/**
 * Encode a list of purpose IDs into bits
 *
 * @param {*} purposes List of purposes from the vendor list
 * @param {*} allowedPurposeIds List of purpose IDs that the user has given consent to
 */
function encodePurposeIdsToBits(purposes) {
  var allowedPurposeIds = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Set();

  var maxPurposeId = Math.max.apply(Math, [0].concat(_toConsumableArray(purposes.map(function (_ref) {
    var id = _ref.id;
    return id;
  })), _toConsumableArray(_arrayFrom(allowedPurposeIds))));

  var purposeString = '';

  for (var id = 1; id <= maxPurposeId; id += 1) {
    purposeString += allowedPurposeIds.indexOf(id) !== -1 ? '1' : '0';
  }

  return purposeString;
}

/**
 * Convert a list of vendor IDs to ranges
 *
 * @param {object[]} vendors List of vendors from the vendor list (important: this list must to be sorted by ID)
 * @param {integer[]} allowedVendorIds List of vendor IDs that the user has given consent to
 */
function convertVendorsToRanges(vendors, allowedVendorIds) {
  var range = [];

  var idsInList = vendors.map(function (vendor) {
    return vendor.id;
  });

  return vendors.reduce(function (acc, _ref2, index) {
    var id = _ref2.id;

    if (allowedVendorIds.indexOf(id) !== -1) {
      range.push(id);
    }

    // Do we need to close the current range?
    if ((allowedVendorIds.indexOf(id) === -1 // The vendor we are evaluating is not allowed
    || index === vendors.length - 1 // There is no more vendor to evaluate
    || idsInList.indexOf(id + 1) === -1 // There is no vendor after this one (ie there is a gap in the vendor IDs) ; we need to stop here to avoid including vendors that do not have consent
    ) && range.length) {
      var startVendorId = range.shift();
      var endVendorId = range.pop();

      range = [];

      return [].concat(_toConsumableArray(acc), [{
        isRange: typeof endVendorId === 'number',
        startVendorId: startVendorId,
        endVendorId: endVendorId
      }]);
    }

    return acc;
  }, []);
}

/**
 * Encode consent data into a web-safe base64-encoded string
 *
 * @param {object} consentData Data to include in the string (see `utils/definitions.js` for the list of fields)
 */
function encodeConsentString(consentData) {
  var maxVendorId = consentData.maxVendorId;
  var _consentData$vendorLi = consentData.vendorList,
      vendorList = _consentData$vendorLi === undefined ? {} : _consentData$vendorLi,
      allowedPurposeIds = consentData.allowedPurposeIds,
      allowedVendorIds = consentData.allowedVendorIds;
  var _vendorList$vendors = vendorList.vendors,
      vendors = _vendorList$vendors === undefined ? [] : _vendorList$vendors,
      _vendorList$purposes = vendorList.purposes,
      purposes = _vendorList$purposes === undefined ? [] : _vendorList$purposes;


  if (!maxVendorId) {
    // Find the max vendor ID from the vendor list if it has not been provided
    maxVendorId = 0;

    vendors.forEach(function (vendor) {
      if (vendor.id > maxVendorId) {
        maxVendorId = vendor.id;
      }
    });
  }

  // Encode the data with and without ranges and return the smallest encoded payload
  var noRangesData = encodeToBase64(_extends({}, consentData, {
    maxVendorId: maxVendorId,
    purposeIdBitString: encodePurposeIdsToBits(purposes, allowedPurposeIds),
    isRange: false,
    vendorIdBitString: encodeVendorIdsToBits(maxVendorId, allowedVendorIds)
  }));

  var vendorRangeList = convertVendorsToRanges(vendors, allowedVendorIds);

  var rangesData = encodeToBase64(_extends({}, consentData, {
    maxVendorId: maxVendorId,
    purposeIdBitString: encodePurposeIdsToBits(purposes, allowedPurposeIds),
    isRange: true,
    defaultConsent: false,
    numEntries: vendorRangeList.length,
    vendorRangeList: vendorRangeList
  }));

  return noRangesData.length < rangesData.length ? noRangesData : rangesData;
}

module.exports = {
  convertVendorsToRanges: convertVendorsToRanges,
  encodeConsentString: encodeConsentString
};
},{"./utils/bits":44}],43:[function(require,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _arrayFrom = Array.from || function () {
  var isCallable = function isCallable(fn) {
    return typeof fn === 'function';
  };

  var toInteger = function toInteger(value) {
    var number = Number(value);

    if (isNaN(number)) {
      return 0;
    }

    if (number === 0 || !isFinite(number)) {
      return number;
    }

    return (number > 0 ? 1 : -1) * Math.floor(Math.abs(number));
  };

  var maxSafeInteger = Math.pow(2, 53) - 1;

  var toLength = function toLength(value) {
    var len = toInteger(value);
    return Math.min(Math.max(len, 0), maxSafeInteger);
  };

  var iteratorProp = function iteratorProp(value) {
    if (value != null) {
      if (['string', 'number', 'boolean', 'symbol'].indexOf(typeof value === 'undefined' ? 'undefined' : _typeof(value)) > -1) {
        return Symbol.iterator;
      } else if (typeof Symbol !== 'undefined' && 'iterator' in Symbol && Symbol.iterator in value) {
        return Symbol.iterator;
      } else if ('@@iterator' in value) {
        return '@@iterator';
      }
    }
  };

  var getMethod = function getMethod(O, P) {
    if (O != null && P != null) {
      var func = O[P];

      if (func == null) {
        return void 0;
      }

      if (!isCallable(func)) {
        throw new TypeError(func + " is not a function");
      }

      return func;
    }
  };

  var iteratorStep = function iteratorStep(iterator) {
    var result = iterator.next();
    var done = Boolean(result.done);

    if (done) {
      return false;
    }

    return result;
  };

  return function from(items) {
    "use strict";

    var C = this;
    var mapFn = arguments.length > 1 ? arguments[1] : void 0;
    var T;

    if (typeof mapFn !== 'undefined') {
      if (!isCallable(mapFn)) {
        throw new TypeError('Array.from: when provided, the second argument must be a function');
      }

      if (arguments.length > 2) {
        T = arguments[2];
      }
    }

    var A, k;
    var usingIterator = getMethod(items, iteratorProp(items));

    if (usingIterator !== void 0) {
      A = isCallable(C) ? Object(new C()) : [];
      var iterator = usingIterator.call(items);

      if (iterator == null) {
        throw new TypeError("Array.from requires an array-like or iterable object");
      }

      k = 0;
      var next, nextValue;

      while (true) {
        next = iteratorStep(iterator);

        if (!next) {
          A.length = k;
          return A;
        }

        nextValue = next.value;

        if (mapFn) {
          A[k] = mapFn.call(T, nextValue, k);
        } else {
          A[k] = nextValue;
        }

        k++;
      }
    } else {
      var arrayLike = Object(items);

      if (items == null) {
        throw new TypeError("Array.from requires an array-like object - not null or undefined");
      }

      var len = toLength(arrayLike.length);
      A = isCallable(C) ? Object(new C(len)) : new Array(len);
      k = 0;
      var kValue;

      while (k < len) {
        kValue = arrayLike[k];

        if (mapFn) {
          A[k] = mapFn.call(T, kValue, k);
        } else {
          A[k] = kValue;
        }

        k++;
      }

      A.length = len;
    }

    return A;
  };
}();

var _require = require('./consent-string'),
    ConsentString = _require.ConsentString;

var _require2 = require('./decode'),
    decodeConsentString = _require2.decodeConsentString;

var _require3 = require('./encode'),
    encodeConsentString = _require3.encodeConsentString;

module.exports = {
  ConsentString: ConsentString,
  decodeConsentString: decodeConsentString,
  encodeConsentString: encodeConsentString
};
},{"./consent-string":40,"./decode":41,"./encode":42}],44:[function(require,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _arrayFrom = Array.from || function () {
  var isCallable = function isCallable(fn) {
    return typeof fn === 'function';
  };

  var toInteger = function toInteger(value) {
    var number = Number(value);

    if (isNaN(number)) {
      return 0;
    }

    if (number === 0 || !isFinite(number)) {
      return number;
    }

    return (number > 0 ? 1 : -1) * Math.floor(Math.abs(number));
  };

  var maxSafeInteger = Math.pow(2, 53) - 1;

  var toLength = function toLength(value) {
    var len = toInteger(value);
    return Math.min(Math.max(len, 0), maxSafeInteger);
  };

  var iteratorProp = function iteratorProp(value) {
    if (value != null) {
      if (['string', 'number', 'boolean', 'symbol'].indexOf(typeof value === 'undefined' ? 'undefined' : _typeof(value)) > -1) {
        return Symbol.iterator;
      } else if (typeof Symbol !== 'undefined' && 'iterator' in Symbol && Symbol.iterator in value) {
        return Symbol.iterator;
      } else if ('@@iterator' in value) {
        return '@@iterator';
      }
    }
  };

  var getMethod = function getMethod(O, P) {
    if (O != null && P != null) {
      var func = O[P];

      if (func == null) {
        return void 0;
      }

      if (!isCallable(func)) {
        throw new TypeError(func + " is not a function");
      }

      return func;
    }
  };

  var iteratorStep = function iteratorStep(iterator) {
    var result = iterator.next();
    var done = Boolean(result.done);

    if (done) {
      return false;
    }

    return result;
  };

  return function from(items) {
    "use strict";

    var C = this;
    var mapFn = arguments.length > 1 ? arguments[1] : void 0;
    var T;

    if (typeof mapFn !== 'undefined') {
      if (!isCallable(mapFn)) {
        throw new TypeError('Array.from: when provided, the second argument must be a function');
      }

      if (arguments.length > 2) {
        T = arguments[2];
      }
    }

    var A, k;
    var usingIterator = getMethod(items, iteratorProp(items));

    if (usingIterator !== void 0) {
      A = isCallable(C) ? Object(new C()) : [];
      var iterator = usingIterator.call(items);

      if (iterator == null) {
        throw new TypeError("Array.from requires an array-like or iterable object");
      }

      k = 0;
      var next, nextValue;

      while (true) {
        next = iteratorStep(iterator);

        if (!next) {
          A.length = k;
          return A;
        }

        nextValue = next.value;

        if (mapFn) {
          A[k] = mapFn.call(T, nextValue, k);
        } else {
          A[k] = nextValue;
        }

        k++;
      }
    } else {
      var arrayLike = Object(items);

      if (items == null) {
        throw new TypeError("Array.from requires an array-like object - not null or undefined");
      }

      var len = toLength(arrayLike.length);
      A = isCallable(C) ? Object(new C(len)) : new Array(len);
      k = 0;
      var kValue;

      while (k < len) {
        kValue = arrayLike[k];

        if (mapFn) {
          A[k] = mapFn.call(T, kValue, k);
        } else {
          A[k] = kValue;
        }

        k++;
      }

      A.length = len;
    }

    return A;
  };
}();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return _arrayFrom(arr); } }

/* eslint no-use-before-define: off */

var base64 = require('base-64');

var _require = require('./definitions'),
    versionNumBits = _require.versionNumBits,
    vendorVersionMap = _require.vendorVersionMap;

function repeat(count) {
  var string = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '0';

  var padString = '';

  for (var i = 0; i < count; i += 1) {
    padString += string;
  }

  return padString;
}

function padLeft(string, padding) {
  return repeat(Math.max(0, padding)) + string;
}

function padRight(string, padding) {
  return string + repeat(Math.max(0, padding));
}

function encodeIntToBits(number, numBits) {
  var bitString = '';

  if (typeof number === 'number' && !isNaN(number)) {
    bitString = parseInt(number, 10).toString(2);
  }

  // Pad the string if not filling all bits
  if (numBits >= bitString.length) {
    bitString = padLeft(bitString, numBits - bitString.length);
  }

  // Truncate the string if longer than the number of bits
  if (bitString.length > numBits) {
    bitString = bitString.substring(0, numBits);
  }

  return bitString;
}

function encodeBoolToBits(value) {
  return encodeIntToBits(value === true ? 1 : 0, 1);
}

function encodeDateToBits(date, numBits) {
  if (date instanceof Date) {
    return encodeIntToBits(date.getTime() / 100, numBits);
  }
  return encodeIntToBits(date, numBits);
}

function encodeLetterToBits(letter, numBits) {
  return encodeIntToBits(letter.toUpperCase().charCodeAt(0) - 65, numBits);
}

function encodeLanguageToBits(language) {
  var numBits = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 12;

  return encodeLetterToBits(language.slice(0, 1), numBits / 2) + encodeLetterToBits(language.slice(1), numBits / 2);
}

function decodeBitsToInt(bitString, start, length) {
  return parseInt(bitString.substr(start, length), 2);
}

function decodeBitsToDate(bitString, start, length) {
  return new Date(decodeBitsToInt(bitString, start, length) * 100);
}

function decodeBitsToBool(bitString, start) {
  return parseInt(bitString.substr(start, 1), 2) === 1;
}

function decodeBitsToLetter(bitString) {
  var letterCode = decodeBitsToInt(bitString);
  return String.fromCharCode(letterCode + 65).toLowerCase();
}

function decodeBitsToLanguage(bitString, start, length) {
  var languageBitString = bitString.substr(start, length);

  return decodeBitsToLetter(languageBitString.slice(0, length / 2)) + decodeBitsToLetter(languageBitString.slice(length / 2));
}

function encodeField(_ref) {
  var input = _ref.input,
      field = _ref.field;
  var name = field.name,
      type = field.type,
      numBits = field.numBits,
      encoder = field.encoder,
      validator = field.validator;


  if (typeof validator === 'function') {
    if (!validator(input)) {
      return '';
    }
  }
  if (typeof encoder === 'function') {
    return encoder(input);
  }

  var bitCount = typeof numBits === 'function' ? numBits(input) : numBits;

  var inputValue = input[name];
  var fieldValue = inputValue === null || inputValue === undefined ? '' : inputValue;

  switch (type) {
    case 'int':
      return encodeIntToBits(fieldValue, bitCount);
    case 'bool':
      return encodeBoolToBits(fieldValue);
    case 'date':
      return encodeDateToBits(fieldValue, bitCount);
    case 'bits':
      return padRight(fieldValue, bitCount - fieldValue.length).substring(0, bitCount);
    case 'list':
      return fieldValue.reduce(function (acc, listValue) {
        return acc + encodeFields({
          input: listValue,
          fields: field.fields
        });
      }, '');
    case 'language':
      return encodeLanguageToBits(fieldValue, bitCount);
    default:
      throw new Error('ConsentString - Unknown field type ' + type + ' for encoding');
  }
}

function encodeFields(_ref2) {
  var input = _ref2.input,
      fields = _ref2.fields;

  return fields.reduce(function (acc, field) {
    acc += encodeField({ input: input, field: field });

    return acc;
  }, '');
}

function decodeField(_ref3) {
  var input = _ref3.input,
      output = _ref3.output,
      startPosition = _ref3.startPosition,
      field = _ref3.field;
  var type = field.type,
      numBits = field.numBits,
      decoder = field.decoder,
      validator = field.validator,
      listCount = field.listCount;


  if (typeof validator === 'function') {
    if (!validator(output)) {
      // Not decoding this field so make sure we start parsing the next field at
      // the same point
      return { newPosition: startPosition };
    }
  }

  if (typeof decoder === 'function') {
    return decoder(input, output, startPosition);
  }

  var bitCount = typeof numBits === 'function' ? numBits(output) : numBits;

  var listEntryCount = 0;
  if (typeof listCount === 'function') {
    listEntryCount = listCount(output);
  } else if (typeof listCount === 'number') {
    listEntryCount = listCount;
  }

  switch (type) {
    case 'int':
      return { fieldValue: decodeBitsToInt(input, startPosition, bitCount) };
    case 'bool':
      return { fieldValue: decodeBitsToBool(input, startPosition) };
    case 'date':
      return { fieldValue: decodeBitsToDate(input, startPosition, bitCount) };
    case 'bits':
      return { fieldValue: input.substr(startPosition, bitCount) };
    case 'list':
      return new Array(listEntryCount).fill().reduce(function (acc) {
        var _decodeFields = decodeFields({
          input: input,
          fields: field.fields,
          startPosition: acc.newPosition
        }),
            decodedObject = _decodeFields.decodedObject,
            newPosition = _decodeFields.newPosition;

        return {
          fieldValue: [].concat(_toConsumableArray(acc.fieldValue), [decodedObject]),
          newPosition: newPosition
        };
      }, { fieldValue: [], newPosition: startPosition });
    case 'language':
      return { fieldValue: decodeBitsToLanguage(input, startPosition, bitCount) };
    default:
      throw new Error('ConsentString - Unknown field type ' + type + ' for decoding');
  }
}

function decodeFields(_ref4) {
  var input = _ref4.input,
      fields = _ref4.fields,
      _ref4$startPosition = _ref4.startPosition,
      startPosition = _ref4$startPosition === undefined ? 0 : _ref4$startPosition;

  var position = startPosition;

  var decodedObject = fields.reduce(function (acc, field) {
    var name = field.name,
        numBits = field.numBits;

    var _decodeField = decodeField({
      input: input,
      output: acc,
      startPosition: position,
      field: field
    }),
        fieldValue = _decodeField.fieldValue,
        newPosition = _decodeField.newPosition;

    if (fieldValue !== undefined) {
      acc[name] = fieldValue;
    }

    if (newPosition !== undefined) {
      position = newPosition;
    } else if (typeof numBits === 'number') {
      position += numBits;
    }

    return acc;
  }, {});

  return {
    decodedObject: decodedObject,
    newPosition: position
  };
}

/**
 * Encode the data properties to a bit string. Encoding will encode
 * either `selectedVendorIds` or the `vendorRangeList` depending on
 * the value of the `isRange` flag.
 */
function encodeDataToBits(data, definitionMap) {
  var version = data.version;


  if (typeof version !== 'number') {
    throw new Error('ConsentString - No version field to encode');
  } else if (!definitionMap[version]) {
    throw new Error('ConsentString - No definition for version ' + version);
  } else {
    var fields = definitionMap[version].fields;
    return encodeFields({ input: data, fields: fields });
  }
}

/**
 * Take all fields required to encode the consent string and produce the URL safe Base64 encoded value
 */
function encodeToBase64(data) {
  var definitionMap = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : vendorVersionMap;

  var binaryValue = encodeDataToBits(data, definitionMap);

  if (binaryValue) {
    // Pad length to multiple of 8
    var paddedBinaryValue = padRight(binaryValue, 7 - (binaryValue.length + 7) % 8);

    // Encode to bytes
    var bytes = '';
    for (var i = 0; i < paddedBinaryValue.length; i += 8) {
      bytes += String.fromCharCode(parseInt(paddedBinaryValue.substr(i, 8), 2));
    }

    // Make base64 string URL friendly
    return base64.encode(bytes).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  }

  return null;
}

function decodeConsentStringBitValue(bitString) {
  var definitionMap = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : vendorVersionMap;

  var version = decodeBitsToInt(bitString, 0, versionNumBits);

  if (typeof version !== 'number') {
    throw new Error('ConsentString - Unknown version number in the string to decode');
  } else if (!vendorVersionMap[version]) {
    throw new Error('ConsentString - Unsupported version ' + version + ' in the string to decode');
  }

  var fields = definitionMap[version].fields;

  var _decodeFields2 = decodeFields({ input: bitString, fields: fields }),
      decodedObject = _decodeFields2.decodedObject;

  return decodedObject;
}

/**
 * Decode the (URL safe Base64) value of a consent string into an object.
 */
function decodeFromBase64(consentString, definitionMap) {
  // Add padding
  var unsafe = consentString;
  while (unsafe.length % 4 !== 0) {
    unsafe += '=';
  }

  // Replace safe characters
  unsafe = unsafe.replace(/-/g, '+').replace(/_/g, '/');

  var bytes = base64.decode(unsafe);

  var inputBits = '';
  for (var i = 0; i < bytes.length; i += 1) {
    var bitString = bytes.charCodeAt(i).toString(2);
    inputBits += padLeft(bitString, 8 - bitString.length);
  }

  return decodeConsentStringBitValue(inputBits, definitionMap);
}

function decodeBitsToIds(bitString) {
  return bitString.split('').reduce(function (acc, bit, index) {
    if (bit === '1') {
      if (acc.indexOf(index + 1) === -1) {
        acc.push(index + 1);
      }
    }
    return acc;
  }, []);
}

module.exports = {
  padRight: padRight,
  padLeft: padLeft,
  encodeField: encodeField,
  encodeDataToBits: encodeDataToBits,
  encodeIntToBits: encodeIntToBits,
  encodeBoolToBits: encodeBoolToBits,
  encodeDateToBits: encodeDateToBits,
  encodeLanguageToBits: encodeLanguageToBits,
  encodeLetterToBits: encodeLetterToBits,
  encodeToBase64: encodeToBase64,
  decodeBitsToIds: decodeBitsToIds,
  decodeBitsToInt: decodeBitsToInt,
  decodeBitsToDate: decodeBitsToDate,
  decodeBitsToBool: decodeBitsToBool,
  decodeBitsToLanguage: decodeBitsToLanguage,
  decodeBitsToLetter: decodeBitsToLetter,
  decodeFromBase64: decodeFromBase64
};
},{"./definitions":45,"base-64":3}],45:[function(require,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _arrayFrom = Array.from || function () {
  var isCallable = function isCallable(fn) {
    return typeof fn === 'function';
  };

  var toInteger = function toInteger(value) {
    var number = Number(value);

    if (isNaN(number)) {
      return 0;
    }

    if (number === 0 || !isFinite(number)) {
      return number;
    }

    return (number > 0 ? 1 : -1) * Math.floor(Math.abs(number));
  };

  var maxSafeInteger = Math.pow(2, 53) - 1;

  var toLength = function toLength(value) {
    var len = toInteger(value);
    return Math.min(Math.max(len, 0), maxSafeInteger);
  };

  var iteratorProp = function iteratorProp(value) {
    if (value != null) {
      if (['string', 'number', 'boolean', 'symbol'].indexOf(typeof value === 'undefined' ? 'undefined' : _typeof(value)) > -1) {
        return Symbol.iterator;
      } else if (typeof Symbol !== 'undefined' && 'iterator' in Symbol && Symbol.iterator in value) {
        return Symbol.iterator;
      } else if ('@@iterator' in value) {
        return '@@iterator';
      }
    }
  };

  var getMethod = function getMethod(O, P) {
    if (O != null && P != null) {
      var func = O[P];

      if (func == null) {
        return void 0;
      }

      if (!isCallable(func)) {
        throw new TypeError(func + " is not a function");
      }

      return func;
    }
  };

  var iteratorStep = function iteratorStep(iterator) {
    var result = iterator.next();
    var done = Boolean(result.done);

    if (done) {
      return false;
    }

    return result;
  };

  return function from(items) {
    "use strict";

    var C = this;
    var mapFn = arguments.length > 1 ? arguments[1] : void 0;
    var T;

    if (typeof mapFn !== 'undefined') {
      if (!isCallable(mapFn)) {
        throw new TypeError('Array.from: when provided, the second argument must be a function');
      }

      if (arguments.length > 2) {
        T = arguments[2];
      }
    }

    var A, k;
    var usingIterator = getMethod(items, iteratorProp(items));

    if (usingIterator !== void 0) {
      A = isCallable(C) ? Object(new C()) : [];
      var iterator = usingIterator.call(items);

      if (iterator == null) {
        throw new TypeError("Array.from requires an array-like or iterable object");
      }

      k = 0;
      var next, nextValue;

      while (true) {
        next = iteratorStep(iterator);

        if (!next) {
          A.length = k;
          return A;
        }

        nextValue = next.value;

        if (mapFn) {
          A[k] = mapFn.call(T, nextValue, k);
        } else {
          A[k] = nextValue;
        }

        k++;
      }
    } else {
      var arrayLike = Object(items);

      if (items == null) {
        throw new TypeError("Array.from requires an array-like object - not null or undefined");
      }

      var len = toLength(arrayLike.length);
      A = isCallable(C) ? Object(new C(len)) : new Array(len);
      k = 0;
      var kValue;

      while (k < len) {
        kValue = arrayLike[k];

        if (mapFn) {
          A[k] = mapFn.call(T, kValue, k);
        } else {
          A[k] = kValue;
        }

        k++;
      }

      A.length = len;
    }

    return A;
  };
}();

/**
 * Number of bits for encoding the version integer
 * Expected to be the same across versions
 */
var versionNumBits = 6;

/**
 * Definition of the consent string encoded format
 *
 * From https://github.com/InteractiveAdvertisingBureau/GDPR-Transparency-and-Consent-Framework/blob/master/Draft_for_Public_Comment_Transparency%20%26%20Consent%20Framework%20-%20cookie%20and%20vendor%20list%20format%20specification%20v1.0a.pdf
 */
var vendorVersionMap = {
  /**
   * Version 1
   */
  1: {
    version: 1,
    metadataFields: ['version', 'created', 'lastUpdated', 'cmpId', 'cmpVersion', 'consentScreen', 'vendorListVersion'],
    fields: [{ name: 'version', type: 'int', numBits: 6 }, { name: 'created', type: 'date', numBits: 36 }, { name: 'lastUpdated', type: 'date', numBits: 36 }, { name: 'cmpId', type: 'int', numBits: 12 }, { name: 'cmpVersion', type: 'int', numBits: 12 }, { name: 'consentScreen', type: 'int', numBits: 6 }, { name: 'consentLanguage', type: 'language', numBits: 12 }, { name: 'vendorListVersion', type: 'int', numBits: 12 }, { name: 'purposeIdBitString', type: 'bits', numBits: 24 }, { name: 'maxVendorId', type: 'int', numBits: 16 }, { name: 'isRange', type: 'bool', numBits: 1 }, {
      name: 'vendorIdBitString',
      type: 'bits',
      numBits: function numBits(decodedObject) {
        return decodedObject.maxVendorId;
      },
      validator: function validator(decodedObject) {
        return !decodedObject.isRange;
      }
    }, {
      name: 'defaultConsent',
      type: 'bool',
      numBits: 1,
      validator: function validator(decodedObject) {
        return decodedObject.isRange;
      }
    }, {
      name: 'numEntries',
      numBits: 12,
      type: 'int',
      validator: function validator(decodedObject) {
        return decodedObject.isRange;
      }
    }, {
      name: 'vendorRangeList',
      type: 'list',
      listCount: function listCount(decodedObject) {
        return decodedObject.numEntries;
      },
      validator: function validator(decodedObject) {
        return decodedObject.isRange;
      },
      fields: [{
        name: 'isRange',
        type: 'bool',
        numBits: 1
      }, {
        name: 'startVendorId',
        type: 'int',
        numBits: 16
      }, {
        name: 'endVendorId',
        type: 'int',
        numBits: 16,
        validator: function validator(decodedObject) {
          return decodedObject.isRange;
        }
      }]
    }]
  }
};

module.exports = {
  versionNumBits: versionNumBits,
  vendorVersionMap: vendorVersionMap
};
},{}],46:[function(require,module,exports){
/*!
 * JavaScript Cookie v2.2.0
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
;(function (factory) {
	var registeredInModuleLoader = false;
	if (typeof define === 'function' && define.amd) {
		define(factory);
		registeredInModuleLoader = true;
	}
	if (typeof exports === 'object') {
		module.exports = factory();
		registeredInModuleLoader = true;
	}
	if (!registeredInModuleLoader) {
		var OldCookies = window.Cookies;
		var api = window.Cookies = factory();
		api.noConflict = function () {
			window.Cookies = OldCookies;
			return api;
		};
	}
}(function () {
	function extend () {
		var i = 0;
		var result = {};
		for (; i < arguments.length; i++) {
			var attributes = arguments[ i ];
			for (var key in attributes) {
				result[key] = attributes[key];
			}
		}
		return result;
	}

	function init (converter) {
		function api (key, value, attributes) {
			var result;
			if (typeof document === 'undefined') {
				return;
			}

			// Write

			if (arguments.length > 1) {
				attributes = extend({
					path: '/'
				}, api.defaults, attributes);

				if (typeof attributes.expires === 'number') {
					var expires = new Date();
					expires.setMilliseconds(expires.getMilliseconds() + attributes.expires * 864e+5);
					attributes.expires = expires;
				}

				// We're using "expires" because "max-age" is not supported by IE
				attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';

				try {
					result = JSON.stringify(value);
					if (/^[\{\[]/.test(result)) {
						value = result;
					}
				} catch (e) {}

				if (!converter.write) {
					value = encodeURIComponent(String(value))
						.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
				} else {
					value = converter.write(value, key);
				}

				key = encodeURIComponent(String(key));
				key = key.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent);
				key = key.replace(/[\(\)]/g, escape);

				var stringifiedAttributes = '';

				for (var attributeName in attributes) {
					if (!attributes[attributeName]) {
						continue;
					}
					stringifiedAttributes += '; ' + attributeName;
					if (attributes[attributeName] === true) {
						continue;
					}
					stringifiedAttributes += '=' + attributes[attributeName];
				}
				return (document.cookie = key + '=' + value + stringifiedAttributes);
			}

			// Read

			if (!key) {
				result = {};
			}

			// To prevent the for loop in the first place assign an empty array
			// in case there are no cookies at all. Also prevents odd result when
			// calling "get()"
			var cookies = document.cookie ? document.cookie.split('; ') : [];
			var rdecode = /(%[0-9A-Z]{2})+/g;
			var i = 0;

			for (; i < cookies.length; i++) {
				var parts = cookies[i].split('=');
				var cookie = parts.slice(1).join('=');

				if (!this.json && cookie.charAt(0) === '"') {
					cookie = cookie.slice(1, -1);
				}

				try {
					var name = parts[0].replace(rdecode, decodeURIComponent);
					cookie = converter.read ?
						converter.read(cookie, name) : converter(cookie, name) ||
						cookie.replace(rdecode, decodeURIComponent);

					if (this.json) {
						try {
							cookie = JSON.parse(cookie);
						} catch (e) {}
					}

					if (key === name) {
						result = cookie;
						break;
					}

					if (!key) {
						result[name] = cookie;
					}
				} catch (e) {}
			}

			return result;
		}

		api.set = api;
		api.get = function (key) {
			return api.call(api, key);
		};
		api.getJSON = function () {
			return api.apply({
				json: true
			}, [].slice.call(arguments));
		};
		api.defaults = {};

		api.remove = function (key, attributes) {
			api(key, '', extend(attributes, {
				expires: -1
			}));
		};

		api.withConverter = init;

		return api;
	}

	return init(function () {});
}));

},{}],47:[function(require,module,exports){
(function(global) {
  'use strict';

  if (!('window' in global && 'document' in global))
    return;

  //----------------------------------------------------------------------
  //
  // CSSOM View Module
  // https://dev.w3.org/csswg/cssom-view/
  //
  //----------------------------------------------------------------------

  // Fix for IE8-'s Element.getBoundingClientRect()
  if ('TextRectangle' in global && !('width' in global.TextRectangle.prototype)) {
    Object.defineProperties(global.TextRectangle.prototype, {
      width: { get: function() { return this.right - this.left; } },
      height: { get: function() { return this.bottom - this.top; } }
    });
  }
}(self));

},{}],48:[function(require,module,exports){
(function(global) {
  'use strict';
  if (!('window' in global && 'document' in global))
    return;

  //----------------------------------------------------------------------
  //
  // DOM
  // https://dom.spec.whatwg.org/
  //
  //----------------------------------------------------------------------

  // Document.querySelectorAll method
  // http://ajaxian.com/archives/creating-a-queryselector-for-ie-that-runs-at-native-speed
  // Needed for: IE7-
  if (!document.querySelectorAll) {
    document.querySelectorAll = function(selectors) {
      var style = document.createElement('style'), elements = [], element;
      document.documentElement.firstChild.appendChild(style);
      document._qsa = [];

      style.styleSheet.cssText = selectors + '{x-qsa:expression(document._qsa && document._qsa.push(this))}';
      window.scrollBy(0, 0);
      style.parentNode.removeChild(style);

      while (document._qsa.length) {
        element = document._qsa.shift();
        element.style.removeAttribute('x-qsa');
        elements.push(element);
      }
      document._qsa = null;
      return elements;
    };
  }

  // Document.querySelector method
  // Needed for: IE7-
  if (!document.querySelector) {
    document.querySelector = function(selectors) {
      var elements = document.querySelectorAll(selectors);
      return (elements.length) ? elements[0] : null;
    };
  }

  // Document.getElementsByClassName method
  // Needed for: IE8-
  if (!document.getElementsByClassName) {
    document.getElementsByClassName = function(classNames) {
      classNames = String(classNames).replace(/^|\s+/g, '.');
      return document.querySelectorAll(classNames);
    };
  }

  // Node interface constants
  // Needed for: IE8-
  global.Node = global.Node || function() { throw TypeError("Illegal constructor"); };
  [
    ['ELEMENT_NODE', 1],
    ['ATTRIBUTE_NODE', 2],
    ['TEXT_NODE', 3],
    ['CDATA_SECTION_NODE', 4],
    ['ENTITY_REFERENCE_NODE', 5],
    ['ENTITY_NODE', 6],
    ['PROCESSING_INSTRUCTION_NODE', 7],
    ['COMMENT_NODE', 8],
    ['DOCUMENT_NODE', 9],
    ['DOCUMENT_TYPE_NODE', 10],
    ['DOCUMENT_FRAGMENT_NODE', 11],
    ['NOTATION_NODE', 12]
  ].forEach(function(p) { if (!(p[0] in global.Node)) global.Node[p[0]] = p[1]; });

  // DOMException constants
  // Needed for: IE8-
  global.DOMException = global.DOMException || function() { throw TypeError("Illegal constructor"); };
  [
    ['INDEX_SIZE_ERR', 1],
    ['DOMSTRING_SIZE_ERR', 2],
    ['HIERARCHY_REQUEST_ERR', 3],
    ['WRONG_DOCUMENT_ERR', 4],
    ['INVALID_CHARACTER_ERR', 5],
    ['NO_DATA_ALLOWED_ERR', 6],
    ['NO_MODIFICATION_ALLOWED_ERR', 7],
    ['NOT_FOUND_ERR', 8],
    ['NOT_SUPPORTED_ERR', 9],
    ['INUSE_ATTRIBUTE_ERR', 10],
    ['INVALID_STATE_ERR', 11],
    ['SYNTAX_ERR', 12],
    ['INVALID_MODIFICATION_ERR', 13],
    ['NAMESPACE_ERR', 14],
    ['INVALID_ACCESS_ERR', 15]
  ].forEach(function(p) { if (!(p[0] in global.DOMException)) global.DOMException[p[0]] = p[1]; });

  // Event and EventTargets interfaces
  // Needed for: IE8
  (function(){
    if (!('Element' in global) || Element.prototype.addEventListener || !Object.defineProperty)
      return;

    // interface Event

    // PhaseType (const unsigned short)
    Event.CAPTURING_PHASE = 1;
    Event.AT_TARGET       = 2;
    Event.BUBBLING_PHASE  = 3;

    Object.defineProperties(Event.prototype, {
      CAPTURING_PHASE: { get: function() { return 1; } },
      AT_TARGET:       { get: function() { return 2; } },
      BUBBLING_PHASE:   { get: function() { return 3; } },
      target: {
        get: function() {
          return this.srcElement;
        }},
      currentTarget: {
        get: function() {
          return this._currentTarget;
        }},
      eventPhase: {
        get: function() {
          return (this.srcElement === this.currentTarget) ? Event.AT_TARGET : Event.BUBBLING_PHASE;
        }},
      bubbles: {
        get: function() {
          switch (this.type) {
            // Mouse
          case 'click':
          case 'dblclick':
          case 'mousedown':
          case 'mouseup':
          case 'mouseover':
          case 'mousemove':
          case 'mouseout':
          case 'mousewheel':
            // Keyboard
          case 'keydown':
          case 'keypress':
          case 'keyup':
            // Frame/Object
          case 'resize':
          case 'scroll':
            // Form
          case 'select':
          case 'change':
          case 'submit':
          case 'reset':
            return true;
          }
          return false;
        }},
      cancelable: {
        get: function() {
          switch (this.type) {
            // Mouse
          case 'click':
          case 'dblclick':
          case 'mousedown':
          case 'mouseup':
          case 'mouseover':
          case 'mouseout':
          case 'mousewheel':
            // Keyboard
          case 'keydown':
          case 'keypress':
          case 'keyup':
            // Form
          case 'submit':
            return true;
          }
          return false;
        }},
      timeStamp: {
        get: function() {
          return this._timeStamp;
        }},
      stopPropagation: {
        value: function() {
          this.cancelBubble = true;
        }},
      preventDefault: {
        value: function() {
          this.returnValue = false;
        }},
      defaultPrevented: {
        get: function() {
          return this.returnValue === false;
        }}
    });

    // interface EventTarget

    function addEventListener(type, listener, useCapture) {
      if (typeof listener !== 'function') return;
      if (type === 'DOMContentLoaded') type = 'load';
      var target = this;
      var f = function(e) {
        e._timeStamp = Date.now();
        e._currentTarget = target;
        listener.call(this, e);
        e._currentTarget = null;
      };
      this['_' + type + listener] = f;
      this.attachEvent('on' + type, f);
    }

    function removeEventListener(type, listener, useCapture) {
      if (typeof listener !== 'function') return;
      if (type === 'DOMContentLoaded') type = 'load';
      var f = this['_' + type + listener];
      if (f) {
        this.detachEvent('on' + type, f);
        this['_' + type + listener] = null;
      }
    }

    [Window, HTMLDocument, Element].forEach(function(o) {
      o.prototype.addEventListener = addEventListener;
      o.prototype.removeEventListener = removeEventListener;
    });
  }());

  // CustomEvent
  // https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/CustomEvent
  // Needed for: IE
  (function () {
    if ('CustomEvent' in global && typeof global.CustomEvent === "function")
      return;
    function CustomEvent ( event, params ) {
      params = params || { bubbles: false, cancelable: false, detail: undefined };
      var evt = document.createEvent( 'CustomEvent' );
      evt.initCustomEvent( event, params.bubbles, params.cancelable, params.detail );
      return evt;
    }
    CustomEvent.prototype = global.Event.prototype;
    global.CustomEvent = CustomEvent;
  })();

  // Shim for DOM Events for IE7-
  // http://www.quirksmode.org/blog/archives/2005/10/_and_the_winner_1.html
  // Use addEvent(object, event, handler) instead of object.addEventListener(event, handler)
  window.addEvent = function(obj, type, fn) {
    if (obj.addEventListener) {
      obj.addEventListener(type, fn, false);
    } else if (obj.attachEvent) {
      obj["e" + type + fn] = fn;
      obj[type + fn] = function() {
        var e = window.event;
        e.currentTarget = obj;
        e.preventDefault = function() { e.returnValue = false; };
        e.stopPropagation = function() { e.cancelBubble = true; };
        e.target = e.srcElement;
        e.timeStamp = Date.now();
        obj["e" + type + fn].call(this, e);
      };
      obj.attachEvent("on" + type, obj[type + fn]);
    }
  };

  window.removeEvent = function(obj, type, fn) {
    if (obj.removeEventListener) {
      obj.removeEventListener(type, fn, false);
    } else if (obj.detachEvent) {
      obj.detachEvent("on" + type, obj[type + fn]);
      obj[type + fn] = null;
      obj["e" + type + fn] = null;
    }
  };

  // DOMTokenList interface and Element.classList / Element.relList
  // Needed for: IE9-
  // Use getClassList(elem) instead of elem.classList() if IE7- support is needed
  // Use getRelList(elem) instead of elem.relList() if IE7- support is needed
  (function() {
    function DOMTokenListShim(o, p) {
      function split(s) { return s.length ? s.split(/\s+/g) : []; }

      // NOTE: This does not exactly match the spec.
      function removeTokenFromString(token, string) {
        var tokens = split(string),
            index = tokens.indexOf(token);
        if (index !== -1) {
          tokens.splice(index, 1);
        }
        return tokens.join(' ');
      }

      Object.defineProperties(
        this,
        {
          length: {
            get: function() { return split(o[p]).length; }
          },

          item: {
            value: function(idx) {
              var tokens = split(o[p]);
              return 0 <= idx && idx < tokens.length ? tokens[idx] : null;
            }
          },

          contains: {
            value: function(token) {
              token = String(token);
              if (token.length === 0) { throw SyntaxError(); }
              if (/\s/.test(token)) { throw Error("InvalidCharacterError"); }
              var tokens = split(o[p]);

              return tokens.indexOf(token) !== -1;
            }
          },

          add: {
            value: function(/*tokens...*/) {
              var tokens = Array.prototype.slice.call(arguments).map(String);
              if (tokens.some(function(token) { return token.length === 0; })) {
                throw SyntaxError();
              }
              if (tokens.some(function(token) { return (/\s/).test(token); })) {
                throw Error("InvalidCharacterError");
              }

              try {
                var underlying_string = o[p];
                var token_list = split(underlying_string);
                tokens = tokens.filter(function(token) { return token_list.indexOf(token) === -1; });
                if (tokens.length === 0) {
                  return;
                }
                if (underlying_string.length !== 0 && !(/\s$/).test(underlying_string)) {
                  underlying_string += ' ';
                }
                underlying_string += tokens.join(' ');
                o[p] = underlying_string;
              } finally {
                var length = split(o[p]).length;
                if (this.length !== length) { this.length = length; }
              }
            }
          },

          remove: {
            value: function(/*tokens...*/) {
              var tokens = Array.prototype.slice.call(arguments).map(String);
              if (tokens.some(function(token) { return token.length === 0; })) {
                throw SyntaxError();
              }
              if (tokens.some(function(token) { return (/\s/).test(token); })) {
                throw Error("InvalidCharacterError");
              }

              try {
                var underlying_string = o[p];
                tokens.forEach(function(token) {
                  underlying_string = removeTokenFromString(token, underlying_string);
                });
                o[p] = underlying_string;
              } finally {
                var length = split(o[p]).length;
                if (this.length !== length) { this.length = length; }
              }
            }
          },

          toggle: {
            value: function(token/*, force*/) {
              var force = arguments[1];
              try {
                token = String(token);
                if (token.length === 0) { throw SyntaxError(); }
                if (/\s/.test(token)) { throw Error("InvalidCharacterError"); }
                var tokens = split(o[p]),
                    index = tokens.indexOf(token);

                if (index !== -1 && (!force || force === (void 0))) {
                  o[p] = removeTokenFromString(token, o[p]);
                  return false;
                }
                if (index !== -1 && force) {
                  return true;
                }
                var underlying_string = o[p];
                if (underlying_string.length !== 0 && !/\s$/.test(underlying_string)) {
                  underlying_string += ' ';
                }
                underlying_string += token;
                o[p] = underlying_string;
                return true;
              } finally {
                var length = split(o[p]).length;
                if (this.length !== length) { this.length = length; }
              }
            }
          },

          toString: {
            value: function() {
              return o[p];
            }
          }
        });
      if (!('length' in this)) {
        // In case getters are not supported
        this.length = split(o[p]).length;
      } else {
        // If they are, shim in index getters (up to 100)
        for (var i = 0; i < 100; ++i) {
          Object.defineProperty(this, String(i), {
            get: (function(n) { return function() { return this.item(n); }; }(i))
          });
        }
      }
    }

    function addToElementPrototype(p, f) {
      if ('Element' in global && Element.prototype && Object.defineProperty) {
        Object.defineProperty(Element.prototype, p, { get: f });
      }
    }

    // HTML - https://html.spec.whatwg.org
    // Element.classList
    if ('classList' in document.createElement('span')) {
      window.getClassList = function(elem) { return elem.classList; };
    } else {
      window.getClassList = function(elem) { return new DOMTokenListShim(elem, 'className'); };
      addToElementPrototype('classList', function() { return new DOMTokenListShim(this, 'className'); } );
    }

    // HTML - https://html.spec.whatwg.org
    // HTMLAnchorElement.relList
    // HTMLLinkElement.relList
    if ('relList' in document.createElement('link')) {
      window.getRelList = function(elem) { return elem.relList; };
    } else {
      window.getRelList = function(elem) { return new DOMTokenListShim(elem, 'rel'); };
      addToElementPrototype('relList', function() { return new DOMTokenListShim(this, 'rel'); } );
    }

    // Add second argument to native DOMTokenList.toggle() if necessary
    (function() {
      if (!('DOMTokenList' in global)) return;
      var e = document.createElement('span');
      if (!('classList' in e)) return;
      e.classList.toggle('x', false);
      if (!e.classList.contains('x')) return;
      global.DOMTokenList.prototype.toggle = function toggle(token/*, force*/) {
        var force = arguments[1];
        if (force === undefined) {
          var add = !this.contains(token);
          this[add ? 'add' : 'remove'](token);
          return add;
        }
        force = !!force;
        this[force ? 'add' : 'remove'](token);
        return force;
      };
    }());


    // DOM - Interface NonDocumentTypeChildNode
    // Interface NonDocumentTypeChildNode
    // previousElementSibling / nextElementSibling - for IE8

    if (!('previousElementSibling' in document.documentElement)) {
      addToElementPrototype('previousElementSibling', function() {
        var n = this.previousSibling;
        while (n && n.nodeType !== Node.ELEMENT_NODE)
          n = n.previousSibling;
        return n;
      });
    }

    if (!('nextElementSibling' in document.documentElement)) {
      addToElementPrototype('nextElementSibling', function() {
        var n = this.nextSibling;
        while (n && n.nodeType !== Node.ELEMENT_NODE)
          n = n.nextSibling;
        return n;
      });
    }
  }());

  // Element.matches
  // https://developer.mozilla.org/en/docs/Web/API/Element/matches
  // Needed for: IE, Firefox 3.6, early Webkit and Opera 15.0
  // Use msMatchesSelector(selector) for IE
  // Use oMatchesSelector(selector) for Opera 15.0
  // Use mozMatchesSelector(selector) for Firefox 3.6
  // Use webkitMatchesSelector(selector) for early Webkit
  // Use polyfill if no matches() support, but querySelectorAll() support
  if ('Element' in global && !Element.prototype.matches) {
    if (Element.prototype.msMatchesSelector) {
      Element.prototype.matches = Element.prototype.msMatchesSelector;
    } else if (Element.prototype.oMatchesSelector) {
      Element.prototype.matches = Element.prototype.oMatchesSelector;
    } else if (Element.prototype.mozMatchesSelector) {
      Element.prototype.matches = Element.prototype.mozMatchesSelector;
    } else if (Element.prototype.webkitMatchesSelector) {
      Element.prototype.matches = Element.prototype.webkitMatchesSelector;
    } else if (document.querySelectorAll) {
      Element.prototype.matches = function matches(selector) {
        var matches = (this.document || this.ownerDocument).querySelectorAll(selector),
            i = matches.length;
        while (--i >= 0 && matches.item(i) !== this) {}
        return i > -1;
      };
    }
  }

  // Element.closest
  // https://developer.mozilla.org/en-US/docs/Web/API/Element/closest
  if (window.Element && !Element.prototype.closest) {
    Element.prototype.closest = function(s) {
      var matches = (this.document || this.ownerDocument).querySelectorAll(s),
          i,
          el = this;
      do {
        i = matches.length;
        while (--i >= 0 && matches.item(i) !== el) {};
      } while ((i < 0) && (el = el.parentElement)); 
      return el;
    };
  }

  function mixin(o, ps) {
    if (!o) return;
    Object.keys(ps).forEach(function(p) {
      if ((p in o) || (p in o.prototype)) return;
      try {
        Object.defineProperty(
          o.prototype,
          p,
          Object.getOwnPropertyDescriptor(ps, p)
        );
      } catch (ex) {
        // Throws in IE8; just copy it
        o[p] = ps[p];
      }
    });
  }

  // Mixin ParentNode
  // https://dom.spec.whatwg.org/#interface-parentnode

  function convertNodesIntoANode(nodes) {
    var node = null;
    nodes = nodes.map(function(node) {
      return !(node instanceof Node) ? document.createTextNode(node) : node;
    });
    if (nodes.length === 1) {
      node = nodes[0];
    } else {
      node = document.createDocumentFragment();
      nodes.forEach(function(n) { node.appendChild(n); });
    }
    return node;
  }

  var ParentNode = {
    prepend: function(/*...nodes*/) {
      var nodes = [].slice.call(arguments);
      nodes = convertNodesIntoANode(nodes);
      this.insertBefore(nodes, this.firstChild);
    },
    append: function(/*...nodes*/) {
      var nodes = [].slice.call(arguments);
      nodes = convertNodesIntoANode(nodes);
      this.appendChild(nodes);
    }
  };

  mixin(global.Document || global.HTMLDocument, ParentNode); // HTMLDocument for IE8
  mixin(global.DocumentFragment, ParentNode);
  mixin(global.Element, ParentNode);

  // Mixin ChildNode
  // https://dom.spec.whatwg.org/#interface-childnode

  var ChildNode = {
    before: function(/*...nodes*/) {
      var nodes = [].slice.call(arguments);
      var parent = this.parentNode;
      if (!parent) return;
      var viablePreviousSibling = this.previousSibling;
      while (nodes.indexOf(viablePreviousSibling) !== -1)
        viablePreviousSibling = viablePreviousSibling.previousSibling;
      var node = convertNodesIntoANode(nodes);
      parent.insertBefore(node, viablePreviousSibling ?
                          viablePreviousSibling.nextSibling : parent.firstChild);
    },
    after: function(/*...nodes*/) {
      var nodes = [].slice.call(arguments);
      var parent = this.parentNode;
      if (!parent) return;
      var viableNextSibling = this.nextSibling;
      while (nodes.indexOf(viableNextSibling) !== -1)
        viableNextSibling = viableNextSibling.nextSibling;
      var node = convertNodesIntoANode(nodes);
      parent.insertBefore(node, viableNextSibling);
    },
    replaceWith: function(/*...nodes*/) {
      var nodes = [].slice.call(arguments);
      var parent = this.parentNode;
      if (!parent) return;
      var viableNextSibling = this.nextSibling;
      while (nodes.indexOf(viableNextSibling) !== -1)
        viableNextSibling = viableNextSibling.nextSibling;
      var node = convertNodesIntoANode(nodes);

      if (this.parentNode === parent)
        parent.replaceChild(node, this);
      else
        parent.insertBefore(node, viableNextSibling);
    },
    remove: function() {
      if (!this.parentNode) return;
      this.parentNode.removeChild(this);
    }
  };

  mixin(global.DocumentType, ChildNode);
  mixin(global.Element, ChildNode);
  mixin(global.CharacterData, ChildNode);

}(self));

},{}],49:[function(require,module,exports){
//----------------------------------------------------------------------
//
// ECMAScript 5 Polyfills
//
//----------------------------------------------------------------------

//----------------------------------------------------------------------
// ES5 15.2 Object Objects
//----------------------------------------------------------------------

//
// ES5 15.2.3 Properties of the Object Constructor
//

// ES5 15.2.3.2 Object.getPrototypeOf ( O )
// From http://ejohn.org/blog/objectgetprototypeof/
// NOTE: won't work for typical function T() {}; T.prototype = {}; new T; case
// since the constructor property is destroyed.
if (!Object.getPrototypeOf) {
  Object.getPrototypeOf = function (o) {
    if (o !== Object(o)) { throw TypeError("Object.getPrototypeOf called on non-object"); }
    return o.__proto__ || o.constructor.prototype || Object.prototype;
  };
}

//    // ES5 15.2.3.3 Object.getOwnPropertyDescriptor ( O, P )
//    if (typeof Object.getOwnPropertyDescriptor !== "function") {
//        Object.getOwnPropertyDescriptor = function (o, name) {
//            if (o !== Object(o)) { throw TypeError(); }
//            if (o.hasOwnProperty(name)) {
//                return {
//                    value: o[name],
//                    enumerable: true,
//                    writable: true,
//                    configurable: true
//                };
//            }
//        };
//    }

// ES5 15.2.3.4 Object.getOwnPropertyNames ( O )
if (typeof Object.getOwnPropertyNames !== "function") {
  Object.getOwnPropertyNames = function (o) {
    if (o !== Object(o)) { throw TypeError("Object.getOwnPropertyNames called on non-object"); }
    var props = [], p;
    for (p in o) {
      if (Object.prototype.hasOwnProperty.call(o, p)) {
        props.push(p);
      }
    }
    return props;
  };
}

// ES5 15.2.3.5 Object.create ( O [, Properties] )
if (typeof Object.create !== "function") {
  Object.create = function (prototype, properties) {
    if (typeof prototype !== "object") { throw TypeError(); }
    function Ctor() {}
    Ctor.prototype = prototype;
    var o = new Ctor();
    if (prototype) { o.constructor = Ctor; }
    if (properties !== undefined) {
      if (properties !== Object(properties)) { throw TypeError(); }
      Object.defineProperties(o, properties);
    }
    return o;
  };
}

// ES 15.2.3.6 Object.defineProperty ( O, P, Attributes )
// Partial support for most common case - getters, setters, and values
(function() {
  if (!Object.defineProperty ||
      !(function () { try { Object.defineProperty({}, 'x', {}); return true; } catch (e) { return false; } } ())) {
    var orig = Object.defineProperty;
    Object.defineProperty = function (o, prop, desc) {
      // In IE8 try built-in implementation for defining properties on DOM prototypes.
      if (orig) { try { return orig(o, prop, desc); } catch (e) {} }

      if (o !== Object(o)) { throw TypeError("Object.defineProperty called on non-object"); }
      if (Object.prototype.__defineGetter__ && ('get' in desc)) {
        Object.prototype.__defineGetter__.call(o, prop, desc.get);
      }
      if (Object.prototype.__defineSetter__ && ('set' in desc)) {
        Object.prototype.__defineSetter__.call(o, prop, desc.set);
      }
      if ('value' in desc) {
        o[prop] = desc.value;
      }
      return o;
    };
  }
}());

// ES 15.2.3.7 Object.defineProperties ( O, Properties )
if (typeof Object.defineProperties !== "function") {
  Object.defineProperties = function (o, properties) {
    if (o !== Object(o)) { throw TypeError("Object.defineProperties called on non-object"); }
    var name;
    for (name in properties) {
      if (Object.prototype.hasOwnProperty.call(properties, name)) {
        Object.defineProperty(o, name, properties[name]);
      }
    }
    return o;
  };
}


// ES5 15.2.3.14 Object.keys ( O )
// https://developer.mozilla.org/en/JavaScript/Reference/Global_Objects/Object/keys
if (!Object.keys) {
  Object.keys = function (o) {
    if (o !== Object(o)) { throw TypeError('Object.keys called on non-object'); }
    var ret = [], p;
    for (p in o) {
      if (Object.prototype.hasOwnProperty.call(o, p)) {
        ret.push(p);
      }
    }
    return ret;
  };
}

//----------------------------------------------------------------------
// ES5 15.3 Function Objects
//----------------------------------------------------------------------

//
// ES5 15.3.4 Properties of the Function Prototype Object
//

// ES5 15.3.4.5 Function.prototype.bind ( thisArg [, arg1 [, arg2, ... ]] )
// https://developer.mozilla.org/en/JavaScript/Reference/Global_Objects/Function/bind
if (!Function.prototype.bind) {
  Function.prototype.bind = function (o) {
    if (typeof this !== 'function') { throw TypeError("Bind must be called on a function"); }

    var args = Array.prototype.slice.call(arguments, 1),
        self = this,
        nop = function() {},
        bound = function () {
          return self.apply(this instanceof nop ? this : o,
                            args.concat(Array.prototype.slice.call(arguments)));
        };

    if (this.prototype)
      nop.prototype = this.prototype;
    bound.prototype = new nop();
    return bound;
  };
}


//----------------------------------------------------------------------
// ES5 15.4 Array Objects
//----------------------------------------------------------------------

//
// ES5 15.4.3 Properties of the Array Constructor
//


// ES5 15.4.3.2 Array.isArray ( arg )
// https://developer.mozilla.org/en/JavaScript/Reference/Global_Objects/Array/isArray
Array.isArray = Array.isArray || function (o) { return Boolean(o && Object.prototype.toString.call(Object(o)) === '[object Array]'); };


//
// ES5 15.4.4 Properties of the Array Prototype Object
//

// ES5 15.4.4.14 Array.prototype.indexOf ( searchElement [ , fromIndex ] )
// From https://developer.mozilla.org/en/JavaScript/Reference/Global_Objects/Array/indexOf
if (!Array.prototype.indexOf) {
  Array.prototype.indexOf = function (searchElement /*, fromIndex */) {
    if (this === void 0 || this === null) { throw TypeError(); }

    var t = Object(this);
    var len = t.length >>> 0;
    if (len === 0) { return -1; }

    var n = 0;
    if (arguments.length > 0) {
      n = Number(arguments[1]);
      if (isNaN(n)) {
        n = 0;
      } else if (n !== 0 && n !== (1 / 0) && n !== -(1 / 0)) {
        n = (n > 0 || -1) * Math.floor(Math.abs(n));
      }
    }

    if (n >= len) { return -1; }

    var k = n >= 0 ? n : Math.max(len - Math.abs(n), 0);

    for (; k < len; k++) {
      if (k in t && t[k] === searchElement) {
        return k;
      }
    }
    return -1;
  };
}

// ES5 15.4.4.15 Array.prototype.lastIndexOf ( searchElement [ , fromIndex ] )
// From https://developer.mozilla.org/en/JavaScript/Reference/Global_Objects/Array/lastIndexOf
if (!Array.prototype.lastIndexOf) {
  Array.prototype.lastIndexOf = function (searchElement /*, fromIndex*/) {
    if (this === void 0 || this === null) { throw TypeError(); }

    var t = Object(this);
    var len = t.length >>> 0;
    if (len === 0) { return -1; }

    var n = len;
    if (arguments.length > 1) {
      n = Number(arguments[1]);
      if (n !== n) {
        n = 0;
      } else if (n !== 0 && n !== (1 / 0) && n !== -(1 / 0)) {
        n = (n > 0 || -1) * Math.floor(Math.abs(n));
      }
    }

    var k = n >= 0 ? Math.min(n, len - 1) : len - Math.abs(n);

    for (; k >= 0; k--) {
      if (k in t && t[k] === searchElement) {
        return k;
      }
    }
    return -1;
  };
}

// ES5 15.4.4.16 Array.prototype.every ( callbackfn [ , thisArg ] )
// From https://developer.mozilla.org/en/JavaScript/Reference/Global_Objects/Array/every
if (!Array.prototype.every) {
  Array.prototype.every = function (fun /*, thisp */) {
    if (this === void 0 || this === null) { throw TypeError(); }

    var t = Object(this);
    var len = t.length >>> 0;
    if (typeof fun !== "function") { throw TypeError(); }

    var thisp = arguments[1], i;
    for (i = 0; i < len; i++) {
      if (i in t && !fun.call(thisp, t[i], i, t)) {
        return false;
      }
    }

    return true;
  };
}

// ES5 15.4.4.17 Array.prototype.some ( callbackfn [ , thisArg ] )
// From https://developer.mozilla.org/en/JavaScript/Reference/Global_Objects/Array/some
if (!Array.prototype.some) {
  Array.prototype.some = function (fun /*, thisp */) {
    if (this === void 0 || this === null) { throw TypeError(); }

    var t = Object(this);
    var len = t.length >>> 0;
    if (typeof fun !== "function") { throw TypeError(); }

    var thisp = arguments[1], i;
    for (i = 0; i < len; i++) {
      if (i in t && fun.call(thisp, t[i], i, t)) {
        return true;
      }
    }

    return false;
  };
}

// ES5 15.4.4.18 Array.prototype.forEach ( callbackfn [ , thisArg ] )
// From https://developer.mozilla.org/en/JavaScript/Reference/Global_Objects/Array/forEach
if (!Array.prototype.forEach) {
  Array.prototype.forEach = function (fun /*, thisp */) {
    if (this === void 0 || this === null) { throw TypeError(); }

    var t = Object(this);
    var len = t.length >>> 0;
    if (typeof fun !== "function") { throw TypeError(); }

    var thisp = arguments[1], i;
    for (i = 0; i < len; i++) {
      if (i in t) {
        fun.call(thisp, t[i], i, t);
      }
    }
  };
}


// ES5 15.4.4.19 Array.prototype.map ( callbackfn [ , thisArg ] )
// From https://developer.mozilla.org/en/JavaScript/Reference/Global_Objects/Array/Map
if (!Array.prototype.map) {
  Array.prototype.map = function (fun /*, thisp */) {
    if (this === void 0 || this === null) { throw TypeError(); }

    var t = Object(this);
    var len = t.length >>> 0;
    if (typeof fun !== "function") { throw TypeError(); }

    var res = []; res.length = len;
    var thisp = arguments[1], i;
    for (i = 0; i < len; i++) {
      if (i in t) {
        res[i] = fun.call(thisp, t[i], i, t);
      }
    }

    return res;
  };
}

// ES5 15.4.4.20 Array.prototype.filter ( callbackfn [ , thisArg ] )
// From https://developer.mozilla.org/en/JavaScript/Reference/Global_Objects/Array/Filter
if (!Array.prototype.filter) {
  Array.prototype.filter = function (fun /*, thisp */) {
    if (this === void 0 || this === null) { throw TypeError(); }

    var t = Object(this);
    var len = t.length >>> 0;
    if (typeof fun !== "function") { throw TypeError(); }

    var res = [];
    var thisp = arguments[1], i;
    for (i = 0; i < len; i++) {
      if (i in t) {
        var val = t[i]; // in case fun mutates this
        if (fun.call(thisp, val, i, t)) {
          res.push(val);
        }
      }
    }

    return res;
  };
}


// ES5 15.4.4.21 Array.prototype.reduce ( callbackfn [ , initialValue ] )
// From https://developer.mozilla.org/en/JavaScript/Reference/Global_Objects/Array/Reduce
if (!Array.prototype.reduce) {
  Array.prototype.reduce = function (fun /*, initialValue */) {
    if (this === void 0 || this === null) { throw TypeError(); }

    var t = Object(this);
    var len = t.length >>> 0;
    if (typeof fun !== "function") { throw TypeError(); }

    // no value to return if no initial value and an empty array
    if (len === 0 && arguments.length === 1) { throw TypeError(); }

    var k = 0;
    var accumulator;
    if (arguments.length >= 2) {
      accumulator = arguments[1];
    } else {
      do {
        if (k in t) {
          accumulator = t[k++];
          break;
        }

        // if array contains no values, no initial value to return
        if (++k >= len) { throw TypeError(); }
      }
      while (true);
    }

    while (k < len) {
      if (k in t) {
        accumulator = fun.call(undefined, accumulator, t[k], k, t);
      }
      k++;
    }

    return accumulator;
  };
}


// ES5 15.4.4.22 Array.prototype.reduceRight ( callbackfn [, initialValue ] )
// From https://developer.mozilla.org/en/JavaScript/Reference/Global_Objects/Array/ReduceRight
if (!Array.prototype.reduceRight) {
  Array.prototype.reduceRight = function (callbackfn /*, initialValue */) {
    if (this === void 0 || this === null) { throw TypeError(); }

    var t = Object(this);
    var len = t.length >>> 0;
    if (typeof callbackfn !== "function") { throw TypeError(); }

    // no value to return if no initial value, empty array
    if (len === 0 && arguments.length === 1) { throw TypeError(); }

    var k = len - 1;
    var accumulator;
    if (arguments.length >= 2) {
      accumulator = arguments[1];
    } else {
      do {
        if (k in this) {
          accumulator = this[k--];
          break;
        }

        // if array contains no values, no initial value to return
        if (--k < 0) { throw TypeError(); }
      }
      while (true);
    }

    while (k >= 0) {
      if (k in t) {
        accumulator = callbackfn.call(undefined, accumulator, t[k], k, t);
      }
      k--;
    }

    return accumulator;
  };
}


//----------------------------------------------------------------------
// ES5 15.5 String Objects
//----------------------------------------------------------------------

//
// ES5 15.5.4 Properties of the String Prototype Object
//


// ES5 15.5.4.20 String.prototype.trim()
if (!String.prototype.trim) {
  String.prototype.trim = function () {
    return String(this).replace(/^\s+/, '').replace(/\s+$/, '');
  };
}



//----------------------------------------------------------------------
// ES5 15.9 Date Objects
//----------------------------------------------------------------------


//
// ES 15.9.4 Properties of the Date Constructor
//

// ES5 15.9.4.4 Date.now ( )
// From https://developer.mozilla.org/en/Core_JavaScript_1.5_Reference/Global_Objects/Date/now
if (!Date.now) {
  Date.now = function now() {
    return Number(new Date());
  };
}


//
// ES5 15.9.5 Properties of the Date Prototype Object
//

// ES5 15.9.4.43 Date.prototype.toISOString ( )
// Inspired by http://www.json.org/json2.js
if (!Date.prototype.toISOString) {
  Date.prototype.toISOString = function () {
    function pad2(n) { return ('00' + n).slice(-2); }
    function pad3(n) { return ('000' + n).slice(-3); }

    return this.getUTCFullYear() + '-' +
      pad2(this.getUTCMonth() + 1) + '-' +
      pad2(this.getUTCDate()) + 'T' +
      pad2(this.getUTCHours()) + ':' +
      pad2(this.getUTCMinutes()) + ':' +
      pad2(this.getUTCSeconds()) + '.' +
      pad3(this.getUTCMilliseconds()) + 'Z';
  };
}

},{}],50:[function(require,module,exports){
//----------------------------------------------------------------------
//
// ECMAScript 2015 Polyfills
//
//----------------------------------------------------------------------

(function (global) {
  "use strict";

  // Set this to always override native implementations, for testing
  // the polyfill in browsers with partial/full ES2015 support.
  var OVERRIDE_NATIVE_FOR_TESTING = false;

  var undefined = (void 0); // Paranoia

  // Helpers

  function strict(o) {
    return o === global ? undefined : o;
  }

  function isSymbol(s) {
    return (typeof s === 'symbol') || ('Symbol' in global && s instanceof global.Symbol);
  }

  function getPropertyDescriptor(target, name) {
    var desc = Object.getOwnPropertyDescriptor(target, name);
    var proto = Object.getPrototypeOf(target);
    while (!desc && proto) {
      desc = Object.getOwnPropertyDescriptor(proto, name);
      proto = Object.getPrototypeOf(proto);
    }
    return desc;
  }

  var enqueue = (function(nativePromise, nativeSetImmediate) {
    if (nativePromise)
      return function(job) { nativePromise.resolve().then(function() { job(); }); };
    if (nativeSetImmediate)
      return function(job) { nativeSetImmediate(job); };
    return function(job) { setTimeout(job, 0); };
  }(global['Promise'], global['setImmediate']));

  function define(o, p, v, override) {
    if (p in o && !override && !OVERRIDE_NATIVE_FOR_TESTING)
      return;

    if (typeof v === 'function') {
      // Sanity check that functions are appropriately named (where possible)
      console.assert(isSymbol(p) || !('name' in v) || v.name === p || v.name === p + '_', 'Expected function name "' + p.toString() + '", was "' + v.name + '"');
      Object.defineProperty(o, p, {
        value: v,
        configurable: true,
        enumerable: false,
        writable: true
      });
    } else {
      Object.defineProperty(o, p, {
        value: v,
        configurable: false,
        enumerable: false,
        writable: false
      });
    }
  }

  function set_internal(o, p, v) {
    Object.defineProperty(o, p, {
      value: v,
      configurable: false,
      enumerable: false,
      writable: true
    });
  }

  // Snapshot intrinsic functions
  var $isNaN = global.isNaN,
      $parseInt = global.parseInt,
      $parseFloat = global.parseFloat;

  var E = Math.E,
      LOG10E = Math.LOG10E,
      LOG2E = Math.LOG2E,
      abs = Math.abs,
      ceil = Math.ceil,
      exp = Math.exp,
      floor = Math.floor,
      log = Math.log,
      max = Math.max,
      min = Math.min,
      pow = Math.pow,
      random = Math.random,
      sqrt = Math.sqrt;

  var orig_match = String.prototype.match,
      orig_replace = String.prototype.replace,
      orig_search = String.prototype.search,
      orig_split = String.prototype.split;

  // These are used for implementing the polyfills, but not exported.

  // Inspired by https://gist.github.com/1638059
  /** @constructor */
  function EphemeronTable() {
    var secretKey = ObjectCreate(null);

    function conceal(o) {
      var oValueOf = o.valueOf, secrets = ObjectCreate(null);
      Object.defineProperty(o, 'valueOf', {
          value: (function(secretKey) {
            return function (k) {
              return (k === secretKey) ? secrets : oValueOf.apply(o, arguments);
            };
          }(secretKey)),
        configurable: true,
        writeable: true,
        enumerable: false
        });
      return secrets;
    }

    function reveal(o) {
      var v = typeof o.valueOf === 'function' && o.valueOf(secretKey);
      return v === o ? null : v;
    }

    return {
      clear: function() {
        secretKey = ObjectCreate(null);
      },
      remove: function(key) {
        var secrets = reveal(key);
        if (secrets && HasOwnProperty(secrets, 'value')) {
          delete secrets.value;
          return true;
        }
        return false;
      },
      get: function(key, defaultValue) {
        var secrets = reveal(key);
        return (secrets && HasOwnProperty(secrets, 'value')) ? secrets.value : defaultValue;
      },
      has: function(key) {
        var secrets = reveal(key);
        return Boolean(secrets && HasOwnProperty(secrets, 'value'));
      },
      set: function(key, value) {
        var secrets = reveal(key) || conceal(key);
        secrets.value = value;
      }
    };
  }

  var empty = Object.create(null);

  //----------------------------------------------------------------------
  //
  // ECMAScript 2015
  // http://www.ecma-international.org/ecma-262/6.0/
  //
  //----------------------------------------------------------------------

  // ---------------------------------------
  // 19.4 Symbol Objects
  // ---------------------------------------

  // NOTE: Symbols are defined here - out of spec order - since we need the
  // properties and prototype to be populated for other polyfills.

  // NOTE: Not secure, nor is obj[$$symbol] hidden from Object.keys()

  var symbolForKey;
  (function() {
    var secret = Object.create(null);
    var symbolMap = {};
    symbolForKey = function(k) {
      return symbolMap[k];
    };

    var GlobalSymbolRegistry = [];

    function unique(bits) {
      return Array(bits + 1).join('x').replace(/x/g, function() {
        return random() < 0.5 ? '\u200C' : '\u200D'; // JWNJ / ZWJ
      });
    }

    // 19.4.1 The Symbol Constructor
    // 19.4.1.1 Symbol ( description=undefined )
    function Symbol(description) {
      if (!(this instanceof Symbol)) return new Symbol(description, secret);
      if (this instanceof Symbol && arguments[1] !== secret) throw TypeError();

      var descString = description === undefined ? undefined : String(description);

      set_internal(this, '[[SymbolData]]', unique(128));
      set_internal(this, '[[Description]]', descString);

      symbolMap[this] = this;
      return this;
    }

    if (!('Symbol' in global) || OVERRIDE_NATIVE_FOR_TESTING)
      global.Symbol = Symbol;

    // 19.4.2 Properties of the Symbol Constructor

    // 19.4.2.1 Symbol.for (key)
    define(Symbol, 'for', function for_(key) {
      var stringKey = String(key);
      for (var i = 0; i < GlobalSymbolRegistry.length; ++i) {
        var e = GlobalSymbolRegistry[i];
        if (SameValue(e['[[key]]'], stringKey)) return e['[[symbol]]'];
      }
      var newSymbol = Symbol(key);
      GlobalSymbolRegistry.push({'[[key]]': stringKey, '[[symbol]]': newSymbol});
      return newSymbol;
    });

    // 19.4.2.2 Symbol.hasInstance
    // 19.4.2.3 Symbol.isConcatSpreadable

    // 19.4.2.4 Symbol.iterator
    define(global.Symbol, 'iterator', global.Symbol('Symbol.iterator'));

    // 19.4.2.5 Symbol.keyFor (sym)
    define(Symbol, 'keyFor', function keyFor(sym) {
      if (!(sym instanceof Symbol)) throw TypeError();
      for (var i = 0; i < GlobalSymbolRegistry.length; ++i) {
        var e = GlobalSymbolRegistry[i];
        if (SameValue(e['[[symbol]]'], sym)) return e['[[key]]'];
      }
      return undefined;
    });

    // 19.4.2.6 Symbol.match
    define(global.Symbol, 'match', global.Symbol('Symbol.match'));

    // 19.4.2.7 Symbol.prototype

    // 19.4.2.8 Symbol.replace
    define(global.Symbol, 'replace', global.Symbol('Symbol.replace'));

    // 19.4.2.9 Symbol.search
    define(global.Symbol, 'search', global.Symbol('Symbol.search'));

    // 19.4.2.10 Symbol.species

    // 19.4.2.11 Symbol.search
    define(global.Symbol, 'split', global.Symbol('Symbol.split'));

    // 19.4.2.12 Symbol.toPrimitive

    // 19.4.2.13 Symbol.toStringTag
    define(global.Symbol, 'toStringTag', global.Symbol('Symbol.toStringTag'));

    // 19.4.2.14 Symbol.unscopables

    // 19.4.3 Properties of the Symbol Prototype Object
    // 19.4.3.1 Symbol.prototype.constructor

    // 19.4.3.2 Symbol.prototype.toString ( )
    Object.defineProperty(Symbol.prototype, 'toString', {
      value: function toString() {
        var s = strict(this);
        var desc = s['[[Description]]'];
        return 'Symbol(' + (desc === undefined ? '' : desc) + s['[[SymbolData]]'] + ')';
      },
      configurable: true, writeable: true, enumerable: false });

    // 19.4.3.3 Symbol.prototype.valueOf ( )
    Object.defineProperty(Symbol.prototype, 'valueOf', {
      value: function valueOf() {
        // To prevent automatic string conversion:
        throw TypeError();

        // Spec has approximately the following:
        //var s = strict(this);
        //if (Type(s) === 'symbol') return s;
        //if (Type(s) !== 'object') throw TypeError();
        //if (!('[[SymbolData]]' in s)) throw TypeError();
        //return s['[[SymbolData]]'];
      },
      configurable: true, writeable: true, enumerable: false });

    // 19.4.3.4 Symbol.prototype [ @@toStringTag ]
    // (Done later to polyfill partial implementations)

    // 19.4.4 Properties of Symbol Instances
  }());

  console.assert(typeof global.Symbol() === 'symbol' || symbolForKey(String(global.Symbol('x'))) !== undefined);

  // Defined here so that other prototypes can reference it
  // 25.1.2 The %IteratorPrototype% Object
  var $IteratorPrototype$ = {};

  //----------------------------------------
  // 6 ECMAScript Data Types and Values
  //----------------------------------------

  // 6.1 ECMAScript Language Types

  // "Type(x)" is used as shorthand for "the type of x"...
  function Type(v) {
    switch (typeof v) {
    case 'undefined': return 'undefined';
    case 'boolean': return 'boolean';
    case 'number': return 'number';
    case 'string': return 'string';
    case 'symbol': return 'symbol';
    default:
      if (v === null) return 'null';
      if (v instanceof global.Symbol) return 'symbol';
      return 'object';
    }
  }

  // 6.1.5.1 Well-Known Symbols
  var $$iterator = global.Symbol.iterator,
      $$match = global.Symbol.match,
      $$replace = global.Symbol.replace,
      $$search = global.Symbol.search,
      $$split = global.Symbol.split,
      $$toStringTag = global.Symbol.toStringTag;

  //----------------------------------------
  // 7 Abstract Operations
  //----------------------------------------

  //----------------------------------------
  // 7.1 Type Conversion
  //----------------------------------------

  // 7.1.1 ToPrimitive ( input [, PreferredType] )
  // just use valueOf()

  // 7.1.2 ToBoolean ( argument )
  // just use Boolean()

  // 7.1.3 ToNumber ( argument )
  // just use Number()

  // 7.1.4 ToInteger ( argument )
  function ToInteger(n) {
    n = Number(n);
    if ($isNaN(n)) return 0;
    if (n === 0 || n === Infinity || n === -Infinity) return n;
    return ((n < 0) ? -1 : 1) * floor(abs(n));
  }

  // 7.1.5 ToInt32 ( argument )
  function ToInt32(v) { return v >> 0; }

  // 7.1.6 ToUint32 ( argument )
  function ToUint32(v) { return v >>> 0; }

  // 7.1.7 ToInt16 ( argument )
  function ToInt16(v) { return (v << 16) >> 16; }

  // 7.1.8 ToUint16 ( argument )
  function ToUint16(v) { return v & 0xFFFF; }

  // 7.1.9 ToInt8 ( argument )
  function ToInt8(v) { return (v << 24) >> 24; }

  // 7.1.10 ToUint8 ( argument )
  function ToUint8(v) { return v & 0xFF; }

  // 7.1.11 ToUint8Clamp ( argument )
  function ToUint8Clamp(argument) {
    var number = Number(argument);
    if ($isNaN(number)) return 0;
    if (number <= 0) return 0;
    if (number >= 255) return 255;
    var f = floor(number);
    if ((f + 0.5) < number) return f + 1;
    if (number < (f + 0.5)) return f;
    if (f % 2) return f + 1;
    return f;
  }

  // 7.1.12 ToString ( argument )
  // just use String()

  // 7.1.13 ToObject ( argument )
  function ToObject(v) {
    if (v === null || v === undefined) throw TypeError();
    return Object(v);
  }

  // 7.1.14 ToPropertyKey ( argument )
  function ToPropertyKey(v) {
    return String(v);
  }

  // 7.1.15 ToLength ( argument )
  function ToLength(v) {
    var len = ToInteger(v);
    if (len <= 0) return 0;
    if (len === Infinity) return 0x20000000000000 - 1; // 2^53-1
    return min(len, 0x20000000000000 - 1); // 2^53-1
  }

  // 7.1.16 CanonicalNumericIndexString ( argument )

  //----------------------------------------
  // 7.2 Testing and Comparison Operations
  //----------------------------------------

  // 7.2.1 RequireObjectCoercible ( argument )
  // 7.2.2 IsArray ( argument )

  // 7.2.3 IsCallable ( argument )
  function IsCallable(o) { return typeof o === 'function'; }

  // 7.2.4 IsConstructor ( argument )
  function IsConstructor(o) {
    // Hacks for Safari 7 TypedArray XXXConstructor objects
    if (/Constructor/.test(Object.prototype.toString.call(o))) return true;
    if (/Function/.test(Object.prototype.toString.call(o))) return true;
    // TODO: Can this be improved on?
    return typeof o === 'function';
  }

  // 7.2.5 IsExtensible (O)
  // 7.2.6 IsInteger ( argument )

  // 7.2.7 IsPropertyKey ( argument )
  function IsPropertyKey(argument) {
    if (Type(argument) === 'string') return true;
    if (Type(argument) === 'symbol') return true;
    return false;
  }

  // 7.2.8 IsRegExp ( argument )

  // 7.2.9 SameValue(x, y)
  function SameValue(x, y) {
    if (typeof x !== typeof y) return false;
    switch (typeof x) {
    case 'undefined':
      return true;
    case 'number':
      if (x !== x && y !== y) return true;
      if (x === 0 && y === 0) return 1/x === 1/y;
      return x === y;
    case 'boolean':
    case 'string':
    case 'object':
    default:
      return x === y;
    }
  }

  // 7.2.10 SameValueZero(x, y)
  function SameValueZero(x, y) {
    if (typeof x !== typeof y) return false;
    switch (typeof x) {
    case 'undefined':
      return true;
    case 'number':
      if (x !== x && y !== y) return true;
      return x === y;
    case 'boolean':
    case 'string':
    case 'object':
    default:
      return x === y;
    }
  }

  //----------------------------------------
  // 7.3 Operations on Objects
  //----------------------------------------

  // 7.3.1 Get (O, P)
  // - just use o.p or o[p]

  // 7.3.2 GetV (V, P)
  function GetV(v, p) {
    var o = ToObject(v);
    return o[p];
  }

  // 7.3.3 Set (O, P, V, Throw)
  // - just use o.p = v or o[p] = v




  // 7.3.9 GetMethod (O, P)
  function GetMethod(o, p) {
    var func = GetV(o, p);
    if (func === undefined || func === null) return undefined;
    if (!IsCallable(func)) throw TypeError();
    return func;
  }

  // 7.3.10 HasProperty (O, P)
  function HasProperty(o, p) {
    while (o) {
      if (Object.prototype.hasOwnProperty.call(o, p)) return true;
      if (Type(o) !== 'object') return false;
      var op = Object.getPrototypeOf(o);
      if (op === o) return false; // IE8 has self-referential prototypes
      o = op;
    }
    return false;
  }

  // 7.3.11 HasOwnProperty (O, P)
  function HasOwnProperty(o, p) {
    return Object.prototype.hasOwnProperty.call(o, p);
  }

  //----------------------------------------
  // 7.4 Operations on Iterator Objects
  //----------------------------------------

  // 7.4.1 GetIterator ( obj, method )
  function GetIterator(obj, method) {
    if (arguments.length < 2)
      method = GetMethod(obj, $$iterator);
    var iterator = method.call(obj);
    if (Type(iterator) !== 'object') throw TypeError();
    return iterator;
  }

  // 7.4.2 IteratorNext ( iterator, value )
  function IteratorNext(iterator, value) {
    if (arguments.length < 2)
      var result = iterator.next();
    else
      result = iterator.next(value);
    if (Type(result) !== 'object') throw TypeError();
    return result;
  }

  // 7.4.3 IteratorComplete ( iterResult )
  function IteratorComplete(iterResult) {
    console.assert(Type(iterResult) === 'object');
    return Boolean(iterResult.done);
  }

  // 7.4.4 IteratorValue ( iterResult )
  function IteratorValue(iterResult) {
    console.assert(Type(iterResult) === 'object');
    return iterResult.value;
  }

  // 7.4.5 IteratorStep ( iterator )
  function IteratorStep( iterator, value ) {
    var result = IteratorNext(iterator, value);
    var done = result['done'];
    if (Boolean(done) === true) return false;
    return result;
  }

  // 7.4.6 IteratorClose( iterator, completion )
  function IteratorClose( iterator, completion ) {
    console.assert(Type(iterator) === 'object');
    var _return = GetMethod(iterator, 'return');
    if (_return === undefined) return completion;
    try {
      var innerResult = _return[iterator]();
    } catch (result) {
      // TODO: If completion.[[type]] is throw, return completion
      return result;
    }
    if (Type(innerResult) !== 'object') throw TypeError();
    return completion;
  }

  // 7.4.7 CreateIterResultObject (value, done)
  function CreateIterResultObject(value, done) {
    console.assert(Type(done) === 'boolean');
    var obj = {};
    obj["value"] = value;
    obj["done"] = done;
    return obj;
  }

  // 7.4.8 CreateListIterator (list)
  // 7.4.8.1 ListIterator next( )

  //----------------------------------------
  // 8 Executable Code and Execution Contexts
  //----------------------------------------

  //----------------------------------------
  // 8.4 Jobs and Job Queues
  //----------------------------------------

  // 8.4.1 EnqueueJob ( queueName, job, arguments)
  function EnqueueJob(queueName, job, args) {
    var fn = function() { job.apply(undefined, args); };
    enqueue(fn);
  }

  // 8.4.2 NextJob result
  function NextJob(result) {
    // no-op
  }

  //----------------------------------------
  // 9 Ordinary and Exotic Objects Behaviors
  //----------------------------------------

  // 9.1.11 [[Enumerate]] ()
  function Enumerate(obj) {
    var e = [];
    if (Object(obj) !== obj) return e;
    var visited = new Set;
    while (obj !== null) {
      Object.getOwnPropertyNames(obj).forEach(function(name) {
        if (!visited.has(name)) {
          var desc = Object.getOwnPropertyDescriptor(obj, name);
          if (desc) {
            visited.add(name);
            if (desc.enumerable) e.push(name);
          }
        }
      });
      obj = Object.getPrototypeOf(obj);
    }
    return e[$$iterator]();
  }

  // 9.1.12 [[OwnPropertyKeys]] ( )
  function OwnPropertyKeys(o) {
    return Object.getOwnPropertyNames(o);
  }

  // 9.1.13 ObjectCreate(proto, internalSlotsList)
  function ObjectCreate(proto, internalSlotsList) {
    return Object.create(proto, internalSlotsList);
  }

  // ---------------------------------------
  // 19 Fundamental Objects
  // ---------------------------------------

  // ---------------------------------------
  // 19.1 Object Objects
  // ---------------------------------------

  // 19.1.1 The Object Constructor
  // 19.1.1.1 Object ( [ value ] )
  // 19.1.2 Properties of the Object Constructor
  // 19.1.2.1 Object.assign ( target, ...sources )
  define(
    Object, 'assign',
    function assign(target, /*...*/sources) {
      var to = ToObject(target);
      if (arguments.length < 2) return to;

      var sourcesIndex = 1;
      while (sourcesIndex < arguments.length) {
        var nextSource = arguments[sourcesIndex++];
        if (nextSource === undefined || nextSource === null) {
          var keys = [];
        } else {
          var from = ToObject(nextSource);
          keys = OwnPropertyKeys(from);
        }
        for (var keysIndex = 0; keysIndex < keys.length; ++keysIndex) {
          var nextKey = keys[keysIndex];
          var desc = Object.getOwnPropertyDescriptor(from, nextKey);
          if (desc !== undefined && desc.enumerable) {
            var propValue = from[nextKey];
            to[nextKey] = propValue;
          }
        }
      }
      return to;
    });

  // 19.1.2.2 Object.create ( O [ , Properties ] )
  // 19.1.2.3 Object.defineProperties ( O, Properties )
  // 19.1.2.4 Object.defineProperty ( O, P, Attributes )
  // 19.1.2.5 Object.freeze ( O )
  // 19.1.2.6 Object.getOwnPropertyDescriptor ( O, P )

  (function() {
    var nativeSymbols = (typeof global.Symbol() === 'symbol'),
        $getOwnPropertyNames = Object.getOwnPropertyNames,
        $keys = Object.keys,
        $window_names = (typeof window === 'object' ? $getOwnPropertyNames(window) : []);

    function isStringKey(k) { return !symbolForKey(k); }

    // 19.1.2.7 Object.getOwnPropertyNames ( O )
    define(
      Object, 'getOwnPropertyNames',
      function getOwnPropertyNames(o) {
        if (Object.prototype.toString.call(o) === '[object Window]') {
          // Workaround for cross-realm calling by IE itself.
          // https://github.com/inexorabletash/polyfill/issues/96
          try {
            return $getOwnPropertyNames(o).filter(isStringKey);
          } catch (_) {
            return $window_names.slice();
          }
        }
        return $getOwnPropertyNames(o).filter(isStringKey);
      }, !nativeSymbols);

    // 19.1.2.8 Object.getOwnPropertySymbols ( O )
    define(
      Object, 'getOwnPropertySymbols',
      function getOwnPropertySymbols(o) {
        return $getOwnPropertyNames(o).filter(symbolForKey).map(symbolForKey);
      }, !nativeSymbols);

    // 19.1.2.14 Object.keys ( O )
    define(
      Object, 'keys',
      function keys(o) {
        return $keys(o).filter(isStringKey);
      }, !nativeSymbols);
  }());

  // 19.1.2.9 Object.getPrototypeOf ( O )
  // 19.1.2.10 Object.is ( value1, value2 )
  define(
    Object, 'is',
    function is(value1, value2) {
      return SameValue(value1, value2);
    });

  // 19.1.2.11 Object.isExtensible ( O )
  // 19.1.2.12 Object.isFrozen ( O )
  // 19.1.2.13 Object.isSealed ( O )

  // 19.1.2.14 Object.keys ( O )
  // see above

  // 19.1.2.15 Object.preventExtensions ( O )
  // 19.1.2.16 Object.prototype
  // 19.1.2.17 Object.seal ( O )

  // 19.1.2.18 Object.setPrototypeOf ( O, proto )
  define(
    Object, 'setPrototypeOf',
    function setPrototypeOf(o, proto) {
      if (Type(o) !== 'object') throw TypeError();
      if (Type(proto) !== 'object' && Type(proto) !== 'null') throw TypeError();
      o.__proto__ = proto;
      return o;
    }
  );

  // 19.1.3 Properties of the Object Prototype Object
  // 19.1.3.1 Object.prototype.constructor
  // 19.1.3.2 Object.prototype.hasOwnProperty ( V )
  // 19.1.3.3 Object.prototype.isPrototypeOf ( V )
  // 19.1.3.4 Object.prototype.propertyIsEnumerable ( V )
  // 19.1.3.5 Object.prototype.toLocaleString ( [ reserved1 [ , reserved2 ] ] )
  // 19.1.3.6 Object.prototype.toString ( )
  var o_p_ts = Object.prototype.toString;
  define(Object.prototype, 'toString',
       function() {
         var o = strict(this);
         if (o === Object(o) && $$toStringTag in o) {
           return '[object ' + o[$$toStringTag] + ']';
         }
         return o_p_ts.apply(o, arguments);
       });

  // 19.1.3.7 Object.prototype.valueOf ( )
  // 19.1.4 Properties of Object Instances

  // ---------------------------------------
  // 19.2 Function Objects
  // ---------------------------------------

  // 19.2.1 The Function Constructor
  // 19.2.1.1 Function ( p1, p2, … , pn, body )
  // 19.2.2 Properties of the Function Constructor
  // 19.2.2.1 Function.length
  // 19.2.2.2 Function.prototype
  // 19.2.3 Properties of the Function Prototype Object
  // 19.2.3.1 Function.prototype.apply ( thisArg, argArray )
  // 19.2.3.2 Function.prototype.bind ( thisArg , ...args)
  // 19.2.3.3 Function.prototype.call (thisArg , ...args)
  // 19.2.3.4 Function.prototype.constructor
  // 19.2.3.5 Function.prototype.toString ( )
  // 19.2.3.6 Function.prototype[@@hasInstance] ( V )
  // 19.2.4 Function Instances
  // 19.2.4.1 length
  // 19.2.4.2 name
  // 19.2.4.3 prototype

  // (No polyfillable changes from ES5)

  // ---------------------------------------
  // 19.3 Boolean Objects
  // ---------------------------------------

  // 19.3.1 The Boolean Constructor
  // 19.3.1.1 Boolean ( value )
  // 19.3.2 Properties of the Boolean Constructor
  // 19.3.2.1 Boolean.prototype
  // 19.3.3 Properties of the Boolean Prototype Object
  // 19.3.3.1 Boolean.prototype.constructor
  // 19.3.3.2 Boolean.prototype.toString ( )
  // 19.3.3.3 Boolean.prototype.valueOf ( )
  // 19.3.4 Properties of Boolean Instances

  // (No polyfillable changes from ES5)

  // ---------------------------------------
  // 19.4 Symbol Objects
  // ---------------------------------------

  // Moved earlier in this script, so that other polyfills can depend on them.

  // 19.4.3.4 Symbol.prototype [ @@toStringTag ]
  define(global.Symbol.prototype, global.Symbol.toStringTag, 'Symbol');

  // ---------------------------------------
  // 19.5 Error Objects
  // ---------------------------------------

  // 19.5.1 The Error Constructor
  // 19.5.1.1 Error ( message )
  // 19.5.1.2 new Error( ...argumentsList )
  // 19.5.2 Properties of the Error Constructor
  // 19.5.2.1 Error.prototype
  // 19.5.3 Properties of the Error Prototype Object
  // 19.5.3.1 Error.prototype.constructor
  // 19.5.3.2 Error.prototype.message
  // 19.5.3.3 Error.prototype.name
  // 19.5.3.4 Error.prototype.toString ( )
  // 19.5.4 Properties of Error Instances
  // 19.5.5 Native Error Types Used in This Standard
  // 19.5.5.1 EvalError
  // 19.5.5.2 RangeError
  // 19.5.5.3 ReferenceError
  // 19.5.5.4 SyntaxError
  // 19.5.5.5 TypeError
  // 19.5.5.6 URIError
  // 19.5.6 NativeError Object Structure
  // 19.5.6.1 NativeError Constructors
  // 19.5.6.1.1 NativeError ( message )
  // 19.5.6.1.2 new NativeError ( ...argumentsList )
  // 19.5.6.2 Properties of the NativeError Constructors
  // 19.5.6.2.1 NativeError.prototype
  // 19.5.6.3 Properties of the NativeError Prototype Objects
  // 19.5.6.4 Properties of NativeError Instances

  // (No polyfillable changes from ES5)

  // ---------------------------------------
  // 20 Numbers and Dates
  // ---------------------------------------

  // ---------------------------------------
  // 20.1 Number Objects
  // ---------------------------------------

  // 20.1.1 The Number Constructor
  // 20.1.1.1 Number ( [ value ] )
  // 20.1.1.2 new Number ( ...argumentsList )
  // 20.1.2 Properties of the Number Constructor

  // 20.1.2.1 Number.EPSILON
  define(
    Number, 'EPSILON',
    (function () {
      var next, result;
      for (next = 1; 1 + next !== 1; next = next / 2)
        result = next;
      return result;
    }()));

  // 20.1.2.2 Number.isFinite ( number )
  define(
    Number, 'isFinite',
    function isFinite(number) {
      if (Type(number) !== 'number') return false;
      if (number !== number || number === +Infinity || number === -Infinity) return false;
      return true;
    });

  // 20.1.2.3 Number.isInteger ( number )
  define(
    Number, 'isInteger',
    function isInteger(number) {
      if (Type(number) !== 'number') return false;
      if (number !== number || number === +Infinity || number === -Infinity) return false;
      var integer = ToInteger(number);
      if (integer !== number) return false;
      return true;
    });

  // 20.1.2.4 Number.isNaN ( number )
  define(
    Number, 'isNaN',
    function isNaN(number) {
      if (Type(number) !== 'number') return false;
      if (number !== number) return true;
      return false;
    });

  // 20.1.2.5 Number.isSafeInteger ( number )
  define(
    Number, 'isSafeInteger',
    function isSafeInteger(number) {
      if (Type(number) !== 'number') return false;
      if (number !== number || number === +Infinity || number === -Infinity) return false;
      var integer = ToInteger(number);
      if (integer !== number) return false;
      if (abs(integer) <= (0x20000000000000 - 1)) // 2^53-1
        return true;
      return false;
    });

  // 20.1.2.6 Number.MAX_SAFE_INTEGER
  define(
    Number, 'MAX_SAFE_INTEGER',
    9007199254740991); // 2^53-1

  // 20.1.2.7 Number.MAX_VALUE

  // 20.1.2.8 Number.MIN_SAFE_INTEGER
  define(
    Number, 'MIN_SAFE_INTEGER',
    -9007199254740991); // -2^53+1

  // 20.1.2.9 Number.MIN_VALUE
  // 20.1.2.10 Number.NaN
  // 20.1.2.11 Number.NEGATIVE_INFINITY

  // 20.1.2.12 Number.parseFloat ( string )
  define(Number, 'parseFloat', $parseFloat);

  // 20.1.2.13 Number.parseInt ( string, radix )
  define(Number, 'parseInt', $parseInt);

  // 20.1.2.14 Number.POSITIVE_INFINITY
  // 20.1.2.15 Number.prototype

  // 20.1.3 Properties of the Number Prototype Object
  // 20.1.3.1 Number.prototype.constructor
  // 20.1.3.2 Number.prototype.toExponential ( fractionDigits )
  // 20.1.3.3 Number.prototype.toFixed ( fractionDigits )
  // 20.1.3.4 Number.prototype.toLocaleString( [ reserved1 [ , reserved2 ] ])
  // 20.1.3.5 Number.prototype.toPrecision ( precision )
  // 20.1.3.6 Number.prototype.toString ( [ radix ] )
  // 20.1.3.7 Number.prototype.valueOf ( )
  // 20.1.4 Properties of Number Instances

  // ---------------------------------------
  // 20.2 The Math Object
  // ---------------------------------------

  // 20.2.1 Value Properties of the Math Object
  // 20.2.1.1 Math.E
  // 20.2.1.2 Math.LN10
  // 20.2.1.3 Math.LN2
  // 20.2.1.4 Math.LOG10E
  // 20.2.1.5 Math.LOG2E
  // 20.2.1.6 Math.PI
  // 20.2.1.7 Math.SQRT1_2
  // 20.2.1.8 Math.SQRT2

  // 20.2.1.9 Math [ @@toStringTag ]
  define(Math, $$toStringTag, 'Math');

  // 20.2.2 Function Properties of the Math Object
  // 20.2.2.1 Math.abs ( x )
  // 20.2.2.2 Math.acos ( x )

  // 20.2.2.3 Math.acosh(x)
  define(
    Math, 'acosh',
    function acosh(x) {
      x = Number(x);
      return log(x + sqrt(x * x - 1));
    });

  // 20.2.2.4 Math.asin ( x )

  // 20.2.2.5 Math.asinh( x )
  define(
    Math, 'asinh',
    function asinh(x) {
      x = Number(x);
      if (SameValue(x, -0)) {
        return x;
      }
      var s = sqrt(x * x + 1);
      return (s === -x) ? log(0) : log(x + s);
    });

  // 20.2.2.6 Math.atan ( x )

  // 20.2.2.7 Math.atanh( x )
  define(
    Math, 'atanh',
    function atanh(x) {
      x = Number(x);
      return (x === 0) ? x : log((1 + x) / (1 - x)) / 2;
    });

  // 20.2.2.8 Math.atan2 ( y, x )

  // 20.2.2.9 Math.cbrt ( x )
  define(
    Math, 'cbrt',
    function cbrt(x) {
      x = Number(x);
      if ($isNaN(x/x)) {
        return x;
      }
      var r = pow(abs(x), 1/3);
      var t = x/r/r;
      return r + (r * (t-r) / (2*r + t));
    });

  // 20.2.2.10 Math.ceil ( x )

  // 20.2.2.11 Math.clz32 ( x )
  define(
    Math, 'clz32',
    function clz32(x) {
      function clz8(x) {
        return (x & 0xf0) ? (x & 0x80 ? 0 : x & 0x40 ? 1 : x & 0x20 ? 2 : 3) :
        (x & 0x08 ? 4 : x & 0x04 ? 5 : x & 0x02 ? 6 : x & 0x01 ? 7 : 8);
      }
      x = ToUint32(x);
      return x & 0xff000000 ? clz8(x >> 24) :
        x & 0xff0000 ? clz8(x >> 16) + 8 :
        x & 0xff00 ? clz8(x >> 8) + 16 : clz8(x) + 24;
    });



  // 20.2.2.12 Math.cos ( x )

  // 20.2.2.13 Math.cosh ( x )
  define(
    Math, 'cosh',
    function cosh(x) {
      x = Number(x);
      return (pow(E, x) + pow(E, -x)) / 2;
    });

  // 20.2.2.14 Math.exp ( x )

  // 20.2.2.15 Math.expm1 ( x )
  define(
    Math, 'expm1',
    function expm1(x) {
      x = Number(x);
      // from: http://www.johndcook.com/cpp_log1p.html
      if (SameValue(x, -0)) {
        return -0;
      } else if (abs(x) < 1e-5) {
        return x + 0.5 * x * x; // two terms of Taylor expansion
      } else {
        return exp(x) - 1;
      }
    });

  // 20.2.2.16 Math.floor ( x )

  // 20.2.2.17 Math.fround ( x )
  define(
    Math, 'fround',
    function fround(x) {
      if ($isNaN(x)) {
        return NaN;
      }
      if (1/x === +Infinity || 1/x === -Infinity || x === +Infinity || x === -Infinity) {
        return x;
      }
      return (new Float32Array([x]))[0];
    });

  // 20.2.2.18 Math.hypot ( value1 [, value2 [ ... ] ] )
  define(
    Math, 'hypot',
    function hypot() {
      var values = [];
      var m = 0, sawNaN = false;
      for (var i = 0; i < arguments.length; ++i) {
        var n = abs(Number(arguments[i]));
        if (n === Infinity) return n;
        if (n !== n) sawNaN = true;
        if (n > m) m = n;
        values[i] = n;
      }
      if (sawNaN) return NaN;
      if (m === 0) return +0;
      var sum = +0;
      for (i = 0; i < values.length; ++i) {
        var r = values[i] / m;
        sum = sum + r * r;
      }
      return m * sqrt(sum);
    });

  // 20.2.2.19 Math.imul ( x, y )
  define(
    Math, 'imul',
    function imul(x, y) {
      var a = ToUint32(x);
      var b = ToUint32(y);
      // (slow but accurate)
      var ah  = (a >>> 16) & 0xffff;
      var al = a & 0xffff;
      var bh  = (b >>> 16) & 0xffff;
      var bl = b & 0xffff;
      return ((al * bl) + (((ah * bl + al * bh) << 16) >>> 0)|0);
    }, ('imul' in Math && Math.imul(1, 0x80000000) === 0) // Safari 7 bug
  );

  // 20.2.2.20 Math.log ( x )

  // 20.2.2.21 Math.log1p ( x )
  define(
    Math, 'log1p',
    function log1p(x) {
      x = Number(x);
      // from: http://www.johndcook.com/cpp_expm1.html
      if (x < -1) {
        return NaN;
      } else if (SameValue(x, -0)) {
        return -0;
      } else if (abs(x) > 1e-4) {
        return log(1 + x);
      } else {
        return (-0.5 * x + 1) * x;
      }
    });

  // 20.2.2.22 Math.log10 ( x )
  define(
    Math, 'log10',
    function log10(x) {
      x = Number(x);
      return log(x) * LOG10E;
    });

  // 20.2.2.23 Math.log2 ( x )
  define(
    Math, 'log2',
    function log2(x) {
      x = Number(x);
      return log(x) * LOG2E;
    });

  // 20.2.2.24 Math.max ( value1, value2 , ...values )
  // 20.2.2.25 Math.min ( value1, value2 , ...values )
  // 20.2.2.26 Math.pow ( x, y )
  // 20.2.2.27 Math.random ( )
  // 20.2.2.28 Math.round ( x )

  // 20.2.2.29 Math.sign(x)
  define(
    Math, 'sign',
    function sign(x) {
      x = Number(x);
      return x < 0 ? -1 : x > 0 ? 1 : x;
    });

  // 20.2.2.30 Math.sin ( x )

  // 20.2.2.31 Math.sinh( x )
  define(
    Math, 'sinh',
    function sinh(x) {
      x = Number(x);
      return SameValue(x, -0) ? x : (pow(E, x) - pow(E, -x)) / 2;
    });

  // 20.2.2.32 Math.sqrt ( x )
  // 20.2.2.33 Math.tan ( x )

  // 20.2.2.34 Math.tanh ( x )
  define(
    Math, 'tanh',
    function tanh(x) {
      x = Number(x);
      var n = pow(E, 2 * x) - 1,
          d = pow(E, 2 * x) + 1;
      if (SameValue(x, -0))
        return x;
      return (n === d) ? 1 : n / d; // Handle Infinity/Infinity
    });

  // 20.2.2.35 Math.trunc ( x )
  define(
    Math, 'trunc',
    function trunc(x) {
      x = Number(x);
      return $isNaN(x) ? NaN :
        x < 0 ? ceil(x) : floor(x);
    });

  // ---------------------------------------
  // 20.3 Date Objects
  // ---------------------------------------

  // 20.3.1 Overview of Date Objects and Definitions of Abstract Operations
  // 20.3.1.1 Time Values and Time Range
  // 20.3.1.2 Day Number and Time within Day
  // 20.3.1.3 Year Number
  // 20.3.1.4 Month Number
  // 20.3.1.5 Date Number
  // 20.3.1.6 Week Day
  // 20.3.1.7 Local Time Zone Adjustment
  // 20.3.1.8 Daylight Saving Time Adjustment
  // 20.3.1.9 Local Time
  // 20.3.1.10 Hours, Minutes, Second, and Milliseconds
  // 20.3.1.11 MakeTime (hour, min, sec, ms)
  // 20.3.1.12 MakeDay (year, month, date)
  // 20.3.1.13 MakeDate (day, time)
  // 20.3.1.14 TimeClip (time)
  // 20.3.1.15 Date Time String Format
  // 20.3.1.15.1 Extended years
  // 20.3.2 The Date Constructor
  // 20.3.2.1 Date ( year, month [, date [ , hours [ , minutes [ , seconds [ , ms ] ] ] ] ] )
  // 20.3.2.2 Date ( value )
  // 20.3.2.3 Date ( )
  // 20.3.3 Properties of the Date Constructor
  // 20.3.3.1 Date.now ( )
  // 20.3.3.2 Date.parse (string)
  // 20.3.3.3 Date.prototype
  // 20.3.3.4 Date.UTC ( year, month [ , date [ , hours [ , minutes [ , seconds [ , ms ] ] ] ] ] )
  // 20.3.4 Properties of the Date Prototype Object
  // 20.3.4.1 Date.prototype.constructor
  // 20.3.4.2 Date.prototype.getDate ( )
  // 20.3.4.3 Date.prototype.getDay ( )
  // 20.3.4.4 Date.prototype.getFullYear ( )
  // 20.3.4.5 Date.prototype.getHours ( )
  // 20.3.4.6 Date.prototype.getMilliseconds ( )
  // 20.3.4.7 Date.prototype.getMinutes ( )
  // 20.3.4.8 Date.prototype.getMonth ( )
  // 20.3.4.9 Date.prototype.getSeconds ( )
  // 20.3.4.10 Date.prototype.getTime ( )
  // 20.3.4.11 Date.prototype.getTimezoneOffset ( )
  // 20.3.4.12 Date.prototype.getUTCDate ( )
  // 20.3.4.13 Date.prototype.getUTCDay ( )
  // 20.3.4.14 Date.prototype.getUTCFullYear ( )
  // 20.3.4.15 Date.prototype.getUTCHours ( )
  // 20.3.4.16 Date.prototype.getUTCMilliseconds ( )
  // 20.3.4.17 Date.prototype.getUTCMinutes ( )
  // 20.3.4.18 Date.prototype.getUTCMonth ( )
  // 20.3.4.19 Date.prototype.getUTCSeconds ( )
  // 20.3.4.20 Date.prototype.setDate ( date )
  // 20.3.4.21 Date.prototype.setFullYear ( year [ , month [ , date ] ] )
  // 20.3.4.22 Date.prototype.setHours ( hour [ , min [ , sec [ , ms ] ] ] )
  // 20.3.4.23 Date.prototype.setMilliseconds ( ms )
  // 20.3.4.24 Date.prototype.setMinutes ( min [ , sec [ , ms ] ] )
  // 20.3.4.25 Date.prototype.setMonth ( month [ , date ] )
  // 20.3.4.26 Date.prototype.setSeconds ( sec [ , ms ] )
  // 20.3.4.27 Date.prototype.setTime ( time )
  // 20.3.4.28 Date.prototype.setUTCDate ( date )
  // 20.3.4.29 Date.prototype.setUTCFullYear ( year [ , month [ , date ] ] )
  // 20.3.4.30 Date.prototype.setUTCHours ( hour [ , min [ , sec [ , ms ] ] ] )
  // 20.3.4.31 Date.prototype.setUTCMilliseconds ( ms )
  // 20.3.4.32 Date.prototype.setUTCMinutes ( min [ , sec [, ms ] ] )
  // 20.3.4.33 Date.prototype.setUTCMonth ( month [ , date ] )
  // 20.3.4.34 Date.prototype.setUTCSeconds ( sec [ , ms ] )
  // 20.3.4.35 Date.prototype.toDateString ( )
  // 20.3.4.36 Date.prototype.toISOString ( )
  // 20.3.4.37 Date.prototype.toJSON ( key )
  // 20.3.4.38 Date.prototype.toLocaleDateString ( [ reserved1 [ , reserved2 ] ] )
  // 20.3.4.39 Date.prototype.toLocaleString ( [ reserved1 [ , reserved2 ] ] )
  // 20.3.4.40 Date.prototype.toLocaleTimeString ( [ reserved1 [ , reserved2 ] ] )
  // 20.3.4.41 Date.prototype.toString ( )
  // 20.3.4.42 Date.prototype.toTimeString ( )
  // 20.3.4.43 Date.prototype.toUTCString ( )
  // 20.3.4.44 Date.prototype.valueOf ( )
  // 20.3.4.45 Date.prototype [ @@toPrimitive ] ( hint )
  // 20.3.5 Properties of Date Instances

  // (No polyfillable changes from ES5)

  // ---------------------------------------
  // 21 Text Processing
  // ---------------------------------------

  var string_regexp_dispatch = (function() {
    var faux = {}, secret = Symbol();
    faux[Symbol.match] = function() { return secret; };
    return ("").match(faux) === secret;
  }());

  // 21.1 String Objects
  // 21.1.1 The String Constructor
  // 21.1.1.1 String ( value )
  // 21.1.2 Properties of the String Constructor
  // 21.1.2.1 String.fromCharCode ( ...codeUnits )

  // 21.1.2.2 String.fromCodePoint ( ...codePoints )
  define(
    String, 'fromCodePoint',
    function fromCodePoint(/*...codePoints*/) {
      var codePoints = arguments,
          length = codePoints.length,
          elements = [],
          nextIndex = 0;
      while (nextIndex < length) {
        var next = codePoints[nextIndex];
        var nextCP = Number(next);
        if (!SameValue(nextCP, ToInteger(nextCP)) ||
            nextCP < 0 || nextCP > 0x10FFFF) {
          throw RangeError('Invalid code point ' + nextCP);
        }
        if (nextCP < 0x10000) {
          elements.push(String.fromCharCode(nextCP));
        } else {
          nextCP -= 0x10000;
          elements.push(String.fromCharCode((nextCP >> 10) + 0xD800));
          elements.push(String.fromCharCode((nextCP % 0x400) + 0xDC00));
        }
        nextIndex += 1;
      }
      return elements.join('');
    });

  // 21.1.2.3 String.prototype

  // 21.1.2.4 String.raw ( template , ...substitutions )
  define(
    String, 'raw',
    function raw(template /*, ...substitutions*/) {
      var substitutions = [].slice.call(arguments, 1);

      var cooked = Object(template);
      var rawValue = cooked['raw'];
      var raw = Object(rawValue);
      var len = raw['length'];
      var literalSegments = ToLength(len);
      if (literalSegments <= 0) return '';
      var stringElements = [];
      var nextIndex = 0;
      while (true) {
        var next = raw[nextIndex];
        var nextSeg = String(next);
        stringElements.push(nextSeg);
        if (nextIndex + 1 === literalSegments)
          return stringElements.join('');
        next = substitutions[nextIndex];
        var nextSub = String(next);
        stringElements.push(nextSub);
        nextIndex = nextIndex + 1;
      }
    });

  // See https://githib.com/inexorabletash/uate for a more useful version.

  // 21.1.3 Properties of the String Prototype Object
  // 21.1.3.1 String.prototype.charAt ( pos )
  // 21.1.3.2 String.prototype.charCodeAt ( pos )

  // 21.1.3.3 String.prototype.codePointAt ( pos )
  define(
    String.prototype, 'codePointAt',
    function codePointAt(pos) {
      var o = strict(this);
      var s = String(o);
      var position = ToInteger(pos);
      var size = s.length;
      if (position < 0 || position >= size) return undefined;
      var first = s.charCodeAt(position);
      if (first < 0xD800 || first > 0xDBFF || position + 1 === size) return first;
      var second = s.charCodeAt(position + 1);
      if (second < 0xDC00 || second > 0xDFFF) return first;
      return ((first - 0xD800) * 1024) + (second - 0xDC00) + 0x10000;
    });

  // 21.1.3.4 String.prototype.concat ( ...args )
  // 21.1.3.5 String.prototype.constructor

  // 21.1.3.6 String.prototype.endsWith ( searchString [ , endPosition] )
  define(
    String.prototype, 'endsWith',
    function endsWith(searchString) {
      var endPosition = arguments[1];

      var o = strict(this);
      var s = String(o);
      var searchStr = String(searchString);
      var len = s.length;
      var pos = (endPosition === undefined) ? len : ToInteger(endPosition);
      var end = min(max(pos, 0), len);
      var searchLength = searchStr.length;
      var start = end - searchLength;
      if (start < 0) return false;
      if (s.substring(start, start + searchLength) === searchStr) return true;
      return false;
    });

  // 21.1.3.7 String.prototype.includes ( searchString [ , position ] )
  define(
    String.prototype, 'includes',
    function includes(searchString) {
      var position = arguments[1];

      var o = strict(this);
      var s = String(o);
      var searchStr = String(searchString);
      var pos = ToInteger(position);
      var len = s.length;
      var start = min(max(pos, 0), len);
      return s.indexOf(searchStr, start) !== -1;
    });

  // 21.1.3.8 String.prototype.indexOf ( searchString [ , position ] )
  // 21.1.3.9 String.prototype.lastIndexOf ( searchString [ , position ] )
  // 21.1.3.10 String.prototype.localeCompare ( that [, reserved1 [ , reserved2 ] ] )
  // 21.1.3.11 String.prototype.match ( regexp )
  define(
    String.prototype, 'match',
    function match(regexp) {
      var o = strict(this);
      var s = String(o);
      if (HasProperty(regexp, $$match)) var rx = regexp;
      else rx = new RegExp(regexp);
      return rx[$$match](s);
    }, !string_regexp_dispatch);

  // 21.1.3.12 String.prototype.normalize ( [ form ] )

  // Not practical due to table sizes; if needed, pull in:
  // https://github.com/walling/unorm/

  // 21.1.3.13 String.prototype.repeat ( count )
  define(
    String.prototype, 'repeat',
    function repeat(count) {
      var o = strict(this);
      var s = String(o);
      var n = ToInteger(count);
      if (n < 0) throw RangeError();
      if (n === Infinity) throw RangeError();
      var t = new Array(n + 1).join(s);
      return t;
    });

  // 21.1.3.14 String.prototype.replace (searchValue, replaceValue )
  define(
    String.prototype, 'replace',
    function replace(searchValue, replaceValue) {
      var o = strict(this);
      if (HasProperty(searchValue, $$replace))
        return searchValue[$$replace](o, replaceValue);
      return orig_replace.call(o, searchValue, replaceValue);
    }, !string_regexp_dispatch);

  // 21.1.3.15 String.prototype.search ( regexp )
  define(
    String.prototype, 'search',
    function search(regexp) {
      var o = strict(this);
      var string = String(o);
      if (HasProperty(regexp, $$search)) var rx = regexp;
      else rx = new RegExp(regexp);
      return rx[$$search](string);
    }, !string_regexp_dispatch);

  // 21.1.3.16 String.prototype.slice ( start, end )
  // 21.1.3.17 String.prototype.split ( separator, limit )
  define(
    String.prototype, 'split',
    function split(separator, limit) {
      var o = strict(this);
      if (HasProperty(separator, $$split))
        return separator[$$split](o, limit);
      return orig_split.call(o, separator, limit);
    }, !string_regexp_dispatch);

  // 21.1.3.18 String.prototype.startsWith ( searchString [, position ] )
  define(
    String.prototype, 'startsWith',
    function startsWith(searchString) {
      var position = arguments[1];

      var o = strict(this);
      var s = String(o);
      var searchStr = String(searchString);
      var pos = ToInteger(position);
      var len = s.length;
      var start = min(max(pos, 0), len);
      var searchLength = searchStr.length;
      if (searchLength + start > len) return false;
      if (s.substring(start, start + searchLength) === searchStr) return true;
      return false;
    });

  // 21.1.3.19 String.prototype.substring ( start, end )
  // 21.1.3.20 String.prototype.toLocaleLowerCase ( [ reserved1 [ , reserved2 ] ] )
  // 21.1.3.21 String.prototype.toLocaleUpperCase ([ reserved1 [ , reserved2 ] ] )
  // 21.1.3.22 String.prototype.toLowerCase ( )
  // 21.1.3.23 String.prototype.toString ( )
  // 21.1.3.24 String.prototype.toUpperCase ( )
  // 21.1.3.25 String.prototype.trim ( )
  // 21.1.3.26 String.prototype.valueOf ( )

  // 21.1.3.27 String.prototype [ @@iterator ]( )
  define(
    String.prototype, $$iterator,
    function entries() {
      return CreateStringIterator(this, 'value');
    });

  // 21.1.4 Properties of String Instances
  // 21.1.4.1 length

  // 21.1.5 String Iterator Objects
  /** @constructor */
  function StringIterator() {}

  // 21.1.5.1 CreateStringIterator Abstract Operation
  function CreateStringIterator(string, kind) {
    var s = String(string);
    var iterator = new StringIterator;
    set_internal(iterator, '[[IteratedString]]', s);
    set_internal(iterator, '[[StringIteratorNextIndex]]', 0);
    set_internal(iterator, '[[StringIterationKind]]', kind);
    return iterator;
  }

  // 21.1.5.2 The %StringIteratorPrototype% Object
  var $StringIteratorPrototype$ = Object.create($IteratorPrototype$);
  StringIterator.prototype = $StringIteratorPrototype$;

  // 21.1.5.2.1 %StringIteratorPrototype%.next ( )
  define(
    $StringIteratorPrototype$, 'next',
    function next() {
      var o = ToObject(this);
      var s = String(o['[[IteratedString]]']),
          index = o['[[StringIteratorNextIndex]]'],
          len = s.length;
      if (index >= len) {
        set_internal(o, '[[StringIteratorNextIndex]]', Infinity);
        return CreateIterResultObject(undefined, true);
      }
      var cp = s.codePointAt(index);
      set_internal(o, '[[StringIteratorNextIndex]]', index + (cp > 0xFFFF ? 2 : 1));
      return CreateIterResultObject(String.fromCodePoint(cp), false);
    });

  // 21.1.5.2.2 %StringIteratorPrototype% [ @@toStringTag ]
  define($StringIteratorPrototype$, $$toStringTag, 'String Iterator');

  // 21.1.5.3 Properties of String Iterator Instances

  // ---------------------------------------
  // 21.2 RegExp (Regular Expression) Objects
  // ---------------------------------------

  // 21.2.1 Patterns
  // 21.2.2 Pattern Semantics
  // 21.2.2.1 Notation
  // 21.2.2.2 Pattern
  // 21.2.2.3 Disjunction
  // 21.2.2.4 Alternative
  // 21.2.2.5 Term
  // 21.2.2.6 Assertion
  // 21.2.2.7 Quantifier
  // 21.2.2.8 Atom
  // 21.2.2.9 AtomEscape
  // 21.2.2.10 CharacterEscape
  // 21.2.2.11 DecimalEscape
  // 21.2.2.12 CharacterClassEscape
  // 21.2.2.13 CharacterClass
  // 21.2.2.14 ClassRanges
  // 21.2.2.15 NonemptyClassRanges
  // 21.2.2.16 NonemptyClassRangesNoDash
  // 21.2.2.17 ClassAtom
  // 21.2.2.18 ClassAtomNoDash
  // 21.2.2.19 ClassEscape
  // 21.2.3 The RegExp Constructor
  // 21.2.3.1 RegExp ( pattern, flags )
  // 21.2.3.2 new RegExp( ...argumentsList )
  // 21.2.3.3 Abstract Operations for the RegExp Constructor
  // 21.2.4 Properties of the RegExp Constructor
  // 21.2.4.1 RegExp.prototype
  // 21.2.5 Properties of the RegExp Prototype Object
  // 21.2.5.1 RegExp.prototype.constructor
  // 21.2.5.2 RegExp.prototype.exec ( string )

  // 21.2.5.3 get RegExp.prototype.flags
  if (!('flags' in RegExp.prototype)) {
    Object.defineProperty(
      RegExp.prototype, 'flags', {
        get: function() {
          var s = String(this);
          return s.substring(s.lastIndexOf('/') + 1);
        }
      });
  }

  // 21.2.5.4 get RegExp.prototype.global
  // 21.2.5.5 get RegExp.prototype.ignoreCase

  // 21.2.5.6 RegExp.prototype [ @@match ] ( string )
  define(RegExp.prototype, $$match, function(string) {
    var o = strict(this);
    return orig_match.call(string, o);
  });

  // 21.2.5.7 get RegExp.prototype.multiline

  // 21.2.5.8 RegExp.prototype [ @@replace ] ( string, replaceValue )
  define(RegExp.prototype, $$replace, function(string, replaceValue) {
    var o = strict(this);
    return orig_replace.call(string, o, replaceValue);
  });

  // 21.2.5.9 RegExp.prototype [ @@search ] ( string )
  define(RegExp.prototype, $$search, function(string) {
    var o = strict(this);
    return orig_search.call(string, o);
  });

  // 21.2.5.10 get RegExp.prototype.source

  // 21.2.5.11 RegExp.prototype [ @@split ] ( string, limit )
  define(RegExp.prototype, $$split, function(string, limit) {
    var o = strict(this);
    return orig_split.call(string, o, limit);
  });

  // 21.2.5.12 get RegExp.prototype.sticky
  // 21.2.5.13 RegExp.prototype.test( S )
  // 21.2.5.14 RegExp.prototype.toString ( )
  // 21.2.5.15 get RegExp.prototype.unicode

  // 21.2.6 Properties of RegExp Instances
  // 21.2.6.1 lastIndex

  // (No polyfillable changes from ES5)

  // ---------------------------------------
  // 22 Indexed Collections
  // ---------------------------------------

  // ---------------------------------------
  // 22.1 Array Objects
  // ---------------------------------------

  // 22.1.1 The Array Constructor
  // 22.1.1.1 Array ( )
  // 22.1.1.2 Array (len)
  // 22.1.1.3 Array (...items )

  // 22.1.2 Properties of the Array Constructor

  // 22.1.2.1 Array.from ( items [ , mapfn [ , thisArg ] ] )
  define(
    Array, 'from',
    function from(items) {
      var mapfn = arguments[1];
      var thisArg = arguments[2];

      var c = strict(this);
      if (mapfn === undefined) {
        var mapping = false;
      } else {
        if (!IsCallable(mapfn)) throw TypeError();
        var t = thisArg;
        mapping = true;
      }
      var usingIterator = GetMethod(items, $$iterator);
      if (usingIterator !== undefined) {
         if (IsConstructor(c)) {
          var a = new c();
        } else {
          a = new Array(0);
        }
        var iterator = GetIterator(items, usingIterator);
        var k = 0;
        while (true) {
          var next = IteratorStep(iterator);
          if (next === false) {
            a.length = k;
            return a;
          }
          var nextValue = IteratorValue(next);
          if (mapping)
            var mappedValue = mapfn.call(t, nextValue);
          else
            mappedValue = nextValue;
          a[k] = mappedValue;
          k += 1;
        }
      }
      var arrayLike = ToObject(items);
      var lenValue = arrayLike.length;
      var len = ToLength(lenValue);
      if (IsConstructor(c)) {
        a = new c(len);
      } else {
        a = new Array(len);
      }
      k = 0;
      while (k < len) {
        var kValue = arrayLike[k];
        if (mapping)
          mappedValue = mapfn.call(t, kValue, k);
        else
          mappedValue = kValue;
        a[k] = mappedValue;
        k += 1;
      }
      a.length = len;
      return a;
    });

  // 22.1.2.2 Array.isArray ( arg )

  // 22.1.2.3 Array.of ( ...items )
  define(
    Array, 'of',
    function of() {
      var items = arguments;

      var lenValue = items.length;
      var len = ToUint32(lenValue);
      var c = strict(this), a;
      if (IsConstructor(c)) {
        a = new c(len);
        a = ToObject(a);
      } else {
        a = new Array(len);
      }
      var k = 0;
      while (k < len) {
        a[k] = items[k];
        k += 1;
      }
      a.length = len;
      return a;
    });

  // 22.1.2.4 Array.prototype
  // 22.1.2.5 get Array [ @@species ]
  // 22.1.3 Properties of the Array Prototype Object
  // 22.1.3.1 Array.prototype.concat ( ...arguments )
  // 22.1.3.1.1 Runtime Semantics: IsConcatSpreadable ( O )
  // 22.1.3.2 Array.prototype.constructor
  // 22.1.3.3 Array.prototype.copyWithin (target, start [ , end ] )
  define(
    Array.prototype, 'copyWithin',
    function copyWithin(target, start/*, end*/) {
      var end = arguments[2];

      var o = ToObject(this);
      var lenVal = o.length;
      var len = ToLength(lenVal);
      len = max(len, 0);
      var relativeTarget = ToInteger(target);
      var to;
      if (relativeTarget < 0)
        to = max(len + relativeTarget, 0);
      else
        to = min(relativeTarget, len);
      var relativeStart = ToInteger(start);
      var from;
      if (relativeStart < 0)
        from = max(len + relativeStart, 0);
      else
        from = min(relativeStart, len);
      var relativeEnd;
      if (end === undefined)
        relativeEnd = len;
      else
        relativeEnd = ToInteger(end);
      var final;
      if (relativeEnd < 0)
        final = max(len + relativeEnd, 0);
      else
        final = min(relativeEnd, len);
      var count = min(final - from, len - to);
      var direction;
      if (from < to && to < from + count) {
        direction = -1;
        from = from + count - 1;
        to = to + count - 1;
      } else {
        direction = 1;
      }
      while (count > 0) {
        var fromKey = String(from);
        var toKey = String(to);
        var fromPresent = HasProperty(o, fromKey);
        if (fromPresent) {
          var fromVal = o[fromKey];
          o[toKey] = fromVal;
        } else {
          delete o[toKey];
        }
        from = from + direction;
        to = to + direction;
        count = count - 1;
      }
      return o;
    });

  // 22.1.3.4 Array.prototype.entries ( )
  var nativeArrayIteratorMethods =
        ('entries' in Array.prototype && 'next' in [].entries());

  define(
    Array.prototype, 'entries',
    function entries() {
      return CreateArrayIterator(this, 'key+value');
    }, !nativeArrayIteratorMethods);

  // 22.1.3.5 Array.prototype.every ( callbackfn [ , thisArg] )

  // 22.1.3.6 Array.prototype.fill (value [ , start [ , end ] ] )
  define(
    Array.prototype, 'fill',
    function fill(value/*, start, end*/) {
      var start = arguments[1],
          end = arguments[2];

      var o = ToObject(this);
      var lenVal = o.length;
      var len = ToLength(lenVal);
      len = max(len, 0);
      var relativeStart = ToInteger(start);
      var k;
      if (relativeStart < 0)
        k = max((len + relativeStart), 0);
      else
        k = min(relativeStart, len);
      var relativeEnd;
      if (end === undefined)
        relativeEnd = len;
      else
        relativeEnd = ToInteger(end);
      var final;
      if (relativeEnd < 0)
        final = max((len + relativeEnd), 0);
      else
        final = min(relativeEnd, len);
      while (k < final) {
        var pk = String(k);
        o[pk] = value;
        k += 1;
      }
      return o;
    });

  // 22.1.3.7 Array.prototype.filter ( callbackfn [ , thisArg ] )

  // 22.1.3.8 Array.prototype.find ( predicate [ , thisArg ] )
  define(
    Array.prototype, 'find',
    function find(predicate) {
      var o = ToObject(this);
      var lenValue = o.length;
      var len = ToInteger(lenValue);
      if (!IsCallable(predicate)) throw TypeError();
      var t = arguments.length > 1 ? arguments[1] : undefined;
      var k = 0;
      while (k < len) {
        var pk = String(k);
        var kPresent = HasProperty(o, pk);
        if (kPresent) {
          var kValue = o[pk];
          var testResult = predicate.call(t, kValue, k, o);
          if (Boolean(testResult)) {
            return kValue;
          }
        }
        ++k;
      }
      return undefined;
    });

  // 22.1.3.9 Array.prototype.findIndex ( predicate [ , thisArg ] )
  define(
    Array.prototype, 'findIndex',
    function findIndex(predicate) {
      var o = ToObject(this);
      var lenValue = o.length;
      var len = ToLength(lenValue);
      if (!IsCallable(predicate)) throw TypeError();
      var t = arguments.length > 1 ? arguments[1] : undefined;
      var k = 0;
      while (k < len) {
        var pk = String(k);
        var kPresent = HasProperty(o, pk);
        if (kPresent) {
          var kValue = o[pk];
          var testResult = predicate.call(t, kValue, k, o);
          if (Boolean(testResult)) {
            return k;
          }
        }
        ++k;
      }
      return -1;
    });

  // 22.1.3.10 Array.prototype.forEach ( callbackfn [ , thisArg ] )
  // 22.1.3.11 Array.prototype.indexOf ( searchElement [ , fromIndex ] )
  // 22.1.3.12 Array.prototype.join (separator)

  // 22.1.3.13 Array.prototype.keys ( )
  define(
    Array.prototype, 'keys',
    function keys() {
      return CreateArrayIterator(this, 'key');
    }, !nativeArrayIteratorMethods);

  // 22.1.3.14 Array.prototype.lastIndexOf ( searchElement [ , fromIndex ] )
  // 22.1.3.15 Array.prototype.map ( callbackfn [ , thisArg ] )
  // 22.1.3.16 Array.prototype.pop ( )
  // 22.1.3.17 Array.prototype.push ( ...items )
  // 22.1.3.18 Array.prototype.reduce ( callbackfn [ , initialValue ] )
  // 22.1.3.19 Array.prototype.reduceRight ( callbackfn [ , initialValue ] )
  // 22.1.3.20 Array.prototype.reverse ( )
  // 22.1.3.21 Array.prototype.shift ( )
  // 22.1.3.22 Array.prototype.slice (start, end)
  // 22.1.3.23 Array.prototype.some ( callbackfn [ , thisArg ] )
  // 22.1.3.24 Array.prototype.sort (comparefn)
  // 22.1.3.25 Array.prototype.splice (start, deleteCount , ...items )
  // 22.1.3.26 Array.prototype.toLocaleString ( [ reserved1 [ , reserved2 ] ] )
  // 22.1.3.27 Array.prototype.toString ( )
  // 22.1.3.28 Array.prototype.unshift ( ...items )

  // 22.1.3.29 Array.prototype.values ( )
  define(
    Array.prototype, 'values',
    function values() {
      return CreateArrayIterator(this, 'value');
    }, !nativeArrayIteratorMethods);

  // 22.1.3.30 Array.prototype [ @@iterator ] ( )
  define(
    Array.prototype, $$iterator,
    Array.prototype.values
    );

  // 22.1.3.31 Array.prototype [ @@unscopables ]
  // 22.1.4 Properties of Array Instances
  // 22.1.4.1 length

  // 22.1.5 Array Iterator Objects
  function ArrayIterator() {}

  // 22.1.5.1 CreateArrayIterator Abstract Operation
  function CreateArrayIterator(array, kind) {
    var o = ToObject(array);
    var iterator = new ArrayIterator;
    set_internal(iterator, '[[IteratedObject]]', o);
    set_internal(iterator, '[[ArrayIteratorNextIndex]]', 0);
    set_internal(iterator, '[[ArrayIterationKind]]', kind);
    return iterator;
  }

  // 22.1.5.2 The %ArrayIteratorPrototype% Object
  var $ArrayIteratorPrototype$ = Object.create($IteratorPrototype$);
  ArrayIterator.prototype = $ArrayIteratorPrototype$;

  // 22.1.5.2.1 %ArrayIteratorPrototype%. next( )
  define(
    $ArrayIteratorPrototype$, 'next',
    function next() {
      var o = strict(this);
      if (Type(o) !== 'object') throw TypeError();
      var a = o['[[IteratedObject]]'],
          index = o['[[ArrayIteratorNextIndex]]'],
          itemKind = o['[[ArrayIterationKind]]'],
          lenValue = a.length,
          len = ToUint32(lenValue),
          elementKey,
          elementValue;
      if (itemKind.indexOf('sparse') !== -1) {
        var found = false;
        while (!found && index < len) {
          elementKey = String(index);
          found = HasProperty(a, elementKey);
          if (!found) {
            index += 1;
          }
        }
      }
      if (index >= len) {
        set_internal(o, '[[ArrayIteratorNextIndex]]', Infinity);
        return CreateIterResultObject(undefined, true);
      }
      elementKey = index;
      set_internal(o, '[[ArrayIteratorNextIndex]]', index + 1);
      if (itemKind.indexOf('value') !== -1)
        elementValue = a[elementKey];
      if (itemKind.indexOf('key+value') !== -1)
        return CreateIterResultObject([elementKey, elementValue], false);
      if (itemKind.indexOf('key') !== -1)
        return CreateIterResultObject(elementKey, false);
      if (itemKind === 'value')
        return CreateIterResultObject(elementValue, false);
      throw Error('Internal error');
    });

  // 22.1.5.2.2 %ArrayIteratorPrototype% [ @@toStringTag ]
  define($ArrayIteratorPrototype$, $$toStringTag, 'Array Iterator');

  // 22.1.5.3 Properties of Array Iterator Instances


  // ---------------------------------------
  // 22.2 TypedArray Objects
  // ---------------------------------------

  // See typedarray.js for TypedArray polyfill

  ['Int8Array', 'Uint8Array', 'Uint8ClampedArray',
   'Int16Array', 'Uint16Array',
   'Int32Array', 'Uint32Array',
   'Float32Array', 'Float64Array'].forEach(function ($TypedArrayName$) {
     if (!($TypedArrayName$ in global))
       return;
     var $TypedArray$ = global[$TypedArrayName$];

     // 22.2.1 The %TypedArray% Intrinsic Object
     // 22.2.1.1 %TypedArray% ( length )
     // 22.2.1.2 %TypedArray% ( typedArray )
     // 22.2.1.3 %TypedArray% ( object )
     // 22.2.1.4 %TypedArray% ( buffer [ , byteOffset [ , length ] ] )
     // 22.2.1.5 %TypedArray% ( all other argument combinations )
     // 22.2.2 Properties of the %TypedArray% Intrinsic Object

     // 22.2.2.1 %TypedArray%.from ( source [ , mapfn [ , thisArg ] ] )
     define(
       $TypedArray$, 'from',
       function from(source) {
         var mapfn = arguments[1];
         var thisArg = arguments[2];

         var c = strict(this);
         if (!IsConstructor(c)) throw TypeError();
         if (mapfn === undefined) {
           var mapping = false;
         } else {
           if (IsCallable(mapfn)) throw TypeError();
           var t = thisArg;
           mapping = true;
         }
         var usingIterator = GetMethod(source, $$iterator);
         if (usingIterator !== undefined) {
           var iterator = GetIterator(source, usingIterator);
           var values = [];
           var next = true;
           while (next !== false) {
             next = IteratorStep(iterator);
             if (next !== false) {
               var nextValue = IteratorValue(next);
               values.push(nextValue);
             }
           }
           var len = values.length;
           var newObj = new c(len);
           var k = 0;
           while (k < len) {
             var kValue = values.shift();
             if (mapping) {
               var mappedValue = mapfn.call(t, kValue);
             } else {
               mappedValue = kValue;
             }
             newObj[k] = mappedValue;
             ++k;
           }
           console.assert(values.length === 0);
           return newObj;
         }
         var arrayLike = ToObject(source);
         var lenValue = arrayLike.length;
         len = ToLength(lenValue);
         newObj = new c(len);
         k = 0;
         while (k < len) {
           kValue = arrayLike[k];
           if (mapping) {
             mappedValue = mapfn.call(t, kValue, k);
           } else {
             mappedValue = kValue;
           }
           newObj[k] = mappedValue;
           ++k;
         }
         return newObj;
       });

     // 22.2.2.2 %TypedArray%.of ( ...items )
     define(
       $TypedArray$, 'of',
       function of() {
         var items = arguments;

         var len = items.length;
         var c = strict(this);
         var newObj = new c(len);
         var k = 0;
         while (k < len) {
           newObj[k] = items[k];
           ++k;
         }
         return newObj;
       });

     // 22.2.2.3 %TypedArray%.prototype
     // 22.2.2.4 get %TypedArray% [ @@species ]
     // 22.2.3 Properties of the %TypedArrayPrototype% Object
     // 22.2.3.1 get %TypedArray%.prototype.buffer
     // 22.2.3.2 get %TypedArray%.prototype.byteLength
     // 22.2.3.3 get %TypedArray%.prototype.byteOffset
     // 22.2.3.4 %TypedArray%.prototype.constructor

     // 22.2.3.5 %TypedArray%.prototype.copyWithin (target, start [, end ] )
     define($TypedArray$.prototype, 'copyWithin', Array.prototype.copyWithin);

     // 22.2.3.6 %TypedArray%.prototype.entries ( )
     define($TypedArray$.prototype, 'entries', Array.prototype.entries);

     // 22.2.3.7 %TypedArray%.prototype.every ( callbackfn [ , thisArg ] )
     define($TypedArray$.prototype, 'every', Array.prototype.every);

     // 22.2.3.8 %TypedArray%.prototype.fill (value [ , start [ , end ] ] )
     define(
       $TypedArray$.prototype, 'fill',
       //Array.prototype.fill // Doesn't work in Safari 7
       function fill(value/*, start, end*/) {
         var start = arguments[1],
             end = arguments[2];

         var o = ToObject(this);
         var lenVal = o.length;
         var len = ToLength(lenVal);
         len = max(len, 0);
         var relativeStart = ToInteger(start);
         var k;
         if (relativeStart < 0) k = max((len + relativeStart), 0);
         else k = min(relativeStart, len);
         var relativeEnd;
         if (end === undefined) relativeEnd = len;
         else relativeEnd = ToInteger(end);
         var final;
         if (relativeEnd < 0) final = max((len + relativeEnd), 0);
         else final = min(relativeEnd, len);
         while (k < final) {
           var pk = String(k);
           o[pk] = value;
           k += 1;
         }
         return o;
       });

     // 22.2.3.9 %TypedArray%.prototype.filter ( callbackfn [ , thisArg ] )
     define(
       $TypedArray$.prototype, 'filter',
       function filter(callbackfn) {
         var thisArg = arguments[1];

         var o = ToObject(this);
         var lenVal = o.length;
         var len = ToLength(lenVal);
         if (!IsCallable(callbackfn)) throw TypeError();
         var t = thisArg;
         var c = o.constructor;
         var kept = [];
         var k = 0;
         var captured = 0;
         while (k < len) {
           var kValue = o[k];
           var selected = callbackfn.call(t, kValue, k, o);
           if (selected) {
             kept.push(kValue);
             ++captured;
           }
           ++k;
         }
         var a = new c(captured);
         var n = 0;
         for (var i = 0; i < kept.length; ++i) {
           var e = kept[i];
           a[n] = e;
           ++n;
         }
         return a;
       });

     // 22.2.3.10 %TypedArray%.prototype.find (predicate [ , thisArg ] )
     define($TypedArray$.prototype, 'find', Array.prototype.find);

     // 22.2.3.11 %TypedArray%.prototype.findIndex ( predicate [ , thisArg ] )
     define($TypedArray$.prototype, 'findIndex', Array.prototype.findIndex);

     // 22.2.3.12 %TypedArray%.prototype.forEach ( callbackfn [ , thisArg ] )
     define($TypedArray$.prototype, 'forEach', Array.prototype.forEach);

     // 22.2.3.13 %TypedArray%.prototype.indexOf (searchElement [ , fromIndex ] )
     define($TypedArray$.prototype, 'indexOf', Array.prototype.indexOf);

     // 22.2.3.14 %TypedArray%.prototype.join ( separator )
     define($TypedArray$.prototype, 'join', Array.prototype.join);

     // 22.2.3.15 %TypedArray%.prototype.keys ( )
     define($TypedArray$.prototype, 'keys', Array.prototype.keys);

     // 22.2.3.16 %TypedArray%.prototype.lastIndexOf ( searchElement [ , fromIndex ] )
     define($TypedArray$.prototype, 'lastIndexOf', Array.prototype.lastIndexOf);

     // 22.2.3.17 get %TypedArray%.prototype.length

     // 22.2.3.18 %TypedArray%.prototype.map ( callbackfn [ , thisArg ] )
     define(
       $TypedArray$.prototype, 'map',
       function map(callbackfn) {
         var thisArg = arguments[1];

         var o = ToObject(this);
         var lenValue = o.length;
         var len = ToLength(lenValue);
         if (!IsCallable(callbackfn)) throw TypeError();
         var t = thisArg;
         var a = undefined;
         var c = o.constructor;
         if (IsConstructor(c))
           a = new c(len);
         if (a === undefined)
           a = new Array(len);
         var k = 0;
         while (k < len) {
           var kPresent = HasProperty(o, k);
           if (kPresent) {
             var kValue = o[k];
             var mappedValue = callbackfn.call(t, kValue, k, o);
             a[k] = mappedValue;
           }
           ++k;
         }
         return a;
       });

     // 22.2.3.19 %TypedArray%.prototype.reduce ( callbackfn [, initialValue] )
     define($TypedArray$.prototype, 'reduce', Array.prototype.reduce);

     // 22.2.3.20 %TypedArray%.prototype.reduceRight ( callbackfn [, initialValue] )
     define($TypedArray$.prototype, 'reduceRight', Array.prototype.reduceRight);

     // 22.2.3.21 %TypedArray%.prototype.reverse ( )
     define($TypedArray$.prototype, 'reverse', Array.prototype.reverse);

     // 22.2.3.22 %TypedArray%.prototype.set ( overloaded [ , offset ])
     // 22.2.3.22.1 %TypedArray%.prototype.set (array [ , offset ] )
     // 22.2.3.22.2 %TypedArray%.prototype.set(typedArray [, offset ] )

     // 22.2.3.23 %TypedArray%.prototype.slice ( start, end )
     define(
       $TypedArray$.prototype, 'slice',
       function slice(start, end) {
         var o = ToObject(this);
         var lenVal = o.length;
         var len = ToLength(lenVal);
         var relativeStart = ToInteger(start);
         var k = (relativeStart < 0) ? max(len + relativeStart, 0) : min(relativeStart, len);
         var relativeEnd = (end === undefined) ? len : ToInteger(end);
         var final = (relativeEnd < 0) ? max(len + relativeEnd, 0) : min(relativeEnd, len);
         var count = final - k;
         var c = o.constructor;
         if (IsConstructor(c)) {
           var a = new c(count);
         } else {
           throw TypeError();
         }
         var n = 0;
         while (k < final) {
           var kValue = o[k];
           a[n] = kValue;
           ++k;
           ++n;
         }
         return a;
       });

     // 22.2.3.24 %TypedArray%.prototype.some ( callbackfn [ , thisArg ] )
     define($TypedArray$.prototype, 'some', Array.prototype.some);

     // 22.2.3.25 %TypedArray%.prototype.sort ( comparefn )
     define(
       $TypedArray$.prototype, 'sort',
       function sort() {
         var comparefn = arguments[0];

         function sortCompare(x, y) {
           console.assert(Type(x) === 'number' && Type(y) === 'number');
           if (x !== x && y !== y) return +0;
           if (x !== x) return 1;
           if (y !== y) return -1;
           if (comparefn !== undefined) {
             return comparefn(x, y);
           }
           if (x < y) return -1;
           if (x > y) return 1;
           return +0;
         }
         return Array.prototype.sort.call(this, sortCompare);
       });

     // 22.2.3.26 %TypedArray%.prototype.subarray( [ begin [ , end ] ] )
     // 22.2.3.27 %TypedArray%.prototype.toLocaleString ([ reserved1 [ , reserved2 ] ])
     // 22.2.3.28 %TypedArray%.prototype.toString ( )

     // 22.2.3.29 %TypedArray%.prototype.values ( )
     define($TypedArray$.prototype, 'values', Array.prototype.values);

     // 22.2.3.30 %TypedArray%.prototype [ @@iterator ] ( )
     define(
       $TypedArray$.prototype, $$iterator,
       $TypedArray$.prototype.values
     );

     // 22.2.3.31 get %TypedArray%.prototype [ @@toStringTag ]
     define($TypedArray$.prototype, $$toStringTag, $TypedArrayName$);

     // 22.2.4 The TypedArray Constructors
     // 22.2.4.1TypedArray( ... argumentsList)
     // 22.2.5 Properties of the TypedArray Constructors
     // 22.2.5.1 TypedArray.BYTES_PER_ELEMENT
     // 22.2.5.2 TypedArray.prototype
     // 22.2.6 Properties of TypedArray Prototype Objects
     // 22.2.6.1 TypedArray.prototype.BYTES_PER_ELEMENT
     // 22.2.6.2 TypedArray.prototype.constructor
     // 22.2.7 Properties of TypedArray Instances
   });

  // ---------------------------------------
  // 23 Keyed Collection
  // ---------------------------------------

  // ---------------------------------------
  // 23.1 Map Objects
  // ---------------------------------------

  (function() {
    // 23.1.1 The Map Constructor

    // 23.1.1.1 Map ( [ iterable ] )
    /** @constructor */
    function Map(/*iterable*/) {
      var map = strict(this);
      var iterable = arguments[0];

      if (Type(map) !== 'object') throw TypeError();
      if ('[[MapData]]' in map) throw TypeError();

      if (iterable !== undefined) {
        var adder = map['set'];
        if (!IsCallable(adder)) throw TypeError();
        var iter = GetIterator(ToObject(iterable));
      }
      set_internal(map, '[[MapData]]', { keys: [], values: [] });
      if (iter === undefined) return map;
      while (true) {
        var next = IteratorStep(iter);
        if (next === false)
          return map;
        var nextItem = IteratorValue(next);
        if (Type(nextItem) !== 'object') throw TypeError();
        var k = nextItem[0];
        var v = nextItem[1];
        adder.call(map, k, v);
      }

      return map;
    }

    if (!('Map' in global) || OVERRIDE_NATIVE_FOR_TESTING ||
        (function() { try { new global.Map([]); return false; } catch (_) { return true; } }()) ||
        (function() { try { return !new global.Map().entries().next; } catch (_) { return true; } }()) ||
        (new global.Map([['a', 1]]).size !== 1))
      global.Map = Map;


    function MapDataIndexOf(mapData, key) {
      var i;
      if (key === key) return mapData.keys.indexOf(key);
      // Slow case for NaN
      for (i = 0; i < mapData.keys.length; i += 1)
        if (SameValueZero(mapData.keys[i], key)) return i;
      return -1;
    }

    // 23.1.1.2 new Map ( ... argumentsList )
    // 23.1.2 Properties of the Map Constructor
    // 23.1.2.1 Map.prototype
    var $MapPrototype$ = {};
    Map.prototype = $MapPrototype$;

    // 23.1.2.2 get Map [ @@species ]

    // 23.1.3 Properties of the Map Prototype Object
    // 23.1.3.1 Map.prototype.clear ()
    define(
      Map.prototype, 'clear',
      function clear() {
        var m = strict(this);
        if (Type(m) !== 'object') throw TypeError();
        if (!('[[MapData]]' in m)) throw TypeError();
        if (m['[[MapData]]'] === undefined) throw TypeError();
        var entries = m['[[MapData]]'];
        entries.keys.length = 0;
        entries.values.length = 0;
        return undefined;
      });

    // 23.1.3.2 Map.prototype.constructor

    // 23.1.3.3 Map.prototype.delete ( key )
    define(
      Map.prototype, 'delete',
      function delete_(key) {
        var m = strict(this);
        if (Type(m) !== 'object') throw TypeError();
        if (!('[[MapData]]' in m)) throw TypeError();
        if (m['[[MapData]]'] === undefined) throw TypeError();
        var entries = m['[[MapData]]'];
        var i = MapDataIndexOf(entries, key);
        if (i < 0) return false;
        entries.keys[i] = empty;
        entries.values[i] = empty;
        return true;
      });

    // 23.1.3.4 Map.prototype.entries ( )
    define(
      Map.prototype, 'entries',
      function entries() {
        var m = strict(this);
        if (Type(m) !== 'object') throw TypeError();
        return CreateMapIterator(m, 'key+value');
      });

    // 23.1.3.5 Map.prototype.forEach ( callbackfn [ , thisArg ] )
    define(
      Map.prototype, 'forEach',
      function forEach(callbackfn /*, thisArg*/) {
        var thisArg = arguments[1];

        var m = strict(this);
        if (Type(m) !== 'object') throw TypeError();
        if (!('[[MapData]]' in m)) throw TypeError();
        if (m['[[MapData]]'] === undefined) throw TypeError();
        var entries = m['[[MapData]]'];

        if (!IsCallable(callbackfn)) {
          throw TypeError('First argument to forEach is not callable.');
        }
        for (var i = 0; i < entries.keys.length; ++i) {
          if (entries.keys[i] !== empty) {
            callbackfn.call(thisArg, entries.values[i], entries.keys[i], m);
          }
        }
        return undefined;
      });

    // 23.1.3.6 Map.prototype.get ( key )
    define(
      Map.prototype, 'get',
      function get(key) {
        var m = strict(this);
        if (Type(m) !== 'object') throw TypeError();
        if (!('[[MapData]]' in m)) throw TypeError();
        if (m['[[MapData]]'] === undefined) throw TypeError();
        var entries = m['[[MapData]]'];
        var i = MapDataIndexOf(entries, key);
        if (i >= 0) return entries.values[i];
        return undefined;
      });

    // 23.1.3.7 Map.prototype.has ( key )
    define(
      Map.prototype, 'has',
      function has(key) {
        var m = strict(this);
        if (Type(m) !== 'object') throw TypeError();
        if (!('[[MapData]]' in m)) throw TypeError();
        if (m['[[MapData]]'] === undefined) throw TypeError();
        var entries = m['[[MapData]]'];
        if (MapDataIndexOf(entries, key) >= 0) return true;
        return false;
      });

    // 23.1.3.8 Map.prototype.keys ( )
    define(
      Map.prototype, 'keys',
      function keys() {
        var m = strict(this);
        if (Type(m) !== 'object') throw TypeError();
        return CreateMapIterator(m, 'key');
      });

    // 23.1.3.9 Map.prototype.set ( key , value )
    define(
      Map.prototype, 'set',
      function set(key, value) {
        var m = strict(this);
        if (Type(m) !== 'object') throw TypeError();
        if (!('[[MapData]]' in m)) throw TypeError();
        if (m['[[MapData]]'] === undefined) throw TypeError();
        var entries = m['[[MapData]]'];
        var i = MapDataIndexOf(entries, key);
        if (i < 0) i = entries.keys.length;
        if (SameValue(key, -0)) key = 0;
        entries.keys[i] = key;
        entries.values[i] = value;
        return m;
      });

    // 23.1.3.10 get Map.prototype.size
    Object.defineProperty(
      Map.prototype, 'size', {
        get: function() {
          var m = strict(this);
          if (Type(m) !== 'object') throw TypeError();
          if (!('[[MapData]]' in m)) throw TypeError();
          if (m['[[MapData]]'] === undefined) throw TypeError();
          var entries = m['[[MapData]]'];
          var count = 0;
          for (var i = 0; i < entries.keys.length; ++i) {
            if (entries.keys[i] !== empty)
              count = count + 1;
          }
          return count;
        }
      });

    // 23.1.3.11 Map.prototype.values ( )
    define(
      Map.prototype, 'values',
      function values() {
        var m = strict(this);
        if (Type(m) !== 'object') throw TypeError();
        return CreateMapIterator(m, 'value');
      });

    // 23.1.3.12 Map.prototype [ @@iterator ]( )
    define(
      Map.prototype, $$iterator,
      function() {
        var m = strict(this);
        if (Type(m) !== 'object') throw TypeError();
        return CreateMapIterator(m, 'key+value');
      });

    // 23.1.3.13 Map.prototype [ @@toStringTag ]
    define(global.Map.prototype, $$toStringTag, 'Map');

    // 23.1.4 Properties of Map Instances
    // 23.1.5 Map Iterator Objects

    /** @constructor */
    function MapIterator() {}

    // 23.1.5.1 CreateMapIterator Abstract Operation
    function CreateMapIterator(map, kind) {
      if (Type(map) !== 'object') throw TypeError();
      if (!('[[MapData]]' in map)) throw TypeError();
      if (map['[[MapData]]'] === undefined) throw TypeError();
      var iterator = new MapIterator;
      set_internal(iterator, '[[Map]]', map);
      set_internal(iterator, '[[MapNextIndex]]', 0);
      set_internal(iterator, '[[MapIterationKind]]', kind);
      return iterator;
    }

    // 23.1.5.2 The %MapIteratorPrototype% Object
    var $MapIteratorPrototype$ = Object.create($IteratorPrototype$);
    MapIterator.prototype = $MapIteratorPrototype$;

    // 23.1.5.2.1 %MapIteratorPrototype%.next ( )
    define(
      $MapIteratorPrototype$, 'next',
      function next() {
        var o = strict(this);
        if (Type(o) !== 'object') throw TypeError();
        var m = o['[[Map]]'],
            index = o['[[MapNextIndex]]'],
            itemKind = o['[[MapIterationKind]]'],
            entries = m['[[MapData]]'];
        while (index < entries.keys.length) {
          var e = {key: entries.keys[index], value: entries.values[index]};
          index = index += 1;
          set_internal(o, '[[MapNextIndex]]', index);
          if (e.key !== empty) {
            if (itemKind === 'key') {
              return CreateIterResultObject(e.key, false);
            } else if (itemKind === 'value') {
              return CreateIterResultObject(e.value, false);
            } else {
              return CreateIterResultObject([e.key, e.value], false);
            }
          }
        }
        return CreateIterResultObject(undefined, true);
      });

    // 23.1.5.2.2 %MapIteratorPrototype% [ @@toStringTag ]
    define($MapIteratorPrototype$, $$toStringTag, 'Map Iterator');

    // 23.1.5.3 Properties of Map Iterator Instances
  }());

  // ---------------------------------------
  // 23.2 Set Objects
  // ---------------------------------------

  (function() {
    // 23.2.1 The Set Constructor
    // 23.2.1.1 Set ( [ iterable ] )

    /** @constructor */
    function Set(/*iterable*/) {
      var set = strict(this);
      var iterable = arguments[0];

      if (Type(set) !== 'object') throw TypeError();
      if ('[[SetData]]' in set) throw TypeError();

      if (iterable !== undefined) {
        var adder = set['add'];
        if (!IsCallable(adder)) throw TypeError();
        var iter = GetIterator(ToObject(iterable));
      }
      set_internal(set, '[[SetData]]', []);
      if (iter === undefined) return set;
      while (true) {
        var next = IteratorStep(iter);
        if (next === false)
          return set;
        var nextValue = IteratorValue(next);
        adder.call(set, nextValue);
      }

      return set;
    }

    if (!('Set' in global) || OVERRIDE_NATIVE_FOR_TESTING ||
        (function() { try { return !new global.Set().entries().next; } catch (_) { return true; } }()) ||
        (new global.Set([1]).size !== 1))
      global.Set = Set;

    function SetDataIndexOf(setData, key) {
      var i;
      if (key === key)
        return setData.indexOf(key);
      // Slow case for NaN
      for (i = 0; i < setData.length; i += 1)
        if (SameValueZero(setData[i], key)) return i;
      return -1;
    }

    // 23.2.1.2 new Set ( ...argumentsList )
    // 23.2.2 Properties of the Set Constructor

    // 23.2.2.1 Set.prototype
    var $SetPrototype$ =  {};
    Set.prototype = $SetPrototype$;

    // 23.2.2.2 get Set [ @@species ]
    // 23.2.3 Properties of the Set Prototype Object

    // 23.2.3.1 Set.prototype.add (value )
    define(
      Set.prototype, 'add',
      function add(value) {
        var s = strict(this);
        if (Type(s) !== 'object') throw TypeError();
        if (!('[[SetData]]' in s)) throw TypeError();
        if (s['[[SetData]]'] === undefined) throw TypeError();
        if (SameValue(value, -0)) value = 0;
        var entries = s['[[SetData]]'];
        var i = SetDataIndexOf(entries, value);
        if (i < 0) i = s['[[SetData]]'].length;
        s['[[SetData]]'][i] = value;

        return s;
      });

    // 23.2.3.2 Set.prototype.clear ()
    define(
      Set.prototype, 'clear',
      function clear() {
        var s = strict(this);
        if (Type(s) !== 'object') throw TypeError();
        if (!('[[SetData]]' in s)) throw TypeError();
        if (s['[[SetData]]'] === undefined) throw TypeError();
        var entries = s['[[SetData]]'];
        entries.length = 0;
        return undefined;
      });

    // 23.2.3.3 Set.prototype.constructor
    // 23.2.3.4 Set.prototype.delete ( value )
    define(
      Set.prototype, 'delete',
      function delete_(value) {
        var s = strict(this);
        if (Type(s) !== 'object') throw TypeError();
        if (!('[[SetData]]' in s)) throw TypeError();
        if (s['[[SetData]]'] === undefined) throw TypeError();
        var entries = s['[[SetData]]'];
        var i = SetDataIndexOf(entries, value);
        if (i < 0) return false;
        entries[i] = empty;
        return true;
      });

    // 23.2.3.5 Set.prototype.entries ( )
    define(
      Set.prototype, 'entries',
      function entries() {
        var s = strict(this);
        if (Type(s) !== 'object') throw TypeError();
        return CreateSetIterator(s, 'key+value');
      });

    // 23.2.3.6 Set.prototype.forEach ( callbackfn [ , thisArg ] )
    define(
      Set.prototype, 'forEach',
      function forEach(callbackfn/*, thisArg*/) {
        var thisArg = arguments[1];

        var s = strict(this);
        if (Type(s) !== 'object') throw TypeError();
        if (!('[[SetData]]' in s)) throw TypeError();
        if (s['[[SetData]]'] === undefined) throw TypeError();
        var entries = s['[[SetData]]'];

        if (!IsCallable(callbackfn)) {
          throw TypeError('First argument to forEach is not callable.');
        }
        for (var i = 0; i < entries.length; ++i) {
          if (entries[i] !== empty) {
            callbackfn.call(thisArg, entries[i], entries[i], s);
          }
        }
      });

    // 23.2.3.7 Set.prototype.has ( value )
    define(
      Set.prototype, 'has',
      function has(key) {
        var s = strict(this);
        if (Type(s) !== 'object') throw TypeError();
        if (!('[[SetData]]' in s)) throw TypeError();
        if (s['[[SetData]]'] === undefined) throw TypeError();
        var entries = s['[[SetData]]'];
        return SetDataIndexOf(entries, key) !== -1;
      });

    // 23.2.3.8 Set.prototype.keys ( )
    // See Set.prototype.values

    // 23.2.3.9 get Set.prototype.size
    Object.defineProperty(
      Set.prototype, 'size', {
        get: function() {
          var s = strict(this);
          if (Type(s) !== 'object') throw TypeError();
          if (!('[[SetData]]' in s)) throw TypeError();
          if (s['[[SetData]]'] === undefined) throw TypeError();
          var entries = s['[[SetData]]'];
          var count = 0;
          for (var i = 0; i < entries.length; ++i) {
            if (entries[i] !== empty)
              count = count + 1;
          }
          return count;
        }
      });

    // 23.2.3.10 Set.prototype.values ( )
    define(
      Set.prototype, 'values',
      function values() {
        var s = strict(this);
        if (Type(s) !== 'object') throw TypeError();
        return CreateSetIterator(s, 'value');
      });
    // NOTE: function name is still 'values':
    Set.prototype.keys = Set.prototype.values;

    // 23.2.3.11 Set.prototype [@@iterator ] ( )
    define(
      Set.prototype, $$iterator,
      function() {
        var s = strict(this);
        if (Type(s) !== 'object') throw TypeError();
        return CreateSetIterator(s);
      });

    // 23.2.3.12 Set.prototype [ @@toStringTag ]
    define(global.Set.prototype, $$toStringTag, 'Set');

    // 23.2.4 Properties of Set Instances
    // 23.2.5 Set Iterator Objects
    /** @constructor */
    function SetIterator() {}

    // 23.2.5.1 CreateSetIterator Abstract Operation
    function CreateSetIterator(set, kind) {
      if (Type(set) !== 'object') throw TypeError();
      if (!('[[SetData]]' in set)) throw TypeError();
      if (set['[[SetData]]'] === undefined) throw TypeError();
      var iterator = new SetIterator;
      set_internal(iterator, '[[IteratedSet]]', set);
      set_internal(iterator, '[[SetNextIndex]]', 0);
      set_internal(iterator, '[[SetIterationKind]]', kind);
      return iterator;
    }

    // 23.2.5.2 The %SetIteratorPrototype% Object
    var $SetIteratorPrototype$ = Object.create($IteratorPrototype$);
    SetIterator.prototype = $SetIteratorPrototype$;

    // 23.2.5.2.1 %SetIteratorPrototype%.next( )
    define(
      $SetIteratorPrototype$, 'next',
      function next() {
        var o = strict(this);
        if (Type(o) !== 'object') throw TypeError();
        var s = o['[[IteratedSet]]'],
            index = o['[[SetNextIndex]]'],
            itemKind = o['[[SetIterationKind]]'],
            entries = s['[[SetData]]'];
        while (index < entries.length) {
          var e = entries[index];
          index = index += 1;
          set_internal(o, '[[SetNextIndex]]', index);
          if (e !== empty) {
            if (itemKind === 'key+value')
              return CreateIterResultObject([e, e], false);
            return CreateIterResultObject(e, false);
          }
        }
        return CreateIterResultObject(undefined, true);
      });

    // 23.2.5.2.2 %SetIteratorPrototype% [ @@toStringTag ]
    define($SetIteratorPrototype$, $$toStringTag, 'Set Iterator');

    // 23.2.5.3 Properties of Set Iterator Instances

  }());

  // ---------------------------------------
  // 23.3 WeakMap Objects
  // ---------------------------------------

  (function() {
    // 23.3.1 The WeakMap Constructor
    // 23.3.1.1 WeakMap ( [ iterable ] )
    /** @constructor */
    function WeakMap(/*iterable*/) {
      var map = strict(this);
      var iterable = arguments[0];

      if (Type(map) !== 'object') throw TypeError();
      if ('[[WeakMapData]]' in map) throw TypeError();

      if (iterable !== undefined) {
        var adder = map['set'];
        if (!IsCallable(adder)) throw TypeError();
        var iter = GetIterator(ToObject(iterable));
      }
      set_internal(map, '[[WeakMapData]]', new EphemeronTable);
      if (iter === undefined) return map;
      while (true) {
        var next = IteratorStep(iter);
        if (next === false)
          return map;
        var nextValue = IteratorValue(next);
        if (Type(nextValue) !== 'object') throw TypeError();
        var k = nextValue[0];
        var v = nextValue[1];
        adder.call(map, k, v);
      }

      return map;
    }

    if (!('WeakMap' in global) || OVERRIDE_NATIVE_FOR_TESTING)
      global.WeakMap = WeakMap;

    // 23.3.2 Properties of the WeakMap Constructor
    // 23.3.2.1 WeakMap.prototype
    var $WeakMapPrototype$ = {};
    WeakMap.prototype = $WeakMapPrototype$;



   // 23.3.2.2 WeakMap[ @@create ] ( )
    // 23.3.3 Properties of the WeakMap Prototype Object

    // 23.3.3.1 WeakMap.prototype.constructor

    // 23.3.3.2 WeakMap.prototype.delete ( key )
    define(
      WeakMap.prototype, 'delete',
      function delete_(key) {
        var M = strict(this);
        if (Type(M) !== 'object') throw TypeError();
        if (M['[[WeakMapData]]'] === undefined) throw TypeError();
        if (Type(key) !== 'object') throw TypeError('Expected object');
        return M['[[WeakMapData]]'].remove(key);
      });

    // 23.3.3.3 WeakMap.prototype.get ( key )
    define(
      WeakMap.prototype, 'get',
      function get(key, defaultValue) {
        var M = strict(this);
        if (Type(M) !== 'object') throw TypeError();
        if (M['[[WeakMapData]]'] === undefined) throw TypeError();
        if (Type(key) !== 'object') throw TypeError('Expected object');
        return M['[[WeakMapData]]'].get(key, defaultValue);
      });

    // 23.3.3.4 WeakMap.prototype.has ( key )
    define(
      WeakMap.prototype, 'has',
      function has(key) {
        var M = strict(this);
        if (Type(M) !== 'object') throw TypeError();
        if (M['[[WeakMapData]]'] === undefined) throw TypeError();
        if (Type(key) !== 'object') throw TypeError('Expected object');
        return M['[[WeakMapData]]'].has(key);
      });

    // 23.3.3.5 WeakMap.prototype.set ( key , value )
    define(
      WeakMap.prototype, 'set',
      function set(key, value) {
        var M = strict(this);
        if (Type(M) !== 'object') throw TypeError();
        if (M['[[WeakMapData]]'] === undefined) throw TypeError();
        if (Type(key) !== 'object') throw TypeError('Expected object');
        M['[[WeakMapData]]'].set(key, value);
        return M;
      });

    // 23.3.3.6 WeakMap.prototype [ @@toStringTag ]
    define(global.WeakMap.prototype, $$toStringTag, 'WeakMap');

    // 23.3.4 Properties of WeakMap Instances

    // Polyfills for incomplete native implementations:
    (function() {
      var wm = new global.WeakMap();
      var orig = global.WeakMap.prototype.set;
      define(global.WeakMap.prototype, 'set', function set() {
        orig.apply(this, arguments);
        return this;
      }, wm.set({}, 0) !== wm);
    }());
  }());

  // ---------------------------------------
  // 23.4 WeakSet Objects
  // ---------------------------------------

  (function() {
    // 23.4.1 The WeakSet Constructor
    // 23.4.1.1 WeakSet ( [ iterable ] )
    /** @constructor */
    function WeakSet(/*iterable*/) {
      var set = strict(this);
      var iterable = arguments[0];

      if (Type(set) !== 'object') throw TypeError();
      if ('[[WeakSetData]]' in set) throw TypeError();

      if (iterable !== undefined) {
        var adder = set['add'];
        if (!IsCallable(adder)) throw TypeError();
        var iter = GetIterator(ToObject(iterable));
      }
      set_internal(set, '[[WeakSetData]]', new EphemeronTable);
      if (iter === undefined) return set;
      while (true) {
        var next = IteratorStep(iter);
        if (next === false)
          return set;
        var nextValue = IteratorValue(next);
        adder.call(set, nextValue);
      }

      return set;
    }

    if (!('WeakSet' in global) || OVERRIDE_NATIVE_FOR_TESTING)
      global.WeakSet = WeakSet;

    // 23.4.2 Properties of the WeakSet Constructor
    // 23.4.2.1 WeakSet.prototype
    var $WeakSetPrototype$ = {};
    WeakSet.prototype = $WeakSetPrototype$;

    // 23.4.3 Properties of the WeakSet Prototype Object
    // 23.4.3.1 WeakSet.prototype.add (value )
    define(
      WeakSet.prototype, 'add',
      function add(value) {
        var S = strict(this);
        if (Type(S) !== 'object') throw TypeError();
        if (S['[[WeakSetData]]'] === undefined) throw TypeError();
        if (Type(value) !== 'object') throw TypeError('Expected object');
        S['[[WeakSetData]]'].set(value, true);
        return S;
      });

    // 23.4.3.2 WeakSet.prototype.constructor
    // 23.4.3.3 WeakSet.prototype.delete ( value )
    define(
      WeakSet.prototype, 'delete',
      function delete_(value) {
        var S = strict(this);
        if (Type(S) !== 'object') throw TypeError();
        if (S['[[WeakSetData]]'] === undefined) throw TypeError();
        if (Type(value) !== 'object') throw TypeError('Expected object');
        return S['[[WeakSetData]]'].remove(value);
      });

    // 23.4.3.4 WeakSet.prototype.has ( value )
    define(
      WeakSet.prototype, 'has',
      function has(key) {
        var S = strict(this);
        if (Type(S) !== 'object') throw TypeError();
        if (S['[[WeakSetData]]'] === undefined) throw TypeError();
        if (Type(key) !== 'object') throw TypeError('Expected object');
        return S['[[WeakSetData]]'].has(key);
      });

    // 23.4.3.5 WeakSet.prototype [ @@toStringTag ]
    define(global.WeakSet.prototype, $$toStringTag, 'WeakSet');

    // 23.4.4 Properties of WeakSet Instances

    // Polyfills for incomplete native implementations:
    (function() {
      var ws = new global.WeakSet();
      var orig = global.WeakSet.prototype.add;
      define(global.WeakSet.prototype, 'add', function add() {
        orig.apply(this, arguments);
        return this;
      }, ws.add({}) !== ws);
    }());
  }());

  // ---------------------------------------
  // 24 Structured Data
  // ---------------------------------------

  // ---------------------------------------
  // 24.1 ArrayBuffer Objects
  // ---------------------------------------

  // See typedarray.js for TypedArray polyfill

  (function() {
    if (!('ArrayBuffer' in global))
      return;

    // 24.1.1 Abstract Operations For ArrayBuffer Objects
    // 24.1.1.1 AllocateArrayBuffer( constructor, byteLength )
    // 24.1.1.2 IsDetachedBuffer( arrayBuffer )
    // 24.1.1.3 DetachArrayBuffer( arrayBuffer )
    // 24.1.1.4 CloneArrayBuffer( srcBuffer, srcByteOffset [, cloneConstructor] )
    // 24.1.1.5 GetValueFromBuffer ( arrayBuffer, byteIndex, type, isLittleEndian )
    // 24.1.1.6 SetValueInBuffer ( arrayBuffer, byteIndex, type, value, isLittleEndian )
    // 24.1.2 The ArrayBuffer Constructor
    // 24.1.2.1 ArrayBuffer( length )
    // 24.1.3 Properties of the ArrayBuffer Constructor

    // 24.1.3.1 ArrayBuffer.isView ( arg )
    define(
      ArrayBuffer, 'isView',
      function isView(arg) {
        if (Type(arg) !== 'object') return false;
        if ('buffer' in arg && arg.buffer instanceof ArrayBuffer) return true;
        return false;
      });

    // 24.1.3.2 ArrayBuffer.prototype
    // 24.1.3.3 get ArrayBuffer [ @@species ]
    // 24.1.4 Properties of the ArrayBuffer Prototype Object
    // 24.1.4.1 get ArrayBuffer.prototype.byteLength
    // 24.1.4.2 ArrayBuffer.prototype.constructor
    // 24.1.4.3 ArrayBuffer.prototype.slice ( start , end)

    // 24.1.4.4 ArrayBuffer.prototype [ @@toStringTag ]
    define(ArrayBuffer.prototype, $$toStringTag, 'ArrayBuffer');

    // 24.1.5 Properties of the ArrayBuffer Instances
  }());

  // ---------------------------------------
  // 24.2 DataView Objects
  // ---------------------------------------

  // See typedarray.js for TypedArray polyfill

  (function() {
    if (!('DataView' in global))
      return;

    // 24.2.1 Abstract Operations For DataView Objects
    // 24.2.1.1 GetViewValue(view, requestIndex, isLittleEndian, type)
    // 24.2.1.2 SetViewValue(view, requestIndex, isLittleEndian, type, value)
    // 24.2.2 The DataView Constructor
    // 24.2.2.1 DataView (buffer [ , byteOffset [ , byteLength ] ] )
    // 24.2.3 Properties of the DataView Constructor
    // 24.2.3.1 DataView.prototype
    // 24.2.4 Properties of the DataView Prototype Object
    // 24.2.4.1 get DataView.prototype.buffer
    // 24.2.4.2 get DataView.prototype.byteLength
    // 24.2.4.3 get DataView.prototype.byteOffset
    // 24.2.4.4 DataView.prototype.constructor
    // 24.2.4.5 DataView.prototype.getFloat32 ( byteOffset [ , littleEndian ] )
    // 24.2.4.6 DataView.prototype.getFloat64 ( byteOffset [ , littleEndian ] )
    // 24.2.4.7 DataView.prototype.getInt8 ( byteOffset )
    // 24.2.4.8 DataView.prototype.getInt16 ( byteOffset [ , littleEndian ] )
    // 24.2.4.9 DataView.prototype.getInt32 ( byteOffset [ , littleEndian ] )
    // 24.2.4.10 DataView.prototype.getUint8 ( byteOffset )
    // 24.2.4.11 DataView.prototype.getUint16 ( byteOffset [ , littleEndian ] )
    // 24.2.4.12 DataView.prototype.getUint32 ( byteOffset [ , littleEndian ] )
    // 24.2.4.13 DataView.prototype.setFloat32 ( byteOffset, value [ , littleEndian ] )
    // 24.2.4.14 DataView.prototype.setFloat64 ( byteOffset, value [ , littleEndian ] )
    // 24.2.4.15 DataView.prototype.setInt8 ( byteOffset, value )
    // 24.2.4.16 DataView.prototype.setInt16 ( byteOffset, value [ , littleEndian ] )
    // 24.2.4.17 DataView.prototype.setInt32 ( byteOffset, value [ , littleEndian ] )
    // 24.2.4.18 DataView.prototype.setUint8 ( byteOffset, value )
    // 24.2.4.19 DataView.prototype.setUint16 ( byteOffset, value [ , littleEndian ] )
    // 24.2.4.20 DataView.prototype.setUint32 ( byteOffset, value [ , littleEndian ] )

    // 24.2.4.21 DataView.prototype[ @@toStringTag ]
    define(DataView.prototype, $$toStringTag, 'DataView');

    // 24.2.5 Properties of DataView Instances
  }());

  // ---------------------------------------
  // 24.3 The JSON Object
  // ---------------------------------------

  // 24.3.1 JSON.parse ( text [ , reviver ] )
  // 24.3.2 JSON.stringify ( value [ , replacer [ , space ] ] )
  // 24.3.3 JSON [ @@toStringTag ]
  define(JSON, $$toStringTag, 'JSON');

  // ---------------------------------------
  // 25.1 Iteration
  // ---------------------------------------

  // 25.1.1 Common Iteration Interfaces
  // 25.1.1.1 The Iterable Interface
  // 25.1.1.2 The Iterator Interface
  // 25.1.1.3 The IteratorResult Interface

  // 25.1.2 The %IteratorPrototype% Object
  // Defined earlier, so other prototypes can reference it.
  // 25.1.2.1 %IteratorPrototype% [ @@iterator ] ( )
  define($IteratorPrototype$, $$iterator, function() {
    return this;
  });


  // ---------------------------------------
  // 25.4 Promise Objects
  // ---------------------------------------

  (function() {
    // 25.4 Promise Objects

    // 25.4.1 Promise Abstract Operations

    // 25.4.1.1 PromiseCapability Records
    // 25.4.1.1.1 IfAbruptRejectPromise ( value, capability )

    function IfAbruptRejectPromise(value, capability) {
      var rejectResult = capability['[[Reject]]'].call(undefined, value);
      return capability['[[Promise]]'];
    }

    // 25.4.1.2 PromiseReaction Records

    // 25.4.1.3 CreateResolvingFunctions ( promise )

    function CreateResolvingFunctions(promise) {
      var alreadyResolved = {'[[value]]': false};
      var resolve = PromiseResolveFunction();
      set_internal(resolve, '[[Promise]]',  promise);
      set_internal(resolve, '[[AlreadyResolved]]', alreadyResolved);
      var reject = PromiseRejectFunction();
      set_internal(reject, '[[Promise]]', promise);
      set_internal(reject, '[[AlreadyResolved]]', alreadyResolved);
      return { '[[Resolve]]': resolve, '[[Reject]]': reject};
    }

    // 25.4.1.3.1 Promise Reject Functions

    function PromiseRejectFunction() {
      var F = function(reason) {
        console.assert(Type(F['[[Promise]]']) === 'object');
        var promise = F['[[Promise]]'];
        var alreadyResolved = F['[[AlreadyResolved]]'];
        if (alreadyResolved['[[value]]']) return undefined;
        set_internal(alreadyResolved, '[[value]]', true);
        return RejectPromise(promise, reason);
      };
      return F;
    }

    // 25.4.1.3.2 Promise Resolve Functions

    function PromiseResolveFunction() {
      var F = function(resolution) {
        console.assert(Type(F['[[Promise]]']) === 'object');
        var promise = F['[[Promise]]'];
        var alreadyResolved = F['[[AlreadyResolved]]'];
        if (alreadyResolved['[[value]]']) return undefined;
        set_internal(alreadyResolved, '[[value]]', true);

        if (SameValue(resolution, promise))  {
          var selfResolutionError = TypeError();
          return RejectPromise(promise, selfResolutionError);
        }
        if (Type(resolution) !== 'object')
          return FulfillPromise(promise, resolution);
        try {
          var then = resolution['then'];
        } catch(then) {
          return RejectPromise(promise, then);
        }
        if (!IsCallable(then))
          return FulfillPromise(promise, resolution);
        EnqueueJob('PromiseJobs', PromiseResolveThenableJob, [promise, resolution, then]);
        return undefined;
      };
      return F;
    }

    // 25.4.1.4 FulfillPromise ( promise, value )

    function FulfillPromise(promise, value) {
      console.assert(promise['[[PromiseState]]'] === 'pending');
      var reactions = promise['[[PromiseFulfillReactions]]'];
      set_internal(promise, '[[PromiseResult]]', value);
      set_internal(promise, '[[PromiseFulfillReactions]]', undefined);
      set_internal(promise, '[[PromiseRejectReactions]]', undefined);
      set_internal(promise, '[[PromiseState]]', 'fulfilled');
      return TriggerPromiseReactions(reactions, value);
    }

    // 25.4.1.5 NewPromiseCapability ( C )

    function NewPromiseCapability(c) {
      // To keep Promise hermetic, this doesn't look much like the spec.
      return CreatePromiseCapabilityRecord(undefined, c);
    }

    // 25.4.1.5.1 CreatePromiseCapabilityRecord ( promise, constructor )

    function CreatePromiseCapabilityRecord(promise, constructor) {
      // To keep Promise hermetic, this doesn't look much like the spec.
      console.assert(IsConstructor(constructor));
      var promiseCapability = {};
      set_internal(promiseCapability, '[[Promise]]', promise);
      set_internal(promiseCapability, '[[Resolve]]', undefined);
      set_internal(promiseCapability, '[[Reject]]', undefined);
      var executor = GetCapabilitiesExecutor();
      set_internal(executor, '[[Capability]]', promiseCapability);

      // NOTE: Differs from spec; object is constructed here
      var constructorResult = promise = new constructor(executor);
      set_internal(promiseCapability, '[[Promise]]', promise);

      if (!IsCallable(promiseCapability['[[Resolve]]'])) throw TypeError();
      if (!IsCallable(promiseCapability['[[Reject]]'])) throw TypeError();
      if (Type(constructorResult) === 'object' && !SameValue(promise, constructorResult)) throw TypeError();
      return promiseCapability;
    }

    // 25.4.1.5.2 GetCapabilitiesExecutor Functions

    function GetCapabilitiesExecutor() {
      var F = function(resolve, reject) {
        console.assert(F['[[Capability]]']);
        var promiseCapability = F['[[Capability]]'];
        if (promiseCapability['[[Resolve]]'] !== undefined) throw TypeError();
        if (promiseCapability['[[Reject]]'] !== undefined) throw TypeError();
        set_internal(promiseCapability, '[[Resolve]]', resolve);
        set_internal(promiseCapability, '[[Reject]]', reject);
        return undefined;
      };
      return F;
    }

    // 25.4.1.6 IsPromise ( x )

    function IsPromise(x) {
      if (Type(x) !== 'object') return false;
      if (!('[[PromiseState]]' in x)) return false;
      if (x['[[PromiseState]]'] === undefined) return false;
      return true;
    }

    // 25.4.1.7 RejectPromise ( promise, reason )

    function RejectPromise(promise, reason) {
      console.assert(promise['[[PromiseState]]'] === 'pending');
      var reactions = promise['[[PromiseRejectReactions]]'];
      set_internal(promise, '[[PromiseResult]]', reason);
      set_internal(promise, '[[PromiseFulfillReactions]]', undefined);
      set_internal(promise, '[[PromiseRejectReactions]]', undefined);
      set_internal(promise, '[[PromiseState]]', 'rejected');
      return TriggerPromiseReactions(reactions, reason);
    }

    // 25.4.1.8 TriggerPromiseReactions ( reactions, argument )

    function TriggerPromiseReactions(reactions, argument) {
      for (var i = 0, len = reactions.length; i < len; ++i)
        EnqueueJob('PromiseJobs', PromiseReactionJob, [reactions[i], argument]);
      return undefined;
    }

    // 25.4.2 Promise Jobs

    // 25.4.2.1 PromiseReactionJob ( reaction, argument )

    function PromiseReactionJob(reaction, argument) {
      var promiseCapability = reaction['[[Capabilities]]'];
      var handler = reaction['[[Handler]]'];
      var handlerResult, status;
      try {
        if (handler === 'Identity') handlerResult = argument;
        else if (handler === 'Thrower') throw argument;
        else handlerResult = handler.call(undefined, argument);
      } catch (handlerResult) {
        status = promiseCapability['[[Reject]]'].call(undefined, handlerResult);
        NextJob(status); return;
      }
      status = promiseCapability['[[Resolve]]'].call(undefined, handlerResult);
      NextJob(status);
    }

    // 25.4.2.2 PromiseResolveThenableJob ( promiseToResolve, thenable, then)

    function PromiseResolveThenableJob(promiseToResolve, thenable, then) {
      // SPEC BUG: promise vs. promiseToResolve
      var resolvingFunctions = CreateResolvingFunctions(promiseToResolve);
      try {
        var thenCallResult = then.call(thenable, resolvingFunctions['[[Resolve]]'],
                                       resolvingFunctions['[[Reject]]']);
      } catch (thenCallResult) {
        var status = resolvingFunctions['[[Reject]]'].call(undefined, thenCallResult);
        NextJob(status); return;
      }
      NextJob(thenCallResult);
    }

    // 25.4.3 The Promise Constructor

    // 25.4.3.1 Promise ( executor )

    function Promise(executor) {
      var config = { configurable: false, enumerable: false, writable: true, value: undefined };
      Object.defineProperty(this, '[[PromiseState]]', config);
      Object.defineProperty(this, '[[PromiseConstructor]]', config);
      Object.defineProperty(this, '[[PromiseResult]]', config);
      Object.defineProperty(this, '[[PromiseFulfillReactions]]', config);
      Object.defineProperty(this, '[[PromiseRejectReactions]]', config);

      var promise = this;
      if (Type(promise) !== 'object') throw new TypeError();
      if (!('[[PromiseState]]' in promise)) throw TypeError();
      if (promise['[[PromiseState]]'] !== undefined) throw TypeError();
      if (!IsCallable(executor)) throw TypeError();

      set_internal(promise, '[[PromiseConstructor]]', Promise);

      return InitializePromise(promise, executor);
    }

    // 25.4.3.1.1 InitializePromise ( promise, executor )

    function InitializePromise(promise, executor) {
      console.assert('[[PromiseState]]' in promise);
      console.assert(IsCallable(executor));
      set_internal(promise, '[[PromiseState]]', 'pending');
      set_internal(promise, '[[PromiseFulfillReactions]]', []);
      set_internal(promise, '[[PromiseRejectReactions]]', []);
      var resolvingFunctions = CreateResolvingFunctions(promise);
      try {
        var completion = executor.call(undefined, resolvingFunctions['[[Resolve]]'],
                                       resolvingFunctions['[[Reject]]']);
      } catch (completion) {
        var status = resolvingFunctions['[[Reject]]'].call(undefined, completion);
      }
      return promise;
    }

    // 25.4.4 Properties of the Promise Constructor
    // 25.4.4.1 Promise.all ( iterable )

    define(Promise, 'all', function all(iterable) {
      var c = strict(this);
      var promiseCapability = NewPromiseCapability(c);
      try {
        var iterator = GetIterator(iterable);
      } catch (value) {
        promiseCapability['[[Reject]]'].call(undefined, value);
        return promiseCapability['[[Promise]]'];
      }
      var values = [];
      var remainingElementsCount = { value: 1 };
      var index = 0;
      while (true) {
        try {
          var next = IteratorStep(iterator);
        } catch (value) {
          promiseCapability['[[Reject]]'].call(undefined, value);
          return promiseCapability['[[Promise]]'];
        }
        if (!next) {
          remainingElementsCount.value -= 1;
          if (remainingElementsCount.value === 0) {
            var resolveResult = promiseCapability['[[Resolve]]'].apply(undefined, values);


          }
          return promiseCapability['[[Promise]]'];
        }
        try {
          var nextValue = IteratorValue(next);
        } catch (value) {
          promiseCapability['[[Reject]]'].call(undefined, value);
          return promiseCapability['[[Promise]]'];
        }
        try {
          var nextPromise = c.resolve(nextValue);
        } catch (value) {
          promiseCapability['[[Reject]]'].call(undefined, value);
          return promiseCapability['[[Promise]]'];
        }
        var resolveElement = PromiseAllResolveElementFunction();
        set_internal(resolveElement, '[[AlreadyCalled]]', { value: false });
        set_internal(resolveElement, '[[Index]]', index);
        set_internal(resolveElement, '[[Values]]', values);
        set_internal(resolveElement, '[[Capabilities]]', promiseCapability);
        set_internal(resolveElement, '[[RemainingElements]]', remainingElementsCount);
        remainingElementsCount.value += 1;
        try {
          var result = nextPromise.then(resolveElement, promiseCapability['[[Reject]]']);
        } catch (value) {
          promiseCapability['[[Reject]]'].call(undefined, value);
          return promiseCapability['[[Promise]]'];
        }
        index += 1;
      }
    });

    // 25.4.4.1.1 Promise.all Resolve Element Functions

    function PromiseAllResolveElementFunction() {
      var F = function(x) {
        var alreadyCalled = F['[[AlreadyCalled]]'];
        if (alreadyCalled.value) return undefined;
        alreadyCalled.value = true;
        var index = F['[[Index]]'];
        var values = F['[[Values]]'];
        var promiseCapability = F['[[Capabilities]]'];
        var remainingElementsCount = F['[[RemainingElements]]'];
        try {
          values[index] = x;
        } catch (result) {
          promiseCapability['[[Reject]]'].call(undefined, result);
          return promiseCapability['[[Promise]]'];
        }
        remainingElementsCount.value -= 1;
        if (remainingElementsCount.value === 0)
          return promiseCapability['[[Resolve]]'].call(undefined, values);
        return undefined;
      };
      return F;
    }

    // 25.4.4.2 Promise.prototype

    Promise.prototype = {};

    // 25.4.4.3 Promise.race ( iterable )

    define(Promise, 'race', function race(iterable) {
      var c = strict(this);
      var promiseCapability = NewPromiseCapability(c);
      try {
        var iterator = GetIterator(iterable);
      } catch (value) {
        promiseCapability['[[Reject]]'].call(undefined, value);
        return promiseCapability['[[Promise]]'];
      }
      while (true) {
        try {
          var next = IteratorStep(iterator);
        } catch (value) {
          promiseCapability['[[Reject]]'].call(undefined, value);
          return promiseCapability['[[Promise]]'];
        }
        if (!next) return promiseCapability['[[Promise]]'];
        try {
          var nextValue = IteratorValue(next);
        } catch (value) {
          promiseCapability['[[Reject]]'].call(undefined, value);
          return promiseCapability['[[Promise]]'];
        }
        try {
          var nextPromise = c.resolve(nextValue);
        } catch (value) {
          promiseCapability['[[Reject]]'].call(undefined, value);
          return promiseCapability['[[Promise]]'];
        }
        try {
          nextPromise.then(promiseCapability['[[Resolve]]'], promiseCapability['[[Reject]]']);
        } catch (value) {
          promiseCapability['[[Reject]]'].call(undefined, value);
          return promiseCapability['[[Promise]]'];
        }
      }
    });

    // 25.4.4.4 Promise.reject ( r )

    define(Promise, 'reject', function reject(r) {
      var c = strict(this);
      var promiseCapability = NewPromiseCapability(c);
      var rejectResult = promiseCapability['[[Reject]]'].call(undefined, r);
      return promiseCapability['[[Promise]]'];
    });

    // 25.4.4.5 Promise.resolve ( x )

    define(Promise, 'resolve', function resolve(x) {
      var c = strict(this);
      if (IsPromise(x)) {
        var constructor = x['[[PromiseConstructor]]'];
        if (SameValue(constructor, c)) return x;
      }
      var promiseCapability = NewPromiseCapability(c);
      var resolveResult = promiseCapability['[[Resolve]]'].call(undefined, x);
      return promiseCapability['[[Promise]]'];
    });

    // 25.4.4.6 Promise [ @@create ] ( )
    // 25.4.4.6.1 AllocatePromise ( constructor )
    // 25.4.5 Properties of the Promise Prototype Object
    // 25.4.5.1 Promise.prototype.catch ( onRejected )

    define(Promise.prototype, 'catch', function catch_(onRejected) {
      var promise = this;
      return promise.then(undefined, onRejected);
    });

    // 25.4.5.2 Promise.prototype.constructor

    Promise.prototype.constructor = Promise;

    // 25.4.5.3 Promise.prototype.then ( onFulfilled , onRejected )

    define(Promise.prototype, 'then', function then(onFulfilled, onRejected) {
      var promise = this;
      if (!IsPromise(promise)) throw TypeError();
      if (!IsCallable(onFulfilled)) onFulfilled = 'Identity';
      if (!IsCallable(onRejected)) onRejected = 'Thrower';
      var c = promise.constructor;
      var promiseCapability = NewPromiseCapability(c);
      var fulfillReaction = { '[[Capabilities]]': promiseCapability,
                              '[[Handler]]': onFulfilled };
      var rejectReaction = { '[[Capabilities]]': promiseCapability,
                             '[[Handler]]': onRejected };
      if (promise['[[PromiseState]]'] === 'pending') {
        promise['[[PromiseFulfillReactions]]'].push(fulfillReaction);
        promise['[[PromiseRejectReactions]]'].push(rejectReaction);
      } else if (promise['[[PromiseState]]'] === 'fulfilled') {
        var value = promise['[[PromiseResult]]'];
        EnqueueJob('PromiseJobs', PromiseReactionJob, [fulfillReaction, value]);
      } else if (promise['[[PromiseState]]'] === 'rejected') {
        var reason = promise['[[PromiseResult]]'];
        EnqueueJob('PromiseJobs', PromiseReactionJob, [rejectReaction, reason]);
      }
      return promiseCapability['[[Promise]]'];
    });

    // 25.4.6 Properties of Promise Instances

    if (!('Promise' in global) || OVERRIDE_NATIVE_FOR_TESTING)
      global.Promise = Promise;

    // Patch early Promise.cast vs. Promise.resolve implementations
    if ('cast' in global.Promise) global.Promise.resolve = global.Promise.cast;
  }());

  // 25.4.5.1 Promise.prototype [ @@toStringTag ]
  define(Promise.prototype, $$toStringTag, 'Promise');

  // ---------------------------------------
  // 26 Reflection
  // ---------------------------------------

  (function() {
    // 26.1 The Reflect Object
    if (!('Reflect' in global) || OVERRIDE_NATIVE_FOR_TESTING)
      global.Reflect = {};

    // 26.1.1 Reflect.apply ( target, thisArgument, argumentsList )
    define(
      Reflect, 'apply',
      function apply(target, thisArgument, argumentsList) {
        if (!IsCallable(target)) throw TypeError();
        return Function.prototype.apply.call(target, thisArgument, argumentsList);
      });

    // 26.1.2 Reflect.construct ( target, argumentsList [, newTarget] )
    define(
      Reflect, 'construct',
      function construct(target, argumentsList) {
        return __cons(target, argumentsList);
      });

    // 26.1.3 Reflect.defineProperty ( target, propertyKey, attributes )
    define(
      Reflect, 'defineProperty',
      function defineProperty(target, propertyKey, attributes) {
        try {
          Object.defineProperty(target, propertyKey, attributes);
          return true;
        } catch (_) {
          return false;
        }
      });

    // 26.1.4 Reflect.deleteProperty ( target, propertyKey )
    define(
      Reflect, 'deleteProperty',
      function deleteProperty(target,name) {
        try {
          delete target[name];
          return !HasOwnProperty(target, name);
        } catch (_) {
          return false;
        }
      });

    // 26.1.5 Reflect.enumerate ( target )
    define(
      Reflect, 'enumerate',
      function enumerate(target) {
        target = ToObject(target);
        var iterator = Enumerate(target);
        return iterator;
      });

    // 26.1.6 Reflect.get ( target, propertyKey [ , receiver ])
    define(
      Reflect, 'get',
      function get(target, name, receiver) {
        target = ToObject(target);
        name = String(name);
        receiver = (receiver === undefined) ? target : ToObject(receiver);
        var desc = getPropertyDescriptor(target, name);
        if (desc && 'get' in desc)
          return Function.prototype.call.call(desc['get'], receiver);
        return target[name];
      });

    // 26.1.7 Reflect.getOwnPropertyDescriptor ( target, propertyKey )
    define(
      Reflect, 'getOwnPropertyDescriptor',
      Object.getOwnPropertyDescriptor);

    // 26.1.8 Reflect.getPrototypeOf ( target )
    define(
      Reflect, 'getPrototypeOf',
      Object.getPrototypeOf);

    // 26.1.9 Reflect.has ( target, propertyKey )
    define(
      Reflect, 'has',
      function has(target,name) {
        return String(name) in ToObject(target);
      });

    // 26.1.10 Reflect.isExtensible (target)
    define(
      Reflect, 'isExtensible',
      Object.isExtensible);

    // 26.1.11 Reflect.ownKeys ( target )
    define(
      Reflect, 'ownKeys',
      function ownKeys(target) {
        var obj = ToObject(target);
        return Object.getOwnPropertyNames(obj);
      });

    // 26.1.12 Reflect.preventExtensions ( target )
    define(
      Reflect, 'preventExtensions',
      function preventExtensions(target) {
        try { Object.preventExtensions(target); return true; } catch (_) { return false; }
      });

    // 26.1.13 Reflect.set ( target, propertyKey, V [ , receiver ] )
    define(
      Reflect, 'set',
      function set(target, name, value, receiver) {
        target = ToObject(target);
        name = String(name);
        receiver = (receiver === undefined) ? target : ToObject(receiver);
        var desc = getPropertyDescriptor(target, name);
        try {
          if (desc && 'set' in desc)
            Function.prototype.call.call(desc['set'], receiver, value);
          else
            target[name] = value;
          return true;
        } catch (_) {
          return false;
        }
      });

    // 26.1.14 Reflect.setPrototypeOf ( target, proto )
    define(
      Reflect, 'setPrototypeOf',
      function setPrototypeOf(target, proto) {
        try {
          target.__proto__ = proto;
          return Reflect.getPrototypeOf(target) === proto;
        } catch(_) {
          return false;
        }
      });

  }());

  // ---------------------------------------
  // 26.2 Proxy Objects
  // ---------------------------------------

  // Not polyfillable.

}(self));

// This helper is defined outside the main scope so that the use of
// 'eval' does not taint the scope for minifiers.
function __cons(t, a) {
  return eval('new t(' + a.map(function(_, i) { return 'a[' + i + ']'; }).join(',') + ')');
}

},{}],51:[function(require,module,exports){
(function(global) {
  'use strict';

  if (!('window' in global && 'document' in global))
    return;

  //----------------------------------------------------------------------
  //
  // HTML
  // https://html.spec.whatwg.org
  //
  //----------------------------------------------------------------------

  // document.head attribute
  // Needed for: IE8-
  if (!('head' in document))
    document.head = document.getElementsByTagName('head')[0];

  // Ensure correct parsing of newish elements ("shiv")
  // Needed for: IE8-
  [
    'abbr', 'article', 'aside', 'audio', 'bdi', 'canvas', 'data', 'datalist',
    'details', 'dialog', 'figcaption', 'figure', 'footer', 'header', 'hgroup',
    'main', 'mark', 'meter', 'nav', 'output', 'picture', 'progress', 'section',
    'summary', 'template', 'time', 'video'].forEach(function(tag) {
     document.createElement(tag);
   });

  // HTMLElement.dataset
  // Needed for: IE10-
  if (!('dataset' in document.createElement('span')) &&
      'Element' in global && Element.prototype && Object.defineProperty) {
    Object.defineProperty(Element.prototype, 'dataset', { get: function() {
      var result = Object.create(null);
      for (var i = 0; i < this.attributes.length; ++i) {
        var attr = this.attributes[i];
        if (attr.specified && attr.name.substring(0, 5) === 'data-') {
          (function(element, name) {
            var prop = name.replace(/-([a-z])/g, function(m, p) {
              return p.toUpperCase();
            });
            result[prop] = element.getAttribute('data-' + name); // Read-only, for IE8-
            Object.defineProperty(result, prop, {
              get: function() {
                return element.getAttribute('data-' + name);
              },
              set: function(value) {
                element.setAttribute('data-' + name, value);
              }});
          }(this, attr.name.substring(5)));
        }
      }
      return result;
    }});
  }

  // Base64 utility methods
  // Needed for: IE9-
  (function() {
    if ('atob' in global && 'btoa' in global)
      return;

    var B64_ALPHABET = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
    function atob(input) {
      input = String(input);
      var position = 0,
          output = [],
          buffer = 0, bits = 0, n;

      input = input.replace(/\s/g, '');
      if ((input.length % 4) === 0) { input = input.replace(/=+$/, ''); }
      if ((input.length % 4) === 1) { throw Error("InvalidCharacterError"); }
      if (/[^+/0-9A-Za-z]/.test(input)) { throw Error("InvalidCharacterError"); }

      while (position < input.length) {
        n = B64_ALPHABET.indexOf(input.charAt(position));
        buffer = (buffer << 6) | n;
        bits += 6;

        if (bits === 24) {
          output.push(String.fromCharCode((buffer >> 16) & 0xFF));
          output.push(String.fromCharCode((buffer >>  8) & 0xFF));
          output.push(String.fromCharCode(buffer & 0xFF));
          bits = 0;
          buffer = 0;
        }
        position += 1;
      }

      if (bits === 12) {
        buffer = buffer >> 4;
        output.push(String.fromCharCode(buffer & 0xFF));
      } else if (bits === 18) {
        buffer = buffer >> 2;
        output.push(String.fromCharCode((buffer >> 8) & 0xFF));
        output.push(String.fromCharCode(buffer & 0xFF));
      }

      return output.join('');
    };

    function btoa(input) {
      input = String(input);
      var position = 0,
          out = [],
          o1, o2, o3,
          e1, e2, e3, e4;

      if (/[^\x00-\xFF]/.test(input)) { throw Error("InvalidCharacterError"); }

      while (position < input.length) {
        o1 = input.charCodeAt(position++);
        o2 = input.charCodeAt(position++);
        o3 = input.charCodeAt(position++);

        // 111111 112222 222233 333333
        e1 = o1 >> 2;
        e2 = ((o1 & 0x3) << 4) | (o2 >> 4);
        e3 = ((o2 & 0xf) << 2) | (o3 >> 6);
        e4 = o3 & 0x3f;

        if (position === input.length + 2) {
          e3 = 64;
          e4 = 64;
        }
        else if (position === input.length + 1) {
          e4 = 64;
        }

        out.push(B64_ALPHABET.charAt(e1),
                 B64_ALPHABET.charAt(e2),
                 B64_ALPHABET.charAt(e3),
                 B64_ALPHABET.charAt(e4));
      }

      return out.join('');
    };

    global.atob = atob;
    global.btoa = btoa;
  }());

  // requestAnimationFrame - needed for IE9-
  (function() {
    if ('requestAnimationFrame' in global)
      return;

    var TARGET_FPS = 60,
        requests = Object.create(null),
        raf_handle = 0,
        timeout_handle = -1;

    function isVisible(element) {
      return element.offsetWidth > 0 && element.offsetHeight > 0;
    }

    function onFrameTimer() {
      var cur_requests = requests;
      requests = Object.create(null);
      timeout_handle = -1;
      Object.keys(cur_requests).forEach(function(id) {
        var request = cur_requests[id];
        if (!request.element || isVisible(request.element))
          request.callback(Date.now());
      });
    }

    function requestAnimationFrame(callback, element) {
      var cb_handle = ++raf_handle;
      requests[cb_handle] = {callback: callback, element: element};
      if (timeout_handle === -1)
        timeout_handle = global.setTimeout(onFrameTimer, 1000 / TARGET_FPS);
      return cb_handle;
    }

    function cancelAnimationFrame(handle) {
      delete requests[handle];
      if (Object.keys(requests).length === 0) {
        global.clearTimeout(timeout_handle);
        timeout_handle = -1;
      }
    }

    global.requestAnimationFrame = requestAnimationFrame;
    global.cancelAnimationFrame = cancelAnimationFrame;
  }());

}(self));

},{}],52:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var scriptLoader = require("../../js/utils/script-loader");
var $ = require("../../js/utils/dom");
var didomi_1 = require("../cmp/didomi");
exports.init = function () {
    if (!didomi_1.CmpDidomi.isConsentedPurpose(didomi_1.Purpose.ADS)) {
        return;
    }
    // loads ligatus, yahoo gemini... using data-role="load-script" selector
    scriptLoader.getScriptsToLoad().forEach(scriptLoader.ensureLoaded);
    $('.js-async').forEach(function (item) {
        var type = item.getAttribute('data-type');
        var url = item.getAttribute('data-src');
        if (type == "ligatus-script" && url) {
            scriptLoader.ensureLoaded(url);
        }
    });
};

},{"../../js/utils/dom":71,"../../js/utils/script-loader":77,"../cmp/didomi":57}],53:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var euconsent_cookie_1 = require("./euconsent-cookie");
var cnil_1 = require("../cnil/cnil");
var PingReturn = /** @class */ (function () {
    function PingReturn() {
    }
    return PingReturn;
}());
exports.PingReturn = PingReturn;
var VendorConsentData = /** @class */ (function () {
    function VendorConsentData() {
    }
    return VendorConsentData;
}());
exports.VendorConsentData = VendorConsentData;
var VendorConsents = /** @class */ (function () {
    function VendorConsents() {
    }
    return VendorConsents;
}());
exports.VendorConsents = VendorConsents;
function ping(callback) {
    var result = new PingReturn();
    result.gdprAppliesGlobaly = true;
    result.cmpLoaded = true;
    callback(result, true);
}
exports.ping = ping;
function getConsentData(consentStringVersion, callback) {
    var result = new VendorConsentData();
    result.gdprApplies = true;
    result.hasGlobalScope = true;
    if (euconsent_cookie_1.euconsent.cookie.exists()) {
        result.consentData = euconsent_cookie_1.euconsent.cookie.read().getConsentString();
    }
    else {
        result.consentData = euconsent_cookie_1.euconsent.newNoConsent().getConsentString();
    }
    callback(result, true);
}
exports.getConsentData = getConsentData;
function getVendorConsents(vendorsId, callback) {
    var consent = euconsent_cookie_1.euconsent.cookie.read();
    if (consent == null) {
        consent = euconsent_cookie_1.euconsent.newNoConsent();
    }
    var result = new VendorConsents();
    var purposeConsents = {};
    for (var _i = 0, _a = consent.getPurposesAllowed(); _i < _a.length; _i++) {
        var purpose = _a[_i];
        purposeConsents[purpose] = true;
    }
    var vendorConsents = {};
    for (var _b = 0, _c = consent.getVendorsAllowed(); _b < _c.length; _b++) {
        var vendor = _c[_b];
        if (vendorsId) {
            if (vendorsId.indexOf(vendor) != -1) {
                vendorConsents[vendor] = true;
            }
        }
        else {
            vendorConsents[vendor] = true;
        }
    }
    // clean consent to build metadata
    consent.setPurposesAllowed([]);
    consent.setVendorsAllowed([]);
    var metadata = consent.getConsentString();
    result.gdprApplies = true;
    result.hasGlobalScope = true;
    result.purposeConsents = purposeConsents;
    result.vendorConsents = vendorConsents;
    result.metadata = metadata;
    callback(result, true);
}
exports.getVendorConsents = getVendorConsents;
function onCnilCategoriesChange(event) {
    if (event.oldValue != null && event.oldValue.ads == event.value.ads) {
        return;
    }
    var consent = euconsent_cookie_1.euconsent.cookie.read();
    if (consent == null) {
        consent = euconsent_cookie_1.euconsent.newFullConsent();
    }
    if (event.value.ads) {
        consent.setPurposesAllowed(euconsent_cookie_1.euconsent.allPurposeIds());
        consent.setVendorsAllowed(euconsent_cookie_1.euconsent.allVendorIds());
    }
    else {
        consent.setPurposesAllowed([]);
        consent.setVendorsAllowed([]);
    }
    euconsent_cookie_1.euconsent.cookie.write(consent);
}
exports.onCnilCategoriesChange = onCnilCategoriesChange;
function __cmp(command, parameter, callback) {
    if (parameter === void 0) { parameter = null; }
    if (callback === void 0) { callback = null; }
    switch (command) {
        case 'ping':
            ping(callback);
            break;
        case 'getVendorConsents':
            getVendorConsents(parameter, callback);
            break;
        case 'getConsentData':
            getConsentData(parameter, callback);
            break;
        case 'showConsentTool':
            cnil_1.cnil.banner.showMainBanner();
            break;
        default:
            console.error('unsupported __cmp command');
    }
}
exports.__cmp = __cmp;

},{"../cnil/cnil":64,"./euconsent-cookie":58}],54:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * See http://prebid.org/dev-docs/modules/consentManagement.html on iframe and message usage
 */
var cmp_framework_1 = require("./cmp-framework");
function init() {
    window.addEventListener('message', onWindowMessage, false);
    ensureFrame();
}
exports.init = init;
function ensureFrame() {
    if (document.getElementsByName('__cmpLocator').length > 0) {
        return;
    }
    var iframe = document.createElement('iframe');
    iframe.name = '__cmpLocator';
    iframe.width = '0';
    iframe.height = '0';
    iframe.style.display = 'none';
    document.body.appendChild(iframe);
}
exports.ensureFrame = ensureFrame;
function onWindowMessage(event) {
    var json = event.data;
    var messageIsString = typeof json === "string";
    try {
        if (messageIsString) {
            json = JSON.parse(json);
        }
        var call_1 = json.__cmpCall;
        if (call_1) {
            cmp_framework_1.__cmp(call_1.command, call_1.parameter, function (result, success) {
                var returnMsg = {
                    __cmpReturn: {
                        returnValue: result, success: success, callId: call_1.callId
                    }
                };
                event.source.postMessage(messageIsString ? JSON.stringify(returnMsg) : returnMsg, '*');
            });
        }
    }
    catch (e) {
        // event.data was not well formatted or not targeted to us
    }
}
exports.onWindowMessage = onWindowMessage;

},{"./cmp-framework":53}],55:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var cmp_framework_1 = require("./cmp-framework");
var cnil_1 = require("../cnil/cnil");
var euconsent_cookie_1 = require("./euconsent-cookie");
var cmpIframe = require("./cmp-iframe");
window.__cmp = cmp_framework_1.__cmp;
// init euconsent cookie with cnil cookie if euconsent wasn't there
if (cnil_1.cnil.cookie.hasValidCookie() && !euconsent_cookie_1.euconsent.cookie.exists()) {
    cmp_framework_1.onCnilCategoriesChange({ value: cnil_1.cnil.cookie.readValues(), oldValue: null });
}
cnil_1.cnil.cookie.onChange(cmp_framework_1.onCnilCategoriesChange);
cmpIframe.init();

},{"../cnil/cnil":64,"./cmp-framework":53,"./cmp-iframe":54,"./euconsent-cookie":58}],56:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_OPTIONS = {
    name: 'rtl.fr',
    apiKey: '4801407c-7ff1-4aed-aa34-71b05434f911',
    logoUrl: 'https://cdn-static.rtl.fr/versions/www/6.0.816/img/logo-rtl-86x60.jpg',
    themeColor: '#E1001B',
    privacyPolicyURL: 'https://www.rtl.fr/cnil/charte-de-confidentialite'
};
exports.didomiConfig = function (options) {
    options = options || exports.DEFAULT_OPTIONS;
    options.name = options.name || exports.DEFAULT_OPTIONS.name;
    options.apiKey = options.apiKey || exports.DEFAULT_OPTIONS.apiKey;
    options.logoUrl = options.logoUrl || exports.DEFAULT_OPTIONS.logoUrl;
    options.themeColor = options.themeColor || exports.DEFAULT_OPTIONS.themeColor;
    options.privacyPolicyURL = options.privacyPolicyURL || exports.DEFAULT_OPTIONS.privacyPolicyURL;
    return {
        app: {
            name: options.name,
            apiKey: options.apiKey,
            logoUrl: options.logoUrl,
            privacyPolicyURL: options.privacyPolicyURL,
            gdprAppliesGlobally: true,
            gdprAppliesWhenUnknown: true,
            vendors: {
                didomi: ['google', 'amazon', 'facebook', 'twitter'],
                iab: {
                    all: true,
                    exclude: [740, 720, 723, 733, 718, 728, 717, 678, 721, 724, 729, 713, 707, 708, 737, 716, 719, 293, 744, 171]
                },
                custom: [
                    {
                        id: 'custom-vendor-osd',
                        name: 'OSD',
                        purposeIds: ['cookies', 'advertising_personalization', 'content_personalization', 'ad_delivery', 'analytics'],
                        policyUrl: ''
                    }
                ]
            },
            customPurposes: [
                {
                    id: 'audience_measurement',
                    name: {
                        fr: options.name + " - Mesure d'audience"
                    },
                    description: {
                        fr: "Ces cookies permettent d’établir des statistiques de fréquentation de nos services. Les désactiver nous empêche de suivre et d’améliorer la qualité de nos services."
                    }
                },
                {
                    id: 'targeted_advertising',
                    name: {
                        fr: options.name + " - Publicit\u00E9 cibl\u00E9e"
                    },
                    description: {
                        fr: "Ces cookies permettent d’analyser votre navigation et de définir vos centres d’intérêts pour vous proposer des publicités plus pertinentes. Les désactiver n’a aucun impact sur le volume de publicité que vous recevrez."
                    }
                },
                {
                    id: 'social_network',
                    name: {
                        fr: options.name + " - R\u00E9seaux sociaux"
                    },
                    description: {
                        fr: "Ces cookies vous permettent de partager des contenus avec d'autres personnes ou de faire connaître votre consultation ou votre opinion (boutons J'aime). Les désactiver peut vous empêcher de vous connecter à votre réseau social."
                    }
                }
            ]
        },
        notice: {
            enable: false,
            position: 'top',
            logoAlignment: 'center',
            closeOnClick: true,
            closeOnClickNavigationDelay: 500,
            closeOnClickBackdrop: true,
            daysBeforeShowingAgain: 360
        },
        preferences: {
            canCloseWhenConsentIsMissing: false,
            showWhenConsentIsMissing: true,
            enableAllButtons: true,
            information: {
                enable: true,
                content: {
                    popup: { fr: 'Votre vie privée nous importe' },
                    title: { fr: 'Votre vie privée nous importe' },
                    text: { fr: 'En poursuivant votre navigation sur notre service vous acceptez que le Groupe M6 et ses partenaires utilisent des traceurs (comme des cookies ou l’identifiant unique de votre appareil) et traitent des données à caractère personnel (comme vos données de navigation et votre adresse IP) dans le but : d’afficher de la publicité personnalisée en fonction de votre navigation et de votre profil, de personnaliser l’affichage de nos produits, services et contenus en fonction de ceux que vous avez précédemment consultés, de mesurer l’audience de notre service, de vous permettre de partager du contenu sur les réseaux sociaux. Vous pouvez choisir de ne pas consentir à ces exploitations en cliquant sur le bouton « Paramétrer mes choix » et modifier vos préférences à tout moment en cliquant sur le lien « Préférences Cookies » figurant sur notre service.' },
                    learnMore: { fr: 'Paramétrer mes choix' },
                    agreeAndClose: { fr: 'Accepter en continuant sur le site' }
                }
            },
            content: {
                title: { fr: 'Votre vie privée nous importe' },
                agreeToAll: { fr: 'Accepter tout' },
                disagreeToAll: { fr: 'Refuser tout' },
            },
            categories: [
                {
                    type: 'purpose',
                    purposeId: 'audience_measurement'
                },
                {
                    type: 'purpose',
                    purposeId: 'targeted_advertising'
                },
                {
                    type: 'purpose',
                    purposeId: 'social_network'
                }
            ]
        },
        languages: {
            enabled: ['fr'],
            default: 'fr'
        },
        theme: {
            color: '#D1D1D1',
            linkColor: options.themeColor,
            font: 'Arial',
            buttons: {
                regularButtons: {
                    backgroundColor: '#eeeeee',
                    textColor: '#212121',
                    borderColor: 'rgba(34, 34, 34, 0.2)',
                    borderWidth: '1px',
                    borderRadius: '0px'
                },
                highlightButtons: {
                    backgroundColor: options.themeColor,
                    textColor: '#ffffff',
                    borderColor: options.themeColor,
                    borderWidth: '1px',
                    borderRadius: '0px'
                }
            }
        },
        tagManager: {
            provider: 'gtm'
        },
        user: {
            bots: {
                consentRequired: false,
                types: ['crawlers', 'performance'],
                extraUserAgents: []
            },
            externalConsent: {
                enabled: true
            }
        }
    };
};

},{}],57:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var env = require("../env/env");
var $ = require("../../../assets/js/utils/dom");
var didomi_config_1 = require("./didomi-config");
var Purpose;
(function (Purpose) {
    Purpose["ANALYTICS"] = "audience_measurement";
    Purpose["ADS"] = "targeted_advertising";
    Purpose["SOCIAL"] = "social_network";
    Purpose["PERSONNALISATION"] = "personnalisation";
})(Purpose = exports.Purpose || (exports.Purpose = {}));
var RTLPurposeIds = {
    'audience_measurement': 'mesurerl-TH6fifgP',
    'targeted_advertising': 'publicite-qfTFazXj',
    'social_network': 'reseauxso-e7EUAMeD',
    'personnalisation': 'personnali-jCkrDhEj',
};
var FunRadioPurposeIds = {
    'audience_measurement': 'mesurerl-TH6fifgP',
    'targeted_advertising': 'publicite-qfTFazXj',
    'social_network': 'reseauxso-e7EUAMeD',
    'personnalisation': 'personnali-jCkrDhEj',
};
var CmpDidomi;
(function (CmpDidomi) {
    CmpDidomi.init = function (options) {
        window.gdprAppliesGlobally = true;
        options.apiKey = options.apiKey || didomi_config_1.DEFAULT_OPTIONS.apiKey;
        // @ts-ignore
        (function () { function a(e) { if (!window.frames[e]) {
            if (document.body && document.body.firstChild) {
                var t = document.body;
                var n = document.createElement("iframe");
                n.style.display = "none";
                n.name = e;
                n.title = e;
                t.insertBefore(n, t.firstChild);
            }
            else {
                setTimeout(function () { a(e); }, 5);
            }
        } } function e(n, r, o, c, s) { function e(e, t, n, a) { if (typeof n !== "function") {
            return;
        } if (!window[r]) {
            window[r] = [];
        } var i = false; if (s) {
            i = s(e, t, n);
        } if (!i) {
            window[r].push({ command: e, parameter: t, callback: n, version: a });
        } } e.stub = true; function t(a) { if (!window[n] || window[n].stub !== true) {
            return;
        } if (!a.data) {
            return;
        } var i = typeof a.data === "string"; var e; try {
            e = i ? JSON.parse(a.data) : a.data;
        }
        catch (t) {
            return;
        } if (e[o]) {
            var r = e[o];
            window[n](r.command, r.parameter, function (e, t) { var n = {}; n[c] = { returnValue: e, success: t, callId: r.callId }; a.source.postMessage(i ? JSON.stringify(n) : n, "*"); }, r.version);
        } } if (typeof window[n] !== "function") {
            window[n] = e;
            if (window.addEventListener) {
                window.addEventListener("message", t, false);
            }
            else {
                window.attachEvent("onmessage", t);
            }
        } } e("__tcfapi", "__tcfapiBuffer", "__tcfapiCall", "__tcfapiReturn"); a("__tcfapiLocator"); })();
        // @ts-ignore
        (function (e) { var t = document.createElement("script"); t.id = "spcloader"; t.type = "text/javascript"; t.async = true; t.src = "https://sdk.privacy-center.org/" + e + "/loader.js?target=" + document.location.hostname; t.charset = "utf-8"; var n = document.getElementsByTagName("script")[0]; n.parentNode.insertBefore(t, n); })(options.apiKey);
        CmpDidomi.attach('didomiOnReady', function (Didomi) {
            CmpDidomi.trackConsent();
        });
    };
    CmpDidomi.trackConsent = function () {
        CmpDidomi.attach('didomiOnReady', function (Didomi) {
            if (Didomi.notice.isVisible()) {
                var img = document.createElement('img');
                img.src = 'https://www.dahta.fr/c/cs';
                document.getElementsByTagName('body')[0].appendChild(img);
            }
        });
        CmpDidomi.attach('didomiEventListeners', {
            event: 'consent.changed',
            listener: function () {
                var statusForAll = window.Didomi.getUserConsentStatusForAll();
                var status = '';
                if (statusForAll.purposes.enabled.length > 0 && statusForAll.purposes.disabled.length === 0)
                    status = 'ca';
                else if (statusForAll.purposes.enabled.length === 0 && statusForAll.purposes.disabled.length > 0)
                    status = 'cr';
                else if (statusForAll.purposes.enabled.length > 0 && statusForAll.purposes.disabled.length > 0)
                    status = 'cp';
                var img = document.createElement('img');
                img.src = 'https://www.dahta.fr/c/' + status;
                document.getElementsByTagName('body')[0].appendChild(img);
            }
        });
    };
    CmpDidomi.isConsentedPurpose = function (purpose) {
        if (window.Didomi.isConsentRequired() == false) {
            return true;
        }
        var purposeId = CmpDidomi.toPurposeId(purpose);
        return window.Didomi.getUserConsentStatusForPurpose(purposeId) || false;
    };
    /**
     * can return true or false or undefined (if CMP is still displayed)
     */
    CmpDidomi.getUserConsentStatusForPurpose = function (purpose) {
        if (window.Didomi.isConsentRequired() == false) {
            return true;
        }
        var purposeId = CmpDidomi.toPurposeId(purpose);
        return window.Didomi.getUserConsentStatusForPurpose(purposeId);
    };
    CmpDidomi.attach = function (eventType, action) {
        window[eventType] = window[eventType] || [];
        window[eventType].push(action);
    };
    CmpDidomi.enablePurpose = function (purpose) {
        var purposeId = CmpDidomi.toPurposeId(purpose);
        var transaction = window.Didomi.openTransaction();
        transaction.enablePurpose(purposeId);
        transaction.commit();
    };
    /**
     * Calls fnDo then consent is available.
     * Otherwise wait for user to choose through displayed notice
     */
    CmpDidomi.waitForDidomiConsent = function (purpose, fnDo) {
        CmpDidomi.attach('didomiOnReady', function () {
            // avoid calling fnDo multiple times when receiving consent.changed
            var consumed = false;
            if (CmpDidomi.getUserConsentStatusForPurpose(purpose) == true || CmpDidomi.getUserConsentStatusForPurpose(purpose) == false) {
                consumed = true;
                fnDo();
                return;
            }
            CmpDidomi.attach('didomiEventListeners', {
                event: 'consent.changed',
                listener: function () {
                    if (!consumed) {
                        consumed = true;
                        fnDo();
                    }
                }
            });
            window.setTimeout(function () {
                if (!window.Didomi.notice.isVisible()) {
                    if (!consumed) {
                        consumed = true;
                        fnDo();
                    }
                }
            }, 1000);
        });
    };
    CmpDidomi.doOnDidomiConsent = function (purpose, fnDo, fnElseDo) {
        CmpDidomi.attach('didomiOnReady', function () {
            if (CmpDidomi.isConsentedPurpose(purpose)) {
                fnDo();
            }
            else {
                fnElseDo();
                CmpDidomi.attach('didomiEventListeners', {
                    event: 'consent.changed',
                    listener: function () {
                        if (CmpDidomi.isConsentedPurpose(purpose)) {
                            CmpDidomi.displayDidomiBanners(purpose, false);
                            fnDo();
                        }
                    }
                });
            }
        });
    };
    CmpDidomi.displayDidomiBanners = function (purpose, display) {
        var $banners = $(document.body).select("[data-role=cnil-banner][data-purpose=" + purpose + "]");
        if ($banners.length) {
            $banners.forEach(function (banner) { return $(banner).css('display', display ? 'block' : 'none'); });
        }
    };
    CmpDidomi.toPurposeId = function (purpose) {
        var ids = env.getDomain() == 'funradio.fr' ? FunRadioPurposeIds : RTLPurposeIds;
        return ids[purpose];
    };
})(CmpDidomi = exports.CmpDidomi || (exports.CmpDidomi = {}));

},{"../../../assets/js/utils/dom":71,"../env/env":65,"./didomi-config":56}],58:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var consent_string_1 = require("consent-string");
var cookies = require("js-cookie");
var vendor_list_1 = require("./vendor-list");
var cnil_cookie_1 = require("../cnil/cnil-cookie");
var env = require("../env/env");
var euconsent;
(function (euconsent) {
    euconsent.COOKIE_NAME = 'euconsent';
    euconsent.CMP_VERSION = 1;
    euconsent.CMP_ID = 136; // cmp id m6web
    function newFullConsent() {
        var consent = new consent_string_1.ConsentString();
        consent.setCmpId(euconsent.CMP_ID);
        consent.setCmpVersion(euconsent.CMP_VERSION);
        consent.setConsentLanguage('fr');
        consent.setGlobalVendorList(vendor_list_1.m6Vendors);
        consent.setPurposesAllowed(allPurposeIds());
        consent.setVendorsAllowed(allVendorIds());
        return consent;
    }
    euconsent.newFullConsent = newFullConsent;
    function newNoConsent() {
        var consent = new consent_string_1.ConsentString();
        consent.setCmpId(euconsent.CMP_ID);
        consent.setCmpVersion(euconsent.CMP_VERSION);
        consent.setConsentLanguage('fr');
        consent.setGlobalVendorList(vendor_list_1.m6Vendors);
        consent.setPurposesAllowed([]);
        consent.setVendorsAllowed([]);
        return consent;
    }
    euconsent.newNoConsent = newNoConsent;
    function allPurposeIds() {
        return vendor_list_1.m6Vendors.purposes.map(function (purpose) { return purpose.id; });
    }
    euconsent.allPurposeIds = allPurposeIds;
    function allVendorIds() {
        return vendor_list_1.m6Vendors.vendors.map(function (vendor) { return vendor.id; });
    }
    euconsent.allVendorIds = allVendorIds;
    var cookie;
    (function (cookie) {
        function exists() {
            return read() != null;
        }
        cookie.exists = exists;
        function read() {
            var value = cookies.get(euconsent.COOKIE_NAME);
            if (value) {
                var consent = new consent_string_1.ConsentString(value);
                consent.setGlobalVendorList(vendor_list_1.m6Vendors);
                return consent;
            }
            else {
                return null;
            }
        }
        cookie.read = read;
        function write(consent) {
            cookies.set(euconsent.COOKIE_NAME, consent.getConsentString(), { expires: cnil_cookie_1.COOKIE_DURATION, path: '/', domain: env.getCookieDomain() });
        }
        cookie.write = write;
    })(cookie = euconsent.cookie || (euconsent.cookie = {}));
})(euconsent = exports.euconsent || (exports.euconsent = {}));

},{"../cnil/cnil-cookie":63,"../env/env":65,"./vendor-list":59,"consent-string":43,"js-cookie":46}],59:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// M6 Web vendor list + gravity (WEBDEV-4026)
exports.m6Vendors = {
    "vendorListVersion": 153,
    // "lastUpdated": "2019-06-27T16:00:16Z",
    "purposes": [
        {
            "id": 1,
            "name": "Stockage d'informations et accès",
            "description": "Autoriser le stockage ou l'accès aux informations sur l'appareil d'un utilisateur. Selon le type de données qu'ils collectent, utilisent et traitent, ainsi que d'autres facteurs, y compris la vie privée dès la conception, certains partenaires dépendent de votre consentement tandis que d'autres vous demandent de vous désinscrire. Pour plus d'informations sur chaque fournisseur et pour exercer vos choix, voir ci-dessous."
        },
        {
            "id": 2,
            "name": "Personnalisation",
            "description": "Autoriser le traitement des données d'un utilisateur pour fournir et informer une publicité personnalisée (y compris la diffusion, la mesure et la création de rapports) en fonction des préférences ou des intérêts d'un utilisateur connus ou inférés à partir de données collectées sur plusieurs sites, applications ou appareils et / ou accéder ou stocker des informations sur des dispositifs à cette fin. Inclura les caractéristiques suivantes: Correspondance des données aux sources déconnectées - combinant des données provenant de sources hors ligne initialement collectées dans d'autres contextes. Liaison de périphériques - permet le traitement des données d'un utilisateur pour connecter un tel utilisateur sur plusieurs périphériques. Données géographiques précises - permettent le traitement des données géographiques précises d'un utilisateur à l'appui d'une fin pour laquelle ce tiers a donné son consentement. Selon le type de données qu'ils collectent, utilisent et traitent, ainsi que d'autres facteurs, y compris la vie privée dès la conception, certains partenaires dépendent de votre consentement tandis que d'autres vous demandent de vous désinscrire. Pour plus d'informations sur chaque fournisseur et pour exercer vos choix, voir ci-dessous."
        },
        {
            "id": 3,
            "name": "Sélection d'annonce, livraison, analyse",
            "description": "La collecte d'informations, et la combinaison avec des informations précédemment collectées, pour sélectionner et livrer des publicités pour vous, et pour mesurer la livraison et l'efficacité de ces publicités. Cela inclut l'utilisation d'informations précédemment collectées sur vos centres d'intérêt pour sélectionner des publicités, le traitement des données affichées, la fréquence à laquelle elles ont été diffusées, le moment et l'endroit où elles ont été diffusées. annonce ou faire un achat. Cela n'inclut pas la personnalisation, qui est la collecte et le traitement d'informations sur votre utilisation de ce service pour ensuite personnaliser la publicité et / ou le contenu pour vous dans d'autres contextes, tels que des sites Web ou des applications, au fil du temps."
        },
        {
            "id": 4,
            "name": "Sélection de contenu, livraison, analyse",
            "description": "Autoriser le traitement des données d'un utilisateur pour fournir du contenu ou des publicités et mesurer la diffusion de ces contenus ou publicités, extraire des informations et générer des rapports pour comprendre l'utilisation des services; et / ou accéder ou stocker des informations sur des dispositifs à cette fin. Inclura les caractéristiques suivantes: Correspondance des données aux sources déconnectées - combinant des données provenant de sources hors ligne initialement collectées dans d'autres contextes. Liaison de périphériques - permet le traitement des données d'un utilisateur pour connecter un tel utilisateur sur plusieurs périphériques. Données géographiques précises - permettent le traitement des données géographiques précises d'un utilisateur à l'appui d'une fin pour laquelle ce tiers a donné son consentement. Selon le type de données qu'ils collectent, utilisent et traitent, ainsi que d'autres facteurs, y compris la vie privée dès la conception, certains partenaires dépendent de votre consentement tandis que d'autres vous demandent de vous désinscrire. Pour plus d'informations sur chaque fournisseur et pour exercer vos choix, voir ci-dessous."
        },
        {
            "id": 5,
            "name": "La mesure",
            "description": "Ce que cela signifie: La collecte d'informations sur votre utilisation du contenu, et la combinaison avec des informations précédemment collectées, utilisées pour mesurer, comprendre et rendre compte de votre utilisation du service. Cela n'inclut pas la personnalisation, la collecte d'informations sur votre utilisation de ce service pour personnaliser ultérieurement le contenu et / ou la publicité dans d'autres contextes, par exemple sur d'autres services, tels que des sites Web ou des applications. Selon le type de données qu'ils collectent, utilisent et traitent, ainsi que d'autres facteurs, y compris la vie privée dès la conception, certains partenaires dépendent de votre consentement tandis que d'autres vous demandent de vous désinscrire. Pour plus d'informations sur chaque fournisseur et pour exercer vos choix, voir ci-dessous."
        }
    ],
    "features": [
        {
            "id": 1,
            "name": "Matching Data to Offline Sources",
            "description": "Combining data from offline sources that were initially collected in other contexts."
        },
        {
            "id": 2,
            "name": "Linking Devices",
            "description": "Allow processing of a user's data to connect such user across multiple devices."
        },
        {
            "id": 3,
            "name": "Precise Geographic Location Data",
            "description": "Allow processing of a user's precise geographic location data in support of a purpose for which that certain third party has consent."
        }
    ],
    "vendors": [
        {
            "id": 8,
            "name": "Emerse Sverige AB",
            "policyUrl": "https://www.emerse.com/privacy-policy/",
            "purposeIds": [
                1,
                2,
                4
            ],
            "legIntPurposeIds": [
                3,
                5
            ],
            "featureIds": [
                1,
                2
            ]
        },
        {
            "id": 12,
            "name": "BeeswaxIO Corporation",
            "policyUrl": "https://www.beeswax.com/privacy.html",
            "purposeIds": [
                1,
                3,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                3
            ]
        },
        {
            "id": 28,
            "name": "TripleLift, Inc.",
            "policyUrl": "https://triplelift.com/privacy/",
            "purposeIds": [
                1,
                3
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                3
            ]
        },
        {
            "id": 27,
            "name": "ADventori SAS",
            "policyUrl": "https://www.adventori.com/with-us/legal-notice/",
            "purposeIds": [
                1,
                3
            ],
            "legIntPurposeIds": [],
            "featureIds": []
        },
        {
            "id": 25,
            "name": "Oath (EMEA) Limited",
            "policyUrl": "https://policies.oath.com/ie/en/oath/privacy/index.html",
            "purposeIds": [
                1,
                2
            ],
            "legIntPurposeIds": [
                3,
                5
            ],
            "featureIds": [
                1,
                2,
                3
            ]
        },
        {
            "id": 26,
            "name": "Venatus Media Limited",
            "policyUrl": "https://www.venatusmedia.com/privacy/",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": []
        },
        {
            "id": 1,
            "name": "Exponential Interactive, Inc",
            "policyUrl": "http://exponential.com/privacy",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": []
        },
        {
            "id": 6,
            "name": "AdSpirit GmbH",
            "policyUrl": "http://www.adspirit.de/privacy",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": []
        },
        {
            "id": 30,
            "name": "BidTheatre AB",
            "policyUrl": "https://www.bidtheatre.com/privacy-policy",
            "purposeIds": [
                2
            ],
            "legIntPurposeIds": [
                1,
                3
            ],
            "featureIds": [
                2,
                3
            ]
        },
        {
            "id": 24,
            "name": "Conversant Europe Ltd.",
            "policyUrl": "https://www.conversantmedia.eu/legal/privacy-policy",
            "purposeIds": [
                1
            ],
            "legIntPurposeIds": [
                2,
                3,
                4,
                5
            ],
            "featureIds": [
                1,
                2,
                3
            ]
        },
        {
            "id": 29,
            "name": "Etarget SE",
            "policyUrl": "https://www.etarget.sk/privacy.php",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                1
            ]
        },
        {
            "id": 39,
            "name": "ADITION technologies AG",
            "policyUrl": "https://www.adition.com/datenschutz",
            "purposeIds": [
                1
            ],
            "legIntPurposeIds": [
                2,
                3,
                4,
                5
            ],
            "featureIds": [
                1,
                2,
                3
            ]
        },
        {
            "id": 11,
            "name": "Quantcast International Limited",
            "policyUrl": "https://www.quantcast.com/privacy/",
            "purposeIds": [
                1
            ],
            "legIntPurposeIds": [
                2,
                3,
                4,
                5
            ],
            "featureIds": [
                1,
                2
            ]
        },
        {
            "id": 15,
            "name": "Adikteev / Emoteev",
            "policyUrl": "https://www.adikteev.com/eu/privacy/",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": []
        },
        {
            "id": 4,
            "name": "Roq.ad GmbH",
            "policyUrl": "https://www.roq.ad/privacy-policy",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                2,
                3
            ]
        },
        {
            "id": 7,
            "name": "Vibrant Media Limited",
            "policyUrl": "https://www.vibrantmedia.com/en/privacy-policy/",
            "purposeIds": [
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [
                1
            ],
            "featureIds": []
        },
        {
            "id": 2,
            "name": "Captify Technologies Limited",
            "policyUrl": "http://www.captify.co.uk/privacy-policy/",
            "purposeIds": [
                1,
                2,
                3
            ],
            "legIntPurposeIds": [
                5
            ],
            "featureIds": [
                2
            ]
        },
        {
            "id": 37,
            "name": "NEURAL.ONE",
            "policyUrl": "https://web.neural.one/privacy-policy/",
            "purposeIds": [
                1,
                2,
                3,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                1,
                2
            ]
        },
        {
            "id": 13,
            "name": "Sovrn Holdings Inc",
            "policyUrl": "https://www.sovrn.com/sovrn-privacy/",
            "purposeIds": [
                1,
                2,
                3
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                2,
                3
            ]
        },
        {
            "id": 34,
            "name": "NEORY GmbH",
            "policyUrl": "https://www.neory.com/privacy.html",
            "purposeIds": [
                1,
                2,
                4,
                5
            ],
            "legIntPurposeIds": [
                3
            ],
            "featureIds": []
        },
        {
            "id": 32,
            "name": "AppNexus Inc.",
            "policyUrl": "https://www.appnexus.com/en/company/platform-privacy-policy",
            "purposeIds": [
                1
            ],
            "legIntPurposeIds": [
                3
            ],
            "featureIds": [
                2,
                3
            ]
        },
        {
            "id": 10,
            "name": "Index Exchange, Inc. ",
            "policyUrl": "https://www.indexexchange.com/privacy",
            "purposeIds": [
                1
            ],
            "legIntPurposeIds": [
                3
            ],
            "featureIds": [
                2,
                3
            ]
        },
        {
            "id": 57,
            "name": "ADARA MEDIA UNLIMITED",
            "policyUrl": "https://adara.com/privacy-promise/",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                1,
                2
            ]
        },
        {
            "id": 63,
            "name": "Avocet Systems Limited",
            "policyUrl": "http://www.avocet.io/privacy-policy",
            "purposeIds": [],
            "legIntPurposeIds": [
                1,
                3
            ],
            "featureIds": []
        },
        {
            "id": 51,
            "name": "xAd, Inc. dba GroundTruth",
            "policyUrl": "https://www.groundtruth.com/privacy-policy/",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                1,
                2,
                3
            ]
        },
        {
            "id": 49,
            "name": "Tradelab, SAS",
            "policyUrl": "http://tradelab.com/en/privacy/",
            "purposeIds": [
                1,
                2,
                3
            ],
            "legIntPurposeIds": [
                5
            ],
            "featureIds": [
                1,
                2,
                3
            ]
        },
        {
            "id": 45,
            "name": "Smart Adserver",
            "policyUrl": "https://smartadserver.com/end-user-privacy-policy/",
            "purposeIds": [
                1
            ],
            "legIntPurposeIds": [
                3,
                5
            ],
            "featureIds": [
                3
            ]
        },
        {
            "id": 52,
            "name": "The Rubicon Project, Inc. ",
            "policyUrl": "http://www.rubiconproject.com/rubicon-project-yield-optimization-privacy-policy/",
            "purposeIds": [
                1
            ],
            "legIntPurposeIds": [
                2,
                3,
                4,
                5
            ],
            "featureIds": [
                3
            ]
        },
        {
            "id": 71,
            "name": "Dataxu, Inc. ",
            "policyUrl": "https://www.dataxu.com/about-us/privacy/data-collection-platform/",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                1,
                2,
                3
            ]
        },
        {
            "id": 79,
            "name": "MediaMath, Inc.",
            "policyUrl": "http://www.mediamath.com/privacy-policy/",
            "purposeIds": [
                1
            ],
            "legIntPurposeIds": [
                2,
                3,
                4,
                5
            ],
            "featureIds": [
                1,
                2,
                3
            ]
        },
        {
            "id": 91,
            "name": "Criteo SA",
            "policyUrl": "https://www.criteo.com/privacy/",
            "purposeIds": [
                1,
                2,
                3
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                1,
                2
            ]
        },
        {
            "id": 85,
            "name": "Crimtan Holdings Limited",
            "policyUrl": "https://crimtan.com/privacy/",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                1,
                2,
                3
            ]
        },
        {
            "id": 16,
            "name": "RTB House S.A.",
            "policyUrl": "https://www.rtbhouse.com/privacy/",
            "purposeIds": [
                1,
                3
            ],
            "legIntPurposeIds": [],
            "featureIds": []
        },
        {
            "id": 86,
            "name": "Scene Stealer Limited",
            "policyUrl": "http://scenestealer.tv/privacy-policy/",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                3
            ]
        },
        {
            "id": 94,
            "name": "Blis Media Limited",
            "policyUrl": "http://www.blis.com/privacy/",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                1,
                2,
                3
            ]
        },
        {
            "id": 73,
            "name": "Simplifi Holdings Inc.",
            "policyUrl": "https://www.simpli.fi/site-privacy-policy2/",
            "purposeIds": [
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [
                1
            ],
            "featureIds": [
                2,
                3
            ]
        },
        {
            "id": 33,
            "name": "ShareThis, Inc.",
            "policyUrl": "http://www.sharethis.com/privacy/",
            "purposeIds": [
                1,
                2,
                3,
                4
            ],
            "legIntPurposeIds": [
                5
            ],
            "featureIds": [
                2
            ]
        },
        {
            "id": 20,
            "name": "N Technologies Inc.",
            "policyUrl": "https://n.rich/privacy-notice",
            "purposeIds": [],
            "legIntPurposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "featureIds": [
                2
            ]
        },
        {
            "id": 55,
            "name": "Madison Logic, Inc.",
            "policyUrl": "https://www.madisonlogic.com/privacy/",
            "purposeIds": [],
            "legIntPurposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "featureIds": [
                1,
                2,
                3
            ]
        },
        {
            "id": 53,
            "name": "Sirdata",
            "policyUrl": "https://www.sirdata.com/privacy/",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                1,
                2
            ]
        },
        {
            "id": 69,
            "name": "OpenX",
            "policyUrl": "https://www.openx.com/legal/privacy-policy/",
            "purposeIds": [
                1,
                2,
                3
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                1,
                2,
                3
            ]
        },
        {
            "id": 98,
            "name": "GroupM",
            "policyUrl": "https://www.groupm.com/privacy-policy",
            "purposeIds": [
                1,
                2,
                3,
                4
            ],
            "legIntPurposeIds": [
                5
            ],
            "featureIds": [
                1,
                2,
                3
            ]
        },
        {
            "id": 62,
            "name": "Justpremium BV",
            "policyUrl": "http://justpremium.com/privacy-policy/",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": []
        },
        {
            "id": 19,
            "name": "Intent Media, Inc.",
            "policyUrl": "https://intentmedia.com/privacy-policy/",
            "purposeIds": [
                1
            ],
            "legIntPurposeIds": [
                2,
                3,
                4,
                5
            ],
            "featureIds": [
                2
            ]
        },
        {
            "id": 43,
            "name": "Vdopia DBA Chocolate Platform",
            "policyUrl": "https://chocolateplatform.com/privacy-policy/",
            "purposeIds": [
                1,
                3
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                3
            ]
        },
        {
            "id": 36,
            "name": "RhythmOne, LLC",
            "policyUrl": "https://www.rhythmone.com/privacy-policy",
            "purposeIds": [
                5
            ],
            "legIntPurposeIds": [
                1,
                2,
                3,
                4
            ],
            "featureIds": [
                1,
                2,
                3
            ]
        },
        {
            "id": 80,
            "name": "Sharethrough, Inc",
            "policyUrl": "https://platform-cdn.sharethrough.com/privacy-policy",
            "purposeIds": [
                3,
                5
            ],
            "legIntPurposeIds": [
                1
            ],
            "featureIds": []
        },
        {
            "id": 81,
            "name": "PulsePoint, Inc.",
            "policyUrl": "https://www.pulsepoint.com/privacy-policy",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                1,
                2,
                3
            ]
        },
        {
            "id": 23,
            "name": "Amobee, Inc. ",
            "policyUrl": "https://www.amobee.com/trust/privacy-guidelines",
            "purposeIds": [
                1
            ],
            "legIntPurposeIds": [
                2,
                3,
                4,
                5
            ],
            "featureIds": [
                1,
                2,
                3
            ]
        },
        {
            "id": 75,
            "name": "M32 Connect Inc",
            "policyUrl": "https://m32.media/privacy-cookie-policy/",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                3
            ]
        },
        {
            "id": 17,
            "name": "Greenhouse Group BV (with its trademark LemonPI)",
            "policyUrl": "https://www.lemonpi.io/privacy-policy/",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                2
            ]
        },
        {
            "id": 61,
            "name": "GumGum, Inc.",
            "policyUrl": "https://gumgum.com/privacy-policy",
            "purposeIds": [
                1,
                2,
                3,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                3
            ]
        },
        {
            "id": 40,
            "name": "Active Agent AG",
            "policyUrl": "http://www.active-agent.com/de/unternehmen/datenschutzerklaerung/",
            "purposeIds": [],
            "legIntPurposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "featureIds": [
                1,
                2,
                3
            ]
        },
        {
            "id": 76,
            "name": "PubMatic, Inc.",
            "policyUrl": "https://pubmatic.com/privacy-policy/",
            "purposeIds": [
                1
            ],
            "legIntPurposeIds": [
                2,
                3,
                4,
                5
            ],
            "featureIds": []
        },
        {
            "id": 89,
            "name": "Tapad, Inc. ",
            "policyUrl": "https://www.tapad.com/privacy",
            "purposeIds": [
                1
            ],
            "legIntPurposeIds": [
                2,
                3,
                5
            ],
            "featureIds": [
                2
            ]
        },
        {
            "id": 46,
            "name": "Skimbit Ltd",
            "policyUrl": "https://skimlinks.com/pages/privacy-policy",
            "purposeIds": [
                1,
                2,
                3
            ],
            "legIntPurposeIds": [
                5
            ],
            "featureIds": [
                2
            ]
        },
        {
            "id": 66,
            "name": "adsquare GmbH",
            "policyUrl": "https://www.adsquare.com/privacy",
            "purposeIds": [
                1,
                2,
                3,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                1,
                2,
                3
            ]
        },
        {
            "id": 105,
            "name": "Impression Desk Technologies Limited",
            "policyUrl": "https://impressiondesk.com/privacy-policy/",
            "purposeIds": [
                1,
                3,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                2,
                3
            ]
        },
        {
            "id": 41,
            "name": "Adverline",
            "policyUrl": "https://www.adverline.com/privacy/",
            "purposeIds": [
                2
            ],
            "legIntPurposeIds": [
                1,
                3
            ],
            "featureIds": []
        },
        {
            "id": 82,
            "name": "Smaato, Inc.",
            "policyUrl": "https://www.smaato.com/privacy/",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                3
            ]
        },
        {
            "id": 60,
            "name": "Rakuten Marketing LLC",
            "policyUrl": "https://rakutenmarketing.com/legal-notices/services-privacy-policy",
            "purposeIds": [
                1
            ],
            "legIntPurposeIds": [
                2,
                3,
                4,
                5
            ],
            "featureIds": [
                1,
                2,
                3
            ]
        },
        {
            "id": 70,
            "name": "Yieldlab AG",
            "policyUrl": "http://www.yieldlab.de/meta-navigation/datenschutz/",
            "purposeIds": [],
            "legIntPurposeIds": [
                1,
                3
            ],
            "featureIds": [
                3
            ]
        },
        {
            "id": 50,
            "name": "Adform A/S",
            "policyUrl": "https://site.adform.com/privacy-policy-opt-out/",
            "purposeIds": [
                1
            ],
            "legIntPurposeIds": [
                2,
                3,
                4,
                5
            ],
            "featureIds": [
                1,
                2
            ]
        },
        {
            "id": 48,
            "name": "NetSuccess, s.r.o.",
            "policyUrl": "https://www.inres.sk/pp/",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                1,
                2,
                3
            ]
        },
        {
            "id": 100,
            "name": "Fifty Technology Limited",
            "policyUrl": "https://fifty.io/privacy-policy.php",
            "purposeIds": [
                1,
                2,
                3
            ],
            "legIntPurposeIds": [
                5
            ],
            "featureIds": []
        },
        {
            "id": 21,
            "name": "The Trade Desk",
            "policyUrl": "https://www.thetradedesk.com/general/privacy-policy",
            "purposeIds": [
                1,
                2
            ],
            "legIntPurposeIds": [
                3,
                5
            ],
            "featureIds": [
                1,
                2,
                3
            ]
        },
        {
            "id": 110,
            "name": "Hottraffic BV (DMA Institute)",
            "policyUrl": "https://www.dma-institute.com/privacy-compliancy/",
            "purposeIds": [
                1,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": []
        },
        {
            "id": 42,
            "name": "Taboola Europe Limited",
            "policyUrl": "https://www.taboola.com/privacy-policy",
            "purposeIds": [
                1
            ],
            "legIntPurposeIds": [
                2,
                3,
                4,
                5
            ],
            "featureIds": [
                1,
                2
            ]
        },
        {
            "id": 112,
            "name": "Maytrics GmbH",
            "policyUrl": "https://maytrics.com/node/2",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": []
        },
        {
            "id": 77,
            "name": "comScore, Inc.",
            "policyUrl": "https://www.comscore.com/About-comScore/Privacy-Policy",
            "purposeIds": [
                1,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                2
            ]
        },
        {
            "id": 109,
            "name": "LoopMe Ltd",
            "policyUrl": "https://loopme.com/privacy/",
            "purposeIds": [
                1,
                2,
                3,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                1,
                2,
                3
            ]
        },
        {
            "id": 120,
            "name": "Eyeota Ptd Ltd",
            "policyUrl": "https://www.eyeota.com/privacy-policy/",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                1
            ]
        },
        {
            "id": 93,
            "name": "Adloox SA",
            "policyUrl": "http://adloox.com/disclaimer",
            "purposeIds": [],
            "legIntPurposeIds": [
                5
            ],
            "featureIds": []
        },
        {
            "id": 132,
            "name": "Teads ",
            "policyUrl": "https://teads.tv/privacy-policy/",
            "purposeIds": [
                1,
                2
            ],
            "legIntPurposeIds": [
                3,
                4,
                5
            ],
            "featureIds": [
                1,
                2
            ]
        },
        {
            "id": 22,
            "name": "admetrics GmbH",
            "policyUrl": "https://admetrics.io/en/privacy_policy/",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": []
        },
        {
            "id": 102,
            "name": "SlimCut Media SAS",
            "policyUrl": "http://www.slimcutmedia.com/privacy-policy/",
            "purposeIds": [
                1,
                2
            ],
            "legIntPurposeIds": [
                3
            ],
            "featureIds": []
        },
        {
            "id": 108,
            "name": "Rich Audience",
            "policyUrl": "https://richaudience.com/privacy/",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                3
            ]
        },
        {
            "id": 18,
            "name": "Widespace AB",
            "policyUrl": "https://www.widespace.com/legal/privacy-policy-notice/",
            "purposeIds": [
                1,
                2,
                3
            ],
            "legIntPurposeIds": [],
            "featureIds": []
        },
        {
            "id": 68,
            "name": "Sizmek Technologies, Inc. ",
            "policyUrl": "https://www.sizmek.com/privacy-policy/",
            "purposeIds": [
                1
            ],
            "legIntPurposeIds": [
                2,
                3,
                4,
                5
            ],
            "featureIds": [
                2
            ]
        },
        {
            "id": 122,
            "name": "Avid Media Ltd",
            "policyUrl": "http://www.avidglobalmedia.eu/privacy-policy.html",
            "purposeIds": [
                1,
                2,
                3
            ],
            "legIntPurposeIds": [],
            "featureIds": []
        },
        {
            "id": 97,
            "name": "LiveRamp, Inc.",
            "policyUrl": "https://www.liveramp.com/service-privacy-policy/",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                1,
                2
            ]
        },
        {
            "id": 74,
            "name": "Admotion SRL",
            "policyUrl": "http://www.admotion.com/policy/",
            "purposeIds": [
                1,
                3
            ],
            "legIntPurposeIds": [],
            "featureIds": []
        },
        {
            "id": 138,
            "name": "ConnectAd Realtime GmbH",
            "policyUrl": "http://connectadrealtime.com/privacy/",
            "purposeIds": [
                1
            ],
            "legIntPurposeIds": [
                3
            ],
            "featureIds": []
        },
        {
            "id": 72,
            "name": "Nano Interactive GmbH",
            "policyUrl": "http://www.nanointeractive.com/privacy",
            "purposeIds": [],
            "legIntPurposeIds": [
                1,
                2,
                3,
                5
            ],
            "featureIds": []
        },
        {
            "id": 127,
            "name": "PIXIMEDIA SAS",
            "policyUrl": "https://piximedia.com/privacy/",
            "purposeIds": [
                1,
                2,
                4
            ],
            "legIntPurposeIds": [
                3,
                5
            ],
            "featureIds": [
                3
            ]
        },
        {
            "id": 136,
            "name": "Str\u00f6er SSP GmbH",
            "policyUrl": "https://www.stroeer.de/fileadmin/user_upload/Datenschutz.pdf",
            "purposeIds": [],
            "legIntPurposeIds": [
                1,
                2,
                3,
                5
            ],
            "featureIds": [
                2,
                3
            ]
        },
        {
            "id": 111,
            "name": "ShowHeroes GmbH",
            "policyUrl": "http://showheroes.com/privacy",
            "purposeIds": [],
            "legIntPurposeIds": [
                5
            ],
            "featureIds": [
                3
            ]
        },
        {
            "id": 56,
            "name": "Confiant Inc.",
            "policyUrl": "https://www.confiant.com/privacy",
            "purposeIds": [
                1
            ],
            "legIntPurposeIds": [],
            "featureIds": []
        },
        {
            "id": 124,
            "name": "Teemo SA",
            "policyUrl": "https://teemo.co/fr/confidentialite/",
            "purposeIds": [
                1,
                2,
                3,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                3
            ]
        },
        {
            "id": 154,
            "name": "YOC AG",
            "policyUrl": "https://yoc.com/privacy/",
            "purposeIds": [
                1,
                2
            ],
            "legIntPurposeIds": [
                3,
                5
            ],
            "featureIds": [
                3
            ]
        },
        {
            "id": 38,
            "name": "Beemray Oy",
            "policyUrl": "https://www.beemray.com/privacy-policy/",
            "purposeIds": [
                1,
                2,
                3,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                3
            ]
        },
        {
            "id": 101,
            "name": "MiQ",
            "policyUrl": "http://wearemiq.com/privacy-policy/",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                1,
                2,
                3
            ]
        },
        {
            "id": 149,
            "name": "ADman Interactive SL",
            "policyUrl": "http://admanmedia.com/politica",
            "purposeIds": [
                1,
                2,
                3
            ],
            "legIntPurposeIds": [
                5
            ],
            "featureIds": []
        },
        {
            "id": 151,
            "name": "Admedo Ltd",
            "policyUrl": "https://www.admedo.com/privacy-policy",
            "purposeIds": [],
            "legIntPurposeIds": [
                1,
                2,
                3
            ],
            "featureIds": [
                3
            ]
        },
        {
            "id": 153,
            "name": "MADVERTISE MEDIA",
            "policyUrl": "https://madvertise.com/en/gdpr/",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                1,
                2,
                3
            ]
        },
        {
            "id": 159,
            "name": "Underdog Media LLC ",
            "policyUrl": "https://underdogmedia.com/privacy-policy/",
            "purposeIds": [
                1,
                2,
                3,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": []
        },
        {
            "id": 157,
            "name": "Seedtag Advertising S.L",
            "policyUrl": "https://www.seedtag.com/en/privacy-policy/",
            "purposeIds": [
                1,
                2,
                3
            ],
            "legIntPurposeIds": [],
            "featureIds": []
        },
        {
            "id": 145,
            "name": "Snapsort Inc., operating as Sortable",
            "policyUrl": "https://sortable.com/privacy",
            "purposeIds": [
                1,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": []
        },
        {
            "id": 131,
            "name": "ID5 Technology SAS",
            "policyUrl": "https://www.id5.io/privacy",
            "purposeIds": [
                1
            ],
            "legIntPurposeIds": [],
            "featureIds": []
        },
        {
            "id": 158,
            "name": "Reveal Mobile, Inc",
            "policyUrl": "https://revealmobile.com/privacy",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                1,
                2,
                3
            ]
        },
        {
            "id": 147,
            "name": "Adacado Technologies Inc. (DBA Adacado)",
            "policyUrl": "https://www.adacado.com/privacy-policy-april-25-2018/",
            "purposeIds": [
                1,
                2,
                3
            ],
            "legIntPurposeIds": [],
            "featureIds": []
        },
        {
            "id": 130,
            "name": "AdRoll Inc",
            "policyUrl": "https://www.adrollgroup.com/privacy",
            "purposeIds": [
                1
            ],
            "legIntPurposeIds": [
                2,
                3
            ],
            "featureIds": [
                1,
                2
            ]
        },
        {
            "id": 129,
            "name": "IPONWEB GmbH",
            "policyUrl": "https://www.iponweb.com/privacy-policy/",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                1,
                2,
                3
            ]
        },
        {
            "id": 128,
            "name": "BIDSWITCH GmbH",
            "policyUrl": "http://www.bidswitch.com/privacy-policy/",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                1,
                2,
                3
            ]
        },
        {
            "id": 168,
            "name": "EASYmedia GmbH",
            "policyUrl": "https://login.rtbmarket.com/gdpr",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                1,
                2,
                3
            ]
        },
        {
            "id": 164,
            "name": "Outbrain UK Ltd",
            "policyUrl": "https://www.outbrain.com/legal/",
            "purposeIds": [
                1,
                2,
                3,
                5
            ],
            "legIntPurposeIds": [
                4
            ],
            "featureIds": [
                1
            ]
        },
        {
            "id": 144,
            "name": "district m inc.",
            "policyUrl": "https://districtm.net/en/page/platforms-data-and-privacy-policy/",
            "purposeIds": [
                1,
                2,
                3,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": []
        },
        {
            "id": 163,
            "name": "Bombora Inc.",
            "policyUrl": "https://bombora.com/privacy",
            "purposeIds": [
                1,
                2
            ],
            "legIntPurposeIds": [
                3,
                4,
                5
            ],
            "featureIds": [
                1,
                2
            ]
        },
        {
            "id": 173,
            "name": "Yieldmo, Inc.",
            "policyUrl": "https://www.yieldmo.com/privacy/",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                1,
                2,
                3
            ]
        },
        {
            "id": 88,
            "name": "TreSensa, Inc.",
            "policyUrl": "https://www.tresensa.com/eu-privacy",
            "purposeIds": [
                1
            ],
            "legIntPurposeIds": [
                2,
                3
            ],
            "featureIds": []
        },
        {
            "id": 78,
            "name": "Flashtalking, Inc.",
            "policyUrl": "http://www.flashtalking.com/privacypolicy/",
            "purposeIds": [
                1
            ],
            "legIntPurposeIds": [],
            "featureIds": []
        },
        {
            "id": 59,
            "name": "Sift Media, Inc",
            "policyUrl": "https://www.sift.co/privacy",
            "purposeIds": [
                1,
                2,
                3
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                3
            ]
        },
        {
            "id": 114,
            "name": "Sublime",
            "policyUrl": "http://ayads.co/privacy.php",
            "purposeIds": [
                1,
                2,
                3
            ],
            "legIntPurposeIds": [
                5
            ],
            "featureIds": []
        },
        {
            "id": 175,
            "name": "FORTVISION",
            "policyUrl": "http://fortvision.com/POC/index.html",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": []
        },
        {
            "id": 133,
            "name": "digitalAudience",
            "policyUrl": "https://digitalaudience.io/legal/privacy-cookies/",
            "purposeIds": [
                1,
                3,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                1,
                2,
                3
            ]
        },
        {
            "id": 14,
            "name": "Adkernel LLC",
            "policyUrl": "http://adkernel.com/privacy-policy/",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                2,
                3
            ]
        },
        {
            "id": 180,
            "name": "Thirdpresence Oy",
            "policyUrl": "http://www.thirdpresence.com/privacy",
            "purposeIds": [
                1
            ],
            "legIntPurposeIds": [
                3
            ],
            "featureIds": [
                3
            ]
        },
        {
            "id": 183,
            "name": "EMX Digital LLC",
            "policyUrl": "https://emxdigital.com/privacy/",
            "purposeIds": [
                1,
                2
            ],
            "legIntPurposeIds": [
                3,
                4,
                5
            ],
            "featureIds": [
                2,
                3
            ]
        },
        {
            "id": 58,
            "name": "33Across",
            "policyUrl": "http://www.33across.com/privacy-policy",
            "purposeIds": [
                1,
                2,
                3,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                2
            ]
        },
        {
            "id": 140,
            "name": "Platform161",
            "policyUrl": "https://platform161.com/cookie-and-privacy-policy/",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": []
        },
        {
            "id": 90,
            "name": "Teroa S.A.",
            "policyUrl": "https://www.e-planning.net/en/privacy.html",
            "purposeIds": [
                1
            ],
            "legIntPurposeIds": [
                2,
                3,
                4,
                5
            ],
            "featureIds": []
        },
        {
            "id": 141,
            "name": "1020, Inc. dba Placecast and Ericsson Emodo",
            "policyUrl": "https://www.ericsson-emodo.com/privacy-policy/",
            "purposeIds": [
                1,
                2,
                3,
                4
            ],
            "legIntPurposeIds": [
                5
            ],
            "featureIds": [
                3
            ]
        },
        {
            "id": 142,
            "name": "Media.net Advertising FZ-LLC",
            "policyUrl": "https://www.media.net/en/privacy-policy",
            "purposeIds": [
                1,
                2
            ],
            "legIntPurposeIds": [
                3,
                5
            ],
            "featureIds": [
                3
            ]
        },
        {
            "id": 209,
            "name": "Delta Projects AB",
            "policyUrl": "http://www.deltaprojects.com/data-collection-policy/",
            "purposeIds": [
                1
            ],
            "legIntPurposeIds": [
                2,
                3,
                5
            ],
            "featureIds": [
                3
            ]
        },
        {
            "id": 195,
            "name": "advanced store GmbH",
            "policyUrl": "http://www.advanced-store.com/de/datenschutz/",
            "purposeIds": [],
            "legIntPurposeIds": [
                1,
                2,
                3
            ],
            "featureIds": [
                3
            ]
        },
        {
            "id": 197,
            "name": "Switch Concepts Limited",
            "policyUrl": "https://www.switchconcepts.com/privacy-policy",
            "purposeIds": [
                1,
                3,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": []
        },
        {
            "id": 190,
            "name": "video intelligence AG",
            "policyUrl": "https://www.vi.ai/privacy-policy/",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": []
        },
        {
            "id": 84,
            "name": "Semasio GmbH",
            "policyUrl": "http://www.semasio.com/privacy-policy/",
            "purposeIds": [],
            "legIntPurposeIds": [
                1,
                2,
                4,
                5
            ],
            "featureIds": []
        },
        {
            "id": 65,
            "name": "Location Sciences AI Ltd",
            "policyUrl": "https://www.locationsciences.ai/privacy-policy/",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                1,
                2,
                3
            ]
        },
        {
            "id": 210,
            "name": "Zemanta, Inc.",
            "policyUrl": "http://www.zemanta.com/legal/privacy",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                1
            ]
        },
        {
            "id": 200,
            "name": "Tapjoy, Inc.",
            "policyUrl": "https://www.tapjoy.com/legal/#privacy-policy",
            "purposeIds": [],
            "legIntPurposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "featureIds": []
        },
        {
            "id": 188,
            "name": "Sellpoints Inc.",
            "policyUrl": "https://retargeter.com/service-privacy-policy/",
            "purposeIds": [],
            "legIntPurposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "featureIds": [
                1,
                2,
                3
            ]
        },
        {
            "id": 217,
            "name": "2KDirect, Inc. (dba iPromote)",
            "policyUrl": "https://www.ipromote.com/privacy-policy/",
            "purposeIds": [],
            "legIntPurposeIds": [
                1,
                3
            ],
            "featureIds": []
        },
        {
            "id": 156,
            "name": "Centro, Inc.",
            "policyUrl": "https://www.centro.net/privacy-policy/",
            "purposeIds": [
                1
            ],
            "legIntPurposeIds": [
                2,
                3,
                4,
                5
            ],
            "featureIds": [
                1
            ]
        },
        {
            "id": 194,
            "name": "Rezonence Limited",
            "policyUrl": "https://rezonence.com/privacy-policy/",
            "purposeIds": [
                3,
                5
            ],
            "legIntPurposeIds": [
                1
            ],
            "featureIds": []
        },
        {
            "id": 226,
            "name": "Publicis Media GmbH",
            "policyUrl": "https://www.publicismedia.de/datenschutz/",
            "purposeIds": [
                1
            ],
            "legIntPurposeIds": [
                2,
                3,
                4,
                5
            ],
            "featureIds": [
                1
            ]
        },
        {
            "id": 198,
            "name": "SYNC",
            "policyUrl": "https://redirect.sync.tv/privacy/",
            "purposeIds": [
                1,
                3
            ],
            "legIntPurposeIds": [],
            "featureIds": []
        },
        {
            "id": 227,
            "name": "ORTEC B.V.",
            "policyUrl": "https://www.ortecadscience.com/privacy-policy/",
            "purposeIds": [
                2
            ],
            "legIntPurposeIds": [
                1,
                3,
                4,
                5
            ],
            "featureIds": [
                1,
                2,
                3
            ]
        },
        {
            "id": 225,
            "name": "Ligatus GmbH",
            "policyUrl": "https://www.ligatus.com/en/privacy-policy",
            "purposeIds": [],
            "legIntPurposeIds": [
                1,
                2,
                3,
                5
            ],
            "featureIds": [
                3
            ]
        },
        {
            "id": 205,
            "name": "Adssets AB",
            "policyUrl": "http://adssets.com/policy/",
            "purposeIds": [],
            "legIntPurposeIds": [
                3,
                5
            ],
            "featureIds": []
        },
        {
            "id": 179,
            "name": "Collective Europe Ltd.",
            "policyUrl": "https://www.timeincuk.com/privacy/",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                1,
                2,
                3
            ]
        },
        {
            "id": 31,
            "name": "Ogury Ltd.",
            "policyUrl": "https://www.ogury.com/privacy/",
            "purposeIds": [
                1,
                2,
                3,
                4
            ],
            "legIntPurposeIds": [
                5
            ],
            "featureIds": [
                2
            ]
        },
        {
            "id": 92,
            "name": "1plusX AG",
            "policyUrl": "https://www.1plusx.com/privacy-policy/",
            "purposeIds": [],
            "legIntPurposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "featureIds": [
                1,
                2,
                3
            ]
        },
        {
            "id": 155,
            "name": "AntVoice",
            "policyUrl": "https://www.antvoice.com/en/privacypolicy/",
            "purposeIds": [
                1,
                2,
                3
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                2
            ]
        },
        {
            "id": 115,
            "name": "smartclip Holding AG",
            "policyUrl": "http://privacy-portal.smartclip.net/",
            "purposeIds": [
                1
            ],
            "legIntPurposeIds": [
                2,
                3,
                5
            ],
            "featureIds": [
                1,
                2,
                3
            ]
        },
        {
            "id": 126,
            "name": "DoubleVerify Inc.\u200b",
            "policyUrl": "https://www.doubleverify.com/privacy/",
            "purposeIds": [
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": []
        },
        {
            "id": 193,
            "name": "Mediasmart Mobile S.L.",
            "policyUrl": "http://mediasmart.io/privacy/",
            "purposeIds": [
                1,
                3
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                3
            ]
        },
        {
            "id": 245,
            "name": "IgnitionOne",
            "policyUrl": "https://www.ignitionone.com/privacy-policy/",
            "purposeIds": [],
            "legIntPurposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "featureIds": [
                1,
                2
            ]
        },
        {
            "id": 213,
            "name": "emetriq GmbH",
            "policyUrl": "https://www.emetriq.com/datenschutz/",
            "purposeIds": [
                1
            ],
            "legIntPurposeIds": [
                2,
                3,
                5
            ],
            "featureIds": [
                1,
                2
            ]
        },
        {
            "id": 244,
            "name": "Leadplace - Temelio",
            "policyUrl": "https://temelio.com/vie-privee",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                1,
                2
            ]
        },
        {
            "id": 224,
            "name": "adrule mobile GmbH",
            "policyUrl": "https://www.adrule.net/de/datenschutz/",
            "purposeIds": [
                2,
                4
            ],
            "legIntPurposeIds": [
                1,
                3,
                5
            ],
            "featureIds": [
                3
            ]
        },
        {
            "id": 174,
            "name": "A Million Ads Limited",
            "policyUrl": "https://www.amillionads.com/privacy-policy",
            "purposeIds": [],
            "legIntPurposeIds": [
                3
            ],
            "featureIds": []
        },
        {
            "id": 192,
            "name": "remerge GmbH",
            "policyUrl": "https://remerge.io/privacy-policy.html",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": []
        },
        {
            "id": 232,
            "name": "Rockerbox, Inc",
            "policyUrl": "http://rockerbox.com/privacy",
            "purposeIds": [],
            "legIntPurposeIds": [
                1,
                3,
                5
            ],
            "featureIds": [
                3
            ]
        },
        {
            "id": 256,
            "name": "Bounce Exchange, Inc",
            "policyUrl": "https://www.bouncex.com/privacy/",
            "purposeIds": [
                1
            ],
            "legIntPurposeIds": [
                2,
                4,
                5
            ],
            "featureIds": [
                1,
                2
            ]
        },
        {
            "id": 234,
            "name": "ZBO Media",
            "policyUrl": "https://zbo.media/mentions-legales/politique-de-confidentialite-service-publicitaire/",
            "purposeIds": [
                1,
                2,
                3
            ],
            "legIntPurposeIds": [
                5
            ],
            "featureIds": [
                1,
                2
            ]
        },
        {
            "id": 246,
            "name": "Smartology Limited",
            "policyUrl": "https://www.smartology.net/privacy-policy/",
            "purposeIds": [],
            "legIntPurposeIds": [
                5
            ],
            "featureIds": []
        },
        {
            "id": 241,
            "name": "OneTag Ltd",
            "policyUrl": "https://www.onetag.net/privacy/",
            "purposeIds": [
                1,
                2,
                3,
                4
            ],
            "legIntPurposeIds": [
                5
            ],
            "featureIds": [
                1,
                2,
                3
            ]
        },
        {
            "id": 254,
            "name": "LiquidM Technology GmbH",
            "policyUrl": "https://liquidm.com/privacy-policy/",
            "purposeIds": [],
            "legIntPurposeIds": [
                1,
                2,
                3,
                5
            ],
            "featureIds": [
                3
            ]
        },
        {
            "id": 215,
            "name": "ARMIS SAS",
            "policyUrl": "https://armis.tech/en/armis-personal-data-privacy-policy/",
            "purposeIds": [
                1,
                2
            ],
            "legIntPurposeIds": [
                3
            ],
            "featureIds": [
                1,
                2,
                3
            ]
        },
        {
            "id": 167,
            "name": "Audiens S.r.l.",
            "policyUrl": "http://www.audiens.com/privacy",
            "purposeIds": [
                1,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                1,
                2,
                3
            ]
        },
        {
            "id": 240,
            "name": "7Hops.com Inc. (ZergNet)",
            "policyUrl": "https://zergnet.com/privacy",
            "purposeIds": [],
            "legIntPurposeIds": [
                1,
                4,
                5
            ],
            "featureIds": []
        },
        {
            "id": 235,
            "name": "Bucksense Inc",
            "policyUrl": "http://www.bucksense.com/platform-privacy-policy/",
            "purposeIds": [
                1
            ],
            "legIntPurposeIds": [
                2,
                3,
                4,
                5
            ],
            "featureIds": [
                2,
                3
            ]
        },
        {
            "id": 185,
            "name": "Bidtellect, Inc",
            "policyUrl": "https://www.bidtellect.com/privacy-policy/",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                1,
                2
            ]
        },
        {
            "id": 258,
            "name": "Adello Group AG",
            "policyUrl": "https://www.adello.com/privacy-policy/",
            "purposeIds": [],
            "legIntPurposeIds": [
                1,
                2,
                3,
                5
            ],
            "featureIds": [
                3
            ]
        },
        {
            "id": 169,
            "name": "RTK.IO, Inc",
            "policyUrl": "http://www.rtk.io/privacy.html",
            "purposeIds": [
                1,
                4
            ],
            "legIntPurposeIds": [
                2,
                3,
                5
            ],
            "featureIds": [
                1,
                3
            ]
        },
        {
            "id": 208,
            "name": "Spotad",
            "policyUrl": "http://www.spotad.co/privacy-policy/",
            "purposeIds": [
                2,
                3
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                1,
                2,
                3
            ]
        },
        {
            "id": 211,
            "name": "AdTheorent, Inc",
            "policyUrl": "http://adtheorent.com/privacy-policy",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                1,
                2,
                3
            ]
        },
        {
            "id": 229,
            "name": "Digitize New Media Ltd",
            "policyUrl": "http://www.digitize.ie/online-privacy",
            "purposeIds": [
                2,
                4
            ],
            "legIntPurposeIds": [],
            "featureIds": []
        },
        {
            "id": 273,
            "name": "Bannerflow AB",
            "policyUrl": "https://www.bannerflow.com/privacy ",
            "purposeIds": [],
            "legIntPurposeIds": [
                3
            ],
            "featureIds": []
        },
        {
            "id": 104,
            "name": "Sonobi, Inc",
            "policyUrl": "http://sonobi.com/privacy-policy/",
            "purposeIds": [
                1,
                2
            ],
            "legIntPurposeIds": [
                3
            ],
            "featureIds": [
                1,
                2,
                3
            ]
        },
        {
            "id": 162,
            "name": "Unruly Group Ltd",
            "policyUrl": "https://unruly.co/privacy/",
            "purposeIds": [],
            "legIntPurposeIds": [
                1,
                2,
                3,
                5
            ],
            "featureIds": [
                1,
                2
            ]
        },
        {
            "id": 249,
            "name": "Spolecznosci Sp. z o.o. Sp. k.",
            "policyUrl": "https://www.spolecznosci.pl/polityka-prywatnosci",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                2,
                3
            ]
        },
        {
            "id": 125,
            "name": "Research Now Group, Inc",
            "policyUrl": "https://www.valuedopinions.co.uk/privacy",
            "purposeIds": [
                1,
                3,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": []
        },
        {
            "id": 170,
            "name": "Goodway Group, Inc.",
            "policyUrl": "https://goodwaygroup.com/privacy-policy/",
            "purposeIds": [],
            "legIntPurposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "featureIds": [
                1,
                2,
                3
            ]
        },
        {
            "id": 160,
            "name": "Netsprint SA",
            "policyUrl": "http://spoldzielnia.nsaudience.pl/opt-out/",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                1,
                2,
                3
            ]
        },
        {
            "id": 189,
            "name": "Intowow Innovation Ltd.",
            "policyUrl": "http://www.intowow.com/privacy/",
            "purposeIds": [
                1,
                3
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                3
            ]
        },
        {
            "id": 279,
            "name": "Mirando GmbH &amp; Co KG",
            "policyUrl": "https://wwwmirando.de/datenschutz/",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                3
            ]
        },
        {
            "id": 269,
            "name": "Sanoma Media Finland",
            "policyUrl": "https://sanoma.fi/tietoa-meista/tietosuoja/",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                1,
                2,
                3
            ]
        },
        {
            "id": 276,
            "name": "Viralize SRL",
            "policyUrl": "https://viralize.com/privacy-policy",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                3
            ]
        },
        {
            "id": 87,
            "name": "Genius Sports Media Limited",
            "policyUrl": "http://www.geniussports.com/privacy-policy/",
            "purposeIds": [
                2,
                4
            ],
            "legIntPurposeIds": [
                1,
                3,
                5
            ],
            "featureIds": [
                2,
                3
            ]
        },
        {
            "id": 182,
            "name": "Collective, Inc. dba Visto",
            "policyUrl": "https://www.vistohub.com/privacy-policy/",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                1,
                2,
                3
            ]
        },
        {
            "id": 255,
            "name": "Onnetwork Sp. z o.o.",
            "policyUrl": "https://www.onnetwork.tv/pp_services.php",
            "purposeIds": [
                2,
                3,
                5
            ],
            "legIntPurposeIds": [
                1
            ],
            "featureIds": []
        },
        {
            "id": 203,
            "name": "Revcontent, LLC",
            "policyUrl": "https://faq.revcontent.com/customer/en/portal/articles/2703838-revcontent-s-privacy-and-cookie-policy",
            "purposeIds": [],
            "legIntPurposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "featureIds": []
        },
        {
            "id": 260,
            "name": "RockYou, Inc.",
            "policyUrl": "https://rockyou.com/privacy-policy/",
            "purposeIds": [
                3
            ],
            "legIntPurposeIds": [
                1,
                2,
                5
            ],
            "featureIds": [
                3
            ]
        },
        {
            "id": 237,
            "name": "LKQD, a division of Nexstar Digital, LLC.",
            "policyUrl": "http://www.lkqd.com/privacy-policy/",
            "purposeIds": [],
            "legIntPurposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "featureIds": [
                2,
                3
            ]
        },
        {
            "id": 274,
            "name": "Golden Bees",
            "policyUrl": "http://goldenbees.fr/notre-politique-de-confidentialite/",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": []
        },
        {
            "id": 280,
            "name": "Spot.IM Ltd.",
            "policyUrl": "http://spot.im/privacy",
            "purposeIds": [],
            "legIntPurposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "featureIds": []
        },
        {
            "id": 239,
            "name": "Triton Digital Canada Inc.",
            "policyUrl": "https://www.tritondigital.com/privacy-policies",
            "purposeIds": [],
            "legIntPurposeIds": [
                1,
                3,
                4,
                5
            ],
            "featureIds": []
        },
        {
            "id": 177,
            "name": "plista GmbH",
            "policyUrl": "https://www.plista.com/about/privacy/",
            "purposeIds": [
                1,
                2,
                3,
                4
            ],
            "legIntPurposeIds": [
                5
            ],
            "featureIds": []
        },
        {
            "id": 201,
            "name": "TimeOne",
            "policyUrl": "https://privacy.timeonegroup.com/en/",
            "purposeIds": [],
            "legIntPurposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "featureIds": [
                2
            ]
        },
        {
            "id": 150,
            "name": "Inskin Media LTD",
            "policyUrl": "http://www.inskinmedia.com/privacy-policy.html",
            "purposeIds": [
                2,
                3,
                5
            ],
            "legIntPurposeIds": [
                1
            ],
            "featureIds": []
        },
        {
            "id": 252,
            "name": "Jaduda GmbH",
            "policyUrl": "https://www.jadudamobile.com/datenschutzerklaerung/",
            "purposeIds": [],
            "legIntPurposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "featureIds": [
                3
            ]
        },
        {
            "id": 248,
            "name": "Converge-Digital",
            "policyUrl": "https://converge-digital.com/privacy-policy/",
            "purposeIds": [
                1
            ],
            "legIntPurposeIds": [
                3,
                4,
                5
            ],
            "featureIds": [
                3
            ]
        },
        {
            "id": 161,
            "name": "Smadex SL",
            "policyUrl": "http://smadex.com/end-user-privacy-policy/",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                1,
                2,
                3
            ]
        },
        {
            "id": 285,
            "name": "Comcast International France SAS",
            "policyUrl": "http://freewheel.tv/privacy-policy",
            "purposeIds": [
                1
            ],
            "legIntPurposeIds": [],
            "featureIds": []
        },
        {
            "id": 228,
            "name": "McCann Discipline LTD",
            "policyUrl": "https://www.primis.tech/wp-content/uploads/2019/03/Primis-Privacy-Policy-GDPR.pdf\r\n",
            "purposeIds": [],
            "legIntPurposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "featureIds": []
        },
        {
            "id": 299,
            "name": "AdClear GmbH",
            "policyUrl": "https://www.adclear.de/datenschutzerklaerung/",
            "purposeIds": [
                1,
                5
            ],
            "legIntPurposeIds": [
                2,
                3,
                4
            ],
            "featureIds": [
                1,
                2
            ]
        },
        {
            "id": 277,
            "name": "Codewise Sp. z o.o. Sp. k",
            "policyUrl": "https://voluumdsp.com/end-user-privacy-policy/",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                1,
                2
            ]
        },
        {
            "id": 259,
            "name": "ADYOULIKE SA",
            "policyUrl": "https://www.adyoulike.com/privacy_policy.php",
            "purposeIds": [
                2,
                4
            ],
            "legIntPurposeIds": [
                1,
                3,
                5
            ],
            "featureIds": []
        },
        {
            "id": 289,
            "name": "mobalo GmbH",
            "policyUrl": "https://www.mobalo.com/datenschutz/",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                3
            ]
        },
        {
            "id": 272,
            "name": "A.Mob",
            "policyUrl": "https://www.we-are-adot.com/privacy-policy/",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                1,
                2,
                3
            ]
        },
        {
            "id": 230,
            "name": "Steel House, Inc.",
            "policyUrl": "https://steelhouse.com/privacy-policy/",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": []
        },
        {
            "id": 253,
            "name": "Improve Digital International BV",
            "policyUrl": "https://www.improvedigital.com/platform-privacy-policy",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                1,
                2,
                3
            ]
        },
        {
            "id": 304,
            "name": "On Device Research Limited",
            "policyUrl": "https://s.on-device.com/privacyPolicy",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                1,
                2,
                3
            ]
        },
        {
            "id": 314,
            "name": "Keymantics",
            "policyUrl": "https://www.keymantics.com/assets/privacy-policy.pdf",
            "purposeIds": [
                1,
                2,
                3
            ],
            "legIntPurposeIds": [],
            "featureIds": []
        },
        {
            "id": 257,
            "name": "R-TARGET",
            "policyUrl": "http://www.r-target.com/privacy",
            "purposeIds": [
                1
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                1,
                2
            ]
        },
        {
            "id": 317,
            "name": "mainADV Srl",
            "policyUrl": "http://www.mainad.com/privacy-policy/",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                2,
                3
            ]
        },
        {
            "id": 278,
            "name": "Integral Ad Science, Inc.",
            "policyUrl": "https://integralads.com/privacy-policy/",
            "purposeIds": [],
            "legIntPurposeIds": [
                5
            ],
            "featureIds": []
        },
        {
            "id": 291,
            "name": "Qwertize",
            "policyUrl": "https://www.qwertize.com/en/privacy",
            "purposeIds": [
                1,
                2,
                4
            ],
            "legIntPurposeIds": [
                3,
                5
            ],
            "featureIds": []
        },
        {
            "id": 295,
            "name": "Sojern, Inc.",
            "policyUrl": "https://www.sojern.com/privacy/product-privacy-policy/",
            "purposeIds": [
                1,
                2,
                3,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                2
            ]
        },
        {
            "id": 315,
            "name": "Celtra, Inc.",
            "policyUrl": "https://www.celtra.com/privacy-policy/",
            "purposeIds": [
                1,
                3
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                3
            ]
        },
        {
            "id": 165,
            "name": "SpotX",
            "policyUrl": "https://www.spotx.tv/privacy-policy/",
            "purposeIds": [
                1
            ],
            "legIntPurposeIds": [],
            "featureIds": []
        },
        {
            "id": 47,
            "name": "ADMAN - Phaistos Networks, S.A.",
            "policyUrl": "http://www.adman.gr/privacy",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": []
        },
        {
            "id": 134,
            "name": "SMARTSTREAM.TV GmbH",
            "policyUrl": "https://www.smartstream.tv/en/privacy",
            "purposeIds": [
                1,
                2,
                3
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                1,
                2
            ]
        },
        {
            "id": 325,
            "name": "Knorex Pte Ltd",
            "policyUrl": "https://www.knorex.com/privacy",
            "purposeIds": [],
            "legIntPurposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "featureIds": [
                1,
                2,
                3
            ]
        },
        {
            "id": 316,
            "name": "Gamned",
            "policyUrl": "https://www.gamned.com/privacy-policy/",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                3
            ]
        },
        {
            "id": 318,
            "name": "Accorp Sp. z o.o.",
            "policyUrl": "http://www.instytut-pollster.pl/privacy-policy/",
            "purposeIds": [
                2,
                3,
                4
            ],
            "legIntPurposeIds": [
                1,
                5
            ],
            "featureIds": []
        },
        {
            "id": 199,
            "name": "ADUX",
            "policyUrl": "http://www.adux.com/donnees-personelles/",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                1,
                2,
                3
            ]
        },
        {
            "id": 236,
            "name": "PowerLinks Media Limited",
            "policyUrl": "https://www.powerlinks.com/privacy-policy/",
            "purposeIds": [
                1,
                2,
                5
            ],
            "legIntPurposeIds": [
                3,
                4
            ],
            "featureIds": [
                3
            ]
        },
        {
            "id": 294,
            "name": "Jivox Corporation",
            "policyUrl": "https://www.jivox.com/privacy",
            "purposeIds": [],
            "legIntPurposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "featureIds": [
                3
            ]
        },
        {
            "id": 143,
            "name": "Connatix Native Exchange Inc.",
            "policyUrl": "https://connatix.com/privacy-policy/",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": []
        },
        {
            "id": 297,
            "name": "Polar Mobile Group Inc.",
            "policyUrl": "https://privacy.polar.me",
            "purposeIds": [
                2
            ],
            "legIntPurposeIds": [
                1,
                3,
                4,
                5
            ],
            "featureIds": []
        },
        {
            "id": 319,
            "name": "Clipcentric, Inc.",
            "policyUrl": "https://clipcentric.com/privacy.bhtml",
            "purposeIds": [
                1,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                3
            ]
        },
        {
            "id": 290,
            "name": "Readpeak Oy",
            "policyUrl": "http://readpeak.com/privacy-policy/",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": []
        },
        {
            "id": 323,
            "name": "Perform Media Services Ltd",
            "policyUrl": "http://www.performgroup.com/media-privacy-notice",
            "purposeIds": [
                2
            ],
            "legIntPurposeIds": [
                1,
                3,
                4,
                5
            ],
            "featureIds": [
                1,
                2
            ]
        },
        {
            "id": 119,
            "name": "S4M",
            "policyUrl": "http://www.s4m.io/privacy-policy/",
            "purposeIds": [
                2
            ],
            "legIntPurposeIds": [
                1,
                3
            ],
            "featureIds": [
                1,
                3
            ]
        },
        {
            "id": 302,
            "name": "Mobile Professionals BV",
            "policyUrl": "https://mobpro.com/privacy.html",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                3
            ]
        },
        {
            "id": 212,
            "name": "usemax advertisement (Emego GmbH)",
            "policyUrl": "http://www.usemax.de/?l=privacy",
            "purposeIds": [],
            "legIntPurposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "featureIds": []
        },
        {
            "id": 264,
            "name": "Adobe Advertising Cloud",
            "policyUrl": "https://www.adobe.com/nz/privacy/marketing-cloud.html",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                2,
                3
            ]
        },
        {
            "id": 44,
            "name": "The ADEX GmbH",
            "policyUrl": "https://www.theadex.com/privacy-opt-out/",
            "purposeIds": [
                1
            ],
            "legIntPurposeIds": [
                2,
                3,
                4,
                5
            ],
            "featureIds": [
                1,
                2,
                3
            ]
        },
        {
            "id": 282,
            "name": "Welect GmbH",
            "policyUrl": "https://www.welect.de/datenschutz",
            "purposeIds": [],
            "legIntPurposeIds": [
                5
            ],
            "featureIds": []
        },
        {
            "id": 238,
            "name": "StackAdapt",
            "policyUrl": "https://www.stackadapt.com/privacy",
            "purposeIds": [],
            "legIntPurposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "featureIds": [
                1,
                2,
                3
            ]
        },
        {
            "id": 284,
            "name": "WEBORAMA",
            "policyUrl": "https://weborama.com/privacy_en/",
            "purposeIds": [
                1
            ],
            "legIntPurposeIds": [
                2,
                3,
                4,
                5
            ],
            "featureIds": [
                1,
                2,
                3
            ]
        },
        {
            "id": 148,
            "name": "Liveintent Inc.",
            "policyUrl": "https://liveintent.com/services-privacy-policy/",
            "purposeIds": [
                1
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                2
            ]
        },
        {
            "id": 64,
            "name": "DigiTrust / IAB Tech Lab",
            "policyUrl": "http://www.digitru.st/privacy-policy/",
            "purposeIds": [
                1
            ],
            "legIntPurposeIds": [],
            "featureIds": []
        },
        {
            "id": 301,
            "name": "zeotap GmbH",
            "policyUrl": "https://www.zeotap.com/privacy_policy/",
            "purposeIds": [],
            "legIntPurposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "featureIds": [
                1,
                2
            ]
        },
        {
            "id": 275,
            "name": "TabMo SAS",
            "policyUrl": "http://static.tabmo.io.s3.amazonaws.com/privacy-policy/index.html",
            "purposeIds": [
                1,
                2,
                3
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                1,
                3
            ]
        },
        {
            "id": 310,
            "name": "Schibsted Classified Media Spain, S.L.",
            "policyUrl": "https://www.vibbo.com/privacidad.htm?ca=0_s",
            "purposeIds": [],
            "legIntPurposeIds": [
                4
            ],
            "featureIds": []
        },
        {
            "id": 139,
            "name": "Permodo GmbH",
            "policyUrl": "https://permodo.com/de/privacy.html",
            "purposeIds": [
                1,
                2,
                3
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                1,
                2,
                3
            ]
        },
        {
            "id": 326,
            "name": "AdTiming Technology Company Limited",
            "policyUrl": "http://www.adtiming.com/en/privacypolicy.html",
            "purposeIds": [
                3,
                5
            ],
            "legIntPurposeIds": [
                1,
                2,
                4
            ],
            "featureIds": []
        },
        {
            "id": 262,
            "name": "Fyber ",
            "policyUrl": "https://www.fyber.com/legal/privacy-policy/",
            "purposeIds": [
                3
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                3
            ]
        },
        {
            "id": 331,
            "name": "ad6media",
            "policyUrl": "https://www.ad6media.fr/privacy",
            "purposeIds": [
                1,
                2,
                4
            ],
            "legIntPurposeIds": [
                3,
                5
            ],
            "featureIds": [
                2,
                3
            ]
        },
        {
            "id": 345,
            "name": "The Kantar Group Limited",
            "policyUrl": "http://www.kantar.com/cookies-policies",
            "purposeIds": [
                1,
                3,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                1,
                2,
                3
            ]
        },
        {
            "id": 308,
            "name": "Rockabox Media Ltd",
            "policyUrl": "http://scoota.com/privacy-policy",
            "purposeIds": [
                1
            ],
            "legIntPurposeIds": [
                2,
                3
            ],
            "featureIds": []
        },
        {
            "id": 270,
            "name": "Marfeel Solutions S.L",
            "policyUrl": "https://www.marfeel.com/privacy-policy/",
            "purposeIds": [
                1,
                3
            ],
            "legIntPurposeIds": [],
            "featureIds": []
        },
        {
            "id": 333,
            "name": "InMobi Pte Ltd",
            "policyUrl": "https://www.inmobi.com/privacy-policy-for-eea",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                1,
                2,
                3
            ]
        },
        {
            "id": 202,
            "name": "Telaria, Inc",
            "policyUrl": "https://telaria.com/privacy-policy/",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                1,
                2,
                3
            ]
        },
        {
            "id": 328,
            "name": "Gemius SA",
            "policyUrl": "https://www.gemius.com/cookie-policy.html",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                2
            ]
        },
        {
            "id": 281,
            "name": "Wizaly",
            "policyUrl": "https://www.wizaly.com/terms-of-use#privacy-policy",
            "purposeIds": [
                1,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                1,
                2
            ]
        },
        {
            "id": 354,
            "name": "Apester Ltd",
            "policyUrl": "https://apester.com/privacy-policy/",
            "purposeIds": [
                2
            ],
            "legIntPurposeIds": [
                1,
                3,
                4,
                5
            ],
            "featureIds": []
        },
        {
            "id": 320,
            "name": "Adelphic LLC",
            "policyUrl": "https://adelphic.com/platform/privacy/",
            "purposeIds": [
                1,
                2,
                3
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                2,
                3
            ]
        },
        {
            "id": 359,
            "name": "Aerserv LLC",
            "policyUrl": "https://www.aerserv.com/privacy-policy/",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                1,
                2,
                3
            ]
        },
        {
            "id": 265,
            "name": "Instinctive, Inc.",
            "policyUrl": "https://instinctive.io/privacy",
            "purposeIds": [
                2,
                3,
                4
            ],
            "legIntPurposeIds": [
                1,
                5
            ],
            "featureIds": []
        },
        {
            "id": 349,
            "name": "Optomaton UG",
            "policyUrl": "http://optomaton.com/privacy.html",
            "purposeIds": [
                1,
                2,
                3,
                4
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                2
            ]
        },
        {
            "id": 288,
            "name": "Video Media Groep B.V.",
            "policyUrl": "http://www.videomediagroup.com/wp-content/uploads/2016/01/Privacy-policy-VMG.pdf",
            "purposeIds": [
                2
            ],
            "legIntPurposeIds": [
                1,
                3,
                4,
                5
            ],
            "featureIds": []
        },
        {
            "id": 266,
            "name": "Digilant Spain, SLU",
            "policyUrl": "https://www.digilant.com/es/politica-privacidad/",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                1
            ]
        },
        {
            "id": 339,
            "name": "Vuble",
            "policyUrl": "https://www.vuble.tv/us/privacy",
            "purposeIds": [
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [
                1
            ],
            "featureIds": []
        },
        {
            "id": 303,
            "name": "Orion Semantics",
            "policyUrl": "http://static.orion-semantics.com/privacy.html",
            "purposeIds": [
                1,
                2,
                3
            ],
            "legIntPurposeIds": [],
            "featureIds": []
        },
        {
            "id": 261,
            "name": "Signal Digital Inc.",
            "policyUrl": "https://www.signal.co/privacy-policy/",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                1,
                2
            ]
        },
        {
            "id": 83,
            "name": "Visarity Technologies GmbH",
            "policyUrl": "http://primo.design/docs/PrivacyPolicyPrimo.html",
            "purposeIds": [
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": []
        },
        {
            "id": 343,
            "name": "DIGITEKA Technologies",
            "policyUrl": "https://www.ultimedia.com/POLICY.html",
            "purposeIds": [],
            "legIntPurposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "featureIds": [
                3
            ]
        },
        {
            "id": 330,
            "name": "Linicom",
            "policyUrl": "https://www.linicom.com/privacy/",
            "purposeIds": [
                2
            ],
            "legIntPurposeIds": [
                1,
                3,
                4,
                5
            ],
            "featureIds": []
        },
        {
            "id": 231,
            "name": "Acuityads Inc.",
            "policyUrl": "https://www.acuityads.com/privacy-policy/",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": []
        },
        {
            "id": 216,
            "name": "Mindlytix SAS",
            "policyUrl": "http://mindlytix.com/privacy/",
            "purposeIds": [],
            "legIntPurposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "featureIds": []
        },
        {
            "id": 360,
            "name": "Permutive Technologies, Inc.",
            "policyUrl": "https://permutive.com/privacy",
            "purposeIds": [],
            "legIntPurposeIds": [
                1
            ],
            "featureIds": [
                1,
                2
            ]
        },
        {
            "id": 361,
            "name": "Permutive Ltd.",
            "policyUrl": "https://permutive.com/privacy",
            "purposeIds": [],
            "legIntPurposeIds": [
                1
            ],
            "featureIds": [
                1,
                2
            ]
        },
        {
            "id": 311,
            "name": "Mobfox US LLC",
            "policyUrl": "https://www.mobfox.com/privacy-policy/",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                3
            ]
        },
        {
            "id": 358,
            "name": "MGID Inc.",
            "policyUrl": "https://www.mgid.com/privacy-policy",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                1
            ]
        },
        {
            "id": 152,
            "name": "Meetrics GmbH",
            "policyUrl": "https://www.meetrics.com/en/data-privacy/",
            "purposeIds": [],
            "legIntPurposeIds": [
                5
            ],
            "featureIds": []
        },
        {
            "id": 251,
            "name": "Yieldlove GmbH",
            "policyUrl": "http://www.yieldlove.com/cookie-policy",
            "purposeIds": [],
            "legIntPurposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "featureIds": []
        },
        {
            "id": 371,
            "name": "Seeding Alliance GmbH",
            "policyUrl": "http://seeding-alliance.de/datenschutz",
            "purposeIds": [],
            "legIntPurposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "featureIds": [
                3
            ]
        },
        {
            "id": 344,
            "name": "My6sense Inc.",
            "policyUrl": "https://my6sense.com/privacy-policy/",
            "purposeIds": [
                1,
                3,
                5
            ],
            "legIntPurposeIds": [
                2,
                4
            ],
            "featureIds": []
        },
        {
            "id": 347,
            "name": "Ezoic Inc.",
            "policyUrl": "https://www.ezoic.com/terms/",
            "purposeIds": [
                2,
                4,
                5
            ],
            "legIntPurposeIds": [
                1
            ],
            "featureIds": []
        },
        {
            "id": 218,
            "name": "Bigabid Media Ltd",
            "policyUrl": "http://www.bigabid.com/data-protection/gdpr",
            "purposeIds": [],
            "legIntPurposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "featureIds": [
                2,
                3
            ]
        },
        {
            "id": 350,
            "name": "Free Stream Media Corp. dba Samba TV",
            "policyUrl": "https://samba.tv/legal/privacy-policy/",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                1,
                2,
                3
            ]
        },
        {
            "id": 351,
            "name": "Samba TV UK Limited",
            "policyUrl": "https://samba.tv/legal/privacy-policy/",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                1,
                2,
                3
            ]
        },
        {
            "id": 341,
            "name": "Somo Audience Corp",
            "policyUrl": "https://somoaudience.com/legal/",
            "purposeIds": [
                1,
                2
            ],
            "legIntPurposeIds": [
                3
            ],
            "featureIds": [
                1,
                2,
                3
            ]
        },
        {
            "id": 380,
            "name": "Vidoomy Media SL",
            "policyUrl": "http://vidoomy.com/privacy-policy.html",
            "purposeIds": [
                1,
                2
            ],
            "legIntPurposeIds": [
                3,
                4,
                5
            ],
            "featureIds": [
                2,
                3
            ]
        },
        {
            "id": 378,
            "name": "communicationAds GmbH &amp; Co. KG",
            "policyUrl": "https://www.communicationads.net/aboutus/privacy/",
            "purposeIds": [],
            "legIntPurposeIds": [
                1
            ],
            "featureIds": []
        },
        {
            "id": 369,
            "name": "Getintent USA, inc.",
            "policyUrl": "https://getintent.com/privacy/",
            "purposeIds": [
                1
            ],
            "legIntPurposeIds": [],
            "featureIds": []
        },
        {
            "id": 184,
            "name": "mediarithmics SAS",
            "policyUrl": "https://www.mediarithmics.com/en-us/content/privacy-policy",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                1,
                2,
                3
            ]
        },
        {
            "id": 368,
            "name": "VECTAURY",
            "policyUrl": "https://www.vectaury.io/en/personal-data",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                1,
                2,
                3
            ]
        },
        {
            "id": 373,
            "name": "Nielsen Marketing Cloud",
            "policyUrl": "http://www.nielsen.com/us/en/privacy-statement/exelate-privacy-policy.html",
            "purposeIds": [
                1,
                2
            ],
            "legIntPurposeIds": [
                5
            ],
            "featureIds": [
                1,
                2
            ]
        },
        {
            "id": 214,
            "name": "Digital Control GmbH &amp; Co. KG",
            "policyUrl": "http://advolution.de/privacy.php",
            "purposeIds": [
                1,
                2,
                3
            ],
            "legIntPurposeIds": [],
            "featureIds": []
        },
        {
            "id": 388,
            "name": "numberly",
            "policyUrl": "http://ads.1000mercis.com/fr.html",
            "purposeIds": [
                1
            ],
            "legIntPurposeIds": [
                2,
                3,
                4,
                5
            ],
            "featureIds": [
                1,
                2,
                3
            ]
        },
        {
            "id": 250,
            "name": "Qriously",
            "policyUrl": "https://www.qriously.com/privacy",
            "purposeIds": [
                2,
                3,
                4
            ],
            "legIntPurposeIds": [
                1
            ],
            "featureIds": []
        },
        {
            "id": 223,
            "name": "Audience Trading Platform Ltd.",
            "policyUrl": "https://atp.io/privacy-policy",
            "purposeIds": [],
            "legIntPurposeIds": [
                1,
                5
            ],
            "featureIds": [
                2
            ]
        },
        {
            "id": 384,
            "name": "Pixalate, Inc.",
            "policyUrl": "http://pixalate.com/privacypolicy/",
            "purposeIds": [],
            "legIntPurposeIds": [
                1,
                5
            ],
            "featureIds": []
        },
        {
            "id": 387,
            "name": "Triapodi Ltd.",
            "policyUrl": "https://appreciate.mobi/page.html#/end-user-privacy-policy",
            "purposeIds": [
                1,
                3,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": []
        },
        {
            "id": 312,
            "name": "Exactag GmbH",
            "policyUrl": "https://www.exactag.com/en/data-privacy/",
            "purposeIds": [
                1,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": []
        },
        {
            "id": 178,
            "name": "Affectv Ltd",
            "policyUrl": "https://affectv.com/privacy-policy",
            "purposeIds": [],
            "legIntPurposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "featureIds": []
        },
        {
            "id": 377,
            "name": "AddApptr GmbH",
            "policyUrl": "https://www.addapptr.com/data-privacy",
            "purposeIds": [
                1,
                3,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                3
            ]
        },
        {
            "id": 382,
            "name": "The Reach Group GmbH",
            "policyUrl": "https://www.reachgroup.com/en/privacy-statement/",
            "purposeIds": [
                1,
                2,
                4,
                5
            ],
            "legIntPurposeIds": [
                3
            ],
            "featureIds": []
        },
        {
            "id": 206,
            "name": "Hybrid Adtech GmbH",
            "policyUrl": "https://hybrid.ai/data_protection_policy",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                1,
                2,
                3
            ]
        },
        {
            "id": 403,
            "name": "Mobusi Mobile Advertising S.L.",
            "policyUrl": "https://www.mobusi.com/privacy.en.html",
            "purposeIds": [
                1,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                3
            ]
        },
        {
            "id": 385,
            "name": "Oracle",
            "policyUrl": "https://www.oracle.com/legal/privacy/marketing-cloud-data-cloud-privacy-policy.html",
            "purposeIds": [
                1,
                2,
                3,
                4
            ],
            "legIntPurposeIds": [
                5
            ],
            "featureIds": [
                2
            ]
        },
        {
            "id": 404,
            "name": "Duplo Media AS",
            "policyUrl": "https://www.easy-ads.com/privacypolicy.htm",
            "purposeIds": [],
            "legIntPurposeIds": [
                1,
                5
            ],
            "featureIds": []
        },
        {
            "id": 242,
            "name": "twiago GmbH",
            "policyUrl": "https://www.twiago.com/datenschutz/",
            "purposeIds": [],
            "legIntPurposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "featureIds": [
                2,
                3
            ]
        },
        {
            "id": 376,
            "name": "Pocketmath Pte Ltd",
            "policyUrl": "https://www.pocketmath.com/privacy-policy",
            "purposeIds": [
                1,
                2,
                3,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                1,
                2,
                3
            ]
        },
        {
            "id": 402,
            "name": "Effiliation",
            "policyUrl": "https://inter.effiliation.com/politique-confidentialite.html",
            "purposeIds": [
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                2
            ]
        },
        {
            "id": 413,
            "name": "Eulerian Technologies",
            "policyUrl": "https://www.eulerian.com/en/privacy/",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                1,
                2
            ]
        },
        {
            "id": 400,
            "name": "Whenever Media Ltd",
            "policyUrl": "https://www.whenevermedia.com/privacy-policy",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                2,
                3
            ]
        },
        {
            "id": 171,
            "name": "Webedia",
            "policyUrl": "http://www.webedia-group.com/site/privacy-policy",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": []
        },
        {
            "id": 398,
            "name": "Yormedia Solutions Ltd",
            "policyUrl": "http://www.yormedia.com/privacy-and-cookies-notice/",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                3
            ]
        },
        {
            "id": 415,
            "name": "Seenthis AB",
            "policyUrl": "https://seenthis.co/privacy-notice-2018-04-18.pdf",
            "purposeIds": [],
            "legIntPurposeIds": [
                1
            ],
            "featureIds": []
        },
        {
            "id": 263,
            "name": "Nativo, Inc.",
            "policyUrl": "https://www.nativo.com/interest-based-ads",
            "purposeIds": [
                1,
                2,
                3,
                4
            ],
            "legIntPurposeIds": [
                5
            ],
            "featureIds": []
        },
        {
            "id": 329,
            "name": "Browsi Mobile Ltd",
            "policyUrl": "http://gobrowsi.com/browsi-privacy-policy/",
            "purposeIds": [
                1,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": []
        },
        {
            "id": 389,
            "name": "Bidmanagement GmbH",
            "policyUrl": "https://www.adspert.net/en/privacy/",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": []
        },
        {
            "id": 337,
            "name": "SheMedia, LLC",
            "policyUrl": "http://corporate.shemedia.com/faq/ad-services-privacy-policy",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                1,
                2
            ]
        },
        {
            "id": 422,
            "name": "Brand Metrics Sweden AB",
            "policyUrl": "https://collector.brandmetrics.com/brandmetrics_privacypolicy.pdf",
            "purposeIds": [
                1
            ],
            "legIntPurposeIds": [],
            "featureIds": []
        },
        {
            "id": 421,
            "name": "LeftsnRight, Inc. dba LIQWID",
            "policyUrl": "https://liqwid.solutions/privacy-policy",
            "purposeIds": [],
            "legIntPurposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "featureIds": [
                3
            ]
        },
        {
            "id": 426,
            "name": "TradeTracker",
            "policyUrl": "https://tradetracker.com/privacy-policy/",
            "purposeIds": [],
            "legIntPurposeIds": [
                1,
                3,
                5
            ],
            "featureIds": [
                2
            ]
        },
        {
            "id": 394,
            "name": "AudienceProject Aps",
            "policyUrl": "https://privacy.audienceproject.com",
            "purposeIds": [
                1,
                2
            ],
            "legIntPurposeIds": [
                3,
                4,
                5
            ],
            "featureIds": [
                1,
                2
            ]
        },
        {
            "id": 287,
            "name": "Avazu Inc.",
            "policyUrl": "http://avazuinc.com/opt-out/",
            "purposeIds": [],
            "legIntPurposeIds": [
                1,
                3,
                4
            ],
            "featureIds": [
                3
            ]
        },
        {
            "id": 243,
            "name": "Cloud Technologies S.A.",
            "policyUrl": "http://onaudience.com/privacy-policy",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                1,
                2
            ]
        },
        {
            "id": 338,
            "name": "dunnhumby Germany GmbH",
            "policyUrl": "https://www.sociomantic.com/privacy/en/",
            "purposeIds": [],
            "legIntPurposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "featureIds": [
                1,
                2,
                3
            ]
        },
        {
            "id": 405,
            "name": "IgnitionAi Ltd",
            "policyUrl": "https://www.isitelab.io/default.aspx",
            "purposeIds": [],
            "legIntPurposeIds": [
                1,
                3,
                4,
                5
            ],
            "featureIds": [
                2
            ]
        },
        {
            "id": 416,
            "name": "Commanders Act",
            "policyUrl": "https://www.commandersact.com/en/privacy/",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                1,
                2,
                3
            ]
        },
        {
            "id": 434,
            "name": "DynAdmic",
            "policyUrl": "http://eu.dynadmic.com/privacy-policy/",
            "purposeIds": [
                1,
                3
            ],
            "legIntPurposeIds": [
                2,
                4
            ],
            "featureIds": [
                1,
                3
            ]
        },
        {
            "id": 435,
            "name": "SINGLESPOT SAS ",
            "policyUrl": "https://www.singlespot.com/privacy_policy?locale=fr",
            "purposeIds": [
                1,
                2,
                3
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                1,
                3
            ]
        },
        {
            "id": 409,
            "name": "Arrivalist Co.",
            "policyUrl": "https://www.arrivalist.com/privacy",
            "purposeIds": [],
            "legIntPurposeIds": [
                1,
                3,
                5
            ],
            "featureIds": [
                1,
                2
            ]
        },
        {
            "id": 321,
            "name": "Ziff Davis LLC",
            "policyUrl": "http://www.ziffdavis.com/privacy-policy",
            "purposeIds": [
                1,
                2,
                3,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                2
            ]
        },
        {
            "id": 436,
            "name": "INVIBES GROUP",
            "policyUrl": "http://www.invibes.com/terms",
            "purposeIds": [
                2,
                3,
                4
            ],
            "legIntPurposeIds": [
                1,
                5
            ],
            "featureIds": [
                1,
                2,
                3
            ]
        },
        {
            "id": 442,
            "name": "R-Advertising",
            "policyUrl": "http://www.tradedoubler.com/en/privacy-policy/",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": []
        },
        {
            "id": 362,
            "name": "Myntelligence Limited",
            "policyUrl": "http://www.myntelligence.com/privacy-page/",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                1,
                2,
                3
            ]
        },
        {
            "id": 418,
            "name": "PROXISTORE",
            "policyUrl": "https://www.proxistore.com/common/en/cgv",
            "purposeIds": [
                1
            ],
            "legIntPurposeIds": [
                3
            ],
            "featureIds": [
                3
            ]
        },
        {
            "id": 449,
            "name": "Mobile Journey B.V.",
            "policyUrl": "https://mobilejourney.com/Privacy-Policy",
            "purposeIds": [],
            "legIntPurposeIds": [
                1,
                3,
                5
            ],
            "featureIds": [
                3
            ]
        },
        {
            "id": 443,
            "name": "Tradedoubler AB",
            "policyUrl": "https://www.tradedoubler.com/en/privacy-policy/",
            "purposeIds": [],
            "legIntPurposeIds": [
                1,
                5
            ],
            "featureIds": [
                2
            ]
        },
        {
            "id": 429,
            "name": "Signals",
            "policyUrl": "https://signalsdata.com/platform-cookie-policy/",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                2,
                3
            ]
        },
        {
            "id": 335,
            "name": "Beachfront Media LLC",
            "policyUrl": "http://beachfront.com/privacy-policy/",
            "purposeIds": [],
            "legIntPurposeIds": [
                1,
                3,
                4,
                5
            ],
            "featureIds": []
        },
        {
            "id": 407,
            "name": "Publishers Internationale Pty Ltd",
            "policyUrl": "https://www.pi-rate.com.au/privacy.html",
            "purposeIds": [
                1,
                2
            ],
            "legIntPurposeIds": [
                3,
                4,
                5
            ],
            "featureIds": [
                1,
                2,
                3
            ]
        },
        {
            "id": 427,
            "name": "Proxi.cloud Sp. z o.o.",
            "policyUrl": "https://proxi.cloud/info/privacy-policy/",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                3
            ]
        },
        {
            "id": 374,
            "name": "Bmind a Sales Maker Company, S.L.",
            "policyUrl": "http://www.bmind.es/legal-notice/",
            "purposeIds": [
                1,
                2,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                1,
                2
            ]
        },
        {
            "id": 438,
            "name": "Ooyala Inc",
            "policyUrl": "https://ooyala.com/privacy",
            "purposeIds": [
                1,
                2,
                3
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                2,
                3
            ]
        },
        {
            "id": 450,
            "name": "Neodata Group srl",
            "policyUrl": "https://www.neodatagroup.com/en/security-policy",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                1,
                3
            ]
        },
        {
            "id": 452,
            "name": "Innovid Inc.",
            "policyUrl": "http://www.innovid.com/privacy-policy",
            "purposeIds": [
                1,
                2,
                3,
                4
            ],
            "legIntPurposeIds": [
                5
            ],
            "featureIds": [
                2
            ]
        },
        {
            "id": 444,
            "name": "Playbuzz Ltd. ",
            "policyUrl": "https://www.playbuzz.com/PrivacyPolicy",
            "purposeIds": [
                2
            ],
            "legIntPurposeIds": [
                1,
                3,
                4,
                5
            ],
            "featureIds": [
                3
            ]
        },
        {
            "id": 412,
            "name": "Cxense ASA",
            "policyUrl": "https://www.cxense.com/about-us/privacy-policy",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": []
        },
        {
            "id": 454,
            "name": "Adimo",
            "policyUrl": "https://adimo.co/privacy-policy/",
            "purposeIds": [
                1
            ],
            "legIntPurposeIds": [
                5
            ],
            "featureIds": [
                3
            ]
        },
        {
            "id": 455,
            "name": "GDMServices, Inc. d/b/a FiksuDSP",
            "policyUrl": "https://fiksu.com/privacy-policy/",
            "purposeIds": [
                1,
                2,
                3
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                2,
                3
            ]
        },
        {
            "id": 298,
            "name": "Cuebiq Inc.",
            "policyUrl": "https://www.cuebiq.com/privacypolicy/",
            "purposeIds": [
                1,
                2,
                3,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                3
            ]
        },
        {
            "id": 423,
            "name": "travel audience GmbH",
            "policyUrl": "https://travelaudience.com/product-privacy-policy/",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": []
        },
        {
            "id": 397,
            "name": "Demandbase, Inc. ",
            "policyUrl": "https://www.demandbase.com/privacy-policy/",
            "purposeIds": [
                1
            ],
            "legIntPurposeIds": [
                2,
                3,
                4,
                5
            ],
            "featureIds": [
                1,
                2,
                3
            ]
        },
        {
            "id": 381,
            "name": "Solocal",
            "policyUrl": "https://client.adhslx.com/privacy.html ",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": []
        },
        {
            "id": 425,
            "name": "ADRINO Sp. z o.o.",
            "policyUrl": "http://www.adrino.pl/ciasteczkowa-polityka/",
            "purposeIds": [],
            "legIntPurposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "featureIds": [
                1,
                2,
                3
            ]
        },
        {
            "id": 365,
            "name": "Forensiq LLC",
            "policyUrl": "https://impact.com/privacy-policy/",
            "purposeIds": [],
            "legIntPurposeIds": [
                1,
                5
            ],
            "featureIds": []
        },
        {
            "id": 447,
            "name": "Adludio Ltd",
            "policyUrl": "https://adludio.com/privacypolicy",
            "purposeIds": [],
            "legIntPurposeIds": [
                5
            ],
            "featureIds": []
        },
        {
            "id": 410,
            "name": "Adtelligent Inc.",
            "policyUrl": "https://adtelligent.com/privacy-policy/",
            "purposeIds": [
                1,
                3
            ],
            "legIntPurposeIds": [],
            "featureIds": []
        },
        {
            "id": 137,
            "name": "mbr targeting GmbH",
            "policyUrl": "https://privacy.mbr-targeting.com/?optedIn=true",
            "purposeIds": [],
            "legIntPurposeIds": [
                1,
                2,
                3
            ],
            "featureIds": []
        },
        {
            "id": 395,
            "name": "PREX Programmatic Exchange GmbH&amp;Co KG",
            "policyUrl": "http://www.programmatic-exchange.com/privacy",
            "purposeIds": [],
            "legIntPurposeIds": [
                1,
                2,
                3,
                5
            ],
            "featureIds": []
        },
        {
            "id": 462,
            "name": "bidstack ltd",
            "policyUrl": "https://bidstack.com/policy/",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                1,
                2,
                3
            ]
        },
        {
            "id": 466,
            "name": "TACTIC\u2122 Real-Time Marketing AS",
            "policyUrl": "https://tacticrealtime.com/privacy/",
            "purposeIds": [
                1,
                3
            ],
            "legIntPurposeIds": [],
            "featureIds": []
        },
        {
            "id": 340,
            "name": "Yieldr UK",
            "policyUrl": "https://www.yieldr.com/privacy",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                1,
                3
            ]
        },
        {
            "id": 431,
            "name": "White Ops, Inc.",
            "policyUrl": "https://www.whiteops.com/privacy",
            "purposeIds": [],
            "legIntPurposeIds": [
                1,
                5
            ],
            "featureIds": [
                1,
                3
            ]
        },
        {
            "id": 336,
            "name": "Telecoming S.A.",
            "policyUrl": "http://www.telecoming.com/privacy-policy/",
            "purposeIds": [],
            "legIntPurposeIds": [
                1,
                2,
                3,
                4
            ],
            "featureIds": [
                3
            ]
        },
        {
            "id": 430,
            "name": "Ad Unity Ltd",
            "policyUrl": "http://www.adunity.com/privacy-policy.html",
            "purposeIds": [],
            "legIntPurposeIds": [
                3
            ],
            "featureIds": []
        },
        {
            "id": 346,
            "name": "Cybba, Inc.",
            "policyUrl": "http://cybba.com/about/legal/data-processing-agreement/",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": []
        },
        {
            "id": 469,
            "name": "Zeta Global",
            "policyUrl": "https://zetaglobal.com/privacy-policy/",
            "purposeIds": [],
            "legIntPurposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "featureIds": [
                1,
                2
            ]
        },
        {
            "id": 440,
            "name": "DEFINE MEDIA GMBH",
            "policyUrl": "http://www.definemedia.de/datenschutz-conative/",
            "purposeIds": [
                2,
                3,
                4
            ],
            "legIntPurposeIds": [
                1,
                5
            ],
            "featureIds": []
        },
        {
            "id": 375,
            "name": "RevX Inc.",
            "policyUrl": "https://www.revx.io/privacy-policy",
            "purposeIds": [
                1,
                2,
                3
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                3
            ]
        },
        {
            "id": 196,
            "name": "AdElement Media Solutions Pvt Ltd",
            "policyUrl": "http://adelement.com/privacy-policy.html",
            "purposeIds": [
                1,
                2,
                4
            ],
            "legIntPurposeIds": [
                3,
                5
            ],
            "featureIds": [
                3
            ]
        },
        {
            "id": 268,
            "name": "Social Tokens Ltd. ",
            "policyUrl": "http://woobi.com/privacy/",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                1,
                2,
                3
            ]
        },
        {
            "id": 475,
            "name": "TAPTAP Networks SL",
            "policyUrl": "http://www.taptapnetworks.com/privacy_policy/",
            "purposeIds": [
                1,
                2,
                3
            ],
            "legIntPurposeIds": [
                4,
                5
            ],
            "featureIds": [
                1,
                2,
                3
            ]
        },
        {
            "id": 474,
            "name": "hbfsTech",
            "policyUrl": "http://www.hbfstech.com/fr/privacy.html",
            "purposeIds": [],
            "legIntPurposeIds": [
                1,
                2
            ],
            "featureIds": []
        },
        {
            "id": 448,
            "name": "TARGETSPOT BELGIUM SPRL",
            "policyUrl": "http://marketing.targetspot.com/Targetspot/Legal/TargetSpot%20Privacy%20Policy%20-%20June%202018.pdf",
            "purposeIds": [],
            "legIntPurposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "featureIds": [
                1,
                2,
                3
            ]
        },
        {
            "id": 428,
            "name": "Internet BillBoard a.s.",
            "policyUrl": "http://www.ibillboard.com/en/privacy-information/",
            "purposeIds": [],
            "legIntPurposeIds": [
                1,
                3,
                4,
                5
            ],
            "featureIds": []
        },
        {
            "id": 461,
            "name": "B2B Media Group EMEA GmbH",
            "policyUrl": "https://www.selfcampaign.com/static/privacy",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": []
        },
        {
            "id": 476,
            "name": "HIRO Media Ltd",
            "policyUrl": "http://hiro-media.com/privacy.php",
            "purposeIds": [],
            "legIntPurposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "featureIds": [
                1
            ]
        },
        {
            "id": 480,
            "name": "pilotx.tv",
            "policyUrl": "https://pilotx.tv/privacy/",
            "purposeIds": [
                2,
                3
            ],
            "legIntPurposeIds": [
                1,
                4,
                5
            ],
            "featureIds": [
                1,
                2,
                3
            ]
        },
        {
            "id": 366,
            "name": "CerebroAd.com s.r.o.",
            "policyUrl": "https://www.cerebroad.com/privacy-policy",
            "purposeIds": [],
            "legIntPurposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "featureIds": [
                1,
                2,
                3
            ]
        },
        {
            "id": 392,
            "name": "Str\u00f6er Mobile Performance GmbH",
            "policyUrl": "https://stroeermobileperformance.com/?dl=privacy",
            "purposeIds": [
                2,
                3,
                4
            ],
            "legIntPurposeIds": [
                1,
                5
            ],
            "featureIds": [
                3
            ]
        },
        {
            "id": 221,
            "name": "LEMO MEDIA GROUP LIMITED",
            "policyUrl": "http://www.lemomedia.com/terms.pdf",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                3
            ]
        },
        {
            "id": 357,
            "name": "Totaljobs Group Ltd ",
            "policyUrl": "https://www.totaljobs.com/privacy-policy",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                1,
                2,
                3
            ]
        },
        {
            "id": 486,
            "name": "Madington",
            "policyUrl": "https://delivered-by-madington.com/dat-privacy-policy/",
            "purposeIds": [],
            "legIntPurposeIds": [
                1,
                5
            ],
            "featureIds": []
        },
        {
            "id": 468,
            "name": "Neustar, Inc.",
            "policyUrl": "https://www.home.neustar/privacy",
            "purposeIds": [
                1
            ],
            "legIntPurposeIds": [
                2,
                3,
                4,
                5
            ],
            "featureIds": [
                1,
                2
            ]
        },
        {
            "id": 458,
            "name": "AdColony, Inc.",
            "policyUrl": "http://www.adcolony.com/privacy-policy",
            "purposeIds": [],
            "legIntPurposeIds": [
                1,
                2,
                3,
                5
            ],
            "featureIds": [
                1
            ]
        },
        {
            "id": 478,
            "name": "RevLifter Ltd",
            "policyUrl": "https://www.revlifter.com/privacy-policy",
            "purposeIds": [
                1
            ],
            "legIntPurposeIds": [
                2
            ],
            "featureIds": []
        },
        {
            "id": 489,
            "name": "YellowHammer Media Group",
            "policyUrl": "http://www.yhmg.com/privacy-policy/",
            "purposeIds": [
                1,
                2,
                3
            ],
            "legIntPurposeIds": [],
            "featureIds": []
        },
        {
            "id": 484,
            "name": "Adledge",
            "policyUrl": "https://adledge.com/data-privacy/",
            "purposeIds": [],
            "legIntPurposeIds": [
                5
            ],
            "featureIds": []
        },
        {
            "id": 493,
            "name": "Clicksco Digital Limited",
            "policyUrl": "https://carbondmp.com/privacy.html",
            "purposeIds": [
                1,
                2,
                3,
                4
            ],
            "legIntPurposeIds": [
                5
            ],
            "featureIds": [
                2
            ]
        },
        {
            "id": 495,
            "name": "Arcspire Limited",
            "policyUrl": "https://s3.eu-west-2.amazonaws.com/public.arcspire.io/docs/ARCSPIRE-PrivacyPolicy_v1.0.pdf",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                3
            ]
        },
        {
            "id": 496,
            "name": "Automattic Inc.",
            "policyUrl": "https://en.blog.wordpress.com/2017/12/04/updated-privacy-policy/",
            "purposeIds": [
                1,
                2,
                3,
                4
            ],
            "legIntPurposeIds": [],
            "featureIds": []
        },
        {
            "id": 424,
            "name": "KUPONA GmbH",
            "policyUrl": "https://www.kupona.de/dsgvo/",
            "purposeIds": [],
            "legIntPurposeIds": [
                3,
                5
            ],
            "featureIds": []
        },
        {
            "id": 408,
            "name": "FM Labs LLC",
            "policyUrl": "https://fidelity-media.com/privacy-policy/",
            "purposeIds": [
                2
            ],
            "legIntPurposeIds": [
                1,
                3,
                4,
                5
            ],
            "featureIds": [
                3
            ]
        },
        {
            "id": 473,
            "name": "Sub2 Technologies Ltd",
            "policyUrl": "http://www.sub2tech.com/privacy-policy/",
            "purposeIds": [
                3,
                4,
                5
            ],
            "legIntPurposeIds": [
                1,
                2
            ],
            "featureIds": []
        },
        {
            "id": 467,
            "name": "Haensel AMS GmbH",
            "policyUrl": "https://haensel-ams.com/data-privacy/",
            "purposeIds": [
                3,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                2
            ]
        },
        {
            "id": 488,
            "name": "Opinary GmbH",
            "policyUrl": "https://opinary.com/privacy-policy/",
            "purposeIds": [],
            "legIntPurposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "featureIds": []
        },
        {
            "id": 490,
            "name": "PLAYGROUND XYZ EMEA LTD",
            "policyUrl": "https://playground.xyz/privacy/privacy-policy.pdf",
            "purposeIds": [
                1,
                3,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": []
        },
        {
            "id": 464,
            "name": "Oracle AddThis",
            "policyUrl": "http://www.addthis.com/privacy/privacy-policy/",
            "purposeIds": [
                1,
                2,
                3,
                4
            ],
            "legIntPurposeIds": [
                5
            ],
            "featureIds": [
                2
            ]
        },
        {
            "id": 491,
            "name": "Triboo Data Analytics",
            "policyUrl": "https://www.shinystat.com/it/informativa_sito.html",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": []
        },
        {
            "id": 499,
            "name": "PurposeLab, LLC",
            "policyUrl": "https://purposelab.com/privacy/",
            "purposeIds": [
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": []
        },
        {
            "id": 500,
            "name": "Turbo",
            "policyUrl": "http://www.turboadv.com/white-rabbit-privacy-policy/",
            "purposeIds": [
                1,
                2,
                3,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                2,
                3
            ]
        },
        {
            "id": 502,
            "name": "NEXD",
            "policyUrl": "https://nexd.com/privacy-policy",
            "purposeIds": [
                3,
                5
            ],
            "legIntPurposeIds": [
                1,
                2,
                4
            ],
            "featureIds": [
                3
            ]
        },
        {
            "id": 465,
            "name": "Schibsted Product and Tech UK",
            "policyUrl": "https://www.schibsted.com/",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                1
            ]
        },
        {
            "id": 497,
            "name": "Little Big Data sp.z.o.o.",
            "policyUrl": "http://dtxngr.com/legal/",
            "purposeIds": [
                1,
                2,
                4
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                1,
                2,
                3
            ]
        },
        {
            "id": 492,
            "name": "LotaData, Inc.",
            "policyUrl": "https://lotadata.com/privacy_policy",
            "purposeIds": [],
            "legIntPurposeIds": [
                1,
                5
            ],
            "featureIds": [
                1
            ]
        },
        {
            "id": 508,
            "name": "Lucid Holdings, LLC",
            "policyUrl": "https://luc.id/gdpr",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                1,
                2,
                3
            ]
        },
        {
            "id": 512,
            "name": "PubNative GmbH",
            "policyUrl": "https://pubnative.net/privacy-notice/",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                3
            ]
        },
        {
            "id": 471,
            "name": "FlexOffers.com, LLC",
            "policyUrl": "https://www.flexoffers.com/privacy-policy/",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                1,
                2,
                3
            ]
        },
        {
            "id": 494,
            "name": "Cablato Limited",
            "policyUrl": "https://cablato.com/privacy",
            "purposeIds": [
                1,
                2,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": []
        },
        {
            "id": 516,
            "name": "Pexi B.V.",
            "policyUrl": "https://pexi.nl/privacy-policy/",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": []
        },
        {
            "id": 507,
            "name": "AdsWizz Inc.",
            "policyUrl": "https://www.adswizz.com/our-privacy-policy/",
            "purposeIds": [],
            "legIntPurposeIds": [
                1,
                2,
                3,
                5
            ],
            "featureIds": [
                1,
                2,
                3
            ]
        },
        {
            "id": 482,
            "name": "UberMedia, Inc.",
            "policyUrl": "http://ubermedia.com/company/products-privacy-policy/#ADDITIONAL_NOTICE",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": []
        },
        {
            "id": 505,
            "name": "Shopalyst Inc",
            "policyUrl": "https://www.shortlyst.com/eu/privacy_terms.html",
            "purposeIds": [
                1,
                2
            ],
            "legIntPurposeIds": [],
            "featureIds": []
        },
        {
            "id": 517,
            "name": "SunMedia ",
            "policyUrl": "https://www.sunmedia.tv/en/cookies",
            "purposeIds": [
                1,
                2
            ],
            "legIntPurposeIds": [
                3
            ],
            "featureIds": [
                2
            ]
        },
        {
            "id": 518,
            "name": "Accelerize Inc.",
            "policyUrl": "https://getcake.com/privacy-policy/",
            "purposeIds": [
                1
            ],
            "legIntPurposeIds": [
                5
            ],
            "featureIds": [
                2,
                3
            ]
        },
        {
            "id": 511,
            "name": "Admixer EU GmbH",
            "policyUrl": "https://admixer.net/privacy",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                1,
                2,
                3
            ]
        },
        {
            "id": 479,
            "name": "INFINIA MOBILE S.L.",
            "policyUrl": "http://www.infiniamobile.com/privacy_policy",
            "purposeIds": [
                1,
                2,
                3
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                2,
                3
            ]
        },
        {
            "id": 513,
            "name": "Shopstyle",
            "policyUrl": "https://www.shopstyle.co.uk/privacy",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                1,
                2
            ]
        },
        {
            "id": 509,
            "name": "ATG Ad Tech Group GmbH",
            "policyUrl": "http://advandeo.com/privacy-policy/",
            "purposeIds": [
                1,
                3
            ],
            "legIntPurposeIds": [],
            "featureIds": []
        },
        {
            "id": 521,
            "name": "netzeffekt GmbH",
            "policyUrl": "https://www.netzeffekt.de/en/imprint",
            "purposeIds": [
                1
            ],
            "legIntPurposeIds": [
                3,
                5
            ],
            "featureIds": []
        },
        {
            "id": 487,
            "name": "nugg.ad GmbH",
            "policyUrl": "https://www.nugg.ad/en/privacy/general-information.html",
            "purposeIds": [],
            "legIntPurposeIds": [
                1,
                2,
                3,
                5
            ],
            "featureIds": [
                1
            ]
        },
        {
            "id": 515,
            "name": "ZighZag",
            "policyUrl": "https://zighzag.com/privacy",
            "purposeIds": [
                1,
                3
            ],
            "legIntPurposeIds": [
                5
            ],
            "featureIds": [
                1,
                2
            ]
        },
        {
            "id": 520,
            "name": "ChannelSight ",
            "policyUrl": "https://www.channelsight.com/privacypolicy/",
            "purposeIds": [
                1
            ],
            "legIntPurposeIds": [
                5
            ],
            "featureIds": []
        },
        {
            "id": 524,
            "name": "The Ozone Project Limited",
            "policyUrl": "https://ozoneproject.com/privacy-policy",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                2,
                3
            ]
        },
        {
            "id": 529,
            "name": "Fidzup",
            "policyUrl": "https://www.fidzup.com/en/privacy/",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                1,
                2,
                3
            ]
        },
        {
            "id": 528,
            "name": "AppLift GmbH ",
            "policyUrl": "https://www.applift.com/privacy-notice",
            "purposeIds": [
                1,
                2,
                3,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": []
        },
        {
            "id": 527,
            "name": "Jampp LTD",
            "policyUrl": "https://jampp.com/privacy-policy/",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                3
            ]
        },
        {
            "id": 506,
            "name": "salesforce.com, inc.",
            "policyUrl": "https://www.salesforce.com/company/privacy/",
            "purposeIds": [
                1,
                2,
                3
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                2
            ]
        },
        {
            "id": 534,
            "name": "SmartyAds Inc.",
            "policyUrl": "https://smartyads.com/privacy-policy",
            "purposeIds": [
                1,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                2,
                3
            ]
        },
        {
            "id": 535,
            "name": "INNITY",
            "policyUrl": "https://www.innity.com/privacy-policy.php",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": []
        },
        {
            "id": 514,
            "name": "Uprival LLC",
            "policyUrl": "https://uprival.com/privacy-policy/",
            "purposeIds": [
                1
            ],
            "legIntPurposeIds": [],
            "featureIds": []
        },
        {
            "id": 522,
            "name": "Tealium Inc",
            "policyUrl": "https://tealium.com/privacy/",
            "purposeIds": [
                2,
                3,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                1,
                2
            ]
        },
        {
            "id": 530,
            "name": "Near Pte Ltd",
            "policyUrl": "https://near.co/privacy",
            "purposeIds": [
                1,
                2,
                3,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                3
            ]
        },
        {
            "id": 539,
            "name": "AdDefend GmbH",
            "policyUrl": "https://www.addefend.com/en/privacy-policy/",
            "purposeIds": [],
            "legIntPurposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "featureIds": []
        },
        {
            "id": 501,
            "name": "Alliance Gravity Data Media",
            "policyUrl": "https://www.alliancegravity.com/politiquedeprotectiondesdonneespersonnelles",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                1,
                2
            ]
        },
        {
            "id": 519,
            "name": "Chargeads",
            "policyUrl": "https://www.chargeplatform.com/privacy",
            "purposeIds": [
                1,
                2
            ],
            "legIntPurposeIds": [
                3,
                4,
                5
            ],
            "featureIds": [
                1,
                2,
                3
            ]
        },
        {
            "id": 523,
            "name": "X-Mode Social, Inc.",
            "policyUrl": "http://xmode.io/privacy-policy.html",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                1,
                2,
                3
            ]
        },
        {
            "id": 537,
            "name": "RUN, Inc.",
            "policyUrl": "http://www.runads.com/privacy-policy",
            "purposeIds": [],
            "legIntPurposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "featureIds": [
                1,
                2,
                3
            ]
        },
        {
            "id": 531,
            "name": "Smartclip Hispania SL",
            "policyUrl": "http://rgpd-smartclip.com/",
            "purposeIds": [
                1,
                2,
                3,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": []
        },
        {
            "id": 536,
            "name": "GlobalWebIndex",
            "policyUrl": "http://legal.trendstream.net/non-panellist_privacy_policy",
            "purposeIds": [
                1
            ],
            "legIntPurposeIds": [
                3,
                5
            ],
            "featureIds": [
                1,
                2
            ]
        },
        {
            "id": 542,
            "name": "Densou Trading Desk ApS",
            "policyUrl": "https://densou.dk/Policy.html",
            "purposeIds": [],
            "legIntPurposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "featureIds": []
        },
        {
            "id": 525,
            "name": "PUB OCEAN LIMITED",
            "policyUrl": "https://rta.pubocean.com/privacy-policy/",
            "purposeIds": [
                1
            ],
            "legIntPurposeIds": [
                5
            ],
            "featureIds": [
                3
            ]
        },
        {
            "id": 544,
            "name": "Kochava Inc.",
            "policyUrl": "https://www.kochava.com/support-privacy/",
            "purposeIds": [],
            "legIntPurposeIds": [
                1,
                5
            ],
            "featureIds": []
        },
        {
            "id": 543,
            "name": "PaperG, Inc. dba Thunder Industries",
            "policyUrl": "https://www.makethunder.com/privacy",
            "purposeIds": [
                1,
                2
            ],
            "legIntPurposeIds": [
                3,
                4,
                5
            ],
            "featureIds": []
        },
        {
            "id": 334,
            "name": "Cydersoft",
            "policyUrl": "http://www.videmob.com/privacy.html",
            "purposeIds": [],
            "legIntPurposeIds": [
                1,
                2,
                3,
                4
            ],
            "featureIds": [
                2,
                3
            ]
        },
        {
            "id": 551,
            "name": "Illuma Technology Limited",
            "policyUrl": "https://www.weareilluma.com/endddd",
            "purposeIds": [
                1
            ],
            "legIntPurposeIds": [
                3
            ],
            "featureIds": []
        },
        {
            "id": 540,
            "name": "Tunnl BV",
            "policyUrl": "https://tunnl.com/privacy.html",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": []
        },
        {
            "id": 547,
            "name": "Video Reach",
            "policyUrl": "https://www.videoreach.de/about/privacy-policy/",
            "purposeIds": [
                1,
                3
            ],
            "legIntPurposeIds": [],
            "featureIds": []
        },
        {
            "id": 546,
            "name": "Smart Traffik",
            "policyUrl": "https://smart-traffik.io/politique-de-confidentialite",
            "purposeIds": [
                1
            ],
            "legIntPurposeIds": [
                3,
                4,
                5
            ],
            "featureIds": [
                3
            ]
        },
        {
            "id": 541,
            "name": "DeepIntent, Inc.",
            "policyUrl": "https://www.deepintent.com/platform-privacy-policy/",
            "purposeIds": [],
            "legIntPurposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "featureIds": [
                3
            ]
        },
        {
            "id": 545,
            "name": "ReigNN Platform Ltd.",
            "policyUrl": "https://www.reignn.com/user-privacy-policy/",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": []
        },
        {
            "id": 439,
            "name": "Bit Q Holdings Limited",
            "policyUrl": "https://bitqueen.com/privacy",
            "purposeIds": [
                1,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                1,
                2,
                3
            ]
        },
        {
            "id": 553,
            "name": "Adhese",
            "policyUrl": "https://adhese.com/privacy-and-cookie-policy",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                2,
                3
            ]
        },
        {
            "id": 556,
            "name": "adhood.com",
            "policyUrl": "http://v3.adhood.com/en/site/politikavekurallar/gizlilik.php?lang=en",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                3
            ]
        },
        {
            "id": 550,
            "name": "Happydemics",
            "policyUrl": "https://www.iubenda.com/privacy-policy/69056167/full-legal",
            "purposeIds": [
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                1,
                3
            ]
        },
        {
            "id": 560,
            "name": "Leiki Ltd.",
            "policyUrl": "http://www.leiki.com/privacy",
            "purposeIds": [
                1,
                2,
                3
            ],
            "legIntPurposeIds": [
                4
            ],
            "featureIds": []
        },
        {
            "id": 554,
            "name": "RMSi Radio Marketing Service interactive GmbH",
            "policyUrl": "https://www.rms.de/datenschutz/",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                1,
                2,
                3
            ]
        },
        {
            "id": 498,
            "name": "Dr. Banner",
            "policyUrl": "https://drbanner.com/privacypolicy_en/",
            "purposeIds": [
                1
            ],
            "legIntPurposeIds": [
                3
            ],
            "featureIds": [
                3
            ]
        },
        {
            "id": 565,
            "name": "Adobe Audience Manager",
            "policyUrl": "https://www.adobe.com/privacy/policy.html",
            "purposeIds": [
                1,
                2,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": []
        },
        {
            "id": 118,
            "name": "Drawbridge, Inc.",
            "policyUrl": "http://www.drawbridge.com/privacy/",
            "purposeIds": [
                1
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                2
            ]
        },
        {
            "id": 572,
            "name": "CHEQ AI TECHNOLOGIES LTD.",
            "policyUrl": "http://www.cheq.ai/privacy",
            "purposeIds": [
                1
            ],
            "legIntPurposeIds": [
                5
            ],
            "featureIds": []
        },
        {
            "id": 571,
            "name": "ViewPay",
            "policyUrl": "http://viewpay.tv/mentions-legales/",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                3
            ]
        },
        {
            "id": 568,
            "name": "Jointag S.r.l.",
            "policyUrl": "https://www.jointag.com/privacy/kariboo/publisher/third/",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                3
            ]
        },
        {
            "id": 570,
            "name": "Czech Publisher Exchange z.s.p.o.",
            "policyUrl": "https://www.cpex.cz/pro-uzivatele/ochrana-soukromi/",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                1,
                2
            ]
        },
        {
            "id": 559,
            "name": "Otto (GmbH &amp; Co KG)",
            "policyUrl": "https://www.otto.de/shoppages/service/datenschutz",
            "purposeIds": [],
            "legIntPurposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "featureIds": [
                2
            ]
        },
        {
            "id": 548,
            "name": "LBC France",
            "policyUrl": "https://www.leboncoin.fr/dc/cookies",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                2,
                3
            ]
        },
        {
            "id": 569,
            "name": "Kairos Fire",
            "policyUrl": "https://www.kairosfire.com/wp-content/uploads/2019/02/Kairos-Fire_Politique-de-confidentialite%CC%81_jan19.pdf",
            "purposeIds": [
                1,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                1,
                3
            ]
        },
        {
            "id": 577,
            "name": "Neustar on behalf of The Procter & Gamble Company",
            "policyUrl": "https://www.pg.com/privacy/english/privacy_statement.shtml",
            "purposeIds": [],
            "legIntPurposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "featureIds": [
                1,
                2
            ]
        },
        {
            "id": 590,
            "name": "Sourcepoint Technologies, Inc.",
            "policyUrl": "https://www.sourcepoint.com/privacy-policy",
            "purposeIds": [],
            "legIntPurposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "featureIds": []
        },
        {
            "id": 587,
            "name": "Localsensor B.V.",
            "policyUrl": "https://www.localsensor.com/privacy.html",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                1,
                3
            ]
        },
        {
            "id": 578,
            "name": "MAIRDUMONT NETLETIX GmbH&amp;Co. KG",
            "policyUrl": "https://mairdumont-netletix.com/datenschutz",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                3
            ]
        },
        {
            "id": 580,
            "name": "Goldbach Group AG",
            "policyUrl": "https://goldbach.com/ch/de/datenschutz",
            "purposeIds": [],
            "legIntPurposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "featureIds": [
                1,
                2,
                3
            ]
        },
        {
            "id": 593,
            "name": "Programatica de publicidad S.L.",
            "policyUrl": "https://datmean.com/politica-privacidad/",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                1,
                2,
                3
            ]
        },
        {
            "id": 574,
            "name": "Realeyes O\u00dc",
            "policyUrl": "https://www.realeyesit.com/privacy",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                1,
                2
            ]
        },
        {
            "id": 581,
            "name": "Mobilewalla, Inc.",
            "policyUrl": "https://www.mobilewalla.com/business-services-privacy-policy",
            "purposeIds": [],
            "legIntPurposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "featureIds": [
                1,
                2,
                3
            ]
        },
        {
            "id": 598,
            "name": "audio content &amp; control GmbH",
            "policyUrl": "https://www.audio-cc.com/audiocc_privacy_policy.pdf",
            "purposeIds": [
                1
            ],
            "legIntPurposeIds": [
                3,
                4,
                5
            ],
            "featureIds": [
                3
            ]
        },
        {
            "id": 596,
            "name": "InsurAds Technologies SA.",
            "policyUrl": "https://www.insurads.com/privacy.html",
            "purposeIds": [
                3
            ],
            "legIntPurposeIds": [
                5
            ],
            "featureIds": [
                3
            ]
        },
        {
            "id": 576,
            "name": "StartApp Inc.",
            "policyUrl": "https://www.startapp.com/policy/privacy-policy/",
            "purposeIds": [
                2
            ],
            "legIntPurposeIds": [
                1,
                3,
                4,
                5
            ],
            "featureIds": [
                3
            ]
        },
        {
            "id": 592,
            "name": "Colpirio.com",
            "policyUrl": "https://privacy-policy.colpirio.com/en/",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": []
        },
        {
            "id": 549,
            "name": "Bandsintown Amplified LLC",
            "policyUrl": "http://corp.bandsintown.com/privacy",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                2
            ]
        },
        {
            "id": 597,
            "name": "Better Banners A/S",
            "policyUrl": "https://betterbanners.com/en/privacy",
            "purposeIds": [],
            "legIntPurposeIds": [
                3,
                5
            ],
            "featureIds": []
        },
        {
            "id": 584,
            "name": "Dynamic 1001 GmbH",
            "policyUrl": "https://dynamic-tracking.com/Datenschutz.aspx",
            "purposeIds": [
                3
            ],
            "legIntPurposeIds": [
                1
            ],
            "featureIds": []
        },
        {
            "id": 601,
            "name": "WebAds B.V",
            "policyUrl": "http://privacy.webads.eu/",
            "purposeIds": [
                1,
                2,
                3
            ],
            "legIntPurposeIds": [],
            "featureIds": []
        },
        {
            "id": 599,
            "name": "Maximus Live LLC",
            "policyUrl": "https://maximusx.com/privacy-policy/",
            "purposeIds": [],
            "legIntPurposeIds": [
                3,
                4,
                5
            ],
            "featureIds": [
                2,
                3
            ]
        },
        {
            "id": 604,
            "name": "Join",
            "policyUrl": "https://www.teamjoin.fr/privacy.html",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                1,
                2,
                3
            ]
        },
        {
            "id": 606,
            "name": "Impactify ",
            "policyUrl": "https://impactify.io/privacy-policy/",
            "purposeIds": [
                1,
                2
            ],
            "legIntPurposeIds": [
                3,
                4,
                5
            ],
            "featureIds": []
        },
        {
            "id": 608,
            "name": "News and Media Holding, a.s.",
            "policyUrl": "https://www.newsandmedia.sk/gdpr/",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                1,
                2,
                3
            ]
        },
        {
            "id": 602,
            "name": "Online Solution Int Limited",
            "policyUrl": "https://adsafety.net/privacy.html/",
            "purposeIds": [
                1,
                2
            ],
            "legIntPurposeIds": [
                3,
                4,
                5
            ],
            "featureIds": []
        },
        {
            "id": 612,
            "name": "Adnami Aps",
            "policyUrl": "https://www.adnami.io/adnami_privacy",
            "purposeIds": [],
            "legIntPurposeIds": [
                3
            ],
            "featureIds": []
        },
        {
            "id": 591,
            "name": "Consumable, Inc.",
            "policyUrl": "http://consumable.com/privacy-policy.html",
            "purposeIds": [
                1,
                3
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                1,
                2
            ]
        },
        {
            "id": 614,
            "name": "Market Resource Partners LLC",
            "policyUrl": "https://www.mrpfd.com/privacy-policy/",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                1,
                2,
                3
            ]
        },
        {
            "id": 615,
            "name": "Adsolutions BV",
            "policyUrl": "https://www.adsolutions.com/privacy-policy/",
            "purposeIds": [
                1,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": []
        },
        {
            "id": 607,
            "name": "ucfunnel Co., Ltd.",
            "policyUrl": "https://www.ucfunnel.com/privacy-policy",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                3
            ]
        },
        {
            "id": 609,
            "name": "Predicio",
            "policyUrl": "http://www.predic.io/privacy",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                1,
                2,
                3
            ]
        },
        {
            "id": 617,
            "name": "Onfocus (Adagio)",
            "policyUrl": "https://adagio.io/privacy",
            "purposeIds": [],
            "legIntPurposeIds": [
                1
            ],
            "featureIds": []
        },
        {
            "id": 620,
            "name": "Blue",
            "policyUrl": "http://www.getblue.io/privacy/",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": []
        },
        {
            "id": 610,
            "name": "Azerion Holding B.V.",
            "policyUrl": "https://azerion.com/business/privacy.html",
            "purposeIds": [],
            "legIntPurposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "featureIds": [
                1,
                2,
                3
            ]
        },
        {
            "id": 621,
            "name": "Seznam.cz, a.s.",
            "policyUrl": "https://www.seznam.cz/ochranaudaju",
            "purposeIds": [
                2,
                3,
                4
            ],
            "legIntPurposeIds": [
                1,
                5
            ],
            "featureIds": []
        },
        {
            "id": 624,
            "name": "Norstat Danmark A/S",
            "policyUrl": "https://panel.norstat.dk/sikkerhed",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                1,
                2
            ]
        },
        {
            "id": 623,
            "name": "Adprime Media Inc. ",
            "policyUrl": "http://adprimehealth.com/privacy/",
            "purposeIds": [
                1,
                2,
                3
            ],
            "legIntPurposeIds": [],
            "featureIds": []
        },
        {
            "id": 95,
            "name": "Lotame Solutions, Inc.",
            "policyUrl": "https://www.lotame.com/about-lotame/privacy/",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": []
        },
        {
            "id": 618,
            "name": "BEINTOO SPA",
            "policyUrl": "http://www.beintoo.com/privacy-cookie-policy/",
            "purposeIds": [
                1,
                3
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                3
            ]
        },
        {
            "id": 619,
            "name": "Capitaldata",
            "policyUrl": "https://www.capitaldata.fr/privacy",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                1,
                2,
                3
            ]
        },
        {
            "id": 625,
            "name": "BILENDI SA",
            "policyUrl": "https://www.maximiles.com/privacy-policy",
            "purposeIds": [
                1,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                2
            ]
        },
        {
            "id": 628,
            "name": ": Tappx",
            "policyUrl": "https://www.tappx.com/en/privacy-policy/",
            "purposeIds": [
                1
            ],
            "legIntPurposeIds": [
                2,
                3
            ],
            "featureIds": [
                2,
                3
            ]
        },
        {
            "id": 630,
            "name": "Contact Impact GmbH",
            "policyUrl": "https://contactimpact.de/privacy",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                3
            ]
        },
        {
            "id": 626,
            "name": "Hivestack Inc.",
            "policyUrl": "https://hivestack.com/privacy-policy",
            "purposeIds": [],
            "legIntPurposeIds": [
                1
            ],
            "featureIds": [
                3
            ]
        },
        {
            "id": 631,
            "name": "Relay42 Netherlands B.V.",
            "policyUrl": "https://relay42.com/privacy",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                1,
                2,
                3
            ]
        },
        {
            "id": 627,
            "name": "D-Edge",
            "policyUrl": "https://www.d-edge.com/privacy-policy/",
            "purposeIds": [
                1
            ],
            "legIntPurposeIds": [],
            "featureIds": []
        },
        {
            "id": 638,
            "name": "Passendo ApS",
            "policyUrl": "https://www.passendo.com/users-privacy-policy/",
            "purposeIds": [
                1,
                3
            ],
            "legIntPurposeIds": [],
            "featureIds": []
        },
        {
            "id": 644,
            "name": "Gamoshi LTD",
            "policyUrl": "https://www.gamoshi.com/privacy-policy",
            "purposeIds": [
                1
            ],
            "legIntPurposeIds": [],
            "featureIds": []
        },
        {
            "id": 634,
            "name": "Samba TV",
            "policyUrl": "https://samba.tv/legal/privacy-policy/",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                1,
                2
            ]
        },
        {
            "id": 639,
            "name": "Smile Wanted Group",
            "policyUrl": "https://www.smilewanted.com/privacy.php",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": []
        },
        {
            "id": 635,
            "name": "WebMediaRM",
            "policyUrl": "http://www.webmediarm.com/vie_privee_et_opposition_en.php",
            "purposeIds": [
                3,
                4
            ],
            "legIntPurposeIds": [
                1,
                2,
                5
            ],
            "featureIds": []
        },
        {
            "id": 579,
            "name": "Ve Global",
            "policyUrl": "https://www.ve.com/privacy-policy",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": []
        },
        {
            "id": 645,
            "name": "Noster Finance S.L.",
            "policyUrl": "https://www.finect.com/terminos-legales/politica-de-cookies",
            "purposeIds": [
                1,
                2,
                3,
                4,
                5
            ],
            "legIntPurposeIds": [],
            "featureIds": [
                2,
                3
            ]
        }
    ]
};

},{}],60:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var $ = require("../../js/utils/dom");
var debounce_1 = require("../../js/utils/debounce");
var cnil_cookie_1 = require("./cnil-cookie");
var cnil_cookie_banner_1 = require("./cnil-cookie-banner");
var env = require("../env/env");
var cnilCookieAutoUpdater;
(function (cnilCookieAutoUpdater) {
    cnilCookieAutoUpdater.consumed = false;
    function onClick(e) {
        if (cnilCookieAutoUpdater.consumed) {
            return;
        }
        var $anchor = $(e.target).parent('A');
        if ($anchor.length == 1 && $anchor[0].href.indexOf(env.getSite()) !== -1) {
            cnil_cookie_1.cnilCookie.writeValues(cnil_cookie_1.ALL_ON, cnil_cookie_1.CLICK_ACTION);
        }
    }
    function onScroll() {
        if (cnilCookieAutoUpdater.consumed) {
            return;
        }
        if (window.pageYOffset > window.innerHeight) {
            cnil_cookie_1.cnilCookie.writeValues(cnil_cookie_1.ALL_ON, cnil_cookie_1.SCROLL_ACTION);
            cnil_cookie_banner_1.cnilCookieBanner.hideMainBanner();
        }
    }
    function init() {
        if (cnil_cookie_1.cnilCookie.isActive()) {
            $(document.body).on('click', 'a:not([data-cnil="1"])', onClick);
            window.addEventListener('scroll', debounce_1.default(function () { return onScroll(); }, 300));
            cnil_cookie_1.cnilCookie.onChange(function () {
                // cookie has been written (through this module code or even banner or else)
                cnilCookieAutoUpdater.consumed = true;
            });
        }
    }
    cnilCookieAutoUpdater.init = init;
    function isCnilSafe() {
        return document.querySelector('[data-cnil-safe="true"]') != undefined;
    }
    cnilCookieAutoUpdater.isCnilSafe = isCnilSafe;
})(cnilCookieAutoUpdater = exports.cnilCookieAutoUpdater || (exports.cnilCookieAutoUpdater = {}));

},{"../../js/utils/debounce":70,"../../js/utils/dom":71,"../env/env":65,"./cnil-cookie":63,"./cnil-cookie-banner":61}],61:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var cnil_cookie_1 = require("./cnil-cookie");
var didomi_1 = require("../cmp/didomi");
var cnilCookieBanner;
(function (cnilCookieBanner) {
    var $mainBanner;
    function init(options, cb) {
        if (cnil_cookie_1.cnilCookie.isActive()) {
            injectBanner(options, cb);
            $mainBanner = options.$container.select('[data-role=cnil-banner]');
        }
    }
    cnilCookieBanner.init = init;
    function injectBanner(options, cb) {
        prependHTML(options.$container[0], options.html);
        var $banner = options.$container.select('[data-role=cnil-banner]');
        $banner.select('[data-action=accept]').on('click', function (e) {
            var category = e.target.getAttribute('data-category');
            if (category) {
                cnil_cookie_1.cnilCookie.setCategory(category, true, cnil_cookie_1.BANNER_ACTION);
            }
            else {
                cnil_cookie_1.cnilCookie.writeValues(cnil_cookie_1.ALL_ON, cnil_cookie_1.BANNER_ACTION);
            }
            if ($banner) {
                $banner.css('display', 'none');
            }
            if (cb) {
                cb();
            }
        });
        $banner.select('[data-action=consent]').on('click', function (e) {
            var purpose = e.target.getAttribute('data-purpose');
            didomi_1.CmpDidomi.enablePurpose(purpose);
            if ($banner) {
                $banner.css('display', 'none');
            }
            if (cb) {
                cb();
            }
        });
        $banner.select('[data-action=close]').on('click', function (e) {
            if ($banner) {
                $banner.css('display', 'none');
            }
        });
    }
    cnilCookieBanner.injectBanner = injectBanner;
    function hideMainBanner() {
        if ($mainBanner) {
            $mainBanner.css('display', 'none');
        }
    }
    cnilCookieBanner.hideMainBanner = hideMainBanner;
    function showMainBanner() {
        if ($mainBanner) {
            $mainBanner.css('display', '');
        }
    }
    cnilCookieBanner.showMainBanner = showMainBanner;
    function prependHTML(elParent, html) {
        if (!elParent) {
            return;
        }
        var elChild = document.createElement('div');
        elChild.innerHTML = html;
        elParent.insertBefore(elChild, elParent.firstChild);
    }
})(cnilCookieBanner = exports.cnilCookieBanner || (exports.cnilCookieBanner = {}));

},{"../cmp/didomi":57,"./cnil-cookie":63}],62:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var $ = require("../../js/utils/dom");
var cnil_cookie_1 = require("./cnil-cookie");
var cnilCookieFormPage;
(function (cnilCookieFormPage) {
    function init() {
        var form = document.forms['form-cnil'];
        if (form) {
            initFormWithCookie();
            $("input[type=checkbox]").forEach(function (input) {
                input.addEventListener('change', function () {
                    cnil_cookie_1.cnilCookie.writeValues(getValue(), cnil_cookie_1.PREFERENCES_ACTION);
                });
            });
        }
    }
    cnilCookieFormPage.init = init;
    function initFormWithCookie() {
        var categories = cnil_cookie_1.cnilCookie.readValues();
        if (categories) {
            $("input[name=cookiesForAds]")[0].checked = categories.ads;
            $("input[name=cookiesForAnalytics]")[0].checked = categories.analytics;
            $("input[name=cookiesForSocial]")[0].checked = categories.social;
        }
        else {
            $("input[type=checkbox]").forEach(function (input) { return input.checked = false; });
        }
    }
    cnilCookieFormPage.initFormWithCookie = initFormWithCookie;
    function getValue() {
        return {
            ads: $("input[name=cookiesForAds]")[0].checked,
            analytics: $("input[name=cookiesForAnalytics]")[0].checked,
            social: $("input[name=cookiesForSocial]")[0].checked,
        };
    }
    cnilCookieFormPage.getValue = getValue;
})(cnilCookieFormPage = exports.cnilCookieFormPage || (exports.cnilCookieFormPage = {}));

},{"../../js/utils/dom":71,"./cnil-cookie":63}],63:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var userAgent = require("../../js/env/user-agent");
var cookies = require("js-cookie");
var env = require("../env/env");
var random = require("../utils/random");
var cnil_cookie_auto_updater_1 = require("./cnil-cookie-auto-updater");
var observable_1 = require("../utils/observable");
// categories
exports.ADS = 'ads';
exports.ANALYTICS = 'analytics';
exports.SOCIAL = 'social';
exports.COOKIE_NAME = 'cnil-cookie-v2';
exports.COOKIE_ID_NAME = 'cnil-cookie-id';
var ONE_YEAR = 365;
exports.COOKIE_DURATION = ONE_YEAR + 28; // about 13 months
exports.COOKIE_ID_DURATION = 10 * ONE_YEAR;
exports.ALL_ON = { ads: true, analytics: true, social: true };
exports.ALL_OFF = { ads: false, analytics: false, social: false };
// action types
exports.BANNER_ACTION = 'banner';
exports.CLICK_ACTION = 'click';
exports.SCROLL_ACTION = 'scroll';
exports.PREFERENCES_ACTION = 'preferences';
var cnilCookie;
(function (cnilCookie) {
    var observable = new observable_1.Observable();
    function ensureId() {
        if (!cookies.get(exports.COOKIE_ID_NAME)) {
            cookies.set(exports.COOKIE_ID_NAME, random.uuid(), { expires: exports.COOKIE_ID_DURATION, path: '/', domain: env.getCookieDomain() });
        }
    }
    cnilCookie.ensureId = ensureId;
    function getId() {
        if (!cookies.get(exports.COOKIE_ID_NAME)) {
            ensureId();
        }
        return cookies.get(exports.COOKIE_ID_NAME);
    }
    cnilCookie.getId = getId;
    function writeValues(categories, actionType) {
        var oldValue = readValues();
        cookies.set(exports.COOKIE_NAME, JSON.stringify(categories), { expires: exports.COOKIE_DURATION, path: '/', domain: env.getCookieDomain() });
        observable.fire({ value: readValues(), oldValue: oldValue });
    }
    cnilCookie.writeValues = writeValues;
    function setCategory(category, value, actionType) {
        var cookie = readValues() || { ads: true, analytics: true, social: true };
        cookie[category] = value;
        writeValues(cookie, actionType);
    }
    cnilCookie.setCategory = setCategory;
    function readValues() {
        var values = cookies.get(exports.COOKIE_NAME);
        try {
            return JSON.parse(values);
        }
        catch (e) {
            return null;
        }
    }
    cnilCookie.readValues = readValues;
    function hasValidCookie() {
        return readValues() != null;
    }
    cnilCookie.hasValidCookie = hasValidCookie;
    function isOn(category) {
        var categories = readValues();
        if (categories) {
            return categories[category];
        }
        else {
            return false;
        }
    }
    cnilCookie.isOn = isOn;
    function isActive() {
        return !userAgent.isBot() && !cnilCookie.hasValidCookie() && !cnil_cookie_auto_updater_1.cnilCookieAutoUpdater.isCnilSafe();
    }
    cnilCookie.isActive = isActive;
    function onChange(handler) {
        observable.observe(handler);
    }
    cnilCookie.onChange = onChange;
})(cnilCookie = exports.cnilCookie || (exports.cnilCookie = {}));

},{"../../js/env/user-agent":66,"../env/env":65,"../utils/observable":75,"../utils/random":76,"./cnil-cookie-auto-updater":60,"js-cookie":46}],64:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var cookies = require("js-cookie");
var cnil_cookie_1 = require("./cnil-cookie");
var cnil_cookie_auto_updater_1 = require("./cnil-cookie-auto-updater");
var cnil_cookie_banner_1 = require("./cnil-cookie-banner");
var cnil_cookie_form_page_1 = require("./cnil-cookie-form-page");
var cnil;
(function (cnil) {
    cnil.cookie = cnil_cookie_1.cnilCookie;
    cnil.banner = cnil_cookie_banner_1.cnilCookieBanner;
    cnil.formPage = cnil_cookie_form_page_1.cnilCookieFormPage;
    function v2Active() {
        // return env.getCookieDomain() == 'rtl2.fr' || env.getCookieDomain() == 'funradio.fr' || cookies.get('cnil-cookie-mode') == 'v2';  TODO WEBDEV-3591 : remove and clean files when done
        return true;
    }
    cnil.v2Active = v2Active;
    function activateV2() {
        cookies.set('cnil-cookie-mode', 'v2');
    }
    cnil.activateV2 = activateV2;
    function isOn(category) {
        if (!v2Active()) {
            // while v2 is not active, all is on
            return true;
        }
        return cnil_cookie_1.cnilCookie.isOn(category);
    }
    cnil.isOn = isOn;
    function isOff(category) {
        return !isOn(category);
    }
    cnil.isOff = isOff;
})(cnil = exports.cnil || (exports.cnil = {}));
if (window.location.search.indexOf('cnil-cookie-mode-v2') != -1) {
    cnil.activateV2();
}
cnil_cookie_auto_updater_1.cnilCookieAutoUpdater.init();
cnil_cookie_form_page_1.cnilCookieFormPage.init();

},{"./cnil-cookie":63,"./cnil-cookie-auto-updater":60,"./cnil-cookie-banner":61,"./cnil-cookie-form-page":62,"js-cookie":46}],65:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEnv = function () {
    return window.env ? window.env : 'prod';
};
exports.isProd = function () {
    return exports.getEnv() == 'prod';
};
exports.isLab = function () {
    return !exports.isProd();
};
exports.isAppwebview = function () {
    return window.appwebview == 'true';
};
exports.isSecured = function () {
    return location && location.protocol === 'https:';
};
exports.getStaticRoot = function () {
    return window.staticRoot;
};
exports.getContextRoot = function () {
    return window.contextRoot;
};
exports.getCookieDomain = function (hostname) {
    hostname = hostname || window.location.hostname;
    if (hostname == 'localhost' || hostname == '0.0.0.0') {
        return '';
    }
    return extractDomain(hostname);
};
exports.getFlags = function () {
    return window.flags == undefined ? [] : window.flags;
};
exports.isFlag = function (name) {
    return exports.getFlags().indexOf(name) != -1;
};
exports.getSite = function () {
    return window.site || 'www.rtl.fr';
};
exports.getDomain = function () {
    return extractDomain(exports.getSite());
};
exports.getRenaissanceDomain = function () {
    switch (exports.getSite()) {
        case 'www.rtl2.fr': return 'RTL2';
        case 'www.funradio.fr': return 'FUN_RADIO';
        default: return 'RTL';
    }
};
var extractDomain = function (site) {
    return site.split('.').reverse().splice(0, 2).reverse().join('.');
};

},{}],66:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * Google page speed use an old version of chrome,
 * so we check it before it wreck our stats
 */
exports.isGgPageSpeed = function () {
    return !!navigator.userAgent.match(/Google Page Speed Insights/gi);
};
exports.isGgBot = function () {
    return !!navigator.userAgent.match(/Googlebot/gi);
};
exports.isMobile = function (userAgent) {
    userAgent = userAgent || navigator.userAgent;
    return userAgent.match(/Android|webOS|iPhone|iPad|iPod|BlackBerry|Windows Phone|Opera Mini|IEMobile|Mobile/i) != null;
};
exports.isWindowsPhone7 = function () {
    return !!navigator.userAgent.match(/Windows Phone OS 7.5/gi);
};
exports.isBot = function () {
    return exports.isGgPageSpeed() || exports.isGgBot();
};
// works only in renaissance which sets a RTLNET_IE8_BROWSER global variable
exports.isIE8 = function () {
    return window['RTLNET_IE8_BROWSER'] || false;
};
exports.isIE = function () {
    return navigator.userAgent.toLowerCase().indexOf('msie') != -1;
};
exports.getIEVersion = function () {
    return exports.isIE() ? parseInt(navigator.userAgent.toLowerCase().split('msie')[1]) : null;
};

},{}],67:[function(require,module,exports){
// https://tc39.github.io/ecma262/#sec-array.prototype.find
if (!Array.prototype['find']) {
    Object.defineProperty(Array.prototype, 'find', {
        value: function (predicate) {
            // 1. Let O be ? ToObject(this value).
            if (this == null) {
                throw new TypeError('"this" is null or not defined');
            }
            var o = Object(this);
            // 2. Let len be ? ToLength(? Get(O, "length")).
            var len = o.length >>> 0;
            // 3. If IsCallable(predicate) is false, throw a TypeError exception.
            if (typeof predicate !== 'function') {
                throw new TypeError('predicate must be a function');
            }
            // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
            var thisArg = arguments[1];
            // 5. Let k be 0.
            var k = 0;
            // 6. Repeat, while k < len
            while (k < len) {
                // a. Let Pk be ! ToString(k).
                // b. Let kValue be ? Get(O, Pk).
                // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
                // d. If testResult is true, return kValue.
                var kValue = o[k];
                if (predicate.call(thisArg, kValue, k, o)) {
                    return kValue;
                }
                // e. Increase k by 1.
                k++;
            }
            // 7. Return undefined.
            return undefined;
        },
        configurable: true,
        writable: true
    });
}

},{}],68:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Promise = require("promise");
var scriptLoader = require("../../js/utils/script-loader");
var SCRIPT = 'https://js.estat.com/js/mu-6.0.js';
exports.ensureLoaded = function () {
    return new Promise(function (resolve) {
        scriptLoader.ensureLoaded(SCRIPT).then(function () {
            resolve();
        });
    });
};
/**
 * estat should be loaded before calling this function
 */
exports.createEstatTag = function (config) {
    return new window.eStatTag(config);
};

},{"../../js/utils/script-loader":77,"promise":178}],69:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// marqueur whap pour la mesure hybride WEBDEV-3483
var scriptloader = require("../../js/utils/script-loader");
exports.init = function () {
    window._eStat_Whap_loaded_func = function () {
        window.eStatWhap.serial('800000000089');
        window.eStatWhap.send();
    };
    scriptloader.ensureLoaded('https://w.estat.com/js/whap.js');
};

},{"../../js/utils/script-loader":77}],70:[function(require,module,exports){
"use strict";
/**
 * https://davidwalsh.name/javascript-debounce-function
 */
Object.defineProperty(exports, "__esModule", { value: true });
function default_1(func, wait, immediate) {
    var timeout;
    return function () {
        var context = this, args = arguments;
        var later = function () {
            timeout = null;
            if (!immediate) {
                func.apply(context, args);
            }
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) {
            func.apply(context, args);
        }
    };
}
exports.default = default_1;
;

},{}],71:[function(require,module,exports){
(function (global){

var utils = require('./utils');
var domCss = require('./dom/css');
var classes = require('./dom/classes');
var api = require('./dom/api');

/**
 * Work in progress, added features as needed. Inspired by :
 * - jquery
 * - https://github.com/bevacqua/dominus
 * - https://github.com/npm-dom/domquery
 * - https://github.com/component/dom
 * Aims to provide simple dom handling methods compatible with testing and browserify
 */

// default method is select at document level
module.exports = function (selector) {
    if (utils.isElement(selector)) {
        return augmentArray([selector]);
    } else {
        return augmentArray(select(document, selector));
    }
}

/**
 * method called 'select' not to get confused with Array.find method
 */
module.exports.select = module.exports;
module.exports.selectByClass = function (clazz) {
    return augmentArray(selectByClass(document, clazz));
};

function select(context, selector) {
    return utils.toArray(context.querySelectorAll(selector));
}

/**
 * selecting by class (getElementsByClassName) is a bit easier and faster than querySelectorAll
 * but doesn't work on ie <= i8 (http://caniuse.com/#search=getElementsByClassName)
 * http://stackoverflow.com/questions/30473141/difference-between-getelementsbyclassname-and-queryselectorall
 */
function selectByClass(context, clazz) {
    return utils.toArray(context.getElementsByClassName(clazz));
}

function augmentArray(array) {
    array.selectByMatcher = array_selectByMatcher;
    array.select = array_select;
    array.selectByClass = array_selectByClass;
    array.parent = array_parent;
    array.firstChild = array_firstChild;
    array.children = array_children;

    array.index = array_index;

    array.isEmpty = array_isEmpty;
    array.clear = array_clear;

    array.text = array_api_call.bind(array, api.text);
    array.html = array_api_call.bind(array, api.html);
    array.value = array_api_call.bind(array, api.value);

    array.data = array_data;
    array.attr = array_attr;
    array.removeAttr = array_removeAttr;

    array.css = array_css;
    array.bounds = array_bounds;
    array.addClass = array_classes_call.bind(array, classes.add);
    array.removeClass = array_classes_call.bind(array, classes.remove);
    array.hasClass = array_hasClass;

    array.before = array_insertAdjacentHTML.bind(array, 'beforebegin');
    array.prepend = array_insertAdjacentHTML.bind(array, 'afterbegin');
    array.append = array_insertAdjacentHTML.bind(array, 'beforeend');
    array.after = array_insertAdjacentHTML.bind(array, 'afterend');
    // migrated from renaissance dom api. This is akward here since it only happend on first selected node
    array.appendTag = array_append_tag;

    array.on = array_on;

    return array;
}

/**
 * Augmented array methods
 */

var array_selectByMatcher = function(selector, matcher) {
    var result = [];

    this.forEach(function(element) {
        result = result.concat(matcher(element, selector));
    });

    return augmentArray(result);
}

var array_select = function(selector) {
    return this.selectByMatcher(selector, select);
}

var array_selectByClass = function(selector) {
    return this.selectByMatcher(selector, selectByClass);
}

var array_isEmpty = function() {
    return this.length == 0
}

var array_clear = function() {
    this.forEach(function(element) {
        element.innerHTML = "";
    });
}

var array_data = function(name) {
    return this.isEmpty() ? null : this[0].getAttribute('data-' + name);
}

var array_parent = function (selector) {
    if (this.isEmpty()) {
        return augmentArray([]);
    }

    var element = this[0];
    if (selector) {
        while (!element.matches(selector)) {
            element = element.parentNode;

            if (!element) {
                return augmentArray([]);
            }
        }

        return augmentArray([element]);
    } else {
        return element.parentNode ? augmentArray([element.parentNode]) : augmentArray([]);
    }
}

var array_firstChild = function (selector) {
    if (this.isEmpty()) {
        return augmentArray([]);
    }

    var element = this[0];
    if (selector) {
        return augmentArray([element.getElementsByClassName(selector)[0]])
    }
}

var array_children = function (selector) {
    if (this.isEmpty()) {
        return augmentArray([]);
    }

    var element = this[0];
    if (selector) {
        return augmentArray(element.querySelectorAll(selector));
    } else {
        return element.children ? augmentArray(element.children) : augmentArray([]);
    }
}

var array_index = function (selector) {
    for (var index = 0; index < this.length; index++) {
        if (classes.contains(this[index], selector)) {
            return index;
        }
    }

    return -1;
}

var array_api_call = function(api, value) {
    var getter = arguments.length < 2;

    if (getter) {
        return this.length ? api(this[0]) : '';
    } else {
        this.forEach(function (element) {
            api(element, value);
        });
        return this;
    }
}

var array_attr = function (name, value) {
    var hash = name && typeof name === 'object';
    var set = hash ? setMany : setSingle;
    var setter = hash || arguments.length > 1;
    if (setter) {
        this.forEach(set);
        return this;
    } else {
        return this.length ? api.getAttr(this[0], name) : null;
    }
    function setMany (element) {
        api.manyAttr(element, name);
    }
    function setSingle (element) {
        api.attr(element, name, value);
    }
};

var array_removeAttr = function (name) {
    this.forEach(function (element) {
        element.removeAttribute(name);
    });
}

var array_css = function (name, value) {
    var props;
    var many = name && typeof name === 'object';
    var getter = !many && typeof value === 'undefined';
    if (getter) {
        return this.length ? domCss.getCss(this[0], name) : null;
    }
    if (many) {
        props = name;
    } else {
        props = {};
        props[name] = value;
    }
    this.forEach(domCss.setCss(props));
    return this;
}

var EMPTY_BOUNDS = {x: 0, y: 0, left: 0, right: 0, top: 0, bottom: 0, width: 0, height: 0};
Object.freeze(EMPTY_BOUNDS)

var array_bounds = function () {
    return this.length ? this[0].getBoundingClientRect() : EMPTY_BOUNDS;
}

var array_classes_call = function (api, value) {
    this.forEach(function (element) {
        api(element, value);
    });
    return this;
}

var array_hasClass = function (value) {
    return this.some(function (element) {
        return classes.contains(element, value);
    });
}

var array_append_tag = function(tag, options) {
    options = options || {};

    var child = global.document.createElement(tag);
    var childWrapper = module.exports.select(child);

    if (options.classes) {
        childWrapper.addClass(options.classes);
    }

    if (options.text) {
        childWrapper.text(options.text);
    }

    this[0].appendChild(child);
    return childWrapper;
};

var array_insertAdjacentHTML = function(where, html) {
    this.forEach(function (element) {
        if (utils.isElement(element)) {
            element.insertAdjacentHTML(where, html);
        }
    });
    return this;
};

var array_on = function(type, delegateSelector, callback, capture) {
    var useDelegate = false;

    if (arguments.length == 2) {
        callback = delegateSelector;
    } else if (arguments.length == 3) {
        if (typeof delegateSelector == 'function') {
            capture = callback;
            callback = delegateSelector;
        } else {
            useDelegate = true;
        }
    } else if (arguments.length == 4) {
        useDelegate = true;
    }

    this.forEach(function(element) {
        element.addEventListener(type, function(e) {
            if (useDelegate) {
                var target = e.target;

                while (target && target != element) {
                    if (target.matches(delegateSelector)) {
                        callback(e, target);
                        break;
                    }
                    target = target.parentNode;
                }
            } else {
                callback(e, element)
            }
        }, capture || false);
    });
};
}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"./dom/api":72,"./dom/classes":73,"./dom/css":74,"./utils":78}],72:[function(require,module,exports){
var utils = require('../utils');

exports.html = function (elem, html) {
    var getter = arguments.length < 2;
    if (getter) {
        return elem.innerHTML;
    } else {
        elem.innerHTML = html;
    }
};

/**
 * Using innerText if defined, textContent otherwise
 * Beware of http://perfectionkills.com/the-poor-misunderstood-innerText/
 */
exports.text = function (elem, text) {
    var checkable = utils.isCheckable(elem);
    var getter = arguments.length < 2;
    if (getter) {
        return checkable ? elem.value : elem.innerText || elem.textContent;
    } else if (checkable) {
        elem.value = text;
    } else {
        elem.innerText = elem.textContent = text;
    }
};

exports.value = function (el, value) {
    var getter = arguments.length < 2;
    if (getter) {
        return el.value;
    }  else {
        el.value = value;
    }
};


exports.attr = function (el, name, value) {
    if (!utils.isElement(el)) {
        return;
    }
    if (value === null || value === void 0) {
        el.removeAttribute(name); return;
    }
    var camel = utils.hyphenToCamel(name);
    if (camel in el) {
        el[camel] = value;
    } else {
        var hyphenate = utils.hyphenate(name);
        el.setAttribute(hyphenate, value);
    }
};

exports.getAttr = function (el, name) {
    var camel = utils.hyphenToCamel(name);
    if (camel in el) {
        return el[camel];
    } else if (el.getAttribute) {
        return el.getAttribute(name);
    }
    return null;
};

exports.manyAttr = function (elem, attrs) {
    Object.keys(attrs).forEach(function (attr) {
        exports.attr(elem, attr, attrs[attr]);
    });
};
},{"../utils":78}],73:[function(require,module,exports){
var trim = /^\s+|\s+$/g;
var whitespace = /\s+/;
var utils = require('../utils');

function interpret (input) {
    return typeof input === 'string' ? input.replace(trim, '').split(whitespace) : input;
}

function classes (el) {
    if (utils.isElement(el)) {
        return el.className ? el.className.replace(trim, '').split(whitespace) : [];
    }
    return [];
}

function set (el, input) {
    if (utils.isElement(el)) {
        el.className = interpret(input).join(' ');
    }
}

function add (el, input) {
    var current = remove(el, input);
    var values = interpret(input);
    current.push.apply(current, values);
    set(el, current);
    return current;
}

function remove (el, input) {
    var current = classes(el);
    var values = interpret(input);
    values.forEach(function (value) {
        var i = current.indexOf(value);
        if (i !== -1) {
            current.splice(i, 1);
        }
    });
    set(el, current);
    return current;
}

function contains (el, input) {
    var current = classes(el);
    var values = interpret(input);

    return values.every(function (value) {
        return current.indexOf(value) !== -1;
    });
}

module.exports = {
    add: add,
    remove: remove,
    contains: contains,
    set: set,
    get: classes
};
},{"../utils":78}],74:[function(require,module,exports){
var utils = require('../utils');
var numericCssProperties = {
    'column-count': true,
    'fill-opacity': true,
    'flex-grow': true,
    'flex-shrink': true,
    'font-weight': true,
    'line-height': true,
    'opacity': true,
    'order': true,
    'orphans': true,
    'widows': true,
    'z-index': true,
    'zoom': true
};
var numeric = /^\d+$/;

exports.getCss = function (el, prop) {

    if (!utils.isElement(el)) {
        return null;
    }

    var hprop = utils.hyphenate(prop);
    var result = window.getComputedStyle(el)[hprop];
    if (prop === 'opacity' && result === '') {
        return 1;
    }
    if (result.substr(-2) === 'px' || numeric.test(result)) {
        return parseFloat(result, 10);
    }
    return result;
};

exports.setCss = function (props) {
    var mapped = Object.keys(props).filter(bad).map(expand);

    function bad (prop) {
        var value = props[prop];
        return value !== null && value === value;
    }
    function expand (prop) {
        var hprop = utils.hyphenate(prop);
        var value = props[prop];
        if (typeof value === 'number' && !numericCssProperties[hprop]) {
            value += 'px';
        }
        return {
            name: hprop, value: value
        };
    }
    return function (el) {
        if (!utils.isElement(el)) {
            return;
        }
        mapped.forEach(function (prop) {
            el.style[prop.name] = prop.value;
        });
    };
};
},{"../utils":78}],75:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Observable = /** @class */ (function () {
    function Observable() {
        this.handlers = [];
    }
    Observable.prototype.observe = function (handler) {
        this.handlers.push(handler);
    };
    Observable.prototype.fire = function (message) {
        this.handlers.forEach(function (handler) {
            handler(message);
        });
    };
    return Observable;
}());
exports.Observable = Observable;

},{}],76:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// from https://stackoverflow.com/questions/105034/create-guid-uuid-in-javascript
exports.uuid = function () {
    var d = new Date().getTime();
    if (window.performance && typeof window.performance.now === "function") {
        d += performance.now(); //use high-precision timer if available
    }
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (d + Math.random() * 16) % 16 | 0;
        d = Math.floor(d / 16);
        return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
};
exports.digits = function (length) {
    var result = '';
    for (var i = 0; i < length; i++) {
        result += Math.floor(Math.random() * 10);
    }
    return result;
};

},{}],77:[function(require,module,exports){

require('../polyfill/array/find');

var Promise = require('promise');
var dom = require('./dom');

var loadingQueues = {};

exports.getScriptsBySrc = function (src) {
    return dom('script').filter(function (script) {
        return script.src == src;
    });
};

exports.ensureLoaded = function (src) {
    return new Promise(function (resolve) {
        var scripts = exports.getScriptsBySrc(src);

        if (scripts.length === 0) {
            insertScript(src).then(function () {
                if (loadingQueues[src]) {
                    loadingQueues[src].forEach(function(item) {
                        item();
                    });

                    delete loadingQueues[src];
                }

                resolve();
            });
        } else if (scripts.find(isLoaded)) {
            resolve();
        } else {
            if (!loadingQueues[src]) {
                loadingQueues[src] = [];
            }

            loadingQueues[src].push(resolve);
        }
    });
};

exports.isLoaded = function (src) {
    var script = exports.getScriptsBySrc(src);

    return script && isLoaded(script);
};

exports.getScriptsToLoad = function() {
    return dom('[data-role="load-script"]').map(function (item) {
        return item.getAttribute('data-src');
    });
};

var isLoaded = function (script) {
    return script.getAttribute('data-loaded') != null;
};

var insertScript = function (url) {
    var script = document.createElement('script');

    script.async = true;
    script.src = url;

    var promise = new Promise(function (resolve) {
        if (script.readyState) {  // IE
            script.onreadystatechange = function () {
                if (script.readyState == "loaded" || script.readyState == "complete") {
                    script.onreadystatechange = null;
                    script.setAttribute('data-loaded', 'true');

                    resolve();
                }
            };
        } else {  // others
            script.onload = function () {
                script.setAttribute('data-loaded', 'true');

                resolve();
            };
        }
    });

    var firstScript = document.getElementsByTagName('script')[0];

    firstScript.parentNode.insertBefore(script, firstScript);

    return promise;
};
},{"../polyfill/array/find":67,"./dom":71,"promise":178}],78:[function(require,module,exports){

/**
 * Determines if an element is displayed using offsetWidth and offsetHeight.
 */
exports.isVisible = function(elem){
    var w = elem.offsetWidth;
    var h = elem.offsetHeight;

    return (w == 0 && h == 0) ? false : (w > 0 && h > 0) ? true : elem.style.display != 'none';
};

/**
 * ie8+ compatible
 * See http://toddmotto.com/a-comprehensive-dive-into-nodelists-arrays-converting-nodelists-and-understanding-the-dom/
 */
exports.toArray = function(nodeList) {
    var array = [];
    for (var i = nodeList.length; i--; array.unshift(nodeList[i]));
    return array;
};

var elementObjects = typeof HTMLElement === 'object';

exports.isElement = function (obj) {
    return elementObjects ? obj instanceof HTMLElement : isElementObject(obj);
}

exports.isArray = function (array) {
    return Object.prototype.toString.call(array) === '[object Array]';
}

exports.isCheckable = function (elem) {
    return 'checked' in elem && elem.type === 'radio' || elem.type === 'checkbox';
}

function isElementObject (obj) {
    return obj &&
        typeof obj === 'object' &&
        typeof obj.nodeName === 'string' &&
        obj.nodeType === 1;
}

exports.hyphenToCamel = function (hyphens) {
    var part = /-([a-z])/g;
    return hyphens.replace(part, function (g, m) {
        return m.toUpperCase();
    });
}

exports.hyphenate = function (text) {
    var camel = /([a-z])([A-Z])/g;
    return text.replace(camel, '$1-$2').toLowerCase();
}
},{}],79:[function(require,module,exports){
var hashClear = require('./_hashClear'),
    hashDelete = require('./_hashDelete'),
    hashGet = require('./_hashGet'),
    hashHas = require('./_hashHas'),
    hashSet = require('./_hashSet');

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;

},{"./_hashClear":121,"./_hashDelete":122,"./_hashGet":123,"./_hashHas":124,"./_hashSet":125}],80:[function(require,module,exports){
var listCacheClear = require('./_listCacheClear'),
    listCacheDelete = require('./_listCacheDelete'),
    listCacheGet = require('./_listCacheGet'),
    listCacheHas = require('./_listCacheHas'),
    listCacheSet = require('./_listCacheSet');

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;

},{"./_listCacheClear":132,"./_listCacheDelete":133,"./_listCacheGet":134,"./_listCacheHas":135,"./_listCacheSet":136}],81:[function(require,module,exports){
var getNative = require('./_getNative'),
    root = require('./_root');

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;

},{"./_getNative":117,"./_root":148}],82:[function(require,module,exports){
var mapCacheClear = require('./_mapCacheClear'),
    mapCacheDelete = require('./_mapCacheDelete'),
    mapCacheGet = require('./_mapCacheGet'),
    mapCacheHas = require('./_mapCacheHas'),
    mapCacheSet = require('./_mapCacheSet');

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;

},{"./_mapCacheClear":137,"./_mapCacheDelete":138,"./_mapCacheGet":139,"./_mapCacheHas":140,"./_mapCacheSet":141}],83:[function(require,module,exports){
var ListCache = require('./_ListCache'),
    stackClear = require('./_stackClear'),
    stackDelete = require('./_stackDelete'),
    stackGet = require('./_stackGet'),
    stackHas = require('./_stackHas'),
    stackSet = require('./_stackSet');

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;

},{"./_ListCache":80,"./_stackClear":152,"./_stackDelete":153,"./_stackGet":154,"./_stackHas":155,"./_stackSet":156}],84:[function(require,module,exports){
var root = require('./_root');

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;

},{"./_root":148}],85:[function(require,module,exports){
var root = require('./_root');

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;

},{"./_root":148}],86:[function(require,module,exports){
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;

},{}],87:[function(require,module,exports){
var baseTimes = require('./_baseTimes'),
    isArguments = require('./isArguments'),
    isArray = require('./isArray'),
    isBuffer = require('./isBuffer'),
    isIndex = require('./_isIndex'),
    isTypedArray = require('./isTypedArray');

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;

},{"./_baseTimes":103,"./_isIndex":127,"./isArguments":162,"./isArray":163,"./isBuffer":166,"./isTypedArray":172}],88:[function(require,module,exports){
var baseAssignValue = require('./_baseAssignValue'),
    eq = require('./eq');

/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if ((value !== undefined && !eq(object[key], value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignMergeValue;

},{"./_baseAssignValue":91,"./eq":160}],89:[function(require,module,exports){
var baseAssignValue = require('./_baseAssignValue'),
    eq = require('./eq');

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;

},{"./_baseAssignValue":91,"./eq":160}],90:[function(require,module,exports){
var eq = require('./eq');

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;

},{"./eq":160}],91:[function(require,module,exports){
var defineProperty = require('./_defineProperty');

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;

},{"./_defineProperty":114}],92:[function(require,module,exports){
var isObject = require('./isObject');

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;

},{"./isObject":169}],93:[function(require,module,exports){
var createBaseFor = require('./_createBaseFor');

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;

},{"./_createBaseFor":112}],94:[function(require,module,exports){
var Symbol = require('./_Symbol'),
    getRawTag = require('./_getRawTag'),
    objectToString = require('./_objectToString');

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;

},{"./_Symbol":84,"./_getRawTag":119,"./_objectToString":145}],95:[function(require,module,exports){
var baseGetTag = require('./_baseGetTag'),
    isObjectLike = require('./isObjectLike');

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;

},{"./_baseGetTag":94,"./isObjectLike":170}],96:[function(require,module,exports){
var isFunction = require('./isFunction'),
    isMasked = require('./_isMasked'),
    isObject = require('./isObject'),
    toSource = require('./_toSource');

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;

},{"./_isMasked":130,"./_toSource":157,"./isFunction":167,"./isObject":169}],97:[function(require,module,exports){
var baseGetTag = require('./_baseGetTag'),
    isLength = require('./isLength'),
    isObjectLike = require('./isObjectLike');

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;

},{"./_baseGetTag":94,"./isLength":168,"./isObjectLike":170}],98:[function(require,module,exports){
var isObject = require('./isObject'),
    isPrototype = require('./_isPrototype'),
    nativeKeysIn = require('./_nativeKeysIn');

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeysIn;

},{"./_isPrototype":131,"./_nativeKeysIn":143,"./isObject":169}],99:[function(require,module,exports){
var Stack = require('./_Stack'),
    assignMergeValue = require('./_assignMergeValue'),
    baseFor = require('./_baseFor'),
    baseMergeDeep = require('./_baseMergeDeep'),
    isObject = require('./isObject'),
    keysIn = require('./keysIn'),
    safeGet = require('./_safeGet');

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  baseFor(source, function(srcValue, key) {
    if (isObject(srcValue)) {
      stack || (stack = new Stack);
      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      assignMergeValue(object, key, newValue);
    }
  }, keysIn);
}

module.exports = baseMerge;

},{"./_Stack":83,"./_assignMergeValue":88,"./_baseFor":93,"./_baseMergeDeep":100,"./_safeGet":149,"./isObject":169,"./keysIn":173}],100:[function(require,module,exports){
var assignMergeValue = require('./_assignMergeValue'),
    cloneBuffer = require('./_cloneBuffer'),
    cloneTypedArray = require('./_cloneTypedArray'),
    copyArray = require('./_copyArray'),
    initCloneObject = require('./_initCloneObject'),
    isArguments = require('./isArguments'),
    isArray = require('./isArray'),
    isArrayLikeObject = require('./isArrayLikeObject'),
    isBuffer = require('./isBuffer'),
    isFunction = require('./isFunction'),
    isObject = require('./isObject'),
    isPlainObject = require('./isPlainObject'),
    isTypedArray = require('./isTypedArray'),
    safeGet = require('./_safeGet'),
    toPlainObject = require('./toPlainObject');

/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = safeGet(object, key),
      srcValue = safeGet(source, key),
      stacked = stack.get(srcValue);

  if (stacked) {
    assignMergeValue(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = isArray(srcValue),
        isBuff = !isArr && isBuffer(srcValue),
        isTyped = !isArr && !isBuff && isTypedArray(srcValue);

    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (isArray(objValue)) {
        newValue = objValue;
      }
      else if (isArrayLikeObject(objValue)) {
        newValue = copyArray(objValue);
      }
      else if (isBuff) {
        isCommon = false;
        newValue = cloneBuffer(srcValue, true);
      }
      else if (isTyped) {
        isCommon = false;
        newValue = cloneTypedArray(srcValue, true);
      }
      else {
        newValue = [];
      }
    }
    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
      newValue = objValue;
      if (isArguments(objValue)) {
        newValue = toPlainObject(objValue);
      }
      else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
        newValue = initCloneObject(srcValue);
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  assignMergeValue(object, key, newValue);
}

module.exports = baseMergeDeep;

},{"./_assignMergeValue":88,"./_cloneBuffer":106,"./_cloneTypedArray":107,"./_copyArray":108,"./_initCloneObject":126,"./_safeGet":149,"./isArguments":162,"./isArray":163,"./isArrayLikeObject":165,"./isBuffer":166,"./isFunction":167,"./isObject":169,"./isPlainObject":171,"./isTypedArray":172,"./toPlainObject":176}],101:[function(require,module,exports){
var identity = require('./identity'),
    overRest = require('./_overRest'),
    setToString = require('./_setToString');

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;

},{"./_overRest":147,"./_setToString":150,"./identity":161}],102:[function(require,module,exports){
var constant = require('./constant'),
    defineProperty = require('./_defineProperty'),
    identity = require('./identity');

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;

},{"./_defineProperty":114,"./constant":158,"./identity":161}],103:[function(require,module,exports){
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;

},{}],104:[function(require,module,exports){
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;

},{}],105:[function(require,module,exports){
var Uint8Array = require('./_Uint8Array');

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;

},{"./_Uint8Array":85}],106:[function(require,module,exports){
var root = require('./_root');

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;

},{"./_root":148}],107:[function(require,module,exports){
var cloneArrayBuffer = require('./_cloneArrayBuffer');

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

module.exports = cloneTypedArray;

},{"./_cloneArrayBuffer":105}],108:[function(require,module,exports){
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;

},{}],109:[function(require,module,exports){
var assignValue = require('./_assignValue'),
    baseAssignValue = require('./_baseAssignValue');

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;

},{"./_assignValue":89,"./_baseAssignValue":91}],110:[function(require,module,exports){
var root = require('./_root');

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;

},{"./_root":148}],111:[function(require,module,exports){
var baseRest = require('./_baseRest'),
    isIterateeCall = require('./_isIterateeCall');

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

module.exports = createAssigner;

},{"./_baseRest":101,"./_isIterateeCall":128}],112:[function(require,module,exports){
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;

},{}],113:[function(require,module,exports){
var baseMerge = require('./_baseMerge'),
    isObject = require('./isObject');

/**
 * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
 * objects into destination objects that are passed thru.
 *
 * @private
 * @param {*} objValue The destination value.
 * @param {*} srcValue The source value.
 * @param {string} key The key of the property to merge.
 * @param {Object} object The parent object of `objValue`.
 * @param {Object} source The parent object of `srcValue`.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 * @returns {*} Returns the value to assign.
 */
function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
  if (isObject(objValue) && isObject(srcValue)) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, objValue);
    baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
    stack['delete'](srcValue);
  }
  return objValue;
}

module.exports = customDefaultsMerge;

},{"./_baseMerge":99,"./isObject":169}],114:[function(require,module,exports){
var getNative = require('./_getNative');

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;

},{"./_getNative":117}],115:[function(require,module,exports){
(function (global){
/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],116:[function(require,module,exports){
var isKeyable = require('./_isKeyable');

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;

},{"./_isKeyable":129}],117:[function(require,module,exports){
var baseIsNative = require('./_baseIsNative'),
    getValue = require('./_getValue');

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;

},{"./_baseIsNative":96,"./_getValue":120}],118:[function(require,module,exports){
var overArg = require('./_overArg');

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;

},{"./_overArg":146}],119:[function(require,module,exports){
var Symbol = require('./_Symbol');

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;

},{"./_Symbol":84}],120:[function(require,module,exports){
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;

},{}],121:[function(require,module,exports){
var nativeCreate = require('./_nativeCreate');

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;

},{"./_nativeCreate":142}],122:[function(require,module,exports){
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;

},{}],123:[function(require,module,exports){
var nativeCreate = require('./_nativeCreate');

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;

},{"./_nativeCreate":142}],124:[function(require,module,exports){
var nativeCreate = require('./_nativeCreate');

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;

},{"./_nativeCreate":142}],125:[function(require,module,exports){
var nativeCreate = require('./_nativeCreate');

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;

},{"./_nativeCreate":142}],126:[function(require,module,exports){
var baseCreate = require('./_baseCreate'),
    getPrototype = require('./_getPrototype'),
    isPrototype = require('./_isPrototype');

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

module.exports = initCloneObject;

},{"./_baseCreate":92,"./_getPrototype":118,"./_isPrototype":131}],127:[function(require,module,exports){
/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;

},{}],128:[function(require,module,exports){
var eq = require('./eq'),
    isArrayLike = require('./isArrayLike'),
    isIndex = require('./_isIndex'),
    isObject = require('./isObject');

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;

},{"./_isIndex":127,"./eq":160,"./isArrayLike":164,"./isObject":169}],129:[function(require,module,exports){
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;

},{}],130:[function(require,module,exports){
var coreJsData = require('./_coreJsData');

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;

},{"./_coreJsData":110}],131:[function(require,module,exports){
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;

},{}],132:[function(require,module,exports){
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;

},{}],133:[function(require,module,exports){
var assocIndexOf = require('./_assocIndexOf');

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;

},{"./_assocIndexOf":90}],134:[function(require,module,exports){
var assocIndexOf = require('./_assocIndexOf');

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;

},{"./_assocIndexOf":90}],135:[function(require,module,exports){
var assocIndexOf = require('./_assocIndexOf');

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;

},{"./_assocIndexOf":90}],136:[function(require,module,exports){
var assocIndexOf = require('./_assocIndexOf');

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;

},{"./_assocIndexOf":90}],137:[function(require,module,exports){
var Hash = require('./_Hash'),
    ListCache = require('./_ListCache'),
    Map = require('./_Map');

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;

},{"./_Hash":79,"./_ListCache":80,"./_Map":81}],138:[function(require,module,exports){
var getMapData = require('./_getMapData');

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;

},{"./_getMapData":116}],139:[function(require,module,exports){
var getMapData = require('./_getMapData');

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;

},{"./_getMapData":116}],140:[function(require,module,exports){
var getMapData = require('./_getMapData');

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;

},{"./_getMapData":116}],141:[function(require,module,exports){
var getMapData = require('./_getMapData');

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;

},{"./_getMapData":116}],142:[function(require,module,exports){
var getNative = require('./_getNative');

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;

},{"./_getNative":117}],143:[function(require,module,exports){
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;

},{}],144:[function(require,module,exports){
var freeGlobal = require('./_freeGlobal');

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

},{"./_freeGlobal":115}],145:[function(require,module,exports){
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;

},{}],146:[function(require,module,exports){
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;

},{}],147:[function(require,module,exports){
var apply = require('./_apply');

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;

},{"./_apply":86}],148:[function(require,module,exports){
var freeGlobal = require('./_freeGlobal');

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;

},{"./_freeGlobal":115}],149:[function(require,module,exports){
/**
 * Gets the value at `key`, unless `key` is "__proto__".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function safeGet(object, key) {
  return key == '__proto__'
    ? undefined
    : object[key];
}

module.exports = safeGet;

},{}],150:[function(require,module,exports){
var baseSetToString = require('./_baseSetToString'),
    shortOut = require('./_shortOut');

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;

},{"./_baseSetToString":102,"./_shortOut":151}],151:[function(require,module,exports){
/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;

},{}],152:[function(require,module,exports){
var ListCache = require('./_ListCache');

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;

},{"./_ListCache":80}],153:[function(require,module,exports){
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;

},{}],154:[function(require,module,exports){
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;

},{}],155:[function(require,module,exports){
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;

},{}],156:[function(require,module,exports){
var ListCache = require('./_ListCache'),
    Map = require('./_Map'),
    MapCache = require('./_MapCache');

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;

},{"./_ListCache":80,"./_Map":81,"./_MapCache":82}],157:[function(require,module,exports){
/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;

},{}],158:[function(require,module,exports){
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;

},{}],159:[function(require,module,exports){
var apply = require('./_apply'),
    baseRest = require('./_baseRest'),
    customDefaultsMerge = require('./_customDefaultsMerge'),
    mergeWith = require('./mergeWith');

/**
 * This method is like `_.defaults` except that it recursively assigns
 * default properties.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.defaults
 * @example
 *
 * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
 * // => { 'a': { 'b': 2, 'c': 3 } }
 */
var defaultsDeep = baseRest(function(args) {
  args.push(undefined, customDefaultsMerge);
  return apply(mergeWith, undefined, args);
});

module.exports = defaultsDeep;

},{"./_apply":86,"./_baseRest":101,"./_customDefaultsMerge":113,"./mergeWith":174}],160:[function(require,module,exports){
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;

},{}],161:[function(require,module,exports){
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;

},{}],162:[function(require,module,exports){
var baseIsArguments = require('./_baseIsArguments'),
    isObjectLike = require('./isObjectLike');

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;

},{"./_baseIsArguments":95,"./isObjectLike":170}],163:[function(require,module,exports){
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;

},{}],164:[function(require,module,exports){
var isFunction = require('./isFunction'),
    isLength = require('./isLength');

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;

},{"./isFunction":167,"./isLength":168}],165:[function(require,module,exports){
var isArrayLike = require('./isArrayLike'),
    isObjectLike = require('./isObjectLike');

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

module.exports = isArrayLikeObject;

},{"./isArrayLike":164,"./isObjectLike":170}],166:[function(require,module,exports){
var root = require('./_root'),
    stubFalse = require('./stubFalse');

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

},{"./_root":148,"./stubFalse":175}],167:[function(require,module,exports){
var baseGetTag = require('./_baseGetTag'),
    isObject = require('./isObject');

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;

},{"./_baseGetTag":94,"./isObject":169}],168:[function(require,module,exports){
/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;

},{}],169:[function(require,module,exports){
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;

},{}],170:[function(require,module,exports){
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;

},{}],171:[function(require,module,exports){
var baseGetTag = require('./_baseGetTag'),
    getPrototype = require('./_getPrototype'),
    isObjectLike = require('./isObjectLike');

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;

},{"./_baseGetTag":94,"./_getPrototype":118,"./isObjectLike":170}],172:[function(require,module,exports){
var baseIsTypedArray = require('./_baseIsTypedArray'),
    baseUnary = require('./_baseUnary'),
    nodeUtil = require('./_nodeUtil');

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;

},{"./_baseIsTypedArray":97,"./_baseUnary":104,"./_nodeUtil":144}],173:[function(require,module,exports){
var arrayLikeKeys = require('./_arrayLikeKeys'),
    baseKeysIn = require('./_baseKeysIn'),
    isArrayLike = require('./isArrayLike');

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;

},{"./_arrayLikeKeys":87,"./_baseKeysIn":98,"./isArrayLike":164}],174:[function(require,module,exports){
var baseMerge = require('./_baseMerge'),
    createAssigner = require('./_createAssigner');

/**
 * This method is like `_.merge` except that it accepts `customizer` which
 * is invoked to produce the merged values of the destination and source
 * properties. If `customizer` returns `undefined`, merging is handled by the
 * method instead. The `customizer` is invoked with six arguments:
 * (objValue, srcValue, key, object, source, stack).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} sources The source objects.
 * @param {Function} customizer The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @example
 *
 * function customizer(objValue, srcValue) {
 *   if (_.isArray(objValue)) {
 *     return objValue.concat(srcValue);
 *   }
 * }
 *
 * var object = { 'a': [1], 'b': [2] };
 * var other = { 'a': [3], 'b': [4] };
 *
 * _.mergeWith(object, other, customizer);
 * // => { 'a': [1, 3], 'b': [2, 4] }
 */
var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
  baseMerge(object, source, srcIndex, customizer);
});

module.exports = mergeWith;

},{"./_baseMerge":99,"./_createAssigner":111}],175:[function(require,module,exports){
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;

},{}],176:[function(require,module,exports){
var copyObject = require('./_copyObject'),
    keysIn = require('./keysIn');

/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return copyObject(value, keysIn(value));
}

module.exports = toPlainObject;

},{"./_copyObject":109,"./keysIn":173}],177:[function(require,module,exports){
// Pannellum 2.5.2, https://github.com/mpetroff/pannellum
window.libpannellum=function(F,f,p){function ja(Z){function R(a,d){return 1==a.level&&1!=d.level?-1:1==d.level&&1!=a.level?1:d.timestamp-a.timestamp}function na(a,d){return a.level!=d.level?a.level-d.level:a.diff-d.diff}function M(a,d,c,f,k,g){this.vertices=a;this.side=d;this.level=c;this.x=f;this.y=k;this.path=g.replace("%s",d).replace("%l",c).replace("%x",f).replace("%y",k)}function La(a,d,f,p,k){var g;var e=d.vertices;g=oa(a,e.slice(0,3));var s=oa(a,e.slice(3,6)),z=oa(a,e.slice(6,9)),e=oa(a,e.slice(9,
12)),n=g[0]+s[0]+z[0]+e[0];-4==n||4==n?g=!1:(n=g[1]+s[1]+z[1]+e[1],g=-4==n||4==n?!1:4!=g[2]+s[2]+z[2]+e[2]);if(g){g=d.vertices;s=g[0]+g[3]+g[6]+g[9];z=g[1]+g[4]+g[7]+g[10];e=g[2]+g[5]+g[8]+g[11];n=Math.sqrt(s*s+z*z+e*e);e=Math.asin(e/n);s=Math.atan2(z,s)-p;s+=s>Math.PI?-2*Math.PI:s<-Math.PI?2*Math.PI:0;s=Math.abs(s);d.diff=Math.acos(Math.sin(f)*Math.sin(e)+Math.cos(f)*Math.cos(e)*Math.cos(s));s=!1;for(z=0;z<c.nodeCache.length;z++)if(c.nodeCache[z].path==d.path){s=!0;c.nodeCache[z].timestamp=c.nodeCacheTimestamp++;
c.nodeCache[z].diff=d.diff;c.currentNodes.push(c.nodeCache[z]);break}s||(d.timestamp=c.nodeCacheTimestamp++,c.currentNodes.push(d),c.nodeCache.push(d));if(d.level<c.level){var e=m.cubeResolution*Math.pow(2,d.level-m.maxLevel),s=Math.ceil(e*m.invTileResolution)-1,z=e%m.tileResolution*2,l=2*e%m.tileResolution;0===l&&(l=m.tileResolution);0===z&&(z=2*m.tileResolution);n=0.5;if(d.x==s||d.y==s)n=1-m.tileResolution/(m.tileResolution+l);var x=1-n,e=[],t=n,y=n,C=n,H=x,I=x,A=x;if(l<m.tileResolution)if(d.x==
s&&d.y!=s){if(I=y=0.5,"d"==d.side||"u"==d.side)A=C=0.5}else d.x!=s&&d.y==s&&(H=t=0.5,"l"==d.side||"r"==d.side)&&(A=C=0.5);z<=m.tileResolution&&(d.x==s&&(t=0,H=1,"l"==d.side||"r"==d.side)&&(C=0,A=1),d.y==s&&(y=0,I=1,"d"==d.side||"u"==d.side)&&(C=0,A=1));l=[g[0],g[1],g[2],g[0]*t+g[3]*H,g[1]*n+g[4]*x,g[2]*C+g[5]*A,g[0]*t+g[6]*H,g[1]*y+g[7]*I,g[2]*C+g[8]*A,g[0]*n+g[9]*x,g[1]*y+g[10]*I,g[2]*C+g[11]*A];l=new M(l,d.side,d.level+1,2*d.x,2*d.y,m.fullpath);e.push(l);d.x==s&&z<=m.tileResolution||(l=[g[0]*t+
g[3]*H,g[1]*n+g[4]*x,g[2]*C+g[5]*A,g[3],g[4],g[5],g[3]*n+g[6]*x,g[4]*y+g[7]*I,g[5]*C+g[8]*A,g[0]*t+g[6]*H,g[1]*y+g[7]*I,g[2]*C+g[8]*A],l=new M(l,d.side,d.level+1,2*d.x+1,2*d.y,m.fullpath),e.push(l));d.x==s&&z<=m.tileResolution||d.y==s&&z<=m.tileResolution||(l=[g[0]*t+g[6]*H,g[1]*y+g[7]*I,g[2]*C+g[8]*A,g[3]*n+g[6]*x,g[4]*y+g[7]*I,g[5]*C+g[8]*A,g[6],g[7],g[8],g[9]*t+g[6]*H,g[10]*n+g[7]*x,g[11]*C+g[8]*A],l=new M(l,d.side,d.level+1,2*d.x+1,2*d.y+1,m.fullpath),e.push(l));d.y==s&&z<=m.tileResolution||(l=
[g[0]*n+g[9]*x,g[1]*y+g[10]*I,g[2]*C+g[11]*A,g[0]*t+g[6]*H,g[1]*y+g[7]*I,g[2]*C+g[8]*A,g[9]*t+g[6]*H,g[10]*n+g[7]*x,g[11]*C+g[8]*A,g[9],g[10],g[11]],l=new M(l,d.side,d.level+1,2*d.x,2*d.y+1,m.fullpath),e.push(l));for(d=0;d<e.length;d++)La(a,e[d],f,p,k)}}}function Ma(){return[-1,1,-1,1,1,-1,1,-1,-1,-1,-1,-1,1,1,1,-1,1,1,-1,-1,1,1,-1,1,-1,1,1,1,1,1,1,1,-1,-1,1,-1,-1,-1,-1,1,-1,-1,1,-1,1,-1,-1,1,-1,1,1,-1,1,-1,-1,-1,-1,-1,-1,1,1,1,-1,1,1,1,1,-1,1,1,-1,-1]}function pa(a,d,c){var f=Math.sin(d);d=Math.cos(d);
if("x"==c)return[a[0],d*a[1]+f*a[2],d*a[2]-f*a[1],a[3],d*a[4]+f*a[5],d*a[5]-f*a[4],a[6],d*a[7]+f*a[8],d*a[8]-f*a[7]];if("y"==c)return[d*a[0]-f*a[2],a[1],d*a[2]+f*a[0],d*a[3]-f*a[5],a[4],d*a[5]+f*a[3],d*a[6]-f*a[8],a[7],d*a[8]+f*a[6]];if("z"==c)return[d*a[0]+f*a[1],d*a[1]-f*a[0],a[2],d*a[3]+f*a[4],d*a[4]-f*a[3],a[5],d*a[6]+f*a[7],d*a[7]-f*a[6],a[8]]}function Ga(a){return[a[0],a[4],a[8],a[12],a[1],a[5],a[9],a[13],a[2],a[6],a[10],a[14],a[3],a[7],a[11],a[15]]}function wa(a){ja(a,a.path+"."+m.extension,
function(d,c){a.texture=d;a.textureLoaded=c?2:1},qa.crossOrigin)}function oa(a,d){var c=[a[0]*d[0]+a[1]*d[1]+a[2]*d[2],a[4]*d[0]+a[5]*d[1]+a[6]*d[2],a[11]+a[8]*d[0]+a[9]*d[1]+a[10]*d[2],1/(a[12]*d[0]+a[13]*d[1]+a[14]*d[2])],f=c[0]*c[3],k=c[1]*c[3],c=c[2]*c[3],g=[0,0,0];-1>f&&(g[0]=-1);1<f&&(g[0]=1);-1>k&&(g[1]=-1);1<k&&(g[1]=1);if(-1>c||1<c)g[2]=1;return g}function Ha(){console.log("Reducing canvas size due to error 1286!");E.width=Math.round(E.width/2);E.height=Math.round(E.height/2)}var E=f.createElement("canvas");
E.style.width=E.style.height="100%";Z.appendChild(E);var c,a,U,V,$,S,xa,ea,m,y,ka,D,fa,ya,aa,qa;this.init=function(G,d,Ra,L,k,g,e,s){function z(a){if(F){var d=a*a*4,g=new Uint8ClampedArray(d),c=s.backgroundColor?s.backgroundColor:[0,0,0];c[0]*=255;c[1]*=255;c[2]*=255;for(var b=0;b<d;b++)g[b++]=c[0],g[b++]=c[1],g[b++]=c[2];a=new ImageData(g,a,a);for(n=0;6>n;n++)0==m[n].width&&(m[n]=a)}}d===p&&(d="equirectangular");if("equirectangular"!=d&&"cubemap"!=d&&"multires"!=d)throw console.log("Error: invalid image type specified!"),
{type:"config error"};y=d;m=G;ka=Ra;qa=s||{};if(c){U&&(a.detachShader(c,U),a.deleteShader(U));V&&(a.detachShader(c,V),a.deleteShader(V));a.bindBuffer(a.ARRAY_BUFFER,null);a.bindBuffer(a.ELEMENT_ARRAY_BUFFER,null);c.texture&&a.deleteTexture(c.texture);if(c.nodeCache)for(G=0;G<c.nodeCache.length;G++)a.deleteTexture(c.nodeCache[G].texture);a.deleteProgram(c);c=p}ea=p;var n,F=!1,x;if("cubemap"==y)for(n=0;6>n;n++)0<m[n].width?(x===p&&(x=m[n].width),x!=m[n].width&&console.log("Cube faces have inconsistent widths: "+
x+" vs. "+m[n].width)):F=!0;"cubemap"==y&&0!==(x&x-1)&&(navigator.userAgent.toLowerCase().match(/(iphone|ipod|ipad).* os 8_/)||navigator.userAgent.toLowerCase().match(/(iphone|ipod|ipad).* os 9_/)||navigator.userAgent.toLowerCase().match(/(iphone|ipod|ipad).* os 10_/)||navigator.userAgent.match(/Trident.*rv[ :]*11\./))||(a||(a=E.getContext("experimental-webgl",{alpha:!1,depth:!1})),a&&1286==a.getError()&&Ha());if(!a&&("multires"==y&&m.hasOwnProperty("fallbackPath")||"cubemap"==y)&&("WebkitAppearance"in
f.documentElement.style||navigator.userAgent.match(/Trident.*rv[ :]*11\./)||-1!==navigator.appVersion.indexOf("MSIE 10"))){S&&Z.removeChild(S);S=f.createElement("div");S.className="pnlm-world";L=m.basePath?m.basePath+m.fallbackPath:m.fallbackPath;var M="frblud".split(""),R=0;k=function(){var a=f.createElement("canvas");a.className="pnlm-face pnlm-"+M[this.side]+"face";S.appendChild(a);var d=a.getContext("2d");a.style.width=this.width+4+"px";a.style.height=this.height+4+"px";a.width=this.width+4;a.height=
this.height+4;d.drawImage(this,2,2);var g=d.getImageData(0,0,a.width,a.height),c=g.data,b,e;for(b=2;b<a.width-2;b++)for(e=0;4>e;e++)c[4*(b+a.width)+e]=c[4*(b+2*a.width)+e],c[4*(b+a.width*(a.height-2))+e]=c[4*(b+a.width*(a.height-3))+e];for(b=2;b<a.height-2;b++)for(e=0;4>e;e++)c[4*(b*a.width+1)+e]=c[4*(b*a.width+2)+e],c[4*((b+1)*a.width-2)+e]=c[4*((b+1)*a.width-3)+e];for(e=0;4>e;e++)c[4*(a.width+1)+e]=c[4*(2*a.width+2)+e],c[4*(2*a.width-2)+e]=c[4*(3*a.width-3)+e],c[4*(a.width*(a.height-2)+1)+e]=c[4*
(a.width*(a.height-3)+2)+e],c[4*(a.width*(a.height-1)-2)+e]=c[4*(a.width*(a.height-2)-3)+e];for(b=1;b<a.width-1;b++)for(e=0;4>e;e++)c[4*b+e]=c[4*(b+a.width)+e],c[4*(b+a.width*(a.height-1))+e]=c[4*(b+a.width*(a.height-2))+e];for(b=1;b<a.height-1;b++)for(e=0;4>e;e++)c[b*a.width*4+e]=c[4*(b*a.width+1)+e],c[4*((b+1)*a.width-1)+e]=c[4*((b+1)*a.width-2)+e];for(e=0;4>e;e++)c[e]=c[4*(a.width+1)+e],c[4*(a.width-1)+e]=c[4*(2*a.width-2)+e],c[a.width*(a.height-1)*4+e]=c[4*(a.width*(a.height-2)+1)+e],c[4*(a.width*
a.height-1)+e]=c[4*(a.width*(a.height-1)-2)+e];d.putImageData(g,0,0);C.call(this)};var C=function(){0<this.width?($===p&&($=this.width),$!=this.width&&console.log("Fallback faces have inconsistent widths: "+$+" vs. "+this.width)):F=!0;R++;6==R&&($=this.width,Z.appendChild(S),e())},F=!1;for(n=0;6>n;n++)g=new Image,g.crossOrigin=qa.crossOrigin?qa.crossOrigin:"anonymous",g.side=n,g.onload=k,g.onerror=C,g.src="multires"==y?L.replace("%s",M[n])+"."+m.extension:m[n].src;z($)}else{if(!a)throw console.log("Error: no WebGL support detected!"),
{type:"no webgl"};"cubemap"==y&&z(x);m.fullpath=m.basePath?m.basePath+m.path:m.path;m.invTileResolution=1/m.tileResolution;G=Ma();xa=[];for(n=0;6>n;n++)xa[n]=G.slice(12*n,12*n+12),G=Ma();G=0;if("equirectangular"==y){if(G=a.getParameter(a.MAX_TEXTURE_SIZE),Math.max(m.width/2,m.height)>G)throw console.log("Error: The image is too big; it's "+m.width+"px wide, but this device's maximum supported size is "+2*G+"px."),{type:"webgl size error",width:m.width,maxWidth:2*G};}else if("cubemap"==y&&x>a.getParameter(a.MAX_CUBE_MAP_TEXTURE_SIZE))throw console.log("Error: The image is too big; it's "+
x+"px wide, but this device's maximum supported size is "+G+"px."),{type:"webgl size error",width:x,maxWidth:G};s===p||s.horizonPitch===p&&s.horizonRoll===p||(ea=[s.horizonPitch==p?0:s.horizonPitch,s.horizonRoll==p?0:s.horizonRoll]);x=a.TEXTURE_2D;a.viewport(0,0,a.drawingBufferWidth,a.drawingBufferHeight);a.getShaderPrecisionFormat&&(d=a.getShaderPrecisionFormat(a.FRAGMENT_SHADER,a.HIGH_FLOAT))&&1>d.precision&&(ra=ra.replace("highp","mediump"));U=a.createShader(a.VERTEX_SHADER);d=t;"multires"==y&&
(d=l);a.shaderSource(U,d);a.compileShader(U);V=a.createShader(a.FRAGMENT_SHADER);d=sa;"cubemap"==y?(x=a.TEXTURE_CUBE_MAP,d=bb):"multires"==y&&(d=ta);a.shaderSource(V,d);a.compileShader(V);c=a.createProgram();a.attachShader(c,U);a.attachShader(c,V);a.linkProgram(c);a.getShaderParameter(U,a.COMPILE_STATUS)||console.log(a.getShaderInfoLog(U));a.getShaderParameter(V,a.COMPILE_STATUS)||console.log(a.getShaderInfoLog(V));a.getProgramParameter(c,a.LINK_STATUS)||console.log(a.getProgramInfoLog(c));a.useProgram(c);
c.drawInProgress=!1;d=s.backgroundColor?s.backgroundColor:[0,0,0];a.clearColor(d[0],d[1],d[2],1);a.clear(a.COLOR_BUFFER_BIT);c.texCoordLocation=a.getAttribLocation(c,"a_texCoord");a.enableVertexAttribArray(c.texCoordLocation);"multires"!=y?(D||(D=a.createBuffer()),a.bindBuffer(a.ARRAY_BUFFER,D),a.bufferData(a.ARRAY_BUFFER,new Float32Array([-1,1,1,1,1,-1,-1,1,1,-1,-1,-1]),a.STATIC_DRAW),a.vertexAttribPointer(c.texCoordLocation,2,a.FLOAT,!1,0,0),c.aspectRatio=a.getUniformLocation(c,"u_aspectRatio"),
a.uniform1f(c.aspectRatio,a.drawingBufferWidth/a.drawingBufferHeight),c.psi=a.getUniformLocation(c,"u_psi"),c.theta=a.getUniformLocation(c,"u_theta"),c.f=a.getUniformLocation(c,"u_f"),c.h=a.getUniformLocation(c,"u_h"),c.v=a.getUniformLocation(c,"u_v"),c.vo=a.getUniformLocation(c,"u_vo"),c.rot=a.getUniformLocation(c,"u_rot"),a.uniform1f(c.h,L/(2*Math.PI)),a.uniform1f(c.v,k/Math.PI),a.uniform1f(c.vo,g/Math.PI*2),"equirectangular"==y&&(c.backgroundColor=a.getUniformLocation(c,"u_backgroundColor"),a.uniform4fv(c.backgroundColor,
d.concat([1]))),c.texture=a.createTexture(),a.bindTexture(x,c.texture),"cubemap"==y?(a.texImage2D(a.TEXTURE_CUBE_MAP_POSITIVE_X,0,a.RGB,a.RGB,a.UNSIGNED_BYTE,m[1]),a.texImage2D(a.TEXTURE_CUBE_MAP_NEGATIVE_X,0,a.RGB,a.RGB,a.UNSIGNED_BYTE,m[3]),a.texImage2D(a.TEXTURE_CUBE_MAP_POSITIVE_Y,0,a.RGB,a.RGB,a.UNSIGNED_BYTE,m[4]),a.texImage2D(a.TEXTURE_CUBE_MAP_NEGATIVE_Y,0,a.RGB,a.RGB,a.UNSIGNED_BYTE,m[5]),a.texImage2D(a.TEXTURE_CUBE_MAP_POSITIVE_Z,0,a.RGB,a.RGB,a.UNSIGNED_BYTE,m[0]),a.texImage2D(a.TEXTURE_CUBE_MAP_NEGATIVE_Z,
0,a.RGB,a.RGB,a.UNSIGNED_BYTE,m[2])):m.width<=G?(a.uniform1i(a.getUniformLocation(c,"u_splitImage"),0),a.texImage2D(x,0,a.RGB,a.RGB,a.UNSIGNED_BYTE,m)):(a.uniform1i(a.getUniformLocation(c,"u_splitImage"),1),L=f.createElement("canvas"),L.width=m.width,L.height=m.height,L=L.getContext("2d"),L.drawImage(m,0,0),k=L.getImageData(0,0,m.width/2,m.height),a.texImage2D(x,0,a.RGB,a.RGB,a.UNSIGNED_BYTE,k),c.texture2=a.createTexture(),a.activeTexture(a.TEXTURE1),a.bindTexture(x,c.texture2),a.uniform1i(a.getUniformLocation(c,
"u_image1"),1),k=L.getImageData(m.width/2,0,m.width/2,m.height),a.texImage2D(x,0,a.RGB,a.RGB,a.UNSIGNED_BYTE,k),a.texParameteri(x,a.TEXTURE_WRAP_S,a.CLAMP_TO_EDGE),a.texParameteri(x,a.TEXTURE_WRAP_T,a.CLAMP_TO_EDGE),a.texParameteri(x,a.TEXTURE_MIN_FILTER,a.LINEAR),a.texParameteri(x,a.TEXTURE_MAG_FILTER,a.LINEAR),a.activeTexture(a.TEXTURE0)),a.texParameteri(x,a.TEXTURE_WRAP_S,a.CLAMP_TO_EDGE),a.texParameteri(x,a.TEXTURE_WRAP_T,a.CLAMP_TO_EDGE),a.texParameteri(x,a.TEXTURE_MIN_FILTER,a.LINEAR),a.texParameteri(x,
a.TEXTURE_MAG_FILTER,a.LINEAR)):(c.vertPosLocation=a.getAttribLocation(c,"a_vertCoord"),a.enableVertexAttribArray(c.vertPosLocation),fa||(fa=a.createBuffer()),ya||(ya=a.createBuffer()),aa||(aa=a.createBuffer()),a.bindBuffer(a.ARRAY_BUFFER,ya),a.bufferData(a.ARRAY_BUFFER,new Float32Array([0,0,1,0,1,1,0,1]),a.STATIC_DRAW),a.bindBuffer(a.ELEMENT_ARRAY_BUFFER,aa),a.bufferData(a.ELEMENT_ARRAY_BUFFER,new Uint16Array([0,1,2,0,2,3]),a.STATIC_DRAW),c.perspUniform=a.getUniformLocation(c,"u_perspMatrix"),c.cubeUniform=
a.getUniformLocation(c,"u_cubeMatrix"),c.level=-1,c.currentNodes=[],c.nodeCache=[],c.nodeCacheTimestamp=0);L=a.getError();if(0!==L)throw console.log("Error: Something went wrong with WebGL!",L),{type:"webgl error"};e()}};this.destroy=function(){Z!==p&&(E!==p&&Z.contains(E)&&Z.removeChild(E),S!==p&&Z.contains(S)&&Z.removeChild(S));if(a){var c=a.getExtension("WEBGL_lose_context");c&&c.loseContext()}};this.resize=function(){var f=F.devicePixelRatio||1;E.width=E.clientWidth*f;E.height=E.clientHeight*
f;a&&(1286==a.getError()&&Ha(),a.viewport(0,0,a.drawingBufferWidth,a.drawingBufferHeight),"multires"!=y&&a.uniform1f(c.aspectRatio,E.clientWidth/E.clientHeight))};this.resize();this.setPose=function(a,c){ea=[a,c]};this.render=function(f,d,l,t){var k,g=0;t===p&&(t={});t.roll&&(g=t.roll);if(ea!==p){k=ea[0];var e=ea[1],s=f,z=d,n=Math.cos(e)*Math.sin(f)*Math.sin(k)+Math.cos(f)*(Math.cos(k)*Math.cos(d)+Math.sin(e)*Math.sin(k)*Math.sin(d)),D=-Math.sin(f)*Math.sin(e)+Math.cos(f)*Math.cos(e)*Math.sin(d);
f=Math.cos(e)*Math.cos(k)*Math.sin(f)+Math.cos(f)*(-Math.cos(d)*Math.sin(k)+Math.cos(k)*Math.sin(e)*Math.sin(d));f=Math.asin(Math.max(Math.min(f,1),-1));d=Math.atan2(D,n);k=[Math.cos(s)*(Math.sin(e)*Math.sin(k)*Math.cos(z)-Math.cos(k)*Math.sin(z)),Math.cos(s)*Math.cos(e)*Math.cos(z),Math.cos(s)*(Math.cos(k)*Math.sin(e)*Math.cos(z)+Math.sin(z)*Math.sin(k))];e=[-Math.cos(f)*Math.sin(d),Math.cos(f)*Math.cos(d)];e=Math.acos(Math.max(Math.min((k[0]*e[0]+k[1]*e[1])/(Math.sqrt(k[0]*k[0]+k[1]*k[1]+k[2]*k[2])*
Math.sqrt(e[0]*e[0]+e[1]*e[1])),1),-1));0>k[2]&&(e=2*Math.PI-e);g+=e}if(a||"multires"!=y&&"cubemap"!=y){if("multires"!=y)l=2*Math.atan(Math.tan(0.5*l)/(a.drawingBufferWidth/a.drawingBufferHeight)),l=1/Math.tan(0.5*l),a.uniform1f(c.psi,d),a.uniform1f(c.theta,f),a.uniform1f(c.rot,g),a.uniform1f(c.f,l),!0===ka&&"equirectangular"==y&&(a.bindTexture(a.TEXTURE_2D,c.texture),a.texImage2D(a.TEXTURE_2D,0,a.RGB,a.RGB,a.UNSIGNED_BYTE,m)),a.drawArrays(a.TRIANGLES,0,6);else{k=a.drawingBufferWidth/a.drawingBufferHeight;
e=2*Math.atan(Math.tan(l/2)*a.drawingBufferHeight/a.drawingBufferWidth);e=1/Math.tan(e/2);k=[e/k,0,0,0,0,e,0,0,0,0,100.1/-99.9,20/-99.9,0,0,-1,0];for(e=1;e<m.maxLevel&&a.drawingBufferWidth>m.tileResolution*Math.pow(2,e-1)*Math.tan(l/2)*0.707;)e++;c.level=e;e=[1,0,0,0,1,0,0,0,1];e=pa(e,-g,"z");e=pa(e,-f,"x");e=pa(e,d,"y");e=[e[0],e[1],e[2],0,e[3],e[4],e[5],0,e[6],e[7],e[8],0,0,0,0,1];a.uniformMatrix4fv(c.perspUniform,!1,new Float32Array(Ga(k)));a.uniformMatrix4fv(c.cubeUniform,!1,new Float32Array(Ga(e)));
g=[k[0]*e[0],k[0]*e[1],k[0]*e[2],0,k[5]*e[4],k[5]*e[5],k[5]*e[6],0,k[10]*e[8],k[10]*e[9],k[10]*e[10],k[11],-e[8],-e[9],-e[10],0];c.nodeCache.sort(R);if(200<c.nodeCache.length&&c.nodeCache.length>c.currentNodes.length+50)for(k=c.nodeCache.splice(200,c.nodeCache.length-200),e=0;e<k.length;e++)a.deleteTexture(k[e].texture);c.currentNodes=[];e="fbudlr".split("");for(k=0;6>k;k++)s=new M(xa[k],e[k],1,0,0,m.fullpath),La(g,s,f,d,l);c.currentNodes.sort(na);for(f=ba.length-1;0<=f;f--)-1===c.currentNodes.indexOf(ba[f].node)&&
(ba[f].node.textureLoad=!1,ba.splice(f,1));if(0===ba.length)for(f=0;f<c.currentNodes.length;f++)if(d=c.currentNodes[f],!d.texture&&!d.textureLoad){d.textureLoad=!0;setTimeout(wa,0,d);break}if(!c.drawInProgress){c.drawInProgress=!0;a.clear(a.COLOR_BUFFER_BIT);for(f=0;f<c.currentNodes.length;f++)1<c.currentNodes[f].textureLoaded&&(a.bindBuffer(a.ARRAY_BUFFER,fa),a.bufferData(a.ARRAY_BUFFER,new Float32Array(c.currentNodes[f].vertices),a.STATIC_DRAW),a.vertexAttribPointer(c.vertPosLocation,3,a.FLOAT,
!1,0,0),a.bindBuffer(a.ARRAY_BUFFER,ya),a.vertexAttribPointer(c.texCoordLocation,2,a.FLOAT,!1,0,0),a.bindTexture(a.TEXTURE_2D,c.currentNodes[f].texture),a.drawElements(a.TRIANGLES,6,a.UNSIGNED_SHORT,0));c.drawInProgress=!1}}if(t.returnImage!==p)return E.toDataURL("image/png")}else for(k=$/2,t={f:"translate3d(-"+(k+2)+"px, -"+(k+2)+"px, -"+k+"px)",b:"translate3d("+(k+2)+"px, -"+(k+2)+"px, "+k+"px) rotateX(180deg) rotateZ(180deg)",u:"translate3d(-"+(k+2)+"px, -"+k+"px, "+(k+2)+"px) rotateX(270deg)",
d:"translate3d(-"+(k+2)+"px, "+k+"px, -"+(k+2)+"px) rotateX(90deg)",l:"translate3d(-"+k+"px, -"+(k+2)+"px, "+(k+2)+"px) rotateX(180deg) rotateY(90deg) rotateZ(180deg)",r:"translate3d("+k+"px, -"+(k+2)+"px, -"+(k+2)+"px) rotateY(270deg)"},l=1/Math.tan(l/2),l=l*E.clientWidth/2+"px",d="perspective("+l+") translateZ("+l+") rotateX("+f+"rad) rotateY("+d+"rad) ",l=Object.keys(t),f=0;6>f;f++)if(g=S.querySelector(".pnlm-"+l[f]+"face"))g.style.webkitTransform=d+t[l[f]],g.style.transform=d+t[l[f]]};this.isLoading=
function(){if(a&&"multires"==y)for(var f=0;f<c.currentNodes.length;f++)if(!c.currentNodes[f].textureLoaded)return!0;return!1};this.getCanvas=function(){return E};var ba=[],ja=function(){function c(){var e=this;this.texture=this.callback=null;this.image=new Image;this.image.crossOrigin=k?k:"anonymous";var d=function(){if(0<e.image.width&&0<e.image.height){var c=e.image;a.bindTexture(a.TEXTURE_2D,e.texture);a.texImage2D(a.TEXTURE_2D,0,a.RGB,a.RGB,a.UNSIGNED_BYTE,c);a.texParameteri(a.TEXTURE_2D,a.TEXTURE_MAG_FILTER,
a.LINEAR);a.texParameteri(a.TEXTURE_2D,a.TEXTURE_MIN_FILTER,a.LINEAR);a.texParameteri(a.TEXTURE_2D,a.TEXTURE_WRAP_S,a.CLAMP_TO_EDGE);a.texParameteri(a.TEXTURE_2D,a.TEXTURE_WRAP_T,a.CLAMP_TO_EDGE);a.bindTexture(a.TEXTURE_2D,null);e.callback(e.texture,!0)}else e.callback(e.texture,!1);ba.length?(c=ba.shift(),e.loadTexture(c.src,c.texture,c.callback)):l[f++]=e};this.image.addEventListener("load",d);this.image.addEventListener("error",d)}function d(a,c,d,f){this.node=a;this.src=c;this.texture=d;this.callback=
f}var f=4,l={},k;c.prototype.loadTexture=function(a,c,d){this.texture=c;this.callback=d;this.image.src=a};for(var g=0;g<f;g++)l[g]=new c;return function(c,g,m,n){k=n;n=a.createTexture();f?l[--f].loadTexture(g,n,m):ba.push(new d(c,g,n,m));return n}}()}var t="attribute vec2 a_texCoord;varying vec2 v_texCoord;void main() {gl_Position = vec4(a_texCoord, 0.0, 1.0);v_texCoord = a_texCoord;}",l="attribute vec3 a_vertCoord;attribute vec2 a_texCoord;uniform mat4 u_cubeMatrix;uniform mat4 u_perspMatrix;varying mediump vec2 v_texCoord;void main(void) {gl_Position = u_perspMatrix * u_cubeMatrix * vec4(a_vertCoord, 1.0);v_texCoord = a_texCoord;}",
ra="precision highp float;\nuniform float u_aspectRatio;\nuniform float u_psi;\nuniform float u_theta;\nuniform float u_f;\nuniform float u_h;\nuniform float u_v;\nuniform float u_vo;\nuniform float u_rot;\nconst float PI = 3.14159265358979323846264;\nuniform sampler2D u_image0;\nuniform sampler2D u_image1;\nuniform bool u_splitImage;\nuniform samplerCube u_imageCube;\nvarying vec2 v_texCoord;\nuniform vec4 u_backgroundColor;\nvoid main() {\nfloat x = v_texCoord.x * u_aspectRatio;\nfloat y = v_texCoord.y;\nfloat sinrot = sin(u_rot);\nfloat cosrot = cos(u_rot);\nfloat rot_x = x * cosrot - y * sinrot;\nfloat rot_y = x * sinrot + y * cosrot;\nfloat sintheta = sin(u_theta);\nfloat costheta = cos(u_theta);\nfloat a = u_f * costheta - rot_y * sintheta;\nfloat root = sqrt(rot_x * rot_x + a * a);\nfloat lambda = atan(rot_x / root, a / root) + u_psi;\nfloat phi = atan((rot_y * costheta + u_f * sintheta) / root);",
bb=ra+"float cosphi = cos(phi);\ngl_FragColor = textureCube(u_imageCube, vec3(cosphi*sin(lambda), sin(phi), cosphi*cos(lambda)));\n}",sa=ra+"lambda = mod(lambda + PI, PI * 2.0) - PI;\nvec2 coord = vec2(lambda / PI, phi / (PI / 2.0));\nif(coord.x < -u_h || coord.x > u_h || coord.y < -u_v + u_vo || coord.y > u_v + u_vo)\ngl_FragColor = u_backgroundColor;\nelse {\nif(u_splitImage) {\nif(coord.x < 0.0)\ngl_FragColor = texture2D(u_image0, vec2((coord.x + u_h) / u_h, (-coord.y + u_v + u_vo) / (u_v * 2.0)));\nelse\ngl_FragColor = texture2D(u_image1, vec2((coord.x + u_h) / u_h - 1.0, (-coord.y + u_v + u_vo) / (u_v * 2.0)));\n} else {\ngl_FragColor = texture2D(u_image0, vec2((coord.x + u_h) / (u_h * 2.0), (-coord.y + u_v + u_vo) / (u_v * 2.0)));\n}\n}\n}",
ta="varying mediump vec2 v_texCoord;uniform sampler2D u_sampler;void main(void) {gl_FragColor = texture2D(u_sampler, v_texCoord);}";return{renderer:function(f,l,p,t){return new ja(f,l,p,t)}}}(window,document);
window.pannellum=function(F,f,p){function ja(t,l){function ra(a){F.removeEventListener("deviceorientation",ra);a&&null!==a.alpha&&null!==a.beta&&null!==a.gamma?(u.container.appendChild(u.orientation),ua=!0,Za&&C()):ua=!1}function ja(){var a=f.createElement("div");a.innerHTML="\x3c!--[if lte IE 9]><i></i><![endif]--\x3e";if(1==a.getElementsByTagName("i").length)R();else{za=b.hfov;Ia=b.pitch;var h;if("cubemap"==b.type){Q=[];for(a=0;6>a;a++)Q.push(new Image),Q[a].crossOrigin=b.crossOrigin;q.load.lbox.style.display=
"block";q.load.lbar.style.display="none"}else if("multires"==b.type)a=JSON.parse(JSON.stringify(b.multiRes)),b.basePath&&b.multiRes.basePath&&!/^(?:[a-z]+:)?\/\//i.test(b.multiRes.basePath)?a.basePath=b.basePath+b.multiRes.basePath:b.multiRes.basePath?a.basePath=b.multiRes.basePath:b.basePath&&(a.basePath=b.basePath),Q=a;else if(!0===b.dynamic)Q=b.panorama;else{if(b.panorama===p){R(b.strings.noPanoramaError);return}Q=new Image}if("cubemap"==b.type)for(var v=6,c=function(){v--;0===v&&ta()},e=function(a){var ha=
f.createElement("a");ha.href=a.target.src;ha.textContent=ha.href;R(b.strings.fileAccessError.replace("%s",ha.outerHTML))},a=0;a<Q.length;a++)h=b.cubeMap[a],"null"==h?(console.log("Will use background instead of missing cubemap face "+a),c()):(b.basePath&&!sa(h)&&(h=b.basePath+h),Q[a].onload=c,Q[a].onerror=e,Q[a].src=I(h));else if("multires"==b.type)ta();else if(h="",b.basePath&&(h=b.basePath),!0!==b.dynamic){h=sa(b.panorama)?b.panorama:h+b.panorama;Q.onload=function(){F.URL.revokeObjectURL(this.src);
ta()};var d=new XMLHttpRequest;d.onloadend=function(){if(200!=d.status){var a=f.createElement("a");a.href=h;a.textContent=a.href;R(b.strings.fileAccessError.replace("%s",a.outerHTML))}Z(this.response);q.load.msg.innerHTML=""};d.onprogress=function(a){if(a.lengthComputable){q.load.lbarFill.style.width=a.loaded/a.total*100+"%";var b,ha;1E6<a.total?(b="MB",ha=(a.loaded/1E6).toFixed(2),a=(a.total/1E6).toFixed(2)):1E3<a.total?(b="kB",ha=(a.loaded/1E3).toFixed(1),a=(a.total/1E3).toFixed(1)):(b="B",ha=a.loaded,
a=a.total);q.load.msg.innerHTML=ha+" / "+a+" "+b}else q.load.lbox.style.display="block",q.load.lbar.style.display="none"};try{d.open("GET",h,!0)}catch(g){R(b.strings.malformedURLError)}d.responseType="blob";d.setRequestHeader("Accept","image/*,*/*;q=0.9");d.withCredentials="use-credentials"===b.crossOrigin;d.send()}b.draggable&&J.classList.add("pnlm-grab");J.classList.remove("pnlm-grabbing");Na=!0===b.dynamicUpdate;b.dynamic&&Na&&(Q=b.panorama,ta())}}function sa(a){return/^(?:[a-z]+:)?\/\//i.test(a)||
"/"==a[0]||"blob:"==a.slice(0,5)}function ta(){B||(B=new libpannellum.renderer(N));Ta||(Ta=!0,W.addEventListener("mousedown",La,!1),f.addEventListener("mousemove",Ga,!1),f.addEventListener("mouseup",wa,!1),b.mouseZoom&&(J.addEventListener("mousewheel",V,!1),J.addEventListener("DOMMouseScroll",V,!1)),b.doubleClickZoom&&W.addEventListener("dblclick",Ma,!1),t.addEventListener("mozfullscreenchange",s,!1),t.addEventListener("webkitfullscreenchange",s,!1),t.addEventListener("msfullscreenchange",s,!1),t.addEventListener("fullscreenchange",
s,!1),F.addEventListener("resize",ka,!1),F.addEventListener("orientationchange",ka,!1),b.disableKeyboardCtrl||(t.addEventListener("keydown",$,!1),t.addEventListener("keyup",xa,!1),t.addEventListener("blur",S,!1)),f.addEventListener("mouseleave",wa,!1),""===f.documentElement.style.pointerAction&&""===f.documentElement.style.touchAction?(W.addEventListener("pointerdown",c,!1),W.addEventListener("pointermove",a,!1),W.addEventListener("pointerup",U,!1),W.addEventListener("pointerleave",U,!1)):(W.addEventListener("touchstart",
oa,!1),W.addEventListener("touchmove",Ha,!1),W.addEventListener("touchend",E,!1)),F.navigator.pointerEnabled&&(t.style.touchAction="none"));ba();n(b.hfov);setTimeout(function(){},500)}function Z(a){var h=new FileReader;h.addEventListener("loadend",function(){var v=h.result;if(navigator.userAgent.toLowerCase().match(/(iphone|ipod|ipad).* os 8_/)){var c=v.indexOf("\u00ff\u00c2");(0>c||65536<c)&&R(b.strings.iOS8WebGLError)}c=v.indexOf("<x:xmpmeta");if(-1<c&&!0!==b.ignoreGPanoXMP){var d=v.substring(c,
v.indexOf("</x:xmpmeta>")+12),e=function(a){var b;0<=d.indexOf(a+'="')?(b=d.substring(d.indexOf(a+'="')+a.length+2),b=b.substring(0,b.indexOf('"'))):0<=d.indexOf(a+">")&&(b=d.substring(d.indexOf(a+">")+a.length+1),b=b.substring(0,b.indexOf("<")));return b!==p?Number(b):null},v=e("GPano:FullPanoWidthPixels"),c=e("GPano:CroppedAreaImageWidthPixels"),f=e("GPano:FullPanoHeightPixels"),g=e("GPano:CroppedAreaImageHeightPixels"),k=e("GPano:CroppedAreaTopPixels"),l=e("GPano:PoseHeadingDegrees"),m=e("GPano:PosePitchDegrees"),
e=e("GPano:PoseRollDegrees");null!==v&&null!==c&&null!==f&&null!==g&&null!==k&&(0>ca.indexOf("haov")&&(b.haov=c/v*360),0>ca.indexOf("vaov")&&(b.vaov=g/f*180),0>ca.indexOf("vOffset")&&(b.vOffset=-180*((k+g/2)/f-0.5)),null!==l&&0>ca.indexOf("northOffset")&&(b.northOffset=l,!1!==b.compass&&(b.compass=!0)),null!==m&&null!==e&&(0>ca.indexOf("horizonPitch")&&(b.horizonPitch=m),0>ca.indexOf("horizonRoll")&&(b.horizonRoll=e)))}Q.src=F.URL.createObjectURL(a)});h.readAsBinaryString!==p?h.readAsBinaryString(a):
h.readAsText(a)}function R(a){a===p&&(a=b.strings.genericWebGLError);q.errorMsg.innerHTML="<p>"+a+"</p>";u.load.style.display="none";q.load.box.style.display="none";q.errorMsg.style.display="table";Oa=!0;N.style.display="none";A("error",a)}function na(a){var b=M(a);ia.style.left=b.x+"px";ia.style.top=b.y+"px";clearTimeout(na.t1);clearTimeout(na.t2);ia.style.display="block";ia.style.opacity=1;na.t1=setTimeout(function(){ia.style.opacity=0},2E3);na.t2=setTimeout(function(){ia.style.display="none"},
2500);a.preventDefault()}function M(a){var b=t.getBoundingClientRect(),v={};v.x=(a.clientX||a.pageX)-b.left;v.y=(a.clientY||a.pageY)-b.top;return v}function La(a){a.preventDefault();t.focus();if(K&&b.draggable){var h=M(a);if(b.hotSpotDebug){var v=pa(a);console.log("Pitch: "+v[0]+", Yaw: "+v[1]+", Center Pitch: "+b.pitch+", Center Yaw: "+b.yaw+", HFOV: "+b.hfov)}Ea();Fa();b.roll=0;w.hfov=0;la=!0;O=Date.now();Aa=h.x;Ba=h.y;Pa=b.yaw;Qa=b.pitch;J.classList.add("pnlm-grabbing");J.classList.remove("pnlm-grab");
A("mousedown",a);D()}}function Ma(a){b.minHfov===b.hfov?ga.setHfov(za,1E3):(a=pa(a),ga.lookAt(a[0],a[1],b.minHfov,1E3))}function pa(a){var h=M(a);a=B.getCanvas();var v=a.clientWidth,c=a.clientHeight;a=h.x/v*2-1;var c=(1-h.y/c*2)*c/v,e=1/Math.tan(b.hfov*Math.PI/360),d=Math.sin(b.pitch*Math.PI/180),f=Math.cos(b.pitch*Math.PI/180),h=e*f-c*d,v=Math.sqrt(a*a+h*h),c=180*Math.atan((c*f+e*d)/v)/Math.PI;a=180*Math.atan2(a/v,h/v)/Math.PI+b.yaw;-180>a&&(a+=360);180<a&&(a-=360);return[c,a]}function Ga(a){if(la&&
K){O=Date.now();var h=B.getCanvas(),v=h.clientWidth,h=h.clientHeight;a=M(a);var c=180*(Math.atan(Aa/v*2-1)-Math.atan(a.x/v*2-1))/Math.PI*b.hfov/90+Pa;w.yaw=(c-b.yaw)%360*0.2;b.yaw=c;v=360*Math.atan(Math.tan(b.hfov/360*Math.PI)*h/v)/Math.PI;v=180*(Math.atan(a.y/h*2-1)-Math.atan(Ba/h*2-1))/Math.PI*v/90+Qa;w.pitch=0.2*(v-b.pitch);b.pitch=v}}function wa(a){la&&(la=!1,15<Date.now()-O&&(w.pitch=w.yaw=0),J.classList.add("pnlm-grab"),J.classList.remove("pnlm-grabbing"),O=Date.now(),A("mouseup",a))}function oa(a){if(K&&
b.draggable){Ea();Fa();b.roll=0;w.hfov=0;var h=M(a.targetTouches[0]);Aa=h.x;Ba=h.y;if(2==a.targetTouches.length){var v=M(a.targetTouches[1]);Aa+=0.5*(v.x-h.x);Ba+=0.5*(v.y-h.y);Ja=Math.sqrt((h.x-v.x)*(h.x-v.x)+(h.y-v.y)*(h.y-v.y))}la=!0;O=Date.now();Pa=b.yaw;Qa=b.pitch;A("touchstart",a);D()}}function Ha(a){if(b.draggable&&(a.preventDefault(),K&&(O=Date.now()),la&&K)){var h=M(a.targetTouches[0]),v=h.x,c=h.y;2==a.targetTouches.length&&-1!=Ja&&(a=M(a.targetTouches[1]),v+=0.5*(a.x-h.x),c+=0.5*(a.y-h.y),
h=Math.sqrt((h.x-a.x)*(h.x-a.x)+(h.y-a.y)*(h.y-a.y)),n(b.hfov+0.1*(Ja-h)),Ja=h);h=b.hfov/360*b.touchPanSpeedCoeffFactor;v=(Aa-v)*h+Pa;w.yaw=(v-b.yaw)%360*0.2;b.yaw=v;c=(c-Ba)*h+Qa;w.pitch=0.2*(c-b.pitch);b.pitch=c}}function E(){la=!1;150<Date.now()-O&&(w.pitch=w.yaw=0);Ja=-1;O=Date.now();A("touchend",event)}function c(a){"touch"==a.pointerType&&(ma.push(a.pointerId),Ca.push({clientX:a.clientX,clientY:a.clientY}),a.targetTouches=Ca,oa(a),a.preventDefault())}function a(a){if("touch"==a.pointerType)for(var b=
0;b<ma.length;b++)if(a.pointerId==ma[b]){Ca[b].clientX=a.clientX;Ca[b].clientY=a.clientY;a.targetTouches=Ca;Ha(a);a.preventDefault();break}}function U(a){if("touch"==a.pointerType){for(var b=!1,c=0;c<ma.length;c++)a.pointerId==ma[c]&&(ma[c]=p),ma[c]&&(b=!0);b||(ma=[],Ca=[],E());a.preventDefault()}}function V(a){K&&("fullscreenonly"!=b.mouseZoom||Da)&&(a.preventDefault(),Ea(),O=Date.now(),a.wheelDeltaY?(n(b.hfov-0.05*a.wheelDeltaY),w.hfov=0>a.wheelDelta?1:-1):a.wheelDelta?(n(b.hfov-0.05*a.wheelDelta),
w.hfov=0>a.wheelDelta?1:-1):a.detail&&(n(b.hfov+1.5*a.detail),w.hfov=0<a.detail?1:-1),D())}function $(a){Ea();O=Date.now();Fa();b.roll=0;var h=a.which||a.keycode;0>b.capturedKeyNumbers.indexOf(h)||(a.preventDefault(),27==h?Da&&e():ea(h,!0))}function S(){for(var a=0;10>a;a++)r[a]=!1}function xa(a){var h=a.which||a.keycode;0>b.capturedKeyNumbers.indexOf(h)||(a.preventDefault(),ea(h,!1))}function ea(a,b){var c=!1;switch(a){case 109:case 189:case 17:case 173:r[0]!=b&&(c=!0);r[0]=b;break;case 107:case 187:case 16:case 61:r[1]!=
b&&(c=!0);r[1]=b;break;case 38:r[2]!=b&&(c=!0);r[2]=b;break;case 87:r[6]!=b&&(c=!0);r[6]=b;break;case 40:r[3]!=b&&(c=!0);r[3]=b;break;case 83:r[7]!=b&&(c=!0);r[7]=b;break;case 37:r[4]!=b&&(c=!0);r[4]=b;break;case 65:r[8]!=b&&(c=!0);r[8]=b;break;case 39:r[5]!=b&&(c=!0);r[5]=b;break;case 68:r[9]!=b&&(c=!0),r[9]=b}c&&b&&(da="undefined"!==typeof performance&&performance.now()?performance.now():Date.now(),D())}function m(){if(K){var a=!1,h=b.pitch,c=b.yaw,e=b.hfov,d;d="undefined"!==typeof performance&&
performance.now()?performance.now():Date.now();da===p&&(da=d);var f=(d-da)*b.hfov/1700,f=Math.min(f,1);r[0]&&!0===b.keyboardZoom&&(n(b.hfov+(0.8*w.hfov+0.5)*f),a=!0);r[1]&&!0===b.keyboardZoom&&(n(b.hfov+(0.8*w.hfov-0.2)*f),a=!0);if(r[2]||r[6])b.pitch+=(0.8*w.pitch+0.2)*f,a=!0;if(r[3]||r[7])b.pitch+=(0.8*w.pitch-0.2)*f,a=!0;if(r[4]||r[8])b.yaw+=(0.8*w.yaw-0.2)*f,a=!0;if(r[5]||r[9])b.yaw+=(0.8*w.yaw+0.2)*f,a=!0;a&&(O=Date.now());if(b.autoRotate){if(0.001<d-da){var a=(d-da)/1E3,g=(w.yaw/a*f-0.2*b.autoRotate)*
a,g=(0<-b.autoRotate?1:-1)*Math.min(Math.abs(b.autoRotate*a),Math.abs(g));b.yaw+=g}b.autoRotateStopDelay&&(b.autoRotateStopDelay-=d-da,0>=b.autoRotateStopDelay&&(b.autoRotateStopDelay=!1,X=b.autoRotate,b.autoRotate=0))}P.pitch&&(y("pitch"),h=b.pitch);P.yaw&&(y("yaw"),c=b.yaw);P.hfov&&(y("hfov"),e=b.hfov);0<f&&!b.autoRotate&&(a=1-b.friction,r[4]||r[5]||r[8]||r[9]||P.yaw||(b.yaw+=w.yaw*f*a),r[2]||r[3]||r[6]||r[7]||P.pitch||(b.pitch+=w.pitch*f*a),r[0]||r[1]||P.hfov||n(b.hfov+w.hfov*f*a));da=d;0<f&&(w.yaw=
0.8*w.yaw+(b.yaw-c)/f*0.2,w.pitch=0.8*w.pitch+(b.pitch-h)/f*0.2,w.hfov=0.8*w.hfov+(b.hfov-e)/f*0.2,h=b.autoRotate?Math.abs(b.autoRotate):5,w.yaw=Math.min(h,Math.max(w.yaw,-h)),w.pitch=Math.min(h,Math.max(w.pitch,-h)),w.hfov=Math.min(h,Math.max(w.hfov,-h)));r[0]&&r[1]&&(w.hfov=0);(r[2]||r[6])&&(r[3]||r[7])&&(w.pitch=0);(r[4]||r[8])&&(r[5]||r[9])&&(w.yaw=0)}}function y(a){var h=P[a],c=Math.min(1,Math.max((Date.now()-h.startTime)/1E3/(h.duration/1E3),0)),c=h.startPosition+b.animationTimingFunction(c)*
(h.endPosition-h.startPosition);if(h.endPosition>h.startPosition&&c>=h.endPosition||h.endPosition<h.startPosition&&c<=h.endPosition||h.endPosition===h.startPosition)c=h.endPosition,w[a]=0,delete P[a];b[a]=c}function ka(){s("resize")}function D(){Ua||(Ua=!0,fa())}function fa(){ya();Va&&clearTimeout(Va);if(la||!0===Y)requestAnimationFrame(fa);else if(r[0]||r[1]||r[2]||r[3]||r[4]||r[5]||r[6]||r[7]||r[8]||r[9]||b.autoRotate||P.pitch||P.yaw||P.hfov||0.01<Math.abs(w.yaw)||0.01<Math.abs(w.pitch)||0.01<Math.abs(w.hfov))m(),
0<=b.autoRotateInactivityDelay&&X&&Date.now()-O>b.autoRotateInactivityDelay&&!b.autoRotate&&(b.autoRotate=X,ga.lookAt(Ia,p,za,3E3)),requestAnimationFrame(fa);else if(B&&(B.isLoading()||!0===b.dynamic&&Na))requestAnimationFrame(fa);else{A("animatefinished",{pitch:ga.getPitch(),yaw:ga.getYaw(),hfov:ga.getHfov()});Ua=!1;da=p;var a=b.autoRotateInactivityDelay-(Date.now()-O);0<a?Va=setTimeout(function(){b.autoRotate=X;ga.lookAt(Ia,p,za,3E3);D()},a):0<=b.autoRotateInactivityDelay&&X&&(b.autoRotate=X,ga.lookAt(Ia,
p,za,3E3),D())}}function ya(){var a;if(K){var h=B.getCanvas();a=b.yaw;var c=0;if(b.avoidShowingBackground){var d=b.hfov/2,f=180*Math.atan2(Math.tan(d/180*Math.PI),h.width/h.height)/Math.PI;b.vaov>b.haov?Math.min(Math.cos((b.pitch-d)/180*Math.PI),Math.cos((b.pitch+d)/180*Math.PI)):c=d*(1-Math.min(Math.cos((b.pitch-f)/180*Math.PI),Math.cos((b.pitch+f)/180*Math.PI)))}var d=b.maxYaw-b.minYaw,f=-180,e=180;360>d&&(f=b.minYaw+b.hfov/2+c,e=b.maxYaw-b.hfov/2-c,d<b.hfov&&(f=e=(f+e)/2),b.yaw=Math.max(f,Math.min(e,
b.yaw)));180<b.yaw?b.yaw-=360:-180>b.yaw&&(b.yaw+=360);!1!==b.autoRotate&&a!=b.yaw&&da!==p&&(b.autoRotate*=-1);a=2*Math.atan(Math.tan(b.hfov/180*Math.PI*0.5)/(h.width/h.height))/Math.PI*180;h=b.minPitch+a/2;c=b.maxPitch-a/2;b.maxPitch-b.minPitch<a&&(h=c=(h+c)/2);isNaN(h)&&(h=-90);isNaN(c)&&(c=90);b.pitch=Math.max(h,Math.min(c,b.pitch));B.render(b.pitch*Math.PI/180,b.yaw*Math.PI/180,b.hfov*Math.PI/180,{roll:b.roll*Math.PI/180});b.hotSpots.forEach(L);b.compass&&(Ka.style.transform="rotate("+(-b.yaw-
b.northOffset)+"deg)",Ka.style.webkitTransform="rotate("+(-b.yaw-b.northOffset)+"deg)")}}function aa(a,b,c,d){this.w=a;this.x=b;this.y=c;this.z=d}function qa(a){var h;h=a.alpha;var c=a.beta;a=a.gamma;c=[c?c*Math.PI/180/2:0,a?a*Math.PI/180/2:0,h?h*Math.PI/180/2:0];h=[Math.cos(c[0]),Math.cos(c[1]),Math.cos(c[2])];c=[Math.sin(c[0]),Math.sin(c[1]),Math.sin(c[2])];h=new aa(h[0]*h[1]*h[2]-c[0]*c[1]*c[2],c[0]*h[1]*h[2]-h[0]*c[1]*c[2],h[0]*c[1]*h[2]+c[0]*h[1]*c[2],h[0]*h[1]*c[2]+c[0]*c[1]*h[2]);h=h.multiply(new aa(Math.sqrt(0.5),
-Math.sqrt(0.5),0,0));c=F.orientation?-F.orientation*Math.PI/180/2:0;h=h.multiply(new aa(Math.cos(c),0,-Math.sin(c),0)).toEulerAngles();"number"==typeof Y&&10>Y?Y+=1:10===Y?($a=h[2]/Math.PI*180+b.yaw,Y=!0,requestAnimationFrame(fa)):(b.pitch=h[0]/Math.PI*180,b.roll=-h[1]/Math.PI*180,b.yaw=-h[2]/Math.PI*180+$a)}function ba(){try{var a={};b.horizonPitch!==p&&(a.horizonPitch=b.horizonPitch*Math.PI/180);b.horizonRoll!==p&&(a.horizonRoll=b.horizonRoll*Math.PI/180);b.backgroundColor!==p&&(a.backgroundColor=
b.backgroundColor);B.init(Q,b.type,b.dynamic,b.haov*Math.PI/180,b.vaov*Math.PI/180,b.vOffset*Math.PI/180,ab,a);!0!==b.dynamic&&(Q=p)}catch(c){if("webgl error"==c.type||"no webgl"==c.type)R();else if("webgl size error"==c.type)R(b.strings.textureSizeError.replace("%s",c.width).replace("%s",c.maxWidth));else throw R(b.strings.unknownError),c;}}function ab(){if(b.sceneFadeDuration&&B.fadeImg!==p){B.fadeImg.style.opacity=0;var a=B.fadeImg;delete B.fadeImg;setTimeout(function(){N.removeChild(a);A("scenechangefadedone")},
b.sceneFadeDuration)}Ka.style.display=b.compass?"inline":"none";d();q.load.box.style.display="none";va!==p&&(N.removeChild(va),va=p);K=!0;A("load");D()}function G(a){a.pitch=Number(a.pitch)||0;a.yaw=Number(a.yaw)||0;var c=f.createElement("div");c.className="pnlm-hotspot-base";c.className=a.cssClass?c.className+(" "+a.cssClass):c.className+(" pnlm-hotspot pnlm-sprite pnlm-"+H(a.type));var d=f.createElement("span");a.text&&(d.innerHTML=H(a.text));var e;if(a.video){e=f.createElement("video");var g=a.video;
b.basePath&&!sa(g)&&(g=b.basePath+g);e.src=I(g);e.controls=!0;e.style.width=a.width+"px";N.appendChild(c);d.appendChild(e)}else if(a.image){g=a.image;b.basePath&&!sa(g)&&(g=b.basePath+g);e=f.createElement("a");e.href=I(a.URL?a.URL:g);e.target="_blank";d.appendChild(e);var k=f.createElement("img");k.src=I(g);k.style.width=a.width+"px";k.style.paddingTop="5px";N.appendChild(c);e.appendChild(k);d.style.maxWidth="initial"}else if(a.URL){e=f.createElement("a");e.href=I(a.URL);if(a.attributes)for(g in a.attributes)e.setAttribute(g,
a.attributes[g]);else e.target="_blank";N.appendChild(e);c.className+=" pnlm-pointer";d.className+=" pnlm-pointer";e.appendChild(c)}else a.sceneId&&(c.onclick=c.ontouchend=function(){c.clicked||(c.clicked=!0,Sa(a.sceneId,a.targetPitch,a.targetYaw,a.targetHfov));return!1},c.className+=" pnlm-pointer",d.className+=" pnlm-pointer"),N.appendChild(c);if(a.createTooltipFunc)a.createTooltipFunc(c,a.createTooltipArgs);else if(a.text||a.video||a.image)c.classList.add("pnlm-tooltip"),c.appendChild(d),d.style.width=
d.scrollWidth-20+"px",d.style.marginLeft=-(d.scrollWidth-c.offsetWidth)/2+"px",d.style.marginTop=-d.scrollHeight-12+"px";a.clickHandlerFunc&&(c.addEventListener("click",function(b){a.clickHandlerFunc(b,a.clickHandlerArgs)},"false"),c.className+=" pnlm-pointer",d.className+=" pnlm-pointer");a.div=c}function d(){Wa||(b.hotSpots?(b.hotSpots=b.hotSpots.sort(function(a,b){return a.pitch<b.pitch}),b.hotSpots.forEach(G)):b.hotSpots=[],Wa=!0,b.hotSpots.forEach(L))}function Ra(){var a=b.hotSpots;Wa=!1;delete b.hotSpots;
if(a)for(var c=0;c<a.length;c++){var d=a[c].div;if(d){for(;d.parentNode&&d.parentNode!=N;)d=d.parentNode;N.removeChild(d)}delete a[c].div}}function L(a){var c=Math.sin(a.pitch*Math.PI/180),d=Math.cos(a.pitch*Math.PI/180),e=Math.sin(b.pitch*Math.PI/180),f=Math.cos(b.pitch*Math.PI/180),g=Math.cos((-a.yaw+b.yaw)*Math.PI/180),k=c*e+d*g*f;if(90>=a.yaw&&-90<a.yaw&&0>=k||(90<a.yaw||-90>=a.yaw)&&0>=k)a.div.style.visibility="hidden";else{var l=Math.sin((-a.yaw+b.yaw)*Math.PI/180),m=Math.tan(b.hfov*Math.PI/
360);a.div.style.visibility="visible";var n=B.getCanvas(),p=n.clientWidth,n=n.clientHeight,c=[-p/m*l*d/k/2,-p/m*(c*f-d*g*e)/k/2],d=Math.sin(b.roll*Math.PI/180),e=Math.cos(b.roll*Math.PI/180),c=[c[0]*e-c[1]*d,c[0]*d+c[1]*e];c[0]+=(p-a.div.offsetWidth)/2;c[1]+=(n-a.div.offsetHeight)/2;p="translate("+c[0]+"px, "+c[1]+"px) translateZ(9999px) rotate("+b.roll+"deg)";a.div.style.webkitTransform=p;a.div.style.MozTransform=p;a.div.style.transform=p}}function k(a){b={};var c,d,e="haov vaov vOffset northOffset horizonPitch horizonRoll".split(" ");
ca=[];for(c in Xa)Xa.hasOwnProperty(c)&&(b[c]=Xa[c]);for(c in l.default)if(l.default.hasOwnProperty(c))if("strings"==c)for(d in l.default.strings)l.default.strings.hasOwnProperty(d)&&(b.strings[d]=H(l.default.strings[d]));else b[c]=l.default[c],0<=e.indexOf(c)&&ca.push(c);if(null!==a&&""!==a&&l.scenes&&l.scenes[a]){var f=l.scenes[a];for(c in f)if(f.hasOwnProperty(c))if("strings"==c)for(d in f.strings)f.strings.hasOwnProperty(d)&&(b.strings[d]=H(f.strings[d]));else b[c]=f[c],0<=e.indexOf(c)&&ca.push(c);
b.scene=a}for(c in l)if(l.hasOwnProperty(c))if("strings"==c)for(d in l.strings)l.strings.hasOwnProperty(d)&&(b.strings[d]=H(l.strings[d]));else b[c]=l[c],0<=e.indexOf(c)&&ca.push(c)}function g(a){if((a=a?a:!1)&&"preview"in b){var c=b.preview;b.basePath&&!sa(c)&&(c=b.basePath+c);va=f.createElement("div");va.className="pnlm-preview-img";va.style.backgroundImage="url('"+I(c).replace(/"/g,"%22").replace(/'/g,"%27")+"')";N.appendChild(va)}var c=b.title,d=b.author;a&&("previewTitle"in b&&(b.title=b.previewTitle),
"previewAuthor"in b&&(b.author=b.previewAuthor));b.hasOwnProperty("title")||(q.title.innerHTML="");b.hasOwnProperty("author")||(q.author.innerHTML="");b.hasOwnProperty("title")||b.hasOwnProperty("author")||(q.container.style.display="none");u.load.innerHTML="<p>"+b.strings.loadButtonLabel+"</p>";q.load.boxp.innerHTML=b.strings.loadingLabel;for(var e in b)if(b.hasOwnProperty(e))switch(e){case "title":q.title.innerHTML=H(b[e]);q.container.style.display="inline";break;case "author":var g=H(b[e]);b.authorURL&&
(g=f.createElement("a"),g.href=I(b.authorURL),g.target="_blank",g.innerHTML=H(b[e]),g=g.outerHTML);q.author.innerHTML=b.strings.bylineLabel.replace("%s",g);q.container.style.display="inline";break;case "fallback":g=f.createElement("a");g.href=I(b[e]);g.target="_blank";g.textContent="Click here to view this panorama in an alternative viewer.";var k=f.createElement("p");k.textContent="Your browser does not support WebGL.";k.appendChild(f.createElement("br"));k.appendChild(g);q.errorMsg.innerHTML="";
q.errorMsg.appendChild(k);break;case "hfov":n(Number(b[e]));break;case "autoLoad":!0===b[e]&&B===p&&(q.load.box.style.display="inline",u.load.style.display="none",ja());break;case "showZoomCtrl":u.zoom.style.display=b[e]&&!1!=b.showControls?"block":"none";break;case "showFullscreenCtrl":u.fullscreen.style.display=b[e]&&!1!=b.showControls&&("fullscreen"in f||"mozFullScreen"in f||"webkitIsFullScreen"in f||"msFullscreenElement"in f)?"block":"none";break;case "hotSpotDebug":Ya.style.display=b[e]?"block":
"none";break;case "showControls":b[e]||(u.orientation.style.display="none",u.zoom.style.display="none",u.fullscreen.style.display="none");break;case "orientationOnByDefault":b[e]&&(ua===p?Za=!0:!0===ua&&C())}a&&(c?b.title=c:delete b.title,d?b.author=d:delete b.author)}function e(){if(K&&!Oa)if(Da)f.exitFullscreen?f.exitFullscreen():f.mozCancelFullScreen?f.mozCancelFullScreen():f.webkitCancelFullScreen?f.webkitCancelFullScreen():f.msExitFullscreen&&f.msExitFullscreen();else try{t.requestFullscreen?
t.requestFullscreen():t.mozRequestFullScreen?t.mozRequestFullScreen():t.msRequestFullscreen?t.msRequestFullscreen():t.webkitRequestFullScreen()}catch(a){}}function s(a){f.fullscreenElement||f.fullscreen||f.mozFullScreen||f.webkitIsFullScreen||f.msFullscreenElement?(u.fullscreen.classList.add("pnlm-fullscreen-toggle-button-active"),Da=!0):(u.fullscreen.classList.remove("pnlm-fullscreen-toggle-button-active"),Da=!1);"resize"!==a&&A("fullscreenchange",Da);B.resize();n(b.hfov);D()}function z(a){var c=
b.minHfov;"multires"==b.type&&B&&b.multiResMinHfov&&(c=Math.min(c,B.getCanvas().width/(b.multiRes.cubeResolution/90*0.9)));if(c>b.maxHfov)return console.log("HFOV bounds do not make sense (minHfov > maxHfov)."),b.hfov;var d=b.hfov,d=a<c?c:a>b.maxHfov?b.maxHfov:a;b.avoidShowingBackground&&B&&(a=B.getCanvas(),d=Math.min(d,360*Math.atan(Math.tan((b.maxPitch-b.minPitch)/360*Math.PI)/a.height*a.width)/Math.PI));return d}function n(a){b.hfov=z(a);A("zoomchange",b.hfov)}function Ea(){P={};X=b.autoRotate?
b.autoRotate:X;b.autoRotate=!1}function x(){Oa&&(q.load.box.style.display="none",q.errorMsg.style.display="none",Oa=!1,A("errorcleared"));K=!1;u.load.style.display="none";q.load.box.style.display="inline";ja()}function Sa(a,c,d,e,f){K||(f=!0);K=!1;P={};var m,n;if(b.sceneFadeDuration&&!f&&(m=B.render(b.pitch*Math.PI/180,b.yaw*Math.PI/180,b.hfov*Math.PI/180,{returnImage:!0}),m!==p)){f=new Image;f.className="pnlm-fade-img";f.style.transition="opacity "+b.sceneFadeDuration/1E3+"s";f.style.width="100%";
f.style.height="100%";f.onload=function(){Sa(a,c,d,e,!0)};f.src=m;N.appendChild(f);B.fadeImg=f;return}f="same"===c?b.pitch:c;m="same"===d?b.yaw:"sameAzimuth"===d?b.yaw+(b.northOffset||0)-(l.scenes[a].northOffset||0):d;n="same"===e?b.hfov:e;Ra();k(a);w.yaw=w.pitch=w.hfov=0;g();f!==p&&(b.pitch=f);m!==p&&(b.yaw=m);n!==p&&(b.hfov=n);A("scenechange",a);x()}function Fa(){F.removeEventListener("deviceorientation",qa);u.orientation.classList.remove("pnlm-orientation-button-active");Y=!1}function C(){Y=1;
F.addEventListener("deviceorientation",qa);u.orientation.classList.add("pnlm-orientation-button-active")}function H(a){return l.escapeHTML?String(a).split(/&/g).join("&amp;").split('"').join("&quot;").split("'").join("&#39;").split("<").join("&lt;").split(">").join("&gt;").split("/").join("&#x2f;").split("\n").join("<br>"):String(a).split("\n").join("<br>")}function I(a){return 0===a.trim().toLowerCase().indexOf("javascript:")?"about:blank":a}function A(a){if(a in T)for(var b=T[a].length;0<b;b--)T[a][T[a].length-
b].apply(null,[].slice.call(arguments,1))}var ga=this,b,B,va,la=!1,O=Date.now(),Aa=0,Ba=0,Ja=-1,Pa=0,Qa=0,r=Array(10),Da=!1,K,Oa=!1,Ta=!1,Q,da,w={yaw:0,pitch:0,hfov:0},Ua=!1,Y=!1,$a=0,Va,X=0,za,Ia,P={},T={},ca=[],Na=!1,Wa=!1,Xa={hfov:100,minHfov:50,multiResMinHfov:!1,maxHfov:120,pitch:0,minPitch:p,maxPitch:p,yaw:0,minYaw:-180,maxYaw:180,roll:0,haov:360,vaov:180,vOffset:0,autoRotate:!1,autoRotateInactivityDelay:-1,autoRotateStopDelay:p,type:"equirectangular",northOffset:0,showFullscreenCtrl:!0,dynamic:!1,
dynamicUpdate:!1,doubleClickZoom:!0,keyboardZoom:!0,mouseZoom:!0,showZoomCtrl:!0,autoLoad:!1,showControls:!0,orientationOnByDefault:!1,hotSpotDebug:!1,backgroundColor:[0,0,0],avoidShowingBackground:!1,animationTimingFunction:function(a){return 0.5>a?2*a*a:-1+(4-2*a)*a},draggable:!0,disableKeyboardCtrl:!1,crossOrigin:"anonymous",touchPanSpeedCoeffFactor:1,capturedKeyNumbers:[16,17,27,37,38,39,40,61,65,68,83,87,107,109,173,187,189],friction:0.15,strings:{loadButtonLabel:"Click to<br>Load<br>Panorama",
loadingLabel:"Loading...",bylineLabel:"by %s",noPanoramaError:"No panorama image was specified.",fileAccessError:"The file %s could not be accessed.",malformedURLError:"There is something wrong with the panorama URL.",iOS8WebGLError:"Due to iOS 8's broken WebGL implementation, only progressive encoded JPEGs work for your device (this panorama uses standard encoding).",genericWebGLError:"Your browser does not have the necessary WebGL support to display this panorama.",textureSizeError:"This panorama is too big for your device! It's %spx wide, but your device only supports images up to %spx wide. Try another device. (If you're the author, try scaling down the image.)",
unknownError:"Unknown error. Check developer console."}};t="string"===typeof t?f.getElementById(t):t;t.classList.add("pnlm-container");t.tabIndex=0;var J=f.createElement("div");J.className="pnlm-ui";t.appendChild(J);var N=f.createElement("div");N.className="pnlm-render-container";t.appendChild(N);var W=f.createElement("div");W.className="pnlm-dragfix";J.appendChild(W);var ia=f.createElement("span");ia.className="pnlm-about-msg";ia.innerHTML='<a href="https://pannellum.org/" target="_blank">Pannellum</a> 2.5.2';
J.appendChild(ia);W.addEventListener("contextmenu",na);var q={},Ya=f.createElement("div");Ya.className="pnlm-sprite pnlm-hot-spot-debug-indicator";J.appendChild(Ya);q.container=f.createElement("div");q.container.className="pnlm-panorama-info";q.title=f.createElement("div");q.title.className="pnlm-title-box";q.container.appendChild(q.title);q.author=f.createElement("div");q.author.className="pnlm-author-box";q.container.appendChild(q.author);J.appendChild(q.container);q.load={};q.load.box=f.createElement("div");
q.load.box.className="pnlm-load-box";q.load.boxp=f.createElement("p");q.load.box.appendChild(q.load.boxp);q.load.lbox=f.createElement("div");q.load.lbox.className="pnlm-lbox";q.load.lbox.innerHTML='<div class="pnlm-loading"></div>';q.load.box.appendChild(q.load.lbox);q.load.lbar=f.createElement("div");q.load.lbar.className="pnlm-lbar";q.load.lbarFill=f.createElement("div");q.load.lbarFill.className="pnlm-lbar-fill";q.load.lbar.appendChild(q.load.lbarFill);q.load.box.appendChild(q.load.lbar);q.load.msg=
f.createElement("p");q.load.msg.className="pnlm-lmsg";q.load.box.appendChild(q.load.msg);J.appendChild(q.load.box);q.errorMsg=f.createElement("div");q.errorMsg.className="pnlm-error-msg pnlm-info-box";J.appendChild(q.errorMsg);var u={};u.container=f.createElement("div");u.container.className="pnlm-controls-container";J.appendChild(u.container);u.load=f.createElement("div");u.load.className="pnlm-load-button";u.load.addEventListener("click",function(){g();x()});J.appendChild(u.load);u.zoom=f.createElement("div");
u.zoom.className="pnlm-zoom-controls pnlm-controls";u.zoomIn=f.createElement("div");u.zoomIn.className="pnlm-zoom-in pnlm-sprite pnlm-control";u.zoomIn.addEventListener("click",function(){K&&(n(b.hfov-5),D())});u.zoom.appendChild(u.zoomIn);u.zoomOut=f.createElement("div");u.zoomOut.className="pnlm-zoom-out pnlm-sprite pnlm-control";u.zoomOut.addEventListener("click",function(){K&&(n(b.hfov+5),D())});u.zoom.appendChild(u.zoomOut);u.container.appendChild(u.zoom);u.fullscreen=f.createElement("div");
u.fullscreen.addEventListener("click",e);u.fullscreen.className="pnlm-fullscreen-toggle-button pnlm-sprite pnlm-fullscreen-toggle-button-inactive pnlm-controls pnlm-control";(f.fullscreenEnabled||f.mozFullScreenEnabled||f.webkitFullscreenEnabled||f.msFullscreenEnabled)&&u.container.appendChild(u.fullscreen);u.orientation=f.createElement("div");u.orientation.addEventListener("click",function(a){Y?Fa():C()});u.orientation.addEventListener("mousedown",function(a){a.stopPropagation()});u.orientation.addEventListener("touchstart",
function(a){a.stopPropagation()});u.orientation.addEventListener("pointerdown",function(a){a.stopPropagation()});u.orientation.className="pnlm-orientation-button pnlm-orientation-button-inactive pnlm-sprite pnlm-controls pnlm-control";var ua,Za=!1;F.DeviceOrientationEvent?F.addEventListener("deviceorientation",ra):ua=!1;var Ka=f.createElement("div");Ka.className="pnlm-compass pnlm-controls pnlm-control";J.appendChild(Ka);l.firstScene?k(l.firstScene):l.default&&l.default.firstScene?k(l.default.firstScene):
k(null);g(!0);var ma=[],Ca=[];aa.prototype.multiply=function(a){return new aa(this.w*a.w-this.x*a.x-this.y*a.y-this.z*a.z,this.x*a.w+this.w*a.x+this.y*a.z-this.z*a.y,this.y*a.w+this.w*a.y+this.z*a.x-this.x*a.z,this.z*a.w+this.w*a.z+this.x*a.y-this.y*a.x)};aa.prototype.toEulerAngles=function(){var a=Math.atan2(2*(this.w*this.x+this.y*this.z),1-2*(this.x*this.x+this.y*this.y)),b=Math.asin(2*(this.w*this.y-this.z*this.x)),c=Math.atan2(2*(this.w*this.z+this.x*this.y),1-2*(this.y*this.y+this.z*this.z));
return[a,b,c]};this.isLoaded=function(){return Boolean(K)};this.getPitch=function(){return b.pitch};this.setPitch=function(a,c,d,e){O=Date.now();if(1E-6>=Math.abs(a-b.pitch))return"function"==typeof d&&d(e),this;(c=c==p?1E3:Number(c))?(P.pitch={startTime:Date.now(),startPosition:b.pitch,endPosition:a,duration:c},"function"==typeof d&&setTimeout(function(){d(e)},c)):b.pitch=a;D();return this};this.getPitchBounds=function(){return[b.minPitch,b.maxPitch]};this.setPitchBounds=function(a){b.minPitch=Math.max(-90,
Math.min(a[0],90));b.maxPitch=Math.max(-90,Math.min(a[1],90));return this};this.getYaw=function(){return b.yaw};this.setYaw=function(a,c,d,e){O=Date.now();if(1E-6>=Math.abs(a-b.yaw))return"function"==typeof d&&d(e),this;c=c==p?1E3:Number(c);a=(a+180)%360-180;c?(180<b.yaw-a?a+=360:180<a-b.yaw&&(a-=360),P.yaw={startTime:Date.now(),startPosition:b.yaw,endPosition:a,duration:c},"function"==typeof d&&setTimeout(function(){d(e)},c)):b.yaw=a;D();return this};this.getYawBounds=function(){return[b.minYaw,
b.maxYaw]};this.setYawBounds=function(a){b.minYaw=Math.max(-180,Math.min(a[0],180));b.maxYaw=Math.max(-180,Math.min(a[1],180));return this};this.getHfov=function(){return b.hfov};this.setHfov=function(a,c,d,e){O=Date.now();if(1E-6>=Math.abs(a-b.hfov))return"function"==typeof d&&d(e),this;(c=c==p?1E3:Number(c))?(P.hfov={startTime:Date.now(),startPosition:b.hfov,endPosition:z(a),duration:c},"function"==typeof d&&setTimeout(function(){d(e)},c)):n(a);D();return this};this.getHfovBounds=function(){return[b.minHfov,
b.maxHfov]};this.setHfovBounds=function(a){b.minHfov=Math.max(0,a[0]);b.maxHfov=Math.max(0,a[1]);return this};this.lookAt=function(a,c,d,e,f,g){e=e==p?1E3:Number(e);a!==p&&1E-6<Math.abs(a-b.pitch)&&(this.setPitch(a,e,f,g),f=p);c!==p&&1E-6<Math.abs(c-b.yaw)&&(this.setYaw(c,e,f,g),f=p);d!==p&&1E-6<Math.abs(d-b.hfov)&&(this.setHfov(d,e,f,g),f=p);"function"==typeof f&&f(g);return this};this.getNorthOffset=function(){return b.northOffset};this.setNorthOffset=function(a){b.northOffset=Math.min(360,Math.max(0,
a));D();return this};this.getHorizonRoll=function(){return b.horizonRoll};this.setHorizonRoll=function(a){b.horizonRoll=Math.min(90,Math.max(-90,a));B.setPose(b.horizonPitch*Math.PI/180,b.horizonRoll*Math.PI/180);D();return this};this.getHorizonPitch=function(){return b.horizonPitch};this.setHorizonPitch=function(a){b.horizonPitch=Math.min(90,Math.max(-90,a));B.setPose(b.horizonPitch*Math.PI/180,b.horizonRoll*Math.PI/180);D();return this};this.startAutoRotate=function(a){a=a||X||1;b.autoRotate=a;
ga.lookAt(Ia,p,za,3E3);D();return this};this.stopAutoRotate=function(){X=b.autoRotate?b.autoRotate:X;b.autoRotate=!1;b.autoRotateInactivityDelay=-1;return this};this.stopMovement=function(){Ea();w={yaw:0,pitch:0,hfov:0}};this.getRenderer=function(){return B};this.setUpdate=function(a){Na=!0===a;B===p?ta():D();return this};this.mouseEventToCoords=function(a){return pa(a)};this.loadScene=function(a,b,c,d){!1!==K&&Sa(a,b,c,d);return this};this.getScene=function(){return b.scene};this.addScene=function(a,
b){l.scenes[a]=b;return this};this.removeScene=function(a){if(b.scene===a||!l.scenes.hasOwnProperty(a))return!1;delete l.scenes[a];return!0};this.toggleFullscreen=function(){e();return this};this.getConfig=function(){return b};this.getContainer=function(){return t};this.addHotSpot=function(a,c){if(c===p&&b.scene===p)b.hotSpots.push(a);else{var d=c!==p?c:b.scene;if(l.scenes.hasOwnProperty(d))l.scenes[d].hasOwnProperty("hotSpots")||(l.scenes[d].hotSpots=[],d==b.scene&&(b.hotSpots=l.scenes[d].hotSpots)),
l.scenes[d].hotSpots.push(a);else throw"Invalid scene ID!";}if(c===p||b.scene==c)G(a),K&&L(a);return this};this.removeHotSpot=function(a,c){if(c===p||b.scene==c){if(!b.hotSpots)return!1;for(var d=0;d<b.hotSpots.length;d++)if(b.hotSpots[d].hasOwnProperty("id")&&b.hotSpots[d].id===a){for(var e=b.hotSpots[d].div;e.parentNode!=N;)e=e.parentNode;N.removeChild(e);delete b.hotSpots[d].div;b.hotSpots.splice(d,1);return!0}}else if(l.scenes.hasOwnProperty(c)){if(!l.scenes[c].hasOwnProperty("hotSpots"))return!1;
for(d=0;d<l.scenes[c].hotSpots.length;d++)if(l.scenes[c].hotSpots[d].hasOwnProperty("id")&&l.scenes[c].hotSpots[d].id===a)return l.scenes[c].hotSpots.splice(d,1),!0}else return!1};this.resize=function(){B&&ka()};this.isLoaded=function(){return K};this.isOrientationSupported=function(){return ua||!1};this.stopOrientation=function(){Fa()};this.startOrientation=function(){ua&&C()};this.isOrientationActive=function(){return Boolean(Y)};this.on=function(a,b){T[a]=T[a]||[];T[a].push(b);return this};this.off=
function(a,b){if(!a)return T={},this;if(b){var c=T[a].indexOf(b);0<=c&&T[a].splice(c,1);0==T[a].length&&delete T[a]}else delete T[a];return this};this.destroy=function(){B&&B.destroy();Ta&&(f.removeEventListener("mousemove",Ga,!1),f.removeEventListener("mouseup",wa,!1),t.removeEventListener("mozfullscreenchange",s,!1),t.removeEventListener("webkitfullscreenchange",s,!1),t.removeEventListener("msfullscreenchange",s,!1),t.removeEventListener("fullscreenchange",s,!1),F.removeEventListener("resize",ka,
!1),F.removeEventListener("orientationchange",ka,!1),t.removeEventListener("keydown",$,!1),t.removeEventListener("keyup",xa,!1),t.removeEventListener("blur",S,!1),f.removeEventListener("mouseleave",wa,!1));t.innerHTML="";t.classList.remove("pnlm-container")}}return{viewer:function(f,l){return new ja(f,l)}}}(window,document);

},{}],178:[function(require,module,exports){
'use strict';

module.exports = require('./lib')

},{"./lib":183}],179:[function(require,module,exports){
'use strict';

var asap = require('asap/raw');

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}

},{"asap/raw":2}],180:[function(require,module,exports){
'use strict';

var Promise = require('./core.js');

module.exports = Promise;
Promise.prototype.done = function (onFulfilled, onRejected) {
  var self = arguments.length ? this.then.apply(this, arguments) : this;
  self.then(null, function (err) {
    setTimeout(function () {
      throw err;
    }, 0);
  });
};

},{"./core.js":179}],181:[function(require,module,exports){
'use strict';

//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = require('./core.js');

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};

},{"./core.js":179}],182:[function(require,module,exports){
'use strict';

var Promise = require('./core.js');

module.exports = Promise;
Promise.prototype['finally'] = function (f) {
  return this.then(function (value) {
    return Promise.resolve(f()).then(function () {
      return value;
    });
  }, function (err) {
    return Promise.resolve(f()).then(function () {
      throw err;
    });
  });
};

},{"./core.js":179}],183:[function(require,module,exports){
'use strict';

module.exports = require('./core.js');
require('./done.js');
require('./finally.js');
require('./es6-extensions.js');
require('./node-extensions.js');
require('./synchronous.js');

},{"./core.js":179,"./done.js":180,"./es6-extensions.js":181,"./finally.js":182,"./node-extensions.js":184,"./synchronous.js":185}],184:[function(require,module,exports){
'use strict';

// This file contains then/promise specific extensions that are only useful
// for node.js interop

var Promise = require('./core.js');
var asap = require('asap');

module.exports = Promise;

/* Static Functions */

Promise.denodeify = function (fn, argumentCount) {
  if (
    typeof argumentCount === 'number' && argumentCount !== Infinity
  ) {
    return denodeifyWithCount(fn, argumentCount);
  } else {
    return denodeifyWithoutCount(fn);
  }
};

var callbackFn = (
  'function (err, res) {' +
  'if (err) { rj(err); } else { rs(res); }' +
  '}'
);
function denodeifyWithCount(fn, argumentCount) {
  var args = [];
  for (var i = 0; i < argumentCount; i++) {
    args.push('a' + i);
  }
  var body = [
    'return function (' + args.join(',') + ') {',
    'var self = this;',
    'return new Promise(function (rs, rj) {',
    'var res = fn.call(',
    ['self'].concat(args).concat([callbackFn]).join(','),
    ');',
    'if (res &&',
    '(typeof res === "object" || typeof res === "function") &&',
    'typeof res.then === "function"',
    ') {rs(res);}',
    '});',
    '};'
  ].join('');
  return Function(['Promise', 'fn'], body)(Promise, fn);
}
function denodeifyWithoutCount(fn) {
  var fnLength = Math.max(fn.length - 1, 3);
  var args = [];
  for (var i = 0; i < fnLength; i++) {
    args.push('a' + i);
  }
  var body = [
    'return function (' + args.join(',') + ') {',
    'var self = this;',
    'var args;',
    'var argLength = arguments.length;',
    'if (arguments.length > ' + fnLength + ') {',
    'args = new Array(arguments.length + 1);',
    'for (var i = 0; i < arguments.length; i++) {',
    'args[i] = arguments[i];',
    '}',
    '}',
    'return new Promise(function (rs, rj) {',
    'var cb = ' + callbackFn + ';',
    'var res;',
    'switch (argLength) {',
    args.concat(['extra']).map(function (_, index) {
      return (
        'case ' + (index) + ':' +
        'res = fn.call(' + ['self'].concat(args.slice(0, index)).concat('cb').join(',') + ');' +
        'break;'
      );
    }).join(''),
    'default:',
    'args[argLength] = cb;',
    'res = fn.apply(self, args);',
    '}',
    
    'if (res &&',
    '(typeof res === "object" || typeof res === "function") &&',
    'typeof res.then === "function"',
    ') {rs(res);}',
    '});',
    '};'
  ].join('');

  return Function(
    ['Promise', 'fn'],
    body
  )(Promise, fn);
}

Promise.nodeify = function (fn) {
  return function () {
    var args = Array.prototype.slice.call(arguments);
    var callback =
      typeof args[args.length - 1] === 'function' ? args.pop() : null;
    var ctx = this;
    try {
      return fn.apply(this, arguments).nodeify(callback, ctx);
    } catch (ex) {
      if (callback === null || typeof callback == 'undefined') {
        return new Promise(function (resolve, reject) {
          reject(ex);
        });
      } else {
        asap(function () {
          callback.call(ctx, ex);
        })
      }
    }
  }
};

Promise.prototype.nodeify = function (callback, ctx) {
  if (typeof callback != 'function') return this;

  this.then(function (value) {
    asap(function () {
      callback.call(ctx, null, value);
    });
  }, function (err) {
    asap(function () {
      callback.call(ctx, err);
    });
  });
};

},{"./core.js":179,"asap":1}],185:[function(require,module,exports){
'use strict';

var Promise = require('./core.js');

module.exports = Promise;
Promise.enableSynchronous = function () {
  Promise.prototype.isPending = function() {
    return this.getState() == 0;
  };

  Promise.prototype.isFulfilled = function() {
    return this.getState() == 1;
  };

  Promise.prototype.isRejected = function() {
    return this.getState() == 2;
  };

  Promise.prototype.getValue = function () {
    if (this._83 === 3) {
      return this._18.getValue();
    }

    if (!this.isFulfilled()) {
      throw new Error('Cannot get a value of an unfulfilled promise.');
    }

    return this._18;
  };

  Promise.prototype.getReason = function () {
    if (this._83 === 3) {
      return this._18.getReason();
    }

    if (!this.isRejected()) {
      throw new Error('Cannot get a rejection reason of a non-rejected promise.');
    }

    return this._18;
  };

  Promise.prototype.getState = function () {
    if (this._83 === 3) {
      return this._18.getState();
    }
    if (this._83 === -1 || this._83 === -2) {
      return 0;
    }

    return this._83;
  };
};

Promise.disableSynchronous = function() {
  Promise.prototype.isPending = undefined;
  Promise.prototype.isFulfilled = undefined;
  Promise.prototype.isRejected = undefined;
  Promise.prototype.getValue = undefined;
  Promise.prototype.getReason = undefined;
  Promise.prototype.getState = undefined;
};

},{"./core.js":179}],186:[function(require,module,exports){
function Agent() {
  this._defaults = [];
}

["use", "on", "once", "set", "query", "type", "accept", "auth", "withCredentials", "sortQuery", "retry", "ok", "redirects",
 "timeout", "buffer", "serialize", "parse", "ca", "key", "pfx", "cert"].forEach(function(fn) {
  /** Default setting for all requests from this agent */
  Agent.prototype[fn] = function(/*varargs*/) {
    this._defaults.push({fn:fn, arguments:arguments});
    return this;
  }
});

Agent.prototype._setDefaults = function(req) {
    this._defaults.forEach(function(def) {
      req[def.fn].apply(req, def.arguments);
    });
};

module.exports = Agent;

},{}],187:[function(require,module,exports){
/**
 * Root reference for iframes.
 */

var root;
if (typeof window !== 'undefined') { // Browser window
  root = window;
} else if (typeof self !== 'undefined') { // Web Worker
  root = self;
} else { // Other environments
  console.warn("Using browser-only version of superagent in non-browser environment");
  root = this;
}

var Emitter = require('component-emitter');
var RequestBase = require('./request-base');
var isObject = require('./is-object');
var ResponseBase = require('./response-base');
var Agent = require('./agent-base');

/**
 * Noop.
 */

function noop(){};

/**
 * Expose `request`.
 */

var request = exports = module.exports = function(method, url) {
  // callback
  if ('function' == typeof url) {
    return new exports.Request('GET', method).end(url);
  }

  // url first
  if (1 == arguments.length) {
    return new exports.Request('GET', method);
  }

  return new exports.Request(method, url);
}

exports.Request = Request;

/**
 * Determine XHR.
 */

request.getXHR = function () {
  if (root.XMLHttpRequest
      && (!root.location || 'file:' != root.location.protocol
          || !root.ActiveXObject)) {
    return new XMLHttpRequest;
  } else {
    try { return new ActiveXObject('Microsoft.XMLHTTP'); } catch(e) {}
    try { return new ActiveXObject('Msxml2.XMLHTTP.6.0'); } catch(e) {}
    try { return new ActiveXObject('Msxml2.XMLHTTP.3.0'); } catch(e) {}
    try { return new ActiveXObject('Msxml2.XMLHTTP'); } catch(e) {}
  }
  throw Error("Browser-only version of superagent could not find XHR");
};

/**
 * Removes leading and trailing whitespace, added to support IE.
 *
 * @param {String} s
 * @return {String}
 * @api private
 */

var trim = ''.trim
  ? function(s) { return s.trim(); }
  : function(s) { return s.replace(/(^\s*|\s*$)/g, ''); };

/**
 * Serialize the given `obj`.
 *
 * @param {Object} obj
 * @return {String}
 * @api private
 */

function serialize(obj) {
  if (!isObject(obj)) return obj;
  var pairs = [];
  for (var key in obj) {
    pushEncodedKeyValuePair(pairs, key, obj[key]);
  }
  return pairs.join('&');
}

/**
 * Helps 'serialize' with serializing arrays.
 * Mutates the pairs array.
 *
 * @param {Array} pairs
 * @param {String} key
 * @param {Mixed} val
 */

function pushEncodedKeyValuePair(pairs, key, val) {
  if (val != null) {
    if (Array.isArray(val)) {
      val.forEach(function(v) {
        pushEncodedKeyValuePair(pairs, key, v);
      });
    } else if (isObject(val)) {
      for(var subkey in val) {
        pushEncodedKeyValuePair(pairs, key + '[' + subkey + ']', val[subkey]);
      }
    } else {
      pairs.push(encodeURIComponent(key)
        + '=' + encodeURIComponent(val));
    }
  } else if (val === null) {
    pairs.push(encodeURIComponent(key));
  }
}

/**
 * Expose serialization method.
 */

request.serializeObject = serialize;

/**
  * Parse the given x-www-form-urlencoded `str`.
  *
  * @param {String} str
  * @return {Object}
  * @api private
  */

function parseString(str) {
  var obj = {};
  var pairs = str.split('&');
  var pair;
  var pos;

  for (var i = 0, len = pairs.length; i < len; ++i) {
    pair = pairs[i];
    pos = pair.indexOf('=');
    if (pos == -1) {
      obj[decodeURIComponent(pair)] = '';
    } else {
      obj[decodeURIComponent(pair.slice(0, pos))] =
        decodeURIComponent(pair.slice(pos + 1));
    }
  }

  return obj;
}

/**
 * Expose parser.
 */

request.parseString = parseString;

/**
 * Default MIME type map.
 *
 *     superagent.types.xml = 'application/xml';
 *
 */

request.types = {
  html: 'text/html',
  json: 'application/json',
  xml: 'text/xml',
  urlencoded: 'application/x-www-form-urlencoded',
  'form': 'application/x-www-form-urlencoded',
  'form-data': 'application/x-www-form-urlencoded'
};

/**
 * Default serialization map.
 *
 *     superagent.serialize['application/xml'] = function(obj){
 *       return 'generated xml here';
 *     };
 *
 */

request.serialize = {
  'application/x-www-form-urlencoded': serialize,
  'application/json': JSON.stringify
};

/**
  * Default parsers.
  *
  *     superagent.parse['application/xml'] = function(str){
  *       return { object parsed from str };
  *     };
  *
  */

request.parse = {
  'application/x-www-form-urlencoded': parseString,
  'application/json': JSON.parse
};

/**
 * Parse the given header `str` into
 * an object containing the mapped fields.
 *
 * @param {String} str
 * @return {Object}
 * @api private
 */

function parseHeader(str) {
  var lines = str.split(/\r?\n/);
  var fields = {};
  var index;
  var line;
  var field;
  var val;

  for (var i = 0, len = lines.length; i < len; ++i) {
    line = lines[i];
    index = line.indexOf(':');
    if (index === -1) { // could be empty line, just skip it
      continue;
    }
    field = line.slice(0, index).toLowerCase();
    val = trim(line.slice(index + 1));
    fields[field] = val;
  }

  return fields;
}

/**
 * Check if `mime` is json or has +json structured syntax suffix.
 *
 * @param {String} mime
 * @return {Boolean}
 * @api private
 */

function isJSON(mime) {
  // should match /json or +json
  // but not /json-seq
  return /[\/+]json($|[^-\w])/.test(mime);
}

/**
 * Initialize a new `Response` with the given `xhr`.
 *
 *  - set flags (.ok, .error, etc)
 *  - parse header
 *
 * Examples:
 *
 *  Aliasing `superagent` as `request` is nice:
 *
 *      request = superagent;
 *
 *  We can use the promise-like API, or pass callbacks:
 *
 *      request.get('/').end(function(res){});
 *      request.get('/', function(res){});
 *
 *  Sending data can be chained:
 *
 *      request
 *        .post('/user')
 *        .send({ name: 'tj' })
 *        .end(function(res){});
 *
 *  Or passed to `.send()`:
 *
 *      request
 *        .post('/user')
 *        .send({ name: 'tj' }, function(res){});
 *
 *  Or passed to `.post()`:
 *
 *      request
 *        .post('/user', { name: 'tj' })
 *        .end(function(res){});
 *
 * Or further reduced to a single call for simple cases:
 *
 *      request
 *        .post('/user', { name: 'tj' }, function(res){});
 *
 * @param {XMLHTTPRequest} xhr
 * @param {Object} options
 * @api private
 */

function Response(req) {
  this.req = req;
  this.xhr = this.req.xhr;
  // responseText is accessible only if responseType is '' or 'text' and on older browsers
  this.text = ((this.req.method !='HEAD' && (this.xhr.responseType === '' || this.xhr.responseType === 'text')) || typeof this.xhr.responseType === 'undefined')
     ? this.xhr.responseText
     : null;
  this.statusText = this.req.xhr.statusText;
  var status = this.xhr.status;
  // handle IE9 bug: http://stackoverflow.com/questions/10046972/msie-returns-status-code-of-1223-for-ajax-request
  if (status === 1223) {
    status = 204;
  }
  this._setStatusProperties(status);
  this.header = this.headers = parseHeader(this.xhr.getAllResponseHeaders());
  // getAllResponseHeaders sometimes falsely returns "" for CORS requests, but
  // getResponseHeader still works. so we get content-type even if getting
  // other headers fails.
  this.header['content-type'] = this.xhr.getResponseHeader('content-type');
  this._setHeaderProperties(this.header);

  if (null === this.text && req._responseType) {
    this.body = this.xhr.response;
  } else {
    this.body = this.req.method != 'HEAD'
      ? this._parseBody(this.text ? this.text : this.xhr.response)
      : null;
  }
}

ResponseBase(Response.prototype);

/**
 * Parse the given body `str`.
 *
 * Used for auto-parsing of bodies. Parsers
 * are defined on the `superagent.parse` object.
 *
 * @param {String} str
 * @return {Mixed}
 * @api private
 */

Response.prototype._parseBody = function(str) {
  var parse = request.parse[this.type];
  if (this.req._parser) {
    return this.req._parser(this, str);
  }
  if (!parse && isJSON(this.type)) {
    parse = request.parse['application/json'];
  }
  return parse && str && (str.length || str instanceof Object)
    ? parse(str)
    : null;
};

/**
 * Return an `Error` representative of this response.
 *
 * @return {Error}
 * @api public
 */

Response.prototype.toError = function(){
  var req = this.req;
  var method = req.method;
  var url = req.url;

  var msg = 'cannot ' + method + ' ' + url + ' (' + this.status + ')';
  var err = new Error(msg);
  err.status = this.status;
  err.method = method;
  err.url = url;

  return err;
};

/**
 * Expose `Response`.
 */

request.Response = Response;

/**
 * Initialize a new `Request` with the given `method` and `url`.
 *
 * @param {String} method
 * @param {String} url
 * @api public
 */

function Request(method, url) {
  var self = this;
  this._query = this._query || [];
  this.method = method;
  this.url = url;
  this.header = {}; // preserves header name case
  this._header = {}; // coerces header names to lowercase
  this.on('end', function(){
    var err = null;
    var res = null;

    try {
      res = new Response(self);
    } catch(e) {
      err = new Error('Parser is unable to parse the response');
      err.parse = true;
      err.original = e;
      // issue #675: return the raw response if the response parsing fails
      if (self.xhr) {
        // ie9 doesn't have 'response' property
        err.rawResponse = typeof self.xhr.responseType == 'undefined' ? self.xhr.responseText : self.xhr.response;
        // issue #876: return the http status code if the response parsing fails
        err.status = self.xhr.status ? self.xhr.status : null;
        err.statusCode = err.status; // backwards-compat only
      } else {
        err.rawResponse = null;
        err.status = null;
      }

      return self.callback(err);
    }

    self.emit('response', res);

    var new_err;
    try {
      if (!self._isResponseOK(res)) {
        new_err = new Error(res.statusText || 'Unsuccessful HTTP response');
      }
    } catch(custom_err) {
      new_err = custom_err; // ok() callback can throw
    }

    // #1000 don't catch errors from the callback to avoid double calling it
    if (new_err) {
      new_err.original = err;
      new_err.response = res;
      new_err.status = res.status;
      self.callback(new_err, res);
    } else {
      self.callback(null, res);
    }
  });
}

/**
 * Mixin `Emitter` and `RequestBase`.
 */

Emitter(Request.prototype);
RequestBase(Request.prototype);

/**
 * Set Content-Type to `type`, mapping values from `request.types`.
 *
 * Examples:
 *
 *      superagent.types.xml = 'application/xml';
 *
 *      request.post('/')
 *        .type('xml')
 *        .send(xmlstring)
 *        .end(callback);
 *
 *      request.post('/')
 *        .type('application/xml')
 *        .send(xmlstring)
 *        .end(callback);
 *
 * @param {String} type
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.type = function(type){
  this.set('Content-Type', request.types[type] || type);
  return this;
};

/**
 * Set Accept to `type`, mapping values from `request.types`.
 *
 * Examples:
 *
 *      superagent.types.json = 'application/json';
 *
 *      request.get('/agent')
 *        .accept('json')
 *        .end(callback);
 *
 *      request.get('/agent')
 *        .accept('application/json')
 *        .end(callback);
 *
 * @param {String} accept
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.accept = function(type){
  this.set('Accept', request.types[type] || type);
  return this;
};

/**
 * Set Authorization field value with `user` and `pass`.
 *
 * @param {String} user
 * @param {String} [pass] optional in case of using 'bearer' as type
 * @param {Object} options with 'type' property 'auto', 'basic' or 'bearer' (default 'basic')
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.auth = function(user, pass, options){
  if (1 === arguments.length) pass = '';
  if (typeof pass === 'object' && pass !== null) { // pass is optional and can be replaced with options
    options = pass;
    pass = '';
  }
  if (!options) {
    options = {
      type: 'function' === typeof btoa ? 'basic' : 'auto',
    };
  }

  var encoder = function(string) {
    if ('function' === typeof btoa) {
      return btoa(string);
    }
    throw new Error('Cannot use basic auth, btoa is not a function');
  };

  return this._auth(user, pass, options, encoder);
};

/**
 * Add query-string `val`.
 *
 * Examples:
 *
 *   request.get('/shoes')
 *     .query('size=10')
 *     .query({ color: 'blue' })
 *
 * @param {Object|String} val
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.query = function(val){
  if ('string' != typeof val) val = serialize(val);
  if (val) this._query.push(val);
  return this;
};

/**
 * Queue the given `file` as an attachment to the specified `field`,
 * with optional `options` (or filename).
 *
 * ``` js
 * request.post('/upload')
 *   .attach('content', new Blob(['<a id="a"><b id="b">hey!</b></a>'], { type: "text/html"}))
 *   .end(callback);
 * ```
 *
 * @param {String} field
 * @param {Blob|File} file
 * @param {String|Object} options
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.attach = function(field, file, options){
  if (file) {
    if (this._data) {
      throw Error("superagent can't mix .send() and .attach()");
    }

    this._getFormData().append(field, file, options || file.name);
  }
  return this;
};

Request.prototype._getFormData = function(){
  if (!this._formData) {
    this._formData = new root.FormData();
  }
  return this._formData;
};

/**
 * Invoke the callback with `err` and `res`
 * and handle arity check.
 *
 * @param {Error} err
 * @param {Response} res
 * @api private
 */

Request.prototype.callback = function(err, res){
  if (this._shouldRetry(err, res)) {
    return this._retry();
  }

  var fn = this._callback;
  this.clearTimeout();

  if (err) {
    if (this._maxRetries) err.retries = this._retries - 1;
    this.emit('error', err);
  }

  fn(err, res);
};

/**
 * Invoke callback with x-domain error.
 *
 * @api private
 */

Request.prototype.crossDomainError = function(){
  var err = new Error('Request has been terminated\nPossible causes: the network is offline, Origin is not allowed by Access-Control-Allow-Origin, the page is being unloaded, etc.');
  err.crossDomain = true;

  err.status = this.status;
  err.method = this.method;
  err.url = this.url;

  this.callback(err);
};

// This only warns, because the request is still likely to work
Request.prototype.buffer = Request.prototype.ca = Request.prototype.agent = function(){
  console.warn("This is not supported in browser version of superagent");
  return this;
};

// This throws, because it can't send/receive data as expected
Request.prototype.pipe = Request.prototype.write = function(){
  throw Error("Streaming is not supported in browser version of superagent");
};

/**
 * Check if `obj` is a host object,
 * we don't want to serialize these :)
 *
 * @param {Object} obj
 * @return {Boolean}
 * @api private
 */
Request.prototype._isHost = function _isHost(obj) {
  // Native objects stringify to [object File], [object Blob], [object FormData], etc.
  return obj && 'object' === typeof obj && !Array.isArray(obj) && Object.prototype.toString.call(obj) !== '[object Object]';
}

/**
 * Initiate request, invoking callback `fn(res)`
 * with an instanceof `Response`.
 *
 * @param {Function} fn
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.end = function(fn){
  if (this._endCalled) {
    console.warn("Warning: .end() was called twice. This is not supported in superagent");
  }
  this._endCalled = true;

  // store callback
  this._callback = fn || noop;

  // querystring
  this._finalizeQueryString();

  return this._end();
};

Request.prototype._end = function() {
  var self = this;
  var xhr = (this.xhr = request.getXHR());
  var data = this._formData || this._data;

  this._setTimeouts();

  // state change
  xhr.onreadystatechange = function(){
    var readyState = xhr.readyState;
    if (readyState >= 2 && self._responseTimeoutTimer) {
      clearTimeout(self._responseTimeoutTimer);
    }
    if (4 != readyState) {
      return;
    }

    // In IE9, reads to any property (e.g. status) off of an aborted XHR will
    // result in the error "Could not complete the operation due to error c00c023f"
    var status;
    try { status = xhr.status } catch(e) { status = 0; }

    if (!status) {
      if (self.timedout || self._aborted) return;
      return self.crossDomainError();
    }
    self.emit('end');
  };

  // progress
  var handleProgress = function(direction, e) {
    if (e.total > 0) {
      e.percent = e.loaded / e.total * 100;
    }
    e.direction = direction;
    self.emit('progress', e);
  };
  if (this.hasListeners('progress')) {
    try {
      xhr.onprogress = handleProgress.bind(null, 'download');
      if (xhr.upload) {
        xhr.upload.onprogress = handleProgress.bind(null, 'upload');
      }
    } catch(e) {
      // Accessing xhr.upload fails in IE from a web worker, so just pretend it doesn't exist.
      // Reported here:
      // https://connect.microsoft.com/IE/feedback/details/837245/xmlhttprequest-upload-throws-invalid-argument-when-used-from-web-worker-context
    }
  }

  // initiate request
  try {
    if (this.username && this.password) {
      xhr.open(this.method, this.url, true, this.username, this.password);
    } else {
      xhr.open(this.method, this.url, true);
    }
  } catch (err) {
    // see #1149
    return this.callback(err);
  }

  // CORS
  if (this._withCredentials) xhr.withCredentials = true;

  // body
  if (!this._formData && 'GET' != this.method && 'HEAD' != this.method && 'string' != typeof data && !this._isHost(data)) {
    // serialize stuff
    var contentType = this._header['content-type'];
    var serialize = this._serializer || request.serialize[contentType ? contentType.split(';')[0] : ''];
    if (!serialize && isJSON(contentType)) {
      serialize = request.serialize['application/json'];
    }
    if (serialize) data = serialize(data);
  }

  // set header fields
  for (var field in this.header) {
    if (null == this.header[field]) continue;

    if (this.header.hasOwnProperty(field))
      xhr.setRequestHeader(field, this.header[field]);
  }

  if (this._responseType) {
    xhr.responseType = this._responseType;
  }

  // send stuff
  this.emit('request', this);

  // IE11 xhr.send(undefined) sends 'undefined' string as POST payload (instead of nothing)
  // We need null here if data is undefined
  xhr.send(typeof data !== 'undefined' ? data : null);
  return this;
};

request.agent = function() {
  return new Agent();
};

["GET", "POST", "OPTIONS", "PATCH", "PUT", "DELETE"].forEach(function(method) {
  Agent.prototype[method.toLowerCase()] = function(url, fn) {
    var req = new request.Request(method, url);
    this._setDefaults(req);
    if (fn) {
      req.end(fn);
    }
    return req;
  };
});

Agent.prototype.del = Agent.prototype['delete'];

/**
 * GET `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.get = function(url, data, fn) {
  var req = request('GET', url);
  if ('function' == typeof data) (fn = data), (data = null);
  if (data) req.query(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * HEAD `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.head = function(url, data, fn) {
  var req = request('HEAD', url);
  if ('function' == typeof data) (fn = data), (data = null);
  if (data) req.query(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * OPTIONS query to `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.options = function(url, data, fn) {
  var req = request('OPTIONS', url);
  if ('function' == typeof data) (fn = data), (data = null);
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * DELETE `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed} [data]
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

function del(url, data, fn) {
  var req = request('DELETE', url);
  if ('function' == typeof data) (fn = data), (data = null);
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
}

request['del'] = del;
request['delete'] = del;

/**
 * PATCH `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed} [data]
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.patch = function(url, data, fn) {
  var req = request('PATCH', url);
  if ('function' == typeof data) (fn = data), (data = null);
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * POST `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed} [data]
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.post = function(url, data, fn) {
  var req = request('POST', url);
  if ('function' == typeof data) (fn = data), (data = null);
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * PUT `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.put = function(url, data, fn) {
  var req = request('PUT', url);
  if ('function' == typeof data) (fn = data), (data = null);
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};

},{"./agent-base":186,"./is-object":188,"./request-base":189,"./response-base":190,"component-emitter":192}],188:[function(require,module,exports){
'use strict';

/**
 * Check if `obj` is an object.
 *
 * @param {Object} obj
 * @return {Boolean}
 * @api private
 */

function isObject(obj) {
  return null !== obj && 'object' === typeof obj;
}

module.exports = isObject;

},{}],189:[function(require,module,exports){
'use strict';

/**
 * Module of mixed-in functions shared between node and client code
 */
var isObject = require('./is-object');

/**
 * Expose `RequestBase`.
 */

module.exports = RequestBase;

/**
 * Initialize a new `RequestBase`.
 *
 * @api public
 */

function RequestBase(obj) {
  if (obj) return mixin(obj);
}

/**
 * Mixin the prototype properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */

function mixin(obj) {
  for (var key in RequestBase.prototype) {
    obj[key] = RequestBase.prototype[key];
  }
  return obj;
}

/**
 * Clear previous timeout.
 *
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.clearTimeout = function _clearTimeout(){
  clearTimeout(this._timer);
  clearTimeout(this._responseTimeoutTimer);
  delete this._timer;
  delete this._responseTimeoutTimer;
  return this;
};

/**
 * Override default response body parser
 *
 * This function will be called to convert incoming data into request.body
 *
 * @param {Function}
 * @api public
 */

RequestBase.prototype.parse = function parse(fn){
  this._parser = fn;
  return this;
};

/**
 * Set format of binary response body.
 * In browser valid formats are 'blob' and 'arraybuffer',
 * which return Blob and ArrayBuffer, respectively.
 *
 * In Node all values result in Buffer.
 *
 * Examples:
 *
 *      req.get('/')
 *        .responseType('blob')
 *        .end(callback);
 *
 * @param {String} val
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.responseType = function(val){
  this._responseType = val;
  return this;
};

/**
 * Override default request body serializer
 *
 * This function will be called to convert data set via .send or .attach into payload to send
 *
 * @param {Function}
 * @api public
 */

RequestBase.prototype.serialize = function serialize(fn){
  this._serializer = fn;
  return this;
};

/**
 * Set timeouts.
 *
 * - response timeout is time between sending request and receiving the first byte of the response. Includes DNS and connection time.
 * - deadline is the time from start of the request to receiving response body in full. If the deadline is too short large files may not load at all on slow connections.
 *
 * Value of 0 or false means no timeout.
 *
 * @param {Number|Object} ms or {response, deadline}
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.timeout = function timeout(options){
  if (!options || 'object' !== typeof options) {
    this._timeout = options;
    this._responseTimeout = 0;
    return this;
  }

  for(var option in options) {
    switch(option) {
      case 'deadline':
        this._timeout = options.deadline;
        break;
      case 'response':
        this._responseTimeout = options.response;
        break;
      default:
        console.warn("Unknown timeout option", option);
    }
  }
  return this;
};

/**
 * Set number of retry attempts on error.
 *
 * Failed requests will be retried 'count' times if timeout or err.code >= 500.
 *
 * @param {Number} count
 * @param {Function} [fn]
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.retry = function retry(count, fn){
  // Default to 1 if no count passed or true
  if (arguments.length === 0 || count === true) count = 1;
  if (count <= 0) count = 0;
  this._maxRetries = count;
  this._retries = 0;
  this._retryCallback = fn;
  return this;
};

var ERROR_CODES = [
  'ECONNRESET',
  'ETIMEDOUT',
  'EADDRINFO',
  'ESOCKETTIMEDOUT'
];

/**
 * Determine if a request should be retried.
 * (Borrowed from segmentio/superagent-retry)
 *
 * @param {Error} err
 * @param {Response} [res]
 * @returns {Boolean}
 */
RequestBase.prototype._shouldRetry = function(err, res) {
  if (!this._maxRetries || this._retries++ >= this._maxRetries) {
    return false;
  }
  if (this._retryCallback) {
    try {
      var override = this._retryCallback(err, res);
      if (override === true) return true;
      if (override === false) return false;
      // undefined falls back to defaults
    } catch(e) {
      console.error(e);
    }
  }
  if (res && res.status && res.status >= 500 && res.status != 501) return true;
  if (err) {
    if (err.code && ~ERROR_CODES.indexOf(err.code)) return true;
    // Superagent timeout
    if (err.timeout && err.code == 'ECONNABORTED') return true;
    if (err.crossDomain) return true;
  }
  return false;
};

/**
 * Retry request
 *
 * @return {Request} for chaining
 * @api private
 */

RequestBase.prototype._retry = function() {

  this.clearTimeout();

  // node
  if (this.req) {
    this.req = null;
    this.req = this.request();
  }

  this._aborted = false;
  this.timedout = false;

  return this._end();
};

/**
 * Promise support
 *
 * @param {Function} resolve
 * @param {Function} [reject]
 * @return {Request}
 */

RequestBase.prototype.then = function then(resolve, reject) {
  if (!this._fullfilledPromise) {
    var self = this;
    if (this._endCalled) {
      console.warn("Warning: superagent request was sent twice, because both .end() and .then() were called. Never call .end() if you use promises");
    }
    this._fullfilledPromise = new Promise(function(innerResolve, innerReject) {
      self.end(function(err, res) {
        if (err) innerReject(err);
        else innerResolve(res);
      });
    });
  }
  return this._fullfilledPromise.then(resolve, reject);
};

RequestBase.prototype['catch'] = function(cb) {
  return this.then(undefined, cb);
};

/**
 * Allow for extension
 */

RequestBase.prototype.use = function use(fn) {
  fn(this);
  return this;
};

RequestBase.prototype.ok = function(cb) {
  if ('function' !== typeof cb) throw Error("Callback required");
  this._okCallback = cb;
  return this;
};

RequestBase.prototype._isResponseOK = function(res) {
  if (!res) {
    return false;
  }

  if (this._okCallback) {
    return this._okCallback(res);
  }

  return res.status >= 200 && res.status < 300;
};

/**
 * Get request header `field`.
 * Case-insensitive.
 *
 * @param {String} field
 * @return {String}
 * @api public
 */

RequestBase.prototype.get = function(field){
  return this._header[field.toLowerCase()];
};

/**
 * Get case-insensitive header `field` value.
 * This is a deprecated internal API. Use `.get(field)` instead.
 *
 * (getHeader is no longer used internally by the superagent code base)
 *
 * @param {String} field
 * @return {String}
 * @api private
 * @deprecated
 */

RequestBase.prototype.getHeader = RequestBase.prototype.get;

/**
 * Set header `field` to `val`, or multiple fields with one object.
 * Case-insensitive.
 *
 * Examples:
 *
 *      req.get('/')
 *        .set('Accept', 'application/json')
 *        .set('X-API-Key', 'foobar')
 *        .end(callback);
 *
 *      req.get('/')
 *        .set({ Accept: 'application/json', 'X-API-Key': 'foobar' })
 *        .end(callback);
 *
 * @param {String|Object} field
 * @param {String} val
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.set = function(field, val){
  if (isObject(field)) {
    for (var key in field) {
      this.set(key, field[key]);
    }
    return this;
  }
  this._header[field.toLowerCase()] = val;
  this.header[field] = val;
  return this;
};

/**
 * Remove header `field`.
 * Case-insensitive.
 *
 * Example:
 *
 *      req.get('/')
 *        .unset('User-Agent')
 *        .end(callback);
 *
 * @param {String} field
 */
RequestBase.prototype.unset = function(field){
  delete this._header[field.toLowerCase()];
  delete this.header[field];
  return this;
};

/**
 * Write the field `name` and `val`, or multiple fields with one object
 * for "multipart/form-data" request bodies.
 *
 * ``` js
 * request.post('/upload')
 *   .field('foo', 'bar')
 *   .end(callback);
 *
 * request.post('/upload')
 *   .field({ foo: 'bar', baz: 'qux' })
 *   .end(callback);
 * ```
 *
 * @param {String|Object} name
 * @param {String|Blob|File|Buffer|fs.ReadStream} val
 * @return {Request} for chaining
 * @api public
 */
RequestBase.prototype.field = function(name, val) {
  // name should be either a string or an object.
  if (null === name || undefined === name) {
    throw new Error('.field(name, val) name can not be empty');
  }

  if (this._data) {
    console.error(".field() can't be used if .send() is used. Please use only .send() or only .field() & .attach()");
  }

  if (isObject(name)) {
    for (var key in name) {
      this.field(key, name[key]);
    }
    return this;
  }

  if (Array.isArray(val)) {
    for (var i in val) {
      this.field(name, val[i]);
    }
    return this;
  }

  // val should be defined now
  if (null === val || undefined === val) {
    throw new Error('.field(name, val) val can not be empty');
  }
  if ('boolean' === typeof val) {
    val = '' + val;
  }
  this._getFormData().append(name, val);
  return this;
};

/**
 * Abort the request, and clear potential timeout.
 *
 * @return {Request}
 * @api public
 */
RequestBase.prototype.abort = function(){
  if (this._aborted) {
    return this;
  }
  this._aborted = true;
  this.xhr && this.xhr.abort(); // browser
  this.req && this.req.abort(); // node
  this.clearTimeout();
  this.emit('abort');
  return this;
};

RequestBase.prototype._auth = function(user, pass, options, base64Encoder) {
  switch (options.type) {
    case 'basic':
      this.set('Authorization', 'Basic ' + base64Encoder(user + ':' + pass));
      break;

    case 'auto':
      this.username = user;
      this.password = pass;
      break;

    case 'bearer': // usage would be .auth(accessToken, { type: 'bearer' })
      this.set('Authorization', 'Bearer ' + user);
      break;
  }
  return this;
};

/**
 * Enable transmission of cookies with x-domain requests.
 *
 * Note that for this to work the origin must not be
 * using "Access-Control-Allow-Origin" with a wildcard,
 * and also must set "Access-Control-Allow-Credentials"
 * to "true".
 *
 * @api public
 */

RequestBase.prototype.withCredentials = function(on) {
  // This is browser-only functionality. Node side is no-op.
  if (on == undefined) on = true;
  this._withCredentials = on;
  return this;
};

/**
 * Set the max redirects to `n`. Does noting in browser XHR implementation.
 *
 * @param {Number} n
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.redirects = function(n){
  this._maxRedirects = n;
  return this;
};

/**
 * Maximum size of buffered response body, in bytes. Counts uncompressed size.
 * Default 200MB.
 *
 * @param {Number} n
 * @return {Request} for chaining
 */
RequestBase.prototype.maxResponseSize = function(n){
  if ('number' !== typeof n) {
    throw TypeError("Invalid argument");
  }
  this._maxResponseSize = n;
  return this;
};

/**
 * Convert to a plain javascript object (not JSON string) of scalar properties.
 * Note as this method is designed to return a useful non-this value,
 * it cannot be chained.
 *
 * @return {Object} describing method, url, and data of this request
 * @api public
 */

RequestBase.prototype.toJSON = function() {
  return {
    method: this.method,
    url: this.url,
    data: this._data,
    headers: this._header,
  };
};

/**
 * Send `data` as the request body, defaulting the `.type()` to "json" when
 * an object is given.
 *
 * Examples:
 *
 *       // manual json
 *       request.post('/user')
 *         .type('json')
 *         .send('{"name":"tj"}')
 *         .end(callback)
 *
 *       // auto json
 *       request.post('/user')
 *         .send({ name: 'tj' })
 *         .end(callback)
 *
 *       // manual x-www-form-urlencoded
 *       request.post('/user')
 *         .type('form')
 *         .send('name=tj')
 *         .end(callback)
 *
 *       // auto x-www-form-urlencoded
 *       request.post('/user')
 *         .type('form')
 *         .send({ name: 'tj' })
 *         .end(callback)
 *
 *       // defaults to x-www-form-urlencoded
 *      request.post('/user')
 *        .send('name=tobi')
 *        .send('species=ferret')
 *        .end(callback)
 *
 * @param {String|Object} data
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.send = function(data){
  var isObj = isObject(data);
  var type = this._header['content-type'];

  if (this._formData) {
    console.error(".send() can't be used if .attach() or .field() is used. Please use only .send() or only .field() & .attach()");
  }

  if (isObj && !this._data) {
    if (Array.isArray(data)) {
      this._data = [];
    } else if (!this._isHost(data)) {
      this._data = {};
    }
  } else if (data && this._data && this._isHost(this._data)) {
    throw Error("Can't merge these send calls");
  }

  // merge
  if (isObj && isObject(this._data)) {
    for (var key in data) {
      this._data[key] = data[key];
    }
  } else if ('string' == typeof data) {
    // default to x-www-form-urlencoded
    if (!type) this.type('form');
    type = this._header['content-type'];
    if ('application/x-www-form-urlencoded' == type) {
      this._data = this._data
        ? this._data + '&' + data
        : data;
    } else {
      this._data = (this._data || '') + data;
    }
  } else {
    this._data = data;
  }

  if (!isObj || this._isHost(data)) {
    return this;
  }

  // default to json
  if (!type) this.type('json');
  return this;
};

/**
 * Sort `querystring` by the sort function
 *
 *
 * Examples:
 *
 *       // default order
 *       request.get('/user')
 *         .query('name=Nick')
 *         .query('search=Manny')
 *         .sortQuery()
 *         .end(callback)
 *
 *       // customized sort function
 *       request.get('/user')
 *         .query('name=Nick')
 *         .query('search=Manny')
 *         .sortQuery(function(a, b){
 *           return a.length - b.length;
 *         })
 *         .end(callback)
 *
 *
 * @param {Function} sort
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.sortQuery = function(sort) {
  // _sort default to true but otherwise can be a function or boolean
  this._sort = typeof sort === 'undefined' ? true : sort;
  return this;
};

/**
 * Compose querystring to append to req.url
 *
 * @api private
 */
RequestBase.prototype._finalizeQueryString = function(){
  var query = this._query.join('&');
  if (query) {
    this.url += (this.url.indexOf('?') >= 0 ? '&' : '?') + query;
  }
  this._query.length = 0; // Makes the call idempotent

  if (this._sort) {
    var index = this.url.indexOf('?');
    if (index >= 0) {
      var queryArr = this.url.substring(index + 1).split('&');
      if ('function' === typeof this._sort) {
        queryArr.sort(this._sort);
      } else {
        queryArr.sort();
      }
      this.url = this.url.substring(0, index) + '?' + queryArr.join('&');
    }
  }
};

// For backwards compat only
RequestBase.prototype._appendQueryString = function() {console.trace("Unsupported");}

/**
 * Invoke callback with timeout error.
 *
 * @api private
 */

RequestBase.prototype._timeoutError = function(reason, timeout, errno){
  if (this._aborted) {
    return;
  }
  var err = new Error(reason + timeout + 'ms exceeded');
  err.timeout = timeout;
  err.code = 'ECONNABORTED';
  err.errno = errno;
  this.timedout = true;
  this.abort();
  this.callback(err);
};

RequestBase.prototype._setTimeouts = function() {
  var self = this;

  // deadline
  if (this._timeout && !this._timer) {
    this._timer = setTimeout(function(){
      self._timeoutError('Timeout of ', self._timeout, 'ETIME');
    }, this._timeout);
  }
  // response timeout
  if (this._responseTimeout && !this._responseTimeoutTimer) {
    this._responseTimeoutTimer = setTimeout(function(){
      self._timeoutError('Response timeout of ', self._responseTimeout, 'ETIMEDOUT');
    }, this._responseTimeout);
  }
};

},{"./is-object":188}],190:[function(require,module,exports){
'use strict';

/**
 * Module dependencies.
 */

var utils = require('./utils');

/**
 * Expose `ResponseBase`.
 */

module.exports = ResponseBase;

/**
 * Initialize a new `ResponseBase`.
 *
 * @api public
 */

function ResponseBase(obj) {
  if (obj) return mixin(obj);
}

/**
 * Mixin the prototype properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */

function mixin(obj) {
  for (var key in ResponseBase.prototype) {
    obj[key] = ResponseBase.prototype[key];
  }
  return obj;
}

/**
 * Get case-insensitive `field` value.
 *
 * @param {String} field
 * @return {String}
 * @api public
 */

ResponseBase.prototype.get = function(field) {
  return this.header[field.toLowerCase()];
};

/**
 * Set header related properties:
 *
 *   - `.type` the content type without params
 *
 * A response of "Content-Type: text/plain; charset=utf-8"
 * will provide you with a `.type` of "text/plain".
 *
 * @param {Object} header
 * @api private
 */

ResponseBase.prototype._setHeaderProperties = function(header){
    // TODO: moar!
    // TODO: make this a util

    // content-type
    var ct = header['content-type'] || '';
    this.type = utils.type(ct);

    // params
    var params = utils.params(ct);
    for (var key in params) this[key] = params[key];

    this.links = {};

    // links
    try {
        if (header.link) {
            this.links = utils.parseLinks(header.link);
        }
    } catch (err) {
        // ignore
    }
};

/**
 * Set flags such as `.ok` based on `status`.
 *
 * For example a 2xx response will give you a `.ok` of __true__
 * whereas 5xx will be __false__ and `.error` will be __true__. The
 * `.clientError` and `.serverError` are also available to be more
 * specific, and `.statusType` is the class of error ranging from 1..5
 * sometimes useful for mapping respond colors etc.
 *
 * "sugar" properties are also defined for common cases. Currently providing:
 *
 *   - .noContent
 *   - .badRequest
 *   - .unauthorized
 *   - .notAcceptable
 *   - .notFound
 *
 * @param {Number} status
 * @api private
 */

ResponseBase.prototype._setStatusProperties = function(status){
    var type = status / 100 | 0;

    // status / class
    this.status = this.statusCode = status;
    this.statusType = type;

    // basics
    this.info = 1 == type;
    this.ok = 2 == type;
    this.redirect = 3 == type;
    this.clientError = 4 == type;
    this.serverError = 5 == type;
    this.error = (4 == type || 5 == type)
        ? this.toError()
        : false;

    // sugar
    this.created = 201 == status;
    this.accepted = 202 == status;
    this.noContent = 204 == status;
    this.badRequest = 400 == status;
    this.unauthorized = 401 == status;
    this.notAcceptable = 406 == status;
    this.forbidden = 403 == status;
    this.notFound = 404 == status;
    this.unprocessableEntity = 422 == status;
};

},{"./utils":191}],191:[function(require,module,exports){
'use strict';

/**
 * Return the mime type for the given `str`.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */

exports.type = function(str){
  return str.split(/ *; */).shift();
};

/**
 * Return header field parameters.
 *
 * @param {String} str
 * @return {Object}
 * @api private
 */

exports.params = function(str){
  return str.split(/ *; */).reduce(function(obj, str){
    var parts = str.split(/ *= */);
    var key = parts.shift();
    var val = parts.shift();

    if (key && val) obj[key] = val;
    return obj;
  }, {});
};

/**
 * Parse Link header fields.
 *
 * @param {String} str
 * @return {Object}
 * @api private
 */

exports.parseLinks = function(str){
  return str.split(/ *, */).reduce(function(obj, str){
    var parts = str.split(/ *; */);
    var url = parts[0].slice(1, -1);
    var rel = parts[1].split(/ *= */)[1].slice(1, -1);
    obj[rel] = url;
    return obj;
  }, {});
};

/**
 * Strip content related fields from `header`.
 *
 * @param {Object} header
 * @return {Object} header
 * @api private
 */

exports.cleanHeader = function(header, changesOrigin){
  delete header['content-type'];
  delete header['content-length'];
  delete header['transfer-encoding'];
  delete header['host'];
  // secuirty
  if (changesOrigin) {
    delete header['authorization'];
    delete header['cookie'];
  }
  return header;
};

},{}],192:[function(require,module,exports){

/**
 * Expose `Emitter`.
 */

if (typeof module !== 'undefined') {
  module.exports = Emitter;
}

/**
 * Initialize a new `Emitter`.
 *
 * @api public
 */

function Emitter(obj) {
  if (obj) return mixin(obj);
};

/**
 * Mixin the emitter properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */

function mixin(obj) {
  for (var key in Emitter.prototype) {
    obj[key] = Emitter.prototype[key];
  }
  return obj;
}

/**
 * Listen on the given `event` with `fn`.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.on =
Emitter.prototype.addEventListener = function(event, fn){
  this._callbacks = this._callbacks || {};
  (this._callbacks['$' + event] = this._callbacks['$' + event] || [])
    .push(fn);
  return this;
};

/**
 * Adds an `event` listener that will be invoked a single
 * time then automatically removed.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.once = function(event, fn){
  function on() {
    this.off(event, on);
    fn.apply(this, arguments);
  }

  on.fn = fn;
  this.on(event, on);
  return this;
};

/**
 * Remove the given callback for `event` or all
 * registered callbacks.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.off =
Emitter.prototype.removeListener =
Emitter.prototype.removeAllListeners =
Emitter.prototype.removeEventListener = function(event, fn){
  this._callbacks = this._callbacks || {};

  // all
  if (0 == arguments.length) {
    this._callbacks = {};
    return this;
  }

  // specific event
  var callbacks = this._callbacks['$' + event];
  if (!callbacks) return this;

  // remove all handlers
  if (1 == arguments.length) {
    delete this._callbacks['$' + event];
    return this;
  }

  // remove specific handler
  var cb;
  for (var i = 0; i < callbacks.length; i++) {
    cb = callbacks[i];
    if (cb === fn || cb.fn === fn) {
      callbacks.splice(i, 1);
      break;
    }
  }

  // Remove event specific arrays for event types that no
  // one is subscribed for to avoid memory leak.
  if (callbacks.length === 0) {
    delete this._callbacks['$' + event];
  }

  return this;
};

/**
 * Emit `event` with the given args.
 *
 * @param {String} event
 * @param {Mixed} ...
 * @return {Emitter}
 */

Emitter.prototype.emit = function(event){
  this._callbacks = this._callbacks || {};

  var args = new Array(arguments.length - 1)
    , callbacks = this._callbacks['$' + event];

  for (var i = 1; i < arguments.length; i++) {
    args[i - 1] = arguments[i];
  }

  if (callbacks) {
    callbacks = callbacks.slice(0);
    for (var i = 0, len = callbacks.length; i < len; ++i) {
      callbacks[i].apply(this, args);
    }
  }

  return this;
};

/**
 * Return array of callbacks for `event`.
 *
 * @param {String} event
 * @return {Array}
 * @api public
 */

Emitter.prototype.listeners = function(event){
  this._callbacks = this._callbacks || {};
  return this._callbacks['$' + event] || [];
};

/**
 * Check if this emitter has `event` handlers.
 *
 * @param {String} event
 * @return {Boolean}
 * @api public
 */

Emitter.prototype.hasListeners = function(event){
  return !! this.listeners(event).length;
};

},{}],193:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ensure = require("./modules/boot/ensure");
require("./modules/common/commons");
require("./modules/ads/all");
require("./modules/layout/article/article-mask");
require("./modules/layout/article/article-print");
require("./modules/layout/article/quizz");
require("./modules/layout/timeline/timeline-comments");
require("./modules/layout/timeline/timeline-more");
require("./modules/form/all");
require("./modules/widget/surveys-article");
require("./modules/widget/tab-panel");
require("./modules/widget/countdown");
require("./modules/widget/modal");
require("./modules/widget/election-presidential");
require("./modules/widget/election-legislative");
require("./modules/partner/postmessage-parent");
require("./modules/tracking/all");
require("./modules/layout/article/article-tracker");
var mediaPlaylistCarousel = require("./modules/widget/media-playlist-carousel");
var mediaPlaylist = require("./modules/widget/media-playlist");
var mediaGallery = require("./modules/layout/article/media-gallery");
var articleSocial = require("./modules/layout/article/article-social");
var contest = require("./modules/layout/article/contest");
var stickyAds = require("./modules/layout/sticky-ads");
var partnerIdalgo = require("./modules/layout/article/partner-idalgo");
var partnerQualifio = require("./modules/layout/article/partner-qualifio");
var socialPosts = require("./modules/social/social-posts");
var socialEmbeds = require("./modules/social/social-embeds");
var widgetSlider = require("./modules/widget/widget-slider");
var widgetDebate = require("./modules/widget/widget-debate");
var playerWibbitz = require("./modules/widget/player-wibbitz");
var commentsReport = require("./modules/widget/comments-report");
var toggleGroup = require("./modules/toggle/toggle-group");
ensure.windowsIsLoaded(function () {
    stickyAds.init();
    mediaPlaylist.initAll();
    mediaPlaylistCarousel.initAll();
    mediaGallery.initAll();
    articleSocial.init();
    contest.initAll();
    partnerIdalgo.init();
    partnerQualifio.init();
    socialPosts.init();
    socialEmbeds.init();
    widgetSlider.initAll();
    widgetDebate.init();
    commentsReport.initAll();
    toggleGroup.initAll();
    playerWibbitz.init();
    // PopupInvitation.init()
});

},{"./modules/ads/all":197,"./modules/boot/ensure":204,"./modules/common/commons":209,"./modules/form/all":219,"./modules/layout/article/article-mask":225,"./modules/layout/article/article-print":226,"./modules/layout/article/article-social":227,"./modules/layout/article/article-tracker":228,"./modules/layout/article/contest":229,"./modules/layout/article/media-gallery":230,"./modules/layout/article/partner-idalgo":231,"./modules/layout/article/partner-qualifio":232,"./modules/layout/article/quizz":233,"./modules/layout/sticky-ads":234,"./modules/layout/timeline/timeline-comments":235,"./modules/layout/timeline/timeline-more":236,"./modules/partner/postmessage-parent":237,"./modules/social/social-embeds":253,"./modules/social/social-posts":254,"./modules/toggle/toggle-group":255,"./modules/tracking/all":256,"./modules/widget/comments-report":269,"./modules/widget/countdown":270,"./modules/widget/election-legislative":271,"./modules/widget/election-presidential":272,"./modules/widget/media-playlist":276,"./modules/widget/media-playlist-carousel":275,"./modules/widget/modal":277,"./modules/widget/player-wibbitz":279,"./modules/widget/surveys-article":280,"./modules/widget/tab-panel":281,"./modules/widget/widget-debate":282,"./modules/widget/widget-slider":283}],194:[function(require,module,exports){
"use strict";
/**
 * Load Adsense in async mode
 */
Object.defineProperty(exports, "__esModule", { value: true });
var $ = require("kawabunga/assets/js/utils/dom");
var scriptLoader = require("kawabunga/assets/js/utils/script-loader");
function init() {
    if (!$('.adsbygoogle').isEmpty()) {
        scriptLoader.ensureLoaded('//pagead2.googlesyndication.com/pagead/js/adsbygoogle.js').then(function () {
            (window.adsbygoogle = window.adsbygoogle || []).push({});
        });
    }
}
exports.init = init;

},{"kawabunga/assets/js/utils/dom":71,"kawabunga/assets/js/utils/script-loader":77}],195:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var scriptLoader = require("kawabunga/assets/js/utils/script-loader");
var env = require("kawabunga/assets/js/env/env");
function init() {
    if (env.getSite() === 'www.rtl.fr') {
        scriptLoader.ensureLoaded('https://boot.pbstck.com/v1/tag/f3af140f-df34-4c37-8e38-2b5f162fce1a').then(function () {
            // loaded
        });
    }
    else if (env.getSite() === 'www.funradio.fr') {
        scriptLoader.ensureLoaded('https://boot.pbstck.com/v1/tag/fc9d8023-e06c-4043-94e9-28da0fa33128').then(function () {
            // loaded
        });
    }
}
exports.init = init;

},{"kawabunga/assets/js/env/env":65,"kawabunga/assets/js/utils/script-loader":77}],196:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var m6pub_1 = require("./m6pub");
var scriptLoader = require("kawabunga/assets/js/utils/script-loader");
var env = require("kawabunga/assets/js/env/env");
var NUGG_HOST = '//asqm6.nuggad.net';
var NUGG_N = '701220792';
var NUGG_TG = '';
var getNuggsId = function () {
    switch (env.getSite()) {
        case 'www.funradio.fr':
            return '651445481';
        case 'www.rtl.fr':
        default:
            return '1813474847';
    }
};
var getScriptUrl = function () {
    return NUGG_HOST + "/rc?nuggn=" + NUGG_N + "&nuggsid=" + getNuggsId() + "&nuggtg=" + NUGG_TG;
};
function init() {
    scriptLoader.ensureLoaded(getScriptUrl()).then(function () {
        if (window.NUGGjson) {
            for (var nuggkey in window.NUGGjson) {
                if (window.NUGGjson.hasOwnProperty(nuggkey)) {
                    m6pub_1.pushIntoPageCriterias({
                        name: nuggkey,
                        value: window.NUGGjson[nuggkey]
                    });
                }
            }
        }
    });
}
exports.init = init;

},{"./m6pub":198,"kawabunga/assets/js/env/env":65,"kawabunga/assets/js/utils/script-loader":77}],197:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ensure = require("../boot/ensure");
var env = require("kawabunga/assets/js/env/env");
var didomi_1 = require("kawabunga/assets/js/cmp/didomi");
var m6pub = require("./m6pub");
var nuggad = require("./ads-nuggad");
var adsense = require("./ads-adsense");
var loadScripts = require("kawabunga/assets/js/advertising/load-ligatus");
var partnerWidgetIframe = require("./partner-widget-iframe");
var adsMonitor = require("./ads-monitor");
var outbrain = require("./outbrain");
var pannellum = require("./pannellum");
var initialized = false;
var init = function () {
    adsMonitor.init();
    initialized = true;
    nuggad.init();
    m6pub.init();
    adsense.init();
    outbrain.init();
    ensure.windowsIsLoaded(function () {
        loadScripts.init();
        if (env.isFlag('pannellum')) {
            pannellum.init();
        }
        partnerWidgetIframe.init();
    });
};
didomi_1.CmpDidomi.doOnDidomiConsent(didomi_1.Purpose.ADS, init, function () {
});

},{"../boot/ensure":204,"./ads-adsense":194,"./ads-monitor":195,"./ads-nuggad":196,"./m6pub":198,"./outbrain":199,"./pannellum":200,"./partner-widget-iframe":201,"kawabunga/assets/js/advertising/load-ligatus":52,"kawabunga/assets/js/cmp/didomi":57,"kawabunga/assets/js/env/env":65}],198:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Promise = require("promise");
var dates = require("../utils/dates");
var env = require("kawabunga/assets/js/env/env");
var $ = require("kawabunga/assets/js/utils/dom");
var scriptLoader = require("kawabunga/assets/js/utils/script-loader");
var domain = env.getRenaissanceDomain();
var subdomain = env.isFlag('m6pubpp') ? 'static-preprod' : 'static';
// FUN RADIO has no _
if (domain == 'FUN_RADIO') {
    domain = 'FUNRADIO';
}
var path = domain.toLowerCase();
exports.NETWORK_CODE = 42159803;
exports.ADUNIT_CODE = domain + '/OTHER';
exports.PREBID_ADDITIONAL_SCRIPT = "https://sac.ayads.co/sublime/" + (domain === 'RTL' ? '26350' : '26352') + "/prebid";
exports.PREBID_SCRIPT = 'https://' + subdomain + '.m6tech.net/' + path + '/prebid-' + path + '.js?v=' + dates.print(new Date());
function init() {
    window._networkCode = window._networkCode || exports.NETWORK_CODE;
    window._adunitCode = window._adunitCode || exports.ADUNIT_CODE;
    window.pageCriterias = window.pageCriterias || [];
    window._activeAdslots = $('div[data-role="m6pub"]').map(function (div) { return div.id; });
    return new Promise(function (resolve) {
        scriptLoader.ensureLoaded(exports.PREBID_ADDITIONAL_SCRIPT)
            .then(function () { return scriptLoader.ensureLoaded(exports.PREBID_SCRIPT); })
            .then(function () {
            window._activeAdslots.forEach(function (slot) {
                window.displayAd(slot);
            });
            if (typeof (window.prebid) !== 'undefined' && typeof (window.prebidFn.defineDynamicAdslot) !== 'undefined') {
                if ($('#dynInfeed1').length) {
                    window.prebidFn.defineDynamicAdslot('dynInfeed', 1);
                }
                if ($('#dynInfeed2').length) {
                    window.prebidFn.defineDynamicAdslot('dynInfeed', 2);
                }
                if ($('#dynInfeed3').length) {
                    window.prebidFn.defineDynamicAdslot('dynInfeed', 3);
                }
            }
            resolve();
        });
    });
}
exports.init = init;
function pushIntoPageCriterias(criteria) {
    window.pageCriterias = window.pageCriterias || [];
    window.pageCriterias.push(criteria);
}
exports.pushIntoPageCriterias = pushIntoPageCriterias;

},{"../utils/dates":265,"kawabunga/assets/js/env/env":65,"kawabunga/assets/js/utils/dom":71,"kawabunga/assets/js/utils/script-loader":77,"promise":178}],199:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var $ = require("kawabunga/assets/js/utils/dom");
var scriptLoader = require("kawabunga/assets/js/utils/script-loader");
var userAgent = require("kawabunga/assets/js/env/user-agent");
var OUTBRAIN_SCRIPT = 'https://widgets.outbrain.com/outbrain.js';
function init() {
    if (!userAgent.isMobile()) {
        $('.OUTBRAIN[data-widget-id="MB_1"]').forEach(function (elem) {
            var container = elem.closest('.container[data-role="sequence"]');
            container ? container.remove() : elem.remove();
        });
    }
    if (!$('.OUTBRAIN').length) {
        return;
    }
    scriptLoader.ensureLoaded(OUTBRAIN_SCRIPT).then(function () {
        //console.log('OUTBRAIN_SCRIPT loaded');
    });
}
exports.init = init;

},{"kawabunga/assets/js/env/user-agent":66,"kawabunga/assets/js/utils/dom":71,"kawabunga/assets/js/utils/script-loader":77}],200:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var env = require("kawabunga/assets/js/env/env");
require("pannellum/build/pannellum");
exports.init = function () {
    window.pannellum.viewer('panorama', {
        "type": "equirectangular",
        "panorama": "photoBenj.jpg",
        "haov": 200,
        "vaov": 60,
        "vOffset": 0,
        "autoLoad": true,
        "preview": "photoBenj-preview.jpg",
        "minYaw": -90,
        "maxYaw": 90,
        "minPitch": -30,
        "maxPitch": 30,
        "basePath": env.getStaticRoot() + "img/",
        /* * Uncomment the next line to print the coordinates of mouse clicks
        * to the browser's developer console, which makes it much easier
        * to figure out where to place hot spots. Always remove it when
        * finished, though.
        */
        //"hotSpotDebug": true,
        "hotSpots": [
            {
                "pitch": -15.031162478955721,
                "yaw": -12.384299892681533,
                "type": "info",
                "text": "Four catalyse Cooke & Lewis",
                "URL": "https://www.castorama.fr/four-catalyse-cooke-lewis-cmlfst/3663602429548_CAFR.prd"
            },
            {
                "pitch": 0.18393436082944992,
                "yaw": 44.28774958675537,
                "type": "info",
                "text": "Micro-ondes à poser blanc",
                "URL": "https://www.castorama.fr/micro-ondes-a-poser-blanc/3700222302759_CAFR.prd"
            }
        ]
    });
};

},{"kawabunga/assets/js/env/env":65,"pannellum/build/pannellum":177}],201:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var $ = require("kawabunga/assets/js/utils/dom");
exports.init = function () {
    $('.js-partner-widget-iframe').forEach(function (iframe) {
        iframe.src = iframe.getAttribute('data-src');
    });
};

},{"kawabunga/assets/js/utils/dom":71}],202:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("./polyfills");
require("./browser");

},{"./browser":203,"./polyfills":205}],203:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Modernizr = require("browsernizr/lib/Modernizr");
Modernizr._config.enableClasses = false;
// pick what tests you need
require("browsernizr/test/css/fontface");
require("browsernizr/test/css/transforms3d");
require("browsernizr/test/css/objectfit");
require("browsernizr/test/touchevents");
var browsernizr = require("browsernizr");
exports.hasFontFace = function () {
    return browsernizr.fontface;
};
exports.supportsCssObjectFit = function () {
    return browsernizr.objectfit;
};
exports.hasTouch = function () {
    // Add custom hasTouch detection because of IE10
    return window.navigator.msMaxTouchPoints || browsernizr.touchevents;
};
/*
 * Cross-browser touch start event
 */
exports.touchStart = 'touchstart';
if (window.navigator.pointerEnabled) {
    exports.touchStart = 'pointerdown';
}
else if (window.navigator.msPointerEnabled) {
    exports.touchStart = 'MSPointerDown';
}
document.documentElement.classList.add(browsernizr['csstransforms3d'] ? 'csstransforms3d' : 'no-csstransforms3d');
document.documentElement.classList.add(exports.hasTouch() ? 'touch' : 'no-touch');
document.documentElement.classList.add(browsernizr['objectfit'] ? 'objectfit' : 'no-objectfit');

},{"browsernizr":4,"browsernizr/lib/Modernizr":5,"browsernizr/test/css/fontface":36,"browsernizr/test/css/objectfit":37,"browsernizr/test/css/transforms3d":38,"browsernizr/test/touchevents":39}],204:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var profile_service_1 = require("../common/profile-service");
function windowsIsLoaded(callBack) {
    if (document.readyState == 'complete') {
        callBack();
    }
    else {
        window.addEventListener('load', function () {
            callBack();
        });
    }
}
exports.windowsIsLoaded = windowsIsLoaded;
function profileIsLoaded() {
    return profile_service_1.profileService.getData();
}
exports.profileIsLoaded = profileIsLoaded;

},{"../common/profile-service":217}],205:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("js-polyfills/es5");
require("js-polyfills/es6");
require("js-polyfills/dom");
require("js-polyfills/html");
require("js-polyfills/cssom");
/**
 * js-polyfills/es5 is pretty heavy, defining Array.find here
 * https://developer.mozilla.org/fr/docs/Web/JavaScript/Reference/Objets_globaux/Array/find
 */
if (!Array.prototype.find) {
    Object.defineProperty(Array.prototype, 'find', {
        value: function (predicate) {
            if (this == null) {
                throw new TypeError('"this" is null or not defined');
            }
            var o = Object(this);
            var len = o.length >>> 0;
            if (typeof predicate !== 'function') {
                throw new TypeError('predicate must be a function');
            }
            var thisArg = arguments[1];
            var k = 0;
            while (k < len) {
                var kValue = o[k];
                if (predicate.call(thisArg, kValue, k, o)) {
                    return kValue;
                }
                k++;
            }
            return undefined;
        }
    });
}
Event.prototype.stop = function () {
    this.preventDefault();
    this.stopPropagation();
};
/*
* Polyfill for browsers that do not support Element.closest(), but carry support for element.matches() (or a prefixed equivalent, meaning IE9+)
* https://developer.mozilla.org/en-US/docs/Web/API/Element/closest#Polyfill
*/
if (!Element.prototype.matches) {
    Element.prototype.matches = Element.prototype.msMatchesSelector ||
        Element.prototype.webkitMatchesSelector;
}
if (!Element.prototype.closest) {
    Element.prototype.closest = function (s) {
        var el = this;
        if (!document.documentElement.contains(el))
            return null;
        do {
            if (el.matches(s))
                return el;
            el = el.parentElement || el.parentNode;
        } while (el !== null && el.nodeType === 1);
        return null;
    };
}

},{"js-polyfills/cssom":47,"js-polyfills/dom":48,"js-polyfills/es5":49,"js-polyfills/es6":50,"js-polyfills/html":51}],206:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var $ = require("kawabunga/assets/js/utils/dom");
var userAgent = require("kawabunga/assets/js/env/user-agent");
exports.DEFAULT_URL_PREFIX = '#scroll-to-';
function scrollToHash(hash) {
    var target = extractTargetFromHref(hash);
    if (target) {
        scrollTo(target);
    }
}
exports.scrollToHash = scrollToHash;
function scrollTo(target) {
    var scroll = document.body.scrollTop || document.documentElement.scrollTop;
    var targetTop = target.getBoundingClientRect().top;
    var totalToScroll = scroll + targetTop - computeOffset();
    window.scrollTo(0, totalToScroll);
}
exports.scrollTo = scrollTo;
function extractTargetFromHref(anchor) {
    anchor = anchor || document.location.hash;
    if (!anchor || anchor.trim() === "") {
        return null;
    }
    var id = anchor.split('#')[1];
    return document.getElementById(id);
}
exports.extractTargetFromHref = extractTargetFromHref;
function extractTargetFromUrl(prefix) {
    prefix = typeof prefix !== 'undefined' ? prefix : exports.DEFAULT_URL_PREFIX;
    var anchor = document.location.hash;
    if (!anchor || anchor.trim() === "") {
        return null;
    }
    var id = anchor.split(prefix)[1];
    return document.getElementById(id);
}
exports.extractTargetFromUrl = extractTargetFromUrl;
function computeOffset() {
    if (userAgent.isIE8()) {
        return 0;
    }
    var subNav = $('.main-nav-sub');
    return subNav.isEmpty() ? 0 : subNav[0].getBoundingClientRect().bottom + 10;
}
exports.computeOffset = computeOffset;
function scrollOnLoad() {
    var target = extractTargetFromUrl();
    if (target) {
        scrollTo(target);
    }
}
exports.scrollOnLoad = scrollOnLoad;
function init() {
    scrollOnLoad();
}
exports.init = init;
$('.js-anchor-link').on('click', function (e, link) {
    e.preventDefault();
    scrollToHash(link.href);
});
init();

},{"kawabunga/assets/js/env/user-agent":66,"kawabunga/assets/js/utils/dom":71}],207:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var vendor_list_1 = require("kawabunga/assets/js/cmp/vendor-list");
var euconsent_cookie_1 = require("kawabunga/assets/js/cmp/euconsent-cookie");
var $ = require("kawabunga/assets/js/utils/dom");
var cnil_1 = require("kawabunga/assets/js/cnil/cnil");
var CmpForm;
(function (CmpForm) {
    var consent;
    var $root;
    var $form;
    CmpForm.init = function () {
        $root = $("[data-role=\"cmp\"]");
        $form = $("[data-role=\"cmp-form\"]");
        consent = euconsent_cookie_1.euconsent.cookie.read();
        $form.html(getPurposeListHTML());
        $form.select("input[name^='purpose']").on('click', function (e) { return CmpForm.updatePurpose(e.target.dataset.id, e.target.checked); });
        $form.select("input[name^='vendor']").on('click', function (e) { return CmpForm.updateVendor(e.target.dataset.id, e.target.checked); });
    };
    CmpForm.toggleVisibility = function () {
        $root.hasClass('d-none') ? $root.removeClass('d-none') : $root.addClass('d-none');
    };
    var checkConsentExists = function (cb) {
        if (!euconsent_cookie_1.euconsent.cookie.exists()) {
            consent = euconsent_cookie_1.euconsent.newFullConsent();
        }
        cb();
    };
    CmpForm.updatePurpose = function (id, isAllowed) {
        checkConsentExists(function () {
            consent.setPurposeAllowed(+id, isAllowed);
            euconsent_cookie_1.euconsent.cookie.write(consent);
        });
    };
    CmpForm.updateVendor = function (id, isAllowed) {
        checkConsentExists(function () {
            consent.setVendorAllowed(+id, isAllowed);
            euconsent_cookie_1.euconsent.cookie.write(consent);
            CmpForm.init();
        });
    };
    var getPurposeHTML = function (purpose) {
        var checked = euconsent_cookie_1.euconsent.cookie.exists() ? consent.isPurposeAllowed(purpose.id) : false;
        return "\n            <div class=\"cmp-form__item\">\n                <ul class=\"list-group\">\n                    <li class=\"list-group-item\">\n                        <div class=\"cmp-form__title d-flex justify-content-between align-items-center\">\n                            " + purpose.name + "\n                            <div class=\"btn-checkbox\">\n                                <input type=\"checkbox\" id=\"purpose-" + purpose.id + "\" name=\"purpose-" + purpose.id + "\" data-id=\"" + purpose.id + "\" " + (checked ? 'checked' : '') + ">\n                                <label for=\"purpose-" + purpose.id + "\"></label>\n                            </div>\n                        </div>\n                        <p class=\"cmp-form__description\">" + purpose.description + "</p>\n                    </li>\n                    " + getVendorListHTML(purpose.id) + "\n                </ul>\n            </div>";
    };
    var getPurposeListHTML = function () {
        var html = '';
        vendor_list_1.m6Vendors.purposes.forEach(function (purpose) {
            html += getPurposeHTML(purpose);
        });
        return html;
    };
    var getVendorHTML = function (vendor) {
        var checked = euconsent_cookie_1.euconsent.cookie.exists() ? consent.isVendorAllowed(vendor.id) : true;
        return "\n            <li class=\"list-group-item list-group-item-action\">\n                <label class=\"d-flex align-items-center justify-content-between\">\n                    " + vendor.name + "<input type=\"checkbox\" name=\"vendor-" + vendor.id + "\" data-id=\"" + vendor.id + "\" class=\"float-right\"  " + (checked ? 'checked' : '') + ">\n                </label>\n            </li>\n        ";
    };
    var getVendorListHTML = function (purposeId) {
        var html = '';
        var matchesPurpose = function (vendor) {
            return vendor.purposeIds.indexOf(purposeId) != -1;
        };
        vendor_list_1.m6Vendors.vendors.filter(matchesPurpose).forEach(function (vendor) {
            html += getVendorHTML(vendor);
        });
        return html;
    };
    CmpForm.reinitOnChangeAds = function (event) {
        if (event.oldValue != null && event.oldValue.ads == event.value.ads) {
            return;
        }
        CmpForm.init();
    };
})(CmpForm = exports.CmpForm || (exports.CmpForm = {}));
CmpForm.init();
$("[data-role=\"cmp-form-btn\"]").on('click', CmpForm.toggleVisibility);
cnil_1.cnil.cookie.onChange(CmpForm.reinitOnChangeAds);

},{"kawabunga/assets/js/cmp/euconsent-cookie":58,"kawabunga/assets/js/cmp/vendor-list":59,"kawabunga/assets/js/cnil/cnil":64,"kawabunga/assets/js/utils/dom":71}],208:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_MESSAGE = "En poursuivant votre navigation sur notre service ou en ouvrant nos communications directes, vous acceptez l\u2019utilisation de cookies, y compris de partenaires tiers, pour r\u00E9aliser des statistiques de visites, pour vous proposer des services et des publicit\u00E9s adapt\u00E9s \u00E0 vos centres d\u2019int\u00E9r\u00EAt (sur internet et via nos communications directes), pour vous proposer des fonctionnalit\u00E9s relatives aux r\u00E9seaux sociaux ainsi que de la lecture directe de vid\u00E9os.";
exports.SOCIAL_MESSAGE = "Pour afficher ce contenu, vous devez accepter les cookies pour les r\u00E9seaux sociaux.";
exports.ANALYTICS_MESSAGE = "Pour afficher ce contenu, vous devez accepter les cookies pour l'analyse et la mesure d'audience.";
var DEFAULT_OPTIONS = {
    modifierClass: '',
    category: '',
    message: exports.DEFAULT_MESSAGE,
    messageCol: 'col-12',
    buttonsCol: 'col-12',
    iconClass: ''
};
exports.ICONS = {
    "twitter-script": 'icon-twitter',
    "instagram-script": 'icon-instagram',
    "facebook-script": 'icon-facebook',
};
exports.cnilBannerHTML = function (bannerOptions) {
    if (bannerOptions === void 0) { bannerOptions = DEFAULT_OPTIONS; }
    var options = {
        modifierClass: bannerOptions.modifierClass || DEFAULT_OPTIONS.modifierClass,
        category: bannerOptions.category || DEFAULT_OPTIONS.category,
        message: bannerOptions.message || DEFAULT_OPTIONS.message,
        messageCol: bannerOptions.messageCol || DEFAULT_OPTIONS.messageCol,
        buttonsCol: bannerOptions.buttonsCol || DEFAULT_OPTIONS.buttonsCol,
        iconClass: bannerOptions.iconClass || DEFAULT_OPTIONS.iconClass
    };
    return "\n    <div class=\"cnil-banner-v2 " + options.modifierClass + "\" data-role=\"cnil-banner\">\n        <div class=\"cnil-banner-v2__icons\">\n            <span class=\"icon " + options.iconClass + "\"></span>\n        </div>\n        <div class=\"container\">\n            <div class=\"row\">\n                <div class=\"" + options.messageCol + "\">\n                    <p class=\"cnil-banner-v2__text\">\n                        " + options.message + "\n                        <a class=\"cnil-banner-v2__more\" href=\"/cnil/preferences\" data-cnil=\"1\">En savoir plus et modifier les param\u00E8tres</a>\n                    </p>\n                </div>\n                <div class=\"" + options.buttonsCol + "\">\n                    <button type=\"button\" class=\"cnil-banner-v2__btn btn btn-flat btn-flat--sm\" data-action=\"accept\" data-category=\"" + options.category + "\">J'accepte</button>\n                    <a href=\"/cnil/preferences\" class=\"cnil-banner-v2__link\" data-cnil=\"1\"><span class=\"icon icon-arrow-right-circle\"></span>Param\u00E9trer les traceurs</a>\n                </div>\n            </div>\n        </div>\n        <button type=\"button\" class=\"cnil-banner-v2__close\" data-action=\"close\" aria-label=\"Close\">\n            <span aria-hidden=\"true\" class=\"icon icon-close-circle\"></span>\n        </button>\n    </div>";
};
exports.didomiBannerHTML = function (bannerOptions) {
    if (bannerOptions === void 0) { bannerOptions = DEFAULT_OPTIONS; }
    var options = {
        modifierClass: bannerOptions.modifierClass || DEFAULT_OPTIONS.modifierClass,
        category: bannerOptions.category || DEFAULT_OPTIONS.category,
        message: bannerOptions.message || DEFAULT_OPTIONS.message,
        messageCol: bannerOptions.messageCol || DEFAULT_OPTIONS.messageCol,
        buttonsCol: bannerOptions.buttonsCol || DEFAULT_OPTIONS.buttonsCol,
        iconClass: bannerOptions.iconClass || DEFAULT_OPTIONS.iconClass
    };
    return "\n    <div class=\"cnil-banner-v2 " + options.modifierClass + "\" data-role=\"cnil-banner\" data-purpose=\"" + options.category + "\">\n        <div class=\"cnil-banner-v2__icons\">\n            <span class=\"icon " + options.iconClass + "\"></span>\n        </div>\n        <div class=\"container\">\n            <div class=\"row\">\n                <div class=\"" + options.messageCol + "\">\n                    <p class=\"cnil-banner-v2__text\">\n                        " + options.message + "\n                        <a href=\"javascript:Didomi.preferences.show('information');\" class=\"cnil-banner-v2__more\">En savoir plus et modifier les param\u00E8tres</a>\n                    </p>\n                </div>\n                <div class=\"" + options.buttonsCol + "\">\n                    <button type=\"button\" class=\"cnil-banner-v2__btn btn btn-flat btn-flat--sm\" data-action=\"consent\" data-purpose=\"" + options.category + "\">J'accepte</button>\n                    <a href=\"javascript:Didomi.preferences.show('purposes');\" class=\"cnil-banner-v2__link\"><span class=\"icon icon-arrow-right-circle\"></span>Param\u00E9trer les traceurs</a>\n                </div>\n            </div>\n        </div>\n        <button type=\"button\" class=\"cnil-banner-v2__close\" aria-label=\"Close\">\n            <span aria-hidden=\"true\" class=\"icon icon-close-circle\"></span>\n        </button>\n    </div>";
};

},{}],209:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("../boot/boot");
require("./mq-state-detection");
require("./image-echo");
require("./fonticon-loader");
require("./anchor-scroll");
// import './cnil'; TODO WEBDEV-3591 : remove and clean files when done
require("./cnil-v2");
require("kawabunga/assets/js/cmp/cmp");
require("./cmp-form");
require("./didomi");
require("./js-anchor");
var newsAlert = require("./news-alert");
newsAlert.init();
require("./objectfit");
require("../header/header");

},{"../boot/boot":202,"../header/header":224,"./anchor-scroll":206,"./cmp-form":207,"./cnil-v2":208,"./didomi":210,"./fonticon-loader":211,"./image-echo":212,"./js-anchor":213,"./mq-state-detection":214,"./news-alert":215,"./objectfit":216,"kawabunga/assets/js/cmp/cmp":55}],210:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var didomi_1 = require("kawabunga/assets/js/cmp/didomi");
var env = require("kawabunga/assets/js/env/env");
var options = {};
if (env.getSite() === 'www.funradio.fr') {
    options = {
        name: 'funradio.fr',
        apiKey: '4801407c-7ff1-4aed-aa34-71b05434f911',
        logoUrl: env.getStaticRoot() + 'img/logo-fun-120x60.jpg',
        themeColor: '#00AFEC',
        privacyPolicyURL: env.getContextRoot() + '/cnil/charte-de-confidentialite'
    };
}
didomi_1.CmpDidomi.init(options);

},{"kawabunga/assets/js/cmp/didomi":57,"kawabunga/assets/js/env/env":65}],211:[function(require,module,exports){
"use strict";
/**
 * Asynchronous load of fonticon
 */
Object.defineProperty(exports, "__esModule", { value: true });
var browser = require("../boot/browser");
var userAgent = require("kawabunga/assets/js/env/user-agent");
var env = require("kawabunga/assets/js/env/env");
exports.init = function () {
    if (supported()) {
        injectLink(exports.getStylesheetUrl());
        setTimeout(function () {
            addFontfaceClass();
        }, 20);
    }
};
exports.getStylesheetUrl = function () {
    return env.getStaticRoot() + 'css/fonticon.css';
};
var supported = function () {
    // Widows Phone 7 has a false positive on Modernizr font-face detection
    return !userAgent.isIE8() && !userAgent.isWindowsPhone7() && browser.hasFontFace();
};
var injectLink = function (href) {
    var link = document.createElement('link');
    link.href = href;
    link.rel = 'stylesheet';
    link.type = 'text/css';
    document.head.appendChild(link);
};
var addFontfaceClass = function () {
    document.documentElement.classList.add('fontface');
};
exports.init();

},{"../boot/browser":203,"kawabunga/assets/js/env/env":65,"kawabunga/assets/js/env/user-agent":66}],212:[function(require,module,exports){
"use strict";
/**
 * Load images within data-src attribute using lazyload technique
 */
Object.defineProperty(exports, "__esModule", { value: true });
var $ = require("kawabunga/assets/js/utils/dom");
var mq_state_detection_1 = require("./mq-state-detection");
var browser = require("../boot/browser");
var debounce_1 = require("kawabunga/assets/js/utils/debounce");
//
// Local Properties
//
var THROTTLE = browser.hasTouch() ? 250 : 150;
var inView = function (elem) {
    var top = -1000;
    var bottom = (window.innerHeight || document.documentElement.clientHeight) + 1000;
    var box = elem.getBoundingClientRect();
    return box.bottom >= top && box.top <= bottom;
};
var getBestSrc = function (image) {
    var size = getCurrentSize();
    var alternatives = ["data-src-" + size, 'data-src'];
    if (mq_state_detection_1.mqState.isRetina()) {
        alternatives = ["data-src-" + size + "-retina", "data-src-" + size, 'data-src-retina', 'data-src'];
    }
    var att;
    alternatives.forEach(function (attribute) {
        if (!att && image.hasAttribute(attribute)) {
            att = attribute;
        }
    });
    return image.getAttribute(att);
};
var getCurrentSize = function () {
    switch (mq_state_detection_1.mqState.getState()) {
        case 1:
            return 'small';
        case 2:
            return 'medium';
        case 3:
            return 'large';
        default:
            return '';
    }
};
//
// Exported Properties
//
function init() {
    render();
    window.addEventListener('scroll', debounce_1.default(render, THROTTLE, false));
    window.addEventListener('load', debounce_1.default(render, THROTTLE, false));
}
exports.init = init;
function render() {
    $('img[data-src]').filter(inView).forEach(function (img) {
        var src, parent = img.parentNode;
        src = getBestSrc(img);
        if (img.hasAttribute('data-srcset')) {
            img.srcset = img.getAttribute('data-srcset');
            img.removeAttribute('data-srcset');
        }
        // setTimeout 0 hack for layout thrashing http://wilsonpage.co.uk/preventing-layout-thrashing/
        setTimeout(function () {
            img.src = src;
        }, 0);
        img.removeAttribute('data-src');
        if (parent.tagName === 'PICTURE') {
            $(parent).select('source[data-srcset]').forEach(function (source) {
                source.srcset = source.getAttribute('data-srcset');
                source.removeAttribute('data-srcset');
            });
        }
    });
}
exports.render = render;
mq_state_detection_1.mqState.onChange(render);
init();

},{"../boot/browser":203,"./mq-state-detection":214,"kawabunga/assets/js/utils/debounce":70,"kawabunga/assets/js/utils/dom":71}],213:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var $ = require("kawabunga/assets/js/utils/dom");
$('.js-anchor').forEach(function (anchor) {
    $(anchor).on('click', function (e) {
        e.stop();
        var href = $(anchor).data('href');
        var targetBlank = $(anchor).data('target-blank');
        if (href) {
            if (targetBlank) {
                window.open(href, '_blank');
            }
            else {
                window.document.location.href = href;
            }
        }
    });
});

},{"kawabunga/assets/js/utils/dom":71}],214:[function(require,module,exports){
(function (__filename){
"use strict";
/**
 * A module to detect media queries state at any given moment
 * current cols (grid layout), can be 1,2,3 or 4
 */
Object.defineProperty(exports, "__esModule", { value: true });
var debounce_1 = require("kawabunga/assets/js/utils/debounce");
var observable_1 = require("kawabunga/assets/js/utils/observable");
exports.UNKNOWN_STATE = -1;
var MQState = /** @class */ (function () {
    function MQState() {
        this.observable = new observable_1.Observable();
        this.currentState = exports.UNKNOWN_STATE;
    }
    MQState.prototype.init = function () {
        this.currentState = this.readState();
    };
    MQState.prototype.getState = function () {
        return this.currentState;
    };
    MQState.prototype.onChange = function (handler) {
        this.observable.observe(handler);
    };
    MQState.prototype.isRetina = function () {
        if (window.getComputedStyle) {
            return window.getComputedStyle(this.getMqStateElement()).getPropertyValue('text-align') == 'right';
        }
        else {
            /* IE8- */
            return this.getMqStateElement().currentStyle.textAlign == 'right';
        }
    };
    MQState.prototype.readState = function () {
        if (!this.getMqStateElement()) {
            console.warn('DOM element indicator is not present on current page.', __filename);
            return exports.UNKNOWN_STATE;
        }
        var zIndex = null;
        if (window.getComputedStyle) {
            zIndex = parseInt(window.getComputedStyle(this.getMqStateElement()).getPropertyValue('z-index'), 10);
        }
        else {
            /* IE8- */
            zIndex = this.getMqStateElement().currentStyle.zIndex;
        }
        return zIndex || exports.UNKNOWN_STATE;
    };
    MQState.prototype.getMqStateElement = function () {
        return document.getElementById('mq-state');
    };
    return MQState;
}());
exports.mqState = new MQState();
window.addEventListener('resize', debounce_1.default(function () {
    var newState = exports.mqState.readState();
    if (exports.mqState.currentState !== newState) {
        exports.mqState.currentState = newState; // store the current state
        exports.mqState.observable.fire(exports.mqState.currentState);
    }
}, 300));
exports.mqState.init();

}).call(this,"/src/js/modules/common/mq-state-detection.ts")
},{"kawabunga/assets/js/utils/debounce":70,"kawabunga/assets/js/utils/observable":75}],215:[function(require,module,exports){
"use strict";
/**
 * Provide a module calling an external service with last news updated
 */
Object.defineProperty(exports, "__esModule", { value: true });
var $ = require("kawabunga/assets/js/utils/dom");
var timer = require("../utils/timer");
var cookies = require("js-cookie");
var http = require("superagent");
var config = require("../config/config");
var Promise = require("promise");
exports.TICKER_NAME = 'news-alert';
exports.COOKIE_NAME = config.brandNameUpper + '-alert';
var NewsAlert = /** @class */ (function () {
    function NewsAlert() {
        var _this = this;
        this.url = null;
        this.currentId = null;
        if (this.isTickerPresent()) {
            return;
        }
        var url = this.url = $('#main-wrapper').data('alert');
        if (url && url.trim() !== "") {
            this.fetchAlert().then(function (res) {
                var alert = res;
                if (_this.isNewAlert(alert)) {
                    _this.currentId = alert.uniqueID;
                    _this.injectTicker(alert);
                }
            }).catch(function (err) {
                // error message
                console.log(err);
            });
        }
    }
    NewsAlert.prototype.fetchAlert = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            http.get(_this.url)
                .type('json')
                .end(function (err, res) {
                if (err) {
                    reject(res);
                    return;
                }
                resolve(res.body || JSON.parse(res.text));
            });
        });
    };
    NewsAlert.prototype.isTickerPresent = function () {
        return $('#' + exports.TICKER_NAME).length != 0;
    };
    NewsAlert.prototype.isNewAlert = function (alert) {
        return alert && alert.uniqueID !== false && alert.uniqueID !== this.currentId && alert.uniqueID !== cookies.get(exports.COOKIE_NAME);
    };
    NewsAlert.prototype.close = function () {
        var $newsAlert = $('#' + exports.TICKER_NAME);
        if (!$newsAlert) {
            return;
        }
        cookies.set(exports.COOKIE_NAME, this.currentId);
        $newsAlert[0].parentNode.removeChild($newsAlert[0]);
    };
    NewsAlert.prototype.injectTicker = function (alert) {
        var _this = this;
        var html = "<div id=\"" + exports.TICKER_NAME + "\" class=\"" + exports.TICKER_NAME + "\">\n                        <div class=\"page-wrap g-gutter\">\n                            <div class=\"wrap\">\n                                <span class=\"type up\">\n                                    <span class=\"valign\">" + alert.title + "</span>\n                                </span>\n                                <span class=\"close\">\n                                    <span class=\"valign\">\n                                        <button class=\"btn\">\n                                            <i class=\"icon icon-close-sign icon-ff\"></i><span class=\"no-ff\">X</span>\n                                        </button>\n                                    </span>\n                                </span>\n                                <a class=\"alert\" id=\"ticker-alert\" href=\"" + alert.link + "\" target=\"" + (alert.target ? alert.target : '') + "\">\n                                    <span class=\"valign\"><span class=\"up\">" + alert.since + "</span> - " + alert.text + "</span>\n                                </a>\n                            </div>\n                        </div>\n                    </div>";
        $(document.body).append(html);
        var $newsAlert = $('#' + exports.TICKER_NAME);
        $newsAlert.select('.alert').on('click', function () {
            cookies.set(exports.COOKIE_NAME, _this.currentId);
            $newsAlert[0].parentNode.removeChild($newsAlert[0]);
        });
        $newsAlert.select('.close').on('click', function (e) {
            e.stopPropagation();
            _this.close();
        });
    };
    return NewsAlert;
}());
exports.NewsAlert = NewsAlert;
function init() {
    return new NewsAlert();
}
exports.init = init;
timer.onTick(function () {
    init();
});

},{"../config/config":218,"../utils/timer":268,"js-cookie":46,"kawabunga/assets/js/utils/dom":71,"promise":178,"superagent":187}],216:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var $ = require("kawabunga/assets/js/utils/dom");
var browser = require("../boot/browser");
function createBackgroundCover(img) {
    var src = img.getAttribute('src');
    var parent = img.parentNode;
    var wrapper = document.createElement('div');
    if (src) {
        wrapper.className = 'js-objectfit-container';
        wrapper.style.backgroundImage = 'url(' + src + ')';
        parent.replaceChild(wrapper, img);
    }
}
function init() {
    renderFallback();
}
exports.init = init;
function renderFallback() {
    if (!browser.supportsCssObjectFit()) {
        $('img.js-objectfit').forEach(function (img) {
            img.onload = createBackgroundCover(img);
        });
    }
}
exports.renderFallback = renderFallback;
init();

},{"../boot/browser":203,"kawabunga/assets/js/utils/dom":71}],217:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Promise = require("promise");
var http = require("superagent");
var passmedia_ctrl_1 = require("../passmedia/passmedia-ctrl");
var env = require("kawabunga/assets/js/env/env");
exports.PROFILE_PATH = env.isProd() ? '/api/profile' : 'https://www.lab.rtl.fr/api/profile';
var ProfileService = /** @class */ (function () {
    function ProfileService() {
    }
    ProfileService.prototype.getData = function () {
        var _this = this;
        if (!this.promisedData) {
            this.promisedData = new Promise(function (resolve, reject) {
                _this.httpGetData()
                    .then(function (profileData) {
                    if (profileData) {
                        resolve(profileData);
                    }
                    else {
                        passmedia_ctrl_1.PassMediaCtrl.init().then(function (connectedPassmedia) {
                            if (connectedPassmedia) {
                                _this.httpGetData().then(function (profileData) {
                                    resolve(profileData);
                                });
                            }
                            else {
                                resolve(null);
                            }
                        }).catch(function () {
                            reject();
                        });
                    }
                }).catch(function () {
                    reject();
                });
            });
        }
        return this.promisedData;
    };
    ProfileService.prototype.httpGetData = function () {
        return new Promise(function (resolve, reject) {
            http.get(exports.PROFILE_PATH).end(function (err, res) {
                if (err) {
                    reject();
                }
                else {
                    if (res.text === '' || res.text === '{}') {
                        resolve(null);
                    }
                    else {
                        resolve(res.body);
                    }
                }
            });
        });
    };
    return ProfileService;
}());
exports.ProfileService = ProfileService;
exports.profileService = new ProfileService();

},{"../passmedia/passmedia-ctrl":239,"kawabunga/assets/js/env/env":65,"promise":178,"superagent":187}],218:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var domain;
exports.domain = domain;
var brandName, brandNameShort, brandNameUpper, domainName;
exports.brandName = brandName;
exports.brandNameUpper = brandNameUpper;
exports.domainName = domainName;
if (window.site == 'www.funradio.fr') {
    exports.domain = domain = 'FUN_RADIO';
    exports.brandName = brandName = 'funradio';
    brandNameShort = 'fun';
    exports.brandNameUpper = brandNameUpper = 'FUNRADIO';
    exports.domainName = domainName = '.funradio.fr';
}
else {
    exports.domain = domain = 'RTL';
    exports.brandName = brandName = 'rtl';
    brandNameShort = 'rtl';
    exports.brandNameUpper = brandNameUpper = 'RTL';
    exports.domainName = domainName = '.rtl.fr';
}
var jwplayer = {
    staticRoot: 'https://static' + domainName + '/versions/jwplayer'
};
exports.jwplayer = jwplayer;

},{}],219:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("./form-check");
require("./form-field-limiter");
require("./form-comment-policy");
require("./form-comment-post");

},{"./form-check":220,"./form-comment-policy":221,"./form-comment-post":222,"./form-field-limiter":223}],220:[function(require,module,exports){
"use strict";
/**
 * Check input if text isn't empty before posting form
 */
Object.defineProperty(exports, "__esModule", { value: true });
var $ = require("kawabunga/assets/js/utils/dom");
var analytics = require("../tracking/universal-analytics");
exports.init = function () {
    $('.js-form').forEach(bind);
};
var bind = function (form) {
    var $input = $(form).select('.js-input-txt');
    var $label = $(form).select('.js-label-txt');
    if ($input.length) {
        $input.forEach(function (input, index) {
            $(input).on('focus', function () {
                $label[index].style.display = "none";
            });
            $(input).on('blur', function () {
                $label[index].style.display = input.value.trim() === "" ? "block" : "none";
            });
        });
        $(form).on('submit', function (e) {
            var shouldCheck = form.className.indexOf('js-form-no-check') == -1;
            if (shouldCheck && hasAnEmptyInput($input)) {
                e.preventDefault();
                e.stopPropagation();
            }
            else if ($(form).hasClass('article-mail-form')) {
                var newsletterName = $(form).select('input[name="newsletters"]').value();
                pushAnalytics(newsletterName);
            }
        });
    }
};
var hasAnEmptyInput = function ($input) {
    return $input.find(function (input) { return input.value.trim() === ""; }) !== undefined;
};
var pushAnalytics = function (newsletterName) {
    analytics.push({
        event: 'eventGA',
        eventCategory: 'newsletter',
        eventAction: 'inscription',
        eventLabel: [{ 'newsletterName': newsletterName }]
    });
};
exports.init();

},{"../tracking/universal-analytics":263,"kawabunga/assets/js/utils/dom":71}],221:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var $ = require("kawabunga/assets/js/utils/dom");
var config = require("../config/config");
var TEXT = 'Votre commentaire ne doit pas :\n- être insultant, à caractère raciste ou discriminatoire\n- contraire à l\'ordre public et aux bonnes mœurs\n- dévoiler des coordonnées personnelles';
if (config.brandName === 'rtl') {
    TEXT = TEXT + '\nIl sera publié après validation par notre équipe de modérateurs';
}
exports.SELECTORS = {
    TEXTAREA: 'textarea.js-textarea-policy',
    SUBMIT: 'input.js-submit-policy'
};
function init() {
    $('.js-field-policy').forEach(bind);
}
exports.init = init;
var bind = function (input) {
    var $textarea = $(input).select(exports.SELECTORS.TEXTAREA);
    var $submit = $(input).select(exports.SELECTORS.SUBMIT);
    var enabled = true;
    var displayPolicy = function () {
        $textarea.value(TEXT);
        enabled = true;
        disableSubmit();
    };
    var enableSubmit = function () {
        $submit.removeAttr('disabled');
    };
    var disableSubmit = function () {
        $submit.attr('disabled', 'disabled');
    };
    $textarea.on('focus', function () {
        if (enabled) {
            $textarea.value('');
            enabled = false;
            enableSubmit();
        }
    });
    $textarea.on('blur', function () {
        if ($textarea.value().trim().length == 0) {
            displayPolicy();
        }
    });
    displayPolicy();
};
init();

},{"../config/config":218,"kawabunga/assets/js/utils/dom":71}],222:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var $ = require("kawabunga/assets/js/utils/dom");
var http = require("superagent");
var analytics = require("../tracking/universal-analytics");
exports.SELECTORS = {
    FORM: '#form-request',
    TEXTAREA: 'textarea.js-textarea-request',
    SUBMIT: 'input.js-submit-request',
    LOG: '#form-request-log',
    LOG_CHROMES: '#form-request-log-chromes',
    IS_ARTICLE: '#timeline-article'
};
function init() {
    var $form = $(exports.SELECTORS.FORM);
    var $textarea = $form.select(exports.SELECTORS.TEXTAREA);
    var $submit = $form.select(exports.SELECTORS.SUBMIT);
    var $target = $('#' + $form.data('target'));
    var $log = $(exports.SELECTORS.LOG);
    var $logChromes = $(exports.SELECTORS.LOG_CHROMES);
    var url = $form.attr('action');
    var delayed = $form.data('delayed') === 'delayed'; // moderation a priori
    var isArticlePage = !$(exports.SELECTORS.IS_ARTICLE).isEmpty();
    var getData = function () {
        var data = {
            text: $textarea.value()
        };
        $form.select('input[type="hidden"]').forEach(function (input) {
            data[input.name] = input.value;
        });
        return data;
    };
    $submit.on('click', function (e) {
        if ($textarea.value().trim() == '') {
            e.preventDefault();
        }
    });
    $form.on('submit', function (e) {
        e.preventDefault();
        $logChromes.css('display', 'block');
        $log.text('Envoi en cours...');
        $log.addClass('bg-loader');
        var data = getData();
        $textarea.value('');
        http.post(url).type('form').send(data).end(function (err, res) {
            $log.removeClass('bg-loader');
            if (err) {
                $log.addClass('error');
                $log.text(toErrorMessage(res.status));
            }
            else {
                if (delayed) {
                    $log.text('Merci pour votre commentaire. Il a été envoyé à notre équipe de modération et sera publié après validation.');
                }
                else {
                    $log.text('Votre commentaire a bien été posté.');
                    $target.prepend(res.text);
                    $($target.children()[0]).addClass('com-highlight');
                }
                if (isArticlePage) {
                    var data_1 = {
                        event: 'eventGA',
                        eventCategory: 'contentComment',
                        eventAction: 'contentComment-add',
                        eventLabel: location.pathname.substring(1)
                    };
                    analytics.push(data_1);
                }
            }
        });
    });
}
exports.init = init;
var toErrorMessage = function (statusCode) {
    switch (statusCode) {
        case 401:
            return 'Utilisateur déconnecté.';
        case 403:
            return 'Utilisateur banni.';
        case 404:
            return '404 Not found.';
        case 405:
            return 'Les commentaires ont été fermés sur cette page.';
        case 422:
            return 'Commentaire vide.';
        case 413:
            return 'Commentaire trop long.';
        case 429:
            return '15 secondes de délai entre 2 commentaires.';
        default:
            return 'Un problème est survenu.';
    }
};
init();

},{"../tracking/universal-analytics":263,"kawabunga/assets/js/utils/dom":71,"superagent":187}],223:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var $ = require("kawabunga/assets/js/utils/dom");
exports.SELECTORS = {
    FIELDSET: '.js-field-limiter',
    FIELD_LISTENER: '.js-field-listener',
    COUNTER_LISTENER: '.js-counter-listener',
    SUBMIT_LISTENER: '.js-submit-listener'
};
exports.ERROR_TEXT = {
    EXCEEDED_LIMIT: 'Limite dépassée'
};
exports.CLASSNAMES = {
    ERROR: 'error'
};
function init() {
    $(exports.SELECTORS.FIELDSET).forEach(bind);
}
exports.init = init;
var bind = function (fieldset) {
    var $fieldListener = $(fieldset).select(exports.SELECTORS.FIELD_LISTENER);
    var $counterListener = $(fieldset).select(exports.SELECTORS.COUNTER_LISTENER);
    var $submitListener = $(fieldset).select(exports.SELECTORS.SUBMIT_LISTENER);
    var intialValue = $submitListener.value();
    var maxchars = $counterListener.text();
    var intervalId = null;
    var disabledForm = false;
    var charsUsed = 0;
    var update = function (count) {
        charsUsed = count;
        var remain = maxchars - charsUsed;
        if (remain < 0) {
            if (!disabledForm) {
                $submitListener.value(exports.ERROR_TEXT.EXCEEDED_LIMIT);
                disabledForm = true;
            }
            $counterListener.addClass(exports.CLASSNAMES.ERROR);
        }
        else {
            if (disabledForm) {
                $submitListener.value(intialValue);
                disabledForm = false;
            }
            $counterListener.removeClass(exports.CLASSNAMES.ERROR);
        }
        $counterListener.text(remain);
    };
    var check = function () {
        var count = $fieldListener.value().trim().length;
        if (charsUsed !== count) {
            update(count);
        }
    };
    $fieldListener.on('focus', function () {
        clearInterval(intervalId);
        intervalId = setInterval(check, 250);
    });
    $fieldListener.on('blur', function () {
        clearInterval(intervalId);
    });
    $submitListener.on('click', function (e) {
        if (disabledForm) {
            e.preventDefault();
        }
    });
    check();
};
init();

},{"kawabunga/assets/js/utils/dom":71}],224:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var $ = require("kawabunga/assets/js/utils/dom");
var userAgent = require("kawabunga/assets/js/env/user-agent");
var mq_state_detection_1 = require("../common/mq-state-detection");
var ensure = require("../boot/ensure");
exports.init = function () {
    new HeaderMain($('[data-role="main-header"]')[0]);
};
exports.DATA_ROLE = {
    NAV_TOGGLER: 'nav-toggler',
    NAV_SLIDE: 'nav-slide',
    NAV_SLIDE_BACKDROP: 'nav-slide-backdrop',
    NAV_HEIGHT: 'nav-height',
    NAV_LOGIN: 'nav-login',
    NAV_LOGGED: 'nav-logged',
    NAV_LOGGED_AVATAR: 'nav-logged-avatar',
    NAV_LOGGED_NAME: 'nav-logged-name'
};
var MOBILE_MAX_WIDTH = 640;
var DIFF_VERTICAL_SWIPE = 50;
var SMALLER_MENU_AFTER_SCROLL_IN_PX = 150;
var SMALLER_MENU_AFTER_SCROLL_IN_PX_MOBILE = 50;
var MENU_HEIGHT = 110;
var MENU_HEIGHT_SMALLER = 50;
var HeaderMain = /** @class */ (function () {
    function HeaderMain(header) {
        var _this = this;
        this.$header = $(header);
        this.$toggler = $(this.$header.select("[data-role=\"" + exports.DATA_ROLE.NAV_TOGGLER + "\"]")[0]);
        this.$navSlide = $(this.$header.select("[data-role=\"" + exports.DATA_ROLE.NAV_SLIDE + "\"]")[0]);
        this.$navSlideBackdrop = this.$header.select("[data-role=\"" + exports.DATA_ROLE.NAV_SLIDE_BACKDROP + "\"]");
        this.$navHeight = $(this.$header.select("[data-role=\"" + exports.DATA_ROLE.NAV_HEIGHT + "\"]")[0]);
        // TODO : repasser sur le data-role quand le menu-v2 sera en prod sur la totalité des sites
        //this.$mainWrapper = $($(`[data-role="main-wrapper"]`)[0]);
        this.$mainWrapper = $('#main-wrapper');
        this.$navLogged = this.$header.select("[data-role=\"" + exports.DATA_ROLE.NAV_LOGGED + "\"]");
        this.$navLoggin = this.$header.select("[data-role=\"" + exports.DATA_ROLE.NAV_LOGIN + "\"]");
        if (userAgent.isIE() && userAgent.getIEVersion() <= 9) {
            this.$navSlide.addClass('old-ie');
        }
        ensure.profileIsLoaded().then(function (profileData) {
            if (profileData) {
                _this.fillNavWithProfileData(profileData);
                _this.$navLogged.css('display', 'block');
                _this.$navLoggin.css('display', 'none');
            }
        });
        this.$toggler.on('click', function (e) {
            e.preventDefault();
            _this.toggle();
        });
        this.$navSlideBackdrop.on('click', function (e) {
            if (_this.$navSlide.hasClass('active')) {
                _this.toggle();
            }
        });
        this.updateMenuHeight();
        window.addEventListener('scroll', function () {
            _this.updateMenuHeight();
        });
        //this.swipeClose();
        //this.swipeOpen();
    }
    HeaderMain.prototype.toggle = function () {
        if (this.$navSlide.hasClass('active')) {
            $('body').removeClass('fixed');
            this.$navSlide.removeClass('active');
            this.$navSlideBackdrop.removeClass('active');
            this.$toggler.selectByClass('burger').removeClass('open');
        }
        else {
            $('body').addClass('fixed');
            this.$navSlide.addClass('active');
            this.$navSlideBackdrop.addClass('active');
            this.$toggler.selectByClass('burger').addClass('open');
        }
    };
    HeaderMain.prototype.updateMenuHeight = function () {
        if (!this.isMenuHeightFixed()) {
            if (this.shouldMenuBeSmaller()) {
                this.$header.addClass('smaller');
                $('body').addClass('smaller');
                // fix sublime skin top position when scrolling down WEBDEV-2815
                $('#ayads-html').css('top', MENU_HEIGHT_SMALLER + 'px');
            }
            else {
                this.$header.removeClass('smaller');
                $('body').removeClass('smaller');
                // fix sublime skin top position when scrolling down WEBDEV-2815
                $('#ayads-html').css('top', MENU_HEIGHT + 'px');
            }
        }
    };
    HeaderMain.prototype.isMenuHeightFixed = function () {
        var $body = $('body');
        return $body.hasClass('page-home') && $body.css('width') <= MOBILE_MAX_WIDTH;
    };
    HeaderMain.prototype.shouldMenuBeSmaller = function () {
        var bodyScrollTop = document.body.scrollTop || window.pageYOffset || document.documentElement.scrollTop;
        return bodyScrollTop >= (mq_state_detection_1.mqState.getState() <= 2 ? SMALLER_MENU_AFTER_SCROLL_IN_PX_MOBILE : SMALLER_MENU_AFTER_SCROLL_IN_PX);
    };
    HeaderMain.prototype.swipeOpen = function () {
        var _this = this;
        var swipeStartX = 0;
        var swipeEndX = 0;
        var pourcent = 100;
        this.$mainWrapper.on('touchstart', function (e) {
            swipeStartX = e.touches[0].screenX;
        });
        this.$mainWrapper.on('touchmove', function (e) {
            swipeEndX = e.touches[0].screenX;
            if ((swipeEndX - swipeStartX) > DIFF_VERTICAL_SWIPE) {
                pourcent = pourcent - 2;
                _this.$navSlide.css('transform', 'translate3d(-' + pourcent + '%, 0, 0)');
            }
        });
        this.$mainWrapper.on('touchend', function (e) {
            if (swipeStartX >= 0 && swipeEndX > swipeStartX && (swipeEndX - swipeStartX) > DIFF_VERTICAL_SWIPE
                && !_this.$navSlide.hasClass('active')) {
                _this.$navSlide.css('transform', 'translate3d(0%, 0, 0)');
                _this.toggle();
            }
        });
    };
    HeaderMain.prototype.swipeClose = function () {
        var _this = this;
        var swipeStartX = 0;
        var swipeEndX = 0;
        var pourcent = 0;
        this.$navSlide.on('touchstart', function (e) {
            swipeStartX = e.touches[0].screenX;
        });
        this.$navSlide.on('touchmove', function (e) {
            swipeEndX = e.touches[0].screenX;
            if ((swipeStartX - swipeEndX) > DIFF_VERTICAL_SWIPE) {
                pourcent = pourcent + 2;
                _this.$navSlide.css('transform', 'translate3d(-' + pourcent + '%, 0, 0)');
            }
        });
        this.$navSlide.on('touchend', function (e) {
            if (swipeStartX <= window.innerWidth && swipeEndX < swipeStartX
                && (swipeStartX - swipeEndX) > DIFF_VERTICAL_SWIPE && _this.$navSlide.hasClass('active')) {
                _this.$navSlide.css('transform', 'translate3d(-100%, 0, 0)');
                _this.toggle();
            }
        });
    };
    HeaderMain.prototype.fillNavWithProfileData = function (data) {
        var $avatar = this.$navLogged.select("[data-role=\"" + exports.DATA_ROLE.NAV_LOGGED_AVATAR + "\"]");
        var $name = this.$navLogged.select("[data-role=\"" + exports.DATA_ROLE.NAV_LOGGED_NAME + "\"]");
        if (data.avatar) {
            $avatar.css('display', 'inline-block');
            $avatar.attr('src', data.avatar);
        }
        if (data.displayName) {
            $name.css('display', 'inline-block');
            $name.text(data.displayName);
        }
    };
    return HeaderMain;
}());
exports.init();

},{"../boot/ensure":204,"../common/mq-state-detection":214,"kawabunga/assets/js/env/user-agent":66,"kawabunga/assets/js/utils/dom":71}],225:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var $ = require("kawabunga/assets/js/utils/dom");
var analytics = require("../../tracking/universal-analytics");
exports.DATA_ROLE = 'article-mask';
exports.CLASS_NAME = 'mask__removed';
exports.initAll = function () {
    $("[data-role=\"" + exports.DATA_ROLE + "\"]").forEach(exports.init);
};
exports.init = function (element) {
    if (typeof element === 'object') {
        return new ArticleMask($(element));
    }
    else {
        return null;
    }
};
var ArticleMask = /** @class */ (function () {
    function ArticleMask($root) {
        var _this = this;
        this.$root = $root;
        this.$trigger = this.$root.select('.read-more');
        this.$trigger.on('click', function (e) {
            e.preventDefault();
            analytics.push({
                event: 'eventGA',
                eventCategory: 'BlocPageArticle',
                eventAction: 'Lien_Lire_la_suite_Mobile' /*,
                eventLabel: [{ 'newsletterName': 'newsletter euro' }]*/
            });
            _this.show();
        });
    }
    ArticleMask.prototype.show = function () {
        this.$root.addClass(exports.CLASS_NAME);
    };
    return ArticleMask;
}());
exports.initAll();

},{"../../tracking/universal-analytics":263,"kawabunga/assets/js/utils/dom":71}],226:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var $ = require("kawabunga/assets/js/utils/dom");
function init() {
    $('#print-article').on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        window.print();
    });
}
exports.init = init;
// AutoInit
init();

},{"kawabunga/assets/js/utils/dom":71}],227:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var $ = require("kawabunga/assets/js/utils/dom");
var debounce_1 = require("kawabunga/assets/js/utils/debounce");
exports.DATA_ROLE = {
    SECTION: 'article-section',
    SOCIAL: 'article-social',
    SHARE: 'article-share'
};
var $articleSection, $articleSocial, $articleShare;
function init() {
    $articleSection = $("[data-role=\"" + exports.DATA_ROLE.SECTION + "\"]");
    $articleSocial = $("[data-role=\"" + exports.DATA_ROLE.SOCIAL + "\"]");
    $articleShare = $("[data-role=\"" + exports.DATA_ROLE.SHARE + "\"]");
    if (!$articleSection.isEmpty() && !$articleSocial.isEmpty() && !$articleShare.isEmpty()) {
        return new ArticleSocial();
    }
}
exports.init = init;
var ArticleSocial = /** @class */ (function () {
    function ArticleSocial() {
        var _this = this;
        this.$section = $articleSection;
        this.$social = $articleSocial;
        this.$share = $articleShare;
        this.mode = '';
        this.isFixed = false;
        window.addEventListener('resize', debounce_1.default(function () {
            _this.detectMode();
        }, 300));
        window.addEventListener('scroll', function () {
            _this.onWindowScroll();
        });
        this.detectMode();
    }
    ArticleSocial.prototype.detectMode = function () {
        var windowWidth = window.innerWidth;
        var mode;
        if (windowWidth <= 660) {
            mode = '';
        }
        else if (windowWidth >= 661 && windowWidth < 1090) {
            mode = 'fixed__mobile';
        }
        else if (windowWidth >= 1301 && windowWidth <= 1415) {
            mode = 'fixed__mobile';
        }
        else {
            mode = 'fixed__desktop';
        }
        if (this.mode !== mode) {
            if (this.mode) {
                this.$share.removeClass(this.mode);
            }
            if (mode) {
                this.$share.addClass(mode);
            }
            this.mode = mode;
        }
        this.onWindowScroll();
    };
    ArticleSocial.prototype.onWindowScroll = function () {
        if (this.mode !== '') {
            if (this.isFixedDisplayable() && !this.isFixed) {
                this.$share.addClass('share__fixed');
                this.isFixed = true;
            }
            else if (!this.isFixedDisplayable() && this.isFixed) {
                this.$share.removeClass('share__fixed');
                this.isFixed = false;
            }
        }
    };
    ArticleSocial.prototype.isFixedDisplayable = function () {
        var socialBoundBottom = this.$social.bounds().bottom;
        var mainNavHeight = $('[data-role="main-header"]').bounds().height;
        var windowHeight = window.innerHeight;
        var sectionBoundBottom = this.$section.bounds().bottom;
        var sectionFooterHeight = this.$section.select('.article-section-footer').bounds().height;
        return ((socialBoundBottom - mainNavHeight) < 0 && (sectionBoundBottom - sectionFooterHeight) > windowHeight / 2);
    };
    return ArticleSocial;
}());
exports.ArticleSocial = ArticleSocial;

},{"kawabunga/assets/js/utils/debounce":70,"kawabunga/assets/js/utils/dom":71}],228:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var $ = require("kawabunga/assets/js/utils/dom");
var analytics = require("../../tracking/universal-analytics");
// ..
// Exported Properties & Methods
//
exports.DATA_ROLE_RELATED = 'article-related';
function init() {
    $("[data-role=" + exports.DATA_ROLE_RELATED + "]").forEach(function (related) {
        var $related = $(related);
        $related.on('click', '.link-track', function () {
            analytics.push({
                event: 'eventGA',
                eventCategory: 'BlocPageArticle',
                eventAction: 'Lien_A_Lire_Aussi'
            });
        });
    });
}
exports.init = init;
// ..
// Auto init
//
init();

},{"../../tracking/universal-analytics":263,"kawabunga/assets/js/utils/dom":71}],229:[function(require,module,exports){
"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var $ = require("kawabunga/assets/js/utils/dom");
var Promise = require("promise");
var http = require("superagent");
exports.DATA_ROLE = 'contest';
exports.DATA_ROLE_FULLSCREEN = 'contest-fullscreen';
exports.DATA_ROLE_RULES_TOGGLE = 'contest-rules-toggle';
exports.DATA_ROLE_RULES_CLOSE = 'contest-rules-close';
exports.DATA_ROLE_ERROR = 'error';
exports.CLASS_BODY_FULLSCREEN = 'overlay-open';
exports.CLASS_STEP_ACTIVE = 'step__active';
exports.CLASS_LOADING = 'contest__loading';
exports.TRANSITION_DURATION = 310;
exports.initAll = function () {
    $("[data-role=\"" + exports.DATA_ROLE + "\"]").forEach(exports.init);
};
exports.init = function (elem) {
    if (elem) {
        return new Contest(elem);
    }
};
var Contest = /** @class */ (function () {
    function Contest(elem) {
        var _this = this;
        this.$root = $(elem);
        this.service = this.$root.attr('data-service');
        this.isInTransition = false;
        this.isFullScreen = false;
        // ..
        // Steps
        //
        this.steps = {};
        this.rulesStep = null;
        this.currentStep = null;
        this.$root.select('[data-step-type]').forEach(function (elem) {
            var step = _this.buildStep(elem);
            if (step && step.name && _this.steps[step.name] === undefined) {
                _this.steps[step.name] = step;
                if (step instanceof RulesStep) {
                    _this.rulesStep = step;
                }
            }
            if (step.isActive()) {
                _this.currentStep = step;
                step.$root.css('display', 'block'); // Fix first transition bug
            }
        });
        // ..
        // Fullscreen
        //
        this.$toggleFullScreen = this.$root.select("[data-role=\"" + exports.DATA_ROLE_FULLSCREEN + "\"]");
        this.$toggleFullScreen.on('click', function () {
            _this.toggleFullScreen();
        });
        // ..
        // Rules
        //
        this.$root.select("[data-role=\"" + exports.DATA_ROLE_RULES_TOGGLE + "\"]").on('click', function (e) {
            e.preventDefault();
            _this.toggleRules();
        });
        // ..
        // Keyboard Navigation
        //
        $(document.body).on('keydown', function (e) {
            if (!_this.isFullScreen) {
                return;
            }
            switch (e.keyCode) {
                case 27:
                    _this.toggleFullScreen();
                    break;
            }
        });
        // ..
        // Ask server what is the current step
        //
        this.setLoading(true);
        this.askServerForCurrentStep();
    }
    Contest.prototype.buildStep = function (elem) {
        var $elem = $(elem);
        var type = $elem.attr('data-step-type');
        if (!type) {
            return null;
        }
        switch (type) {
            case 'form':
                return new FormStep(elem, this);
            case 'rules':
                return new RulesStep(elem, this);
            case 'login':
                return new LoginStep(elem, this);
            case 'simple':
                return new SimpleStep(elem, this);
            default:
                return null;
        }
    };
    Contest.prototype.askServerForCurrentStep = function () {
        var _this = this;
        http.put(this.buildCurrentStepUrl()).end(function (err, res) {
            var payload = (res && res.body && res.body.payload) ? res.body.payload : {};
            if (err) {
                _this.setLoading(false);
                // @TODO Erreur, currentStep should be defined
                if (_this.currentStep && _this.currentStep.setError) {
                    _this.currentStep.setError(payload);
                }
            }
            else {
                _this.setLoading(false);
                _this.goToStep(res.body.step, payload);
            }
        });
    };
    Contest.prototype.goToStep = function (where, data) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            if (!_this.canTransitionTo(where)) {
                reject();
            }
            else {
                _this.isInTransition = true;
                var nextStep_1 = _this.steps[where];
                _this.currentStep.beforeFadeOutTransition();
                nextStep_1.beforeFadeInTransition();
                nextStep_1.setData(data);
                setTimeout(function () {
                    _this.currentStep.afterFadeOutTransition();
                    nextStep_1.afterFadeInTransition();
                    _this.isInTransition = false;
                    _this.currentStep = nextStep_1;
                    resolve();
                }, exports.TRANSITION_DURATION);
            }
        });
    };
    Contest.prototype.transitionTo = function (target, data) {
        var _this = this;
        data = data ? data : {};
        this.setLoading(true);
        http.put(this.buildTransitionUrl(target)).send(data).end(function (err, res) {
            if (err) {
                _this.setLoading(false);
                _this.currentStep.setError(res.body);
            }
            else {
                _this.setLoading(false);
                _this.goToStep(target, res.body);
            }
        });
    };
    Contest.prototype.canTransitionTo = function (where) {
        if (typeof where !== 'string') {
            return false;
        }
        if (this.isInTransition) {
            return false;
        }
        if (this.currentStep.name === where) {
            return false;
        }
        return (this.steps[where] !== undefined);
    };
    Contest.prototype.buildTransitionUrl = function (where) {
        return this.service + "/move?from=" + this.currentStep.name + "&to=" + where;
    };
    Contest.prototype.buildCurrentStepUrl = function () {
        return this.service + "/current";
    };
    Contest.prototype.toggleFullScreen = function () {
        var $body = $('body');
        var $icon = this.$toggleFullScreen.select('.icon');
        if (this.isFullScreen) {
            $body.removeClass(exports.CLASS_BODY_FULLSCREEN);
            this.$root.removeClass('contest__fullscreen');
            $icon.removeClass('icon-fullscreen-off').addClass('icon-fullscreen');
            this.isFullScreen = false;
        }
        else {
            $body.addClass(exports.CLASS_BODY_FULLSCREEN);
            this.$root.addClass('contest__fullscreen');
            $icon.removeClass('icon-fullscreen').addClass('icon-fullscreen-off');
            this.isFullScreen = true;
        }
    };
    Contest.prototype.toggleRules = function () {
        if (this.rulesStep.isActive()) {
            this.goToStep(this.previousStep.name, {});
            this.previousStep = null;
        }
        else {
            this.previousStep = this.currentStep;
            this.goToStep(this.rulesStep.name, {});
        }
    };
    Contest.prototype.setLoading = function (loading) {
        if (loading) {
            this.$root.addClass(exports.CLASS_LOADING);
        }
        else {
            this.$root.removeClass(exports.CLASS_LOADING);
        }
    };
    return Contest;
}());
// ..
// Steps
//
var BaseStep = /** @class */ (function () {
    function BaseStep(elem, contest) {
        this.$root = $(elem);
        this.name = this.$root.attr('data-step');
        this.contest = contest;
        this.$error = this.$root.select("[data-role=\"" + exports.DATA_ROLE_ERROR + "\"]");
    }
    BaseStep.prototype.isActive = function () {
        return this.$root.hasClass(exports.CLASS_STEP_ACTIVE);
    };
    BaseStep.prototype.setActive = function (active) {
        if (active) {
            this.$root.addClass(exports.CLASS_STEP_ACTIVE);
        }
        else {
            this.$root.removeClass(exports.CLASS_STEP_ACTIVE);
        }
    };
    BaseStep.prototype.hide = function () {
        this.$root.css('display', 'none');
    };
    BaseStep.prototype.show = function () {
        this.$root.css('display', 'block');
    };
    BaseStep.prototype.beforeFadeOutTransition = function () {
        this.setActive(false);
    };
    BaseStep.prototype.afterFadeOutTransition = function () {
        this.hide();
    };
    BaseStep.prototype.beforeFadeInTransition = function () {
        this.show();
        this.$root.css('height', '0');
    };
    BaseStep.prototype.afterFadeInTransition = function () {
        this.setActive(true);
        this.$root.css('height', '100%');
    };
    BaseStep.prototype.setData = function (data) {
    };
    BaseStep.prototype.setError = function (error) {
        if (!this.$error.isEmpty() && error && error.message) {
            this.$error.text(error.message);
        }
    };
    return BaseStep;
}());
var RulesStep = /** @class */ (function (_super) {
    __extends(RulesStep, _super);
    function RulesStep(elem, contest) {
        var _this = _super.call(this, elem, contest) || this;
        _this.$root.select("[data-role=\"" + exports.DATA_ROLE_RULES_CLOSE + "\"]").on('click', function (e) {
            e.preventDefault();
            _this.contest.toggleRules();
        });
        return _this;
    }
    return RulesStep;
}(BaseStep));
var SimpleStep = /** @class */ (function (_super) {
    __extends(SimpleStep, _super);
    function SimpleStep(elem, contest) {
        var _this = _super.call(this, elem, contest) || this;
        _this.$root.select("[data-step-target]").forEach(function (elem) {
            var $elem = $(elem);
            var target = $elem.attr('data-step-target');
            if (!target) {
                return;
            }
            $(elem).on('click', function (e) {
                e.preventDefault();
                _this.contest.transitionTo(target);
            });
        });
        return _this;
    }
    return SimpleStep;
}(BaseStep));
var FormStep = /** @class */ (function (_super) {
    __extends(FormStep, _super);
    function FormStep(elem, contest) {
        var _this = _super.call(this, elem, contest) || this;
        _this.$form = _this.$root.select('form');
        _this.$form.on('submit', function (e) {
            e.preventDefault();
            var target = _this.$form.attr('data-step-target');
            _this.setErrorText('');
            _this.contest.transitionTo(target, _this.getData());
        });
        return _this;
    }
    FormStep.prototype.getData = function () {
        var data = {};
        this.getFields().forEach(function (field) { return data[field.name] = field.value; });
        return data;
    };
    FormStep.prototype.setData = function (data) {
        data = data || {};
        this.getFields().forEach(function (field) {
            field.value = data[field.name] ? data[field.name] : '';
        });
    };
    FormStep.prototype.setError = function (error) {
        if (error.fields && Object.keys(error.fields).length > 0) {
            var name_1 = Object.keys(error.fields)[0];
            this.setErrorText(name_1 + ': ' + error.fields[name_1]);
        }
        else if (error.message) {
            this.setErrorText(error.message);
        }
        else {
            this.setErrorText('erreur inattendue');
        }
    };
    FormStep.prototype.setErrorText = function (text) {
        this.$error.css('display', text == '' ? 'none' : 'inline');
        this.$error.text(text);
    };
    FormStep.prototype.getFields = function () {
        return this.$form.select('input[type="text"], input[type="checkbox"]');
    };
    return FormStep;
}(BaseStep));
var LoginStep = /** @class */ (function (_super) {
    __extends(LoginStep, _super);
    function LoginStep(elem, contest) {
        var _this = _super.call(this, elem, contest) || this;
        _this.$root.select("[data-step-target]").forEach(function (elem) {
            var $elem = $(elem);
            var target = $elem.attr('data-step-target');
            if (!target) {
                return;
            }
            $(elem).on('click', function (e) {
                e.preventDefault();
                _this.contest.transitionTo(target);
            });
        });
        return _this;
    }
    LoginStep.prototype.setData = function (data) {
        if (data && data.profile && data.profile.email) {
            this.$root.select('.login-email').text(data.profile.email);
            this.$root.select('[data-login-state="logged-in"]').css('display', 'block');
        }
        else {
            this.$root.select('[data-login-state="logged-off"]').css('display', 'block');
        }
    };
    return LoginStep;
}(BaseStep));

},{"kawabunga/assets/js/utils/dom":71,"promise":178,"superagent":187}],230:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var $ = require("kawabunga/assets/js/utils/dom");
var overlay_gallery_1 = require("../../widget/overlay-gallery");
exports.DATA_ROLE = {
    ROOT: 'media-gallery',
    SLIDER: 'media-gallery-slider',
    SLIDER_CONTAINER: 'media-gallery-slider-container',
    PREV: 'media-gallery-prev',
    NEXT: 'media-gallery-next'
};
function initAll() {
    $("[data-role=\"" + exports.DATA_ROLE.ROOT + "\"]").forEach(init);
}
exports.initAll = initAll;
function init(elem) {
    return new MediaGallery(elem);
}
exports.init = init;
var MediaGallery = /** @class */ (function () {
    function MediaGallery(elem) {
        var _this = this;
        this.$root = $(elem);
        this.$slider = this.$root.select("[data-role=\"" + exports.DATA_ROLE.SLIDER + "\"]");
        if (!this.$slider.isEmpty()) {
            this.slider = new SlidingGallery(this.$slider);
            /* Changement de comportement : ouverture overlay au lieu de slider */
            if (!this.slider.$next.isEmpty()) {
                this.slider.$next.on('click', function (e) {
                    e.preventDefault();
                    if (_this.overlay && _this.overlay.openOverlay) {
                        _this.overlay.openOverlay();
                    }
                });
            }
        }
        var target = this.$root.attr('data-target');
        var $overlay = target ? $('#' + target) : null;
        if (!$overlay.isEmpty()) {
            this.overlay = new overlay_gallery_1.OverlayGallery($overlay[0]);
            this.$root.select('.media-item').forEach(function (item, index) {
                $(item).on('click', function (e) {
                    e.preventDefault();
                    _this.overlay.goToItem(index);
                    _this.overlay.openOverlay();
                });
            });
        }
    }
    return MediaGallery;
}());
exports.MediaGallery = MediaGallery;
var SlidingGallery = /** @class */ (function () {
    function SlidingGallery($elem) {
        this.$root = $elem;
        this.$container = this.$root.select("[data-role=\"" + exports.DATA_ROLE.SLIDER_CONTAINER + "\"]");
        this.$items = this.$root.select('.media-item');
        this.$prev = this.$root.select("[data-role=\"" + exports.DATA_ROLE.PREV + "\"]");
        this.$next = this.$root.select("[data-role=\"" + exports.DATA_ROLE.NEXT + "\"]");
        if (!this.$container.length || !this.$items.length) {
            return;
        }
        this.currentIndex = 0;
        this.maxIndex = this.$items.length - 1;
        this.refreshSliderSizes();
        if (!this.$prev.isEmpty()) {
            this.$prev[0].style.display = 'block';
        }
        if (!this.$next.isEmpty()) {
            this.$next[0].style.display = 'block';
        }
        /*
         = La gallerie format carousel a ete developpe
         = simplification demande, mais je garde le code, ca peut resservir
         this.$prev.on('click', (e) => {
         e.stopPropagation();
         this.slideToPreviousIndex();
         });
         this.$next.on('click', (e) => {
         e.stopPropagation();
         this.slideToNextIndex();
         });
         */
        // On resize
        (function () {
            var resizeTimeout;
            var onResize = (function () {
                this.refreshSliderSizes();
                this.maxIndex = this.$items.length - 1;
                this.slideToIndex(this.currentIndex);
            }).bind(this);
            window.addEventListener('resize', function () {
                if (!resizeTimeout) {
                    resizeTimeout = setTimeout(function () {
                        resizeTimeout = null;
                        onResize();
                    }, 66);
                }
            });
        }).apply(this);
    }
    ;
    SlidingGallery.prototype.refreshSliderSizes = function () {
        this.computedWidth = this.computeItemsWidth();
        this.containerWidth = this.computedWidth[this.computedWidth.length - 1];
        this.sliderWidth = this.$root.css('width');
        this.$container.css('width', this.containerWidth);
    };
    ;
    SlidingGallery.prototype.computeItemsWidth = function () {
        var widths = [0];
        var delta = 0;
        this.$items.forEach(function (item, index) {
            var $item = $(item);
            var m = $item.css('margin-right');
            var w = Math.round($item.css('width'));
            delta += ($item.css('width') - w);
            widths.push(w + m + widths[index]);
        });
        if (delta > 0) {
            widths.push(widths[widths.length - 1] + Math.ceil(delta));
        }
        return widths;
    };
    ;
    SlidingGallery.prototype.slideToIndex = function (index) {
        var left = (-1 * this.computedWidth[index]);
        if (left < (this.sliderWidth - this.containerWidth)) {
            left = (this.sliderWidth - this.containerWidth);
            this.maxIndex = index;
        }
        this.$container.css('left', left + 'px');
        this.currentIndex = index;
    };
    ;
    SlidingGallery.prototype.slideToPreviousIndex = function () {
        this.slideToIndex((this.currentIndex - 1 >= 0) ? this.currentIndex - 1 : 0);
    };
    ;
    SlidingGallery.prototype.slideToNextIndex = function () {
        this.slideToIndex((this.currentIndex + 1 <= this.maxIndex) ? this.currentIndex + 1 : this.maxIndex);
    };
    ;
    return SlidingGallery;
}());

},{"../../widget/overlay-gallery":278,"kawabunga/assets/js/utils/dom":71}],231:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var $ = require("kawabunga/assets/js/utils/dom");
var scriptLoader = require("kawabunga/assets/js/utils/script-loader");
var http = require("superagent");
var config = require("../../config/config");
var cnil_1 = require("kawabunga/assets/js/cnil/cnil");
var cnil_v2_1 = require("../../common/cnil-v2");
var didomi_1 = require("kawabunga/assets/js/cmp/didomi");
var PATTERN = /<body[^>]*>((.|[\n\r])*)<\/body>/im;
var insertList = [];
exports.init = function () {
    $('div.' + config.brandName + '-idalgo').forEach(function (item) {
        var insert = new PartnerIdalgo(item);
        insert.init();
        insertList.push(insert);
    });
};
var PartnerIdalgo = /** @class */ (function () {
    function PartnerIdalgo(item) {
        var _this = this;
        this.item = item;
        this.loadScript = function () {
            // ensure banner is hidden
            _this.hideCnilbanner();
            var url = _this.$root[0].getAttribute('data-url');
            http.get(url).end(function (err, res) {
                if (res) {
                    _this.processResponse(res.text);
                }
            });
        };
        this.injectDidomiBanner = function () {
            cnil_1.cnil.banner.injectBanner({
                $container: _this.$parent,
                html: cnil_v2_1.didomiBannerHTML({
                    modifierClass: 'cnil-banner-v2--post border-0',
                    message: cnil_v2_1.ANALYTICS_MESSAGE,
                    category: didomi_1.Purpose.ANALYTICS
                })
            });
        };
        this.$root = $(item);
        this.$parent = this.$root.parent();
    }
    PartnerIdalgo.prototype.init = function () {
        didomi_1.CmpDidomi.doOnDidomiConsent(didomi_1.Purpose.ANALYTICS, this.loadScript, this.injectDidomiBanner);
    };
    PartnerIdalgo.prototype.processResponse = function (text) {
        var item = this.$root[0];
        var array_matches = PATTERN.exec(text);
        item.innerHTML = "&nbsp;" + array_matches[1];
        var $scripts = $(item).select('script');
        $scripts.forEach(function (item) {
            item.parentNode.removeChild(item);
            scriptLoader.ensureLoaded(item.src);
        });
    };
    PartnerIdalgo.prototype.hideCnilbanner = function () {
        this.$parent.select('[data-role=cnil-banner]').css('display', 'none');
    };
    return PartnerIdalgo;
}());
exports.PartnerIdalgo = PartnerIdalgo;
cnil_1.cnil.cookie.onChange(function () { return insertList.forEach(function (insert) { return insert.init(); }); });

},{"../../common/cnil-v2":208,"../../config/config":218,"kawabunga/assets/js/cmp/didomi":57,"kawabunga/assets/js/cnil/cnil":64,"kawabunga/assets/js/utils/dom":71,"kawabunga/assets/js/utils/script-loader":77,"superagent":187}],232:[function(require,module,exports){
"use strict";
/**
 * Load Qualifio using async mode
 */
Object.defineProperty(exports, "__esModule", { value: true });
var $ = require("kawabunga/assets/js/utils/dom");
var scriptLoader = require("kawabunga/assets/js/utils/script-loader");
var config = require("../../config/config");
var cnil_1 = require("kawabunga/assets/js/cnil/cnil");
var cnil_v2_1 = require("../../common/cnil-v2");
var didomi_1 = require("kawabunga/assets/js/cmp/didomi");
var insertList = [];
exports.init = function () {
    $('.js-qualifio').forEach(function (item) {
        if (item.id) {
            var insert = new PartnerQualifio(item);
            insert.init();
            insertList.push(insert);
        }
    });
};
var PartnerQualifio = /** @class */ (function () {
    function PartnerQualifio(item) {
        var _this = this;
        this.item = item;
        this.loadScript = function () {
            // ensure banner is hidden
            _this.hideCnilbanner();
            var qualifioDomain = 'qualifio.' + config.brandName + '.fr';
            scriptLoader.ensureLoaded('https://' + qualifioDomain + '/kit/qualp.2.min.js').then(function () {
                window._qual_async.push(['createIframe', _this.item.id, qualifioDomain, _this.item.getAttribute('data-version'), _this.item.getAttribute('data-guid'), _this.item.getAttribute('data-width'), _this.item.getAttribute('data-height'), '']);
            });
        };
        this.injectDidomiBanner = function () {
            cnil_1.cnil.banner.injectBanner({
                $container: _this.$parent,
                html: cnil_v2_1.didomiBannerHTML({
                    modifierClass: 'cnil-banner-v2--post border-0',
                    message: cnil_v2_1.ANALYTICS_MESSAGE,
                    category: didomi_1.Purpose.ANALYTICS
                })
            });
        };
        this.$root = $(item);
        this.$parent = this.$root.parent();
    }
    PartnerQualifio.prototype.init = function () {
        didomi_1.CmpDidomi.doOnDidomiConsent(didomi_1.Purpose.ANALYTICS, this.loadScript, this.injectDidomiBanner);
    };
    PartnerQualifio.prototype.hideCnilbanner = function () {
        this.$parent.select('[data-role=cnil-banner]').css('display', 'none');
    };
    ;
    return PartnerQualifio;
}());
exports.PartnerQualifio = PartnerQualifio;
cnil_1.cnil.cookie.onChange(function () { return insertList.forEach(function (insert) { return insert.init(); }); });

},{"../../common/cnil-v2":208,"../../config/config":218,"kawabunga/assets/js/cmp/didomi":57,"kawabunga/assets/js/cnil/cnil":64,"kawabunga/assets/js/utils/dom":71,"kawabunga/assets/js/utils/script-loader":77}],233:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var http = require("superagent");
var $ = require("kawabunga/assets/js/utils/dom");
var $quizzForm;
var fieldArray = [];
var appendNextStep = function (html) {
    var lengthList = $quizzForm.selectByClass('question').length;
    $($quizzForm.selectByClass('question')[lengthList - 1]).after(html);
};
var showNextQuestion = function (url) {
    http.get(url).end(function (err, res) {
        appendNextStep(res.text);
        exports.init();
    });
};
var handleQuestion = function () {
    $quizzForm.selectByClass('input-radio').on('click', function (e) {
        var input = e.target;
        var field = $(input).parent('.list');
        if (fieldArray.indexOf(field[0]) === -1) {
            fieldArray.push(field[0]);
            var url = field.attr('data-url');
            if (url) {
                showNextQuestion(url);
            }
            else {
                handleForm();
            }
        }
    });
};
var getDataFrom = function () {
    var data = {};
    var $quizzInput = $('.input-radio');
    $quizzInput.forEach(function (input) {
        var $input = $(input);
        if ($input.attr('checked')) {
            data[$input.attr('name')] = $input.value();
        }
        $input.attr('disabled', 'disabled');
    });
    return data;
};
var handleForm = function () {
    var url = $quizzForm.attr('action');
    http.post(url).type('form').send(getDataFrom()).end(function (err, res) {
        appendNextStep(res.text);
    });
};
exports.init = function () {
    $quizzForm = $('[data-role="quizz"]');
    if (!$quizzForm) {
        return false;
    }
    handleQuestion();
};
exports.init();

},{"kawabunga/assets/js/utils/dom":71,"superagent":187}],234:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var $ = require("kawabunga/assets/js/utils/dom");
var debounce_1 = require("kawabunga/assets/js/utils/debounce");
var AD_MARGIN = 20;
var CLASS_NAME = {
    AD: 'g-aside-ad',
    STICKY: 'g-aside-ad--sticky',
};
exports.DATA_ROLE = {
    HEADER: 'main-header',
    ROOT: 'sticky-ads',
    ASIDE: 'sticky-ads-aside',
    ITEM: 'sticky-ads-item'
};
function init() {
    return new StickyAds($("[data-role=" + exports.DATA_ROLE.ROOT + "]"));
}
exports.init = init;
var StickyAds = /** @class */ (function () {
    function StickyAds($root) {
        var _this = this;
        this.$root = $root;
        this.$aside = this.$root.select("[data-role=" + exports.DATA_ROLE.ASIDE + "]");
        this.$items = this.$aside.select("[data-role=" + exports.DATA_ROLE.ITEM + "]");
        this.$header = $("[data-role=" + exports.DATA_ROLE.HEADER + "]");
        if (this.$aside.isEmpty() || this.$items.isEmpty()) {
            return;
        }
        window.addEventListener('scroll', function () {
            _this.checkAds();
        });
        window.addEventListener('resize', debounce_1.default(function () {
            _this.checkAds();
        }, 300));
        this.checkAds();
    }
    StickyAds.prototype.checkAds = function () {
        var _this = this;
        this.$items.forEach(function (ad, index) {
            if (ad.classList.contains(CLASS_NAME.AD)) {
                _this.checkAd(ad, index);
            }
        });
    };
    StickyAds.prototype.checkAd = function (ad, index) {
        var $ad = $(ad);
        var $child = $ad.select("div.ad-sumo, div.ad-pave");
        var headerHeight = this.$header.bounds().height + AD_MARGIN;
        var adHeight = $child.bounds().height ? $child.bounds().height + AD_MARGIN : 250 + AD_MARGIN;
        if ($ad.bounds().top <= headerHeight) {
            var spaceBeforeBoundBottom = (this.$items[index + 1]) ? $(this.$items[index + 1]).bounds().top : this.$root.bounds().bottom;
            var adTop = spaceBeforeBoundBottom - adHeight;
            $ad.addClass(CLASS_NAME.STICKY);
            $child.css('top', (adTop < headerHeight) ? adTop : headerHeight);
        }
        else {
            $ad.removeClass(CLASS_NAME.STICKY);
        }
    };
    return StickyAds;
}());
exports.StickyAds = StickyAds;

},{"kawabunga/assets/js/utils/debounce":70,"kawabunga/assets/js/utils/dom":71}],235:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var $ = require("kawabunga/assets/js/utils/dom");
var http = require("superagent");
var ensure = require("../../boot/ensure");
var DATA_ROLE = {
    ROOT: 'timeline-comments',
    FORM: 'timeline-comments-form',
    LOGIN: 'timeline-comments-login'
};
var CLASS_DISPLAY_NONE = 'd-none';
function init() {
    var $list = $('#timeline-list');
    var url = $list.data('url');
    if (url) {
        http.get(url).end(function (err, res) {
            if (res && res.text) {
                $list.html(res.text);
            }
        });
    }
    var $root = $("[data-role=" + DATA_ROLE.ROOT + "]");
    var $form = $root.select("[data-role=" + DATA_ROLE.FORM + "]");
    var $login = $root.select("[data-role=" + DATA_ROLE.LOGIN + "]");
    ensure.profileIsLoaded().then(function (profileData) {
        if (profileData) {
            $form.removeClass(CLASS_DISPLAY_NONE);
        }
        else {
            $login.removeClass(CLASS_DISPLAY_NONE);
        }
    }).catch(function () {
        $login.removeClass(CLASS_DISPLAY_NONE);
    });
}
exports.init = init;
init();

},{"../../boot/ensure":204,"kawabunga/assets/js/utils/dom":71,"superagent":187}],236:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var listing_more_1 = require("../../widget/listing-more");
listing_more_1.attachToButton('timeline-list', 'js-timeline-more');

},{"../../widget/listing-more":273}],237:[function(require,module,exports){
/*  BASED ON :
 *  File: iframeSizer.js
 *  Desc: Force cross domain iframes to size to content.
 *  Requires: iframeResizer.contentWindow.js to be loaded into the target frame.
 *  Author: David J. Bradshaw - dave@bradshaw.net
 *  Contributor: Jure Mav - jure.mav@gmail.com
 */
var count = 0;
var msgId = '[RTLNETiFrameSizer]'; //Must match iframe msg ID
var msgIdLen = msgId.length;
var page = ':' + location.href; //Uncomment to debug nested iFrames
var resetRequiredMethods = { max: 1, scroll: 1, bodyScroll: 1, documentElementScroll: 1 };
var settings = {};
var defaults = {
    autoResize: true,
    checkOrigin: true,
    heightCalculationMethod: 'offset',
    messageCallback: function () {
    },
    resizedCallback: function () {
    },
    scrolling: false,
    sizeHeight: true
};
var iFrameResize;
var createNativePublicFunction = function () {
    function init(element) {
        if ('IFRAME' !== element.tagName) {
            throw new TypeError('Expected <IFRAME> tag, found <' + element.tagName + '>.');
        }
        else {
            setupIFrame.call(element);
        }
    }
    function processOptions(options) {
        options = options || {};
        if ('object' !== typeof options) {
            throw new TypeError('Options is not an object.');
        }
        for (var option in defaults) {
            if (defaults.hasOwnProperty(option)) {
                settings[option] = options.hasOwnProperty(option) ? options[option] : defaults[option];
            }
        }
    }
    iFrameResize = function iFrameResizeF(options, selecter) {
        if (typeof Array.prototype.forEach != 'function') {
            Array.prototype.forEach = function (callback) {
                for (var i = 0; i < this.length; i++) {
                    callback.apply(this, [this[i], i, this]);
                }
            };
        }
        processOptions(options);
        Array.prototype.forEach.call(document.querySelectorAll(selecter || 'iframe'), init);
    };
};
var setSize = function (messageData) {
    if (settings.sizeHeight) {
        messageData.iframe.style['height'] = messageData['height'] + 'px';
    }
};
var syncResize = function (func, messageData, doNotSync) {
    if (doNotSync !== messageData.type) {
        window.requestAnimationFrame(func);
    }
    else {
        func();
    }
};
var trigger = function (calleeMsg, msg, iframe) {
    iframe.contentWindow.postMessage(msgId + msg, '*');
};
var setupIFrame = function () {
    function ensureHasId(iframeID) {
        if ('' === iframeID) {
            iframe.id = iframeID = 'iFrameResizer' + count++;
        }
        return iframeID;
    }
    function setScrolling() {
        iframe.style.overflow = false === settings.scrolling ? 'hidden' : 'auto';
        iframe.scrolling = false === settings.scrolling ? 'no' : 'yes';
    }
    function createOutgoingMsg() {
        return iframeID +
            ':' + settings.sizeWidth +
            ':' + settings.autoResize +
            ':' + settings.heightCalculationMethod;
    }
    function init(msg) {
        //We have to call trigger twice, as we can not be sure if all
        //iframes have completed loading when this code runs. The
        //event listener also catches the page changing in the iFrame.
        iframe.addEventListener('load', function () {
            trigger('iFrame.onload', msg, iframe);
        });
    }
    var iframe = this;
    var iframeID = ensureHasId(iframe.id);
    setScrolling();
    init(createOutgoingMsg());
};
var iFrameListener = function (event) {
    var msg = event.data;
    var messageData = {};
    function resizeIFrame() {
        function resize() {
            setSize(messageData);
        }
        syncResize(resize, messageData, 'resetPage');
    }
    function processMsg() {
        var data = msg.substr(msgIdLen).split(':');
        return {
            iframe: document.getElementById(data[0]),
            id: data[0],
            height: data[1]
        };
    }
    function actionMsg() {
        switch (messageData.type) {
            case 'message':
                forwardMsgFromIFrame();
                break;
            default:
                resizeIFrame();
                settings.resizedCallback(messageData);
        }
    }
    function isMessageFromIFrame() {
        var origin = event.origin;
        var remoteHost = messageData.iframe.src.split('/').slice(0, 3).join('/');
        if (settings.checkOrigin) {
            if (('' + origin !== 'null') && (origin !== remoteHost)) {
                throw new Error('Unexpected message received from: ' + origin +
                    ' for ' + messageData.iframe.id +
                    '. Message was: ' + event.data);
            }
        }
        return true;
    }
    function isMessageForUs() {
        return msgId === ('' + msg).substr(0, msgIdLen); //''+Protects against non-string msg
    }
    function isMessageFromMetaParent() {
        //test if this message is from a parent above us.
        return messageData.type in { 'true': 1, 'false': 1 };
    }
    function forwardMsgFromIFrame() {
        var receivedMsg = msg.substr(msg.lastIndexOf(':') + 1);
        settings.messageCallback({
            iframe: messageData.iframe,
            message: receivedMsg
        });
    }
    function checkIFrameExists() {
        if (null === messageData.iframe) {
            throw new Error('iFrame (' + messageData.id + ') does not exist on ' + page);
        }
        return true;
    }
    if (isMessageForUs()) {
        messageData = processMsg();
        if (!isMessageFromMetaParent() && checkIFrameExists() && isMessageFromIFrame()) {
            actionMsg();
        }
    }
};
window.addEventListener('message', iFrameListener);
createNativePublicFunction();
iFrameResize({});

},{}],238:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var GigyaAccounts;
(function (GigyaAccounts) {
    GigyaAccounts.getTokenJWT = function () {
        return new Promise(function (resolve, reject) {
            window.gigya.accounts.getJWT({
                fields: 'profile.email,data.mailVerified',
                callback: function (result) {
                    switch (result.status) {
                        case 'OK':
                            resolve(result);
                            break;
                        case 'FAIL':
                            reject(new Error("Gigya error code " + result.errorCode + " : " + result.errorMessage));
                            break;
                        default:
                            reject();
                    }
                }
            });
        });
    };
    GigyaAccounts.getTokenJWT_onLogin = function () {
        return new Promise(function (resolve, reject) {
            window.gigya.accounts.addEventHandlers({
                onLogin: function () { return GigyaAccounts.getTokenJWT().then(resolve).catch(reject); }
            });
            window.onGigyaServiceReady = function () {
                setTimeout(function () { reject('Passmedia: getTokenJWT response timed out [onGigyaServiceReady]'); }, 500);
            };
        });
    };
    GigyaAccounts.sendValidationEmail = function (email) {
        window.gigya.accounts.resendVerificationCode({
            email: email
        });
    };
})(GigyaAccounts = exports.GigyaAccounts || (exports.GigyaAccounts = {}));

},{}],239:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var env = require("kawabunga/assets/js/env/env");
var custom_popup_1 = require("../popup/custom-popup");
var passmedia_1 = require("./passmedia");
var gigya_accounts_1 = require("./gigya-accounts");
var PassMediaCtrl;
(function (PassMediaCtrl) {
    var passmedia = new passmedia_1.PassMedia();
    PassMediaCtrl.init = function () {
        return new Promise(function (resolve) {
            if (!passmedia.isAuthorizedToLoad()) {
                resolve(false);
                return;
            }
            passmedia.loadGigya()
                .then(window.passmediaSkipOnLogin ? gigya_accounts_1.GigyaAccounts.getTokenJWT : gigya_accounts_1.GigyaAccounts.getTokenJWT_onLogin)
                .then(passmedia.requestAutologin)
                .then(handleAutologinApproval)
                .then(resolve)
                .catch(function (err) {
                resolve(false);
            });
        });
    };
    var handleAutologinApproval = function (res) {
        passmedia.token = res.token;
        return new Promise(function (resolve) {
            switch (res.body.type) {
                case passmedia_1.Response.ASK_EMAIL:
                    resolve(false);
                    PassMediaCtrl.displayVerifyEmailPopup(res.body.email);
                    break;
                case passmedia_1.Response.REQUEST_APPROVAL:
                    PassMediaCtrl.displayLoginPopup(resolve);
                    break;
                case passmedia_1.Response.LOGIN_SUCCESS:
                    passmedia.createSession(res.body.s_id, res.body.access_token).then(function () {
                        resolve(true);
                    });
                    if (window.passmediaSkipOnLogin) {
                        PassMediaCtrl.displayFeedbackPopup("Vous \u00EAtes connect\u00E9 avec PassMedia");
                    }
                    break;
                case passmedia_1.Response.ERROR:
                    resolve(false);
                    break;
                case passmedia_1.Response.PREVENT_LOGIN:
                    resolve(false);
                    break;
                default:
                    resolve(false);
            }
        });
    };
    PassMediaCtrl.displayLoginPopup = function (resolve) {
        var requestLogin = function () {
            if (env.getEnv() == 'prod' || env.getEnv() == 'lab') {
                passmedia.requestLogin().then(function (result) { return PassMediaCtrl.handleLogin(result, resolve); });
            }
            else {
                console.log('REQUEST LOGIN');
                PassMediaCtrl.displayFeedbackPopup("Vous \u00EAtes connect\u00E9");
            }
        };
        // todo fill CGU link
        new custom_popup_1.default({
            type: 'passmediaLogin',
            onOk: requestLogin,
            delay: 8,
            afterDelay: requestLogin,
            onClose: function () {
            }
        });
    };
    PassMediaCtrl.handleLogin = function (res, resolve) {
        switch (res.body.type) {
            case passmedia_1.Response.ASK_EMAIL:
                resolve(false);
                PassMediaCtrl.displayVerifyEmailPopup(res.body.email);
                break;
            case passmedia_1.Response.LOGIN_SUCCESS:
                passmedia.createSession(res.body.s_id, res.body.access_token).then(function () {
                    resolve(true);
                });
                PassMediaCtrl.displayFeedbackPopup("Vous \u00EAtes connect\u00E9");
                break;
            case passmedia_1.Response.ERROR:
                resolve(false);
                break;
            default:
                resolve(false);
        }
    };
    PassMediaCtrl.displayVerifyEmailPopup = function (email) {
        new custom_popup_1.default({
            type: 'passmediaVerifyEmail',
            data: {
                email: email,
            },
            onOk: function () {
                gigya_accounts_1.GigyaAccounts.sendValidationEmail(email);
                PassMediaCtrl.displayFeedbackPopup("Un email vous a \u00E9t\u00E9 envoy\u00E9 \u00E0 l'adresse suivante <strong>" + email + "</strong>");
            }
        });
    };
    PassMediaCtrl.displayFeedbackPopup = function (text) {
        new custom_popup_1.default({
            type: 'passmediaFeedback',
            data: {
                text: text
            }
        });
    };
    PassMediaCtrl.createLoginSession = function (sessionId, accessToken, resolve) {
        resolve(true);
    };
})(PassMediaCtrl = exports.PassMediaCtrl || (exports.PassMediaCtrl = {}));

},{"../popup/custom-popup":252,"./gigya-accounts":238,"./passmedia":241,"kawabunga/assets/js/env/env":65}],240:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var env = require("kawabunga/assets/js/env/env");
var getKey = function () {
    if (env.isProd()) {
        return '3_60SXoNbTGCWPNC88AYot1x5s9teB6yw-u3RobuN3qli0bobrJSy7dbiZRaWU51L5';
    }
    else {
        return '3_TSaCp1yTOdQ0e56_96DV8zptdNiZLAhjFuSVBO7ajhmXtwo8HAkG2mklLPxzKmhE';
    }
};
var api = function (path) {
    if (env.isProd()) {
        return 'https://connect.rtl.fr/passmedia' + path;
    }
    else {
        return 'https://connect-pp.rtl.fr/passmedia' + path;
    }
};
var wwwApi = function (path) {
    if (env.isProd()) {
        return 'https://www.rtl.fr/connect' + path;
    }
    else {
        return 'https://www.lab.rtl.fr/connect' + path;
    }
};
exports.API = {
    GIGYA_KEY: getKey(),
    AUTOLOGIN: api('/autologin'),
    LOGIN: api('/login'),
    CREATE_SESSION: wwwApi('/createSession')
};

},{"kawabunga/assets/js/env/env":65}],241:[function(require,module,exports){
"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var env = require("kawabunga/assets/js/env/env");
var http = require("superagent");
var scriptLoader = require("kawabunga/assets/js/utils/script-loader");
var passmedia_env_1 = require("./passmedia-env");
var Response;
(function (Response) {
    Response["ASK_EMAIL"] = "ASK_FOR_EMAIL_VERIFICATION";
    Response["REQUEST_APPROVAL"] = "REQUEST_APPROVAL";
    Response["LOGIN_SUCCESS"] = "LOGIN_SUCCESS";
    Response["ERROR"] = "ERROR_INVALID_REQUEST";
    Response["PREVENT_LOGIN"] = "PREVENT_LOGIN";
})(Response = exports.Response || (exports.Response = {}));
var PassMedia = /** @class */ (function () {
    function PassMedia() {
    }
    Object.defineProperty(PassMedia.prototype, "token", {
        set: function (token) {
            this._token = token;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PassMedia.prototype, "state", {
        get: function () {
            return {
                emailVerified: this.emailVerified
            };
        },
        enumerable: true,
        configurable: true
    });
    PassMedia.prototype.loadGigya = function () {
        return scriptLoader.ensureLoaded("https://cdns.gigya.com/js/gigya.js?apikey=" + passmedia_env_1.API.GIGYA_KEY);
    };
    PassMedia.prototype.requestAutologin = function (result) {
        return new Promise(function (resolve, reject) {
            if (!result) {
                reject();
            }
            if (!('id_token' in result)) {
                resolve(false);
            }
            var params = {
                'token': result.id_token,
                'disableCapping': window.passmediaSkipOnLogin || false
            };
            http.post(passmedia_env_1.API.AUTOLOGIN)
                .withCredentials()
                .type('json')
                .send(params)
                .end(function (err, res) {
                resolve(__assign({}, res, params));
            });
        });
    };
    PassMedia.prototype.requestLogin = function () {
        var params = { 'token': this._token };
        return new Promise(function (resolve) {
            http.post(passmedia_env_1.API.LOGIN)
                .withCredentials()
                .type('json')
                .send(params)
                .end(function (err, res) {
                resolve(res);
            });
        });
    };
    PassMedia.prototype.createSession = function (sessionId, accessToken) {
        var params = { 'sessionId': sessionId, 'accessToken': accessToken };
        return new Promise(function (resolve) {
            http.post(passmedia_env_1.API.CREATE_SESSION)
                .withCredentials()
                .type('json')
                .send(params)
                .end(function (err, res) {
                resolve();
            });
        });
    };
    PassMedia.prototype.isAuthorizedToLoad = function () {
        if (env.getRenaissanceDomain() !== 'RTL') {
            return false;
        }
        else if (window.passmediaSkipOnLogin) {
            return true;
        }
        return !window.passmediaDisabled;
    };
    return PassMedia;
}());
exports.PassMedia = PassMedia;

},{"./passmedia-env":240,"kawabunga/assets/js/env/env":65,"kawabunga/assets/js/utils/script-loader":77,"superagent":187}],242:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * dailymotion script injector
 * sdk : https://developer.dailymotion.com/tools/sdks
 */
var scriptLoader = require("kawabunga/assets/js/utils/script-loader");
exports.SCRIPT_PATH = window.document.location.protocol + '//api.dmcdn.net/all.js';
var STATE = {
    NOT_INJECTED: 'NOT_INJECTED',
    INJECTED: 'INJECTED',
    LOADED: 'LOADED'
};
var loadingState = STATE.NOT_INJECTED;
var loadingQueue = [];
var oldDmAsyncInit = window.dmAsyncInit;
window.dmAsyncInit = function () {
    if (typeof oldDmAsyncInit !== 'undefined') {
        oldDmAsyncInit();
    }
    loadingState = STATE.LOADED;
    unqueueCallbacks();
};
exports.init = function () {
    loadingState = STATE.NOT_INJECTED;
};
exports.init();
exports.ensureScriptIsLoaded = function (callback) {
    if (loadingState == STATE.NOT_INJECTED) {
        loadingState = STATE.INJECTED;
        queueCallback(callback);
        scriptLoader.ensureLoaded(exports.SCRIPT_PATH);
    }
    else if (loadingState == STATE.INJECTED) {
        queueCallback(callback);
        // wait for dmAsyncInit to be called
    }
    else if (loadingState == STATE.LOADED) {
        if (callback) {
            callback();
        }
    }
};
var queueCallback = function (callback) {
    if (callback) {
        loadingQueue.push(callback);
    }
};
var unqueueCallbacks = function () {
    loadingQueue.forEach(function (callback) {
        callback();
    });
};

},{"kawabunga/assets/js/utils/script-loader":77}],243:[function(require,module,exports){
"use strict";
/**
 * dailymotion api wrapper
 * sdk : https://developer.dailymotion.com/tools/sdks
 */
Object.defineProperty(exports, "__esModule", { value: true });
var defaultsDeep = require("lodash/defaultsDeep");
var dmplayerScript = require("./dmplayer-script");
exports.ID_GENERATION_PREFIX = 'media_engine_dm_id_';
// http://www.dailymotion.com/doc/api/player.html
var DEFAULT_OPTIONS = {
    // 'video': null,
    'width': '100%',
    'height': '100%',
    'params': {
        'autoplay-mute': false,
        'webkit-playsinline': true
    }
};
var counter = 0;
exports.ensureScriptIsLoaded = function (callback) {
    dmplayerScript.ensureScriptIsLoaded(callback);
};
exports.createPlayer = function (where, options, callback) {
    if (!window.DM) {
        return;
    }
    // dailymotion API needs a unique identifier
    if (!where.getAttribute('id')) {
        counter += 1;
        where.setAttribute('id', exports.ID_GENERATION_PREFIX + counter);
    }
    var player = window.DM.player(where, options);
    if (callback) {
        player.addEventListener('apiready', function (e) {
            callback(new DMPlayerWrapper(player));
        });
    }
};
exports.mergeWithDefaultConfig = function (config) {
    return defaultsDeep(config, DEFAULT_OPTIONS);
};
var DMPlayerWrapper = /** @class */ (function () {
    function DMPlayerWrapper(api) {
        this.api = api;
    }
    DMPlayerWrapper.prototype.destroy = function () {
        this.api.src = "";
    };
    DMPlayerWrapper.prototype.onPlay = function (callback) {
        this.api.addEventListener('playing', callback);
    };
    DMPlayerWrapper.prototype.onPause = function (callback) {
        this.api.addEventListener('pause', callback);
    };
    DMPlayerWrapper.prototype.onEnd = function (callback) {
        this.api.addEventListener('ended', callback);
    };
    DMPlayerWrapper.prototype.onAdPlay = function (callback) {
        this.api.addEventListener('ad_play', callback);
    };
    DMPlayerWrapper.prototype.play = function () {
        this.api.play();
    };
    DMPlayerWrapper.prototype.pause = function () {
        this.api.pause();
    };
    DMPlayerWrapper.prototype.stop = function () {
        // no stop on api
        this.api.pause();
    };
    DMPlayerWrapper.prototype.isPlaying = function () {
        return !this.api.paused;
    };
    return DMPlayerWrapper;
}());
exports.DMPlayerWrapper = DMPlayerWrapper;

},{"./dmplayer-script":242,"lodash/defaultsDeep":159}],244:[function(require,module,exports){
"use strict";
/**
 * vast configuration (ads) for jwp
 */
Object.defineProperty(exports, "__esModule", { value: true });
var env = require("kawabunga/assets/js/env/env");
var random = require("kawabunga/assets/js/utils/random");
var userAgent = require("kawabunga/assets/js/env/user-agent");
var eventCollector = require("../tracking/event-collector");
var cookies = require("js-cookie");
exports.M6_CALL_TEMPLATE = 'https://7cbf2.v.fwmrm.net/ad/g/1?nw=510962&prof=510962:m6_rtl_live&resp=vast3&flag=+exvt+sltp-slcb+emcr&metr=1023&csid=@CSID@&caid=@CAID@&pvrn=@RANDOM1@&vprn=@RANDOM2@';
function getReplayPrerollTag(count) {
    var result = '';
    if (count == 1 || count == 2) {
        result = m6url({ live: false, count: count });
    }
    else {
        result = m6url({ live: false, count: 0 });
    }
    result = result.concat(typeof window.spotx_url_fragment != "undefined" ? window.spotx_url_fragment : '');
    return result;
}
exports.getReplayPrerollTag = getReplayPrerollTag;
function getLivePrerollTag() {
    var result = '';
    result = m6url({ live: true, count: 2 });
    result = result.concat(typeof window.spotx_url_fragment != "undefined" ? window.spotx_url_fragment : '');
    return result;
}
exports.getLivePrerollTag = getLivePrerollTag;
function getSite() {
    var site = env.getSite();
    if (env.isAppwebview()) {
        site = 'www.mobilertl.fr';
    }
    return site;
}
function getM6Site() {
    return env.getSite();
}
function getCsid(config) {
    var device = userAgent.isMobile() ? 'webmobile' : 'desktop';
    if (userAgent.isMobile() && env.isAppwebview()) {
        device = 'inapp';
    }
    return getM6Site() + '_' + device + '_jwplayer_' + (config.live ? 'live' : 'replay');
}
function m6url(config) {
    return exports.M6_CALL_TEMPLATE
        .replace(/@CSID@/, getCsid(config))
        .replace(/@CAID@/, 'clip_rtl_' + config.count)
        .replace(/@RANDOM1@/, random.digits(12))
        .replace(/@RANDOM2@/, random.digits(12));
}
exports.m6url = m6url;
function getReplayPrerollAdvertisingConfig(count, zoneId) {
    if (count == 0) {
        return {};
    }
    return getPrerollAdvertisingVastConfig(zoneId);
    // let config: any = getPrerollAdvertisingConfig({live: false, count: count});
    //
    // if (typeof window.spotx_url_fragment != "undefined") {
    //     if (typeof config.freewheel.custom == "undefined") {
    //         config.freewheel.custom = {};
    //     }
    //     config.freewheel.custom.spotx_bid = window.spotx_url_fragment.split(';')[1].split('&')[0].split('=')[1];
    //     config.freewheel.custom.spotx_ad_key = window.spotx_url_fragment.split(';')[1].split('&')[1].split('=')[1];
    // }
    //
    // return config;
}
exports.getReplayPrerollAdvertisingConfig = getReplayPrerollAdvertisingConfig;
function getLivePrerollAdvertisingConfig() {
    return getPrerollAdvertisingConfig({ live: true, count: 2 });
}
exports.getLivePrerollAdvertisingConfig = getLivePrerollAdvertisingConfig;
function getPrerollAdvertisingConfig(config) {
    var conf = {
        skipoffset: null,
        schedule: {
            adbreak1: {
                offset: 'pre',
                tag: ''
            }
        },
        client: 'freewheel',
        freewheel: {
            networkid: 510962,
            // The 'adManagerUrl' specified below should
            // be the URL you receive from Freewheel.
            adManagerUrl: "https://mssl.fwmrm.net/libs/adm/6.24.0/AdManager.js",
            serverid: "https://7cbf2.v.fwmrm.net/ad/g/1",
            profileid: "510962:m6_jw_html5_live",
            sectionid: getCsid(config)
        }
    };
    if (eventCollector.getDeviceId()) {
        if (typeof conf.freewheel.custom == "undefined") {
            conf.freewheel.custom = {};
        }
        conf.freewheel.custom._fw_vcid2 = eventCollector.getDeviceId();
    }
    return conf;
}
exports.getPrerollAdvertisingConfig = getPrerollAdvertisingConfig;
function getPrerollAdvertisingVastConfig(zoneId) {
    var conf = {
        client: 'vast',
        skipoffset: null,
        adscheduleid: randomAdscheduleid(),
        schedule: [
            {
                "tag": getVastTagUrl(zoneId)
            }
        ]
    };
    return conf;
}
exports.getPrerollAdvertisingVastConfig = getPrerollAdvertisingVastConfig;
function randomAdscheduleid() {
    var length = 8;
    var chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
    var result = '';
    for (var i = 0; i < length; i++) {
        result += chars[Math.round(Math.random() * (chars.length - 1))];
    }
    return result;
}
function getVastTagUrl(zoneId) {
    var template = "https://rtlfr.deliveryengine.adswizz.com/vast/4.0/request?aw_0_1st.adEvents=%5b%7b%22zoneId%22:%22[ZONE_ID]%22%7d%5d&aisDelivery=streaming&duration=31000&aw_0_req.userConsentV2=[USER_CONSENT]&aw_0_1st.playerId=[PLAYER_ID]";
    template = template.replace("[ZONE_ID]", getZoneId(zoneId));
    template = template.replace("[USER_CONSENT]", getUserConsent());
    template = template.replace("[PLAYER_ID]", getPlayerId());
    return template;
}
function getUserConsent() {
    return cookies.get('euconsent-v2') || '';
}
function getZoneId(zoneId) {
    if (zoneId) {
        return zoneId;
    }
    // default zone id by domain
    if (env.getRenaissanceDomain() == 'RTL2') {
        return "1081";
    }
    else if (env.getRenaissanceDomain() == 'FUN_RADIO') {
        return "1083";
    }
    else {
        return "1069";
    }
}
function getPlayerId() {
    if (env.getRenaissanceDomain() == 'RTL2') {
        return "rtl2_web_onDemand";
    }
    else if (env.getRenaissanceDomain() == 'FUN_RADIO') {
        return "fun_web_onDemand";
    }
    else {
        return "rtl_web_onDemand";
    }
}

},{"../tracking/event-collector":259,"js-cookie":46,"kawabunga/assets/js/env/env":65,"kawabunga/assets/js/env/user-agent":66,"kawabunga/assets/js/utils/random":76}],245:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var env = require("kawabunga/assets/js/env/env");
var estat = require("kawabunga/assets/js/tracking/estat-v6");
var config = require("../config/config");
exports.attachLivePlayer = function (player, stream) {
    estat.ensureLoaded().then(function () {
        var adEnded = false;
        player.onPlay(function () {
            adEnded = true;
        });
        var getState = function () {
            return (adEnded && player.isPlaying()) ? "play" : "pause";
        };
        var estatConfig = {
            serial: getSerial(),
            measure: 'streaming',
            streaming: {
                diffusion: 'live',
                streamName: 'Player Live ' + config.brandNameUpper,
                streamGenre: 'live',
                playerName: 'jwplayer',
                callbackState: getState,
                probe: true
            },
            levels: {
                level_1: config.domain,
                level_2: null,
                level_3: 'Ecoutez ' + config.brandName + ' en direct',
                level_4: null,
                level_5: 'audio'
            },
            newLevels: {
                newLevel_1: null,
                newLevel_2: 'natif',
                newLevel_3: (stream.files && stream.files.length > 0) ? stream.files[0].file : '',
                newLevel_4: stream.label,
                newLevel_5: null,
                newLevel_6: null,
                newLevel_7: null,
                newLevel_8: null,
                newLevel_9: null,
                newLevel_10: null,
                newLevel_11: null
            }
        };
        var tag = estat.createEstatTag(estatConfig);
        player.onIdle(function () { return tag.notifyPlayer('stop'); });
    });
};
exports.attachReplayPlayer = function (player, data) {
    estat.ensureLoaded().then(function () {
        var getPosition = function () {
            return player.getPosition();
        };
        var estatConfig = {
            serial: getSerial(),
            measure: 'streaming',
            streaming: {
                diffusion: "replay",
                streamName: data.title,
                streamDuration: data.duration,
                streamGenre: data.genre,
                playerName: 'jwplayer',
                callbackPosition: getPosition,
                probe: true
            },
            levels: {
                level_1: data.levels ? data.levels[0] : '',
                level_2: data.levels ? data.levels[1] : '',
                level_3: data.levels ? data.levels[2] : '',
                level_4: data.levels ? data.levels[3] : '',
                level_5: data.levels ? data.levels[4] : '' // audio / video
            },
            newLevels: {
                newLevel_1: null,
                newLevel_2: 'replay',
                newLevel_3: data.src,
                newLevel_4: null,
                newLevel_5: null,
                newLevel_6: null,
                newLevel_7: null,
                newLevel_8: null,
                newLevel_9: null,
                newLevel_10: null,
                newLevel_11: null
            }
        };
        var tag = estat.createEstatTag(estatConfig);
        player.onIdle(function () { return tag.notifyPlayer('stop'); });
    });
};
var getSerial = function () {
    switch (env.getSite()) {
        case 'www.funradio.fr':
            return '239039218626';
        default:
            return '254054218632';
    }
};

},{"../config/config":218,"kawabunga/assets/js/env/env":65,"kawabunga/assets/js/tracking/estat-v6":68}],246:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var scriptLoader = require("kawabunga/assets/js/utils/script-loader");
var config = require("../config/config");
var Promise = require("promise");
var defaultsDeep = require("lodash/defaultsDeep");
exports.JWPLAYER8_KEY = 'vdVfWJzg+SCw7E3DOR2GB9AXv9Oo0Gg6B68akw==';
var JWPLAYER_VERSION = '8.6.0';
var idCounter = 0;
/**
 * https://developer.jwplayer.com/jw-player/docs/developer-guide/customization/configuration-reference/
 *
 * autoplay on mobile : https://www.jwplayer.com/blog/mobile-web-autoplay/
 */
var DEFAULT_OPTIONS = {
    width: '100%',
    aspectratio: '16:9',
    primary: 'html5',
    autostart: 'false',
    localization: {
        play: "Play",
        playback: "Start playback",
        pause: "Pause",
        volume: "Volume",
        prev: "Précédent",
        next: "Suivant",
        cast: "Chromecast",
        fullscreen: "Fullscreen",
        playlist: "Playlist",
        hd: "Qualité",
        cc: "Closed captions",
        audioTracks: "Audio tracks",
        replay: "Replay",
        buffer: "Chargement",
        more: "Plus",
        liveBroadcast: "Direct",
        loadingAd: "Chargement Publicité",
        rewind: "Retour 10s",
        nextUp: "Next Up",
        related: "En relation"
    },
    advertising: {
        client: 'googima',
        skipoffset: 5,
        skipmessage: 'xx',
        skiptext: 'Ignorer',
        admessage: 'Votre programme commence dans xx seconde(s)',
        autoplayadsmuted: true,
        schedule: {
        // sample values
        /*
         'adbreak1': {
         'offset': 'pre',
         'tag': vastSetup.prerollLive
         },
         'adbreak2': {
         'offset': 'post',
         'tag': vastSetup.postrollLive
         }
         */
        }
    }
};
exports.setup = function () {
    return new Promise(function (resolve) {
        scriptLoader.ensureLoaded(getScriptPath()).then(function () {
            window.jwplayer.key = exports.JWPLAYER8_KEY;
            resolve();
        });
    });
};
exports.mergeWithDefaultConfig = function (config) { return defaultsDeep(config, DEFAULT_OPTIONS); };
function createPlayer(where, options) {
    return new Promise(function (resolve, reject) {
        if (!window.jwplayer) {
            reject("JWPlayer API isn't loaded or missing window.jwplayer");
            return;
        }
        // jwplayer API needs a unique identifier
        if (!where.getAttribute('id')) {
            where.setAttribute('id', nextId());
        }
        var api = window.jwplayer(where);
        api.setup(options);
        api.on('ready', function () {
            resolve(new JWPlayerWrapper(where, api));
        });
    });
}
exports.createPlayer = createPlayer;
function getScriptPath() {
    return config.jwplayer.staticRoot + '/' + JWPLAYER_VERSION + '/jwplayer.js?jw';
}
exports.getScriptPath = getScriptPath;
function nextId() {
    return "jwplayer8-" + idCounter++;
}
exports.nextId = nextId;
var JWPlayerWrapper = /** @class */ (function () {
    function JWPlayerWrapper(container, api) {
        this.api = api;
        this.container = container;
    }
    JWPlayerWrapper.prototype.destroy = function () {
        /**
         * Propagate a stop so estat know play has stopped
         */
        this.stop();
        this.api.remove();
    };
    JWPlayerWrapper.prototype.getContainer = function () { return this.container; };
    JWPlayerWrapper.prototype.getPosition = function () { return this.api.getPosition(); };
    JWPlayerWrapper.prototype.stop = function () { this.api.stop(); };
    JWPlayerWrapper.prototype.pause = function () { this.api.pause(); };
    JWPlayerWrapper.prototype.onPlay = function (callback) {
        var _this = this;
        this.api.on('play', function (obj) {
            if (_this.api.getState() == 'playing') {
                callback(obj);
            }
        });
    };
    JWPlayerWrapper.prototype.onPause = function (callback) { this.api.on('pause', callback); };
    JWPlayerWrapper.prototype.onIdle = function (callback) { this.api.on('idle', callback); };
    JWPlayerWrapper.prototype.onSeek = function (callback) { this.api.on('seek', callback); };
    JWPlayerWrapper.prototype.onBuffer = function (callback) { this.api.on('buffer', callback); };
    JWPlayerWrapper.prototype.onBufferChange = function (callback) { this.api.on('bufferChange', callback); };
    JWPlayerWrapper.prototype.onEnd = function (callback) { this.api.on('complete', callback); };
    JWPlayerWrapper.prototype.isPlaying = function () {
        /**
         * possible states: idle, buffering, playing and paused
         */
        switch (this.api.getState()) {
            case 'playing':
            case 'buffering':
                return true;
            default:
                return false;
        }
    };
    return JWPlayerWrapper;
}());
exports.JWPlayerWrapper = JWPlayerWrapper;

},{"../config/config":218,"kawabunga/assets/js/utils/script-loader":77,"lodash/defaultsDeep":159,"promise":178}],247:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CLASSNAME_PLAYER = 'm6player-iframe';
var M6Player = /** @class */ (function () {
    function M6Player(node, src) {
        this.root = node;
        this.src = src;
        this.player = document.createElement('iframe');
        this.player.setAttribute('allowfullscreen', '');
        this.player.setAttribute('mozallowfullscreen', '');
        this.player.setAttribute('webkitallowfullscreen', '');
        this.player.setAttribute('allow', 'encrypted-media');
        this.player.classList.add(exports.CLASSNAME_PLAYER);
        this.player.src = this.src;
        this.root.appendChild(this.player);
    }
    M6Player.prototype.destroy = function () {
        this.root.removeChild(this.player);
        this.player.src = '';
    };
    M6Player.prototype.isPlaying = function () {
        return true;
    };
    /**
     * postMessage
     **/
    M6Player.prototype.postMessage = function (msg) {
        this.player.contentWindow.postMessage(msg, '*');
    };
    M6Player.prototype.play = function () {
        this.postMessage('player:play');
    };
    M6Player.prototype.pause = function () {
        this.postMessage('player:pause');
    };
    M6Player.prototype.mute = function () {
        this.postMessage('player:mute');
    };
    M6Player.prototype.unMute = function () {
        this.postMessage('player:unMute');
    };
    M6Player.prototype.seekAt = function (timeCode) {
        this.postMessage("player:seekAt:" + timeCode);
    };
    M6Player.prototype.enterFullscreen = function () {
        this.postMessage('player:enterFullscreen');
    };
    M6Player.prototype.exitFullscreen = function () {
        this.postMessage('player:exitFullscreen');
    };
    return M6Player;
}());
exports.M6Player = M6Player;

},{}],248:[function(require,module,exports){
"use strict";
/**
 * youtube script injector
 * https://developers.google.com/youtube/iframe_api_reference?hl=fr
 */
Object.defineProperty(exports, "__esModule", { value: true });
var scriptLoader = require("kawabunga/assets/js/utils/script-loader");
exports.SCRIPT_PATH = window.document.location.protocol + '//www.youtube.com/iframe_api';
var STATE = {
    NOT_INJECTED: 'NOT_INJECTED',
    INJECTED: 'INJECTED',
    LOADED: 'LOADED'
};
var loadingState = STATE.NOT_INJECTED;
var loadingQueue = [];
//let oldOnYouTubeIframeAPIReady = window.onYouTubeIframeAPIReady;
exports.init = function () {
    loadingState = STATE.NOT_INJECTED;
};
exports.init();
exports.ensureScriptIsLoaded = function (callback) {
    if (loadingState == STATE.NOT_INJECTED) {
        loadingState = STATE.INJECTED;
        queueCallback(callback);
        window.onYouTubeIframeAPIReady = onYouTubeIframeAPIReady;
        scriptLoader.ensureLoaded(exports.SCRIPT_PATH);
    }
    else if (loadingState == STATE.INJECTED) {
        queueCallback(callback);
        // wait for onYouTubeIframeAPIReady to be called
    }
    else if (loadingState == STATE.LOADED) {
        if (callback) {
            callback();
        }
    }
};
var onYouTubeIframeAPIReady = function () {
    loadingState = STATE.LOADED;
    unqueueCallbacks();
};
var queueCallback = function (callback) {
    if (callback) {
        loadingQueue.push(callback);
    }
};
var unqueueCallbacks = function () {
    loadingQueue.forEach(function (callback) {
        callback();
    });
};

},{"kawabunga/assets/js/utils/script-loader":77}],249:[function(require,module,exports){
(function (__filename){
"use strict";
/**
 * youtube api wrapper
 */
Object.defineProperty(exports, "__esModule", { value: true });
var defaultsDeep = require("lodash/defaultsDeep");
var ytplayerScript = require("./ytplayer-script");
exports.ID_GENERATION_PREFIX = 'media_engine_yt_id_';
// https://developers.google.com/youtube/player_parameters?playerVersion=HTML5
var DEFAULT_OPTIONS = {
    // 'videoId'	 : null,
    'width': '100%',
    'height': '100%',
    'playerVars': {
        'autoplay': 0,
        'autohide': 1,
        'cc_load_policy': 0,
        'iv_load_policy': 3,
        'enablejsapi': 1,
        'showinfo': 0,
        'origin': window.document.location.protocol + '//' + window.document.location.hostname,
        'wmode': 'transparent'
    }
};
var counter = 0;
exports.ensureScriptIsLoaded = function (callback) {
    ytplayerScript.ensureScriptIsLoaded(callback);
};
exports.createPlayer = function (where, options, callback) {
    if (!window.YT) {
        console.warn("Youtube API is not loaded or missing window.YT", __filename);
        return;
    }
    // youtube API needs a unique identifier
    if (!where.getAttribute('id')) {
        counter += 1;
        where.setAttribute('id', exports.ID_GENERATION_PREFIX + counter);
    }
    var player;
    if (callback) {
        options.events = {
            onReady: function (e) {
                callback(new YTPlayerWrapper(player));
            }
        };
    }
    player = new window.YT.Player(where, options);
};
exports.mergeWithDefaultConfig = function (config) {
    return defaultsDeep(config, DEFAULT_OPTIONS);
};
var YTPlayerWrapper = /** @class */ (function () {
    function YTPlayerWrapper(api) {
        this.onPlayListeners = [];
        this.onPauseListeners = [];
        this.onEndListeners = [];
        this.api = api;
        var _this = this;
        api.addEventListener('onStateChange', function (e) {
            switch (e.data) {
                case 0:
                    _this.onEndListeners.forEach(function (listener) {
                        listener();
                    });
                    break;
                case 1:
                    _this.onPlayListeners.forEach(function (listener) {
                        listener();
                    });
                    break;
                case 2:
                    _this.onPauseListeners.forEach(function (listener) {
                        listener();
                    });
            }
        });
    }
    YTPlayerWrapper.prototype.destroy = function () {
        this.api.destroy();
    };
    YTPlayerWrapper.prototype.onPlay = function (callback) {
        this.onPlayListeners.push(callback);
    };
    YTPlayerWrapper.prototype.onPause = function (callback) {
        this.onPauseListeners.push(callback);
    };
    YTPlayerWrapper.prototype.onEnd = function (callback) {
        this.onEndListeners.push(callback);
    };
    YTPlayerWrapper.prototype.play = function () {
        this.api.playVideo();
    };
    YTPlayerWrapper.prototype.pause = function () {
        this.api.pauseVideo();
    };
    YTPlayerWrapper.prototype.stop = function () {
        this.api.stopVideo();
    };
    YTPlayerWrapper.prototype.isPlaying = function () {
        switch (this.api.getPlayerState()) {
            case 1:
            case 3:
                return true;
            default:
                return false;
        }
    };
    ;
    return YTPlayerWrapper;
}());
exports.YTPlayerWrapper = YTPlayerWrapper;

}).call(this,"/src/js/modules/player/ytplayer.ts")
},{"./ytplayer-script":248,"lodash/defaultsDeep":159}],250:[function(require,module,exports){
"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var popupViews = require("./custom-popup-views");
var popupInvoker = __assign({}, popupViews
/// ...otherViews
);
exports.renderer = {
    draw: function (name, args) {
        if (name in popupInvoker) {
            return popupInvoker[name].apply(popupInvoker, [].slice.call(arguments, 1));
        }
        return false;
    }
};

},{"./custom-popup-views":251}],251:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.passmediaLogin = function () { return "\n<div class=\"passmedia-popup\">\n    <div class=\"passmedia-popup__container\">\n        <span class=\"passmedia-popup__close\" data-role=\"cs-popup-close\">&times;</span>\n        <div class=\"passmedia-popup__side\">\n            <span class=\"icon icon-passmedia-logo-mini\"><span class=\"d-none\">PassMedia</span></span>\n        </div>\n        <div class=\"passmedia-popup__content\">\n            <div class=\"passmedia-popup__text\" >F\u00E9licitations,<br/> Vous b\u00E9n\u00E9ficiez d\u00E8s \u00E0 pr\u00E9sent d'un acc\u00E8s connect\u00E9 \u00E0 RTL</div>\n            <div class=\"passmedia-popup__btn-container\">\n                <button class=\"passmedia-btn passmedia-btn--secondary\" data-role=\"cs-popup-close\">NE PAS ME CONNECTER</button>\n                <button class=\"passmedia-btn passmedia-btn--primary\" data-role=\"cs-popup-ok\">OK</button>\n            </div>\n            <div class=\"passmedia-popup__cgu\">Consulter les <a href=\"/cnil/charte-de-confidentialite\">CGU de RTL</a></div>\n            <div class=\"progress\">\n                <div class=\"progress-bar bg-success\" role=\"progressbar\" aria-valuenow=\"0\" aria-valuemin=\"0\" aria-valuemax=\"100\"></div>\n            </div>\n        </div>\n    </div>\n</div>"; };
exports.passmediaVerifyEmail = function (_a) {
    var email = _a.email;
    return "\n<div class=\"passmedia-popup\">\n    <div class=\"passmedia-popup__container\">\n        <span class=\"passmedia-popup__close\" data-role=\"cs-popup-close\">&times;</span>\n        <div class=\"passmedia-popup__content\">\n            <div class=\"passmedia-popup__header-logo\">\n                <span class=\"icon icon-passmedia-logo\"><span class=\"d-none\">PassMedia</span></span>\n            </div>\n            <div class=\"passmedia-popup__title\">Session PassMedia d\u00E9tect\u00E9e</div>\n            <div class=\"passmedia-popup__text\">Vous disposez d\u00E9j\u00E0 d'un compte RTL avec l'adresse email <strong>" + (email ? email : '') + "</strong></div>\n            <div class=\"passmedia-popup__text\">Pour associer votre compte PassMedia avec votre compte RTL en toute s\u00E9curit\u00E9, validez votre email</div>\n            <div class=\"passmedia-popup__btn-container\">\n                <button class=\"passmedia-btn passmedia-btn--primary\" data-role=\"cs-popup-ok\">Recevoir le lien de v\u00E9rification</button>\n            </div>\n        </div>\n    </div>\n</div>";
};
exports.passmediaFeedback = function (_a) {
    var text = _a.text;
    return "\n<div class=\"passmedia-popup\">\n    <div class=\"passmedia-popup__container\">\n        <span class=\"passmedia-popup__close\" data-role=\"cs-popup-close\">&times;</span>\n        <div class=\"passmedia-popup__side\">\n            <span class=\"icon icon-passmedia-logo-mini\"><span class=\"d-none\">PassMedia</span></span>\n        </div>\n        <div class=\"passmedia-popup__content\">\n            <div class=\"passmedia-popup__text\">" + text + "</div>\n            <div class=\"passmedia-popup__btn-container\">\n                <button class=\"passmedia-btn passmedia-btn--primary\" data-role=\"cs-popup-ok\">Ok</button>\n            </div>\n        </div>\n    </div>\n</div>";
};
exports.invitation = function (_a) {
    var title = _a.title, text = _a.text;
    return "\n<div class=\"popup-invitation\">\n    <div class=\"popup-invitation__backdrop\" data-role=\"cs-popup-close\"></div>\n    <div class=\"popup-invitation__container\">\n        <span class=\"popup-invitation__close\" data-role=\"cs-popup-close\">&times;</span>\n        <div class=\"popup-invitation__logo\">\n            <i class=\"icon icon-ff icon-rtl-logo\"></i>\n        </div>\n        <div class=\"popup-invitation__content\">\n            <h3 class=\"popup-invitation__title\">" + title + "</h3>\n            <p class=\"popup-invitation__text\">" + text + "</p>\n            <div class=\"popup-invitation__btn\">\n                <a href=\"#\" class=\"popup-btn\" data-role=\"cs-popup-ok\">S'inscrire</a>\n            </div>\n        </div>\n    </div>\n</div>";
};

},{}],252:[function(require,module,exports){
"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var $ = require("kawabunga/assets/js/utils/dom");
var custom_popup_renderer_1 = require("./custom-popup-renderer");
var repeat_1 = require("../utils/repeat");
var noop = function () { };
var DEFAULT_OPTIONS = {
    type: '',
    onOk: noop,
    onClose: noop,
    afterDelay: noop
};
var CustomPopup = /** @class */ (function () {
    function CustomPopup(options) {
        if (options === void 0) { options = {}; }
        this._options = __assign({}, DEFAULT_OPTIONS, options);
        this.html = this.renderPopup();
        this.appendElementToDOM();
        this.attachEvents();
        CustomPopup.numberInstance++;
    }
    CustomPopup.prototype.renderPopup = function () {
        return custom_popup_renderer_1.renderer.draw(this._options.type, this._options.data);
    };
    CustomPopup.prototype.updateProgress = function (current, maxSeconds) {
        if (this.progressEl) {
            if (current === 1) {
                this.progressEl.style.width = this.progressEl.offsetWidth;
            }
            var progressPercentage = 100 * current / maxSeconds;
            this.progressEl.style.width = progressPercentage + "%";
        }
    };
    CustomPopup.prototype.appendElementToDOM = function () {
        var el = document.createElement('div');
        document.body.appendChild(el);
        el.innerHTML = this.html;
        this.$el = $(el).addClass('custom-popup');
        this.progressEl = this.$el[0].querySelector('.progress-bar');
    };
    CustomPopup.prototype.destroy = function () {
        CustomPopup.numberInstance--;
        this.$el[0].parentElement.removeChild(this.$el[0]);
    };
    CustomPopup.prototype.attachEvents = function () {
        var _this = this;
        var $btnOk = this.$el.select('[data-role="cs-popup-ok"]');
        $btnOk.on('click', function () {
            _this._options.onOk();
            _this._options.afterDelay = noop;
            _this.destroy();
        });
        var $btnClose = this.$el.select('[data-role="cs-popup-close"]');
        $btnClose.on('click', function () {
            _this._options.onClose();
            _this._options.afterDelay = noop;
            _this.destroy();
        });
        if (this._options.delay) {
            repeat_1.repeat(this._options.delay, 1000, function (elapsedTimes, maxTimes) { return _this.updateProgress(elapsedTimes, maxTimes); })
                .then(function () {
                _this._options.afterDelay();
                _this.destroy();
            })
                .catch(function () { return console.log("error"); });
        }
    };
    CustomPopup.hasInstance = function () {
        return CustomPopup.numberInstance > 0;
    };
    CustomPopup.numberInstance = 0;
    return CustomPopup;
}());
exports.default = CustomPopup;

},{"../utils/repeat":267,"./custom-popup-renderer":250,"kawabunga/assets/js/utils/dom":71}],253:[function(require,module,exports){
"use strict";
/**
 * social embeds in main column
 */
Object.defineProperty(exports, "__esModule", { value: true });
var $ = require("kawabunga/assets/js/utils/dom");
var cnil_1 = require("kawabunga/assets/js/cnil/cnil");
var cnil_cookie_1 = require("kawabunga/assets/js/cnil/cnil-cookie");
var cnil_v2_1 = require("../common/cnil-v2");
var didomi_1 = require("kawabunga/assets/js/cmp/didomi");
var embeds = [];
exports.init = function () {
    $('.js-embed').forEach(function (item) {
        var $item = $(item);
        var contentHTML = $item.attr('data-content');
        if (contentHTML) {
            var post = new SocialEmbeds($item, contentHTML);
            post.init();
            embeds.push(post);
        }
    });
};
cnil_1.cnil.cookie.onChange(function () { return embeds.forEach(function (post) { return post.init(); }); });
var SocialEmbeds = /** @class */ (function () {
    function SocialEmbeds($root, contentHTML) {
        var _this = this;
        this.$root = $root;
        this.contentHTML = contentHTML;
        this.injectDidomiBanner = function () {
            cnil_1.cnil.banner.injectBanner({
                $container: _this.$parent,
                html: cnil_v2_1.didomiBannerHTML({
                    message: cnil_v2_1.SOCIAL_MESSAGE,
                    modifierClass: 'cnil-banner-v2--post',
                    category: didomi_1.Purpose.SOCIAL
                })
            });
        };
        this.loadScript = function () {
            // ensure banner is hidden
            _this.hideCnilbanner();
            _this.$root[0].innerHTML = _this.contentHTML;
            _this.$root.css('display', 'block');
        };
        this.$parent = this.$root.parent();
        this.type = this.$root.attr('data-type');
        // this.$root.css('display', 'none');
    }
    SocialEmbeds.prototype.init = function () {
        didomi_1.CmpDidomi.doOnDidomiConsent(didomi_1.Purpose.SOCIAL, this.loadScript, this.injectDidomiBanner);
    };
    SocialEmbeds.prototype.hideCnilbanner = function () {
        this.$parent.select('[data-role=cnil-banner]').css('display', 'none');
    };
    SocialEmbeds.prototype.getBannerOptions = function () {
        return {
            $container: this.$parent,
            html: cnil_v2_1.cnilBannerHTML({
                message: cnil_v2_1.SOCIAL_MESSAGE,
                modifierClass: 'cnil-banner-v2--post',
                category: cnil_cookie_1.SOCIAL
            })
        };
    };
    return SocialEmbeds;
}());

},{"../common/cnil-v2":208,"kawabunga/assets/js/cmp/didomi":57,"kawabunga/assets/js/cnil/cnil":64,"kawabunga/assets/js/cnil/cnil-cookie":63,"kawabunga/assets/js/utils/dom":71}],254:[function(require,module,exports){
"use strict";
/**
 * social posts in main column
 */
Object.defineProperty(exports, "__esModule", { value: true });
var $ = require("kawabunga/assets/js/utils/dom");
var scriptLoader = require("kawabunga/assets/js/utils/script-loader");
var cnil_1 = require("kawabunga/assets/js/cnil/cnil");
var cnil_v2_1 = require("../common/cnil-v2");
var didomi_1 = require("kawabunga/assets/js/cmp/didomi");
var posts = [];
var SCRIPTS = {
    "twitter-script": 'https://platform.twitter.com/widgets.js',
    "instagram-script": 'https://platform.instagram.com/en_US/embeds.js',
};
exports.init = function () {
    $('.js-async').forEach(function (item) {
        var $item = $(item);
        var type = $item.attr('data-type');
        if (SCRIPTS[type]) {
            var post = new SocialPost($item, SCRIPTS[type]);
            post.init();
            posts.push(post);
        }
    });
};
cnil_1.cnil.cookie.onChange(function () { return posts.forEach(function (post) { return post.init(); }); });
var SocialPost = /** @class */ (function () {
    function SocialPost($root, scriptUrl) {
        var _this = this;
        this.$root = $root;
        this.scriptUrl = scriptUrl;
        this.injectDidomiBanner = function () {
            _this.$root.css('display', 'none');
            cnil_1.cnil.banner.injectBanner({
                $container: _this.$parent,
                html: cnil_v2_1.didomiBannerHTML({
                    message: cnil_v2_1.SOCIAL_MESSAGE,
                    modifierClass: 'cnil-banner-v2--post',
                    iconClass: cnil_v2_1.ICONS[_this.type],
                    category: didomi_1.Purpose.SOCIAL
                })
            });
        };
        this.loadScript = function () {
            // ensure banner is hidden
            _this.hideCnilbanner();
            scriptLoader.ensureLoaded(_this.scriptUrl);
            _this.$root.css('display', 'block');
        };
        this.$parent = this.$root.parent();
        this.type = this.$root.attr('data-type');
    }
    SocialPost.prototype.init = function () {
        didomi_1.CmpDidomi.doOnDidomiConsent(didomi_1.Purpose.SOCIAL, this.loadScript, this.injectDidomiBanner);
    };
    SocialPost.prototype.hideCnilbanner = function () {
        this.$parent.select('[data-role=cnil-banner]').css('display', 'none');
    };
    return SocialPost;
}());

},{"../common/cnil-v2":208,"kawabunga/assets/js/cmp/didomi":57,"kawabunga/assets/js/cnil/cnil":64,"kawabunga/assets/js/utils/dom":71,"kawabunga/assets/js/utils/script-loader":77}],255:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var $ = require("kawabunga/assets/js/utils/dom");
exports.DATA_ROLE = 'toggle-group';
exports.DATA_ROLE_BTN = 'toggle-btn';
exports.DATA_ROLE_CONTENT = 'toggle-content';
var CLASS_ACTIVE = 'btn-toggle--active';
var ToggleButton = /** @class */ (function () {
    function ToggleButton(toggleGroup, $elem) {
        var _this = this;
        this.$root = $elem;
        this.contents = toggleGroup.$root.select("[data-role=" + exports.DATA_ROLE_CONTENT + "]").filter(function (content) { return content.getAttribute('data-listen') == '#' + _this.$root[0].id; });
    }
    ToggleButton.prototype.isActive = function () {
        return this.$root.hasClass(CLASS_ACTIVE);
    };
    ToggleButton.prototype.setActive = function (active) {
        if (active) {
            this.$root.addClass(CLASS_ACTIVE);
        }
        else {
            this.$root.removeClass(CLASS_ACTIVE);
        }
    };
    ToggleButton.prototype.displayContent = function (display) {
        this.contents.forEach(function (content) {
            if (display) {
                $(content).removeClass('d-none');
            }
            else {
                $(content).addClass('d-none');
            }
        });
    };
    ToggleButton.prototype.isContentVisible = function () {
        return this.contents.filter(function (content) { return $(content).hasClass('d-none'); }).length == 0;
    };
    ToggleButton.prototype.getDebugState = function () {
        return {
            active: this.isActive(),
            contentVisible: this.isContentVisible()
        };
    };
    return ToggleButton;
}());
exports.ToggleButton = ToggleButton;
var ToggleGroup = /** @class */ (function () {
    function ToggleGroup($elem) {
        var _this = this;
        this.$root = $elem;
        this.buttons = [];
        this.$root.select("[data-role=" + exports.DATA_ROLE_BTN + "]").forEach(function (elem) {
            _this.buttons.push(new ToggleButton(_this, $(elem)));
        });
        this.$root.select("[data-role=" + exports.DATA_ROLE_BTN + "]").on('click', function (e) { return _this.selectBtn(e.target); });
    }
    ToggleGroup.prototype.selectBtn = function (elem) {
        this.buttons.forEach(function (btn) {
            btn.setActive(btn.$root[0] == elem);
            btn.displayContent(btn.$root[0] == elem);
        });
    };
    ToggleGroup.prototype.getDebugState = function () {
        return {
            buttons: this.buttons.map(function (btn) { return btn.getDebugState(); })
        };
    };
    return ToggleGroup;
}());
exports.ToggleGroup = ToggleGroup;
function init(elem) {
    if (elem) {
        return new ToggleGroup($(elem));
    }
    else {
        return null;
    }
}
exports.init = init;
function initAll() {
    $("[data-role=" + exports.DATA_ROLE + "]").forEach(init);
}
exports.initAll = initAll;

},{"kawabunga/assets/js/utils/dom":71}],256:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var env = require("kawabunga/assets/js/env/env");
var universalAnalytics = require("./universal-analytics");
var estatWhap = require("kawabunga/assets/js/tracking/estat-whap");
var chartbeat = require("./chartbeat");
var cedexisRadar = require("./cedexis-radar");
var hit = require("./hit");
var socialHitCount = require("./social-hitcount");
var gravity = require("./gravity");
var eventCollector = require("./event-collector");
var didomi_1 = require("kawabunga/assets/js/cmp/didomi");
var initialized = false;
var init = function () {
    initialized = true;
    universalAnalytics.init();
    chartbeat.init();
    if (env.getRenaissanceDomain() === 'RTL') {
        cedexisRadar.init();
    }
    if (env.getRenaissanceDomain() == 'RTL') {
        estatWhap.init();
    }
    socialHitCount.init();
    gravity.init();
};
didomi_1.CmpDidomi.doOnDidomiConsent(didomi_1.Purpose.ANALYTICS, init, function () {
});
// always hit
hit.init();
// always collect event
eventCollector.init();

},{"./cedexis-radar":257,"./chartbeat":258,"./event-collector":259,"./gravity":260,"./hit":261,"./social-hitcount":262,"./universal-analytics":263,"kawabunga/assets/js/cmp/didomi":57,"kawabunga/assets/js/env/env":65,"kawabunga/assets/js/tracking/estat-whap":69}],257:[function(require,module,exports){
"use strict";
/**
 * Manage page statistics
 */
Object.defineProperty(exports, "__esModule", { value: true });
var scriptLoader = require("kawabunga/assets/js/utils/script-loader");
exports.init = function () {
    scriptLoader.ensureLoaded('https://s3.amazonaws.com/cdx-radar/01-10120-radar10.min.js');
};

},{"kawabunga/assets/js/utils/script-loader":77}],258:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var scriptLoader = require("kawabunga/assets/js/utils/script-loader");
exports.init = function () {
    var chartbeat = document.querySelector('[data-role="chartbeat"]');
    if (chartbeat) {
        var sections = chartbeat.getAttribute('data-sections');
        var authors = chartbeat.getAttribute('data-authors');
        var _sf_async_config = window._sf_async_config || {};
        _sf_async_config.uid = 64269;
        _sf_async_config.domain = 'rtl.fr';
        _sf_async_config.useCanonical = true;
        _sf_async_config.flickerControl = false;
        _sf_async_config.sections = sections;
        _sf_async_config.authors = authors;
        scriptLoader.ensureLoaded('https://static.chartbeat.com/js/chartbeat_video.js');
    }
};

},{"kawabunga/assets/js/utils/script-loader":77}],259:[function(require,module,exports){
"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _this = this;
Object.defineProperty(exports, "__esModule", { value: true });
var env = require("kawabunga/assets/js/env/env");
var http = require("superagent");
var cookies = require("js-cookie");
var random = require("kawabunga/assets/js/utils/random");
var didomi_1 = require("kawabunga/assets/js/cmp/didomi");
var universal_analytics_1 = require("./universal-analytics");
exports.COOKIE_NAME = 'ec_id';
exports.SERVICE_URL = 'https://e.m6web.fr/event';
exports.SEVEN_DAYS = 7 * 24 * 60 * 60 * 1000;
var Service;
(function (Service) {
    Service["rtl"] = "rtl";
    Service["funradio"] = "funradio";
    Service["onrefaitlescourses"] = "onrefaitlescourses";
    Service["astro"] = "astro";
})(Service || (Service = {}));
exports.init = function () {
    didomi_1.CmpDidomi.attach('didomiOnReady', exports.readCookieAndSendEvent);
};
exports.readCookieAndSendEvent = function () { return __awaiter(_this, void 0, void 0, function () {
    var data, id;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                data = exports.readCookie();
                if (!(data && isOldCookie(data))) return [3 /*break*/, 2];
                data.date = new Date().getTime();
                writeCookie(data);
                return [4 /*yield*/, sendEvent()];
            case 1:
                _a.sent();
                return [3 /*break*/, 4];
            case 2:
                if (!!data) return [3 /*break*/, 4];
                id = random.uuid();
                writeCookie({ id: id, date: new Date().getTime() });
                return [4 /*yield*/, sendEvent()];
            case 3:
                _a.sent();
                _a.label = 4;
            case 4:
                universal_analytics_1.push({
                    'deviceId': exports.readCookie().deviceId,
                    'platformCode': 'm6group_web',
                    'event': 'userDeviceType'
                });
                return [2 /*return*/];
        }
    });
}); };
exports.onConsentChange = function () {
    if (env.getSite() != 'www.rtl.fr') {
        return;
    }
    sendEvent();
};
exports.readCookie = function () {
    return cookies.getJSON(exports.COOKIE_NAME);
};
exports.getDeviceId = function () {
    var cookie = exports.readCookie();
    if (!cookie) {
        return null;
    }
    return cookie.deviceId ? exports.readCookie().deviceId : null;
};
var writeCookie = function (data) {
    cookies.set(exports.COOKIE_NAME, data);
};
var isOldCookie = function (data) {
    return new Date().getTime() > data.date + exports.SEVEN_DAYS;
};
var sendEvent = function () {
    return new Promise(function (resolve, reject) {
        http.get(exports.SERVICE_URL + buildQueryParameters())
            .accept('json')
            .withCredentials()
            .end(function (err, res) {
            var data = exports.readCookie();
            data.deviceId = res.body.device_id;
            writeCookie(data);
            resolve();
        });
    });
};
var buildQueryParameters = function () {
    var data = buildEvent();
    return '?' + Object.keys(data).map(function (key) { return key + '=' + encodeURIComponent(data[key]); }).join('&');
};
var buildEvent = function () {
    return {
        customer: 'm6web',
        service: env.getSite() === 'www.funradio.fr' ? Service.funradio : Service.rtl,
        device_type: 'm6group_web',
        event_type: 'raw_user_consents',
        /*
        'uids[0][uid_type]': 'external',
        'uids[0][uid]': profile.id,
        */
        'data[consents_updated]': true,
        'data[analytics][consent]': didomi_1.CmpDidomi.isConsentedPurpose(didomi_1.Purpose.ANALYTICS),
        'data[analytics][form]': 'explicit',
        'data[adtargeting][consent]': didomi_1.CmpDidomi.isConsentedPurpose(didomi_1.Purpose.ADS),
        'data[adtargeting][form]': 'explicit',
        'data[socialnetwork][consent]': didomi_1.CmpDidomi.isConsentedPurpose(didomi_1.Purpose.SOCIAL),
        'data[socialnetwork][form]': 'explicit'
    };
};

},{"./universal-analytics":263,"js-cookie":46,"kawabunga/assets/js/cmp/didomi":57,"kawabunga/assets/js/env/env":65,"kawabunga/assets/js/utils/random":76,"superagent":187}],260:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var euconsent_cookie_1 = require("kawabunga/assets/js/cmp/euconsent-cookie");
var scriptLoader = require("kawabunga/assets/js/utils/script-loader");
exports.init = function () {
    if (checkConsent()) {
        window.grvt_customProperties = {};
        window.grvt_siteToken = 'rtl-18';
        window.grvt_processingToken = 'pennsylvania-apart';
        scriptLoader.ensureLoaded('https://tag.agrvt.com/tag/v2/wrapper.js');
    }
};
var checkConsent = function () {
    var consent = euconsent_cookie_1.euconsent.cookie.read();
    if (consent == null) {
        return false;
    }
    var purposes = consent.isPurposeAllowed(1) &&
        consent.isPurposeAllowed(2) &&
        consent.isPurposeAllowed(3) &&
        consent.isPurposeAllowed(4) &&
        consent.isPurposeAllowed(5);
    var vendor = consent.isVendorAllowed(501) && // gravity
        consent.isVendorAllowed(184); // mediarithmics
    return purposes && vendor;
};

},{"kawabunga/assets/js/cmp/euconsent-cookie":58,"kawabunga/assets/js/utils/script-loader":77}],261:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var http = require("superagent");
var $ = require("kawabunga/assets/js/utils/dom");
function hit(url) {
    http.get(url).end();
}
exports.findHits = function () {
    return $('[data-hit]').map(function (element) { return $(element).data('hit'); });
};
exports.init = function () {
    exports.findHits().forEach(hit);
};

},{"kawabunga/assets/js/utils/dom":71,"superagent":187}],262:[function(require,module,exports){
"use strict";
/**
 * Post a count request to backend after click event on social share elements
 */
Object.defineProperty(exports, "__esModule", { value: true });
var http = require("superagent");
var $ = require("kawabunga/assets/js/utils/dom");
var currentItemInfo = {};
exports.init = function () {
    var $socialHitcount = $('.js-social-hitcount');
    var url = $socialHitcount.data('hitcount-url');
    $socialHitcount.on('click', '.js-social-counter', function (e, socialCounter) {
        if ($(socialCounter).data('type') === "fb-share-gal") {
            e.stop();
            window.open(createFacebookGalleryUrl(socialCounter.href));
        }
        http.post(url).end();
    });
};
var createFacebookGalleryUrl = function (href) {
    return href.split('&redirect_uri')[0]
        + "&picture=" + encodeURIComponent(currentItemInfo.src)
        + "&description=" + encodeURIComponent(currentItemInfo.title)
        + "&redirect_uri" + href.split('&redirect_uri')[1];
};
exports.setCurrentItemInfo = function (itemInfo) {
    currentItemInfo = itemInfo;
};

},{"kawabunga/assets/js/utils/dom":71,"superagent":187}],263:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Push data to UniversalAnalytics
 */
var scriptLoader = require("kawabunga/assets/js/utils/script-loader");
/**
 * @param data object containing properties to send
 */
exports.push = function (data) {
    if (typeof window.dataLayer == 'undefined' || window.dataLayer == null) {
        return;
    }
    window.dataLayer.push(data);
};
var getConfigFromMarker = function () {
    var marker = window.document.getElementById('ua-marker');
    return marker ? {
        gtmId: marker.getAttribute('data-gtm-id'),
        push: marker.getAttribute('data-push'),
        domain: marker.getAttribute('data-domain')
    } : null;
};
function domainToSiteName(domain) {
    switch (domain) {
        case 'FUN_RADIO':
            return 'funRadio';
        case 'RTL':
            return 'rtl';
        default:
            return 'unknown';
    }
}
function websiteVersion() {
    if (window.innerWidth < 640) {
        return "mobile";
    }
    else if (window.innerWidth <= 960) {
        return "tablet";
    }
    else {
        return "desktop";
    }
}
exports.init = function () {
    var config = getConfigFromMarker();
    if (!config) {
        return;
    }
    window.dataLayer = [{
            "siteName": domainToSiteName(config.domain),
            "userAgent": window.navigator.userAgent,
            "websiteVersion": websiteVersion(),
            "pageType": "classique"
        }];
    exports.push(config.push);
    exports.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
    // universal analytics loaded through google tag manager
    scriptLoader.ensureLoaded("https://www.googletagmanager.com/gtm.js?id=" + config.gtmId);
};

},{"kawabunga/assets/js/utils/script-loader":77}],264:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.now = function () {
    return Date.now();
};

},{}],265:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.safeRead = function (input) {
    return input && input.trim() != '' ? new Date(parseInt(input)) : null;
};
exports.print = function (date) {
    var yyyy = date.getFullYear().toString();
    var mm = (date.getMonth() + 1).toString(); // getMonth() is zero-based
    var dd = date.getDate().toString();
    // padding
    return yyyy + (mm[1] ? mm : "0" + mm[0]) + (dd[1] ? dd : "0" + dd[0]);
};

},{}],266:[function(require,module,exports){
"use strict";
/**
 * geoloc utilities
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var http = require("superagent");
var browser = require("../boot/browser");
var env = require("kawabunga/assets/js/env/env");
var cookies = require("js-cookie");
var EMPTY_RESPONSE = {};
exports.supportsGeolocation = function () {
    return browser.hasTouch() == true && window.navigator.geolocation;
};
exports.getCurrentPosition = function (success, failure) {
    window.navigator.geolocation.getCurrentPosition(success, failure);
};
exports.fetchGeoInfo = function (callback) {
    if (exports.supportsGeolocation()) {
        exports.getCurrentPosition(function (currentPosition) { return doFetchGeoInfo(currentPosition, callback); }, function () { return callback(EMPTY_RESPONSE); });
    }
    else {
        doFetchGeoInfo(null, callback);
    }
};
exports.fetchGeoBoInfoWithLocation = function (location, callback) {
    var url = 'https://geo.bo.rtl.fr/stream/' + env.getRenaissanceDomain();
    if (location) {
        url += '/' + location;
    }
    if (env.isFlag('hls')) {
        url += '?hls=true';
    }
    var get = http.get(url).type('json');
    get.end(function (err, res) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!err) return [3 /*break*/, 1];
                        callback(EMPTY_RESPONSE);
                        return [3 /*break*/, 4];
                    case 1:
                        result = res.body;
                        if (!(result && result.stream && result.stream.files && result.stream.files.length > 0)) return [3 /*break*/, 3];
                        result = replaceWithStreamABC(result);
                        result = concatWithTrackedParams(result);
                        return [4 /*yield*/, concatWithConsentParams(result)];
                    case 2:
                        result = _a.sent();
                        _a.label = 3;
                    case 3:
                        callback(result);
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    });
};
exports.withParams = function (url, param) {
    return url.indexOf('?') != -1 ? url.concat('&' + param) : url.concat('?' + param);
};
var replaceWithStreamABC = function (result) {
    var STREAM_RTL = 'http://streaming.radio.funradio.fr/fun-1-44-128';
    var STREAM_ABC = 'http://m6.stream.vip/funradio/mp3-128/Website/';
    var funradioNatioStreamExists = result.stream.files.filter(function (f) { return f.file === STREAM_RTL; }).length > 0;
    if (funradioNatioStreamExists) {
        result.stream.files.find(function (f) { return f.file === STREAM_RTL; }).file = STREAM_ABC;
    }
    return result;
};
/*
    WEBDEV-4522
    Changement URL Icecast pour jwplayer RTL et FUN
 */
var concatWithTrackedParams = function (result) {
    var param = null;
    if (env.getRenaissanceDomain() == "RTL") {
        param = 'id=webRTL&aw_0_1st.playerId=playerliveRTL';
    }
    else if (env.getRenaissanceDomain() == "FUN_RADIO") {
        param = 'id=webFUNRADIO&aw_0_1st.playerId=playerliveFUNRADIO';
    }
    if (param != null) {
        for (var i = 0; i < result.stream.files.length; i++) {
            result.stream.files[i].file = exports.withParams(result.stream.files[i].file, param);
        }
    }
    return result;
};
var concatWithConsentParams = function (result) {
    return __awaiter(this, void 0, void 0, function () {
        var userConsent, i;
        return __generator(this, function (_a) {
            try {
                userConsent = exports.getUserConsent();
                for (i = 0; i < result.stream.files.length; i++) {
                    result.stream.files[i].file = exports.withParams(result.stream.files[i].file, 'aw_0_req.userConsentV2=' + userConsent);
                }
                return [2 /*return*/, result];
            }
            catch (e) {
                return [2 /*return*/, result];
            }
            return [2 /*return*/];
        });
    });
};
exports.getUserConsent = function () {
    return cookies.get('euconsent-v2') || '';
};
var doFetchGeoInfo = function (currentPosition, callback) {
    var location = null;
    if (currentPosition) {
        location = currentPosition.coords.latitude + ',' + currentPosition.coords.longitude;
    }
    exports.fetchGeoBoInfoWithLocation(location, callback);
};

},{"../boot/browser":203,"js-cookie":46,"kawabunga/assets/js/env/env":65,"superagent":187}],267:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var testing = function (elapsed, maxTimes) {
    return new Promise(function (resolve, reject) {
        (elapsed === maxTimes) ? resolve() : reject();
    });
};
exports.repeat = function (maxTimes, intervalMs, fn) {
    var elapsedTimes = 1;
    fn(elapsedTimes, maxTimes);
    return new Promise(function (resolve, reject) {
        var interval = setInterval(function () {
            testing(elapsedTimes, maxTimes).then(function () {
                clearInterval(interval);
                resolve();
            }).catch(function () {
                elapsedTimes++;
                fn(elapsedTimes, maxTimes);
            });
        }, intervalMs);
    });
};

},{}],268:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var observable_1 = require("kawabunga/assets/js/utils/observable");
var onTickObservable = new observable_1.Observable();
var ONE_MINUTE = 60000;
exports.onTick = function (observer) {
    onTickObservable.observe(observer);
};
/*
 * Global Timer, set to 1 minute
 */
exports.timer = setInterval(function () {
    onTickObservable.fire();
}, ONE_MINUTE);

},{"kawabunga/assets/js/utils/observable":75}],269:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var $ = require("kawabunga/assets/js/utils/dom");
var browser = require("../boot/browser");
var http = require("superagent");
var DATA_ROLE_LIST = 'comment-list';
var DATA_ROLE_OPEN = 'report-open';
var DATA_ROLE_CLOSE = 'report-close';
exports.initAll = function () {
    $("[data-role=\"" + DATA_ROLE_LIST + "\"]").forEach(exports.init);
};
exports.init = function (element) {
    if (typeof element === 'object') {
        return new ReportCommentOverlay(element);
    }
};
var ReportCommentOverlay = /** @class */ (function () {
    function ReportCommentOverlay(element) {
        var _this = this;
        this.$root = $(element);
        this.$overlay = $("#" + this.$root.data('target'));
        if (!this.$root.length || !this.$overlay.length) {
            return;
        }
        this.isOverlayDisplayed = false;
        var isTouchStart;
        var onClickOrTouch = function (callback) {
            return function (e) {
                switch (e.type) {
                    case browser.touchStart:
                        isTouchStart = true;
                        e.stop();
                        break;
                    case 'click':
                        var $texts = [];
                        var data = {};
                        if ($(e.target).data('role') == DATA_ROLE_OPEN) {
                            e.preventDefault();
                            $texts = $(e.target).parent('.post-content').select('.texts');
                            data = {
                                id: $(e.target).data('id'),
                                pseudo: $texts.select('.header').text(),
                                comment: $texts.select('.text').text()
                            };
                        }
                        _this.setFormData(data);
                        if (isTouchStart) {
                            isTouchStart = false;
                            return false;
                        }
                        break;
                }
                callback();
            };
        };
        var onOpen = onClickOrTouch(function () {
            _this.openOverlay();
        });
        var onClose = onClickOrTouch(function () {
            _this.closeOverlay();
        });
        // OPEN REPORT OVERLAY
        this.$root.on('click', "[data-role=\"" + DATA_ROLE_OPEN + "\"]", onOpen);
        this.$root.on(browser.touchStart, "[data-role=\"" + DATA_ROLE_OPEN + "\"]", onOpen);
        // CLOSE REPORT OVERLAY
        this.$overlay.on('click', "[data-role=\"" + DATA_ROLE_CLOSE + "\"]", onClose);
        this.$overlay.on(browser.touchStart, "[data-role=\"" + DATA_ROLE_CLOSE + "\"]", onClose);
        // SEND FORM
        this.$overlay.select('.report-submit').on('click', function (e) {
            e.preventDefault();
            _this.sendForm();
        });
    }
    ReportCommentOverlay.prototype.openOverlay = function () {
        $('body').addClass('overlay-open');
        this.$overlay.css('display', 'block');
        this.isOverlayDisplayed = true;
    };
    ReportCommentOverlay.prototype.closeOverlay = function () {
        $('body').removeClass('overlay-open');
        this.$overlay.css('display', 'none');
        this.isOverlayDisplayed = false;
        $('#form-report')[0].reset();
    };
    ReportCommentOverlay.prototype.setFormData = function (data) {
        var $form = $('#form-report');
        $form.select('input[name=commentId]').value(data.id);
        $form.select('.report-quote').text(data.pseudo);
        $form.select('.text').text(data.comment);
    };
    ReportCommentOverlay.prototype.getFormData = function (form) {
        var data = {};
        for (var i = 0; i < form.elements.length; i++) {
            var e = form.elements[i];
            if (e.value && (e.type !== "submit")) {
                if (e.name) {
                    data[e.name] = e.value;
                }
                else {
                    data[i] = e.value;
                }
            }
        }
        return data;
    };
    ;
    ReportCommentOverlay.prototype.sendForm = function () {
        var reportForm = $('#form-report')[0];
        var data = this.getFormData(reportForm);
        var $this = this;
        http.post(reportForm.getAttribute('action')).type('form').send(data).end(function (err, res) {
            $this.closeOverlay();
        });
    };
    return ReportCommentOverlay;
}());

},{"../boot/browser":203,"kawabunga/assets/js/utils/dom":71,"superagent":187}],270:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var $ = require("kawabunga/assets/js/utils/dom");
var clock = require("../utils/clock");
var http = require("superagent");
var Promise = require("promise");
var ONE_SECOND = 1000;
exports.init = function () {
    return $('[data-countdown]').map(function (element) {
        var countdown = exports.createCountdown(element);
        countdown.start();
        return countdown;
    });
};
exports.createCountdown = function (element) {
    return new Countdown(element);
};
var Countdown = /** @class */ (function () {
    function Countdown(element) {
        this.elements = this.fetchElementsFromHtml(element);
        this.endTime = this.getEndTime();
        this.srcHtml = this.elements.root.getAttribute('data-src-html');
        this.interval = null;
    }
    Countdown.prototype.fetchElementsFromHtml = function (element) {
        var digits = element.querySelectorAll('.digit');
        return {
            root: element,
            $days: [$(digits[0]), $(digits[1])],
            $hours: [$(digits[2]), $(digits[3])],
            $minutes: [$(digits[4]), $(digits[5])],
            $seconds: [$(digits[6]), $(digits[7])]
        };
    };
    Countdown.prototype.getTimeRemaining = function () {
        var diff = this.getDiffTime();
        return {
            ended: diff <= 0,
            time: {
                days: Math.floor(diff / (1000 * 60 * 60 * 24)),
                hours: Math.floor((diff / (1000 * 60 * 60)) % 24),
                minutes: Math.floor((diff / 1000 / 60) % 60),
                seconds: Math.floor((diff / 1000) % 60),
                total: diff
            }
        };
    };
    Countdown.prototype.getEndTime = function () {
        return new Date(parseInt(this.elements.root.getAttribute('data-end-date')));
    };
    Countdown.prototype.getDiffTime = function () {
        var diff = this.endTime.getTime() - clock.now();
        // round to upper second
        return Math.ceil(diff / 1000) * 1000;
    };
    Countdown.prototype.readHtml = function () {
        return {
            days: [this.elements.$days[0].text(), this.elements.$days[1].text()],
            hours: [this.elements.$hours[0].text(), this.elements.$hours[1].text()],
            minutes: [this.elements.$minutes[0].text(), this.elements.$minutes[1].text()],
            seconds: [this.elements.$seconds[0].text(), this.elements.$seconds[1].text()]
        };
    };
    Countdown.prototype.updateHtml = function () {
        var timeRemaining = this.getTimeRemaining();
        if (timeRemaining.time.total <= 0) {
            this.updateHtmlDigits(this.elements.$days, this.toDigits(0));
            this.updateHtmlDigits(this.elements.$hours, this.toDigits(0));
            this.updateHtmlDigits(this.elements.$minutes, this.toDigits(0));
            this.updateHtmlDigits(this.elements.$seconds, this.toDigits(0));
        }
        else {
            this.updateHtmlDigits(this.elements.$days, this.toDigits(timeRemaining.time.days));
            this.updateHtmlDigits(this.elements.$hours, this.toDigits(timeRemaining.time.hours));
            this.updateHtmlDigits(this.elements.$minutes, this.toDigits(timeRemaining.time.minutes));
            this.updateHtmlDigits(this.elements.$seconds, this.toDigits(timeRemaining.time.seconds));
        }
    };
    Countdown.prototype.updateHtmlDigits = function ($elements, values) {
        $elements[0].text(values[0]);
        $elements[1].text(values[1]);
    };
    Countdown.prototype.toDigits = function (value) {
        return ('0' + value).split('').slice(-2);
    };
    Countdown.prototype.start = function () {
        var _this = this;
        this.updateHtml();
        this.interval = setInterval(function () { return _this.tick(); }, ONE_SECOND);
    };
    Countdown.prototype.endCountdown = function () {
        var self = this;
        return new Promise(function (resolve, reject) {
            http.get(self.srcHtml).end(function (err, res) {
                if (err) {
                    reject(err);
                }
                else {
                    if (res.text == '') {
                        self.elements.root.parentNode.parentNode.style.display = 'none';
                    }
                    else {
                        self.elements.root.parentNode.parentNode.innerHTML = res.text;
                        resolve();
                    }
                }
            });
        });
    };
    Countdown.prototype.tick = function () {
        this.updateHtml();
        if (this.interval && this.getTimeRemaining().ended) {
            clearInterval(this.interval);
            this.interval = null;
            return this.endCountdown();
        }
        else {
            return new Promise(function (resolve) {
                resolve();
            });
        }
    };
    return Countdown;
}());
exports.init();

},{"../utils/clock":264,"kawabunga/assets/js/utils/dom":71,"promise":178,"superagent":187}],271:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var $ = require("kawabunga/assets/js/utils/dom");
// ..
// Exported Properties & Methods
//
exports.DATA_ROLE = 'election-legislative';
exports.DATA_ROLE_DISTRICT = 'election-legislative-district';
exports.DATA_ROLE_SEARCH = 'election-legislative-search';
exports.CLASS_NAME_DISTRICT_DISPLAYED = 'district__active';
function initAll() {
    $("[data-role=" + exports.DATA_ROLE + "]").forEach(function (elem) {
        init(elem);
    });
}
exports.initAll = initAll;
function init(elem) {
    return new ElectionLegislative(elem);
}
exports.init = init;
// ..
// Class ElectionLegislative
//
var ElectionLegislative = /** @class */ (function () {
    function ElectionLegislative(elem) {
        this.$root = $(elem);
        this.$district = this.$root.select("[data-role=" + exports.DATA_ROLE_DISTRICT + "]");
        if (!this.$district.isEmpty()) {
            this.initDistrictToggle();
        }
    }
    ElectionLegislative.prototype.initDistrictToggle = function () {
        var $items = this.$district.select('.district-item');
        $items.forEach(function (item) {
            var $item = $(item);
            $item.on('click', '.district-more', function (e) {
                e.preventDefault();
                $item.addClass(exports.CLASS_NAME_DISTRICT_DISPLAYED);
            });
            $item.on('click', '.district-less', function (e) {
                e.preventDefault();
                $item.removeClass(exports.CLASS_NAME_DISTRICT_DISPLAYED);
            });
        });
    };
    return ElectionLegislative;
}());
exports.ElectionLegislative = ElectionLegislative;
// ..
// Auto init
//
initAll();

},{"kawabunga/assets/js/utils/dom":71}],272:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var $ = require("kawabunga/assets/js/utils/dom");
// ..
// Exported Properties & Methods
//
exports.DATA_ROLE = 'election-presidential';
exports.DATA_ROLE_TOGGLE = 'election-presidential-toggle';
exports.DATA_ROLE_TOGGLE_BTN = 'election-presidential-toggle-btn';
exports.CLASSNAME_TOGGLE_ACTIVE = 'toggle__active';
function initAll() {
    $("[data-role=" + exports.DATA_ROLE + "]").forEach(function (elem) {
        init(elem);
    });
}
exports.initAll = initAll;
function init(elem) {
    return new ElectionPresidential(elem);
}
exports.init = init;
// ..
// Class ElectionPresidential
//
var ElectionPresidential = /** @class */ (function () {
    function ElectionPresidential(elem) {
        this.$root = $(elem);
        this.$toggle = this.$root.select("[data-role=" + exports.DATA_ROLE_TOGGLE + "]");
        if (!this.$toggle.isEmpty()) {
            this.initToggle();
        }
    }
    ElectionPresidential.prototype.initToggle = function () {
        var _this = this;
        var $btn = this.$toggle.select("[data-role=" + exports.DATA_ROLE_TOGGLE_BTN + "]");
        if ($btn.isEmpty()) {
            return;
        }
        $btn.on('click', function () {
            if (_this.$toggle.hasClass("" + exports.CLASSNAME_TOGGLE_ACTIVE)) {
                _this.$toggle.removeClass("" + exports.CLASSNAME_TOGGLE_ACTIVE);
            }
            else {
                _this.$toggle.addClass("" + exports.CLASSNAME_TOGGLE_ACTIVE);
            }
        });
    };
    return ElectionPresidential;
}());
exports.ElectionPresidential = ElectionPresidential;
// ..
// Auto init
//
initAll();

},{"kawabunga/assets/js/utils/dom":71}],273:[function(require,module,exports){
"use strict";
/**
 * Load asynchronously more content in the bottom timeline
 */
Object.defineProperty(exports, "__esModule", { value: true });
var ImageEcho = require("./../common/image-echo");
var http = require("superagent");
var $ = require("kawabunga/assets/js/utils/dom");
var loading = false;
exports.attachToButton = function (targetId, buttonClass) {
    var $target = $('#' + targetId);
    $target.on('click', '.' + buttonClass, function (e, button) {
        if (!loading) {
            loading = true;
            var $button_1 = $(button);
            var initialHTML_1 = $button_1[0].innerHTML;
            $button_1.text('Chargement...');
            http.get($button_1.data('url')).end(function (err, res) {
                $button_1.html(initialHTML_1);
                loading = false;
                $button_1[0].remove();
                $target[0].insertAdjacentHTML('beforeend', res.text);
                ImageEcho.render();
            });
        }
    });
};

},{"./../common/image-echo":212,"kawabunga/assets/js/utils/dom":71,"superagent":187}],274:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var $ = require("kawabunga/assets/js/utils/dom");
var env = require("kawabunga/assets/js/env/env");
var random = require("kawabunga/assets/js/utils/random");
var http = require("superagent");
var vastHelper = require("../player/jwplayer-vast");
var jwplayer8 = require("../player/jwplayer8");
var jwplayer8Estat6 = require("../player/jwplayer8-estat-v6");
var m6player_1 = require("../player/m6player");
var dmplayer = require("../player/dmplayer");
var ytplayer = require("../player/ytplayer");
var analytics = require("../tracking/universal-analytics");
var ConfigProject = require("../config/config");
var didomi_1 = require("kawabunga/assets/js/cmp/didomi");
var geo_1 = require("../utils/geo");
var MediaPlayer = /** @class */ (function () {
    function MediaPlayer($elem) {
        if (!$elem || $elem.isEmpty()) {
            return;
        }
        this.$root = $elem;
        this.$holder = this.$root.select('.media-holder');
        this.playerNode = null;
        this.playerHolder = document.createElement('div');
        this.playerHolder.classList.add('media-player-holder');
        this.currentPlayer = null;
        var handlers = {
            'playerEnd': function () {
            },
            'playerPlay': function () {
            }
        };
        this.on = {
            set play(cb) {
                if (typeof cb === 'function') {
                    handlers['playerPlay'] = cb;
                }
            },
            set end(cb) {
                if (typeof cb === 'function') {
                    handlers['playerEnd'] = cb;
                }
            },
            get play() {
                return handlers['playerPlay'];
            },
            get end() {
                return handlers['playerEnd'];
            }
        };
    }
    MediaPlayer.prototype.setMediaData = function (data) {
        data = data || {};
        this.data = {
            player: (data.player ? data.player : ''),
            type: (data.type ? data.type : ''),
            src: (data.src ? data.src : ''),
            dfp: (data.dfp ? data.dfp : '0'),
            zoneId: (data.zoneId ? data.zoneId : ''),
            levels: (data.levels ? JSON.parse(data.levels) : ['', '', '', '', '']),
            podcastestaturl: data.podcastestaturl,
            genre: (data.genre ? data.genre : ''),
            media: (data.media ? data.media : ''),
            primary: (data.primary ? data.primary : ''),
            duration: (data.duration ? data.duration : ''),
            title: (data.title ? data.title : ''),
            autoplay: (data.autoplay === true || data.autoplay === 'true' || data.autoplay === '1'),
            cover: (data.cover ? data.cover : ''),
            pulpix: (data.pulpix ? true : false)
        };
    };
    MediaPlayer.prototype.appendPlayerHolder = function () {
        this.$holder[0].appendChild(this.playerHolder);
        this.$holder[0].classList.add('player-inserted');
    };
    MediaPlayer.prototype.createPlayerNode = function () {
        this.playerNode = document.createElement('div');
        this.playerHolder.appendChild(this.playerNode);
    };
    MediaPlayer.prototype.removePlayerNode = function () {
        while (this.playerHolder.firstChild) {
            this.playerHolder.removeChild(this.playerHolder.firstChild);
        }
        this.playerNode = null;
    };
    MediaPlayer.prototype.fixAndroidWebview = function (playerNode) {
        if (!playerNode) {
            return;
        }
        var video = playerNode.getElementsByTagName('video')[0];
        if (video) {
            video.setAttribute('poster', env.getStaticRoot() + 'img/spacer.gif');
        }
    };
    MediaPlayer.prototype.createPlayer = function (data) {
        var _this = this;
        if (env.isFlag("nocmp")) {
            this.doCreatePlayer(data);
        }
        else {
            didomi_1.CmpDidomi.waitForDidomiConsent(didomi_1.Purpose.ADS, function () { return _this.doCreatePlayer(data); });
        }
    };
    MediaPlayer.prototype.doCreatePlayer = function (data) {
        var _this = this;
        if (!data) {
            return;
        }
        this.currentPlayer = null;
        this.setMediaData(data);
        if (!this.playerNode) {
            this.appendPlayerHolder();
            this.createPlayerNode();
        }
        else {
            this.removePlayerNode();
            this.createPlayerNode();
        }
        this.injectPulpixData();
        switch (this.data.player) {
            case 'jwplayer':
                jwplayer8.setup()
                    .then(function () {
                    var adsConsent = !env.isFlag("nocmp") && didomi_1.CmpDidomi.isConsentedPurpose(didomi_1.Purpose.ANALYTICS) && didomi_1.CmpDidomi.isConsentedPurpose(didomi_1.Purpose.ADS);
                    var params = 'aw_0_req.userConsentV2=' + geo_1.getUserConsent();
                    var options = {
                        autostart: _this.data.autoplay,
                        file: geo_1.withParams(_this.data.src, params),
                        title: _this.data.title,
                        image: _this.data.cover ? _this.data.cover : env.getStaticRoot() + 'img/default-cover-replay.jpg',
                        advertising: adsConsent ? vastHelper.getReplayPrerollAdvertisingConfig(_this.data.dfp, _this.data.zoneId) : null
                    };
                    options.fwassetid = 'clip_rtl_' + _this.data.dfp;
                    options = jwplayer8.mergeWithDefaultConfig(options);
                    if (_this.data.primary === 'html5' || _this.data.primary === 'flash') {
                        options.primary = _this.data.primary;
                    }
                    jwplayer8.createPlayer(_this.playerNode, options).then(function (player) {
                        _this.currentPlayer = player;
                        _this.fixAndroidWebview($('#' + player.container.id)[0]);
                        if (!env.isFlag("nocmp") && didomi_1.CmpDidomi.isConsentedPurpose(didomi_1.Purpose.ANALYTICS)) {
                            jwplayer8Estat6.attachReplayPlayer(player, _this.data);
                        }
                        var podcastestaturlConsumed = false;
                        player.onPlay(function () {
                            _this.on.play();
                            if (ConfigProject.brandName === 'rtl') {
                                analytics.push({
                                    'event': 'mediaPlay',
                                    'mediaType': _this.data.type,
                                    'mediaTitle': _this.data.title,
                                    'mediaFormat': 'replay',
                                    'mediaSource': 'rtl'
                                });
                            }
                            if (!podcastestaturlConsumed && env.isFlag('podcast-tracking') && data.podcastestaturl) {
                                podcastestaturlConsumed = true;
                                var url = data.podcastestaturl.replace('[RANDOM]', random.digits(12));
                                http.get(url).end(function (err, res) { });
                            }
                        });
                        player.onEnd(_this.on.end);
                        // Chartbeat
                        window._cbv = window._cbv || [];
                        window._cbv.push(window.jwplayer);
                    });
                });
                break;
            case 'dmplayer':
                dmplayer.ensureScriptIsLoaded(function () {
                    var options = dmplayer.mergeWithDefaultConfig({
                        video: _this.data.src,
                        params: {
                            'autoplay-mute': _this.data.autoplay,
                            'syndication': "249290"
                        }
                    });
                    dmplayer.createPlayer(_this.playerNode, options, function (player) {
                        _this.currentPlayer = player;
                        player.onPlay(function () {
                            _this.on.play();
                            if (ConfigProject.brandName === 'rtl') {
                                analytics.push({
                                    'event': 'mediaPlay',
                                    'mediaType': 'video',
                                    'mediaTitle': _this.data.title,
                                    'mediaFormat': 'replay',
                                    'mediaSource': 'dailymotion'
                                });
                            }
                        });
                        player.onAdPlay(_this.on.play);
                        player.onEnd(_this.on.end);
                    });
                });
                break;
            case 'ytplayer':
                ytplayer.ensureScriptIsLoaded(function () {
                    var options = ytplayer.mergeWithDefaultConfig({
                        videoId: _this.data.src,
                        playerVars: {
                            'autoplay': _this.data.autoplay
                        }
                    });
                    ytplayer.createPlayer(_this.playerNode, options, function (player) {
                        _this.currentPlayer = player;
                        player.onPlay(function () {
                            _this.on.play();
                            if (ConfigProject.brandName === 'rtl') {
                                analytics.push({
                                    'event': 'mediaPlay',
                                    'mediaType': 'video',
                                    'mediaTitle': _this.data.title,
                                    'mediaFormat': 'replay',
                                    'mediaSource': 'youtube'
                                });
                            }
                        });
                        player.onEnd(_this.on.end);
                    });
                });
                break;
            case 'm6play':
                this.data.src += "?share_use_url=" + encodeURIComponent(window.location.href);
                if (this.data.autoplay) {
                    this.data.src += "&autoplay=true";
                }
                this.currentPlayer = new m6player_1.M6Player(this.playerNode, this.data.src);
                break;
        }
    };
    MediaPlayer.prototype.isPlaying = function () {
        return (this.currentPlayer && this.currentPlayer.isPlaying) ? this.currentPlayer.isPlaying() : false;
    };
    MediaPlayer.prototype.destroy = function () {
        if (this.currentPlayer && this.currentPlayer.destroy) {
            this.currentPlayer.destroy();
        }
    };
    MediaPlayer.prototype.stop = function () {
        if (this.currentPlayer && this.currentPlayer.stop) {
            this.currentPlayer.stop();
        }
    };
    MediaPlayer.prototype.pause = function () {
        if (this.currentPlayer && this.currentPlayer.pause) {
            this.currentPlayer.pause();
        }
    };
    MediaPlayer.prototype.injectPulpixData = function () {
        // #WEBDEV-2927 | data-pulpix //
        if (this.data.pulpix === false) {
            this.playerHolder.setAttribute('data-pulpix', 'false');
        }
        else {
            this.playerHolder.removeAttribute('data-pulpix');
        }
    };
    return MediaPlayer;
}());
exports.MediaPlayer = MediaPlayer;

},{"../config/config":218,"../player/dmplayer":243,"../player/jwplayer-vast":244,"../player/jwplayer8":246,"../player/jwplayer8-estat-v6":245,"../player/m6player":247,"../player/ytplayer":249,"../tracking/universal-analytics":263,"../utils/geo":266,"kawabunga/assets/js/cmp/didomi":57,"kawabunga/assets/js/env/env":65,"kawabunga/assets/js/utils/dom":71,"kawabunga/assets/js/utils/random":76,"superagent":187}],275:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var $ = require("kawabunga/assets/js/utils/dom");
var media_player_1 = require("./media-player");
exports.DATA_ROLE = {
    ROOT: 'media-playlist-carousel',
    HOLDER: 'media-playlist-carousel-holder',
    PREV: 'media-playlist-carousel-prev',
    NEXT: 'media-playlist-carousel-next',
    PLAYER: 'media-player',
    PLAYER_PLAY: 'media-player-play'
};
function initAll() {
    $("[data-role=\"" + exports.DATA_ROLE.ROOT + "\"]").forEach(function (elem) {
        new MediaPlaylistCarousel(elem);
    });
}
exports.initAll = initAll;
var MediaPlaylistCarousel = /** @class */ (function () {
    function MediaPlaylistCarousel(elem) {
        var _this = this;
        this.$root = $(elem);
        this.$holder = this.$root.select("[data-role=\"" + exports.DATA_ROLE.HOLDER + "\"]");
        this.$prev = this.$root.select("[data-role=\"" + exports.DATA_ROLE.PREV + "\"]");
        this.$next = this.$root.select("[data-role=\"" + exports.DATA_ROLE.NEXT + "\"]");
        var $players = this.$root.select("[data-role=\"" + exports.DATA_ROLE.PLAYER + "\"]");
        if (!$players.length || !this.$holder.length) {
            return;
        }
        this.medias = [];
        $players.forEach(function (player) {
            _this.medias.push({
                player: new media_player_1.MediaPlayer($(player)),
                data: _this.getMediaDataFromNode(player)
            });
        });
        var stopOtherVideosOnPlay = (function (currentIndex) {
            this.medias.forEach(function (media, index) {
                if (currentIndex === index) {
                    return;
                }
                if (media.player.isPlaying()) {
                    media.player.pause();
                }
            });
        });
        // Event media player holder
        this.medias.forEach(function (media, index) {
            var launched = false;
            var launchPlayer = (function (e) {
                e.preventDefault();
                if (launched) {
                    return;
                }
                media.player.on.play = stopOtherVideosOnPlay.bind(this, index);
                media.player.createPlayer(media.data);
                launched = true;
            }).bind(_this);
            media.player.$holder.on('click', launchPlayer);
        });
        this.currentIndex = 0;
        this.maxIndex = this.medias.length - 1;
        this.refreshCarouselSizes();
        this.$prev.on('click', function (e) {
            e.preventDefault();
            _this.goToPrevMedia();
        });
        this.$next.on('click', function (e) {
            e.preventDefault();
            _this.goToNextMedia();
        });
        // On resize
        (function () {
            var resizeTimeout;
            var onResize = (function () {
                this.refreshCarouselSizes();
                this.maxIndex = this.medias.length - 1;
                this.goToMedia(this.currentIndex);
            }).bind(this);
            window.addEventListener('resize', function () {
                if (!resizeTimeout) {
                    resizeTimeout = setTimeout(function () {
                        resizeTimeout = null;
                        onResize();
                    }, 66);
                }
            }, false);
        }).apply(this);
    }
    MediaPlaylistCarousel.prototype.refreshCarouselSizes = function () {
        this.mediaWidth = this.medias[0].player.$root.css('width');
        this.mediaMargin = this.medias[0].player.$root.css('margin-right');
        this.holderWidth = this.medias.length * (this.mediaWidth + this.mediaMargin) - this.mediaMargin;
        this.carouselWidth = this.$root.css('width');
        this.$holder.css('width', this.holderWidth);
    };
    ;
    MediaPlaylistCarousel.prototype.getMediaDataFromNode = function (node) {
        return {
            player: node.getAttribute('data-player') || '',
            type: node.getAttribute('data-type') || '',
            src: node.getAttribute('data-src') || '',
            credits: node.getAttribute('data-credits') || '',
            dfp: node.getAttribute('data-dfp') || '',
            zoneId: node.getAttribute('data-zoneid') || '',
            levels: node.getAttribute('data-levels') || '',
            podcastestaturl: node.getAttribute('data-podcastestaturl') || '',
            genre: node.getAttribute('data-genre') || '',
            cover: node.getAttribute('data-cover') || '',
            duration: node.getAttribute('data-duration') || '',
            primary: node.getAttribute('data-primary') || '',
            autoplay: true,
            time: node.getAttribute('data-time') || '',
            update: node.getAttribute('data-update') || '',
            title: node.getAttribute('data-title') || ''
        };
    };
    ;
    MediaPlaylistCarousel.prototype.goToPrevMedia = function () {
        this.goToMedia((this.currentIndex - 1 >= 0) ? this.currentIndex - 1 : 0);
    };
    ;
    MediaPlaylistCarousel.prototype.goToNextMedia = function () {
        this.goToMedia((this.currentIndex + 1 <= this.maxIndex) ? this.currentIndex + 1 : this.maxIndex);
    };
    ;
    MediaPlaylistCarousel.prototype.goToMedia = function (index) {
        var left = -index * (this.mediaWidth + this.mediaMargin);
        if (left < (this.carouselWidth - this.holderWidth)) {
            left = (this.carouselWidth - this.holderWidth);
            this.maxIndex = index;
        }
        this.$holder.css('left', left + 'px');
        this.currentIndex = index;
    };
    ;
    return MediaPlaylistCarousel;
}());
exports.MediaPlaylistCarousel = MediaPlaylistCarousel;

},{"./media-player":274,"kawabunga/assets/js/utils/dom":71}],276:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var env = require("kawabunga/assets/js/env/env");
var $ = require("kawabunga/assets/js/utils/dom");
var media_player_1 = require("./media-player");
var didomi_1 = require("kawabunga/assets/js/cmp/didomi");
exports.DATA_ROLE = {
    ROOT: 'media-playlist',
    PLAYER: 'media-player',
    LIST: 'media-list',
    LIST_ITEM: 'media-list-item',
    LIST_PREV: 'media-list-prev',
    LIST_NEXT: 'media-list-next',
    FIGCAPTION: 'media-figcaption'
};
function initAll() {
    $("[data-role=\"" + exports.DATA_ROLE.ROOT + "\"]").forEach(function (elem) {
        new MediaPlaylist(elem);
    });
}
exports.initAll = initAll;
exports.isIos = function () {
    return navigator.userAgent.match(/iPhone|iPad|iPod/i) != null;
};
var MediaPlaylist = /** @class */ (function () {
    function MediaPlaylist(elem) {
        var _this = this;
        this.$root = $(elem);
        this.$player = this.$root.select("[data-role=\"" + exports.DATA_ROLE.PLAYER + "\"]");
        this.$list = this.$root.select("[data-role=\"" + exports.DATA_ROLE.LIST + "\"]");
        this.$listItems = this.$root.select("[data-role=\"" + exports.DATA_ROLE.LIST_ITEM + "\"]");
        this.$listPrev = this.$root.select("[data-role=\"" + exports.DATA_ROLE.LIST_PREV + "\"]");
        this.$listNext = this.$root.select("[data-role=\"" + exports.DATA_ROLE.LIST_NEXT + "\"]");
        this.$figcaption = this.$root.select("[data-role=\"" + exports.DATA_ROLE.FIGCAPTION + "\"]");
        if (!this.$player.length) {
            return;
        }
        this.player = new media_player_1.MediaPlayer(this.$player);
        this.player.on.end = (this.playNextIndex.bind(this));
        this.items = this.getDataItems();
        if (this.$figcaption.length) {
            // @todo set total (but figcaption disapears when players is played)
            // this.$figcaption.select('.media-length').text(this.items.length);
        }
        // Click on Player
        this.launchPlayer = (function (e) {
            e.preventDefault();
            _this.playIndex(0);
        }).bind(this);
        if (!this.player.$holder.isEmpty()) {
            this.player.$holder[0].addEventListener('click', this.launchPlayer);
        }
        // Click on Playlist Items
        this.$listItems.forEach(function (item, index) {
            var $item = $(item);
            $item.on('click', '.item-link', function (e) {
                e.preventDefault();
                _this.playIndex(index);
            });
        });
        // Click on Prev / Next
        this.$listPrev.on('click', this.playPreviousIndex.bind(this));
        this.$listNext.on('click', this.playNextIndex.bind(this));
        // Autoplay
        if (this.items[0].autoplay && !exports.isIos()) {
            if (env.isFlag("nocmp")) {
                this.playIndex(0);
            }
            else {
                if (didomi_1.CmpDidomi.isConsentedPurpose(didomi_1.Purpose.ADS)) {
                    this.playIndex(0);
                }
            }
        }
    }
    MediaPlaylist.prototype.getDataItems = function () {
        var _this = this;
        var $items = this.$list.length ? this.$listItems : this.player.$root;
        return this.injectDataPulpix($items.map(function (item) { return _this.getDataItemFromNode(item); }));
    };
    MediaPlaylist.prototype.getDataItemFromNode = function (node) {
        return {
            player: node.getAttribute('data-player') || '',
            type: node.getAttribute('data-type') || '',
            src: node.getAttribute('data-src') || '',
            credits: node.getAttribute('data-credits') || '',
            dfp: node.getAttribute('data-dfp') || '',
            zoneId: node.getAttribute('data-zoneid') || '',
            levels: node.getAttribute('data-levels') || '',
            podcastestaturl: node.getAttribute('data-podcastestaturl') || '',
            genre: node.getAttribute('data-genre') || '',
            cover: node.getAttribute('data-cover') || '',
            duration: node.getAttribute('data-duration') || '',
            primary: node.getAttribute('data-primary') || '',
            autoplay: (node.getAttribute('data-autoplay') === 'true' || node.getAttribute('data-autoplay') === '1'),
            time: node.getAttribute('data-time') || '',
            update: node.getAttribute('data-update') || '',
            title: node.getAttribute('data-title') || '',
            name: $(node).select('.name').text() || '',
            pulpix: false
        };
    };
    MediaPlaylist.prototype.playIndex = function (index) {
        this.disableClickOnHolder();
        if (!this.items[index]) {
            return;
        }
        if (index === this.currentIndex) {
            return;
        }
        // destroy previous player
        this.player.destroy();
        // prevent one useless click
        this.items[index].autoplay = true;
        this.player.createPlayer(this.items[index]);
        if (!this.$figcaption.hasClass('figcaption__replay')) {
            this.$figcaption.css('display', 'none');
        }
        this.currentIndex = index;
        this.refreshHtml();
    };
    MediaPlaylist.prototype.playPreviousIndex = function () {
        this.playIndex(typeof this.currentIndex === 'number' ? (this.currentIndex - 1) : 0);
    };
    MediaPlaylist.prototype.playNextIndex = function () {
        this.playIndex(typeof this.currentIndex === 'number' ? (this.currentIndex + 1) : 1);
    };
    MediaPlaylist.prototype.disableClickOnHolder = function () {
        // @todo kawabunga dom doen't have a .off method
        if (!this.player.$holder.isEmpty()) {
            this.player.$holder[0].removeEventListener('click', this.launchPlayer);
        }
    };
    MediaPlaylist.prototype.refreshHtml = function () {
        this.$listItems.removeClass('item__active');
        if (this.$listItems[this.currentIndex]) {
            $(this.$listItems[this.currentIndex]).addClass('item__active');
        }
        /*
        @todo figcaption disapears when player is launched
        if(this.$figcaption.length) {
            this.$figcaption.select('.media-title').text(this.items[this.currentIndex]['name']);
            this.$figcaption.select('.credits').text(this.items[this.currentIndex]['credits']);
            this.$figcaption.select('.time').text(this.items[this.currentIndex]['time']);
            this.$figcaption.select('.date').text(this.items[this.currentIndex]['update']);
            this.$figcaption.select('.media-pos').text(this.currentIndex + 1);
        }
        */
    };
    MediaPlaylist.prototype.injectDataPulpix = function (data) {
        // #WEBDEV-2927 | Last item get data-pulpix="false" //
        data[data.length - 1].pulpix = true;
        return data;
    };
    return MediaPlaylist;
}());
exports.MediaPlaylist = MediaPlaylist;

},{"./media-player":274,"kawabunga/assets/js/cmp/didomi":57,"kawabunga/assets/js/env/env":65,"kawabunga/assets/js/utils/dom":71}],277:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var $ = require("kawabunga/assets/js/utils/dom");
exports.BODY_CLASS = 'modal-displayed';
exports.initAllModals = function () {
    $('[data-modal]').forEach(function (item) {
        var modalId = item.getAttribute('data-modal');
        var modalElem = modalId && document.getElementById(modalId);
        if (!modalElem) {
            return;
        }
        var modal = exports.init(modalElem);
        /**
         * Warning, many events if initAllModals is called more than once
         */
        if (modal && modal.show) {
            item.addEventListener('click', function (e) {
                e.preventDefault();
                modal.show();
            });
        }
    });
};
exports.init = function (modalElem) {
    if (typeof modalElem !== 'object') {
        return;
    }
    return new Modal(modalElem);
};
/*
 * constructor
 */
var Modal = /** @class */ (function () {
    function Modal(modalElem) {
        var _this = this;
        this.$elemModal = $(modalElem);
        var btnClose = modalElem.querySelector('.modal-close');
        var dialog = modalElem.querySelector('.modal-dialog');
        if (btnClose !== null) {
            btnClose.addEventListener('click', function (e) {
                e.preventDefault();
                _this.hide();
            });
        }
        if (dialog !== null) {
            dialog.addEventListener('click', function (e) { return e.stopPropagation(); });
        }
        modalElem.addEventListener('click', function () { return _this.hide(); });
    }
    Modal.prototype.show = function () {
        this.$elemModal.css('display', 'block');
        this.$elemModal.addClass('opened');
        document.getElementsByTagName('body')[0].classList.add(exports.BODY_CLASS);
        return this;
    };
    Modal.prototype.hide = function () {
        document.getElementsByTagName('body')[0].classList.remove(exports.BODY_CLASS);
        this.$elemModal.removeClass('opened');
        this.$elemModal.css('display', 'none');
        return this;
    };
    return Modal;
}());
exports.initAllModals();

},{"kawabunga/assets/js/utils/dom":71}],278:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var browser = require("../boot/browser");
var $ = require("kawabunga/assets/js/utils/dom");
var mq_state_detection_1 = require("../common/mq-state-detection");
var ligatus = (function () {
    var selector = '[data-role="ligatus-gallery-ad"]';
    var url = 'https://a-ssl.ligatus.com/?ids=84349&t=js&s=1';
    return {
        getMarker: function ($el) {
            return $el.select(selector);
        },
        isEnabled: function ($item) {
            return this.getMarker($item).length !== 0;
        },
        displayAd: function ($items) {
            var $marker = this.getMarker($items);
            if ($marker.children().length === 0) {
                $marker.attr('id', 'aa');
                var script = document.createElement('script');
                script.src = url;
                $marker[0].appendChild(script);
            }
            $marker.css('display', 'block');
        },
        hideAd: function ($items) {
            var $marker = this.getMarker($items);
            $marker.css('display', 'block');
        }
    };
})();
exports.M6_PUB_ID = 'mpuMiddle';
exports.CLASSNAME_M6_PUB_ABS = 'mpuOverlayDisplayed';
exports.DATA_ROLE = {
    CLOSE: 'media-gallery-close',
    PREV: 'media-gallery-prev',
    NEXT: 'media-gallery-next'
};
var OverlayGallery = /** @class */ (function () {
    function OverlayGallery(elem) {
        this.$root = $(elem);
        this.$items = this.$root.select('.overlay-items .item');
        this.$legends = this.$root.select('.overlay-legend .aside');
        this.currentIndex = 0;
        this.isOverlayDisplayed = false;
        this.$root.select('.overlay-length').text(this.$items.length);
        this.$ad = $("#" + exports.M6_PUB_ID);
        // ..
        // Bindings
        var isNavigating;
        var isTouchStart;
        var onClickOrTouch = (function (cb) {
            return (function (e) {
                if (e.type === browser.touchStart) {
                    isTouchStart = true;
                    e.stop();
                }
                if (e.type === 'click') {
                    if (isTouchStart) {
                        isTouchStart = false;
                        return false;
                    }
                }
                cb.apply(this);
            }).bind(this);
        }).bind(this);
        // Close Overlay
        var $close = this.$root.select("[data-role=\"" + exports.DATA_ROLE.CLOSE + "\"]");
        var onClose = onClickOrTouch(this.closeOverlay);
        $close.on('click', onClose);
        $close.on(browser.touchStart, onClose);
        // Navigation Prev / Next
        var $btnPrev = this.$root.select("[data-role=\"" + exports.DATA_ROLE.PREV + "\"]");
        var $btnNext = this.$root.select("[data-role=\"" + exports.DATA_ROLE.NEXT + "\"]");
        var onPrev = onClickOrTouch(this.goToPreviousItem);
        var onNext = onClickOrTouch(this.goToNextItem);
        $btnPrev.on('click', onPrev);
        $btnPrev.on(browser.touchStart, onPrev);
        $btnNext.on('click', onNext);
        $btnNext.on(browser.touchStart, onNext);
        // Show / hide figcaption on small devices
        var $btnAside = this.$root.select('.media-btn-show-aside');
        var onShowFigcaption = onClickOrTouch(function () {
            if (this.$root.hasClass('show')) {
                this.$root.removeClass('show');
            }
            else {
                this.$root.addClass('show');
            }
        });
        $btnAside.on('click', onShowFigcaption);
        $btnAside.on(browser.touchStart, onShowFigcaption);
        // Keyboard controls
        var keydownNavHandler = (function (e) {
            if (!this.isOverlayDisplayed) {
                return;
            }
            switch (e.keyCode) {
                case 27:
                    this.closeOverlay();
                    break;
                case 37:
                    this.goToPreviousItem();
                    isNavigating = false;
                    break;
                case 39:
                    this.goToNextItem();
                    isNavigating = false;
                    break;
            }
        }).bind(this);
        $(document.body).on('keydown', keydownNavHandler);
        // Navigation on Touch
        (function () {
            var _this = this;
            var startX;
            var startY;
            var distX;
            var distY;
            var typeEvent;
            var start;
            var end;
            var move;
            var dir;
            var startTime;
            var endTime;
            var allowedTime = 600;
            var thresHold = 50;
            var restraint = 100;
            if (window.MSPointerEvent) {
                typeEvent = 'MS';
                start = 'MSPointerDown' || 'pointerdown';
                end = 'MSPointerUp' || 'pointerup';
                move = 'MSPointerMove' || 'pointermove';
            }
            else {
                start = 'touchstart';
                end = 'touchend';
                move = 'touchmove';
            }
            this.$root.on(start, function (e) {
                if (isNavigating) {
                    return false;
                }
                isNavigating = true;
                if (typeEvent === 'MS') {
                    startX = e.clientX;
                    startY = e.clientY;
                }
                else {
                    var touchobj = e.changedTouches[0];
                    startX = touchobj.pageX;
                    startY = touchobj.pageY;
                }
                dir = 'none';
                distX = 0;
                startTime = new Date().getTime(); // record time when finger first makes contact with surface
            });
            this.$root.on(move, function (e) {
                e.preventDefault();
            });
            this.$root.on(end, function (e) {
                if (typeEvent === 'MS') {
                    distX = e.clientX - startX;
                    distY = e.clientY - startY;
                }
                else {
                    var touchobj = e.changedTouches[0];
                    distX = touchobj.pageX - startX; // get horizontal dist traveled by finger while in contact with surface
                    distY = touchobj.pageY - startY; // get vertical dist traveled by finger while in contact with surface
                }
                endTime = new Date().getTime() - startTime; // get time elapsed
                if (endTime <= allowedTime) {
                    if ((Math.abs(distX) >= thresHold) && (Math.abs(distY) <= restraint)) { // 2nd condition for horizontal swipe met
                        if (distX < 0) {
                            _this.goToNextItem();
                        }
                        else {
                            _this.goToPreviousItem();
                        }
                    }
                    if ((Math.abs(distY) >= thresHold) && (Math.abs(distX) <= restraint)) {
                        if (mq_state_detection_1.mqState.getState() === 2 || 1) {
                            if (distY < 0) {
                                _this.$root.addClass('show');
                            }
                            else {
                                _this.$root.removeClass('show');
                            }
                        }
                        else {
                            _this.$root.removeClass('show');
                        }
                    }
                }
                isNavigating = false;
            });
        }).apply(this);
    }
    OverlayGallery.prototype.openOverlay = function () {
        this.setupAd();
        $('body').addClass('overlay-open');
        this.$root.css('display', 'block');
        this.isOverlayDisplayed = true;
    };
    OverlayGallery.prototype.closeOverlay = function () {
        this.detachAd();
        $('body').removeClass('overlay-open');
        this.$root.css('display', 'none');
        this.isOverlayDisplayed = false;
    };
    OverlayGallery.prototype.goToItem = function (index) {
        if (!this.$items[index]) {
            return;
        }
        this.$items.removeClass('active');
        this.$legends.removeClass('active');
        $(this.$items[index]).addClass('active');
        if (this.$legends[index]) {
            $(this.$legends[index]).addClass('active');
        }
        // Ligatus
        if (ligatus.isEnabled($(this.$items[index]))) {
            ligatus.displayAd(this.$items);
        }
        else {
            ligatus.hideAd(this.$items);
        }
        this.currentIndex = index;
        this.$root.select('.overlay-pos').text(index + 1);
    };
    OverlayGallery.prototype.goToPreviousItem = function () {
        this.goToItem((this.currentIndex - 1 >= 0) ? this.currentIndex - 1 : this.$items.length - 1);
    };
    OverlayGallery.prototype.goToNextItem = function () {
        this.goToItem((this.currentIndex + 1 < this.$items.length) ? this.currentIndex + 1 : 0);
    };
    OverlayGallery.prototype.setupAd = function () {
        this.$ad.addClass(exports.CLASSNAME_M6_PUB_ABS);
    };
    OverlayGallery.prototype.detachAd = function () {
        this.$ad.removeClass(exports.CLASSNAME_M6_PUB_ABS);
    };
    return OverlayGallery;
}());
exports.OverlayGallery = OverlayGallery;

},{"../boot/browser":203,"../common/mq-state-detection":214,"kawabunga/assets/js/utils/dom":71}],279:[function(require,module,exports){
"use strict";
/**
 * Load Wibbitz using async mode
 */
Object.defineProperty(exports, "__esModule", { value: true });
var $ = require("kawabunga/assets/js/utils/dom");
var scriptLoader = require("kawabunga/assets/js/utils/script-loader");
var cnil_1 = require("kawabunga/assets/js/cnil/cnil");
var cnil_v2_1 = require("../common/cnil-v2");
var didomi_1 = require("kawabunga/assets/js/cmp/didomi");
exports.WIBBITZ_SCRIPT = '//cdn4.wibbitz.com/static.js';
var playerList = [];
exports.init = function () {
    var $wibbitz = $('[wibbitz][wibbitz-clip-id]');
    if ($wibbitz.isEmpty()) {
        return;
    }
    $wibbitz.forEach(function (item) {
        var player = new PlayerWibbitz(item);
        player.init();
        playerList.push(player);
    });
};
var PlayerWibbitz = /** @class */ (function () {
    function PlayerWibbitz(item) {
        var _this = this;
        this.item = item;
        this.loadScript = function () {
            // ensure banner is hidden
            _this.hideCnilbanner();
            scriptLoader.ensureLoaded(exports.WIBBITZ_SCRIPT);
        };
        this.injectDidomiBanner = function () {
            cnil_1.cnil.banner.injectBanner({
                $container: _this.$parent,
                html: cnil_v2_1.didomiBannerHTML({
                    modifierClass: 'cnil-banner-v2--player',
                    category: didomi_1.Purpose.ADS
                })
            });
        };
        this.$root = $(item);
        this.$parent = this.$root.parent();
    }
    PlayerWibbitz.prototype.init = function () {
        didomi_1.CmpDidomi.doOnDidomiConsent(didomi_1.Purpose.ADS, this.loadScript, this.injectDidomiBanner);
    };
    PlayerWibbitz.prototype.hideCnilbanner = function () {
        this.$parent.select('[data-role=cnil-banner]').css('display', 'none');
    };
    ;
    return PlayerWibbitz;
}());
exports.PlayerWibbitz = PlayerWibbitz;
cnil_1.cnil.cookie.onChange(function () { return playerList.forEach(function (player) { return player.init(); }); });

},{"../common/cnil-v2":208,"kawabunga/assets/js/cmp/didomi":57,"kawabunga/assets/js/cnil/cnil":64,"kawabunga/assets/js/utils/dom":71,"kawabunga/assets/js/utils/script-loader":77}],280:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var dates = require("../utils/dates");
var cookies = require("js-cookie");
var $ = require("kawabunga/assets/js/utils/dom");
var http = require("superagent");
var UniversalAnalytics = require("../tracking/universal-analytics");
exports.parseSurveys = function () {
    $('.article-sondage').forEach(function (element) {
        var survey = exports.parseSurvey(element);
        if (survey.canVote()) {
            survey.bindUi();
        }
        else {
            setTimeout(function () {
                survey.getFromServer();
            }, 500);
        }
    });
};
exports.parseSurvey = function (element) {
    return new Survey(element);
};
var Survey = /** @class */ (function () {
    function Survey(element) {
        this.element = element;
        this.form = $('[data-role="surveys"]')[0];
        this.id = this.form.getAttribute('data-id');
        this.date = dates.safeRead(this.form.getAttribute('data-date'));
        this.url = this.form.getAttribute('action') + this.id + '.json';
        this.selectedOrdinal = null;
    }
    Survey.prototype.canVote = function () {
        var now = new Date();
        if (this.date && this.date < now) {
            return false;
        }
        return cookies.get(this.id) === undefined;
    };
    Survey.prototype.canPostVote = function () {
        return this.selectedOrdinal !== null;
    };
    Survey.prototype.postVote = function () {
        if (!this.selectedOrdinal) {
            return;
        }
        var self = this;
        http.post(this.url)
            .type('form')
            .send({ ordinal: this.selectedOrdinal })
            .end(function (err, res) {
            self.displayResult(res.body);
        });
        $(this.form).addClass('loading');
        if (cookies.get(this.id) === undefined) {
            cookies.set(this.id, 'true', { expires: 1, path: '/' });
        }
        this.pushUniversalAnalyticsEvent();
    };
    Survey.prototype.getFromServer = function () {
        var self = this;
        http.get(self.url)
            .end(function (err, res) {
            self.displayResult(res.body);
        });
    };
    Survey.prototype.displayResult = function (result) {
        var items = $(this.element).selectByClass('item');
        if (items.length !== result.answers.length) {
            return;
        }
        $(this.form).removeClass('loading').addClass('answered');
        var countWrap = $(this.element).select('.votes .number')[0];
        $(countWrap).text(result.voteCount);
        setTimeout(function () {
            result.answers.forEach(function (answer, index) {
                var itemWrap = $(items[index]);
                var percent = (result.voteCount === 0 ? 0 : Math.round((answer.count * 100) / result.voteCount));
                var progressDiv = itemWrap.appendTag('div', { classes: "progress" }).attr('dataProgress', percent);
                progressDiv.appendTag('span', { classes: 'pourcent' }).text(percent + '%').css('width', percent + '%');
            });
        }, 500);
    };
    Survey.prototype.bindUi = function () {
        var _this = this;
        $(this.form).selectByClass('input-radio').forEach(function (input) {
            $(input).on('click', function () {
                _this.selectedOrdinal = input.value;
            });
        });
        $(this.form).selectByClass('btn-action').forEach(function (btn) {
            $(btn).on('click', function (e) {
                e.preventDefault();
                _this.postVote();
            });
        });
    };
    Survey.prototype.pushUniversalAnalyticsEvent = function () {
        var data = {
            event: 'eventGA',
            eventCategory: 'userVote',
            eventAction: '[' + dates.print(new Date()) + '] ' + this.getTheme(),
            eventLabel: $(this.element).select('.title').text(),
            eventValue: this.selectedOrdinal
        };
        UniversalAnalytics.push(data);
    };
    Survey.prototype.getTheme = function () {
        var themes = [
            { clazz: 'th-rtl-actu', theme: 'info' },
            { clazz: 'th-rtl-sport', theme: 'sport' },
            { clazz: 'th-rtl-culture', theme: 'culture' },
            { clazz: 'th-girls-mode', theme: 'mode-beaute' },
            { clazz: 'th-girls-sexo', theme: 'sexo-psycho' },
            { clazz: 'th-girls-lifestyle', theme: 'lifestyle' },
            { clazz: 'th-girls-confessions', theme: 'confessions' }
        ];
        var $title = $(this.element).select('.title');
        var theme = themes.find(function (theme) { return $title.hasClass(theme.clazz) != -1; });
        return theme ? theme.theme : '';
    };
    return Survey;
}());
;
exports.parseSurveys(); /**
 * Created by aleborgne on 07/06/2017.
 */

},{"../tracking/universal-analytics":263,"../utils/dates":265,"js-cookie":46,"kawabunga/assets/js/utils/dom":71,"superagent":187}],281:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var $ = require("kawabunga/assets/js/utils/dom");
exports.init = function () {
    var $tabs = $('[data-tab-target]');
    $tabs.forEach(function (tab) {
        var $tab = $(tab);
        $tab.on('click', function () {
            var content = document.getElementById(tab.getAttribute('data-tab-target'));
            if (content) {
                var $contents = $(content.parentNode).select('[data-role="tab-target"]');
                var $tabs_1 = $(tab.parentNode).select('[data-tab-target]');
                $contents.forEach(removeActive);
                $tabs_1.forEach(removeActive);
                addActive(content);
                addActive(tab);
            }
        });
    });
};
var addActive = function (item) {
    item.classList.add('active');
};
var removeActive = function (item) {
    item.classList.remove('active');
};
exports.init();

},{"kawabunga/assets/js/utils/dom":71}],282:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var $ = require("kawabunga/assets/js/utils/dom");
var http = require("superagent");
exports.DATA_ROLE = 'widget-debate';
exports.DATA_ROLE_FORM = 'widget-debate-form';
exports.DATA_ROLE_FORM_WHO = 'widget-debate-form-who';
exports.DATA_ROLE_FORM_QUESTION = 'widget-debate-form-question';
exports.DATA_ROLE_FORM_SUBMIT = 'widget-debate-form-submit';
exports.init = function () {
    var $widget = $("[data-role=\"" + exports.DATA_ROLE + "\"]");
    if ($widget.length > 0) {
        return new WidgetDebate($widget);
    }
};
var WidgetDebate = /** @class */ (function () {
    function WidgetDebate($elem) {
        var _this = this;
        this.$root = $elem;
        this.$form = this.$root.select("[data-role=\"" + exports.DATA_ROLE_FORM + "\"]");
        this.$who = this.$form.select("[data-role=\"" + exports.DATA_ROLE_FORM_WHO + "\"]");
        this.$question = this.$form.select("[data-role=\"" + exports.DATA_ROLE_FORM_QUESTION + "\"]");
        this.$submit = this.$root.select("[data-role=\"" + exports.DATA_ROLE_FORM_SUBMIT + "\"]");
        this.isSubmitted = false;
        this.enableFields();
        this.$form.on('submit', function (e) {
            e.preventDefault();
        });
        this.$submit.on('click', function (e) {
            e.preventDefault();
            if (!_this.isSubmitted) {
                _this.submitForm();
            }
        });
    }
    WidgetDebate.prototype.enableFields = function () {
        if (!this.$who.length || !this.$question.length) {
            return;
        }
        this.$who.removeAttr('disabled');
        this.$question.removeAttr('disabled');
    };
    WidgetDebate.prototype.submitForm = function () {
        var _this = this;
        this.$form.select('.row__question').removeClass('row__error');
        if (typeof String.prototype.trim === 'function') {
            this.$question.value(this.$question.value().trim());
        }
        if (!this.checkForm()) {
            return;
        }
        var handleError = function () {
            _this.$submit.text('Erreur');
            _this.$submit.removeClass('icon-arrow-right-circle').addClass('icon-close-circle');
        };
        var handleSuccess = function () {
            _this.$submit.text('Envoyé');
            _this.$submit.removeClass('icon-arrow-right-circle').addClass('icon-check-circle');
        };
        http.post(this.$form.attr('action')).type('form').send({
            askTo: this.$who.value(),
            text: this.$question.value()
        }).end(function (err, res) {
            _this.isSubmitted = true;
            if (err) {
                handleError();
            }
            else {
                handleSuccess();
            }
        });
    };
    WidgetDebate.prototype.checkForm = function () {
        if (!this.$who.length || !this.$question.length) {
            return false;
        }
        if (this.$question.value().length === 0 || this.$question.value().length > 1000) {
            this.$form.select('.row__question').addClass('row__error');
            return false;
        }
        return true;
    };
    return WidgetDebate;
}());

},{"kawabunga/assets/js/utils/dom":71,"superagent":187}],283:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var $ = require("kawabunga/assets/js/utils/dom");
exports.DATA_ROLE = "widget-slider";
exports.TIME_INTERVAL = 5000;
exports.initAll = function () {
    $("[data-role=\"" + exports.DATA_ROLE + "\"]").forEach(exports.init);
};
exports.init = function (element) {
    return new WidgetSlider(element);
};
var WidgetSlider = /** @class */ (function () {
    function WidgetSlider(element) {
        var _this = this;
        this.$slider = $(element);
        this.$images = this.$slider.select('.widget-body .slide');
        this.$texts = this.$slider.select('.widget-footer .slide');
        if (this.$images.length != this.$texts.length) {
            return;
        }
        this.currentIndex = 0;
        this.$bullets = this.$slider.select('.corner-right .list');
        for (var i = 0; i < this.$images.length; i++) {
            this.$bullets.append('<li class="item"><a href="#" class="point"></a></li>');
        }
        this.defaultActive();
        this.startInterval();
        this.$bullets.select('.item .point').on('click', function (e) {
            e.preventDefault();
            var index = _this.indexItem($(e.target).parent('.item')[0]);
            _this.goToItem(index);
        });
    }
    WidgetSlider.prototype.defaultActive = function () {
        $(this.$images[0]).addClass('active');
        $(this.$texts[0]).addClass('active');
        $(this.$bullets.select('.item')[0]).addClass('active');
    };
    WidgetSlider.prototype.indexItem = function (element) {
        var $items = this.$bullets.select('.item');
        var i;
        for (i = 0; i < $items.length; i++) {
            if (element == $items[i]) {
                break;
            }
        }
        return i;
    };
    WidgetSlider.prototype.goToItem = function (index) {
        this.$images.removeClass('active');
        this.$texts.removeClass('active');
        this.$bullets.select('.item').removeClass('active');
        $(this.$images[index]).addClass('active');
        $(this.$texts[index]).addClass('active');
        $(this.$bullets.select('.item')[index]).addClass('active');
        this.startInterval();
    };
    WidgetSlider.prototype.startInterval = function () {
        var _this = this;
        if (this.intervalId) {
            clearInterval(this.intervalId);
        }
        this.intervalId = setInterval(function () {
            var index = _this.indexItem(_this.$bullets.select('.item.active')[0]);
            _this.goToItem((index + 1 < _this.$images.length) ? index + 1 : 0);
        }, exports.TIME_INTERVAL);
    };
    return WidgetSlider;
}());

},{"kawabunga/assets/js/utils/dom":71}]},{},[193]);
